/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title rx.js: Feature level module
	 * @description The module used for the 'rx'
	 * feature which encapsulates 'rx homepage','rx feature pages'
	 * 'product details', etc.
	 * @dependency rxsignin and bunch of others
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(113), __webpack_require__(121), __webpack_require__(115), __webpack_require__(116), __webpack_require__(117), __webpack_require__(118), __webpack_require__(114), __webpack_require__(119), __webpack_require__(120), __webpack_require__(112), __webpack_require__(24), __webpack_require__(14), __webpack_require__(72), __webpack_require__(13), __webpack_require__(122), __webpack_require__(123), __webpack_require__(124), __webpack_require__(39)], __WEBPACK_AMD_DEFINE_RESULT__ = function (rxRefillPrescription, rxPrescriptionStatus, rxNewPrescription, rxTransferPrescription, rxPatientProfile, rxPrescriptionHelper, rxAddressHelper, rxSignin, rxSearch, rxDrugDetails, checkout_helper, address, addressSelectionDialog, addressForm, pharmacyRefillPrescription, rxContactUs, rxFamilyAccount, timeoutModal) {
		function init() {
			// Case where user is timed out from pharmacy page and clicks back in browser tab without logging in. This reloads the page so that the user relands on the logon page rather than the auth pharmacy page.
			if (window.performance && window.performance.getEntriesByType("navigation")[0].type === 'back_forward' && !$.cookie('hashedUserId')) {
				window.location.reload(true);
			}
	
			address.bindEvents();
			rxSignin.init();
			rxSearch.init();
			rxContactUs.init();
	
			var page = $('[data-page]').data('page') || '';
			if (page.indexOf('NewPrescription,PrescriptionSearch,FIXED') >= 0 || page.indexOf('TransferPrescription,PrescriptionSearch,FIXED') >= 0 || page.indexOf('HomeDeliveryHome,DrugDirectory,FIXED') >= 0) {
				rxDrugDetails.init();
			}
	
			if (page.indexOf('HDRefillPrescription') >= 0) {
				var addressSettings = undefined;
	
				if (page.indexOf('HDRefillPrescriptionConfirmation') >= 0) {
					addressSettings = {
						updateURL: '/AjaxPrescriptionManageAddressCmd?mode=UPDATE&fromPage=' + rxCheckoutPageName,
						addURL: '/AjaxPrescriptionManageAddressCmd?mode=ADD&fromPage=' + rxCheckoutPageName,
						setDefaultURL: '/AjaxPrescriptionManageAddressCmd?mode=SET_DEFAULT&fromPage=' + rxCheckoutPageName
					};
	
					rxPrescriptionHelper.init();
				}
	
				rxRefillPrescription.init(addressSettings);
			} else if (page.indexOf('NewPrescription') >= 0) {
				var _addressSettings = undefined;
				if (page.indexOf('ConfirmPrescriptionRequest') >= 0) {
					_addressSettings = {
						updateURL: '/AjaxPrescriptionManageAddressCmd?mode=UPDATE&fromPage=' + rxCheckoutPageName,
						addURL: '/AjaxPrescriptionManageAddressCmd?mode=ADD&fromPage=' + rxCheckoutPageName,
						setDefaultURL: '/AjaxPrescriptionManageAddressCmd?mode=SET_DEFAULT&fromPage=' + rxCheckoutPageName
					};
	
					rxPrescriptionHelper.init();
				}
	
				rxNewPrescription.init(_addressSettings);
			} else if (page.indexOf('TransferPrescription') >= 0) {
	
				var _addressSettings2 = undefined;
	
				if (page.indexOf('ConfirmTransferRequest') >= 0) {
					_addressSettings2 = {
						updateURL: '/AjaxPrescriptionManageAddressCmd?mode=UPDATE&fromPage=' + rxCheckoutPageName,
						addURL: '/AjaxPrescriptionManageAddressCmd?mode=ADD&fromPage=' + rxCheckoutPageName,
						setDefaultURL: '/AjaxPrescriptionManageAddressCmd?mode=SET_DEFAULT&fromPage=' + rxCheckoutPageName
					};
	
					rxPrescriptionHelper.init();
				}
	
				rxTransferPrescription.init(_addressSettings2);
			} else if (page.indexOf('PatientInformation') >= 0) {
				rxPatientProfile.init();
			} else if (page.indexOf('ManageFamilyAccount') >= 0) {
				rxFamilyAccount.init();
			} else if (page.indexOf('wh-rx-status') >= 0) {
				pharmacyRefillPrescription.init();
			} else if (page.indexOf('HDPrescriptionStatus') >= 0) {
				rxPrescriptionStatus.init();
			}
	
			// Begin: A temporary fix to identify the header skip element for legacy pharmacy pages
			// 			which do not have the right headerskip element. Needs to be removed during re-design
			var skipContentElementID = $('a[id="skip-content"]').attr('href');
			if (!$(skipContentElementID).length) {
				$('a[id="skip-content"]').attr('href', '#main_content_wrapper');
			}
	
			$('.control--radio input[type="radio"]').on("focusin", function () {
				$(this).next().addClass('ada-outline');
			});
	
			$('.control--radio input[type="radio"]').on("blur", function () {
				$(this).next().removeClass('ada-outline');
			});
	
			// This handles the case when the pharmacy patient has accept their
			// prescription details privacy notice and is back on the Pharmacy Homepage
			// A keyword has been placed in the URL and is only present when the user is coming from
			// the PharmacySavePrescriptionDetailsAcceptanceCmd.
	
			var param = COSTCO.util.getParameterByName("keyword");
			if (param == 'prescaccepted') {
				COSTCO.dialog.createExtDialogBox({
					title: "Success",
					body: "Your preferences have been saved successfully.",
					primary: messages.JS_DIALOG_CLOSE,
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					}
				});
			}
	
			$('a.prescription-acceptance').click(function () {
				var link = this.href;
				COSTCO.dialog.createExtDialogBox({
					title: "Warning",
					body: "Your changes have not been saved. Are you sure you want to leave this page?",
					primary: messages.JS_DIALOG_STAY_ON_PAGE,
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					},
					secondary: messages.JS_DIALOG_LEAVE_PAGE,
					secondary_event: function secondary_event() {
						COSTCO.dialog.close();
						window.location = link;
					}
	
				});
				return false;
			});
	
			// Adds aria-current for ADA Compliance on "Left Navbar" link for Pharmacy.
			$("div.leftnav-element.active").find("a").attr("aria-current", "page");
	
			$("ol.progress-meter").find("li.active").attr("aria-current", "step");
	
			//Aria-expanded true/false switch for drug details when Drug Details info displays only
			rxDrugDetails.rxDrugDetailAriaExpandSwitch();
	
			//Aria-expanded true/false switch for all expandable rx tabs
			rxPatientProfile.rxAriaExpandSwitch();
	
			timeoutModal.init();
		}
	
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
	
		if (typeof window.COSTCO.Global == 'undefined') {
			document.addEventListener("CostcoGlobalLoaded", init, false);
		} else {
			init();
		}
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title account-helper.js: Sub-module for Account pages
	 * @description This module is used to handle various account tasks
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	  var AccountHelper = {
	
	    /**
	     * Initialization of the module.
	     */
	    init: function init() {
	      console.log('Account Helper module intialized.');
	      if (COSTCO.util.isRunningOnMobileApp() && !COSTCO.util.isBusinessDelivery()) {
	        if (document.readyState == 'complete') {
	          $('#my-account-top-nav').on("click", function () {
	            COSTCO.AccountHelper.showMobileMyAccountMenu();
	          });
	        } else {
	          $(window).on('load', function () {
	            $('#my-account-top-nav').on("click", function () {
	              COSTCO.AccountHelper.showMobileMyAccountMenu();
	            });
	          });
	        }
	      }
	    },
	    /**
	     * Constants
	     */
	    notificationType: {
	      SUCCESS: 'SUCCESS',
	      WARNING: 'WARNING',
	      ERROR: 'ERROR'
	    },
	
	    /**
	     * Displays error, warning, or success notification
	     * @param  {String} notificationType Notification type
	     * @param  {Array} notifications     Notification messages
	     * @return {void}
	     */
	    displayTopNotification: function displayTopNotification(notificationType, notifications) {
	
	      this.clearNotification();
	
	      var topNotificationClass = '';
	      var topNotificationInnerHtml = '';
	
	      switch (notificationType) {
	        case this.notificationType.SUCCESS:
	          topNotificationClass = 'success-notification';
	          break;
	        case this.notificationType.WARNING:
	          topNotificationClass = 'warning';
	          break;
	        case this.notificationType.ERROR:
	          topNotificationClass = 'critical-notification';
	          break;
	        default:
	          break;
	      }
	
	      notifications.forEach(function (notification) {
	        topNotificationInnerHtml += '<p automation-id="notificationMessage">' + notification + '</p>';
	      });
	      $('#notification-message').addClass(topNotificationClass);
	      $('#notification-message').html(topNotificationInnerHtml);
	    },
	    /**
	     * Clears top notification
	     */
	    clearNotification: function clearNotification() {
	
	      $('#notification-message').removeClass();
	      $('#notification-message').html('');
	    },
	    /**
	     * Makes dropdown menu options clickable and redirecting to URL stated in
	     * option value attribute, when this HTML class attribute is used.
	     * Used in Top Navigation dropdown menu.
	     */
	    activateDropdownMenuRedirect: function activateDropdownMenuRedirect() {
	      $('.dropdown-menu-redirect').unbind('change').change(function () {
	        window.location.href = $(this).val();
	      });
	    },
	    /**
	     * Reinitializes value selected in  a dropdown manu when the back button is clicked
	     */
	    reinitDropDownMenu: function reinitDropDownMenu() {
	      $('.dropdown-menu-redirect').each(function () {
	        var select = $(this);
	        var selectedValue = select.find('option[selected]').val();
	
	        if (selectedValue) {
	          select.val(selectedValue);
	        } else {
	          select.prop('selectedIndex', 0);
	        }
	      });
	    },
	    /**
	    * Function used to invoke the mobile app My Account navigation
	    */
	    showMobileMyAccountMenu: function showMobileMyAccountMenu() {
	      console.log('Initializing Mobile My Account Menu');
	      try {
	        if (typeof Android != 'undefined') {
	          Android.showMyAccount();
	        } else if (typeof webkit != 'undefined') {
	          webkit.messageHandlers.showMyAccount.postMessage('myaccount');
	        }
	      } catch (e) {
	        console.warn(e);
	      }
	    },
	
	    /**
	        * Adds aria-current for ADA Compliance on "Left Navbar" link for account.
	       * @return void
	       */
	    addAdaComplianceOnLeftNabarForAccount: function addAdaComplianceOnLeftNabarForAccount() {
	      $('#leftnav li.active a').attr('aria-current', "page");
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.AccountHelper = AccountHelper;
	
	  return AccountHelper;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title product_helper.js: utility module
	 * @description This module is fabulous. A utility
	 * module for the product page.
	 * @author kmedz
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var itemIdMap = new Map();
	  var listOfObjects = [];
	  var OOSMap = new Map();
	  var Product = {
	    /**
	     * This variable corresponds with the kind of product we're looking
	     * at. It gets set in mathtable.js.init as part of the product.module.js.init
	     * process.
	     * @type {[string]}
	     */
	    item_type: undefined,
	    chatWindow: undefined,
	
	    /**
	     * This constant represents top value that can be set for quantity for BD
	     */
	    MAX_QUANTITY_BD: 9999,
	
	    /**
	     * This constant represents bottom value that can be set for quantity
	     */
	    MIN_QUANTITY: 1,
	
	    SKIP_EDD: false,
	    isLocCtrlSmallPck: false,
	    isEDDStatusAvailable: true,
	    isEddItem: false,
	
	    /**
	     * The initializing function modules use
	     * to call.
	     * @return {[type]} [description]
	     */
	    init: function init() {
	
	      if (isBDApplication && isBDApplication === 'BC') {
	        var pageNames = "";
	        if (window.currentPageName !== undefined) {
	          pageNames = window.currentPageName;
	        }
	        if ($("#left-side-content") != undefined && pageNames === 'pdp') {
	          $(window).scroll(function () {
	            var windowWidth = parseInt(window.innerWidth);
	            if (window.pageYOffset > parseFloat($("#left-side-content").offset().top - 50)) {
	              if (windowWidth > 768) {
	                $("#left-side-content").css({
	                  "position": "sticky",
	                  "top": "20px",
	                  "background": "#fff"
	                });
	                if ($("#product-details").height() > $("#zoomViewer").height()) {
	                  if ($(".bottom-content").offset().top - window.pageYOffset - $("#product-details").height() < 0) {
	                    $("#left-side-content").css({
	                      "position": "sticky",
	                      "top": $(".bottom-content").offset().top - window.pageYOffset - $("#product-details").height() + 20 + "px",
	                      "background": "#fff"
	                    });
	                  }
	                } else {
	                  if ($(".bottom-content").offset().top - window.pageYOffset - $("#zoomViewer").height() < 0) {
	                    $("#left-side-content").css({
	                      "position": "sticky",
	                      "top": $(".bottom-content").offset().top - window.pageYOffset - $("#zoomViewer").height() + 20 + "px",
	                      "background": "#fff"
	
	                    });
	                  }
	                }
	              } else {
	                $("#left-side-content").css({
	                  "position": "static",
	                  "top": "20px",
	                  "background": "#fff"
	                });
	                $(".top-content").css({ "background-color": "#fff" });
	                $(".product-interaction").css({ "background-color": "#fff" });
	                $("#fulfillments").css({ "background-color": "#fff" });
	                $(".buyinstoreonly").css({ "background-color": "#fff" });
	              }
	              if (COSTCO.CMath.iskitsbundle) {
	                $(".style-select").addClass("kits-pdp-margin");
	              }
	
	              $("#product-page").css({ "padding-bottom": "0px" });
	              $("#product-info").css({ "background": "#fff" });
	              $("#merkle-recommendations").css({ "background-color": "#fff" });
	              $("#product-vendor-content > div").css({ "background-color": "#fff" });
	            } else {
	              $("#left-side-content").css({
	                "position": "static",
	                "top": "20px",
	                "background": "transparent"
	              });
	            }
	          });
	        }
	      }
	      $('#product-page').attr("data-onloadTracker", "true");
	      if (isBVv2Enabled === 'false') {
	        this.hide_writereview();
	      }
	      this.maskQuantityInput();
	      this.product_details_view_more();
	      this.enablePlainPackagingMessage();
	      this.pop_overs();
	      this.set_option_price_text();
	      this.injectHiddenSwatchesDiv();
	      this.showViewMore();
	      this.setEDDZipCode();
	      if (COSTCO.util.checkElementById('#liveChatEnabled', 'true')) {
	        this.enableChatFeature();
	      }
	      this.scrollToElementOnPdpWithOffset();
	
	      if ($('#liveEDD').length > 0 && $('#liveEDD').val() === 'true') {
	        COSTCO.Product.eddMutationObserverState = Product.eddObserver.state.STOPPED;
	        if ($('#backOrdered').val() !== 'true') {
	          COSTCO.Product.eddFormDisplayed = true;
	        }
	        $('#minQtyText').bind("change", function () {
	          if (COSTCO.Product.eddFormDisplayed === false && $.cookie('invCheckPostalCode') != null) {
	            COSTCO.Product.retrieveEDD();
	          }
	        });
	      }
	      $('#minQtyText').bind("click", function () {
	        $('#minQtyText').focus();
	      });
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        this.pdpMakeElementSticky();
	        if (COSTCO.Product.item_type == 'bundle') {
	          this.bundlePageReload();
	          this.bundle_backorder_check();
	        }
	        this.initializeAdaForTabPanel();
	        this.makeTextNonClicableForSR();
	        this.initShippingStatementPopover();
	      }
	
	      document.addEventListener("CostcoSubModulesLoaded", COSTCO.Product.startMutationObserver, false);
	
	      /** INC6205314 - Below code will resize the PDP Review tab content after the BV call back. */
	      window.bvCallback = function (BV) {
	        BV.configure('global', {
	          events: {
	            bvRender: function bvRender(data) {
	              // JavaScript code that executes when the Bazaarvoice application renders.
	              COSTCO.Product.showViewMore();
	            }
	          }
	        });
	      };
	
	      // Binding for Success Notification element Close Icon
	      $('#product-page').on('click', '.success-notification .co-close', function (event) {
	        $('#product-page .success-notification').remove();
	      });
	      this.makeSocialIconsAdaCompliant();
	
	      COSTCO.Product.setShareButtonWidth();
	      COSTCO.Product.startProductActionV2MutationObserver();
	      COSTCO.Product.startVendorActionV2MutationObserver();
	      var ctaEspotAttr = $('.product-cta-espot div').attr('data-bi-placement');
	      if (!((typeof ctaEspotAttr === "undefined" ? "undefined" : _typeof(ctaEspotAttr)) !== ( true ? "undefined" : _typeof(undefined)) && ctaEspotAttr !== false)) {
	        $('.product-cta-espot').addClass("hide");
	      }
	      $('.unit-content').unbind().on('click', function (e) {
	        $('#minQtyText').focus();
	      });
	      var sessionStorageDataModal = sessionStorage.getItem('AddedToCartModalData');
	      if (sessionStorageDataModal && sessionStorageDataModal != null) {
	        this.invokeAddedToCartModalData(sessionStorageDataModal);
	      }
	
	      $('#mattress-statement').hide();
	
	      COSTCO.Product.toggleDeliveryMoleculeOnComingSoon();
	
	      $(window).on('load', function () {
	        COSTCO.Product.unsetBreadcrumbPadding();
	
	        $('.lcrelatedvideos-e2').each(function () {
	          this.style.setProperty('margin-left', '0px', 'important');
	        });
	        try {
	          COSTCO.Product.mobileSharePdp();
	        } catch (e) {}
	        //3 level item variants
	        if (!COSTCO.CMath.iskitsbundle) {
	          for (var i = $('.varis[data-product=0]').length - 1; i > 0; i--) {
	            if ($('#swatches-productOption0' + i + ' .selection-box-v2 input:disabled').length > 0) {
	              var firstSelectedVariant = $('#swatches-productOption0' + i + ' .selection-box-v2 input:not(:disabled)')[0];
	
	              $('#productOption0' + i).val($(firstSelectedVariant).val());
	              $('#productOption0' + i).change();
	            }
	          }
	          if ($('#swatches-productOption00 .selection-box-v2 input:disabled').length > 0) {
	            var _firstSelectedVariant = $('#swatches-productOption00 .selection-box-v2 input:not(:disabled)')[0];
	
	            $('#productOption00').val($(_firstSelectedVariant).val());
	            $('#productOption00').change();
	          } else if ($('.varis-v2').length > 0) {
	            var selectedOptionSpanText = $('.selectedOptionValue').text().trim();
	            var selectedOptionDropdownText = $('.varis-v2').find(":selected").text().trim();
	
	            if (selectedOptionSpanText != selectedOptionDropdownText) {
	              $('.varis-v2 option').filter(function () {
	                return $(this).text() == selectedOptionSpanText;
	              }).prop('selected', true);
	
	              var selectedOptionValue = $('.varis-v2').find(":selected").val();
	              $('.varis').find('option[value=' + selectedOptionValue + ']').prop('selected', true);
	              $('#productOption00').change();
	            }
	          }
	        }
	      });
	
	      //SFSTRY0014266 - SOK iFrame analytics change
	      if ($('ul#tablist a#reqConsultTab').length > 0 && typeof digitalDataEvents !== 'undefined') {
	        digitalDataEvents.push({ update: { product: { inventoryStatus: "Request Consultation" } } });
	      }
	    },
	
	    hide_writereview: function hide_writereview() {
	      if (COSTCO.CMath.iskitsbundle) {
	        var targetObject = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? $('#product-info')[0] : $('#accordion-product-details')[0];
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("childList" === mutation.type && $(mutation.target).find('.bv-content-list-container').length > 0) {
	              $('.bv-submission-button').removeClass("bv-write-review");
	              $('.bv-submission-button').removeClass("bv-first-to-review");
	              $('.bv-submission-button').html("");
	              $('.bv-action-bar').html("");
	              $('.bv-action-bar').removeClass("bv-action-bar");
	            }
	          });
	        });
	        observerObject.observe(targetObject, { attributes: true, attributeOldValue: true,
	          childList: true,
	          subtree: true,
	          characterData: true
	        });
	      }
	    },
	
	    unsetBreadcrumbPadding: function unsetBreadcrumbPadding() {
	      $('#crumbs_ul > div').css('padding', 'unset');
	    },
	
	    mobileSharePdp: function mobileSharePdp() {
	      try {
	
	        if (typeof Android != 'undefined' && typeof Android.onSharePopup != 'undefined') {
	          $("#pdp-share-android-native").show();
	          $(".social-share").hide();
	          $("#pdp-share-android-native").unbind("click").bind("click", function () {
	            Android.onSharePopup($(document).attr('title'), window.location.href);
	          });
	        } else if (typeof webkit != 'undefined' && typeof webkit.messageHandlers != 'undefined' && typeof webkit.messageHandlers.onSharePopup != 'undefined' && typeof webkit.messageHandlers.onSharePopup.postMessage != 'undefined') {
	
	          $("#pdp-share-ios-native").show();
	          $(".social-share").hide();
	          $("#pdp-share-ios-native").unbind("click").bind("click", function () {
	            webkit.messageHandlers.onSharePopup.postMessage(window.location.href);
	          });
	
	          //iOS behaves strange, it needs timeout to run async
	          setTimeout(function () {
	            if ($("#pdp-share-ios-native").is(":hidden") && $("#pdp-share-android-native").is(":hidden")) {
	              $(".social-share").show();
	            }
	          }, 1000);
	        }
	      } catch (e) {
	        $("#pdp-share-android-native").hide();
	        $("#pdp-share-ios-native").hide();
	        $(".social-share").show();
	      }
	    },
	
	    eddObserver: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null
	    },
	
	    productActionV2Observer: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null
	    },
	
	    productActionV2ObserverState: '',
	
	    vendorActionV2Observer: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null
	    },
	
	    vendorActionV2ObserverState: '',
	
	    eddMutationObserverState: '',
	
	    eddFormDisplayed: '',
	
	    displayEDDForm: true,
	
	    sortVariantOptions: false,
	
	    sortVariantOptions_V2: false,
	
	    /**
	     * Function used to watch for changes of catEntryId, calling retrieveEDD in case of observing
	    */
	    startEDDMutationObserver: function startEDDMutationObserver() {
	      var targetObject = $('#ProductForm #catEntryId');
	      if (targetObject.length > 0 && this.displayEDDForm === true) {
	        targetObject = targetObject[0];
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("attributes" === mutation.type) {
	              COSTCO.Product.showEddForm();
	            }
	          });
	        });
	        // Register the target node to observe and specify which DOM changes to watch
	        observerObject.observe(targetObject, {
	          attributes: true
	        });
	
	        this.eddObserver.observer = observerObject;
	      }
	      COSTCO.Product.eddMutationObserverState = Product.eddObserver.state.STARTED;
	    },
	
	    /**
	     * Function used to watch for changes of #ctas content, calling changeContentOfExternalButton in case of observing change in first loop
	    */
	    startVendorActionV2MutationObserver: function startVendorActionV2MutationObserver() {
	      var targetObject = $('#ctas');
	      if (targetObject.length > 0) {
	        targetObject = targetObject[0];
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("childList" === mutation.type && COSTCO.Product.vendorActionV2ObserverState !== 'STOPPED') {
	              if ($('#ctas ul li a').length) {
	                COSTCO.Product.changeContentOfExternalButton();
	              }
	              COSTCO.Product.vendorActionV2ObserverState = Product.vendorActionV2Observer.state.STOPPED;
	            }
	          });
	        });
	        // Register the target node to observe and specify which DOM changes to watch
	        observerObject.observe(targetObject, {
	          childList: true,
	          subtree: true
	        });
	        this.vendorActionV2Observer.observer = observerObject;
	      }
	      COSTCO.Product.vendorActionV2ObserverState = Product.vendorActionV2Observer.state.STARTED;
	    },
	
	    /**
	     * Function used to watch for changes of #mr-registry-container content, calling setShareButtonWidth in case of observing
	    */
	    startProductActionV2MutationObserver: function startProductActionV2MutationObserver() {
	      var targetObject = $('#mr-registry-container');
	      if (targetObject.length > 0) {
	        targetObject = targetObject[0];
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("childList" === mutation.type) {
	              COSTCO.Product.setShareButtonWidth();
	              COSTCO.Product.makeGiftRegistryAdaCompliant();
	              if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.item_type == 'bundle') {
	                COSTCO.Product.arrangeBundleButtons();
	              }
	            }
	          });
	        });
	        // Register the target node to observe and specify which DOM changes to watch
	        observerObject.observe(targetObject, {
	          childList: true
	        });
	        this.productActionV2Observer.observer = observerObject;
	      }
	      productActionV2ObserverState = Product.productActionV2Observer.state.STARTED;
	    },
	
	    /**
	     * Mask quantity input field for PDP page
	     */
	    maskQuantityInput: function maskQuantityInput() {
	      $("input[name*='quantity']").unmask().mask(COSTCO.util.isBusinessDelivery() ? '0000' : '000');
	    },
	
	    /**
	     * Function used to change state eddMutationObserverState and disconnect observer in case of showing edd form.
	    */
	    stopEDDMutationObserver: function stopEDDMutationObserver() {
	
	      COSTCO.Product.eddMutationObserverState = Product.eddObserver.state.STOPPED;
	      if (!_typeof(this.eddObserver.observer) === "undefined") {
	        this.eddObserver.observer.disconnect();
	      }
	    },
	
	    /**
	     * Function used to show Live Chat Us feature on the PDP page
	    */
	    enableChatFeature: function enableChatFeature() {
	      if ('BC' === $('#applicationType').val() && $("input[name='productBeanId']").length > 0) {
	        /* Get Catentry Id and partnumber of the Product */
	        var catentryid = $("input[name='productBeanId']").val();
	        var partnumber = $("input[name='productPartnumber']").val();
	        if (!(typeof catentryid === "undefined")) {
	
	          COSTCO.util.ajax({
	            url: '/AjaxGetChatDetails',
	            method: 'GET',
	            dataType: 'json',
	            data: {
	              productId: catentryid,
	              signedIn: COSTCO.util.getMemberCookie().signedIn,
	              hostname: window.location.protocol + "//" + window.location.hostname,
	              partnumber: partnumber
	            },
	            done: function done(data, textStatus, jqXHR, options) {
	              if (data.errorMessageKey) {
	                console.log('Error Occured ' + data.errorMessage);
	              } else if (data.showChatURL) {
	                var windowHeight = window.innerHeight;
	                var feedbackWidth = $('button.chat-button').width() + 10; /* 10px spacing between feedback and chat */
	                var feedbackConverted = feedbackWidth * 100 / windowHeight;
	                var finalHeight = 49 + feedbackConverted; /* 49 top of feedback button */
	                $('button.chat-button').css('top', finalHeight + "%");
	                var chatUrl = new DOMParser().parseFromString(data.chatURL, "text/html");
	                var finalChatUrl = chatUrl.body.textContent;
	                COSTCO.Product.showChatWindow(finalChatUrl);
	              } else {
	                var chatButton = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? 'button.chat-button-v2' : 'button.chat-button';
	                $(chatButton).addClass('hidden');
	              }
	            }, fail: function fail(data) {
	              console.log('Unexpected Error Occured');
	            }
	          });
	        }
	      }
	    },
	    /**
	     * This method is used to render a new Chat Window and load the Chat Us Link
	     */
	    showChatWindow: function showChatWindow(customURL) {
	      var liveChatButton;
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        liveChatButton = 'button.chat-button-v2';
	      } else {
	        liveChatButton = 'button.chat-button';
	      }
	      $(liveChatButton).click(function (event) {
	        /**
	         * If chat window already open then focus existing one
	         * else open new window
	         */
	        if (customURL.length > 0) {
	          if (COSTCO.Product.chatWindow != undefined && !COSTCO.Product.chatWindow.closed) {
	            COSTCO.Product.chatWindow.focus();
	          } else {
	            var chatWindowWidth = 320;
	            var chatWindowHeight = 800;
	            var left = $(window).width() - chatWindowWidth;
	            COSTCO.Product.chatWindow = window.open(customURL, 'chatWindow', 'width=' + chatWindowWidth + ',height=' + chatWindowHeight + ',scrollbars=1,top=0,left=' + left);
	            COSTCO.Product.chatWindow.moveTo(left, 0);
	            COSTCO.Product.chatWindow.focus();
	          }
	        }
	      });
	    },
	
	    /**
	     * Setting width for button share on pdp
	     * @return void
	     */
	    setShareButtonWidth: function setShareButtonWidth() {
	      if ($('#add-to-list').html() == undefined && ($('#mr-registry-container').html() == undefined || $('#mr-registry-container').html().contents == undefined)) {
	        $('#mr-registry-container').remove(); //remove container if it is empty
	        $('#product-social-print-mobile').css('width', '100%');
	      }
	    },
	
	    /**
	     * Changing content of external button
	     * @return void
	     */
	    changeContentOfExternalButton: function changeContentOfExternalButton() {
	      var selector = $('div#ctas').find('a').children('input.primary').length ? $('div#ctas').find('a').children('input.primary') : $('div#ctas').find('a.external').children('span');
	      if (selector.length > 0 && selector.text() !== messages.RWD_VENDOR_CTA_BUTTON_TEXT_ORDER_HERE) {
	        if (selector.is('span')) {
	          selector.text(messages.RWD_VENDOR_CTA_BUTTON_TEXT);
	        } else {
	          selector.val(messages.RWD_VENDOR_CTA_BUTTON_TEXT);
	        }
	      }
	      COSTCO.Product.vendorActionV2ObserverState = Product.vendorActionV2Observer.state.STOPPED;
	    },
	    /**
	     * Update the EDD zip code based on the current zip code cookie value.
	     */
	    setEDDZipCode: function setEDDZipCode() {
	      $("#eddZipCodeField").val($.cookie('invCheckPostalCode'));
	    },
	
	    /**
	     * change prive from base 64 to a decimal value
	     */
	    processPrice: function processPrice(value) {
	      value = typeof value !== 'undefined' && value != null ? value : "";
	      value = typeof value == "string" ? COSTCO.util.base64test.test(value) ? COSTCO.util.decode(value) : value : value;
	      if ($.type(value) === 'string') {
	        value = value.split(',').join('');
	      }
	      return this.parseCurrency(value);
	    },
	    /**
	     * round a number down to 2 decimal places
	     */
	    parseCurrency: function parseCurrency(num) {
	      if (typeof num == "number") {
	        num = num.toString();
	      }
	      num = parseFloat(Math.round(num.replace(/\s/g, '') * 100) / 100).toFixed(2).toLocaleString();
	      return num;
	    },
	    focusToNavPdpTabHeader1: function focusToNavPdpTabHeader1() {
	      $("#nav-pdp-tab-header-1").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader2: function focusToNavPdpTabHeader2() {
	      $("#nav-pdp-tab-header-2").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader3: function focusToNavPdpTabHeader3() {
	      $("#nav-pdp-tab-header-3").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader4: function focusToNavPdpTabHeader4() {
	      $("#nav-pdp-tab-header-4").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader5: function focusToNavPdpTabHeader5() {
	      $("#nav-pdp-tab-header-5").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader6: function focusToNavPdpTabHeader6() {
	      $("#nav-pdp-tab-header-6").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader7: function focusToNavPdpTabHeader7() {
	      $("#nav-pdp-tab-header-7").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader8: function focusToNavPdpTabHeader8() {
	      $("#nav-pdp-tab-header-8").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader9: function focusToNavPdpTabHeader9() {
	      $("#nav-pdp-tab-header-9").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader10: function focusToNavPdpTabHeader10() {
	      $("#nav-pdp-tab-header-10").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader11: function focusToNavPdpTabHeader11() {
	      $("#nav-pdp-tab-header-11").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader12: function focusToNavPdpTabHeader12() {
	      $("#nav-pdp-tab-header-12").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader13: function focusToNavPdpTabHeader13() {
	      $("#nav-pdp-tab-header-13").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader14: function focusToNavPdpTabHeader14() {
	      $('html, body').scrollToElem($('.bottom-content'), 500);
	      setTimeout(function () {
	        $('#tablist li').removeClass('active');
	        $('.tab-content div').removeClass('active in');
	        $('#tab-header-bundle').addClass('active');
	        $('.build-bundle-tab').addClass('active in');
	      }, 500);
	      $("#buildabundleTitle").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader15: function focusToNavPdpTabHeader15() {
	      $("#selectedKbOffScreenSwatch").attr("tabindex", -1).focus();
	    },
	
	    formatMoney: function formatMoney(number, has_symbol) {
	      var number = number.toString(),
	          dollars = number.split('.')[0],
	          cents = (number.split('.')[1] || '') + '00';
	      dollars = dollars.split('').reverse().join('').replace(/(\d{3}(?!$))/g, '$1,').split('').reverse().join(''), symbol = has_symbol ? '$' : "";
	      var locale = COSTCO.util.getLocale();
	      var appType = $('#applicationType').val();
	
	      if (locale == 'fr-CA' && appType == 'BD') {
	        return dollars.split(",").join(" ") + ',' + cents.slice(0, 2) + ' ' + symbol;
	      } else if (locale == 'fr-CA' && appType == 'BC') {
	        return dollars.split(",").join(" ") + ',' + cents.slice(0, 2) + symbol;
	      }
	
	      return symbol + dollars + '.' + cents.slice(0, 2);
	    },
	    /**
	     * This function iterates through every variant on a product page and sorts
	     * its option, first by sequence, then price (if single variant) else alphabetically.
	     * @return {[type]} [description]
	     */
	    sort_variant_options: function sort_variant_options() {
	      $('.variantContainer').each(function (i, vContainer) {
	        $(vContainer).find('select.varis').each(function (j, select) {
	          var $options = $(select).find('option:not([value=unselected])'),
	              product_num = $(select).data('product');
	          if (!COSTCO.CMath.iskitsbundle) {
	            $options.detach().sort(function (option_a, option_b) {
	
	              var seq_a = parseFloat(this.get_item_sequence(option_a.value, product_num)),
	                  seq_b = parseFloat(this.get_item_sequence(option_b.value, product_num));
	              if (seq_a == seq_b) {
	                // Same sequences, try sorting by price
	                var item_a = this.findItem(products[product_num], this.get_selected_array($(option_a))),
	                    item_b = this.findItem(products[product_num], this.get_selected_array($(option_b)));
	                if (item_a && item_b) {
	                  var price_a = parseFloat(COSTCO.util.decode(item_a.price).split(',').join('')),
	                      price_b = parseFloat(COSTCO.util.decode(item_b.price).split(',').join(''));
	                  return price_b - price_a;
	                } else {
	                  return option_a.text.toLowerCase() > option_b.text.toLowerCase() ? 1 : -1;
	                }
	              } else {
	                return seq_a > seq_b ? 1 : -1;
	              }
	            }.bind(this));
	            $options.removeAttr("selected");
	            $options.appendTo(select);
	          }
	
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            this.displayVarianceView(select);
	            if ($(vContainer).find('select.varis').length == j + 1) {
	              COSTCO.Product.sortVariantOptions_V2 = true;
	              var preselectOption = COSTCO.util.getParameterByName('preselectOption');
	              if (typeof preselectOption !== 'undefined' && preselectOption != null) {
	                COSTCO.CMath.bindVariantProducts('', preselectOption);
	              } else {
	                COSTCO.CMath.bindVariantProducts();
	              }
	            }
	          } else {
	            if ($(vContainer).find('select.varis').length == j + 1) {
	              COSTCO.Product.sortVariantOptions = true;
	            }
	            COSTCO.CMath.bindVariantProducts();
	          }
	        }.bind(this));
	      }.bind(this));
	    },
	
	    sort_secondary_variant_options: function sort_secondary_variant_options(selectedVariant) {
	      $('.variantContainer').find('select.varis').each(function (j, select) {
	        if ($(select).attr('id') !== $(selectedVariant).attr('id')) {
	          var $options = $(select).find('option:not([value=unselected])'),
	              product_num = $(select).data('product');
	          var selectedOptionVal = $(select).find('option:selected').val();
	          $options.detach().sort(function (option_a, option_b) {
	            var seq_a = parseFloat(COSTCO.Product.get_item_sequence_selectVariant(option_a.value, $(selectedVariant).val(), product_num)),
	                seq_b = parseFloat(COSTCO.Product.get_item_sequence_selectVariant(option_b.value, $(selectedVariant).val(), product_num));
	
	            if (isNaN(seq_a)) {
	              seq_a = 0;
	            } else if (isNaN(seq_b)) {
	              seq_b = 0;
	            }
	            if (seq_a == seq_b) {
	              // Same sequences, try sorting by price
	              var item_a = COSTCO.Product.findItem(products[product_num], COSTCO.Product.get_selected_array($(option_a))),
	                  item_b = COSTCO.Product.findItem(products[product_num], COSTCO.Product.get_selected_array($(option_b)));
	              if (item_a && item_b) {
	                var price_a = parseFloat(COSTCO.util.decode(item_a.price).split(',').join('')),
	                    price_b = parseFloat(COSTCO.util.decode(item_b.price).split(',').join(''));
	                return price_b - price_a;
	              } else {
	                return option_a.text.toLowerCase() > option_b.text.toLowerCase() ? 1 : -1;
	              }
	            } else {
	              return seq_a > seq_b ? 1 : -1;
	            }
	          }.bind(this));
	
	          $options.removeAttr("selected");
	          $options.appendTo(select);
	          var rePrintSortedTiles = '<legend id="variantLegend-productOption0' + j + '" class="sr-only">' + $(select).closest('.vari').find('label').text() + '</legend>';
	          $options.each(function (i, option) {
	            var optionValue = $(option).text();
	            if ($(option).val() === selectedOptionVal) {
	              $(option).prop('selected', true);
	            }
	            var templateName;
	            if (COSTCO.CMath.iskitsbundle) {
	              templateName = 'tmpl_KB_product_variants_v2';
	            } else {
	              templateName = 'tmpl_product_variants_v2';
	            }
	            rePrintSortedTiles += COSTCO.util.tmpl(templateName, {
	              inputName: $(select).prop('name'),
	              inputValue: $(option).val(),
	              variantName: optionValue,
	              disabled: $(select).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? 'disabled' : '',
	              tabindex: $(select).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? '-1' : '0',
	              checkedValue: $(option).is(':selected') ? 'checked' : '',
	              ariaChecked: $(option).is(':selected') ? 'true' : 'false'
	            });
	          });
	          var sortedVariantFieldset = $('#swatches-' + $(select).prop('name')).find('fieldset label.variant-v2').parent();
	          sortedVariantFieldset.html('');
	          sortedVariantFieldset.html(rePrintSortedTiles);
	
	          $('#swatches-' + $(select).prop('name') + ' label.selection-box-v2').on('click keypress', function () {
	            $('#isPriceCallInvokedForPickup').val('false');
	            var radioValue = $(this).find('input').val();
	            $('#' + $(select).prop('name')).val(radioValue);
	            $('#' + $(select).prop('name')).trigger('change.vari');
	            $(this).find('input').each(function () {
	              $(this).prop('checked', 'false');
	            });
	            $(this).find('input').prop('checked', 'true');
	          });
	        }
	      }.bind(this));
	    },
	
	    /**
	     * Generate variance view for a PDP Redesign page
	     * @param selectVariant variant selection to generate view from
	     * @return void
	     */
	    displayVarianceView: function displayVarianceView(selectVariant) {
	      var _this = this;
	
	      var tileHtml = '';
	      var variantLabelHtml = '';
	      var selectVariantName = $(selectVariant).prop('name');
	      var selectVariantOptions = $(selectVariant).find('option:not([value=unselected])');
	      var variantSelected = $(selectVariant).find('option:selected').hasClass('opt');
	      var isBundle = $('.bundleQty').length > 0;
	      var variantLabelText = $(selectVariant).closest('.vari').find('label').text().trim();
	      var templateName;
	      if (COSTCO.CMath.iskitsbundle) {
	        templateName = 'tmpl_KB_product_variants_v2_label';
	      } else {
	        templateName = 'tmpl_product_variants_v2_label';
	      }
	
	      variantLabelHtml += COSTCO.util.tmpl(templateName, {
	        selectedOptionKey: variantLabelText,
	        optionId: $(selectVariant).attr('id')
	      });
	
	      if ($(selectVariant).parents('.vari').is('.swatchDropdown[data-swatch-mode=2]')) {
	        if (COSTCO.CMath.iskitsbundle) {
	          var theSwatchesCloned = $('#theKBSwatches').clone(true);
	          $('#theKBSwatches').remove();
	          var $labelForSwatches = $('label[for="theKBSwatches"]');
	          $labelForSwatches.removeClass('hide');
	          $labelForSwatches.after(theSwatchesCloned);
	          $('#theKBSwatches').removeClass('hide');
	        } else {
	          var _theSwatchesCloned = $('#theSwatches').clone(true);
	          $('#theSwatches').remove();
	          $('#pdpSwatches').remove();
	          var _$labelForSwatches = $('label[for="theSwatches"]');
	          _$labelForSwatches.removeClass('hide');
	          _$labelForSwatches.after(_theSwatchesCloned);
	
	          var $labelForPdpSwatches = $('label[for="pdpSwatches"]');
	          $labelForPdpSwatches.removeClass('hide');
	          $labelForPdpSwatches.after(_theSwatchesCloned);
	        }
	      } else if (numberOfOptionsToDisplayAsTiles && selectVariantOptions.length < numberOfOptionsToDisplayAsTiles && !isBundle) {
	
	        selectVariantOptions.each(function (i, option) {
	          var optionValue = $(option).text();
	          if (COSTCO.CMath.iskitsbundle) {
	            tileHtml += COSTCO.util.tmpl('tmpl_KB_product_variants_v2', {
	              inputName: selectVariantName,
	              inputValue: $(option).val(),
	              variantName: optionValue,
	              disabled: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? 'disabled' : '',
	              tabindex: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? '-1' : '0',
	              checkedValue: $(option).is(':selected') ? 'checked' : '',
	              ariaChecked: $(option).is(':selected') ? 'true' : 'false',
	              i: i + 1
	            });
	          } else {
	            tileHtml += COSTCO.util.tmpl('tmpl_product_variants_v2', {
	              inputName: selectVariantName,
	              inputValue: $(option).val(),
	              variantName: optionValue,
	              disabled: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? 'disabled' : '',
	              tabindex: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? '-1' : '0',
	              checkedValue: $(option).is(':selected') ? 'checked' : '',
	              ariaChecked: $(option).is(':selected') ? 'true' : 'false'
	            });
	          }
	        });
	        var templateName;
	        if (COSTCO.CMath.iskitsbundle) {
	          templateName = 'tmpl_KB_product_variants_v2_row';
	        } else {
	          templateName = 'tmpl_product_variants_v2_row';
	        }
	        $('#product-details').append(COSTCO.util.tmpl(templateName, {
	          swatchesId: selectVariantName,
	          tileDisplay: tileHtml,
	          variantLabel: variantLabelHtml,
	          selectedOptionKey: $(selectVariant).closest('.vari').find('label').text()
	
	        }));
	
	        if (variantSelected) {
	          COSTCO.CMath.update_selected_option_label($(selectVariant).find('option:selected').val());
	        }
	
	        $('#swatches-' + selectVariantName + ' input[type=radio]').change(function () {
	          var radioValue = $(this).val();
	          $('#' + selectVariantName).val(radioValue);
	          $('#isPriceCallInvokedForPickup').val('false');
	          if (selectVariantName === 'productOption00') {
	            COSTCO.Product.sort_secondary_variant_options($(selectVariant));
	          }
	          if (COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete) {
	            //Following code for reload page if user is clicking dropdown
	            COSTCO.CMath.redirectPDP();
	          } else {
	            $('#' + selectVariantName).trigger('change.vari');
	          }
	        });
	
	        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	          $('#swatches-' + selectVariantName + ' label.selection-box-v2').on('keypress', function () {
	            $('#isPriceCallInvokedForPickup').val('false');
	            var radioValue = $(this).find('input').val();
	            $('#' + selectVariantName).val(radioValue);
	            $('#' + selectVariantName).trigger('change.vari');
	            $(this).find('input').each(function () {
	              $(this).prop('checked', 'false');
	            });
	            $(this).find('input').prop('checked', 'true');
	          });
	        };
	      } else {
	
	        var styleSelect = $(selectVariant).parent('.style-select');
	        if (!isBundle) {
	          $('#product-details').append(variantLabelHtml);
	        }
	        if ($('#isBDAppVar').val() != 'BD' && isPDPVariantGreyOutEnabled == 'true') {
	          var dropdownSkeleton = '<div class="style-select form-group dropdown-skeleton-' + selectVariantName + '" id="PDP-dropdown-skeleton"> <select class="dropdown-skeleton-load loading" disabled></select></div>';
	          $('#product-details').append(dropdownSkeleton);
	          $('[name=' + selectVariantName + ']').hide();
	        }
	        var styleSelectCloned = styleSelect.clone();
	        var optionsCloned = styleSelectCloned.find('.varis');
	        optionsCloned.removeAttr('id');
	        optionsCloned.addClass('varis-v2');
	        optionsCloned.removeClass('varis');
	        optionsCloned.attr('autocomplete', 'off');
	        optionsCloned.attr('aria-label', variantLabelText);
	
	        $('#product-details').append(styleSelectCloned);
	
	        if (isBundle) {
	          var i;
	          var a;
	
	          (function () {
	            styleSelectCloned.hide();
	            var bundleArr = document.getElementsByClassName('bundle-info-container');
	            var varArr = document.getElementsByClassName('varis-v2');
	            for (i = 0; i < bundleArr.length; i++) {
	              if (varArr[i] != undefined) {
	                varArr[i].id = "cloned" + varArr[i].name;
	                varArr[i].classList.add("cloned");
	                //Append select to the bundle container
	                for (a = 0; a < bundleArr.length; a++) {
	                  if (varArr[i].dataset.product == bundleArr[a].dataset.product && !bundleArr[a].classList.contains("input-field-v2")) {
	                    bundleArr[a].classList.add("input-field-v2");
	                    bundleArr[a].appendChild(varArr[i]);
	                  }
	                }
	              }
	            }
	            var clonedVarArr = document.getElementsByClassName('cloned');
	            var varianceLabel = $(selectVariant).closest('.vari').find('label').text();
	            for (var _i = 0; _i < clonedVarArr.length; _i++) {
	              if ($('label[for="' + clonedVarArr[_i].id + '"]').length === 0) {
	                _this.add_label_to_variance_select(clonedVarArr[_i], varianceLabel);
	                $('#' + clonedVarArr[_i].id).change(function () {
	                  var labels = $("label[for='" + this.id + "']");
	                  var selectedValue = $(this).children("option:selected").val();
	                  var item;
	                  var p = products[$(this).data('product')];
	                  labels.removeClass("label-outline-error");
	                  labels.filter('.error').hide();
	                  $(this).removeClass("error-in-bundle");
	                  for (var i = 0; i < p.length; i++) {
	                    if ($(this).val() == p[i].options || $(this).val() == p[i].catentry) {
	                      item = p[i];
	                    }
	                  }
	                  if (item) {
	                    var catentryid = item.catentry;
	                    var opPrice = COSTCO.util.decode($('.online-price[data-catentry=' + catentryid + ']').data('opvalue'));
	                    var container = this.parentElement.parentElement;
	                    var bundle = container.parentElement;
	                    var checkbox = $(bundle).find('input:checkbox');
	                    var isBackordered = false;
	                    var varianceBackorderMessage = null;
	                    $(container).find('.price').find('span').text(COSTCO.Product.formatMoney(opPrice, true));
	                    $(bundle).parent().find('#backorder-message').remove();
	                    products.forEach(function (product, index) {
	                      products[index].forEach(function (pro, ind) {
	                        if (selectedValue === pro.options[0]) {
	                          if (pro.inventory === "BACK_ORDER") {
	                            isBackordered = true;
	                            if (typeof pro.backorderMessage !== "undefined" && pro.backorderMessage != null) {
	                              $(bundle).parent().append($('<div id="backorder-message" class="warning"></div>').text(pro.backorderMessage));
	                              varianceBackorderMessage = pro.backorderMessage;
	                            } else {
	                              $(bundle).parent().append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	                              varianceBackorderMessage = messages.BACKORDER_TEXT_MSG5;
	                            }
	                          }
	                        }
	                      });
	                    });
	                    if ($(checkbox).is(':checked')) {
	                      $('#' + selectVariantName).val(selectedValue);
	                      $('#' + selectVariantName).trigger('change.vari');
	                      COSTCO.Product.changeBundleItemVarianceValue($(this).data('product') + 1, varianceLabel.trim(), $(this).children("option:selected").text(), opPrice, isBackordered, varianceBackorderMessage);
	                    }
	                  } else if (selectedValue == "unselected") {
	                    var _container = this.parentElement.parentElement;
	                    var _bundle = _container.parentElement;
	                    var _checkbox = $(_bundle).find('input:checkbox');
	                    if ($(_checkbox).is(':checked')) {
	                      $('#' + selectVariantName).val(selectedValue);
	                      $('#' + selectVariantName).trigger('change.vari');
	                      $(_container).find('.price').find('span').text('');
	                      $(_checkbox).click();
	                    }
	                  }
	                });
	              }
	              $('#' + clonedVarArr[_i].id).trigger('change');
	            }
	            if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	              styleSelectCloned.show();
	            }
	            _this.add_ellipsis_to_variance_select();
	          })();
	        }
	
	        styleSelectCloned.find('.varis-v2').change(function (event) {
	          var selectedOptionValue = $(event.target).find('option:selected').val();
	          $('.varis').find('option[value=' + selectedOptionValue + ']').prop('selected', true);
	          if (COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete) {
	            //Following code for reload page if user is clicking dropdown
	            COSTCO.CMath.redirectPDP();
	          } else {
	            $('#' + selectVariantName).trigger('change.vari');
	          }
	        });
	      }
	      $(selectVariant).parents('#variants').addClass('visually-hidden');
	    },
	
	    /**
	     * Check if bundle option is backordered
	     */
	    bundle_backorder_check: function bundle_backorder_check() {
	      $('#backorder-message').hide();
	      var containers = $('.variantContainer');
	      var bundleProducts = $('.bundle-product');
	      $(bundleProducts).find('#backorder-message').remove();
	      products.forEach(function (product, index) {
	        if ($(containers[index]).find('select').length) {
	          //Single item with one select box
	          selectedValue = $(containers[index]).find('select > option:selected').val();
	          if (selectedValue === products[index][0].options[0]) {
	            if (products[index][0].inventory === "BACK_ORDER") {
	              if (typeof products[index][0].backorderMessage !== "undefined") {
	                $(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(products[index][0].backorderMessage));
	              } else {
	                $(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	              }
	            }
	          }
	        } else if (parseInt($(containers[index]).find('input').val()) != null) {
	          // Single item with no select box (just quantity input shown)
	          var test = $(containers[index]).find('input').val();
	          if (products[index][0].inventory === "BACK_ORDER") {
	            if (bundleProducts[index] != null) {
	              if (typeof backorderMessage !== "undefined") {
	                $(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(backorderMessage));
	              } else {
	                $(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	              }
	            }
	          }
	        }
	      });
	    },
	
	    /**
	     *  Adds ellipsis to variance when text overflows select element size
	     */
	    add_ellipsis_to_variance_select: function add_ellipsis_to_variance_select() {
	      $('.varianceContainer').each(function () {
	        if ($(this).find(".viewport").length === 0) {
	          var newDiv = document.createElement("div");
	          newDiv.className = "viewport";
	          var innerDiv = document.createElement("div");
	          innerDiv.className = "innerViewport";
	          innerDiv.innerHTML = $(this).find('select option:selected').get(0).textContent;
	          newDiv.appendChild(innerDiv);
	          this.insertBefore(newDiv, this.firstChild);
	          $(this).find('select').change(function () {
	            $(this).parent().find('.innerViewport').text($("option:selected", this).text());
	          });
	        }
	      });
	    },
	
	    /**
	     * Adds label and error label to cloned variance select list
	     * @param  varianceArray
	     * @param  varianceLabel
	     */
	    add_label_to_variance_select: function add_label_to_variance_select(varianceArray, varianceLabel) {
	      var $label = $("<label>").text(varianceLabel);
	      var $errorLabel = $("<label>").text(messages.ERR_SELECT_VARIANCE + " " + varianceLabel);
	      var wrapper = document.createElement('div');
	      wrapper.classList.add("varianceContainer");
	      varianceArray.parentNode.insertBefore(wrapper, varianceArray);
	      wrapper.appendChild(varianceArray);
	      $label.attr('for', varianceArray.id);
	      $label.addClass("label-outline ");
	      $errorLabel.attr('for', varianceArray.id);
	      $errorLabel.addClass("error");
	      $errorLabel[0].style.display = "none";
	      varianceArray.parentNode.insertBefore($label[0], varianceArray.nextSibling);
	      varianceArray.parentNode.insertBefore($errorLabel[0], varianceArray.nextSibling);
	    },
	
	    /**
	     * Gets the item sequence of a product using the option value
	     * of a variant item select
	     * @param  {[type]} optionVal  [description]
	     * @param  {[type]} productNum [description]
	     * @return {[type]}            [description]
	     */
	    get_item_sequence: function get_item_sequence(optionVal, productNum) {
	      var _sequence = "";
	      for (var i = 0, len = products[productNum].length; i < len; i++) {
	        var item = products[productNum][i];
	        if (COSTCO.util.hasElem(optionVal, item.options)) {
	          _sequence = item.itemSequence;
	          break;
	        }
	      }
	      return _sequence;
	    },
	
	    /**
	     * Gets the item sequence of a product using the option value1 and option value2
	     * of a variant item select
	     * @param  {[type]} optionVal  [description]
	     * @param  {[type]} productNum [description]
	     * @return {[type]}            [description]
	     */
	    get_item_sequence_selectVariant: function get_item_sequence_selectVariant(optionVal1, optionVal2, productNum) {
	      var _sequence = "";
	      for (var i = 0, len = products[productNum].length; i < len; i++) {
	        var item = products[productNum][i];
	        if (COSTCO.util.hasElem(optionVal1, item.options) && COSTCO.util.hasElem(optionVal2, item.options)) {
	          _sequence = item.itemSequence;
	          break;
	        }
	      }
	      return _sequence;
	    },
	
	    /**
	     * Validates EDD zip code format. Returns true if zip code format is valid.
	     */
	    validateZipCode: function validateZipCode(form) {
	
	      if ($('#edd-form').find('.edd-error').length > 0) {
	        $('#edd-form').find('.edd-error').empty();
	      }
	      $.validator.addMethod("countrySpecificZipcode", function (value, element) {
	        if (wcs.storeId == '10301') return (/^(\d{5}(-\d{4})?$)$/.test($.trim(value))
	        );
	        if (wcs.storeId == '10302') return (/^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/.test($.trim(value))
	        );
	      }, messages.ERR_GROCERY_INVALID_ZIP);
	
	      $(form).validate({
	        rules: {
	          eddZipCodeField: { required: true, countrySpecificZipcode: true }
	        },
	        messages: {
	          eddZipCodeField: "<span class=\"sr-only\">" + messages.ERROR + "</span>" + messages.ERR_GROCERY_INVALID_ZIP
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          error.insertAfter(element);
	        },
	        highlight: function highlight(element, errorClass, validClass) {
	          $(element).addClass(errorClass).removeClass(validClass);
	          var enterZipMessageId = $('[id^=enterZipMessage]')[0].id;
	          $(element).attr("aria-describedby", enterZipMessageId);
	        },
	        unhighlight: COSTCO.util.unhighlightWithErrorLabel
	      });
	
	      return $(form).valid();
	    },
	
	    /**
	     * Function to validate delivery zip code
	     * 2 validation will be done
	     * 	 1. Standard form validation postal regex and required
	     *   2. Pass the zipcode to bing to also lookup country and state
	     *   	which we will pass to the command to valid zipcode
	     */
	    validateRefreshEDDZipCode: function validateRefreshEDDZipCode(element) {
	      event.preventDefault();
	      var form = event.currentTarget;
	
	      if (COSTCO.Product.validateZipCode(form)) {
	        if (typeof document.getElementById("isEDDNonNarvarFlow") !== "undefined" && document.getElementById("isEDDNonNarvarFlow") !== null) {
	          document.getElementById("isEDDNonNarvarFlow").value = true;
	        }
	        var deliveryFormZipCode = null;
	        if (wcs.storeId === '10302') {
	          if ($('#eddZipCodeField') !== undefined && $('#eddZipCodeField') !== null) {
	            deliveryFormZipCode = $('#eddZipCodeField').val().toUpperCase();
	          }
	        } else {
	          deliveryFormZipCode = $(form).find("input[name=eddZipCodeField]").val().toUpperCase();
	        }
	
	        window.wioEventBus.publish('changeDeliveryLocation', deliveryFormZipCode);
	      } else {
	        var errorContainer = $('#edd-form-block').find('.edd-error');
	        errorContainer.empty();
	        errorContainer.append(messages.ERR_INVALID_ZIP);
	        errorContainer.show();
	        $('#edd-form-block').removeClass('hide');
	      }
	    },
	
	    /** 
	     * Validates zip code. If valid calls bing and updates cookies for: zip code, state, city.
	     * Then, it invokes get edd service, and update UI with appropriate edd date or error message
	     */
	    refreshEDD: function refreshEDD(event) {
	
	      event.preventDefault();
	      var form = event.currentTarget;
	      var serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
	
	      // clear errors
	      if ($('#edd-form').find('.edd-error').length > 0) {
	        $('#edd-form').find('.edd-error').empty();
	      }
	
	      if (COSTCO.Product.validateZipCode(form)) {
	        var zipCode = $(form).find("input[name=eddZipCodeField]").val();
	
	        if (typeof zipCode !== 'undefined') {
	          zipCode = zipCode.toUpperCase();
	        }
	
	        serviceToUpdateCookies(zipCode).then(function () {
	          var qty = $('#minQtyText').val();
	          COSTCO.Product.callServiceAndRefreshEDD(qty, COSTCO.Product.refreshEDDServiceCallback);
	        }).fail(function (data) {
	          // bing failed
	          var errorContainer = $('#edd-form-block').find('.edd-error');
	          errorContainer.empty();
	          errorContainer.append(messages.ERR_INVALID_ZIP);
	          errorContainer.show();
	        });
	      }
	    },
	
	    /**
	     * Shows zip code form whenever change zip is clicked in EDD widget, hides previously
	    * displayed scenario, and resets the states of Add to cart button and OOS overlay
	     */
	    showEddForm: function showEddForm() {
	      COSTCO.Product.hideEddMessagecode();
	      $('#edd-form-block').removeClass('hide');
	      $('#add-to-cart-btn').attr("disabled", true);
	      $('#add-to-cart-btn').attr("value", messages.ADDTOCART);
	      $('.oos-overlay').addClass('hide');
	      $('#eddZipCodeField').focus();
	      if (COSTCO.Product.eddMutationObserverState === Product.eddObserver.state.STARTED) {
	        COSTCO.Product.stopEDDMutationObserver();
	      }
	      $('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
	      $('#link-membership-for-price').removeClass('primary-button-v2').addClass('secondary-button-v2');
	
	      COSTCO.Product.eddFormDisplayed = true;
	    },
	
	    retrieveEDD: function retrieveEDD() {
	      var qty = $('#minQtyText').val();
	      COSTCO.Product.callServiceAndRefreshEDD(qty, COSTCO.Product.refreshEDDServiceCallback);
	      var eddStockStatusUpdateDelay = $('#eddStockStatusUpdateDelay').val();
	      //To capture EDD response for local storage stock status we need this async
	      setTimeout(function () {
	        var itemPartNumber = COSTCO.Product.getPartnumber();
	        COSTCO.Product.updateEDDStockstatusforvariant(itemPartNumber);
	      }, eddStockStatusUpdateDelay);
	    },
	
	    callServiceAndRefreshEDD: function callServiceAndRefreshEDD(quantity, callback) {
	
	      if (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) {
	        //If the product coming soon flag is true, no need to check for EDD
	        return;
	      }
	      if (typeof quantity !== 'undefined' && parseInt(quantity) > 0) {
	        $(" #edd-check-button, #eddZipCodeField").attr("disabled", true);
	        COSTCO.Product.invokeEDDServices(quantity, callback);
	      }
	    },
	    /**
	     *  Method to invoke EDD service
	    **/
	    invokeEDDServices: function invokeEDDServices(quantity, callback) {
	      var itemPartNumber = COSTCO.Product.getPartnumber();
	      var baseUri = $('#baseUriForEDD').val();
	      var baseInventoryHeader = $('#baseInventoryHeader').val();
	      var clientIdentifier = $('#apigeeClientIdentifierHeader').val();
	      var eddConnectionTime = $('#connectionTimeOutForEDD').val();
	      var smallPackConnectionTime = $('#baseUriConnectionTimeOutForSmallPack').val();
	      var serviceTimeOut = '';
	      var costcoEnv = COSTCO.Product.validateCostcoEnv();
	      var country = COSTCO.Product.getCountry();
	      eddInstallationServicesJSON = {};
	      COSTCO.Product.hideEddMessagecode();
	      var zipCode = COSTCO.Product.getZipcode();
	      var costcoService = "restInventory";
	      var eddVendor;
	      var isGroceryProduct = $('#groceryIdentifier').val();
	      var eddUrl = '';
	      var shipcode = $('#defaultShipCode').val();
	      eddUrl = baseUri + '/' + itemPartNumber + "?destinationState=" + $.cookie('invCheckStateCode') + "&destinationPostalCode=" + zipCode + "&destinationCountryCode=" + country + "&quantity=" + quantity + "&orderItemId=" + "0" + "&shippingCodes=" + shipcode + "&action=EDD";
	      serviceTimeOut = eddConnectionTime;
	
	      var timeOutController = COSTCO.util.getTimeoutController();
	      timeOutController(serviceTimeOut, fetch(eddUrl, {
	        method: 'GET',
	        headers: {
	          "costco.env": costcoEnv,
	          "client-identifier": clientIdentifier,
	          "costco.service": costcoService,
	          "costco-x-wcs-clientSystemId": baseInventoryHeader
	        }
	      })).then(function (response) {
	        return response.json();
	      }).then(function (jsonResponse) {
	
	        //identify backordered or presell status from edd response to prevent edd message display in PDP
	        var skipEddMessage = jsonResponse.availability === COSTCO.util.productConstants.edd_backordered || jsonResponse.availability === COSTCO.util.productConstants.edd_presell;
	        var itemNumber = jsonResponse.itemNumber;
	
	        if ($("#displaybundle").length) {
	          if (null !== jsonResponse.virtualBundleId && undefined !== jsonResponse.virtualBundleId) {
	            $('#displaybundle').removeClass('hidden');
	            COSTCO.CMath.invokeBundleSetForPDP(jsonResponse.virtualBundleId);
	          } else {
	            $('#displaybundle').addClass('hidden');
	          }
	        }
	
	        SKIP_EDD = skipEddMessage;
	        //Set estimatedDeliveryDate if shipmodeDates has valid values present
	        var estimatedDeliveryDate = null !== jsonResponse.shipmodeDates && undefined !== jsonResponse.shipmodeDates && jsonResponse.shipmodeDates.length > 0 ? jsonResponse.shipmodeDates[0].estimatedDeliveryDate : undefined;
	
	        if ($('#vendorName').length > 0 && $('#vendorName').val().toLowerCase().includes('smallpack')) {
	          if (jsonResponse.itemClassification === 'SMALLPACK' && null !== estimatedDeliveryDate && undefined !== estimatedDeliveryDate) {
	            COSTCO.Product.populateSmallPackEDD(estimatedDeliveryDate);
	            COSTCO.Product.isEDDStatusAvailable = true;
	          } else if (skipEddMessage) {
	            jsonResponse.messageCode = "EDD_BACKORDERED_PRESELL_ITEM";
	            COSTCO.Product.isEDDStatusAvailable = true;
	          } else if (undefined !== isGroceryProduct && isGroceryProduct === 'true') {
	            jsonResponse.messageCode = "EDD_SMALLPACK_GROCERY_UNAVAILABLE";
	          } else {
	            if ('ShipRestricted' === jsonResponse.fulfilledBy || COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
	              jsonResponse.messageCode = 'MSG_CODE_POSTAL_CODE_RESTRICTED';
	              COSTCO.Product.isEDDStatusAvailable = false;
	            } else {
	              jsonResponse.messageCode = "EDD_SMALLPACK_UNAVAILABLE";
	              COSTCO.Product.isEDDStatusAvailable = true;
	            }
	          }
	          callback(jsonResponse);
	        } else if ($('#vendorName').length > 0 && $('#vendorName').val().toLowerCase().includes('chubltl')) {
	          if (jsonResponse.itemClassification === 'CHUBLTL' && null !== estimatedDeliveryDate && undefined !== estimatedDeliveryDate) {
	            COSTCO.Product.populateChubLTLEDD(estimatedDeliveryDate);
	            COSTCO.Product.isEDDStatusAvailable = true;
	          } else {
	            if ('ShipRestricted' === jsonResponse.fulfilledBy || COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
	              jsonResponse.messageCode = 'MSG_CODE_POSTAL_CODE_RESTRICTED';
	              COSTCO.Product.isEDDStatusAvailable = false;
	            } else {
	              jsonResponse.messageCode = "EDD_SMALLPACK_UNAVAILABLE";
	              COSTCO.Product.isEDDStatusAvailable = true;
	            }
	          }
	          callback(jsonResponse);
	        } else {
	          var msgCode = COSTCO.Product.buildMessageCodeForEDD(jsonResponse);
	          COSTCO.Product.setEDDdisplay(msgCode, jsonResponse);
	          if (jsonResponse !== undefined && jsonResponse.status !== undefined && jsonResponse.status === "SUCCESS") {
	            if (!COSTCO.util.isCAStore()) {
	              COSTCO.Product.prepareAndCallDeliveryServices();
	            }
	          }
	          callback(jsonResponse);
	          COSTCO.Product.executeAlways();
	        }
	      }).catch(function (err) {
	        COSTCO.Product.externalServiceDown();
	        if (err.message !== undefined && err.message === 'API_TIMEOUT') {
	          console.log('API TIMEOUT');
	        } else {
	          console.log('API Service Fault');
	        }
	      });
	    }, populateSmallPackEDD: function populateSmallPackEDD(estimatedDeliveryDate) {
	      var date = estimatedDeliveryDate.split('T')[0];
	      var dateToDisplay = COSTCO.Product.getDateFormattedToDisplay(date);
	      document.getElementById('estimatedDeliveryDate').innerHTML = dateToDisplay;
	      document.getElementById('edd-postal-code').innerHTML = $.cookie('invCheckPostalCode');
	      document.getElementById('edd-heading-text').innerHTML = messages.DATE_TEXT_SMALL_PACK;
	      document.getElementById('edd-heading-text-suffix').innerHTML = messages.DATE_TEXT_ORDER_NOW_SUFFIX;
	      COSTCO.Product.setZipInErrMsg('edd-date-msg');
	      $('#edd-date-msg').removeClass('hide');
	      $('.edd-carrier-text').addClass('hidden');
	    }, populateChubLTLEDD: function populateChubLTLEDD(estimatedDeliveryDate) {
	      var date = estimatedDeliveryDate.split('T')[0];
	      var dateToDisplay = COSTCO.Product.getDateFormattedToDisplay(date);
	      document.getElementById('estimatedDeliveryDate').innerHTML = dateToDisplay;
	      document.getElementById('edd-postal-code').innerHTML = $.cookie('invCheckPostalCode');
	      document.getElementById('edd-heading-text').innerHTML = messages.DATE_TEXT_SMALL_PACK;
	      document.getElementById('edd-heading-text-suffix').innerHTML = messages.DATE_TEXT_ORDER_NOW_SUFFIX;
	      COSTCO.Product.setZipInErrMsg('edd-date-msg');
	      $('#edd-date-msg').removeClass('hide');
	      document.getElementById('edd-disclaimer-text').innerHTML = messages.EDD_CHUB_LTL_GUARANTEE_PRECONDITION;
	      $('.edd-carrier-text').removeClass('hidden');
	    },
	    /**
	          *  Method to get selected partnumber for variant items and normal line items
	        **/
	    getPartnumber: function getPartnumber() {
	      var itemPartnumber = '';
	      var variantItem = COSTCO.Header.itemPartNumberSelcted;
	      var normalItem = $('#resultingItemNumbers').val();
	      if (variantItem !== undefined && variantItem !== '') {
	        itemPartnumber = variantItem;
	      } else {
	        itemPartnumber = normalItem.replace(/[[\]]/g, '');
	      }
	      return itemPartnumber;
	    },
	    /**
	          *  Method to get Zipcode for EDD and installation service call
	        **/
	    getZipcode: function getZipcode() {
	      var zipCode = $.cookie('invCheckPostalCode');
	      var finalZip = '';
	      if (zipCode != null && zipCode != '') {
	        var zipCodeWithoutExtraFour = zipCode.split('-');
	        if (zipCodeWithoutExtraFour.length > 1) {
	          finalZip = zipCodeWithoutExtraFour[0];
	        } else {
	          finalZip = zipCode;
	        }
	      }
	      return finalZip;
	    },
	    /**
	          *  Method to hide message code components
	        **/
	    hideEddMessagecode: function hideEddMessagecode() {
	      $('#edd-date-msg').addClass('hide');
	      $('#edd-postal-code-restricted').addClass('hide');
	      $('#edd-oos-select-option').addClass('hide');
	      $('#edd-outofstock').addClass('hide');
	      $('#edd-unknown-error').addClass('hide');
	      $('#edd-addit-trans-time').addClass('hide');
	      $('#edd-msg-code-available-house').addClass('hide');
	      $('#edd-msg-code-external-service-down').addClass('hide');
	      $('#edd-transit-block').addClass('hide');
	      $(" #edd-check-button, #eddZipCodeField").attr("disabled", false);
	      $('#edd-back-order-msg').addClass('hide');
	      $('#edd-form-block').addClass('hide');
	      $('#edd-msg-code-smallpack').addClass('hide');
	      $('#edd-msg-code-grocery-smallpack').addClass('hide');
	    },
	    /**
	          *  Method to disable zipcode field based on refresh edd param
	        **/
	    executeAlways: function executeAlways() {
	      $('#product-page').attr("data-onloadTracker", "false");
	      COSTCO.Product.pdpMakeElementSticky();
	    },
	    /**
	          *  Method to set EDD value from edd response to JSP page
	        **/
	    setEDDdisplay: function setEDDdisplay(msgCode, jsonResponse) {
	      if (msgCode !== undefined && msgCode !== '') {
	        var status = msgCode.split('+')[0];
	        var messageCode = msgCode.split('+')[1];
	        jsonResponse.status = status;
	        jsonResponse.messageCode = messageCode;
	        if (jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== undefined && jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== null && status === "SUCCESS" && COSTCO.Product.checkIfEDDInValidRange(jsonResponse.shipmodeDates[0].estimatedDeliveryDate)) {
	          var date = jsonResponse.shipmodeDates[0].estimatedDeliveryDate.split('T')[0];
	          var dateToDisplay = COSTCO.Product.getDateFormattedToDisplay(date);
	          jsonResponse.shipmodeDates[0].estimatedDeliveryDate = dateToDisplay;
	          document.getElementById('estimatedDeliveryDate').innerHTML = dateToDisplay;
	          document.getElementById('edd-postal-code').innerHTML = $.cookie('invCheckPostalCode');
	          $('#edd-date-msg').removeClass('hide');
	          document.getElementById('edd-disclaimer-text').innerHTML = messages.EDD_AND_CALENDAR_GUARANTEE_PRECONDITION;
	          $('.edd-carrier-text').removeClass('hidden');
	        }
	      }
	    },
	    /**
	          *  Method to disable add to cart button and enable edd form if edd service is down
	          *  NOTE: If item is smallpack, we do not want to disable add to cart button on external service down or timeout
	        **/
	    externalServiceDown: function externalServiceDown() {
	      if ($('#vendorName').length > 0 && ($('#vendorName').val().toLowerCase().includes('smallpack') || $('#vendorName').val().toLowerCase().includes('chubltl'))) {
	        $('#add-to-cart-btn').attr("disabled", false);
	      } else {
	        $('#add-to-cart-btn').attr("disabled", true);
	        COSTCO.CMath.addBorderToShipItMolecule('outOfStock');
	      }
	      $('#add-to-cart-btn').attr("value", messages.ADDTOCART);
	      $('.oos-overlay').addClass('hide');
	      $('#edd-msg-code-external-service-down').removeClass('hide');
	      $('#product-page').attr("data-onloadTracker", "false");
	      COSTCO.Product.pdpMakeElementSticky();
	    },
	    /**
	            *  Method to get country from lang id
	          **/
	    getCountry: function getCountry() {
	      var langId = COSTCO.util.getLangId();
	      var country = 'US';
	      if (langId === '-24' || langId === '-25') {
	        country = 'CA';
	      }
	      return country;
	    },
	    /**
	          * Method to set costco environment for service header
	        **/
	    validateCostcoEnv: function validateCostcoEnv() {
	      var costcoEnv = $('#costcoEnvironmentForEDD').val();
	      var higherEnv = 'QA2';
	      var ecomEnv = 'ECOM';
	      var devEnv = 'DEV';
	      if (costcoEnv === "") {
	        costcoEnv = ecomEnv;
	      } else if (costcoEnv == devEnv) {
	        costcoEnv = higherEnv;
	      }
	      return costcoEnv;
	    },
	    /**
	          * Method to invoke installation API service
	        **/
	    invokeInstallationServices: function invokeInstallationServices(eddServiceResponse, itemPartNumber, zipCode) {
	      var installationServiceUri = $('#baseUriForEDDInstallationServices').val();
	      var clientIdentifier = $('#apigeeClientIdentifierHeader').val();
	      var installationConnetionTime = $('#connectionTimeOutForEDD').val();
	      var costcoEnv = COSTCO.Product.validateCostcoEnv();
	      var installationUri = installationServiceUri + '/' + itemPartNumber + "?destinationPostalCode=" + zipCode + "&fulfilledBy=" + eddServiceResponse.fulfilledBy + "&orderItemId=" + "0";
	      var timeOutController = COSTCO.util.getTimeoutController();
	      timeOutController(installationConnetionTime, fetch(installationUri, {
	        method: 'GET',
	        headers: {
	          "costco.env": costcoEnv,
	          "client-identifier": clientIdentifier
	        }
	      })).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        eddInstallationServicesJSON = data.services;
	      }).catch(function (err) {
	        if (err.message !== undefined && err.message === 'API_TIMEOUT') {
	          console.log('API TIMEOUT');
	        } else {
	          console.log('API Service Fault');
	        }
	      });
	    },
	    /**
	     * Callback function which updates Add to cart button state and OOS overlay based on service response
	     */
	    refreshEDDServiceCallback: function refreshEDDServiceCallback(response) {
	      if (typeof response !== 'undefined' && !SKIP_EDD) {
	
	        if (COSTCO.util.islocationControlledInventoryFlow()) {
	          //fetch inventory from inventory service response
	          var inventoryStatus = $('.online-price[data-catentry=' + $('#catEntryId').val() + ']').data('inv');
	          // Handling of EDD messages of location controlled items - to avoid multiple message displays
	          // Item failing in CMath.handleContractSpecificRules() will not display EDD messages.
	          if (inventoryStatus === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	            $('.edd-container').hide();
	            $('#edd-message-block').hide();
	          }
	          if (inventoryStatus !== COSTCO.util.productConstants.inv_backorderd && inventoryStatus !== COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	            if (response.messageCode === "MSG_CODE_POSTAL_CODE_RESTRICTED") {
	              COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	              document.getElementById('postal-code-restricted-zip-code').innerHTML = $.cookie('invCheckPostalCode') + '.';
	              $('#edd-postal-code-restricted').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK" && COSTCO.Product.isVariantAvailable()) {
	              if (isPDPVariantGreyOutEnabled == 'false') {
	                $('.oos-overlay').removeClass('hide');
	              }
	              $('#edd-oos-select-option').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK") {
	              if (isPDPVariantGreyOutEnabled == 'false') {
	                $('.oos-overlay').removeClass('hide');
	              }
	              $('#edd-oos-select-option').addClass('hide');
	              document.getElementById('out-of-stock-zip-code').innerHTML = $.cookie('invCheckPostalCode') + '.';
	              $('#edd-outofstock').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_EXTERNAL_SERVICE_DOWN") {
	              $('.oos-overlay').addClass('hide');
	              $('#edd-msg-code-external-service-down').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_ADDITIONAL_TRANSIT_TIME") {
	              $('.oos-overlay').addClass('hide');
	              document.getElementById('edd-postal-code-transit-time').innerHTML = $.cookie('invCheckPostalCode');
	              $('#edd-addit-trans-time').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_AVAILABLE_INHOUSE") {
	              $('.oos-overlay').addClass('hide');
	              document.getElementById('edd-postal-code-available-inhouse').innerHTML = $.cookie('invCheckPostalCode');
	              $('#edd-msg-code-available-house').removeClass('hide');
	            } else if (response.messageCode === "EDD_SMALLPACK_GROCERY_UNAVAILABLE") {
	              $('.oos-overlay').addClass('hide');
	              document.getElementById('edd-postal-code-grocery-smallpack').innerHTML = $.cookie('invCheckPostalCode');
	              $('#edd-msg-code-grocery-smallpack').removeClass('hide');
	            } else if (response.messageCode === "EDD_SMALLPACK_UNAVAILABLE") {
	              COSTCO.Product.isLocCtrlSmallPck = true;
	              $('.oos-overlay').addClass('hide');
	              if (COSTCO.CMath.invAvailableAjax) {
	                //condition for depozipin small pck edd msg hide
	                $('#edd-msg-code-smallpack').removeClass('hide');
	                document.getElementById('edd-postal-code-smallpack').innerHTML = $.cookie('invCheckPostalCode');
	              } else {
	                $('#edd-msg-code-smallpack').addClass('hide');
	              }
	            } else if (response.status === "FAILURE" || response.messageCode === "MSG_CODE_UNKNOWN_ERROR") {
	              $('#edd-unknown-error').removeClass('hide');
	            } else {
	              $('.oos-overlay').addClass('hide');
	            }
	          }
	        } else if (response.messageCode === "MSG_CODE_POSTAL_CODE_RESTRICTED") {
	          $('.edd-container').show();
	          $('#edd-message-block').show();
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	          document.getElementById('postal-code-restricted-zip-code').innerHTML = $.cookie('invCheckPostalCode') + '.';
	          $('#edd-postal-code-restricted').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK" && COSTCO.Product.isVariantAvailable()) {
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	          if (isPDPVariantGreyOutEnabled == 'false') {
	            $('.oos-overlay').removeClass('hide');
	          }
	          $('#edd-oos-select-option').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK") {
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART_OUTOFSTOCK);
	          if (isPDPVariantGreyOutEnabled == 'false') {
	            $('.oos-overlay').removeClass('hide');
	          }
	          $('#edd-oos-select-option').addClass('hide');
	          document.getElementById('out-of-stock-zip-code').innerHTML = $.cookie('invCheckPostalCode') + '.';
	          $('#edd-outofstock').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_EXTERNAL_SERVICE_DOWN") {
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	          $('#edd-msg-code-external-service-down').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_ADDITIONAL_TRANSIT_TIME") {
	          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          document.getElementById('edd-postal-code-transit-time').innerHTML = $.cookie('invCheckPostalCode');
	          $('#edd-addit-trans-time').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_AVAILABLE_INHOUSE") {
	          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          document.getElementById('edd-postal-code-available-inhouse').innerHTML = $.cookie('invCheckPostalCode');
	          $('#edd-msg-code-available-house').removeClass('hide');
	        } else if (response.messageCode === "EDD_SMALLPACK_GROCERY_UNAVAILABLE") {
	          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          document.getElementById('edd-postal-code-grocery-smallpack').innerHTML = $.cookie('invCheckPostalCode');
	          $('#edd-msg-code-grocery-smallpack').removeClass('hide');
	        } else if (response.messageCode === "EDD_SMALLPACK_UNAVAILABLE") {
	          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#edd-msg-code-smallpack').removeClass('hide');
	          document.getElementById('edd-postal-code-smallpack').innerHTML = $.cookie('invCheckPostalCode');
	        } else if (response.status === "FAILURE" || response.messageCode === "MSG_CODE_UNKNOWN_ERROR") {
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	          $('#edd-unknown-error').removeClass('hide');
	        } else {
	          if (!COSTCO.CMath.siteControllOOS) {
	            $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	            $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	            $('.oos-overlay').addClass('hide');
	          }
	        }
	      }
	      COSTCO.Product.eddFormDisplayed = false;
	    },
	
	    prepareAndCallDeliveryServices: function prepareAndCallDeliveryServices() {
	
	      var deliveryServicesRequestMap = new Map();
	      var itemPartNumber = COSTCO.Product.getPartnumber();
	      var zipCode = COSTCO.Product.getZipcode();
	      var deliveryServicesUri = $('#baseUriForEDDDeliveryServices').val();
	      installationUri = deliveryServicesUri + '/' + itemPartNumber + "?destinationPostalCode=" + zipCode + "&orderItemId=0";
	      var defaultShipcode = $('#defaultShipCode').val();
	      if (defaultShipcode) {
	        installationUri += "&shipMode=" + defaultShipcode;
	      }
	      deliveryServicesRequestMap.set(0, installationUri);
	      COSTCO.EDD.invokeDeliveryServices(deliveryServicesRequestMap, {});
	    },
	
	    isVariantAvailable: function isVariantAvailable() {
	      return $('#product-page').attr('data-onloadTracker') === "true" && !COSTCO.Product.isSingleAvailableSKU(products) && (COSTCO.Product.item_type === 'single_variant' || COSTCO.Product.item_type === 'multi_variant') ? true : false;
	    },
	    enableAddtoCart: function enableAddtoCart() {
	      $('#add-to-cart-btn').attr("disabled", false);
	      $('#add-to-cart-btn').attr("value", messages.ADDTOCART);
	      $('.oos-overlay').addClass('hide');
	      $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	      $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	      $('#add-to-list').show();
	      COSTCO.CMath.addBorderToShipItMolecule();
	    },
	    disableAddtoCart: function disableAddtoCart(buttonMessage) {
	      $('#add-to-cart-btn').attr("disabled", true);
	      $('#add-to-cart-btn').attr("value", buttonMessage);
	      $('.oos-overlay').addClass('hide');
	      COSTCO.CMath.addBorderToShipItMolecule();
	
	      if (buttonMessage == messages.ADDTOCART_OUTOFSTOCK) {
	        $('#add-to-list').hide();
	        COSTCO.CMath.addBorderToShipItMolecule('outOfStock');
	      } else {
	        $('#add-to-list').show();
	      }
	    },
	    /**
	          * Method used to replace latest zipcode in message code string
	        **/
	    setZipInErrMsg: function setZipInErrMsg(component) {
	      var zipCode = $.cookie('invCheckPostalCode');
	      var prevZipcode = document.getElementById('prevZipCode').value;
	      var str = document.getElementById(component).innerHTML;
	      if (prevZipcode !== undefined && prevZipcode !== "" && zipCode !== prevZipcode) {
	        document.getElementById(component).innerHTML = str.replace(prevZipcode, zipCode);
	        document.getElementById('prevZipCode').value = zipCode;
	      } else if (prevZipcode === "") {
	        document.getElementById(component).innerHTML = str.replace("null", zipCode);
	        document.getElementById('prevZipCode').value = zipCode;
	      }
	    },
	    /**
	        * Method return EDD Date in Day,Month date (Thursday, October 1) format
	        **/
	    getDateFormattedToDisplay: function getDateFormattedToDisplay(date) {
	      var splitDate = date.split('-');
	      var year = splitDate[0];
	      var month = splitDate[1] - 1;
	      var day = splitDate[2];
	      var langId = COSTCO.util.getLangId();
	      var daysOfWeek;
	      var monthName;
	      if (langId === '-25') {
	        dateFormat = new Date(year, month, day).toLocaleDateString('fr-CA', { weekday: 'long', month: 'long', day: 'numeric' });
	      } else {
	        dateFormat = new Date(year, month, day).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
	      }
	      return dateFormat;
	    },
	    /**
	        *    Method return true if EDD date is in range after validating xapp entry EDD_MAX_FUTURE_DATE_DIFF
	       **/
	    checkIfEDDInValidRange: function checkIfEDDInValidRange(date) {
	      if (null != date) {
	        date = date.split('T')[0].split('-');
	        var rangeValid = false;
	        var eddMaxFutureDateDiff = parseInt($('#eddMaxFutureDateDiff').val());
	        var year = date[0];
	        var month = date[1] - 1;
	        var day = date[2];
	        var eddDate = new Date(year, month, day);
	        var today = new Date();
	        var diffTime = Math.abs(eddDate - today);
	        var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	        if (diffDays <= eddMaxFutureDateDiff) {
	          rangeValid = true;
	        }
	        return rangeValid;
	      }
	    },
	    /**
	             * Method used to form and return  message code from EDD response
	           **/
	    buildMessageCodeForEDD: function buildMessageCodeForEDD(jsonResponse) {
	      var msgString = '';
	      if (jsonResponse.availability === COSTCO.util.productConstants.edd_backordered || jsonResponse.availability === COSTCO.util.productConstants.edd_presell) {
	        //Backordered or Presell item messages will be displayed by inventory service flow
	        msgString = 'SUCCESS+EDD_BACKORDERED_PRESELL_ITEM';
	        COSTCO.Product.isEDDStatusAvailable = true;
	      } else if (typeof jsonResponse.availableForSale != 'undefined' && jsonResponse.availableForSale) {
	        if (typeof jsonResponse.shipmodeDates[0].estimatedDeliveryDate === 'undefined' || jsonResponse.shipmodeDates[0].estimatedDeliveryDate == null || jsonResponse.shipmodeDates[0].estimatedDeliveryDate != null && jsonResponse.shipmodeDates[0].estimatedDeliveryDate.trim().length === 0) {
	          if (COSTCO.Product.isAdditionalTransitTimeRequired()) {
	            msgString = 'SUCCESS+MSG_CODE_ADDITIONAL_TRANSIT_TIME';
	            COSTCO.Product.isEDDStatusAvailable = true;
	          } else {
	            msgString = 'SUCCESS+MSG_CODE_AVAILABLE_INHOUSE';
	            COSTCO.Product.isEDDStatusAvailable = true;
	          }
	        } else if (COSTCO.Product.checkIfEDDInValidRange(jsonResponse.shipmodeDates[0].estimatedDeliveryDate)) {
	          msgString = 'SUCCESS+';
	          COSTCO.Product.isEDDStatusAvailable = true;
	        } else {
	          msgString = 'FAILURE+MSG_CODE_ITEM_OUT_OF_STOCK';
	          COSTCO.Product.isEDDStatusAvailable = false;
	        }
	      } else if ('ShipRestricted' === jsonResponse.fulfilledBy || COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
	        // If fulfilled by comes back with "ship restricted", show a different error message
	        msgString = 'FAILURE+MSG_CODE_POSTAL_CODE_RESTRICTED';
	        COSTCO.Product.isEDDStatusAvailable = false;
	      } else if (jsonResponse.fulfilledBy != null && 'UNKNOWN' === jsonResponse.fulfilledBy.toUpperCase()) {
	        // if fulfilledBy = 'UNKNOWN' then an exception happened - date will be null
	        msgString = 'FAILURE+MSG_CODE_UNKNOWN_ERROR';
	        COSTCO.Product.isEDDStatusAvailable = false;
	      } else {
	        msgString = 'FAILURE+MSG_CODE_ITEM_OUT_OF_STOCK';
	        COSTCO.Product.isEDDStatusAvailable = false;
	      }
	      return msgString;
	    },
	
	    updateEDDStockstatusforvariant: function updateEDDStockstatusforvariant(itemNumber) {
	      if ((COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant') && isPDPVariantGreyOutEnabled == 'true') {
	        var uptitemarrayStatus = {};
	        var uptvariantitemArray = {};
	        var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
	        var len = optionsSelected.length;
	        var lowerSwatch = $('#swatches-productOption0' + parseInt(len - 1) + '').length > 0;
	        var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0;
	        if (COSTCO.CMath.variantJSON.length > 0) {
	          for (var i in COSTCO.CMath.variantJSON) {
	            var val = COSTCO.CMath.variantJSON[i];
	            for (var j in val) {
	              var sub_key = j;
	              var sub_val = val[j];
	              if (sub_key == itemNumber && (!COSTCO.Product.isEDDStatusAvailable || COSTCO.CMath.isErrorlocationControlleditem)) {
	                uptitemarrayStatus["OL"] = '0';
	                uptitemarrayStatus["WH"] = sub_val.WH;
	                uptvariantitemArray[itemNumber] = uptitemarrayStatus;
	                COSTCO.CMath.variantJSON[i] = uptvariantitemArray;
	                localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	              }
	            }
	          }
	          for (var i in COSTCO.CMath.variantJSON) {
	            var val = COSTCO.CMath.variantJSON[i];
	            for (var j in val) {
	              var sub_key = j;
	              var sub_val = val[j];
	              if (sub_key == itemNumber) {
	                if (sub_val.OL == '0' && sub_val.WH == '0') {
	                  if (COSTCO.Product.item_type === 'multi_variant') {
	                    if (lowerSwatch) {
	                      COSTCO.CMath.ajaxStrikeSwatches();
	                    } else if (lowerDropDown) {
	                      COSTCO.CMath.ajaxGrayOutDropDown();
	                    }
	                  } else if (COSTCO.Product.item_type === 'single_variant') {
	                    if ($('#swatches-productOption00').length > 0) {
	                      COSTCO.CMath.ajaxStrikeSwatches();
	                    } else if ($('.varis-v2[data-product=0]').length > 0) {
	                      COSTCO.CMath.ajaxGrayOutDropDown();
	                    }
	                  }
	                } else {
	                  //Following code for remove css of previous selected swatches
	
	                  if (lowerSwatch) {
	                    // pills
	                    if (COSTCO.Product.item_type === 'multi_variant') {
	
	                      variable = $('input[value=' + optionsSelected[len - 1] + ']').next().attr("automation-id");
	                    } else if (COSTCO.Product.item_type === 'single_variant') {
	                      $('.selection-item').removeClass("select-span1-OOS");
	                      variable = $('input[value=' + optionsSelected[0] + ']').next().attr("automation-id");
	                    }
	                    $('span[automation-id=' + variable + ']').removeClass("select-span1-OOS");
	                    $('span[automation-id=' + variable + ']').removeClass("span1-outofstock");
	                    $('span[automation-id=' + variable + ']').children("p").remove(); // for removing P tag
	                  } else if (lowerDropDown) {
	                    // lower level drop-down
	                    $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').removeClass("out-of-stock");
	                    $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').children("span").remove();
	                  }
	                  COSTCO.CMath.update_selected_option_label(optionsSelected[len - 1]);
	                }
	                if ($('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0) {
	                  COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
	                } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0) {
	                  COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    /**
	             * Method return true if additional transit time  required for selected state by checking  xapp entry EDD_STATES_THAT_REQUIRE_ADDITIONAL_TRANSIT_TIME
	           **/
	    isAdditionalTransitTimeRequired: function isAdditionalTransitTimeRequired() {
	      var additionalTransitTimeStates = $('#additionalTransitTimeStates').val();
	      var additionTransitTimeRequired = false;
	      var state = $.cookie('invCheckStateCode');
	      if (null !== state) {
	        state = state.toUpperCase();
	        if (additionalTransitTimeStates != null) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = additionalTransitTimeStates.split(",")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var stateFromConf = _step.value;
	
	              if (stateFromConf.toUpperCase() === state) {
	                additionTransitTimeRequired = true;
	                break;
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	      }
	      return additionTransitTimeRequired;
	    },
	
	    /**
	     * This function appends price (and backordered text) to every Single Variant product's
	     * We will only show price if the item is not member only pricing if the member is not signed in
	     * select options so that they show something like this Color: "Brown - $194.99".
	     * @return {[void]}
	     */
	    set_option_price_text: function set_option_price_text() {
	      $('.variantContainer').each(function (i, vContainer) {
	        var product_num = $(vContainer).find('[data-product]').data('product');
	        if (this.isSingleVariant([products[product_num]], true)) {
	          $(vContainer).find('select.varis option').each(function (i, option) {
	            if ($(option).val() != 'unselected') {
	              var item = this.findItem(products[product_num], this.get_selected_array($(option))),
	                  back_ordered = item.inventory == 'BACK_ORDER' ? ' - ' + messages.BACKORDER_TEXT : item.inventory == 'OUT_STOCK' ? ' - ' + messages.OUT_OF_STOCK_TEXT : "";
	              var memberOnly = $('#memberItem').val() == "true" ? true : false,
	                  userInfo = COSTCO.util.getMemberCookie(),
	                  signedIn = userInfo.signedIn,
	                  costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false;
	              var variantOptionText = $(option).text() + back_ordered;
	              if (!memberOnly || memberOnly && signedIn && costcoMember) {
	                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                  variantOptionText = variantOptionText;
	                } else {
	                  variantOptionText = variantOptionText + ' - ' + this.formatMoney(this.processPrice(item.price), true);
	                }
	              }
	              $(option).text(variantOptionText);
	              $variant_option_input = $('input[value=' + $(option)[0].value + ']');
	              if (typeof $variant_option_input.siblings('.selection-item')[0] !== "undefined") {
	                $variant_option_input.siblings('.selection-item')[0].innerHTML = variantOptionText;
	                $variant_option_input.removeAttr('checked');
	                if ($('.variantContainer select.varis').find('option:selected').val() == $(option).val()) {
	                  $('label[for=' + $('.variantContainer select.varis').find('option:selected').parent().attr('id') + ']').find('.selectedOptionValue').html(' ' + variantOptionText);
	                  $variant_option_input.prop('checked', true);
	                }
	              }
	              if (back_ordered.includes(messages.OUT_OF_STOCK_TEXT)) {
	                $(option).attr("disabled", "disabled");
	                $variant_option_input.attr("disabled", "disabled");
	                $variant_option_input.parents('label.variant-v2').addClass('disabled');
	              } else {
	                $variant_option_input.removeAttr('disabled');
	                $variant_option_input.parents('label.variant-v2').removeClass('disabled');
	              }
	            }
	          }.bind(this));
	        }
	      }.bind(this));
	    },
	    /**
	     * The popover for fees associated with a product. These are the "tool-tips" part
	     * of the line items in math table.
	     * @return {[void]}
	     */
	    pop_overs: function pop_overs() {
	      $('.co-info').popover({
	        container: '.math-table'
	      });
	
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        COSTCO.util.socialNetworksPopover('social-share-link');
	      }
	    },
	    /**
	     * If span.view-more-height is set by the business within
	     * a product's long description, this function sets the
	     * product details product-info-description to that designated
	     * max-height and appends a "View More Details" button.
	     * @return {[void]}
	     */
	    product_details_view_more: function product_details_view_more() {
	      $('#product-page .panel-body').each(function (index, el) {
	        var tab_max_height = $(el).find('.view-more-height').length > 0 ? $(el).find('.view-more-height').data('height') : $(el).find('.view-more-height-default').data('height'),
	            $content = $(el).find('.product-info-description');
	        var productType = $('#product-info').data('product');
	        //for BD specific, we want to show the content in its entirety
	        if (tab_max_height && productType !== 'tobacco') {
	          // Append the view more html
	          if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            $content.after(COSTCO.util.tmpl('tmpl_view_more', {}));
	          } else {
	            $content.after(COSTCO.util.tmpl('tmpl_view_more_v2', {}));
	          }
	          // Set the max-height to the business controlled max-height
	          $content.css({
	            'max-height': tab_max_height
	          });
	        }
	      });
	    },
	    /**
	     * Event listener for button allocated by product_details_view_more
	     * that removes the max-height attribute and then removes itself to
	     * view the entire product details.
	     * @return {[void]}
	     */
	    view_more: function view_more() {
	      if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        $(this).parents('.view-more').siblings('.product-info-description').css({
	          'max-height': 'none'
	        });
	        $(this).parents('.view-more').remove();
	      } else {
	        $(this).parents('.view-more-v2').siblings('.product-info-description').css({
	          'max-height': 'none'
	        });
	
	        $(this).parents('.view-more-v2').siblings('.product-info-description').removeClass('bv-review-section');
	
	        try {
	          var focusableElements = $(this).parents('.view-more-v2').siblings('.section-title');
	          focusableElements.attr('tabindex', '0');
	          $(focusableElements).focus();
	          if ($(this).parents('.panel-body').attr('id') === "nav-pdp-tab-header-13") {
	            COSTCO.Product.changeVisibilityOfReviewContents("show");
	          }
	          focusableElements.removeAttr('tabindex');
	        } catch (err) {}
	        $(this).parents('.view-more-v2').remove();
	      }
	    },
	    findItem: function findItem(p, o) {
	      if (o.length == 0 && p.length > 0) {
	        return p[0];
	      }
	      for (var i = 0; i < p.length; i++) {
	        if (this.areArraysEqual(o, p[i].options) || o == p[i].catentry) {
	          return p[i];
	        }
	      }
	      return null;
	    },
	    areArraysEqual: function areArraysEqual(array1, array2) {
	      var temp = new Array();
	      if (!array1[0] || !array2[0]) {
	        // If either is not an array
	        return false;
	      }
	      if (array1.length != array2.length) {
	        return false;
	      }
	      for (var i = 0; i < array1.length; i++) {
	        key = _typeof(array1[i]) + "~" + array1[i];
	        if (temp[key]) {
	          temp[key]++;
	        } else {
	          temp[key] = 1;
	        }
	      }
	      for (var i = 0; i < array2.length; i++) {
	        key = _typeof(array2[i]) + "~" + array2[i];
	        if (temp[key]) {
	          if (temp[key] == 0) {
	            return false;
	          } else {
	            temp[key]--;
	          }
	        } else {
	          // Key didn't appear in array1, arrays are not equal.
	          return false;
	        }
	      }
	      return true;
	    },
	    isSingleItem: function isSingleItem(productsArray) {
	      var no_variant_container = $('.variantContainer').length == 0;
	      return productsArray.length === 1 && productsArray[0].length === 1 && no_variant_container ? true : false;
	    },
	    isSingleAvailableSKU: function isSingleAvailableSKU(productsArray) {
	      return productsArray.length === 1 && productsArray[0].length === 1 ? true : false;
	    },
	
	    isBundle: function isBundle(productsArray) {
	      return productsArray.length > 1 || $('.bundleQty').length > 0;
	    },
	    /**
	     * On product page search for collection tab.
	     * 
	     * @return true if collection tab exist, otherwise false
	     */
	    isCollectionPage: function isCollectionPage() {
	      return $('#product-page').find('.collection-tab').length > 0 ? true : false;
	    },
	    isSingleVariant: function isSingleVariant(productsArray, override) {
	      if (productsArray != undefined && productsArray[0] != undefined && productsArray.length === 1 && $('.bundleQty').length === 0 || override) {
	        for (var i = 0, len = productsArray[0].length; i < len; i++) {
	          if (productsArray[0][i].options) if (productsArray[0][i].options.length === 1) return true;
	        }
	      } else {
	        return false;
	      }
	      return false;
	    },
	    isMultiVariant: function isMultiVariant(productsArray, override) {
	      if (productsArray.length === 1 && $('.bundleQty').length === 0 || override) {
	        for (var i = 0, len = productsArray[0].length; i < len; i++) {
	          if (productsArray[0][i].options) if (productsArray[0][i].options.length > 1) return true;
	        }
	      } else {
	        return false;
	      }
	      return false;
	    },
	    isSelectedSingleVariantBackOrdered: function isSelectedSingleVariantBackOrdered(selectedOption, product) {
	      var isBackordered = false,
	          selectedOptionValue = selectedOption.val();
	      product.forEach(function (opt, i) {
	        if (selectedOptionValue === opt.options[0]) {
	          if (opt.inventory === "BACK_ORDER") isBackordered = true;
	          return;
	        }
	      });
	      return isBackordered;
	    },
	    isSelectedMultiVariantBackOrdered: function isSelectedMultiVariantBackOrdered(selectedOptions, product) {
	      var isBackordered = false;
	      product.forEach(function (opt, i) {
	        var options = opt.options,
	            count = 0;
	        selectedOptions.each(function (chosen, k) {
	          if (COSTCO.util.hasElem(this.value, options)) count++;
	        });
	        if (count === options.length) {
	          if (opt.inventory === "BACK_ORDER") isBackordered = true;
	          return;
	        }
	      });
	      return isBackordered;
	    },
	    areAnySelectedFromBundleBackordered: function areAnySelectedFromBundleBackordered(containers) {
	      var isBackordered = false;
	      products.forEach(function (product, index) {
	        // interogate each product from 'products' array; find out what kind of item it is
	        var selectedValue;
	        if (this.isSingleItem([products[index]])) {
	          if ($(containers[index]).find('select').length) {
	            // Single item with a select box with only one option
	            selectedValue = $(containers[index]).find('select > option:selected').val();
	            if (selectedValue === products[index][0].options[0]) if (products[index][0].inventory === "BACK_ORDER") isBackordered = true;
	            return;
	          } else if (parseInt($(containers[index]).find('input').val()) > 0) {
	            // Single item with no select box (just quantity input shown)
	            if (products[index][0].inventory === "BACK_ORDER") isBackordered = true;
	            return;
	          }
	        } else if (this.isSingleVariant([products[index]], true)) {
	          if (this.isSelectedSingleVariantBackOrdered($(containers[index]).find('select > option:selected'), products[index])) {
	            isBackordered = true;
	            return;
	          }
	        } else if (this.isMultiVariant([products[index]], true)) {
	          if (this.isSelectedMultiVariantBackOrdered($(containers[index]).find('select > option:selected'), products[index])) {
	            isBackordered = true;
	            return;
	          }
	        }
	      }.bind(this));
	      return isBackordered;
	    },
	    bindSubmitToBackOrderModal: function bindSubmitToBackOrderModal() {
	      $("#ProductForm input[name='add-to-cart']").unbind('click').click(function () {
	        if (this.item_type == 'single') {
	          // Its a single product aka only "add to cart" button exists
	          typeof products[0][0].inventory !== "undefined" && products[0][0].inventory === 'BACK_ORDER' ? this.backorder_modal(products[0][0]) : $('#ProductForm').submit();
	        } else if (this.item_type == 'single_variant') {
	          // Its a single item with options (ie color or size, etc.)
	          var $options = $('#ProductForm select option:selected'),
	              selected_arr = this.get_selected_array($options);
	          this.isSelectedSingleVariantBackOrdered($options, products[0]) ? this.backorder_modal(this.findItem(products[0], selected_arr)) : $('#ProductForm').submit();
	        } else if (this.item_type == 'multi_variant') {
	          // Its a single item with multiple options (ie color and size, etc.)
	          var $options = $('#ProductForm select option:selected'),
	              selected_arr = this.get_selected_array($options);
	          this.isSelectedMultiVariantBackOrdered($options, products[0]) ? this.backorder_modal(this.findItem(products[0], selected_arr)) : $('#ProductForm').submit();
	        } else if (this.item_type == 'bundle') {
	          // Its bundle which can contain variants/singleItems - check the option(s) selected and see if they're backordered
	          this.areAnySelectedFromBundleBackordered($('.variantContainer')) ? this.backorder_modal() : $('#ProductForm').submit();
	        } else {
	          // fallback - always try to add to cart.
	          $('#ProductForm').submit();
	        }
	      }.bind(this));
	    },
	    is_sku_resolved: function is_sku_resolved(item_type, quantity_obj) {
	      var resolved = false;
	      if (item_type == 'single_variant' || item_type == 'multi_variant') {
	        // Get values of variant options selected
	        var selected_arr = this.get_selected_array($('.varis option:selected'));
	        // Are any of the select options "unselected"?
	        var any_unselected = COSTCO.util.any(selected_arr, function (value) {
	          return value == 'unselected';
	        });
	        if (!any_unselected) resolved = true;
	      } else if (item_type == 'bundle') {
	        quantity_obj.product_indices.forEach(function (indice) {
	          var product_num = indice;
	          var productArray = products && products[product_num] ? products[product_num] : [];
	          var optionsSelected = this.get_selected_array($('.varis[data-product=' + product_num + ']').find('option:selected'));
	          var product_selected = this.findItem(productArray, optionsSelected);
	          if (product_selected) {
	            // If at least one product is resolved, we're good.
	            resolved = true;
	            return;
	          }
	        }.bind(this));
	      } else {
	        // We're a single item. We always resolve.
	        resolved = true;
	      }
	      return resolved;
	    },
	    /**
	     * Returns the option:selected ($options) values as an array of strings
	     * aka ['7000000000000053', '7000000000000623']
	     * @param  {[object]} $options - The jQuery selector representing option:selected
	     * @return {[array]} Returns an array of strings
	     */
	    get_selected_array: function get_selected_array($options) {
	      return $.map($options, function (option) {
	        return $(option).val();
	      });
	    },
	    maxQuantity: function maxQuantity() {
	      return COSTCO.util.isBusinessDelivery() ? COSTCO.Product.MAX_QUANTITY_BD : Number($('#cartTotalLimitBC').val());
	    },
	    /**
	     * Returns an object with two properties. The first property, 'valid',
	     * is set to true/false based on whether or not we have (at least one) valid
	     * quantity. The product_indices property correlates with bundles; specifically
	     * their 'data-product=' attributes and is used to validate skus in the next step
	     * of validation.
	     * @param  {[string]} item_type - string representing item type. Corresponds
	     * with phelper.item_type
	     * @param quantityId quantity input element reference
	     * @return {[object]} quantity_obj - The object containing valid quantity p
	     * property (and product_indicies in case of bundles)
	     */
	    is_valid_quantity: function is_valid_quantity(item_type, quantityId) {
	      var quantityStep = COSTCO.Product.getQuantityStep(quantityId);
	      var unitOfMeasure = COSTCO.Product.getUnitOfMeasure(quantityId);
	      var err_msgs = {
	        min: "<p class='sr-only'>" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_INVALID_QTY.replace("{0}", COSTCO.Product.getQuantityStep(quantityId, unitOfMeasure)),
	        max: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_HIGHER_QTY_2.replace("{0}", COSTCO.Product.maxQuantity()),
	        badQtyIncrement: "<p class='sr-only'>" + messages.ERROR + "</p>" + quantityId.data("error-message") + ' ' + COSTCO.Product.getQuantityStep(quantityId, unitOfMeasure)
	      };
	      var quantity_obj = {
	        valid: true,
	        message: err_msgs.min
	      };
	      var product_indices = [];
	      var maxQnty = COSTCO.Product.maxQuantity();
	      var bundleQuantity = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE == true ? 'input[name^=bundle-quantity-]' : 'input[name^=quantity-]';
	      if (item_type == 'bundle') {
	        // At least one quantity must be valid
	        $(bundleQuantity).each(function (i, input) {
	          var quantity_str = $(input).val();
	          var quantity_int = parseInt(quantity_str);
	          if (!COSTCO.Product.testInput(quantity_str, quantity_int, maxQnty, quantityStep)) {
	            product_indices.push($(input).data('product'));
	            $(input).attr('aria-invalid', 'false');
	          } else {
	            //set aria-invalid to reflect invalid entry
	            $(input).attr('aria-invalid', 'true');
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	              quantity_obj.valid = false;
	              if (quantity_int <= 0) {
	                quantity_obj.message = err_msgs.min;
	              }
	              if (quantity_int > maxQnty) {
	                quantity_obj.message = err_msgs.max;
	              }
	            }
	          }
	        });
	        if (product_indices.length == 0) {
	          quantity_obj.valid = false;
	        }
	      } else {
	        var quantity_str = $('input[name=quantity]').val();
	        var quantity_int = parseInt(quantity_str);
	        if (COSTCO.Product.testInput(quantity_str, quantity_int, maxQnty, quantityStep)) {
	          $('input[name=quantity]').attr('aria-invalid', 'true');
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            quantity_obj.valid = false;
	            $('input[name=quantity]').addClass('error-qty');
	            if (quantity_int <= 0) {
	              quantity_obj.message = err_msgs.min;
	            } else if (quantity_int > maxQnty) {
	              quantity_obj.message = err_msgs.max;
	            } else if (quantity_int % quantityStep != 0) {
	              quantity_obj.message = err_msgs.badQtyIncrement;
	            }
	          }
	        } else {
	          $('input[name=quantity]').attr('aria-invalid', 'false');
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            $('input[name=quantity]').removeClass('error-qty');
	          }
	        }
	      }
	      quantity_obj.product_indices = product_indices;
	      return quantity_obj;
	    },
	    /**
	     * Returns unit of measure of input quantity value (empty string if there is no unit of measure)
	     * @param quantityId quantity input element reference
	     * @return quantity value unit of measure
	     */
	    getUnitOfMeasure: function getUnitOfMeasure(quantityId) {
	      return quantityId.next('.unit').text();
	    },
	    /**
	     * Returns true if iput value is vlaid or false otherwise
	     * @param quantity_str quantity input value in form of string
	     * @param quantity_int quantity input value in form of integer
	     * @param maxQty maximum quantity input value
	     * @param increment increment/step of quantity input value
	     * @return true if iput value is vlaid or false otherwise
	     */
	    testInput: function testInput(quantity_str, quantity_int, maxQty, increment) {
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        return isNaN(quantity_int) || quantity_int <= 0 || quantity_int > maxQty || quantity_int.toString() != quantity_str || quantity_int % increment != 0;
	      } else {
	        return isNaN(quantity_int) || quantity_int <= 0 || quantity_int > maxQty || quantity_int.toString() != quantity_str;
	      }
	    },
	
	    backorder_modal: function backorder_modal(product) {
	      // The user must select "add to cart" in the backorder modal to switch this to true
	      var add_obj = {
	        isAdd: false
	      };
	      COSTCO.dialog.showModal({
	        title: messages.RWD_ITEM_BACKORDERED,
	        body: this.backorder_message(product),
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.ADDTOCART,
	        primary_event: function () {
	          // user selected "add to cart"
	          this.isAdd = true;
	          $('#costcoModal').modal('hide');
	        }.bind(add_obj),
	        afterclose: function () {
	          if (this.isAdd) {
	            // If primary event was selected, add to cart
	            $('#ProductForm').submit();
	          }
	          this.isAdd = false; // reset state
	        }.bind(add_obj)
	      });
	    },
	    backorder_message: function backorder_message(product) {
	      if (isBDApplication && isBDApplication === 'BC') {
	        var message = product.backorderMessage + ' ' + messages.BACKORDER_TEXT_ADD;
	        var locmessage = $('#backorder-message').text();
	        if (product.isLocInvItem || (typeof locmessage === "undefined" ? "undefined" : _typeof(locmessage)) !== undefined && null != locmessage) {
	          message = locmessage + ' ' + messages.BACKORDER_TEXT_ADD;
	        }
	        return message;
	      }
	      var message_key = 'BACKORDER_TEXT_',
	          message_num = product && product.message || '5',
	          date_1 = product && product.date || '',
	          date_2 = product && product.date2 || '';
	
	      if (product) {
	        if (product.allBackorderable == 0) {
	          message_key += 'PART_MSG';
	        } else {
	          message_key += 'MSG';
	        }
	        switch (message_num) {
	          case '1':
	            message_key += message_num;
	            break;
	          case '2':
	            message_key += message_num;
	            break;
	          case '3':
	            date_1 == date_2 ? message_key += 1 : message_key += message_num;
	            break;
	          case '4':
	            date_1 == date_2 ? message_key += 2 : message_key += message_num;
	            break;
	          default:
	            message_key += message_num;
	        }
	      } else {
	        message_key += 'MSG' + message_num;
	      }
	      return messages[message_key].replace('{0}', date_1).replace('{1}', date_2) + ' ' + messages.BACKORDER_TEXT_ADD;
	    },
	    /**
	     * Add to cart modal. Invoked after the "done" promise resolves
	     * when calling AddToCart.ajaxAddToCart.
	     * @param  {[array]} selected_products Array of objects representing
	     * the items that went into the cart
	     * @return {[void]}
	     */
	    added_modal: function added_modal(selected_products, orderItemId, qtyBought, originalQty) {
	      this.related_products_member_pricing();
	      $('.modal-footer').addClass('hide');
	      var items_html = "",
	          partsandservices = this.getPartsAndServices($('#configuredInfo').val()),
	          partsandservicesType = $('#configuredInfoType').val(),
	          service_html = "",
	          parts_html = "",
	          remark_html = "",
	          parts_and_services_html = "",
	          partandserviceArray = "";
	      if ($('#reactkitsandbundle').val() != 'true') {
	        var $related_products_template = $('#product-page .related-products');
	        $('#product-page .related-products').remove();
	      } else {
	        var selectedVirtualParentPartnumber = $('#productPartnumberVal').val();
	        $related_products_template = $('#product-page #RelatedProducts_' + selectedVirtualParentPartnumber);
	      }
	      var installationFlag = undefined;
	      if (partsandservices != "") {
	        var installationFlag = JSON.parse(partsandservices).installationAvailable;
	      }
	
	      //show if installation is not available
	      if (installationFlag != undefined && !installationFlag) {
	        remark_html += COSTCO.util.tmpl('tmpl_selected_delivery_parts_no_installation', {
	          remark: messages.SCHED_DELIV_NO_INSTALLATION_ALERT
	        });
	      }
	
	      //Parts and service section for Added to cart model box
	      if (partsandservicesType == 7) {
	        if (partsandservices != 'undefined' && partsandservices.length > 0 && partsandservices != "") {
	          partandserviceArray = JSON.parse(partsandservices).services;
	          if (partandserviceArray != 'undefined' && partandserviceArray != "" && partandserviceArray.length > 0) {
	            $.each(partandserviceArray, function (index, value) {
	              if (value.serviceType == 'Service') {
	                service_html += COSTCO.util.tmpl('tmpl_services', {
	                  description: value.description,
	                  selected: value.selected ? "Yes" : "No"
	                });
	              } else if (value.serviceType == 'Part') {
	                if (!value.hidden && value.selected && value.availabilityType != 'hidden') {
	                  parts_html += COSTCO.util.tmpl('tmpl_delivery_parts_service_list', {
	                    description: value.description
	                  });
	                } else if (!value.hidden && !value.selected && value.availabilityType != 'hidden') {
	                  parts_html += COSTCO.util.tmpl('tmpl_delivery_parts_service_list', {
	                    description: value.description + " : No"
	                  });
	                }
	              }
	            });
	
	            parts_and_services_html = COSTCO.util.tmpl('tmpl_parts_and_services_addedtocart', {
	              services: service_html,
	              parts: parts_html,
	              remarks: remark_html != "" ? remark_html : ""
	            });
	          }
	        }
	      }
	
	      selected_products.forEach(function (product, orderItemId) {
	        // this is for the added to cart review modal
	        var ecofeeIncludedPrice = (document.getElementById("ecoFeeHiddenLayout_" + product.catentry) || {}).value || "0";
	        items_html += COSTCO.util.tmpl(product.isFsaChdItem == 'true' ? 'tmpl_addtocart_item_FsaChd' : 'tmpl_addtocart_item', {
	          img_url: product.img_url ? product.img_url : product.parent_img_url,
	          item_name: product.productName,
	          item_url: product.productUrl,
	          item_number: product.item_number,
	          model_number: product.manufacturerPartNumber,
	          price: ecofeeIncludedPrice != "0" ? ecofeeIncludedPrice : product.final_price,
	          quantity: product.quantity,
	          orderItemId: orderItemId,
	          parts_and_services_html: parts_and_services_html != "" ? parts_and_services_html : "",
	          linkFee: COSTCO.Product.displayLinkFee(product.feeOptions)
	        });
	      });
	
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.RELATED_PRODUCT_ADDED_TO_CART,
	        dialogclasses: 'medium',
	        body: COSTCO.util.tmpl('tmpl_addtocart_modal', {
	          items: items_html,
	          related_products: $related_products_template.length > 0 ? $related_products_template[0].outerHTML : ''
	        }),
	        onclose: function onclose() {
	          //COSTCO.Header.refreshMiniBanner();
	          $('.modal-footer').removeClass('hide');
	          if ($related_products_template.length > 0) {
	            $('#product-page').append($related_products_template[0].outerHTML);
	          }
	          window.wioEventBus.publish('focusPickUpButton', { focusPickUpButton: true });
	        }
	      });
	      $('input[name="parentOrderItemId"]').val(orderItemId);
	      $('input[name="relatedQty"]').val(originalQty);
	      console.log("Related Quantity Incoming :: " + originalQty + " :: Document source " + $('input[name="relatedQty"]').val());
	      if ($('#related-products-container:not(.hide)').find('div[name="RelatedProductFormDiv"]:not(.hide)').length > 0) {
	        $('.modal-body .related-products').removeClass('hide');
	
	        if (relProductLinkFee !== undefined && relProductLinkFee != null) {
	          Object.entries(relProductLinkFee).forEach(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                key = _ref2[0],
	                value = _ref2[1];
	
	            if ($('#relLinkFee_' + key).length > 0) {
	              $('#relLinkFee_' + key).html(COSTCO.Product.displayLinkFee(value));
	            }
	          });
	        }
	      }
	      $('.co-help.eco-fee').popover();
	    },
	    /**
	     * If a related product is a member only item, show pricing based on member cookie.
	     * @return {[void]}
	     */
	    related_products_member_pricing: function related_products_member_pricing() {
	      var userInfo = COSTCO.util.getMemberCookie(),
	          signedIn = userInfo.signedIn,
	          costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
	          validated = userInfo.validated != 'undefined' ? userInfo.validated : false;
	      active = userInfo.active != 'undefined' ? userInfo.active : false;
	      // This check is added to keep BD flow unaffected by the change in BC flow
	      var showPricingForMember = COSTCO.util.isBusinessDelivery() ? costcoMember : costcoMember && validated && active;
	      if (!signedIn) {
	        $('.sign-in').show();
	        $('.price-details.moi,.productFormContent.moi-atcf,.mem-button.moi').hide();
	      } else {
	        if (showPricingForMember) {
	          $('.sign-in, .mem-button').hide();
	        } else {
	          $('.price-details.moi,.productFormContent.moi-atcf,.sign-in').hide();
	        }
	      }
	    },
	
	    displayLinkFee: function displayLinkFee(feeOptions) {
	      var _this2 = this;
	
	      var linkFeeContenty = '';
	      if (feeOptions !== 'undefined' && feeOptions != null) {
	        var feesConfiguration;
	        var i;
	
	        (function () {
	          var region = $.cookie('C_LOC');
	          feesConfiguration = typeof feesConfigurations !== 'undefined' ? feesConfigurations : null;
	
	          if (feesConfiguration !== 'undefined' && feesConfiguration != null) {
	            var regionalFeeConfig = feesConfiguration[region] || feesConfiguration["ALL"];
	            if (regionalFeeConfig !== undefined && regionalFeeConfig != null) {
	              var _loop = function _loop() {
	                var feeCatConfig = regionalFeeConfig[i];
	                var feeTypeLis = feeCatConfig.feeType.split(',');
	                var categoryWiseFeeOpt = feeOptions.filter(function (fee) {
	                  return fee.region == region && fee.feeCategory == feeCatConfig.feeCategory;
	                });
	                if (categoryWiseFeeOpt !== undefined && categoryWiseFeeOpt != null) {
	                  var hasHybridFee = categoryWiseFeeOpt.some(function (fee) {
	                    return feeTypeLis[0] != 'ALL' && !feeTypeLis.includes(fee.feeType);
	                  });
	                  var isRegionFee = categoryWiseFeeOpt.some(function (fee) {
	                    return feeTypeLis[0] != 'ALL' && feeTypeLis.includes(fee.feeType);
	                  });
	                  var feeCategory = '',
	                      display = '',
	                      feeDesc = '';
	                  var feeAmount = 0,
	                      sameFeeCategoryCount = 0;
	                  var _iteratorNormalCompletion2 = true;
	                  var _didIteratorError2 = false;
	                  var _iteratorError2 = undefined;
	
	                  try {
	                    for (var _iterator2 = categoryWiseFeeOpt[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                      var feeOption = _step2.value;
	
	                      if (feeOption.feeCategory === feeCatConfig.feeCategory) {
	                        if (feeTypeLis.includes(feeOption.feeType) || feeCatConfig.feeType === "ALL" || hasHybridFee && !isRegionFee) {
	                          sameFeeCategoryCount++;
	                          if (!hasHybridFee || hasHybridFee && !isRegionFee) {
	                            feeAmount += parseFloat(feeOption.price);
	                          }
	                          feeCategory = feeOption.feeCategory;
	                          display = hasHybridFee ? 'STANDARD' : feeCatConfig.display.Browse;
	                          feeDesc = COSTCO.util.sentenceToPascalCase(feeOption.desc.trim());
	                        } else if (hasHybridFee) {
	                          feeAmount += parseFloat(feeOption.price);
	                        }
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                      }
	                    } finally {
	                      if (_didIteratorError2) {
	                        throw _iteratorError2;
	                      }
	                    }
	                  }
	
	                  if (sameFeeCategoryCount > 0) {
	                    linkFeeContenty += COSTCO.util.tmpl('tmpl_addtocart_linkFee_display', {
	                      "feeCategory": feeCategory,
	                      "display": display,
	                      "fee": feeAmount > 0 ? _this2.formatMoney(_this2.processPrice(feeAmount), true) : '',
	                      "feeDesc": feeDesc,
	                      "ecoFeeToolTipContent": ecoFeeToolTipContent
	                    });
	                  }
	                }
	              };
	
	              for (i = 0; i < regionalFeeConfig.length; i++) {
	                _loop();
	              }
	            }
	          }
	        })();
	      }
	      return linkFeeContenty;
	    },
	
	    /**
	     * Gets an array of item objects that are selected on the page with positive quantity
	     * @return {[array]} an array of item objects
	     */
	    getSelectedBundleAndVariantItems: function getSelectedBundleAndVariantItems() {
	      var selectedItems = [];
	      $('.variantContainer').each(function (index) {
	        var qty = $('input[name=quantity]').val(); //for non-bundle
	        var bundleQty = $(this).find('input[name^=quantity-]').val(); //for bundle
	        if (qty > 0 || bundleQty > 0) {
	          if ($(this).find('.swatchDropdown').length > 0) {
	            //variant
	            var options = [];
	            $(this).find('.varis :selected').each(function () {
	              options.push($(this).val());
	            });
	            selectedItems.push(COSTCO.Product.findItem(products[index], options));
	          } else {
	            //not a variant
	            selectedItems.push(products[index][0]);
	          }
	        }
	      });
	      return selectedItems;
	    },
	    /**
	     * Shows plain packaging option on variant selection and/or bundle quantity change
	     * based on plainPackaging property of selected item(s) on the page. Immediately
	     * shows plain packaging option for a single item page.
	     * @return {[void]}
	     */
	    enablePlainPackagingMessage: function enablePlainPackagingMessage() {
	      //shows or hides plain packaging message based on given option
	      function showHideMessage(ppOption) {
	        //for bundles and variants ppOption will be array.
	        //call the function again based on what's in the array.
	        if ($.isArray(ppOption)) {
	          if ($.inArray("0", ppOption) > -1) {
	            showHideMessage("0");
	          } else if ($.inArray("1", ppOption) > -1) {
	            showHideMessage("1");
	          } else if ($.inArray("3", ppOption) > -1) {
	            showHideMessage("3");
	          } else {
	            showHideMessage(null);
	          }
	          return;
	        }
	        if (ppOption == "1") {
	          //available
	          $("#plain-packaging-available").show();
	          $("#plain-packaging-not-available").hide();
	          $("#plain-packaging-mandatory").hide();
	        } else if (ppOption == "0") {
	          //not available
	          $("#plain-packaging-available").hide();
	          $("#plain-packaging-not-available").show();
	          $("#plain-packaging-mandatory").hide();
	        } else if (ppOption == "3") {
	          //mandatory plain packaging option
	          $("#plain-packaging-available").hide();
	          $("#plain-packaging-not-available").hide();
	          $("#plain-packaging-mandatory").show();
	        } else {
	          //don't show a message. This will be a value of null for item's plainPackaging property
	          $("#plain-packaging-available").hide();
	          $("#plain-packaging-not-available").hide();
	          $("#plain-packaging-mandatory").hide();
	        }
	      }
	
	      //returns an array of plainPackaging properties of the given items
	      function getPPOptions(items) {
	        var ppOptions = [];
	        $(items).each(function () {
	          ppOptions.push(this.plainPackaging);
	        });
	
	        return ppOptions;
	      }
	
	      if (typeof products == 'undefined') {
	        return;
	      }
	      if (COSTCO.Product.isSingleItem(products)) {
	        showHideMessage(products[0][0].plainPackaging);
	      } else {
	        //bind change event on variant selection and quantity change
	        $('.variantContainer').on('change', '.swatchDropdown:last, input[name^=quantity]', function () {
	          var selectedItems = COSTCO.Product.getSelectedBundleAndVariantItems();
	          showHideMessage(getPPOptions(selectedItems));
	        });
	      }
	    },
	
	    addToWishList: function addToWishList(baseURL) {
	      if ($('#ProductForm').valid()) {
	        var target = baseURL + '&catentryId=' + $('#ProductForm .catentryInput').map(function () {
	          return $(this).val();
	        }).get().join(',');
	        window.location = target;
	      }
	    },
	
	    openWishListSuccess: function openWishListSuccess() {
	      var queryString = COSTCO.util.getQueryStringArray();
	      if (queryString['addToWishlistSuccessMessageKey']) {
	        COSTCO.dialog.createExtDialogBox({
	          title: messages.RWD_WISH_LIST_CONFIRM_TITLE,
	          body: messages.WISHLIST_ITEM_ADD_CONFIRMATION_MESSAGE,
	          primary: messages.RWD_VIEW_WISH_LIST,
	          primary_event: function primary_event() {
	            window.location = '/NonAjaxAccountWishListDisplayView?listId=.';
	          },
	          secondary: messages.CONTINUE_SHOPPING
	        });
	      }
	    },
	    /**
	     * Select options modal for GE. Invoked after the "done" promise resolves
	     * @param data = Parts and Services JSON
	     * @return {[void]}
	     */
	    show_options_modal: function show_options_modal(data) {
	      var locale = COSTCO.util.getLocale();
	      var selected_product = undefined;
	      if (this.isSingleItem(products)) selected_product = this.findItem(products[0], []);else selected_product = this.getSelectedBundleAndVariantItems()[0];
	
	      selected_product.quantity = messages.RWD_QUANTITY + ' ' + $('input[name=quantity]').val();
	      selected_product.item_number = $('span.item-number').text();
	      selected_product.final_price = (locale == 'en-US' || locale == 'en-CA' ? ' $' : '') + $('.your-price .value').text() + (locale == 'fr-CA' ? ' $' : '');
	
	      this.related_products_member_pricing();
	      $('.modal-footer').addClass('hide');
	      var items_html = "",
	          $related_products_template = $('#product-page .related-products');
	      $('#product-page .related-products').remove();
	
	      //call function to create parts and services form
	      var options_htmls = COSTCO.ScheduledDeliverable.create_parts_and_services_list(data);
	
	      partsservices_html = options_htmls['partsservices_html'];
	      remark_html = options_htmls['remark_html'];
	
	      items_html += COSTCO.util.tmpl('tmpl_selected_delivery_Item', {
	        img_url: selected_product.img_url ? selected_product.img_url : selected_product.parent_img_url,
	        item_name: selected_product.productName,
	        item_url: selected_product.productUrl,
	        item_number: selected_product.item_number,
	        price: selected_product.final_price,
	        quantity: selected_product.quantity,
	        partsservices: partsservices_html,
	        remarksContainer: remark_html,
	        model_number: null
	      });
	
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.SCHED_DELIV_SELECT_OPTIONS_HEADING,
	        body: COSTCO.util.tmpl('tmpl_select_options_modal', {
	          items: items_html,
	          related_products: $related_products_template.length > 0 ? $related_products_template[0].outerHTML : ''
	        }),
	        onclose: function onclose() {
	          $('.modal-footer').removeClass('hide');
	          if ($related_products_template.length > 0) {
	            $('#product-page').append($related_products_template[0].outerHTML);
	          }
	        }
	      });
	      $('.modal-body .related-products').removeClass('hide');
	    },
	    /**
	     * this function is to prevent rich media from injecting swatches
	     * onto our page when product has no buyable items or is out of stock.
	     * We don't include theSwatches div in these cases on the jsp so we add
	     * it here.
	     */
	    injectHiddenSwatchesDiv: function injectHiddenSwatchesDiv() {
	      if ($('#theSwatches').length == 0) {
	        $('<div id="theSwatches" class="hide"></div>').appendTo('#zoomViewer');
	      }
	    },
	    /**
	     * Function used to check if any modifications have been appended
	     * to the product details accordion
	     */
	
	    startMutationObserver: function startMutationObserver() {
	      //STRY0141473 - fire showViewMore() anyway if none of the mutations occur
	      COSTCO.Product.showViewMore(observerObject);
	
	      var targetObject = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? $('#product-info')[0] : $('#accordion-product-details')[0];
	      try {
	        if (!$('#CostcoBVContainer').length > 0) {
	          var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              if ("attributes" === mutation.type) {
	                COSTCO.Product.showViewMore(observerObject);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          observerObject.observe(targetObject, {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	            characterData: true
	          });
	
	          //INC3616033 add a seperate mutationObserver for product-info-description
	          var prodInfoObserverObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              if ("attributes" === mutation.type || "childList" === mutation.type) {
	                COSTCO.Product.showViewMore(prodInfoObserverObject);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          prodInfoObserverObject.observe($('.product-info-description')[0], {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	            characterData: true
	          });
	        } else {
	          // Observe Reviews section on PDP
	          var observerObjectReview = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              if ("childList" === mutation.type && ($(mutation.target).find('#bv_review_maincontainer').length > 0 || $(mutation.target).find('.bv-content-list-container').length > 0)) {
	                COSTCO.Product.showViewMore(observerObjectReview);
	
	                if (isBVv2Enabled === 'false') {
	                  // Auto popup BV Write a Review for relogin user
	                  // bveventid is appended to logonform by BV when not logged in user tries WAR
	                  var bveventid = COSTCO.util.getParameterByName('bveventid');
	                  var summaryWAR = $('#WAR');
	                  if (bveventid !== null && summaryWAR.length > 0) {
	                    summaryWAR.trigger('click');
	                  }
	                }
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          observerObjectReview.observe(targetObject, {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	            characterData: true
	          });
	
	          //INC3616033 add a seperate mutationObserver for product-info-description
	          var prodInfoObserverObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              if ("attributes" === mutation.type || "childList" === mutation.type) {
	                COSTCO.Product.showViewMore(prodInfoObserverObject);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          prodInfoObserverObject.observe($('.product-info-description')[0], {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	            characterData: true
	          });
	        }
	        //If < IE 10 then display the product details in its entirety
	      } catch (e) {
	        COSTCO.Product.view_more(this);
	        return;
	      }
	    },
	
	    /**
	     * Function used to show the View More Details button
	     * depend on the the height of the product info content.
	     */
	    showViewMore: function showViewMore(observer) {
	      var integrationContentIds = ['#wc-power-page', '#wc-pp', '#SP_ProductImage', '#wc-button', '#easy2-demo', '#ccslogos', '#inline_showcase', '#flix-minisite', '#flix-inpage'];
	      var doesnIntegrationIdExists = false;
	      for (var i = 0; i < integrationContentIds.length; i++) {
	        if ($(integrationContentIds[i]).length > 0) {
	          doesnIntegrationIdExists = true;
	          break;
	        }
	      }
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        $('.product-info-description').each(function (index) {
	          var height = $(this).prop('scrollHeight');
	          var productType = $('#product-info').data('product');
	          var screenSize = screen.width;
	
	          //for BD specific, we do want to show the product info in its entirety for tobacco product
	          if ((height > 600 || index == 0 && doesnIntegrationIdExists) && productType !== 'tobacco') {
	            $(this).next().removeClass("hide");
	            if (observer) {
	              observer.disconnect();
	            }
	          }
	        });
	      } else {
	        var height = $('.product-info-description').prop('scrollHeight');
	        var productType = $('#product-info').data('product');
	        var screenSize = screen.width;
	        //need to take into account the height of the product manual
	        var $productManual = $('.product-info-description').find('.product-manuals');
	        //if item has product manual and it is view on screen larger than 768
	        //product manual should be taken into account because it would be hidden
	        if ($productManual.length && screenSize > 768) {
	          var productManualHeight = $productManual.prop('scrollHeight');
	          //if product manual is hidden in case of large display, do not count its height
	          height = height - productManualHeight;
	        }
	
	        //for BD specific, we do want to show the product info in its entirety for tobacco product
	        if ((height > 600 || doesnIntegrationIdExists) && productType !== 'tobacco') {
	          $('.view-more').removeClass("hide");
	          if (observer) {
	            observer.disconnect();
	          }
	        } else {
	          if (!$('.view-more').hasClass('hide')) {
	            $('.view-more').addClass('hide');
	          }
	        }
	      }
	    },
	    getPartsAndServices: function getPartsAndServices(data) {
	      var configuredInfoArray = [];
	      var showablePartsAndServices = [];
	
	      if (data && data.length > 0) {
	        configuredInfoArray = JSON.parse(data);
	
	        //determine which GE dishwasher parts are not to be displayed
	        if (configuredInfoArray.services.length > 0) {
	          $.each(configuredInfoArray.services, function (index, value) {
	            if (!(value.groupId == 1 && value.serviceType.toUpperCase() == 'PART' && value.dependent_service_ids.length > 0) && !(value.groupId == 1 && value.serviceType.toUpperCase() == 'PART' && value.selected == false)) {
	              showablePartsAndServices.push(value);
	            }
	          });
	          if (showablePartsAndServices.length > 0) {
	            configuredInfoArray.services = showablePartsAndServices.slice(0);
	          }
	          data = JSON.stringify(configuredInfoArray);
	        }
	      }
	
	      return data;
	    },
	
	    showReplacementProductModal: function showReplacementProductModal(partNumber) {
	      var $relatedProducts = partNumber ? $('#RelatedProducts_' + partNumber) : $('.related-products');
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.TEMP_REPLACED_ITEM_MODAL_TITLE,
	        dialogclasses: 'medium',
	        onshow: function onshow() {
	          if (window.checkoutPage) {
	            $('#costcoModal .close').hide();
	          }
	        },
	        preventClose: window.checkoutPage ? true : false,
	        body: COSTCO.util.tmpl('tmpl_related_products', {
	          related_products: $relatedProducts.html()
	        })
	      });
	    },
	    /**
	     * Triggers click event, binded to social images, by pressing Enter key
	     * @return {[void]}
	     */
	    makeSocialIconsAdaCompliant: function makeSocialIconsAdaCompliant() {
	      $(".social.list-inline.social-icons img").each(function () {
	        $(this).on('keydown', function (event) {
	          if (event.which === 13) {
	            $(this).click();
	          }
	        });
	      });
	    },
	
	    showSuccessMessage: function showSuccessMessage(message) {
	      var messsages_html = '';
	      messsages_html += COSTCO.util.tmpl('tmpl_succes_notification', { message: message });
	      $('#message-area').html(messsages_html);
	    },
	    /**
	     * Changes the quantity displayed in input element on plus/minus click
	     * @param element element user clicked on (plus or minus button)
	     * @return void
	     */
	    changeQuantityValue: function changeQuantityValue(element) {
	      var $inputElement = $('[name=quantity]');
	      var qtyValue = parseInt($inputElement.val());
	      if (!qtyValue && qtyValue != 0) {
	        qtyValue = 0;
	      } else {
	        var quantityStep = COSTCO.Product.getQuantityStep($inputElement);
	        var isIncrement = undefined;
	        if ($(element).attr('name') === 'plusQty') {
	          isIncrement = true;
	          var maxQnty = COSTCO.Product.maxQuantity();
	          qtyValue += quantityStep;
	          var residual = qtyValue % quantityStep;
	          qtyValue = qtyValue - residual;
	        } else if ($(element).attr('name') === 'minusQty') {
	          isIncrement = false;
	          var _residual = qtyValue % quantityStep;
	          if (_residual == 0) {
	            qtyValue -= quantityStep;
	          } else {
	            qtyValue -= _residual;
	          }
	        } else if (qtyValue == 0) {
	          isIncrement = false;
	        }
	
	        $inputElement.val(qtyValue);
	
	        COSTCO.Product.validateQuantityValue($inputElement, '.product-error', 'span');
	        COSTCO.Product.expendErrorOnQtyUnit($inputElement, 'span');
	        COSTCO.Product.discardInvalidQtyValues(qtyValue, $inputElement, isIncrement);
	      }
	      COSTCO.util.announceSRMessage("Quantity " + qtyValue);
	    },
	    ChangeQuantityField: function ChangeQuantityField(element) {
	      var $inputElement = $('[name=quantity]');
	      var qtyValue = parseInt($inputElement.val());
	      COSTCO.Product.validateQuantityValue($inputElement, '.product-error', 'span');
	      if (qtyValue == 0) {
	        $inputElement.val(1);
	      }
	      COSTCO.util.announceSRMessage("Quantity " + qtyValue);
	    },
	    /** /reset error class if it is applyed/reseted on quanty value itself
	     * @param quantityId quantity value element reference
	     * @param nextElement element behind input
	     */
	    expendErrorOnQtyUnit: function expendErrorOnQtyUnit(quantityId, nextElement) {
	      if (COSTCO.util.isPDPCartCheckoutEnabled()) {
	        var inputError = COSTCO.Product.getErrorArea(quantityId, nextElement);
	        if (inputError !== quantityId) {
	          var inputParent = quantityId.parent();
	          var hasError = quantityId.hasClass('error');
	          if (hasError) {
	            inputParent.addClass('error');
	          } else {
	            inputParent.removeClass('error');
	          }
	        }
	      }
	    },
	    /**
	    * Get quantity step (which is also treated as minimal quantity value as well) plust (optional) unit of measure
	    * @param quantityId quantity value element reference
	    * @param unitOfMeasure unit of measure
	    * @return quantity step (min quantity value)
	    */
	    getQuantityStep: function getQuantityStep(quantityId, unitOfMeasure) {
	      var stepIncrement = quantityId.attr('data-quantity-increment') ? parseInt(quantityId.attr('data-quantity-increment')) : 1;
	      if (typeof unitOfMeasure === "undefined") {
	        return stepIncrement;
	      } else return stepIncrement + " " + unitOfMeasure;
	    },
	    /**
	     * Discard invalid quantity values
	     * @param value current value in quantity input element
	     * @param quantityId quantity input element reference
	     * @param isIncrement undefined value means value is entered not incremented/decremented
	     * @return void
	     */
	    discardInvalidQtyValues: function discardInvalidQtyValues(value, quantityId, isIncrement) {
	      var quantityStep = COSTCO.Product.getQuantityStep(quantityId);
	      if (isIncrement != undefined && value <= 0) {
	        quantityId.val(quantityStep);
	      }
	      var max = COSTCO.Product.maxQuantity();
	      if (value > max) {
	        var remainder = max % quantityStep;
	        quantityId.val(max - remainder);
	      }
	    },
	
	    /**
	     * Test validity of quantity value and applay result.
	     * @param quantityId quantity input element reference
	     * @param errorSelector elements, classes and IDs
	     * @param nextElement if next element is label or span (they contain unit of measure) then error area is bigger then just input field
	     * @return void
	     */
	    validateQuantityValue: function validateQuantityValue(quantityId, errorSelector, nextElement) {
	      if (COSTCO.util.isPDPCartCheckoutEnabled()) {
	        var quantity_obj = COSTCO.Product.is_valid_quantity(COSTCO.Product.item_type, quantityId);
	        var $product_error = $(errorSelector);
	        var inputError = COSTCO.Product.getErrorArea(quantityId, nextElement);
	        // Check if we have a valid quantity
	        if (!quantity_obj.valid) {
	          $product_error.html(quantity_obj.message);
	          inputError.addClass('error');
	          if (quantityId !== inputError) {
	            quantityId.addClass('error');
	          }
	        } else {
	          $product_error.empty();
	          inputError.removeClass('error');
	          if (quantityId !== inputError) {
	            quantityId.removeClass('error');
	          }
	        }
	      }
	    },
	    /**
	     * Find HTML element on which error class should be applyed.
	     * @param quantityId quantity input element reference
	     * @param qtyUnitElement possible next element with quantity unit
	     * @return void
	     */
	    getErrorArea: function getErrorArea(quantityId, qtyUnitElement) {
	      var errObj = quantityId;
	      if (COSTCO.util.isPDPCartCheckoutEnabled() && qtyUnitElement) {
	        var nextElement = quantityId.next();
	        if (nextElement.is(qtyUnitElement)) {
	          errObj = quantityId.parent();
	        }
	      }
	      return errObj;
	    },
	    /**
	        * Shows the sticky element on tablet/desktop view and makes sticky element for mobile view for BC and BD
	        * @return void
	        */
	    pdpMakeElementSticky: function pdpMakeElementSticky() {
	      var userInfo = COSTCO.util.getMemberCookie();
	      var signedIn = userInfo.signedIn;
	      var costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false;
	      var validated = userInfo.validated;
	      var verified = userInfo.verified;
	      var memberActive = userInfo.active;
	      var $qtyInput = $('#qty-input');
	      var isBundle = COSTCO.Product.item_type == 'bundle';
	      var isTwoDayDeliveryZipIn = ($('.two-day-delivery').length > 0 || $('.frozen-foods-badge').length > 0) && COSTCO.Header.hasInvPostalCodeCookie();
	      var $addButtonContainer = $('input[name="isOOSItem"]').length > 0 ? $('.notify-me-btn-area') : $('#ctas ul'); //notify-me-btn-area
	      var $isAppliance = $('#productCategory').val() === messages.APPLIANCES && ($('#submit-delivery-area').length > 0 || $('#edd-check-button').length > 0);
	      var $addButtonGroup = void 0;
	
	      if ($isAppliance || COSTCO.CMath.iskitsbundle) {
	        if ($('#edd-check-button').is(':visible') && !COSTCO.CMath.iskitsbundle) {
	          $addButtonGroup = $('#check-availability-sticky');
	          $('#sticky-price').hide();
	          $('#sticky-qty').hide();
	        } else if ($('#add-to-cart').is(':visible')) {
	          $addButtonGroup = $('#add-to-cart');
	          $('#sticky-price').show();
	          $('#sticky-qty').show();
	        } else if (COSTCO.CMath.iskitsbundle && $('#bundle-button').is(':visible')) {
	          $('#sticky-price').show();
	          $('#sticky-qty').hide();
	          $('#bundle-button-container').append($('#bundle-button'));
	          $addButtonGroup = $('#bundle-button-container');
	        } else if ($('#renew-membership-for-price').is(':visible')) {
	          $addButtonGroup = $('#renew-membership-for-price');
	          $('#sticky-price').hide();
	          $('#sticky-qty').hide();
	        } else {
	          if (!signedIn) {
	            if ($('#mapItem').val() == "true") {
	              $addButtonGroup = $('#sign-in-to-buy');
	            } else {
	              $addButtonGroup = $('#sign-in-to-buy-button-v2');
	            }
	          } else {
	            if (!costcoMember) {
	              $addButtonGroup = $('#link-membership-for-price');
	            }
	          }
	        }
	      } else if ($('input[name="isOOSItem"]').length > 0) {
	        $addButtonGroup = $addButtonContainer.find('input');
	      } else {
	        $addButtonGroup = $addButtonContainer.children().not('#qty-input');
	      }
	      var $detailsBazaarVoice = $('#details-bazaar-voice');
	      var $price = $('#pull-right-price');
	      var $clonedPrice = $price.clone();
	      var $hiddenSticky = $('#hidden-sticky');
	      var $stickyAddBtn = $('#sticky-add-btn');
	      var isHidden = true;
	      var isSticky = false;
	      var topOfBottomContent = void 0;
	      var topOfWindow = void 0;
	      var bottomOfWindow = void 0;
	      $('#pdp-sticky-desktop .tablist').hide();
	
	      var showStickyElementForDesktopAndTablet = function showStickyElementForDesktopAndTablet() {
	        if (topOfWindow < topOfBottomContent && isHidden == false) {
	          if (isBundle) {
	            if ($('#addBundleBtn').attr('disabled')) {
	              $('#sticky-price').empty();
	              $('#bundle-button-container').append($('#bundle-button'));
	            } else {
	              $('#sticky-price').empty();
	              $('#bundle-items-container').append($('#addBundleBtn'));
	            }
	          } else {
	            $addButtonContainer.prepend($addButtonGroup);
	            $addButtonContainer.prepend($qtyInput);
	            $addButtonContainer.prepend($('#sticky-add-btn li'));
	            //2 day delivery not zipped in
	            $('#postal-popup-form-inline').append($('#postal-code-submit-btn'));
	          }
	          if (isBDApplication && isBDApplication === 'BD') {
	            $('#delivery-zipcode-form .get-zip-code-form').append($('#formProductDetails'));
	            $('#formProductDetails .outline').removeClass('hide');
	            $('#formProductDetails').validate();
	          }
	          $('#sticky-qty #minQtyText').off();
	          $('#bazaar-container').append($detailsBazaarVoice);
	          $('.math-table .your-price').append($price);
	          $('#check-availability-sticky').hide();
	          $hiddenSticky.hide(500);
	          isHidden = true;
	          $('#pdp-sticky-desktop .tablist').hide();
	        } else if (topOfWindow >= topOfBottomContent + 10 && isHidden == true) {
	
	          var selected_product = undefined;
	          if (COSTCO.Product.isSingleItem(products)) selected_product = COSTCO.Product.findItem(products[0], []);else selected_product = COSTCO.Product.getSelectedBundleAndVariantItems()[0];
	
	          var stickyImageUrl = typeof selected_product === 'undefined' ? products[0][0].img_url ? products[0][0].img_url : products[0][0].parent_img_url : selected_product.img_url ? selected_product.img_url : selected_product.parent_img_url;
	          $('#initialProductImageSticky').attr('src', stickyImageUrl);
	
	          $('#sticky-qty').append($qtyInput);
	          if (isBundle) {
	            $stickyAddBtn.append($('#addBundleBtn').attr('disabled') ? $('#bundle-button') : $('#addBundleBtn'));
	          } else {
	            // If item is OOS, set variables again beacause of updated content after Ajax call
	            if ($('input[name="isOOSItem"]').length > 0) {
	              $addButtonContainer = $('input[name="isOOSItem"]').length > 0 ? $('.notify-me-btn-area') : $('#ctas ul');
	              $addButtonGroup = $isAppliance ? $('#check-availability-sticky') : $('input[name="isOOSItem"]').length > 0 ? $addButtonContainer.find('input') : $addButtonContainer.children().not('#qty-input');
	            }
	            $('#check-availability-sticky').show();
	            $stickyAddBtn.append($addButtonGroup);
	            $stickyAddBtn.append($('#ctas ul li'));
	            //2 day delivery not zipped in
	            if (!isTwoDayDeliveryZipIn || $('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) {
	              $stickyAddBtn.on('click', function (event) {
	                event.preventDefault();
	                $(window).scrollTop(0);
	              });
	            }
	          }
	          if (isBDApplication && isBDApplication === 'BD' && !$('#bdZipCookie').val().length > 0) {
	            $stickyAddBtn.append($('#formProductDetails'));
	            $('#formProductDetails .outline').addClass('hide');
	            $stickyAddBtn.on('click', function (event) {
	              event.preventDefault();
	              $(window).scrollTop(0);
	              $('#formProductDetails').validate();
	              $('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').rules('add', {
	                required: true,
	                'countryspecificpostalcode': true,
	                messages: {
	                  required: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER,
	                  countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER
	                }
	              });
	            });
	          }
	          $('#sticky-qty #minQtyText').on('keypress', function (event) {
	            COSTCO.Product.ChangeQuantityField($('#sticky-qty #minQtyText'));
	            if (event.keyCode === 13) {
	              console.log('test event');
	              $('#add-to-cart-btn').click();
	            }
	          });
	          $('#sticky-bazaar').append($detailsBazaarVoice);
	          if (isBundle) {
	            $clonedPrice = $price.clone();
	            $('#sticky-price').append($clonedPrice);
	            var $isChecked = $('[id^="checkbox-bundle-"]').is(':checked');
	            $isChecked ? $('#sticky-price').show() : $('#sticky-price').hide();
	            $isChecked ? $('.product-numbers').show() : $('.product-numbers').hide();
	          } else if (isTwoDayDeliveryZipIn && !(($('.two-day-delivery').length > 0 || $('.frozen-foods-badge').length > 0) && $price.text().includes("- -.- -")) || $('.two-day-delivery').length === 0 && $('.frozen-foods-badge').length === 0 && $price.is(':visible')) {
	            $('#sticky-price').append($price);
	            $('.product-numbers').hide();
	          } else {
	            $('.product-numbers').show();
	          }
	          $hiddenSticky.show(500);
	          $hiddenSticky.css('display', 'flex');
	          isHidden = false;
	          $('#pdp-sticky-desktop .tablist').show();
	        }
	        $('#sticky').css('width', $('#product_tabs').width());
	      };
	
	      var makeElementStickyForMobile = function makeElementStickyForMobile() {
	        var $isChecked = $('[id^="checkbox-bundle-"]').is(':checked');
	        var $stickyContent = $isChecked ? $('#bundle-items-container') : $('#build-bundle-sticky');
	        var $addButtonContainer = isBundle ? $stickyContent : $('input[name="isOOSItem"]').length > 0 ? $('.notify-me-btn-area') : $('#ctas ul');
	        var $isWarningMsg = $("#prod-page-delivery").length > 0 && !$("#prod-page-delivery").hasClass('hide') || $("#edd-form-block").length > 0 && !$("#edd-form-block").hasClass('hide') || $("#edd-message-block .warning").length > $("#edd-message-block .warning.hide").length || $("#deliveryFailMessage").length > 0 && !$("#deliveryFailMessage").hasClass('hide');
	        var $appContent = $isWarningMsg ? $('#check-availability-sticky') : $('input[name="isOOSItem"]').length > 0 ? $addButtonContainer.find('input') : $addButtonContainer;
	        if ($('#ctas').val() !== undefined) {
	          var $buildABundle = $('#build-a-bundle');
	          var bottomOfElement = void 0;
	          if ($('#mobile-bazaar').length > 0 && $('#mobile-bazaar').html().trim() == '') {
	            $('#mobile-bazaar').append($detailsBazaarVoice);
	          }
	          if ($('input[name="isOOSItem"]').length > 0) {
	            bottomOfElement = isBundle ? $buildABundle.offset().top + $buildABundle.outerHeight() : $('.notify-me-body').offset().top + $('.notify-me-body').outerHeight();
	          } else {
	            bottomOfElement = isBundle ? $buildABundle.offset().top + $buildABundle.outerHeight() : $('#ctas').offset().top + $('#ctas').outerHeight();
	          }
	          if (topOfWindow < bottomOfElement && isSticky == true) {
	            $('#build-bundle-sticky').attr("hidden", true);
	            $('#check-availability-sticky').attr("hidden", true);
	            $addButtonContainer = isBundle ? $stickyContent : $('input[name="isOOSItem"]').length > 0 ? $('#pdp-sticky-mobile') : $('#pdp-sticky-mobile ul');
	            $appContent = $isWarningMsg ? $('#check-availability-sticky') : $('input[name="isOOSItem"]').length > 0 ? $addButtonContainer.find('input') : $addButtonContainer;
	            $appContent.children('#product-social-print-mobile').length > 0 && $appContent.children('#product-social-print-mobile').removeClass('hide');
	            if (isBundle) {
	              $('#bundle-container').prepend($appContent);
	              $('#bundle-accordion-collapse').removeClass('collapse');
	              $('#bundle-accordion-collapse').css('height', '');
	            } else {
	              if ($('input[name="isOOSItem"]').length > 0) {
	                $('.notify-me-btn-area').prepend($appContent);
	              } else {
	                $('#ctas').prepend($appContent);
	              }
	            }
	            //2 day delivery not zipped in
	            if (!isTwoDayDeliveryZipIn || $('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) {
	              $('#postal-popup-form-inline').append($('#postal-code-submit-btn'));
	            }
	            isSticky = false;
	            $('#chatInlay').removeClass('mobile-inlay-sticker-shown');
	          } else if (topOfWindow >= bottomOfElement && isSticky == false) {
	            $('#build-bundle-sticky').removeAttr('hidden');
	            $('#check-availability-sticky').removeAttr('hidden');
	            $appContent.children('#product-social-print-mobile').length > 0 && $appContent.children('#product-social-print-mobile').addClass('hide');
	            $('#pdp-sticky-mobile').append($appContent);
	            $('#footer-bottom').addClass('sticky-pdp-footer');
	            if (!isTwoDayDeliveryZipIn || $('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) {
	              $('#pdp-sticky-mobile').append($('#postal-code-submit-btn'));
	              $('#pdp-sticky-mobile').on('click', function (event) {
	                event.preventDefault();
	                $(window).scrollTop($('.product-interaction').offset().top - 1.2 * $('.product-interaction').outerHeight());
	              });
	            }
	            var interectionElement = $('#pdp-sticky-mobile ul li:visible').length > 0 ? $('#pdp-sticky-mobile ul li:visible') : $('#pdp-sticky-mobile ul div:visible').not('.error');
	            if ($('#ctas').hasClass('hide') || interectionElement.length === 0 && !isBundle && !$isAppliance && isTwoDayDeliveryZipIn && !($('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) && !$isWarningMsg) {
	              $('#pdp-sticky-mobile').hide();
	            }
	            if (isBundle) {
	              $('#bundle-accordion-collapse').addClass('collapse');
	            }
	            isSticky = true;
	            $('#chatInlay').addClass('mobile-inlay-sticker-shown');
	          }
	        }
	      };
	
	      var makeElementStickyForMobileBD = function makeElementStickyForMobileBD() {
	        var $stickyElement = $('#pdp-sticky-mobile');
	        var bottomOfElement = $('.product-interaction').offset().top + $('.product-interaction').outerHeight();
	        if (topOfWindow < bottomOfElement) {
	          $('#zipFormatterFlag').after($('#formProductDetails'));
	          $('#formProductDetails .outline').removeClass('hide');
	          $('#formProductDetails').validate();
	        } else if (topOfWindow >= bottomOfElement) {
	          //check out if sticky element should be displayed
	          $stickyElement.append($('#formProductDetails'));
	          $('#footer-bottom').addClass('sticky-pdp-footer');
	          $('#formProductDetails .outline').addClass('hide');
	          $stickyElement.on('click', function (event) {
	            event.preventDefault();
	            $(window).scrollTop(0);
	            //generate validation on input field of zip code
	            $('#formProductDetails').validate();
	            $('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').rules('add', {
	              required: true,
	              'countryspecificpostalcode': true,
	              messages: {
	                required: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER,
	                countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER
	              }
	            });
	          });
	        }
	      };
	      window.addEventListener('load', function (event) {
	        $(window).scroll(function (event) {
	          if ($('#productPage').val() && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            if (isBundle) {
	              topOfBottomContent = $('#addBundleBtn').attr('disabled') ? $('.bottom-content').offset().top : $('#bundle-container').offset().top + $('#bundle-container').outerHeight(true);
	            } else if ($('#displaybundle').length > 0) {
	              topOfBottomContent = $('.bottom-content').offset().top + $('#displaybundle').outerHeight();
	            } else {
	              topOfBottomContent = $('.bottom-content').offset().top;
	            }
	            topOfWindow = $(window).scrollTop();
	            bottomOfWindow = topOfWindow + $(window).height();
	
	            //checks if page is in MOBILE or TABLET/DESKTOP display view, and calls the appropriate function
	            if (window.innerWidth > 768) {
	              showStickyElementForDesktopAndTablet();
	            } else if (isBDApplication === 'BD') {
	              if ($('#bdZipCookie').val().length > 0) {
	                makeElementStickyForMobile();
	              } else {
	                makeElementStickyForMobileBD();
	              }
	            } else {
	              window.onbeforeunload = function () {
	                window.scrollTo(0);
	              };
	              makeElementStickyForMobile();
	            }
	          }
	        });
	        var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
	        if ((COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant') && !scheduledDeliverable && $('#isBDAppVar').val() != 'BD' && !COSTCO.CMath.pdpPageloadComplete && isPDPVariantGreyOutEnabled == 'true' && !(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag)) {
	          if (COSTCO.CMath.isErrorlocationControlleditem) {
	            if ($('div.buyinstoreonly.MuiBox-root').length > 0) {
	              COSTCO.CMath.isWarehouseEnabled = true;
	            } else {
	              COSTCO.CMath.isWarehouseEnabled = false;
	            }
	          }
	          if (!COSTCO.CMath.iskitsbundle) {
	            COSTCO.Product.findOOSitem(true);
	          }
	        } else {
	          if ($('#isBDAppVar').val() != 'BD' && (isPDPVariantGreyOutEnabled == 'false' || Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag || scheduledDeliverable) && !COSTCO.CMath.pdpPageloadComplete && (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant')) {
	            COSTCO.CMath.pdpPageloadComplete = true;
	          }
	        }
	        if (COSTCO.CMath.iskitsbundle) {
	          var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
	          COSTCO.CMath.onloadSelectOption = optionsSelected;
	          for (var i = 0; i <= optionsSelected.length; i++) {
	            $('#swatchesID-productOption0' + i + ' span.selection-item').each(function () {
	              var selectedTile = $(this).attr("automation-id");
	              var tileId = selectedTile.split('_')[1];
	            });
	          }
	          COSTCO.CMath.setKbLabel();
	          $('#theSwatches').remove();
	
	          if (COSTCO.Product.item_type === 'single_variant' || COSTCO.Product.item_type === 'multi_variant') {
	            COSTCO.CMath.hideKBSkeletone();
	          }
	        }
	        var currentUrl = window.location.href;
	        var swatchParam = window.location.href.split('?')[1];
	        if (COSTCO.CMath.iskitsbundle && swatchParam == 'isSwatchReload') {
	          COSTCO.Product.focusToNavPdpTabHeader15();
	        }
	        COSTCO.CMath.kbPageloadComplete = true;
	        if (window.innerWidth > 768) {
	          if ($('#bazaar-container').length > 0 && $('#bazaar-container').html().trim() == '') {
	            $('#bazaar-container').append($detailsBazaarVoice);
	          }
	        } else {
	          if ($('#mobile-bazaar').length > 0 && $('#mobile-bazaar').html().trim() == '') {
	            $('#mobile-bazaar').append($detailsBazaarVoice);
	          }
	        }
	      });
	
	      $(window).resize(function () {
	        if (!$("input").is(":focus")) {
	          if ($('#productPage').val() && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            if (isBundle) {
	              topOfBottomContent = $('#addBundleBtn').attr('disabled') ? $('.bottom-content').offset().top : $('#bundle-container').offset().top + $('#bundle-container').outerHeight(true);
	            } else if ($('#displaybundle').length > 0) {
	              topOfBottomContent = $('.bottom-content').offset().top + $('#displaybundle').outerHeight();
	            } else {
	              topOfBottomContent = $('.bottom-content').offset().top;
	            }
	            topOfWindow = $(window).scrollTop();
	            bottomOfWindow = topOfWindow + $(window).height();
	
	            //checks if page is in MOBILE or TABLET/DESKTOP display view, and modifies sticky element accordingly
	            if (window.innerWidth > 768 && isBDApplication === 'BC') {
	              if ($('#pdp-sticky-mobile ul').length > 0 || $('#bundle-container').hasClass('fixed-footer-bundle')) {
	                $addButtonContainer = isBundle ? $('#bundle-items-container') : $('#pdp-sticky-mobile ul');
	                isBundle ? $('#bundle-container').prepend($addButtonContainer) : $('#ctas').prepend($addButtonContainer);
	                if (isBundle) {
	                  $('#bundle-accordion-collapse').removeClass('collapse');
	                  $('#bundle-accordion-collapse').css('height', '');
	                }
	                isSticky = false;
	                showStickyElementForDesktopAndTablet();
	              }
	              if ($('#bazaar-container').length > 0 && $('#bazaar-container').html().trim() == '') {
	                $('#bazaar-container').append($detailsBazaarVoice);
	              }
	            } else {
	              if (isBundle) {
	                $('#bundle-button-container').append($('#addBundleBtn').attr('disabled') ? $('#bundle-button') : $('#addBundleBtn'));
	              } else {
	                if (!($('input[name="isOOSItem"]').length > 0)) {
	                  $addButtonContainer.prepend($addButtonGroup);
	                  $addButtonContainer.prepend($qtyInput);
	                  $addButtonContainer.prepend($('#sticky-add-btn li'));
	                }
	              }
	              $('.math-table .your-price').append($price);
	              $('#product-body-model-number').after($detailsBazaarVoice);
	              $hiddenSticky.hide();
	              isHidden = true;
	              if (isBDApplication && isBDApplication === 'BD') {
	                makeElementStickyForMobileBD();
	              } else {
	                makeElementStickyForMobile();
	              }
	            }
	          }
	        }
	      });
	
	      $(document).on("click", '.tablist a', function () {
	        var clickedTab = $(this);
	        var clickedTabHref = $(this).attr('href');
	        $('.tablist li').removeClass("active");
	        $('.tablist li a').removeClass("active");
	        $('.tablist li a').attr("aria-current", "false");
	        $('.tablist a[href=' + clickedTabHref + ']').addClass("active");
	        $('.tablist a[href=' + clickedTabHref + ']').parent().addClass("active");
	        $('.tablist a[href=' + clickedTabHref + ']').attr("aria-current", "true");
	      });
	
	      $(document).on('keydown', '.tablist a', function (e) {
	        if (e.which === 13) {
	          var clickedTabHref = $(this).attr('href');
	          this.click();
	          $('div' + clickedTabHref + ' h3').attr('tabindex', '0');
	          $('div' + clickedTabHref + ' h3').focus().on('focusout', function () {
	            $(this).attr('tabindex', '-1');
	          });
	        }
	      });
	    },
	
	    invokeInventoryBatchAPIcallforSingleitem: function invokeInventoryBatchAPIcallforSingleitem(itemId) {
	      var isBopiw = $('#isBOPIWItemForMemberInfo').val();
	      var selectedWarehouse = "";
	      if (isEnableBOPIWUpdatesSync == 'true' && isBopiw == 'true') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isBopiwEnabled && !COSTCO.CMath.isWioEnabled && isBopiw == 'true') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isWioEnabled && !COSTCO.CMath.isBopiwEnabled && isBopiw == 'false') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isWioEnabled && COSTCO.CMath.isBopiwEnabled) {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      }
	      var _data = {
	        "distributionCenters": [""],
	        "selectedWarehouse": selectedWarehouse,
	        "itemNumbers": [itemId]
	      };
	      var clientIdentifier = $('#besBatchCLientIdentifier').val();
	      var batchApiURL = $('#baseUriForInventoryBatch').val();
	      var costcoEnv = $('#costcoEnvironmentForBatchInv').val(); //COSTCO.Product.validateCostcoEnv();
	      var costcoEnvECOMEnabled = $('#batchApiCostcoEnvECOMEnabled').val();
	      if (typeof costcoEnvECOMEnabled !== "undefined" && costcoEnvECOMEnabled === "true") {
	        if (costcoEnv === "" || costcoEnv === null || costcoEnv === 'null') {
	          costcoEnv = "ECOM";
	        }
	      }
	      var costcoService = "restInventory";
	
	      var inventoryBatchAkamaiCacheEnabled = $('#inventoryBatchAkamaiCacheEnabled').val();
	      var inventoryBatchEnabledV2 = $('#inventoryBatchEnabledV2').val();
	      var akamaiHeaders = {};
	      akamaiHeaders["Content-type"] = "application/json; charset=UTF-8";
	      akamaiHeaders["costco.env"] = costcoEnv;
	      akamaiHeaders["client-identifier"] = clientIdentifier;
	      akamaiHeaders["costco.service"] = costcoService;
	
	      if (inventoryBatchAkamaiCacheEnabled === "true") {
	        var batchVariantCacheKey = itemId + "-" + COSTCO.Product.getZipcode() + "-" + selectedWarehouse;;
	        akamaiHeaders["batch-variant-cache-key"] = batchVariantCacheKey;
	      }
	      var batchApiURL;
	      if (inventoryBatchEnabledV2 === "true") {
	        batchApiURL = $('#baseUriForInventoryBatchV2').val();
	      } else {
	        batchApiURL = $('#baseUriForInventoryBatch').val();
	      }
	
	      fetch(batchApiURL, {
	        method: "POST",
	        body: JSON.stringify(_data),
	        headers: akamaiHeaders
	      }).then(function (response) {
	        if (response.status >= 200 && response.status <= 299) {
	          return response.json();
	        } else {
	          throw Error(response.statusText);
	        }
	      }).then(function (jsonResponse) {
	        var programType = jsonResponse[0].programTypes;
	        var inwarehousepgType;
	        if (programType != null && programType.hasOwnProperty("inWarehouse") && Array.isArray(programType.inWarehouse)) {
	          if (programType.inWarehouse[0].length != 0) {
	            inwarehousepgType = programType.inWarehouse[0];
	          }
	        } else {
	          inwarehousepgType = programType.inWarehouse;
	        }
	        if (null != inwarehousepgType && inwarehousepgType.availability == 'NOSTOCK' && COSTCO.CMath.isWarehouseEnabled || null == inwarehousepgType || !COSTCO.CMath.isWarehouseEnabled) {
	          $('.crumbs').show();
	          $('#product-page').addClass('hide');
	          $('#not_found_error_pdp').removeClass('hide');
	
	          // set city and zip code
	          var storeLocation = COSTCO.LWSearch.getCookie('STORELOCATION');
	          console.log("storeLocation : " + storeLocation);
	          if (storeLocation !== "" || storeLocation != null) {
	            var storeLocation_ = JSON.parse(unescape(storeLocation));
	            var notfound_deliveryWarehouse = storeLocation_.storeLocation.city;
	            $('#notfound_deliveryWarehouse').html(notfound_deliveryWarehouse);
	          }
	          var notfound_deliveryLocation = COSTCO.LWSearch.getCookie('invCheckPostalCode');
	          $('#notfound_deliveryLocation').html(notfound_deliveryLocation);
	
	          $('#pdp-sticky-desktop').hide();
	          $('#pdp-sticky-mobile').hide();
	        }
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    pickUpinDistribution: function pickUpinDistribution(cookieDistributionCenters, pickUpCenters) {
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = pickUpCenters[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var centers = _step3.value;
	
	          if (!cookieDistributionCenters.includes(centers)) cookieDistributionCenters.push(centers);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return cookieDistributionCenters;
	    },
	    /**
	     * This method is for checkingwarehouse cookie to see whether 3pl location and pickupcenters is present and 
	     * return flag
	     */
	    checkifOutofNetworkLocation: function checkifOutofNetworkLocation() {
	      var cookieDistributionCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('distributionCenters');
	      var pickUpCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('pickUpCenters');
	      var isOutOfNetworkLocation = false;
	      if (pickUpCenters != undefined && pickUpCenters.length != 0 && cookieDistributionCenters != undefined && cookieDistributionCenters.length != 0 && !cookieDistributionCenters.includes('-3pl')) {
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = pickUpCenters[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var centers = _step4.value;
	
	            if (!cookieDistributionCenters.includes(centers)) {
	              isOutOfNetworkLocation = true;
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	      return isOutOfNetworkLocation;
	    },
	    /**
	        * This method is for call inventory batch API call
	        * @return void
	        */
	    invokeInventoryBatchAPIcall: function invokeInventoryBatchAPIcall(optionsSelected) {
	      var isBopiw = $('#isVariantBopiw').val();
	      var ltlFeatureFlag = $('#isLtlFeatureFlagOn').val();
	      var selectedWarehouse = "";
	      if (isEnableBOPIWUpdatesSync == 'true' && isBopiw == 'true') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isBopiwEnabled && !COSTCO.CMath.isWioEnabled && isBopiw == 'true') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isWioEnabled && !COSTCO.CMath.isBopiwEnabled && isBopiw == 'false') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isWioEnabled && COSTCO.CMath.isBopiwEnabled) {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      }
	      var distributionCenters = [];
	      var cookieDistributionCenters = [];
	      var cookieGroceryCenters = [];
	      var pickUpCenters = [];
	      var hasLTLPgType = false;
	      cookieDistributionCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('distributionCenters');
	      pickUpCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('pickUpCenters');
	      if (ltlFeatureFlag === "true" && pickUpCenters != undefined && pickUpCenters.length != 0) {
	        for (var i = 0; i < listOfObjects.length; i++) {
	          if (listOfObjects[i].programType.includes('LTLPickUp')) {
	            hasLTLPgType = true;
	            break;
	          }
	        }
	      }
	      if (hasLTLPgType == true) {
	        cookieDistributionCenters = COSTCO.Product.pickUpinDistribution(cookieDistributionCenters, pickUpCenters);
	      }
	      cookieGroceryCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('groceryCenters');
	      distributionCenters = cookieDistributionCenters.concat(cookieGroceryCenters);
	      var JsonResponseSum = 0;
	      itemIdMap.forEach(function (itemIdArray, keys) {
	        var _data = {
	          "distributionCenters": distributionCenters,
	          "selectedWarehouse": selectedWarehouse,
	          "itemNumbers": itemIdArray
	        };
	
	        var costcoEnv = $('#costcoEnvironmentForBatchInv').val(); //COSTCO.Product.validateCostcoEnv();
	        var costcoEnvECOMEnabled = $('#batchApiCostcoEnvECOMEnabled').val();
	        if (typeof costcoEnvECOMEnabled !== "undefined" && costcoEnvECOMEnabled === "true") {
	          if (costcoEnv === "" || costcoEnv === null || costcoEnv === 'null') {
	            costcoEnv = "ECOM";
	          }
	        }
	        var costcoService = "restInventory";
	        var clientIdentifier = $('#besBatchCLientIdentifier').val();
	
	        var inventoryBatchAkamaiCacheEnabled = $('#inventoryBatchAkamaiCacheEnabled').val();
	        var inventoryBatchEnabledV2 = $('#inventoryBatchEnabledV2').val();
	        var akamaiHeaders = {};
	        akamaiHeaders["Content-type"] = "application/json; charset=UTF-8";
	        akamaiHeaders["costco.env"] = costcoEnv;
	        akamaiHeaders["client-identifier"] = clientIdentifier;
	        akamaiHeaders["costco.service"] = costcoService;
	        var itemIdArraysort = itemIdArray.sort(function (a, b) {
	          return a - b;
	        });
	        if (inventoryBatchAkamaiCacheEnabled === "true") {
	          var batchVariantCacheKey = itemIdArraysort + "-" + COSTCO.Product.getZipcode() + "-" + selectedWarehouse;;
	          akamaiHeaders["batch-variant-cache-key"] = batchVariantCacheKey;
	        }
	
	        var batchApiURL;
	        if (inventoryBatchEnabledV2 === "true") {
	          batchApiURL = $('#baseUriForInventoryBatchV2').val();
	        } else {
	          batchApiURL = $('#baseUriForInventoryBatch').val();
	        }
	        fetch(batchApiURL, {
	          method: "POST",
	          body: JSON.stringify(_data),
	          headers: akamaiHeaders
	        }).then(function (response) {
	          if (response.status >= 200 && response.status <= 299) {
	            return response.json();
	          } else {
	            throw Error(response.statusText);
	          }
	        }).then(function (jsonResponse) {
	          if (!window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi) {
	            COSTCO.CMath.varItemJSON.push(jsonResponse);
	            window.reactObj.batchApiResponse.apiResponse = COSTCO.CMath.varItemJSON;
	            try {
	              if (COSTCO.CMath.varItemJSON.length > 0) {
	                window.wioEventBus.publish('notifyBatchApiComplete', COSTCO.CMath.varItemJSON);
	              }
	            } catch (e) {
	              console.log(e);
	            }
	          }
	          Object.entries(jsonResponse).forEach(function (entry) {
	            var _entry = _slicedToArray(entry, 2),
	                key = _entry[0],
	                value = _entry[1];
	
	            var itemarrayStatus = {};
	            var variantitemArray = {};
	            var valuesToCheck = ['NOSTOCK'];
	            var programType = value.programTypes;
	            var siteControlledpgType, locationControlledpgType, inwarehousepgType, ltlPickUpPgType;
	
	            if (programType != null && programType.hasOwnProperty("locationControlledInventory") && Array.isArray(programType.locationControlledInventory)) {
	              var locationControlledList = programType && programType.locationControlledInventory || [];
	              var _locationControlledpgType = Array.isArray(locationControlledList) && locationControlledList.every(function (item) {
	                return valuesToCheck.includes(item.availability);
	              });
	            } else if (programType.locationControlledInventory != undefined) {
	              locationControlledpgType = programType.locationControlledInventory;
	            }
	            if (programType != null && programType.hasOwnProperty("siteControlledInventory") && Array.isArray(programType.siteControlledInventory)) {
	              var siteControlledList = programType && programType.siteControlledInventory || [];
	              siteControlledpgType = Array.isArray(siteControlledList) && siteControlledList.every(function (item) {
	                return valuesToCheck.includes(item.availability);
	              });
	            } else if (programType.siteControlledInventory != undefined) {
	              siteControlledpgType = programType.siteControlledInventory;
	            }
	            if (programType != null && programType.hasOwnProperty("inWarehouse") && Array.isArray(programType.inWarehouse)) {
	              if (programType.inWarehouse[0].length != 0) {
	                inWarehousepgType = programType.inWarehouse[0];
	              }
	            } else {
	              inWarehousepgType = programType.inWarehouse;
	            }
	            if (programType != null && programType.hasOwnProperty("ltlPickUp") && Array.isArray(programType.ltlPickUp)) {
	              ltlPickUpPgType = programType.ltlPickUp[0];
	              var ltlPickUpList = programType && programType.ltlPickUp || [];
	              ltlPickUpPgType = Array.isArray(ltlPickUpList) && ltlPickUpList.every(function (item) {
	                return valuesToCheck.includes(item.availability);
	              });
	            } else if (programType.ltlPickup != undefined) {
	              ltlPickUpPgType = programType.ltlPickUp;
	            }
	
	            if (undefined != siteControlledpgType && (siteControlledpgType || siteControlledpgType.availability == 'NOSTOCK') || undefined != locationControlledpgType && (locationControlledpgType || locationControlledpgType.availability == 'NOSTOCK') || COSTCO.CMath.isErrorlocationControlleditem) {
	
	              itemarrayStatus["OL"] = '0';
	            } else {
	              itemarrayStatus["OL"] = '1';
	            }
	
	            if (null != inWarehousepgType && (inWarehousepgType.availability == 'INSTOCK' || inWarehousepgType.availability == 'LOWSTOCK') && COSTCO.CMath.isWarehouseEnabled || ltlPickUpPgType != undefined && (!ltlPickUpPgType || ltlPickUpPgType.availability == 'INSTOCK')) {
	
	              itemarrayStatus["WH"] = '1';
	            } else if (null != inWarehousepgType && inWarehousepgType.availability == 'NOSTOCK' && COSTCO.CMath.isWarehouseEnabled || null == inWarehousepgType || !COSTCO.CMath.isWarehouseEnabled) {
	              itemarrayStatus["WH"] = '0';
	            }
	            variantitemArray[value.itemNumber] = itemarrayStatus;
	            COSTCO.CMath.variantJSON.push(variantitemArray);
	
	            JsonResponseSum++;
	            if (JsonResponseSum == listOfObjects.length) {
	
	              var len = optionsSelected.length;
	              localStorage.setItem("variantStatus", JSON.stringify(COSTCO.CMath.variantJSON));
	              if ($('#swatches-productOption0' + parseInt(len - 1) + '').length > 0) {
	                COSTCO.Product.strikeOosSwatches(optionsSelected);
	              } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0) {
	                COSTCO.Product.grayOutDropDown(optionsSelected);
	              }
	            }
	          });
	        }).catch(function (err) {
	          return console.log(err);
	        });
	      });
	    },
	    /**
	        * This method is for Strike out lower level Swatches
	        * @return void
	        */
	    strikeOosSwatches: function strikeOosSwatches(optionsSelected) {
	      var len = optionsSelected.length;
	      var option = "option" + parseInt(len);
	      if (len == 3) {
	        var option0 = "option" + parseInt(len - 2);
	        var level0 = optionsSelected[len - 3];
	        var option1 = "option" + parseInt(len - 1);
	        var level1 = optionsSelected[len - 2];
	      } else if (len == 2) {
	        var option0 = "option" + parseInt(len - 1);
	        var level0 = optionsSelected[len - 2];
	      }
	
	      for (var i = 0; i < listOfObjects.length; i++) {
	        var obj = listOfObjects[i];
	        for (var k in COSTCO.CMath.variantJSON) {
	          var val = COSTCO.CMath.variantJSON[k];
	          for (var j in val) {
	            var sub_key = j;
	            var sub_val = val[j];
	            if (sub_key == listOfObjects[i].itemId) {
	
	              if (COSTCO.CMath.isWarehouseEnabled) {
	                var uptitemarrayStatus = {};
	                var uptvariantitemArray = {};
	
	                uptitemarrayStatus["OL"] = sub_val.OL;
	                if (listOfObjects[i].isaVariant == 'true') {
	                  uptitemarrayStatus["WH"] = '0';
	                } else {
	                  uptitemarrayStatus["WH"] = sub_val.WH;
	                }
	                uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	              }
	            }
	          }
	        }
	        /*following if condtion for skipping strike out for current selected. 
	        * Even selected product is NOSTOCK in batch API call and it is INSTOCK in Ajax call(means INSTOCK in wcs DB) prioprity is given to WCS response
	        *  */
	        if (COSTCO.CMath.invokeAjaxCall) {
	          for (var k in COSTCO.CMath.variantJSON) {
	            var val = COSTCO.CMath.variantJSON[k];
	            for (var j in val) {
	              var sub_key = j;
	              var sub_val = val[j];
	              if (sub_key == listOfObjects[i].itemId) {
	                if (optionsSelected[len - 1] == obj[option] && level0 == obj[option0] && (COSTCO.CMath.invAvailableAjax || COSTCO.CMath.isBackOrderFlag) && COSTCO.Product.isEDDStatusAvailable) {
	                  if (len == 3 && level1 == obj[option1]) {
	                    var uptitemarrayStatus = {};
	                    var uptvariantitemArray = {};
	                    uptitemarrayStatus["OL"] = '1';
	                    uptitemarrayStatus["WH"] = sub_val.WH;
	                    uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                    COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                    localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                  } else {
	
	                    var uptitemarrayStatus = {};
	                    var uptvariantitemArray = {};
	                    uptitemarrayStatus["OL"] = '1';
	                    uptitemarrayStatus["WH"] = sub_val.WH;
	                    uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                    COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                    localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                  }
	                } else {
	
	                  if (optionsSelected[len - 1] == obj[option] && level0 == obj[option0] && ((!COSTCO.CMath.invAvailableAjax || !COSTCO.CMath.isBackOrderFlag) && !COSTCO.Product.isEddItem || !COSTCO.Product.isEDDStatusAvailable || !COSTCO.CMath.invAvailableAjax && COSTCO.Product.isEDDStatusAvailable)) {
	                    if (len == 3 && level1 == obj[option1]) {
	                      var uptitemarrayStatus = {};
	                      var uptvariantitemArray = {};
	                      uptitemarrayStatus["OL"] = '0';
	                      uptitemarrayStatus["WH"] = sub_val.WH;
	                      uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                      COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                      localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                    } else {
	                      var uptitemarrayStatus = {};
	                      var uptvariantitemArray = {};
	                      uptitemarrayStatus["OL"] = '0';
	                      uptitemarrayStatus["WH"] = sub_val.WH;
	                      uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                      COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                      localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	        for (var k in COSTCO.CMath.variantJSON) {
	          var val = COSTCO.CMath.variantJSON[k];
	          for (var j in val) {
	            var sub_key = j;
	            var sub_val = val[j];
	            if (sub_key == listOfObjects[i].itemId) {
	              if (sub_val.OL == '0' && sub_val.WH == '0') {
	                var _variable = void 0;
	                _variable = $('input[value=' + obj[option] + ']').next().attr("automation-id");
	                if (COSTCO.Product.item_type === 'multi_variant') {
	                  if ($("input[automation-id='variationOptions_" + obj[option] + "']:checked").length) {
	                    $('span[automation-id=' + _variable + ']').addClass("select-span1-OOS");
	                    //folowing  code for appending OOS label in lower level
	                    var $selectedOptionLabel = $('label[for=productOption0' + parseInt(len - 1) + ']');
	                    var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	                    if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	                      $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                    }
	                    $selectedOptionValue.show();
	                  } else {
	                    $('span[automation-id=' + _variable + ']').removeClass("select-span1-OOS");
	                  }
	                  if (!$('span[automation-id=' + _variable + ']').hasClass('span1-outofstock')) {
	                    $('span[automation-id=' + _variable + ']').addClass("span1-outofstock");
	                  }
	                  if (!$('span[automation-id=' + _variable + ']').children('p').length) {
	                    $('span[automation-id=' + _variable + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	                    $('span[automation-id=' + _variable + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                  }
	                } else if (COSTCO.Product.item_type === 'single_variant') {
	                  // $('.selection-item').removeClass("select-span1-OOS");
	                  if ($("input[automation-id='variationOptions_" + obj[option] + "']:checked").length) {
	                    $('span[automation-id=' + _variable + ']').addClass("select-span1-OOS");
	                    //folowing  code for appending OOS label in lower level
	                    var $selectedOptionLabel = $('label[for=productOption00]');
	                    var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	                    if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	                      $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                    }
	                    $selectedOptionValue.show();
	                  } else {
	                    $('span[automation-id=' + _variable + ']').removeClass("select-span1-OOS");
	                  }
	                  if (!$('span[automation-id=' + _variable + ']').hasClass('span1-outofstock')) {
	                    $('span[automation-id=' + _variable + ']').addClass("span1-outofstock");
	                    if (!$('span[automation-id=' + _variable + ']').children('p').length) {
	                      $('span[automation-id=' + _variable + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	                      $('span[automation-id=' + _variable + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	
	      // following code striking upper swatch and dropdown
	
	      if ($('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0) {
	        COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
	      } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0) {
	        COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
	      }
	      //For 3 level varaints in order to retain  top level strike when swaping between other top levels
	      COSTCO.CMath.strikealllevelvariants();
	    },
	    /**
	        * This method is for OOS Drop down
	        * @return void
	        */
	    grayOutDropDown: function grayOutDropDown(optionsSelected) {
	      var len = optionsSelected.length;
	      var option = "option" + parseInt(len);
	      if (len == 3) {
	        var option0 = "option" + parseInt(len - 2);
	        var level0 = optionsSelected[len - 3];
	        var option1 = "option" + parseInt(len - 1);
	        var level1 = optionsSelected[len - 2];
	      } else if (len == 2) {
	        var option0 = "option" + parseInt(len - 1);
	        var level0 = optionsSelected[len - 2];
	      }
	      for (var i = 0; i < listOfObjects.length; i++) {
	        var option = "option" + parseInt(len);
	        var obj = listOfObjects[i];
	        for (var k in COSTCO.CMath.variantJSON) {
	          var val = COSTCO.CMath.variantJSON[k];
	          for (var j in val) {
	            var sub_key = j;
	            var sub_val = val[j];
	            if (sub_key == listOfObjects[i].itemId) {
	
	              if (COSTCO.CMath.isWarehouseEnabled) {
	                var uptitemarrayStatus = {};
	                var uptvariantitemArray = {};
	
	                uptitemarrayStatus["OL"] = sub_val.OL;
	                if (listOfObjects[i].isaVariant == 'true') {
	                  uptitemarrayStatus["WH"] = '0';
	                } else {
	                  uptitemarrayStatus["WH"] = sub_val.WH;
	                }
	                uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	              }
	            }
	          }
	        }
	        /*following if condtion for skipping strike out for current selected. 
	           	 * Even selected product is NOSTOCK in batch API call and it is INSTOCK in Ajax call(means INSTOCK in wcs DB) prioprity is given to WCS response
	           	 *  */
	        if (COSTCO.CMath.invokeAjaxCall) {
	          for (var k in COSTCO.CMath.variantJSON) {
	            var val = COSTCO.CMath.variantJSON[k];
	            for (var j in val) {
	              var sub_key = j;
	              var sub_val = val[j];
	              if (sub_key == listOfObjects[i].itemId) {
	
	                if (optionsSelected[len - 1] == obj[option] && level0 == obj[option0] && (COSTCO.CMath.invAvailableAjax || COSTCO.CMath.isBackOrderFlag) && COSTCO.Product.isEDDStatusAvailable) {
	                  if (len == 3 && level1 == obj[option1]) {
	                    var uptitemarrayStatus = {};
	                    var uptvariantitemArray = {};
	                    uptitemarrayStatus["OL"] = '1';
	                    uptitemarrayStatus["WH"] = sub_val.WH;
	                    uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                    COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                    localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                  } else {
	
	                    var uptitemarrayStatus = {};
	                    var uptvariantitemArray = {};
	                    uptitemarrayStatus["OL"] = '1';
	                    uptitemarrayStatus["WH"] = sub_val.WH;
	                    uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                    COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                    localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                  }
	                } else {
	                  if (optionsSelected[len - 1] == obj[option] && level0 == obj[option0] && ((!COSTCO.CMath.invAvailableAjax || !COSTCO.CMath.isBackOrderFlag) && !COSTCO.Product.isEddItem || !COSTCO.Product.isEDDStatusAvailable || !COSTCO.CMath.invAvailableAjax && COSTCO.Product.isEDDStatusAvailable)) {
	                    if (len == 3 && level1 == obj[option1]) {
	                      var uptitemarrayStatus = {};
	                      var uptvariantitemArray = {};
	                      uptitemarrayStatus["OL"] = '0';
	                      uptitemarrayStatus["WH"] = sub_val.WH;
	                      uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                      COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                      localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                    } else {
	                      var uptitemarrayStatus = {};
	                      var uptvariantitemArray = {};
	                      uptitemarrayStatus["OL"] = '0';
	                      uptitemarrayStatus["WH"] = sub_val.WH;
	                      uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                      COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                      localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	        for (var k in COSTCO.CMath.variantJSON) {
	          var val = COSTCO.CMath.variantJSON[k];
	          for (var j in val) {
	            var sub_key = j;
	            var sub_val = val[j];
	            if (sub_key == listOfObjects[i].itemId) {
	              if (sub_val.OL == '0' && sub_val.WH == '0') {
	                var _variable2 = void 0;
	                var obj = listOfObjects[i];
	                var len = optionsSelected.length;
	                if (!$('.varis-v2 option[automation-id=varisOption_' + obj[option] + ']').hasClass('out-of-stock')) {
	                  $('.varis-v2 option[automation-id=varisOption_' + obj[option] + ']').append('<span class="out-of-stock-text"></span>');
	                  $('.varis-v2 option[automation-id=varisOption_' + obj[option] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                  $('.varis-v2 option[automation-id=varisOption_' + obj[option] + ']').addClass("out-of-stock");
	                  var $selectedOptionLabel = $('label[for=productOption0' + parseInt(len - 1) + ']');
	                  var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	                  if (optionsSelected[len - 1] == obj[option] && !$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	                    var textToReplace = $selectedOptionValue.text();
	                    var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
	                    $selectedOptionValue.text(newText);
	                    $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                  }
	                  $selectedOptionValue.show();
	                }
	              }
	            }
	          }
	        }
	      }
	      if ($('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0) {
	        COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
	      } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0) {
	        COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
	      }
	      //For 3 level varaints in order to retain  top level strike when swaping between other top levels
	      COSTCO.CMath.strikealllevelvariants();
	    },
	    /**
	        * This method is for strike upper level swatch
	        * @return void
	        */
	    grayOutUpperLevelDropDown: function grayOutUpperLevelDropDown(optionsSelected) {
	      var lowerLevelOOSCount;
	      var lowerLevelCount;
	      var lowerSwatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 1) + '').length > 0;
	      var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').length > 0;
	      //following code for checking lower level is drop down or pills. if  all lower level items are OOS will strike out upper level
	      if (lowerDropDown) {
	        lowerLevelCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').find('option.opt:not(:disabled)').length;
	        lowerLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').find('option.out-of-stock:not(:disabled)').length;
	      } else if (lowerSwatch) {
	        lowerLevelCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').find('.selection-box-v2:visible').length;
	        lowerLevelOOSCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').find('.span1-outofstock').length;
	      }
	      if (lowerLevelOOSCount != "" && lowerLevelCount != "" && lowerLevelCount === lowerLevelOOSCount) {
	        var option = "option" + parseInt(optionsSelected.length - 1);
	        if (!$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 2] + ']').hasClass('out-of-stock')) {
	          $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 2] + ']').append('<span class="out-of-stock-text"></span>');
	          $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 2] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	          $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 2] + ']').addClass("out-of-stock");
	          var $selectedOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length - 2) + ']');
	          var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	          if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	            //$selectedOptionValue.prepend('Out of Stock - ' );
	            var textToReplace = $selectedOptionValue.text();
	            var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
	            $selectedOptionValue.text(newText);
	            $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	          }
	          $selectedOptionValue.show();
	        }
	        if (optionsSelected.length == 3) {
	          var midLevelOOSCount;
	          var midLevelCount;
	          var midSwatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0;
	          var midDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0;
	          //following code for checking mid level is drop down or pills. if  all mid level items are OOS will strike out upper level
	          if (midDropDown) {
	            midLevelCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.opt:not(:disabled)').length;
	            midLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.out-of-stock:not(:disabled)').length;
	          } else if (midSwatch) {
	            midLevelCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.selection-box-v2:visible').length;
	            midLevelOOSCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.span1-outofstock').length;
	          }
	          if (midLevelOOSCount != "" && midLevelCount != "" && midLevelCount === midLevelOOSCount) {
	            var option = "option" + parseInt(optionsSelected.length - 2);
	            if (!$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 3] + ']').hasClass('out-of-stock')) {
	              $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 3] + ']').append('<span class="out-of-stock-text"></span>');
	              $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 3] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	              $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 3] + ']').addClass("out-of-stock");
	              var $selectedOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length - 3) + ']');
	              var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	              if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	                //$selectedOptionValue.prepend('Out of Stock - ' );
	                var _textToReplace = $selectedOptionValue.text();
	                var _newText = _textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
	                $selectedOptionValue.text(_newText);
	                $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	              }
	              $selectedOptionValue.show();
	            }
	          }
	        }
	      } else {
	        var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length - 2) + ']');
	        var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	        $dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);
	
	        var $dropDownOOSOption = $('.varis-v2 option[value=' + optionsSelected[optionsSelected.length - 2] + ']').attr("automation-id");
	        $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
	        $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
	        if (optionsSelected.length == 3) {
	          var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length - 3) + ']');
	          var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	          $dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);
	
	          var $dropDownOOSOption = $('.varis-v2 option[value=' + optionsSelected[optionsSelected.length - 3] + ']').attr("automation-id");
	          $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
	          $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
	        }
	      }
	    },
	    /**
	        * This method is for strike upper level swatch
	        * @return void
	        */
	    strikeUpperLevelVariant: function strikeUpperLevelVariant(optionsSelected) {
	      var element;
	      var noOfLevel = optionsSelected.length;
	      // below code for appending OOS label in upper level swatch if all
	      // item in lower level is OOS
	      var lowerLevelOOSCount;
	      var lowerLevelCount;
	      var lowerSwatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 1) + '').length > 0;
	      var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').length > 0;
	      //following code for checking lower level is drop down or pills. if  all lower level items are OOS will strike out upper level
	      if (lowerDropDown) {
	        lowerLevelCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').find('option.opt:not(:disabled)').length;
	        lowerLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').find('option.out-of-stock:not(:disabled)').length;
	      } else if (lowerSwatch) {
	        lowerLevelCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').find('.selection-box-v2:visible').length;
	        lowerLevelOOSCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').find('.span1-outofstock').length;
	      }
	      if (lowerLevelOOSCount != "" && lowerLevelCount != "" && lowerLevelCount === lowerLevelOOSCount) {
	
	        if ($('#swatches-productOption0' + parseInt(noOfLevel - 2) + '').length > 0) {
	          // if upper layer is pills
	          element = $('input[value=' + optionsSelected[noOfLevel - 2] + ']').next().attr("automation-id");
	          if ($('input[value=' + optionsSelected[noOfLevel - 2] + ']').attr('checked') === 'checked') {
	            $('span[automation-id=' + element + ']').addClass("select-span1-OOS");
	          }
	          if (!$('span[automation-id=' + element + ']').hasClass('span1-outofstock')) {
	            $('span[automation-id=' + element + ']').addClass("span1-outofstock");
	            if (!$('span[automation-id=' + element + ']').children('p').length) {
	              // if upper layer is dropdown
	              $('span[automation-id=' + element + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	              $('span[automation-id=' + element + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	            }
	          }
	        }
	        COSTCO.Product.appendLabelSwatches(noOfLevel - 2);
	        if (noOfLevel == 3) {
	          var midLevelOOSCount;
	          var midLevelCount;
	          var midSwatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0;
	          var midDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0;
	          if (midDropDown) {
	            midLevelCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.opt:not(:disabled)').length;
	            midLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.out-of-stock:not(:disabled)').length;
	          } else if (midSwatch) {
	            midLevelCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.selection-box-v2:visible').length;
	            midLevelOOSCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.span1-outofstock').length;
	          }
	          if (midLevelOOSCount != "" && midLevelCount != "" && midLevelOOSCount === midLevelCount) {
	
	            if ($('#swatches-productOption0' + parseInt(noOfLevel - 3) + '').length > 0) {
	              // if upper layer is pills
	              element = $('input[value=' + optionsSelected[noOfLevel - 3] + ']').next().attr("automation-id");
	              if ($('input[value=' + optionsSelected[noOfLevel - 3] + ']').attr('checked') === 'checked') {
	                $('span[automation-id=' + element + ']').addClass("select-span1-OOS");
	              }
	              if (!$('span[automation-id=' + element + ']').hasClass('span1-outofstock')) {
	                $('span[automation-id=' + element + ']').addClass("span1-outofstock");
	              }
	              if (!$('span[automation-id=' + element + ']').children('p').length) {
	                // if upper layer is dropdown
	                $('span[automation-id=' + element + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	                $('span[automation-id=' + element + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	              }
	            }
	            COSTCO.Product.appendLabelSwatches(noOfLevel - 3);
	          }
	        }
	      } else {
	        var $selectedUpperLabel = $('label[for=productOption0' + parseInt(noOfLevel - 2) + ']');
	        var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	        $selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS);
	
	        var $selectedOOSOption = $('input[value=' + optionsSelected[noOfLevel - 2] + ']').next().attr("automation-id");
	        $('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
	        $('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
	        $('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
	        if (noOfLevel == 3) {
	          var $selectedUpperLabel = $('label[for=productOption0' + parseInt(noOfLevel - 3) + ']');
	          var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	          $selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS);
	
	          var $selectedOOSOption = $('input[value=' + optionsSelected[noOfLevel - 3] + ']').next().attr("automation-id");
	          $('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
	          $('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
	          $('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
	        }
	      }
	    },
	    /**
	        * This method is for getting array of object
	        * object having item id and what are the options associated with the item
	        * @return void
	        */
	    getLowerLevelItemDetails: function getLowerLevelItemDetails(optionsSelected) {
	      //following for loop for getting item and option associated with that item 
	      var selected_first = $('#productOption00').val();
	      var count50 = 0;
	
	      var numberOfChunks = 0;
	      var itemIdchunk = [];
	      for (var i = 0; i < product.length; i++) {
	        for (var j = 0; j < products[i].length; j++) {
	          var singleObj = {}; // this object for holding item id and what are the options belong to that item ID
	          singleObj['itemId'] = products[i][j].partNumber;
	          singleObj['isaVariant'] = products[i][j].isaVariant;
	          singleObj['programType'] = products[i][j].programType;
	          // following for lopp for ordering options in object
	          if (COSTCO.Product.item_type === 'multi_variant') {
	            for (var m = 0; m < optionsSelected.length - 1; m++) {
	              if (products[i][j].options.includes(optionsSelected[m])) {
	                if (m == optionsSelected.length - 2) {
	                  // if upto 2nd last layer all options are macthed then only we are passing that item to batch API
	                  for (var m = 0; m < optionsSelected.length; m++) {
	                    if (products[i][j].options.includes(optionsSelected[m])) {
	                      // folloeing code finding common elements and adding accoding to the index of selected option
	                      var findCommonOption = products[i][j].options.find(function (element) {
	                        return element == optionsSelected[m];
	                      });
	                      singleObj['option' + parseInt(m + 1)] = findCommonOption;
	                    } else {
	                      //finding different option and adding to the bottom of the array
	                      var differentElement = products[i][j].options.filter(function (x) {
	                        return !optionsSelected.includes(x);
	                      });
	                      singleObj['option' + parseInt(optionsSelected.length)] = differentElement[0];
	                    }
	                  }
	
	                  listOfObjects.push(singleObj);
	                  itemIdchunk.push(products[i][j].partNumber);
	                  count50++;
	                }
	              } else {
	                break;
	              }
	            }
	          } else {
	            for (var k = 0; k < products[i][j].options.length; k++) {
	              singleObj['option' + parseInt(k + 1)] = products[i][j].options[k];
	            }
	            listOfObjects.push(singleObj);
	            itemIdchunk.push(products[i][j].partNumber);
	            count50++;
	          }
	
	          /*following code for check item pushed in the array reached the limit(which is configured in appconfigparam) or it loop is completed
	           * in bot scenario pushing all element to the map. this map later used for callling batch API
	          */
	          if (count50 == numberOfBatchApiIds || j == products[i].length - 1 && itemIdchunk.length > 0) {
	            count50 = 0;
	            numberOfChunks++;
	            itemIdMap.set(numberOfChunks, itemIdchunk);
	            itemIdchunk = [];
	          }
	        }
	      }
	    },
	    /**
	        * This method is for OOS item using batch API
	        * @return void
	        */
	    appendLabelSwatches: function appendLabelSwatches(labelLevel) {
	      var $selectedOptionLabel = $('label[for=productOption0' + parseInt(labelLevel) + ']');
	      var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	      if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	        $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	      }
	      $selectedOptionValue.show();
	    },
	
	    /**
	        * This method is for OOS item using batch API
	        * @return void
	        */
	    findOOSitem: function findOOSitem(invokeBatchAPICall) {
	      itemIdMap = new Map();
	      listOfObjects = [];
	      OOSMap = new Map();
	
	      //folowing code for avoiding 2nd method call
	      var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
	      COSTCO.CMath.selectedswatches = optionsSelected;
	
	      // following code for setting 2nd swatch items for selected first swatch
	
	      COSTCO.Product.getLowerLevelItemDetails(optionsSelected); //for setting array of item id and listOfObjects which has  itemid and option associated with that item 
	      if (invokeBatchAPICall) {
	        COSTCO.Product.invokeInventoryBatchAPIcall(optionsSelected); // following code for call bact API call
	      } else {
	        var len = optionsSelected.length;
	        if ($('#swatches-productOption0' + parseInt(len - 1) + '').length > 0) {
	          COSTCO.Product.strikeOosSwatches(optionsSelected);
	        } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0) {
	          COSTCO.Product.grayOutDropDown(optionsSelected);
	        }
	      }
	      //following code for remove lower skeleton and append swatches
	      $('#PDPSwatchSkeletone-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
	      $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').show();
	      $('.dropdown-skeleton-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
	      $('[name=productOption0' + parseInt(optionsSelected.length - 1) + ']').show();
	      COSTCO.CMath.pdpPageloadComplete = true;
	      COSTCO.CMath.invokebatchCall = false;
	    },
	    /**
	        * Changes the variance value displayed in bundle element
	        * @param id of variance select element user changed
	        * @param  variance label
	        * @param new variance value
	        * @param product price
	        * @param varianceIsBackordered
	        * @param varianceBackorderMessage
	        * @return void
	        */
	    changeBundleItemVarianceValue: function changeBundleItemVarianceValue(varianceId, varianceLabel, varianceValue, variancePrice, varianceIsBackordered, varianceBackorderMessage) {
	      var $varianceValue = $('#bundle-item-value-' + varianceId);
	      $varianceValue.find('span').text(varianceLabel + ': ' + varianceValue);
	      var $variancePrice = $('#bundle-item-price-' + varianceId);
	      $variancePrice.find('span').text(COSTCO.Product.formatMoney(variancePrice, true));
	      var $bundleItem = $('#bundle-item-' + varianceId);
	      $bundleItem.find('#backorder-message').remove();
	      if (varianceIsBackordered && varianceBackorderMessage) {
	        $bundleItem.append($('<div id="backorder-message" class="warning"></div>').text(varianceBackorderMessage));
	      }
	    },
	
	    /**
	        * Changes the quantity displayed in bundle input element on plus/minus click
	        * @param index ID of quantity element user clicked on
	        * @param isIncrement boolean showing if user clicked on plus or minus button
	        * @return void
	        */
	    changeBundleItemQuantityValue: function changeBundleItemQuantityValue(index, isIncrement) {
	      var qtyInput = $('#bundle-quantity-' + index);
	      var qtyValue = parseInt(qtyInput.val());
	      var quantityStep = 1;
	
	      if (isIncrement === true) {
	        var maxQnty = COSTCO.Product.maxQuantity();
	        if (qtyValue + quantityStep <= maxQnty + 1) {
	          qtyValue += quantityStep;
	        }
	      } else if (isIncrement === false) {
	        if (qtyValue - quantityStep >= 0) {
	          qtyValue -= quantityStep;
	        }
	      }
	
	      qtyInput.val(qtyValue);
	
	      COSTCO.Product.validateQuantityValue(qtyInput, '.bundle-item #bundle-error-' + index);
	      COSTCO.Product.discardInvalidQtyValues(qtyValue, qtyInput, isIncrement);
	
	      if (!qtyInput.hasClass("error")) {
	        $('[name=quantity-' + index + ']').val(qtyValue);
	        $('[name=quantity-' + index + ']').trigger('change');
	      }
	    },
	
	    /**
	     * Adds item to the bundle and shows it in the bundle section
	     * @param bundleItemObj product that is added to bundle
	     * @return void
	     */
	    addBundleItem: function addBundleItem(bundleItemObj) {
	      $('#bundle-div-empty').hide();
	      if (bundleItemObj.varianceLabel && bundleItemObj.varianceValue) {
	        $('#bundle-div').append(COSTCO.util.tmpl('tmpl_bundle_item_variance', {
	          item_desc: bundleItemObj.desc,
	          item_url: bundleItemObj.url,
	          item_price: bundleItemObj.price,
	          item_id: bundleItemObj.itemId,
	          item_label: bundleItemObj.varianceLabel,
	          item_value: bundleItemObj.varianceValue,
	          item_data_product: parseInt(bundleItemObj.itemId) - 1
	        }));
	        if (bundleItemObj.backordered) {
	          if (typeof bundleItemObj.beckorderedMessage !== "undefined") {
	            $('#bundle-item-' + bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(bundleItemObj.beckorderedMessage));
	          } else {
	            $('#bundle-item-' + bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	          }
	        }
	      } else {
	        $('#bundle-div').append(COSTCO.util.tmpl('tmpl_bundle_item', {
	          item_desc: bundleItemObj.desc,
	          item_url: bundleItemObj.url,
	          item_price: bundleItemObj.price,
	          item_id: bundleItemObj.itemId,
	          item_data_product: parseInt(bundleItemObj.itemId) - 1
	        }));
	        if (bundleItemObj.backordered) {
	          if (typeof backorderMessage !== "undefined") {
	            $('#bundle-item-' + bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(backorderMessage));
	          } else {
	            $('#bundle-item-' + bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	          }
	        }
	      }
	      var $qtyInput = $('#bundle-quantity-' + bundleItemObj.itemId);
	      COSTCO.Product.changeBundleItemQuantityValue(bundleItemObj.itemId);
	      var numberOfItems = $('.bundle-item').length;
	      if (numberOfItems == 1) {
	        $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.ITEM + ')');
	        $('#accordion-item-number').text('(' + numberOfItems + ' ' + messages.ITEM + ')');
	      } else {
	        $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')');
	        $('#accordion-item-number').text('(' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')');
	      }
	      $('#bundle-container').append($('#bundle-items-container'));
	      $('#bundle-items-container').show();
	      var topOfWindow = $(window).scrollTop();
	      var $buildABundle = $('#build-a-bundle');
	      var bottomOfElement = $buildABundle.offset().top + $buildABundle.outerHeight();
	      if (topOfWindow >= bottomOfElement && $(window).width() < 769) {
	        $('#pdp-sticky-mobile').append($('#bundle-items-container'));
	        $('#build-bundle-sticky').detach();
	      }
	      $('#addBundleBtn').removeAttr('disabled');
	    },
	
	    /**
	     * Removes the item from the bundle section
	     * @param bundleItemNumber ID number of bundle item that is being removed
	     * @return void
	     */
	    removeBundleItem: function removeBundleItem(bundleItemNumber) {
	      $('#ProductForm #quantity-' + bundleItemNumber).val('0');
	      $('#ProductForm #quantity-' + bundleItemNumber).trigger('change');
	      if ($('#checkbox-bundle-' + bundleItemNumber).is(':checked')) {
	        $('#checkbox-bundle-' + bundleItemNumber).prop('checked', false);
	        $('#checkbox-bundle-' + bundleItemNumber).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADD_TO_BUNDLE);
	      }
	      $('#bundle-item-' + bundleItemNumber).remove();
	      var numberOfItems = $('.bundle-item').length;
	      if (numberOfItems == 0) {
	        $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE_ITEMS);
	        $('#accordion-item-number').text('');
	        $('#bundle-div-empty').show();
	        var topOfWindow = $(window).scrollTop();
	        var $buildABundle = $('#build-a-bundle');
	        var bottomOfElement = $buildABundle.offset().top + $buildABundle.outerHeight();
	        if (topOfWindow >= bottomOfElement && $(window).width() < 769) {
	          $('#bundle-container').append($('#bundle-items-container'));
	          $('#pdp-sticky-mobile').append($('#build-bundle-sticky'));
	        }
	        $('#addBundleBtn').attr('disabled', true);
	      } else {
	        if (numberOfItems == 1) {
	          $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.ITEM + ')');
	          $('#accordion-item-number').text('(' + numberOfItems + ' ' + messages.ITEM + ')');
	        } else {
	          $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')');
	          $('#accordion-item-number').text('(' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')');
	        }
	      }
	    },
	
	    /**
	     * Calls addBundleItem/removeBundleItem when the bundle checkbox is clicked
	     * @param element checkbox element that is being clicked
	     * @param bundleItemNumber ID number of bundle item
	     * @return void
	     */
	    bundleCheckboxClick: function bundleCheckboxClick(element, bundleItemNumber) {
	      if ($(element).is(':checked')) {
	        var clonedVarArr = document.getElementsByClassName('cloned');
	        var select = $("select[data-product=" + (bundleItemNumber - 1) + "]");
	        //Check if item is backordered
	        var isBackordered = false;
	        if ($(element).closest('.bundle-product').find('#backorder-message').length > 0) {
	          isBackordered = true;
	        }
	        if (clonedVarArr.length > 0 && select.length > 0) {
	          var selectedOption = $("select[data-product=" + (bundleItemNumber - 1) + "] option:selected");
	          var selectVariantName = $(select).prop('name');
	          var labels = '';
	          //check if bundle item has variance to select
	          labels = $("label[for='" + select[1].id + "']");
	          //check value of the cloned select 
	          if (selectedOption[1].value == "unselected") {
	            $(element).prop("checked", false);
	            select.addClass("error-in-bundle");
	            labels.addClass("label-outline-error");
	            labels.show();
	            return;
	          } else {
	            $('#' + selectVariantName).val(selectedOption[1].value);
	            $('#' + selectVariantName).trigger('change.vari');
	          }
	          var $bundleItemLink = $(element).closest('.vari').find('.desc');
	          var bundleItemObj = {
	            desc: $bundleItemLink.text(),
	            url: $bundleItemLink.attr('href'),
	            price: $(element).closest('.vari').find('.price span').text(),
	            itemId: bundleItemNumber,
	            varianceLabel: labels[1].textContent.trim(),
	            varianceValue: selectedOption[1].text,
	            backordered: isBackordered,
	            beckorderedMessage: $(element).closest('.bundle-product').find('#backorder-message').text()
	          };
	          $(element).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADDED_TO_BUNDLE);
	          COSTCO.Product.addBundleItem(bundleItemObj);
	        } else {
	          var _$bundleItemLink = $(element).closest('.vari').find('.desc');
	          var _bundleItemObj = {
	            desc: _$bundleItemLink.text(),
	            url: _$bundleItemLink.attr('href'),
	            price: $(element).closest('.vari').find('.price span').text(),
	            itemId: bundleItemNumber,
	            backordered: isBackordered
	          };
	          $(element).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADDED_TO_BUNDLE);
	          COSTCO.Product.addBundleItem(_bundleItemObj);
	        }
	      } else {
	        $(element).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADD_TO_BUNDLE);
	        COSTCO.Product.removeBundleItem(bundleItemNumber);
	      }
	    },
	
	    /**
	     * Scroll to section from product info sticky element. 
	     * Sets offset approximately for the width of sticky element.   
	     */
	    scrollToElementOnPdpWithOffset: function scrollToElementOnPdpWithOffset() {
	      $('a.scrollLink').click(function (event) {
	        event.preventDefault();
	        var stickyOffset = $('#hidden-sticky').is(':hidden') ? 190 : 140;
	        $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top - stickyOffset }, 500);
	      });
	    },
	
	    /**
	     * Changes bundle accordion header text when accordion is expanded/collapsed
	     * @return void
	     */
	    bundleAccordionClick: function bundleAccordionClick() {
	      if ($('#bundle-accordion-collapse').hasClass('in')) {
	        $('#accordion-header-text').text(messages.PDP_REDESIGN_V2_VIEW_ORDER_SUMMARY);
	        $('#bundle-accordion-header a i').removeClass('rotate270');
	        $('#bundle-accordion-header a i').addClass('rotate90');
	      } else {
	        $('#accordion-header-text').text(messages.PDP_REDESIGN_V2_HIDE_ORDER_SUMMARY);
	        $('#bundle-accordion-header a i').removeClass('rotate90');
	        $('#bundle-accordion-header a i').addClass('rotate270');
	      }
	    },
	    /**
	     * Scrolls the page to tablist and shows the buld a bundle tab
	     * @return void
	     */
	    focusBuildABundle: function focusBuildABundle() {
	      $('html, body').scrollToElem($('.bottom-content'), 500);
	      $('#build-bundle-tab').focus();
	      setTimeout(function () {
	        $('#tablist li').removeClass('active');
	        $('.tab-content div').removeClass('active in');
	        $('#tab-header-bundle').addClass('active');
	        $('.bundle-tab').addClass('active in');
	      }, 500);
	    },
	    /**
	     * Scrolls the page to the top and focuses on the Zip Code field
	     * @return void
	     */
	    focusZipCodeField: function focusZipCodeField() {
	      var x = $('#edd-message-block').length > 0 ? $("#edd-message-block").offset() : $('#delivery-zip').offset();
	      $('html, body').animate({ scrollTop: x.top - 200 }, 'slow');
	      if ($('#edd-message-block').length > 0) {
	        $('#edd-message-block').focus();
	      } else {
	        $('#delivery-zip').focus();
	      }
	    },
	
	    /**
	     * Makes Add to Registry button reachable by keyboard,
	     * and enables click on the button via keyboard 
	     */
	    makeGiftRegistryAdaCompliant: function makeGiftRegistryAdaCompliant() {
	      var addToRegistryDivContent = $('.mr-registry-container a');
	      addToRegistryDivContent.attr('tabindex', '0');
	      addToRegistryDivContent.attr('role', 'button');
	
	      addToRegistryDivContent.on('keypress click', function (event) {
	        if (event.which === 13 || event.which === 1) {
	          addToRegistryDivContent.click();
	          return false;
	        }
	      });
	    },
	    /**
	     * ADA compliance
	     * Initializes aria-current value for tab panel
	     * @return void
	     */
	    initializeAdaForTabPanel: function initializeAdaForTabPanel() {
	      $('.tablist li.active a').attr('aria-current', "true");
	    },
	    /**
	     * Sets all bundle checkboxes to unchecked on load
	     * @return void
	     */
	    bundlePageReload: function bundlePageReload() {
	      $('[id^="checkbox-bundle-"]').prop('checked', false);
	      $('[id^="clonedproductOption"]').prop("selectedIndex", 0);
	    },
	
	    arrangeBundleButtons: function arrangeBundleButtons() {
	      if (!$('#mr-registry-container').is(':empty')) {
	        $('#bundle-button').addClass('not-alone');
	      }
	    },
	
	    /** envent for determing if quantity-selector-v2 buttons shoud be enabled/disabled. This event is triggering when user changes quantity box
	     * 
	     */
	    initializeQuantityBtns: function initializeQuantityBtns() {
	      $('#minQtyText').unbind('keyup').bind('keyup', function () {
	        COSTCO.Product.changeQuantityButtonsBehaviour();
	      });
	    },
	
	    /** function for disabling '+' and '-' buttons for quantity-selector-v2
	     * @param disblebuttonSelector - selector for buttton which needs to be disabled.
	     * @return void
	     * 
	     */
	    disableButton: function disableButton(disblebuttonSelector) {
	      disblebuttonSelector.get(0).setAttribute('disabled', true);
	      disblebuttonSelector.addClass("disabled");
	    },
	
	    /** function for enabling '+' and '-' buttons for quantity-selector-v2
	     * @param enablebuttonSelector - selector for buttton which needs to be enabled.
	     * @return void
	     * 
	     */
	    enableButton: function enableButton(enablebuttonSelector) {
	      enablebuttonSelector.removeAttr("disabled");
	      enablebuttonSelector.removeClass("disabled");
	    },
	    /**
	     * this function has logic for determing should '+' or '-' buttons be enabled or disabled
	     * @return void
	     */
	    changeQuantityButtonsBehaviour: function changeQuantityButtonsBehaviour() {
	      var quantityStep = $('#minQtyText').attr('data-quantity-increment') ? parseInt($('#minQtyText').attr('data-quantity-increment')) : 1;
	      var currentQut = $('[name=quantity]').val();
	      if (currentQut > 999 - quantityStep) {
	        COSTCO.Product.disableButton($("#plusQty"));
	      } else if (currentQut <= quantityStep) {
	        COSTCO.Product.disableButton($("#minusQty"));
	      } else {
	        COSTCO.Product.enableButton($("#minusQty"));
	        COSTCO.Product.enableButton($("#plusQty"));
	      }
	    },
	    makeTextNonClicableForSR: function makeTextNonClicableForSR() {
	      $('#product-details').off('click');
	      $('#product-details').find('*').off('click');
	    },
	
	    initShippingStatementPopover: function initShippingStatementPopover() {
	      $('.popup-help').attr('aria-haspopup', 'true');
	      $('.popup-help').attr('aria-expanded', 'false');
	      var sr_message = messages.RWD_HELP;
	      $('.popup-help i').append("<span class='sr-only'>" + sr_message + "</span>");
	      $('.popup-help').popover({
	        trigger: 'click'
	      }).on('keypress', function (e) {
	        if (e.which === 13 || e.which === 32 || e.which === 1) {
	          // mozilla condition
	          if ($('.popover').length === 1) {
	            return;
	          } else {
	            $(this).click();
	          }
	        }
	      }).on('shown.bs.popover', function () {
	        COSTCO.util.announceSRMessage('expanded');
	        $('.popover').on('focusout ', function (e) {
	          $('.popup-help').popover('hide').on('keydown', function (e) {
	            if (event.shiftKey && event.keyCode === 9) {
	              $('.popup-help').popover('hide');
	            }
	          });
	        });
	        $('body').on('click', function (e) {
	          var $popupContainer = $('.shipping-statement .popup-help');
	          if (!$popupContainer.is(e.target) && $popupContainer.has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
	            $popupContainer.popover('hide');
	          }
	        });
	      });
	    },
	    /**
	      * this function has logic to show/hide review contents
	      * param action
	      * @return void
	      */
	    changeVisibilityOfReviewContents: function changeVisibilityOfReviewContents(action) {
	      var $bvReviewContents = $('.bv-content-item.bv-content-top-review.bv-content-review');
	      $bvReviewContents.each(function (index) {
	        if (index != 0 && action === "hide") {
	          $(this).attr("style", "display: none !important");
	        } else if (action === "show") {
	          $(this).attr("style", "display: flex !important");
	        }
	      });
	    },
	    invokeAddedToCartModalData: function invokeAddedToCartModalData(sessionStorageDataModal) {
	      var addedToCartModalData = $.parseJSON(sessionStorageDataModal);
	      COSTCO.AddToCart.product_form_done(addedToCartModalData);
	      sessionStorage.removeItem("AddedToCartModalData");
	    },
	    /**
	    * Show/Hide the EDD details and message based on whether Product is coming soon.
	    * @param product isComingSoon and feature flag are true shows the coming soon message else shows EDD details.
	    */
	    toggleDeliveryMoleculeOnComingSoon: function toggleDeliveryMoleculeOnComingSoon() {
	      if (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) {
	        $('#comingsoon-alert-id').removeClass('hide');
	        $('#product-form-and-action').addClass('hide');
	        $('#product-estimated-date').addClass('hide');
	        $('#sticky-content').addClass('hide');
	      } else {
	        $('#comingsoon-alert-id').addClass('hide');
	        $('#product-form-and-action').removeClass('hide');
	        if (!COSTCO.CMath.iskitsbundle) {
	          $('#product-estimated-date').removeClass('hide');
	        }
	        $('#sticky-content').removeClass('hide');
	      }
	    }
	  };
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.Product = Product;
	  return Product;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * @title addressBook.js: Feature level module
	 * @description Module associated with address book section
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var CAddressBook = {
	    url: {
	      MANAGE_ADDRESS_UPDATE: '/AjaxManageAddressCmd?mode=UPDATE',
	      MANAGE_ADDRESS_ADD: '/AjaxManageAddressCmd?mode=ADD',
	      MANAGE_ADDRESS_SET_DEFAULT: '/AjaxManageAddressCmd?mode=SET_DEFAULT',
	      MANAGE_ADDRESS_REMOVE: '/AjaxManageAddressCmd?mode=DELETE',
	      MANAGE_ADDRESSTYPE_UPDATE: '/AjaxManageAddressCmd?mode=SET_ADDRESSTYPE'
	    },
	
	    /**
	     * Constants
	     */
	    DEFAULT_ADDRESS_ADD_BUTTON_HEIGHT: 114,
	
	    DEFAULT_ADDRESS_CELL_HEIGHT: 140,
	
	    DEFAULT_ADDRESS_CELL_TITLE_HEIGHT: 24,
	
	    ENTRIES_PER_PAGE_LG: 8,
	    ENTRIES_PER_PAGE_NON_LG: 7,
	
	    //    ADDRESS_TYPE_SHIPPING: 'Shipping',
	    //    ADDRESS_TYPE_BILLING: 'Billing',
	
	    ADDRESS_TYPE_SHIPPING: 'S',
	    ADDRESS_TYPE_BILLING: 'B',
	
	    ADDRESS_TYPE_S: 'S',
	    ADDRESS_TYPE_B: 'B',
	
	    ADDRESS_SORT_MOST_RECENT: '1',
	    ADDRESS_SORT_FIRST_A_Z: '2',
	    ADDRESS_SORT_FIRST_Z_A: '3',
	    ADDRESS_SORT_LAST_A_Z: '4',
	    ADDRESS_SORT_LAST_Z_A: '5',
	    ADDRESS_SORT_COMPANY_NAME_A_Z: '6',
	    ADDRESS_SORT_COMPANY_NAME_Z_A: '7',
	
	    currentShippingPage: 1,
	    currentBillingPage: 1,
	    resizeTimer: 0,
	    activeTab: 'S',
	
	    /**
	     * Adjust add button height to be equal to address cells.
	     */
	    adjustAddButtonHeight: function adjustAddButtonHeight() {
	      var currentBtnHeight = $('.add-new-address > .caption').height();
	      var topPadding = (CAddressBook.DEFAULT_ADDRESS_ADD_BUTTON_HEIGHT - currentBtnHeight) / 2;
	      if ($('#xs-sm-visible-indicator').css('display') === 'none') {
	        // Btn height should be same as address cell next to it, otherwise it should be square.
	        var addressCellHeight = $('.address-cell').length > 0 ? $('.address-cell:first').height() - 2.75 : $('.add-new-address').width(); // -1 for fine cells alignment
	        if (addressCellHeight != null && addressCellHeight > CAddressBook.DEFAULT_ADDRESS_ADD_BUTTON_HEIGHT) {
	          topPadding = (addressCellHeight - currentBtnHeight) / 2;
	          $('.add-new-address').height(addressCellHeight - 1);
	        }
	      } else {
	        // Subtracting 2.5 from desired height because of border-box box-sizing 
	        $('.add-new-address').height(CAddressBook.DEFAULT_ADDRESS_ADD_BUTTON_HEIGHT - 2.5);
	      }
	      $('.add-new-address > .caption').css('margin-top', topPadding + 'px');
	    },
	
	    /**
	     * Adjust cell title section height when label breaks to two lines
	     */
	    adjustAddressCellTitleSection: function adjustAddressCellTitleSection() {
	      var aHrefHeight = $('.address-cell > .style-check > a').length > 0 ? $('.address-cell > .style-check > a:last').height() : 0;
	      var pHeight = $('.address-cell > .style-check > p').length > 0 ? $('.address-cell > .style-check > p:last').height() : 0;
	      var higher = aHrefHeight > pHeight ? aHrefHeight : pHeight;
	      var cellHeight = $('.address-cell > .style-check').height();
	      if (cellHeight < CAddressBook.DEFAULT_ADDRESS_CELL_TITLE_HEIGHT) {
	        cellHeight = CAddressBook.DEFAULT_ADDRESS_CELL_TITLE_HEIGHT;
	      }
	      var finalHeight = higher > cellHeight ? higher : cellHeight;
	      finalHeight = finalHeight + parseInt($('.address-cell > .style-check').css('padding-top')) + parseInt($('.address-cell > .style-check').css('padding-bottom'));
	      $('.address-cell > .style-check').map(function () {
	        $(this).innerHeight(finalHeight);
	      });
	    },
	
	
	    /**
	     * Adjust cell matrix element's size
	     * @param alignClass - class of elements which will be processed
	     */
	    addjustCells: function addjustCells(alignClass) {
	      if (this.getColumnNumber() > 1) {
	        // 4 rows maximum
	        COSTCO.util.adjustDivHeights(alignClass + '-0', CAddressBook.DEFAULT_ADDRESS_CELL_HEIGHT);
	        COSTCO.util.adjustDivHeights(alignClass + '-1', CAddressBook.DEFAULT_ADDRESS_CELL_HEIGHT);
	        COSTCO.util.adjustDivHeights(alignClass + '-2', CAddressBook.DEFAULT_ADDRESS_CELL_HEIGHT);
	        COSTCO.util.adjustDivHeights(alignClass + '-3', CAddressBook.DEFAULT_ADDRESS_CELL_HEIGHT);;
	      }
	      this.adjustAddressCellTitleSection();
	      this.adjustAddButtonHeight();
	    },
	
	    init: function init() {
	      // Case where user is timed out from address page and clicks back in browser tab without logging in. This reloads the page so that the user relands on the logon page rather than the auth address page.
	      if (window.performance && window.performance.getEntriesByType("navigation")[0].type === 'back_forward' && !$.cookie('hashedUserId')) {
	        window.location.reload(true);
	      }
	
	      // this.currentPage = 1;
	      this.setActiveAddressType();
	      this.bindEvents();
	      if (COSTCO.util.isBusinessDelivery()) {
	        COSTCO.CAddressForm.initiatePopovers();
	      }
	
	      if (document.readyState == 'complete') {
	        this.initializeAddresses();
	      } else {
	        $(window).on('load', function () {
	          COSTCO.CAddressBook.initializeAddresses();
	        });
	      }
	      COSTCO.CAddressBook.addressbookTabAriaExpandedSwitch();
	      COSTCO.CAddressBook.analytics();
	    },
	
	    initializeAddresses: function initializeAddresses(addressType) {
	      COSTCO.util.resetAddressLoadState();
	      COSTCO.util.getAddressBatch(COSTCO.CAddressBook.ADDRESS_TYPE_SHIPPING, 'ALL', 'RECENT', '1', '100000', function (data) {
	        COSTCO.CAddressBook.validateShippingAddressPhoneNumber(data.addresses);
	        COSTCO.util.getAddressBatch(COSTCO.CAddressBook.ADDRESS_TYPE_BILLING, 'ALL', 'RECENT', '1', '100000', function (data) {
	          COSTCO.CAddressBook.populate(data);
	        });
	      });
	    },
	
	    populate: function populate(data) {
	
	      COSTCO.CAddressBook.createNewAddressButton('add-new-address-btn-box');
	      COSTCO.CAddressBook.populateAddressSection('addresses-list-box', 1);
	    },
	
	    /**
	     * Events binding for address section elements
	     */
	    bindEvents: function bindEvents() {
	      $('#billingTab a').click(function () {
	        COSTCO.CAddressBook.activeTab = CAddressBook.ADDRESS_TYPE_BILLING;
	        $('#shippingTab').removeClass('active');
	        $('#billingTab').addClass('active');
	        COSTCO.CAddressBook.populateAddressSection('addresses-list-box');
	      });
	      $('#shippingTab a').click(function () {
	        COSTCO.CAddressBook.activeTab = CAddressBook.ADDRESS_TYPE_SHIPPING;
	        $('#shippingTab').addClass('active');
	        $('#billingTab').removeClass('active');
	        COSTCO.CAddressBook.populateAddressSection('addresses-list-box');
	      });
	      $('a[href="#address"]').on('shown.bs.tab', function () {
	        COSTCO.CAddressBook.populateAddressSection('addresses-list-box');
	      });
	
	      // TODO: Try to find more optimal solution!!!!
	      // $(window).resize(function() {
	      //   if ($('#address-book').length) {
	      //     clearTimeout(CAddressBook.resizeTimer);
	      //     CAddressBook.resizeTimer = setTimeout(function() {
	      //       COSTCO.CAddressBook.resizedw();
	      //     }, 100);
	      //   }
	      // });
	      // TODO: Kurt says: Perhaps debouncing this function will work. Essentially
	      // resize gets invoked constantly, this will stop function execution
	      // until N seconds pass.
	      //$(window).resize(COSTCO.util.debounce(
	      //  COSTCO.CAddressBook.resizedw.bind(this), 300)).bind(this);
	
	      $(window).resize(function () {
	        if ($('#address-book').length) {
	          clearTimeout(CAddressBook.resizeTimer);
	          CAddressBook.resizeTimer = setTimeout(function () {
	            COSTCO.CAddressBook.resizedw();
	          }, 100);
	        }
	      });
	    },
	
	    /**
	     * Callback on resize event. Refresh address and paging section.
	     */
	    resizedw: function resizedw() {
	      this.populateAddressSection('addresses-list-box');
	    },
	
	    /**
	     * Returns number of displayed addresses on page depending on screen size
	     * @return entries per page
	     */
	    getEntriesPerPage: function getEntriesPerPage() {
	      if ($('#lg-visible-indicator').css('display') === 'none') {
	        return CAddressBook.ENTRIES_PER_PAGE_NON_LG;
	      } else {
	        return CAddressBook.ENTRIES_PER_PAGE_LG;
	      }
	    },
	
	
	    /**
	     * Returns number of columns in address matrix
	     * @return number of columns
	     */
	    getColumnNumber: function getColumnNumber() {
	      var columnNumber = 1;
	      if ($('#xl-visible-indicator').css('display') != undefined && $('#xl-visible-indicator').css('display') != 'none') {
	        columnNumber = 4;
	      } else if ($('#lg-visible-indicator').css('display') != undefined && $('#lg-visible-indicator').css('display') != 'none') {
	        columnNumber = 3;
	      } else if ($('#md-visible-indicator').css('display') != undefined && $('#md-visible-indicator').css('display') != 'none') {
	        columnNumber = 2;
	      } else {
	        columnNumber = 1;
	      }
	      return columnNumber;
	    },
	
	
	    /**
	     * Sort addresses
	     * @param addresses - addresses list to be sorted
	     * @return sorted addresses list
	     */
	    sort: function sort(addresses) {
	      var sortedAddressList = [];
	
	      var sortType = $('option:selected', $('#sort_by')).val();
	      if (sortType === CAddressBook.ADDRESS_SORT_MOST_RECENT) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var id1 = parseInt(elem1.addressId);
	          var id2 = parseInt(elem2.addressId);
	          return id1 > id2 ? -1 : id1 < id2 ? 1 : 0;
	        });
	      }
	      if (sortType === CAddressBook.ADDRESS_SORT_FIRST_A_Z) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var name1 = elem1.firstName.toLowerCase();
	          var name2 = elem2.firstName.toLowerCase();
	          return name1 < name2 ? -1 : name1 > name2 ? 1 : 0;
	        });
	      }
	      if (sortType === CAddressBook.ADDRESS_SORT_FIRST_Z_A) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var name1 = elem1.firstName.toLowerCase();
	          var name2 = elem2.firstName.toLowerCase();
	          return name1 > name2 ? -1 : name1 < name2 ? 1 : 0;
	        });
	      }
	      if (sortType === CAddressBook.ADDRESS_SORT_LAST_A_Z) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var name1 = elem1.lastName.toLowerCase();
	          var name2 = elem2.lastName.toLowerCase();
	          return name1 < name2 ? -1 : name1 > name2 ? 1 : 0;
	        });
	      }
	      if (sortType === CAddressBook.ADDRESS_SORT_LAST_Z_A) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var name1 = elem1.lastName.toLowerCase();
	          var name2 = elem2.lastName.toLowerCase();
	          return name1 > name2 ? -1 : name1 < name2 ? 1 : 0;
	        });
	      }
	      if (sortType === CAddressBook.ADDRESS_SORT_COMPANY_NAME_A_Z) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var name1 = elem1.company.toLowerCase();
	          var name2 = elem2.company.toLowerCase();
	          return name1 < name2 ? -1 : name1 > name2 ? 1 : 0;
	        });
	      }
	      if (sortType === CAddressBook.ADDRESS_SORT_COMPANY_NAME_Z_A) {
	        sortedAddressList = addresses.sort(function (elem1, elem2) {
	          // Default address need to be always first
	          if (elem1.isPrimary) return -1;
	          if (elem2.isPrimary) return 1;
	          var name1 = elem1.company.toLowerCase();
	          var name2 = elem2.company.toLowerCase();
	          return name1 > name2 ? -1 : name1 < name2 ? 1 : 0;
	        });
	      }
	
	      return sortedAddressList;
	    },
	
	    /**
	     * Populate address range which is currently displayed.
	     * @param start - range bottom index
	     * @param end - range up index
	     * @param numberOfEntries - overall number of addresses of particular ttype( shipping or billing )
	     */
	    populateDisplayedEntriesRange: function populateDisplayedEntriesRange(start, end, numberOfEntries) {
	      $('.results > label').map(function () {
	        $(this).text(addressBoxLabels.addressesRange);
	        $(this).text($(this).text().replace('{0}', start));
	        $(this).text($(this).text().replace('{1}', end));
	        $(this).text($(this).text().replace('{2}', numberOfEntries));
	      });
	    },
	
	    /**
	     * Get addresses for particular page
	     * @param addresses - address list
	     * @param pageNum - number of page to be displayed
	     * @return address list for particular page
	     */
	    getEntriesForPage: function getEntriesForPage(addresses, pageNum) {
	      var addressesPerPage = this.getEntriesPerPage();
	      var totalPagesNum = addresses.length % addressesPerPage == 0 ? parseInt(addresses.length / addressesPerPage) : parseInt(addresses.length / addressesPerPage) + 1;
	      if (pageNum > totalPagesNum) {
	        pageNum = totalPagesNum;
	        this.setCurrentPageNumber(pageNum);
	      }
	      var startIndex = (pageNum - 1) * addressesPerPage;
	      var endIndex = pageNum * addressesPerPage < addresses.length ? pageNum * addressesPerPage - 1 : addresses.length - 1;
	      var resultArr = [];
	      $.each(addresses, function (index, value) {
	        if (startIndex <= index && index <= endIndex) {
	          resultArr.push(value);
	        }
	      });
	      this.populateDisplayedEntriesRange(startIndex + 1, endIndex + 1, addresses.length);
	      return resultArr;
	    },
	
	    /**
	     * Dynamically populate addresses.
	     * @param  - id of block which will contain created content
	     * @param newAddressBtnId - id of section which holds new address button.
	     * @pageNum - page number for display
	     */
	    populateAddressSection: function populateAddressSection(blockId, pageNum) {
	      if (typeof pageNum === 'undefined') {
	        pageNum = this.getCurrentPageNumber();
	      } else {
	        this.setCurrentPageNumber(pageNum);
	      }
	
	      var addresses = this.filterAddressesByType(this.activeTab);
	      if (addresses.length > 0) {
	        $('#sort-section').show();
	        addresses = this.sort(addresses);
	      } else {
	        $('#sort-section').hide();
	      }
	
	      var addressesForDisplay = this.getEntriesForPage(addresses, pageNum);
	
	      this.createAddressesMatrix(blockId, addressesForDisplay);
	      this.addjustCells('.resizable');
	      this.populatePagingSection('search-results', addresses.length);
	      // TODO Kurt says: This is slightly disorienting on desktop resolution
	      if (COSTCO.util.getScreenType() != 'DESKTOP') {
	        this.backToTop();
	      }
	    },
	
	    /**
	     * [description]
	     * @param  {[type]} newAddressBtnId [description]
	     * @return {[type]}                 [description]
	     */
	    createNewAddressButton: function createNewAddressButton(newAddressBtnId) {
	      $('#' + newAddressBtnId).html('');
	      var btnTemplate = COSTCO.util.tmpl('add_new_address_btn_tmpl', {});
	      btnTemplate = $(btnTemplate);
	      $('#' + newAddressBtnId).append(btnTemplate);
	    },
	
	    /**
	     * Create address matrix
	     * @param blockId - id of block which will contain created content
	     * @addressesForDisplay - array of addresses which will be displayed
	     */
	    createAddressesMatrix: function createAddressesMatrix(blockId, addressesForDisplay) {
	      var columnNumber = this.getColumnNumber();
	      $('#' + blockId).html('');
	      $.each(addressesForDisplay, function (index, value) {
	        var template = value.isPrimary ? COSTCO.util.tmpl('address_box_default', value) : COSTCO.util.tmpl('address_box', value);
	        template = $(template);
	        template.find('#address-info-container').addClass('resizable-' + parseInt((index + 1) / columnNumber));
	        // Adjust checkbox style and label text
	        var checkboxElem = template.find('#setDefault_' + value.addressIndex);
	        COSTCO.CAddressBook.setAHrefCellLook($(checkboxElem), !value.isPrimary);
	
	        $('#' + blockId).append(template);
	      });
	    },
	
	    createDefaultShippingAddressErrorDiv: function createDefaultShippingAddressErrorDiv(errorDivId) {
	      var defaultShippingAddress = this.getDefaultAddress(CAddressBook.ADDRESS_TYPE_SHIPPING)[0];
	      var errorDivTemplate = COSTCO.util.tmpl('tmpl_default_address_error', defaultShippingAddress);
	      $('#' + errorDivId).append(errorDivTemplate);
	      $('#' + errorDivId).show();
	    },
	
	    /**
	     * Populate paging section
	     * @param blockId - id of block which will contain created content
	     */
	    populatePagingSection: function populatePagingSection(blockId, addressListSize) {
	      var addressesPerPage = this.getEntriesPerPage();
	      var currentPage = this.getCurrentPageNumber();
	      if (addressListSize > addressesPerPage) {
	        $('#' + blockId).show();
	        var elem = $('#' + blockId + ' div > ul');
	        elem.html('');
	        elem.append('<li class="back"><a id="previous-page" class="body-copy-link" href="javascript:void(0)"><i class="co-arrow-left"></i></a></li>');
	
	        var pagesNum = addressListSize % addressesPerPage == 0 ? parseInt(addressListSize / addressesPerPage) : parseInt(addressListSize / addressesPerPage) + 1;
	        var pagesArray = [];
	        for (i = 1; i <= pagesNum; i++) {
	          pagesArray.push({
	            'containerId': '\'addresses-list-box\'',
	            'pageNum': i
	          });
	        }
	        var pageIndex = currentPage - 1;
	        $.each(pagesArray, function (index, value) {
	          var template = COSTCO.util.tmpl('address_pagination_box', value);
	          template = $(template);
	          var pageBtn = template.find('.btn');
	          if (index == pageIndex) {
	            pageBtn.addClass('btn-primary');
	          } else {
	            pageBtn.removeClass('btn-primary');
	          }
	          elem.append(template);
	        });
	        elem.append('<li class="forward"><a id="next-page" class="body-copy-link" href="javascript:void(0)"><i class="co-arrow-right"></i></a></li>');
	        if (currentPage == 1 || pagesNum == 1) {
	          $('#previous-page').parent().hide();
	        } else {
	          $('#previous-page').parent().show();
	          $('#previous-page').unbind().on('click', function () {
	            COSTCO.CAddressBook.populateAddressSection('addresses-list-box', currentPage - 1);
	          });
	        }
	        if (currentPage == pagesNum || pagesNum == 1) {
	          $('#next-page').parent().hide();
	        } else {
	          $('#next-page').parent().show();
	          $('#next-page').unbind().on('click', function () {
	            COSTCO.CAddressBook.populateAddressSection('addresses-list-box', currentPage + 1);
	          });
	        }
	        //	    		$('.results > label').map(function() {
	        //	    			$(this).show();
	        //	    		});
	      } else {
	        $('#' + blockId).hide();
	        //	    		$('.results > label').map(function() {
	        //	    			$(this).hide();
	        //	    		});
	      }
	    },
	
	    /**
	     * Returns active address type
	     * @return address type string: Shipping or Billing
	     */
	    getActiveAddressType: function getActiveAddressType() {
	      var addressType = $('#shippingTab').hasClass('active') ? CAddressBook.ADDRESS_TYPE_SHIPPING : CAddressBook.ADDRESS_TYPE_BILLING;
	      return addressType;
	    },
	
	    setActiveAddressType: function setActiveAddressType() {
	      if (this.activeTab === CAddressBook.ADDRESS_TYPE_SHIPPING) {
	        $('#billingTab').removeClass('active');
	        $('#shippingTab').addClass('active');
	      } else {
	        $('#shippingTab').removeClass('active');
	        $('#billingTab').addClass('active');
	      }
	    },
	
	    getCurrentPageNumber: function getCurrentPageNumber() {
	      var pageNumber = $('#shippingTab').hasClass('active') ? this.currentShippingPage : this.currentBillingPage;
	      return pageNumber;
	    },
	
	    setCurrentPageNumber: function setCurrentPageNumber(pageNum) {
	      if ($('#shippingTab').hasClass('active')) {
	        this.currentShippingPage = pageNum;
	      } else {
	        this.currentBillingPage = pageNum;
	      }
	    },
	
	    /**
	     * Filters addresses by type: Shipping or Billing
	     * @param address type
	     * @return address list of particular type
	     */
	    filterAddressesByType: function filterAddressesByType(addressType) {
	      var result = [];
	      $.each(COSTCO.util.addresses, function (index, value) {
	        if (value.addressType.trim() === addressType) {
	          var addressObj = {};
	          addressObj.addressIndex = index;
	          addressObj.defaultAddressType = addressType;
	          addressObj.addressId = value.id;
	          addressObj.isPrimary = value.isPrimary === '1';
	          addressObj.company = value.company;
	          addressObj.firstName = value.first;
	          addressObj.lastName = value.last;
	          addressObj.addressLine0 = value.line1;
	          addressObj.addressLine1 = value.line2;
	          addressObj.city = value.city;
	          addressObj.state = value.state;
	          addressObj.postalCode = value.zip;
	          addressObj.phoneNo = value.phone ? value.phone.substring(0, 3) + '-' + value.phone.substring(3, 6) + '-' + value.phone.substring(6) : "";
	          addressObj.email = value.email;
	          addressObj.addressField1 = '';
	          addressObj.userAddressType = value.userAddressType;
	          addressObj.showAddressType = value.showAddressType;
	          addressObj.showAddressTypeEdit = value.showAddressTypeEdit;
	
	          result.push(addressObj);
	        }
	      });
	      return result;
	    },
	
	    /**
	     * Adds new address
	     * @param setDefault - sets newly added address as default one
	     */
	    addNewAddress: function addNewAddress(setDefault) {
	      var addressType = $('#shippingTab').hasClass('active') ? 'S' : 'B';
	      var addressOptions = {};
	      if (setDefault != undefined) {
	        addressOptions.setAsDefaultAddress = setDefault;
	      }
	      this.createNewAddress(addressType, addressOptions);
	    },
	
	    /**
	     * Prepares data for add address modal display
	     * @param {String} addressType	Type of address to create ('S' - shipping, 'B' - billing)
	     * @param addressOptions - address options
	     */
	    createNewAddress: function createNewAddress(addressType, addressOptions) {
	      if (addressOptions == undefined) {
	        addressOptions = {};
	      }
	
	      addressOptions.url = CAddressBook.url.MANAGE_ADDRESS_ADD;
	      addressOptions.tmplFooterText = 'tmpl_rx_add_edit_address_footer';
	      //National delivery UX change to remove Terms and Condition Modal in Address book for BD US
	      if (COSTCO.util.isBusinessDelivery() && addressType === 'S' && !COSTCO.util.isNdEnabled()) {
	        this.termsAndCond(addressType, undefined, 'add', addressOptions);
	      } else {
	        this.openAddressAddModal(addressType, undefined, 'add', addressOptions);
	      }
	    },
	
	    /**
	     * Opens add/edit address modal
	     * If it is edit modal, jQuery validator is triggered immediately
	     * @param {String} addressType			Type of address to create ('S' - shipping, 'B' - billing)
	     * @param {Object} addressObj			If mode 'edit', address object to prepopulate input fields in modal
	     * @param {String} mode					Mode of address modal ('add' - add new address, 'edit' - edit existing address)
	     * @param {String} addressOptions		Various options for address add/edit
	     */
	    openAddressAddModal: function openAddressAddModal(addressType, addressObj, mode, addressOptions) {
	      if (addressOptions.tmplFooterText) {
	        var footerText = COSTCO.util.tmpl(addressOptions.tmplFooterText, {});
	      }
	
	      var openAddress = function openAddress(error) {
	        var _COSTCO$CAddress$base;
	
	        var htmlBody = COSTCO.CAddressForm.createHtml(addressType, addressObj, mode, undefined, undefined, undefined, error);
	        var key = "footerText";
	        var isEditDefaultShippingAddress = false;
	        if (mode == "edit") {
	          if (addressOptions.setAsDefaultAddress) {
	            key = "footerText2";
	            isEditDefaultShippingAddress = true;
	          }
	
	          COSTCO.CAddressForm.validate(addressType, htmlBody, isEditDefaultShippingAddress);
	        }
	
	        COSTCO.CAddress.baseModal(addressType, mode, (_COSTCO$CAddress$base = {
	          body: htmlBody
	        }, _defineProperty(_COSTCO$CAddress$base, key, footerText), _defineProperty(_COSTCO$CAddress$base, 'primary_event', function primary_event() {
	          if (COSTCO.CAddressForm.validate(addressType)) {
	            addressOptions.addressBookReinit = true;
	            COSTCO.CAddressForm.submit(addressType, false, addressOptions);
	          }
	        }), _defineProperty(_COSTCO$CAddress$base, 'onshown', function onshown() {
	
	          if (addressOptions.setAsDefaultAddress) {
	            $('#set-default').val('true');
	            $('#set-default').attr('checked', true);
	          } else {
	            $('#set-default').val('false');
	            $('#set-default').attr('checked', false);
	          }
	
	          if ($('input[name=invalid-ship-addr]').length > 0 && $('input[name=invalid-ship-addr]').val() === 'true') {
	            var formId = $('#address-modal-modal');
	            var addressField = '#address1Id';
	            COSTCO.dialog.sameAddressValidation(formId, addressField);
	          }
	          COSTCO.CAddressForm.updateAddressModal();
	        }), _COSTCO$CAddress$base));
	      };
	
	      openAddress(undefined);
	
	      $('body').unbind('costco.address.error').bind('costco.address.error', function (event, error) {
	        openAddress(error);
	      });
	
	      $('.country-select').on('change', function () {
	        var stateProvList = COSTCO.CAddressForm.addressVal;
	        var country = $('.country-select').val();
	        var stateOptions = COSTCO.CAddressForm.getStateOptions(stateProvList, addressType, { country: country });
	        $('.stateprov-select').empty().append(stateOptions);
	        $('#postalId').val('');
	        $('#cityId').val('');
	
	        if ($('.country-select').val() === 'US') {
	          $('[name=postal]').unmask().mask('00000-0000');
	          COSTCO.CAddressBook.updateCountryLabels(country);
	        } else if ($('.country-select').val() === 'CA') {
	          $('[name=postal]').unmask().mask('S0S 0S0');
	          COSTCO.CAddressBook.updateCountryLabels(country);
	        }
	      });
	
	      if (mode === 'add' && $('#address-same-as-ship').length > 0 && this.getActiveAddressType() === CAddressBook.ADDRESS_TYPE_BILLING) {
	        $('#address-same-as-ship').removeClass('hide');
	      }
	
	      if ($('#rx-email-address').length > 0) {
	        $('#emailId').val($('#rx-email-address').html().trim());
	      }
	      var legendTypeName = 'legendBillingText';
	      if (addressType == 'S') {
	        legendTypeName = 'legendShippingText';
	      }
	      $('#address-modal-modal fieldset legend').text($("input[name=" + legendTypeName + "]:hidden").val());
	    },
	
	    updateCountryLabels: function updateCountryLabels(country) {
	      var $form = COSTCO.CAddressForm.getForm();
	      var $postal = $form.find('label[for="postalId"]');
	      var $state = $form.find('label[for="stateId"]');
	      if (country == 'US') {
	        $postal.html(messages.RWD_US_ZIP_LABEL);
	        $state.html(messages.RWD_US_STATE_LABEL);
	      } else {
	        $postal.html(messages.RWD_CA_ZIP_LABEL);
	        $state.html(messages.RWD_CA_STATE_LABEL);
	      }
	    },
	
	    /**
	     * Prepares data for edit address modal display
	     * @param {String} addressType	Type of address to edit ('S' - shipping, 'B' - billing)
	     * @param {Object} obj 					Address object to be edited
	     */
	    editAddress: function editAddress(obj) {
	      var addressType = $('#shippingTab').hasClass('active') ? 'S' : 'B';
	      var addressJson = COSTCO.CAddress.getAddressJson(obj)[0];
	      var validateAddressTypeModal = [];
	      data = addressJson;
	      var addressOptions = {};
	      addressOptions.url = CAddressBook.url.MANAGE_ADDRESS_UPDATE;
	      addressOptions.tmplFooterText = 'tmpl_rx_add_edit_address_footer';
	      if (data.userAddressType != 'U') {
	        validateAddressTypeModal[3] = data.userAddressType;
	      }
	      if (addressJson.isPrimary && addressJson.isPrimary === '1') {
	        addressOptions.setAsDefaultAddress = addressJson.isPrimary;
	        addressOptions.tmplFooterText = 'tmpl_add_edit_address_footer';
	      }
	      if (addressType === 'B') {
	        addressOptions.tmplFooterText = 'tmpl_add_edit_billing_address_footer';
	      }
	      addressOptions.validateParams = validateAddressTypeModal;
	      //National delivery UX change to remove Terms and Condition Modal in Address book for BD US
	      if (COSTCO.util.isBusinessDelivery() && addressType === 'S') {
	        if (COSTCO.util.isNdEnabled()) {
	          COSTCO.CAddressBook.openAddressAddModal(addressType, data, 'edit', addressOptions);
	        } else {
	          this.termsAndCond(addressType, data, 'edit', addressOptions);
	        }
	      } else {
	        CAddressBook.openEditAddressModal(addressType, data, addressOptions);
	      }
	    },
	
	    openEditAddressModal: function openEditAddressModal(addressType, data, addressOptions) {
	      if (data.addressType === 'S' && data.isPrimary === '1') {
	        COSTCO.dialog.createExtDialogBox({
	          title: messages.JS_CHANGE_DEFAULT_ADDRESS_TITLE,
	          body: $('#tmpl_default_address_info_dialog').html(),
	          primary: messages.JS_DIALOG_ACCEPT,
	          primary_event: function primary_event() {
	            CAddressBook.openAddressAddModal(addressType, data, 'edit', addressOptions);
	            $('#costcoModal').modal('hide');
	          },
	          secondary: messages.JS_DIALOG_CANCEL
	        });
	      } else {
	        CAddressBook.openAddressAddModal(addressType, data, 'edit', addressOptions);
	      }
	    },
	
	    /**
	     * Sets address to be default
	     * @param {String} addressId 		Address id to be set as default
	     */
	    setDefault: function setDefault(addressId, onDoneCallback) {
	
	      if (typeof onDoneCallback === 'undefined') {
	        onDoneCallback = function onDoneCallback() {
	          COSTCO.CAddressBook.init();
	        };
	      }
	      COSTCO.Checkout.ajax_update_state({
	        url: CAddressBook.url.MANAGE_ADDRESS_SET_DEFAULT,
	        method: 'POST',
	        dataType: 'json',
	        data: {
	          authToken: COSTCO.Checkout.getAuthToken(),
	          mode: 'SET_DEFAULT',
	          formdata: encodeURIComponent(JSON.stringify({
	            'id': addressId
	          }))
	        },
	        done: onDoneCallback
	      });
	    },
	
	    /**
	     * Removes address
	     * @param {String} addressId - Address id to be removed
	     */
	    remove: function remove(addressId) {
	      COSTCO.Checkout.ajax_update_state({
	        url: CAddressBook.url.MANAGE_ADDRESS_REMOVE,
	        method: 'POST',
	        dataType: 'json',
	        data: {
	          authToken: COSTCO.Checkout.getAuthToken(),
	          mode: 'DELETE',
	          formdata: encodeURIComponent(JSON.stringify({
	            'id': addressId
	          }))
	        },
	        done: function done() {
	          COSTCO.CAddressBook.init();
	        }
	      });
	    },
	
	    /**
	     * Opens default address confirmation modal and executes appropriate action
	     * @param addressId - address id
	     * @param element - html element which is going to be updated
	     */
	    setDefaultAddress: function setDefaultAddress(addressId, element) {
	      if ($('#shippingTab').hasClass('active') && CAddressBook.getDefaultAddress(CAddressBook.ADDRESS_TYPE_SHIPPING).length > 0 && !COSTCO.util.isBusinessDelivery()) {
	        COSTCO.dialog.createExtDialogBox({
	          title: messages.JS_CHANGE_DEFAULT_ADDRESS_TITLE,
	          body: $('#tmpl_default_address_info_dialog').html(),
	          primary: messages.JS_DIALOG_ACCEPT,
	          primary_event: function primary_event() {
	            CAddressBook.setDefault(addressId);
	            $('#costcoModal').modal('hide');
	          },
	          secondary: messages.JS_DIALOG_CANCEL
	        });
	      } else {
	        CAddressBook.setDefault(addressId);
	      }
	    },
	
	    /**
	     * Opens remove confirmation modal
	     * @param addressId - id of address for removal
	     */
	    removeAddress: function removeAddress(addressId) {
	      COSTCO.dialog.createExtDialogBox({
	        title: addressBoxLabels.removeAddressTitle,
	        body: $('#tmpl_remove_address_info_dialog').html(),
	        primary: addressBoxLabels.removeLink,
	        primary_event: function primary_event() {
	          CAddressBook.remove(addressId);
	          $('#costcoModal').modal('hide');
	        },
	        secondary: messages.JS_DIALOG_CANCEL,
	        onshown: function onshown() {
	          COSTCO.CAddressForm.updateAddressModal();
	        }
	      });
	    },
	
	    setAHrefCellLook: function setAHrefCellLook(element, toDefault) {
	      var parentDiv = element.parent().closest('div');
	      var aElem = void 0;
	      if (toDefault) {
	        aElem = parentDiv.find('a').attr('id', $(element).attr('id'));
	      } else {
	        aElem = parentDiv.find('p');
	      }
	
	      var linkText = $('#shippingTab').hasClass('active') ? toDefault ? addressBoxLabels.setShippingAddress : addressBoxLabels.defaultShippingAddress : toDefault ? addressBoxLabels.setBillingAddress : addressBoxLabels.defaultBillingAddress;
	      aElem.html(linkText);
	    },
	
	    /**
	     * Returns default address of particular address type.
	     * @return default address
	     */
	    getDefaultAddress: function getDefaultAddress(addressType) {
	      var defaultAddress = [];
	      $.each(CAddressBook.filterAddressesByType(addressType), function (index, value) {
	        if (value.isPrimary) {
	          defaultAddress.push(value);
	        }
	      });
	      return defaultAddress;
	    },
	
	    /**
	     * Function which populates new billing address fields with
	     * default shipping address data.
	     * @param input
	     */
	    handleBillingSameAsShipping: function handleBillingSameAsShipping(input) {
	      if (input.checked) {
	        var defaultShippingAddress = this.getDefaultAddress(CAddressBook.ADDRESS_TYPE_SHIPPING);
	        if (defaultShippingAddress.length > 0) {
	          COSTCO.util.getAddressBatchPage('S', 'FIRSTNAME', 'ASC', '1', '96', function (data) {
	            data = COSTCO.CAddress.getAddressJson(defaultShippingAddress[0].addressId)[0];
	
	            if (data != null) {
	              delete data['id'];
	              delete data['nickname'];
	              // delete data['isPrimary'];
	              COSTCO.CAddressForm.populateAddressModal($(input.form), data, 'modal');
	            }
	          });
	        }
	      } else {
	        COSTCO.CAddressForm.populateAddressModal($(input.form), '', 'modal');
	      }
	    },
	
	    backToTop: function backToTop() {
	      document.body.scrollTop = 0; // For Chrome, Safari and Opera
	      document.documentElement.scrollTop = 0; // For IE and Firefox
	    },
	    /**
	    * This function is used for showing the  and condition in cased of BD
	    * shipping address
	    */
	    termsAndCond: function termsAndCond(addressType, addressObj, mode, addressOptions) {
	
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.BD_DELIVERY_ADDRESS_TERMS,
	        body: $('#tmpl_delivery_warning').html(),
	        primary: messages.JS_DIALOG_AGREE,
	        primary_event: function primary_event() {
	          COSTCO.CAddressBook.openAddressAddModal(addressType, addressObj, mode, addressOptions);
	        },
	        secondary: messages.JS_DIALOG_CANCEL
	      });
	    },
	    /**
	     * This method shows the Address type popup for change link in Address Book
	     * Calls the 'AjaxManageAddressCmd' to save user selected Address type to DB
	    */
	    addUserSelectionFromAddressBook: function addUserSelectionFromAddressBook(addressId) {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.SET_ADDRESS_TYPE,
	        body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
	        primary: messages.SET_ADDRESS_TYPE,
	        popover: true,
	        primary_event: function primary_event() {
	          if (document.querySelector('input[name="addrtype"]:checked') == null) {
	            $('.addresstype-setup-notification').removeClass("hidden");
	            $('.addresstype-setup-notification').find("div").html(messages.ERR_ADDRESS_TYPE_NOT_SELECTED);
	          } else {
	            userAddressType = document.querySelector('input[name="addrtype"]:checked').value;
	            onDoneCallback = function onDoneCallback() {
	              COSTCO.CAddressBook.init();
	            };
	            COSTCO.Checkout.ajax_update_state({
	              url: CAddressBook.url.MANAGE_ADDRESSTYPE_UPDATE,
	              method: 'POST',
	              dataType: 'json',
	              data: {
	                authToken: COSTCO.Checkout.getAuthToken(),
	                mode: 'SET_ADDRESSTYPE',
	                formdata: encodeURIComponent(JSON.stringify({
	                  'id': addressId, 'userAddressType': userAddressType
	                }))
	              },
	              done: onDoneCallback
	            });
	            COSTCO.dialog.close();
	          }
	        }
	      });
	      $('.close').addClass("hidden");
	    },
	
	    addressbookTabAriaExpandedSwitch: function addressbookTabAriaExpandedSwitch() {
	      $('.costco-tabs-alternate .table-cell .active').find('a').attr('aria-expanded', 'true');
	
	      $('.costco-tabs-alternate .table-cell a').on('click', function (e) {
	        if ($('#shippingTab').attr('class').includes('active')) {
	          $('#shippingTab').find('a').attr('aria-selected', 'true');
	          $('#billingTab').find('a').attr('aria-selected', 'false');
	        } else {
	          $('#shippingTab').find('a').attr('aria-selected', 'false');
	          $('#billingTab').find('a').attr('aria-selected', 'true');
	        }
	      });
	    },
	    //Checks to see if the default shipping address has a valid phone number and email address
	    //Prompts the user to verify default shipping address if there is a problem with either 
	    validateShippingAddressPhoneNumber: function validateShippingAddressPhoneNumber() {
	      var PHONE_NUMBER_REGEX = new RegExp("^\\(?([2-9]{1}[0-9]{2})\\)?[-.\\s]?([0-9]{3})[-.\\s]?([0-9]{4})$");
	      var defaultShippingAddress = this.getDefaultAddress(CAddressBook.ADDRESS_TYPE_SHIPPING);
	      if (defaultShippingAddress.length > 0) {
	        var hasValidPhoneNumber = PHONE_NUMBER_REGEX.test(defaultShippingAddress[0].phoneNo.substring(0, 12));
	        var hasEmail = Boolean(defaultShippingAddress[0].email);
	        if (!hasValidPhoneNumber || !hasEmail) {
	          COSTCO.CAddressBook.createDefaultShippingAddressErrorDiv('invalidAddressError');
	        }
	      }
	    },
	
	    analytics: function analytics() {
	      var addressBookPage = document.getElementById("address-book");
	      if (typeof addressBookPage != 'undefined' && addressBookPage != null) {
	        window.digitalData = window.digitalData || {};
	        digitalData.pageName = "My Account | Address Book";
	        digitalData.pageType = "My Account";
	      }
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.CAddressBook = CAddressBook;
	  return CAddressBook;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title utility.js: Global sub-module - combination of utility1.js and utility2.js
	 * @description A collection of functions used
	 * application wide. This module should contain
	 * generic utility code. No module specifics.
	 * 
	 * 07/27/2022
	 * utility.js was split into two files, utility1.js and utility2.js
	 * utility2.js contains fucntions that are not invoked on Home, Browse 
	 * and Product pages. Rest of the functions are in utility1.js
	 * 
	 * Only utility1.js is imported into new global module called global.hbp.js for Home, Browser & Product (HBP) pages
	 * Rest of the site will continue to load existing global.module.js which will inlcude both utility1.js and utility2.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = function (util1, util2) {
	    var util = Object.assign({}, util1, util2);
	    if (typeof window.COSTCO == 'undefined') {
	        window.COSTCO = new Object();
	    }
	    window.COSTCO.util = util;
	    return util;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title utility1.js: Global sub-module
	 * @description A collection of functions used
	 * application wide. This module should contain
	 * generic utility code. No module specifics.
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var util = {
	    POSTAL_CODE_REGEX_US: /^(\d{5}(-\d{4})?$)$/,
	    POSTAL_CODE_REGEX_CA: /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/,
	    ATLEAST_ONE_ALPHABET: /^(?=.*[A-Za-z\u00C0-\u017F]).+/,
	    CC_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\&\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	    /**
	     * John Resig's micro-templating function
	     * @param  {[string]} str  String ID of template
	     * @param  {[object]} data Object representing dynamic values
	     * @return {[string]}      HTML representation as
	     * a string
	     */
	    tmpl: function tmpl(str, data) {
	      var fn = !/\W/.test(str) ? this.tmpl(document.getElementById(str).innerHTML) : new Function('obj', 'var p=[],print=function(){p.push.apply(p,arguments);};' + 'with(obj){p.push(\'' + str.replace(/[\r\t\n]/g, ' ').split('<&').join('\t').replace(/((^|&>)[^\t]*)'/g, '$1\r').replace(/\t=(.*?)&>/g, '\',$1,\'').split('\t').join('\');').split('&>').join('p.push(\'').split('\r').join('\\\'') + '\');}return p.join(\'\');');
	      return data ? fn(data) : fn;
	    },
	    /**
	     * http://kenwheeler.github.io/slick/
	     * Generalized intialization of carousel.
	     * [carousel description]
	     * @param  {[string]} id        [description]
	     * @param  {[object]} options   [description]
	     * @param  {[object]} settings  [description]
	     * @return {[void]}             [description]
	     */
	    carousel: function carousel(id, options, settings) {
	      options = options || {};
	      $slider = $(id);
	      if (settings && settings.initFn) {
	        $slider.on('init', settings.initFn);
	      }
	      // Initialize the carousel. Waits for the application style sheet
	      // to load before initializing to ensure we have the correct
	      // CSS attributes attached to DOM elements
	      if (window.stylesLoaded) {
	        COSTCO.util.initCarousel($slider, options, settings);
	      } else {
	        document.addEventListener('styles-loaded', function initCarouselEvent() {
	          this.util.initCarousel(this.slider, options, settings);
	        }.bind({
	          util: COSTCO.util,
	          slider: $slider
	        }), false);
	      }
	    },
	
	    /**
	     * Initializes the carousel and does any additional bindings and/or
	     * settings.
	     * @param  {[type]} $slider  [description]
	     * @param  {[type]} options  [description]
	     * @param  {[type]} settings [description]
	     * @return {void}
	     */
	    initCarousel: function initCarousel($slider, options, settings) {
	      $slider.slick(options);
	      if (settings && settings.hasPause) {
	        // append a pause button
	        $slider.find('.slick-dots').append('<li class="pause"><button class="playToggle" role="button" type="button" aria-label="' + messages.PAUSE + '"></button></li>');
	        $slider.find('.pause button').unbind().on('click', function () {
	          // define slider to pause/play as the closest parent of the play/pause button
	          // cannot use $slider as by the time the page is initialized $slider points to a different carousel
	          var mySlider = $(this).closest('.slick-slider');
	          $(this).toggleClass('active');
	          if ($(this).hasClass('active')) {
	            mySlider.slick('slickPause');
	            $(this).attr('aria-label', messages.PLAY);
	          } else {
	            mySlider.slick('slickPlay');
	            $(this).attr('aria-label', messages.PAUSE);
	          }
	        });
	      }
	
	      if (options && options.arrows) {
	        // Update the aria label on the arrows
	        $slider.find('.slick-next').attr('aria-label', settings != undefined && settings.nextLabel != undefined ? settings.nextLabel : messages.NEXT_SLIDE);
	        $slider.find('.slick-prev').attr('aria-label', settings != undefined && settings.prevLabel != undefined ? settings.prevLabel : messages.PREV_SLIDE);
	      }
	
	      // put descriptive text for carousel dot buttons for ADA
	      $slider.each(function () {
	        $(this).find('li button[data-role=none]').each(function (index) {
	          $(this).text('slide set ' + (index + 1));
	        });
	        $(this).find('li').removeAttr('aria-hidden');
	      });
	
	      // Are there any events beforeChange/afterChange we are binding?
	      if (settings && settings.beforeFn) {
	        $slider.on('beforeChange', settings.beforeFn);
	      }
	      if (settings && settings.afterFn) {
	        $slider.on('afterChange', settings.afterFn);
	      }
	      if (settings && settings.destroyFn) {
	        $slider.on('destroy', settings.destroyFn);
	      }
	    },
	    setStyleRule: function setStyleRule(selector, rule) {
	      var stylesheet = document.styleSheets[document.styleSheets.length - 1];
	      COSTCO.util.safe(function () {
	        for (var i in document.styleSheets) {
	          if (document.styleSheets[i].href && document.styleSheets[i].href.indexOf('rwd') >= 0) {
	            stylesheet = document.styleSheets[i];
	            break;
	          }
	        }
	      })();
	      if (stylesheet.addRule) {
	        stylesheet.addRule(selector, rule);
	      } else if (stylesheet.insertRule) {
	        stylesheet.insertRule(selector + ' { ' + rule + ' }', stylesheet.cssRules.length);
	      }
	    },
	    /**
	     * Function decorator that wraps a provided function in a try/catch
	     * to mitigate breaking JS execution. Returns a new function which
	     * must be called.
	     * @param {[function]} fn
	     * @param {[string]} signature
	     * @return {[function]}
	     */
	    safe: function safe(fn, signature) {
	      return function util_safe() {
	        try {
	          fn.apply(this, arguments);
	        } catch (e) {
	          console.error(e, 'at ' + signature);
	        }
	      };
	    },
	    /**
	     * Function used to call bing to obtain location data based on query value
	     *
	     * Param
	     * 	  postalCode -> postalCode that we want to get the city or state for
	     * 	  sucessCallback -> function to be fired after the sucess of the ajax request
	     *
	     */
	    callBing: function callBing(postalCode, successCallback, errorCallback) {
	
	      var globalBingStaticKeyVar = $('#globalBingStaticKey').val();
	      var geocodeRequest = 'https://dev.virtualearth.net/REST/v1/Locations?postalCode=' + postalCode + '&includeNeighborhood=true&include=ciso2&maxResults=5&key=' + globalBingStaticKeyVar;
	
	      $.ajax({
	        url: geocodeRequest,
	        dataType: 'jsonp',
	        jsonp: 'jsonp',
	        error: function error(XMLHttpRequest, textStatus, errorThrown) {
	          console.log('error getting City / State' + postalCode);
	          if (errorCallback) errorCallback(XMLHttpRequest, textStatus, errorThrown);
	        },
	        success: function success(data, textstatus, XMLHttpRequest) {
	          console.log('BING - Success retrieving location');
	          successCallback(data, textstatus, XMLHttpRequest);
	        }
	      });
	    },
	
	    /**
	     * Calls the GeocodeAPI to obtain location data based on the provided postal code.
	     *
	     * @param {string} postalCode - The postal for which to get city/state data.
	     * @param {function} successCallback - The function to be called on successful AJAX request.
	     * @param {function} errorCallback - The function to be called if the AJAX request fails.
	     */
	    callGeocodeAPI: function callGeocodeAPI(postalCode, successCallback, errorCallback) {
	      var country = 'USA';
	      if (COSTCO.util.isCAStore() || COSTCO.util.isCABDStore()) {
	        country = 'CAN';
	        postalCode = postalCode.toUpperCase();
	      }
	
	      var geocodeRequestUrl = $('#geocodeServiceEndpoint').val() + '?q=' + postalCode + '&country=' + country;
	
	      var deriveCityStateFromZipCodeEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === 'true';
	      var allowedCityTypes = deriveCityStateFromZipCodeEnabled ? ['A', 'D'] : ['D'];
	
	      errorCallback = errorCallback || successCallback;
	      var handleError = function handleError() {
	        console.log('Error getting City/State for ' + postalCode);
	        var errData = [{ invalidZip: true }];
	        errorCallback(errData);
	      };
	
	      $.ajax({
	        url: geocodeRequestUrl,
	        dataType: 'json',
	        error: function error(jqXHR, textStatus, errorThrown) {
	          if (textStatus === 'error') {
	            handleError();
	          }
	        },
	        success: function success(data, textStatus, jqXHR) {
	          var filteredElements = data && data.length > 0 ? data.filter(function (element) {
	            return allowedCityTypes.includes(element.cityType);
	          }) : [];
	          if (filteredElements.length) {
	            console.log('GeocodeAPI - Success retrieving location');
	            successCallback(filteredElements, textStatus, jqXHR);
	          } else {
	            handleError();
	          }
	        }
	      });
	    },
	
	    /**
	     * BD only: calls Bing Location service and updates WC_BD_LOC cookie as pipe-separated City|ST|CC value.
	     * @param {string} zipCode
	     * @returns {object} Deferred
	     */
	    callBingAndUpdateBDLocationCookie: function callBingAndUpdateBDLocationCookie(zipCode) {
	      var deferred = $.Deferred();
	      var updateCookie = function updateCookie(data) {
	        if (data && data.resourceSets && data.resourceSets[0] && data.resourceSets[0].estimatedTotal > 0) {
	          var city = '' + data.resourceSets[0].resources[0].address.locality;
	          var state = '' + data.resourceSets[0].resources[0].address.adminDistrict;
	          var countryCode = '' + data.resourceSets[0].resources[0].address.countryRegionIso2;
	          var locationCookie = encodeURI(city.trim() + '|' + state.trim() + '|' + countryCode.trim());
	          var expiration = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
	          document.cookie = 'WC_BD_LOC=' + locationCookie + '; expires=' + expiration + '; path=/';
	          deferred.resolve(data);
	        } else {
	          document.cookie = 'WC_BD_LOC=; expires=' + new Date(0) + '; path=/';
	          console.log('BING - No location for ZIP/postal code: ' + zipCode + ', location cookie deleted.');
	          deferred.resolve(data);
	        }
	      };
	      COSTCO.util.callBing(zipCode, updateCookie);
	      return deferred.promise();
	    },
	    /**
	     * BD only: calls Geocode API service and updates WC_BD_LOC cookie as pipe-separated City|ST|CC value.
	     * @param {string} zipCode
	     * @returns {object} Deferred
	     */
	    callGeocodeApiAndUpdateBDLocationCookie: function callGeocodeApiAndUpdateBDLocationCookie(zipCode) {
	      var deferred = $.Deferred();
	      var updateCookie = function updateCookie(data) {
	        var totalResponses = data.length;
	        if (totalResponses != 0) {
	          var city = '' + data[0].city;
	          var state = '' + data[0].stateProvinceAbbreviation;
	          var countryCode = '' + data[0].country === "USA" ? "US" : "CA";
	          var locationCookie = encodeURI(city.trim() + '|' + state.trim() + '|' + countryCode.trim());
	          var expiration = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
	          document.cookie = 'WC_BD_LOC=' + locationCookie + '; expires=' + expiration + '; path=/';
	          COSTCO.util.setInSession("finalZipcode", data[0].postalCode);
	          deferred.resolve(data);
	        } else {
	          document.cookie = 'WC_BD_LOC=; expires=' + new Date(0) + '; path=/';
	          console.log('Geocode API - No location for ZIP/postal code: ' + zipCode + ', location cookie deleted.');
	          deferred.resolve(data);
	        }
	      };
	      COSTCO.util.callGeocodeAPI(zipCode, updateCookie);
	      return deferred.promise();
	    },
	    /**
	     * Calls bing and updates zip/state/city cookies
	     * @retrns jquery Deferred object
	     */
	    callBingAndUpdateCookies: function callBingAndUpdateCookies(zipcode) {
	
	      var deferred = $.Deferred();
	
	      var updateCookieValues = function updateCookieValues(data) {
	        var totalResponses = data.resourceSets[0].estimatedTotal;
	        if (totalResponses != 0) {
	          var province = null;
	          var country = null;
	          var city = data.resourceSets[0].resources[0].address.locality;
	          try {
	            //Check out if country is Puerto Rico specific
	            country = data.resourceSets[0].resources[0].address.countryRegionIso2;
	            if (country != undefined && country === 'PR') {
	              province = data.resourceSets[0].resources[0].address.countryRegionIso2;
	              country = 'US';
	            } else {
	              province = data.resourceSets[0].resources[0].address.adminDistrict;
	            }
	          } catch (e) {
	            province = "";
	          }
	          $.cookie("invCheckPostalCode", zipcode);
	          $.cookie("invCheckStateCode", province);
	          $.cookie("invCheckCity", city);
	          deferred.resolve(data);
	        } else {
	          deferred.reject();
	        }
	      };
	
	      COSTCO.util.callBing(zipcode, updateCookieValues);
	
	      return deferred.promise();
	    },
	    /**
	     * Calls GeocodeAPI and updates zip/state/city cookies
	     * @retrns jquery Deferred object
	     */
	    callGeocodeAPIAndUpdateCookies: function callGeocodeAPIAndUpdateCookies(zipcode) {
	
	      var deferred = $.Deferred();
	
	      var updateCookieValues = function updateCookieValues(data) {
	        var province = null;
	        var country = null;
	        var city = null;
	        var totalResponses = data.length;
	        if (totalResponses != 0) {
	          try {
	            city = data[0].city;
	            province = data[0].stateProvinceAbbreviation;
	            if (province == null) {
	              province = data[0].stateProvince;
	            }
	            country = data[0].country;
	          } catch (e) {
	            console.error('Error: ' + e.message);
	          }
	
	          //SFSTRY0035043 don't update header zip on multishipping page
	          if (typeof checkoutPage == 'undefined' || checkoutPage !== 'multi-shipping') {
	            $.cookie("invCheckPostalCode", zipcode);
	            $.cookie("invCheckStateCode", province);
	            $.cookie("invCheckCity", city);
	          }
	
	          deferred.resolve(data);
	        } else {
	          deferred.reject();
	        }
	      };
	
	      COSTCO.util.callGeocodeAPI(zipcode, updateCookieValues);
	
	      return deferred.promise();
	    },
	
	    hover_click_popover: function hover_click_popover(selector, _content, trigger, placement) {
	      var hoverClickElement = $(selector);
	      hoverClickElement.attr({
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false'
	      });
	      hoverClickElement.popover({
	        html: true,
	        sanitize: false,
	        animation: false,
	        delay: {
	          show: 400,
	          hide: 400
	        },
	        content: function content() {
	          return $(_content).html();
	        },
	        container: selector,
	        placement: placement || 'bottom',
	        trigger: trigger || 'hover click'
	      }).on('keydown', function (e) {
	        if (e.which == 13) {
	          if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
	            e.preventDefault();
	            $(this).popover('show');
	          }
	        }
	      }).on('mouseleave focusout', '.popover', {
	        selector: selector,
	        content: _content,
	        placement: placement || 'bottom'
	      }, this.popoverLeave)
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        if (('#warehouse-locations' == selector || '#warehouse-locations-t' == selector) && $.cookie('WC_BD_ZIP') != null) {
	          $('#warehouse-search-field').val($.cookie('WC_BD_ZIP').replace('+', ' '));
	        }
	        $(this).attr('aria-expanded', 'true');
	
	        // used to create ada required attributes on popover
	        var identifierSrting = $(selector)[0].id;
	        $(this).find('.popover-content').attr('id', identifierSrting + '-id');
	        // Add tabindex of -1 to the content to prevent a safari bug where the relatedTarget
	        // is not populated when no tabindex is specified this caused all a and input
	        // to not function on click event
	        $(this).find('.popover-content').attr('tabindex', '-1');
	        // New requirement to focus on the first visible input on popover shown
	        var firstInput = $(this).find('a,input[type!=hidden]')[0];
	        $(this).removeAttr('aria-describedby');
	        $(this).find('.popover-content').removeAttr('aria-label');
	        $(this).find('.popover').removeAttr('role');
	        if (firstInput) $(firstInput).focus();
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      })
	      // stry0123297 - issue with IE with user having to double-click on text boxes in pop-overs
	      // solution to trigger the focus on text boxes on mousedown event
	      .on('mousedown', 'input[type=search], input[type=text]', function () {
	        $(this).trigger('focus');
	      });
	    },
	    click_popover: function click_popover(selector, _content2, trigger, placement) {
	      var ClickElement = $(selector);
	      ClickElement.attr({
	        'aria-expanded': 'false'
	      });
	      ClickElement.popover({
	        html: true,
	        sanitize: false,
	        animation: false,
	        delay: {
	          show: 400,
	          hide: 400
	        },
	        content: function content() {
	          return $(_content2).html();
	        },
	        container: selector,
	        placement: placement || 'bottom',
	        trigger: trigger || 'click'
	      }).on('keydown', function (e) {
	        if (e.which == 13) {
	          if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
	            e.preventDefault();
	            $(this).popover('show');
	          }
	        }
	      }).on('click focusout', '.popover', {
	        selector: selector,
	        content: _content2,
	        placement: placement || 'bottom'
	      }, this.clickpopoverLeave)
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        if (('#warehouse-locations' == selector || '#warehouse-locations-t' == selector) && $.cookie('WC_BD_ZIP') != null) {
	          $('#warehouse-search-field').val($.cookie('WC_BD_ZIP').replace('+', ' '));
	        }
	        $(this).attr('aria-expanded', 'true');
	
	        if (_content2 === '#ca-grocery-delivery-postal-code-popover') {
	          $(this).find('#postal-code-input').val($('.user-entered-zip:first').text());
	        }
	
	        $('#delivery-postal-change,  #set-delivery-zipcode').removeAttr('aria-describedby');
	        $('#delivery-postal-change,  #set-delivery-zipcode').find('.popover').removeAttr('role');
	
	        // used to create ada required attributes on popover
	        var identifierSrting = $(selector)[0].id;
	        $(this).find('.popover-content').attr('id', identifierSrting + '-id');
	        // Add tabindex of -1 to the content to prevent a safari bug where the relatedTarget
	        // is not populated when no tabindex is specified this caused all a and input
	        // to not function on click event
	        $(this).find('.popover-content').attr('tabindex', '-1');
	        $(this).find('.popover-content').removeAttr('aria-label');
	        // New requirement to focus on the first visible input on popover shown
	        var firstInput = $(this).find('a,input[type!=hidden]')[0];
	        if (firstInput) $(firstInput).focus();
	        var firstBDInput = $(this).find('div > input[type!=hidden]')[0];
	        setTimeout(function () {
	          if (firstBDInput) {
	            $(firstBDInput).focus();
	          }
	        }, 100);
	        $('#postal-code-input-grocery').on('focusout', function () {
	          var content = $('#postal-code-input-grocery').val();
	          if (content !== undefined && content != '') {
	            $('#postal-code-input-grocery-label').addClass('active');
	          }
	        });
	        var nameOfCategoryInput = $('#delivery-postal-code-popover-container').parent().parent().parent().attr('id');
	        $('#delivery-postal-form').append('<input type="hidden" name="category-grocery-delivery" value="' + nameOfCategoryInput + '">');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      })
	      // stry0123297 - issue with IE with user having to double-click on text boxes in pop-overs
	      // solution to trigger the focus on text boxes on mousedown event
	      .on('mousedown', 'input[type=search], input[type=text]', function () {
	        $(this).trigger('focus');
	      });
	    },
	    hover_click_popover_nav: function hover_click_popover_nav(selector, _content3, trigger) {
	      var hoverClickElement = $(selector);
	      hoverClickElement.attr({
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false'
	      });
	      hoverClickElement.popover({
	        html: true,
	        animation: false,
	        delay: {
	          show: 400,
	          hide: 400
	        },
	        content: function content() {
	          return $(_content3).html();
	        },
	        container: selector,
	        placement: 'bottom',
	        trigger: trigger || 'hover click'
	      }).on('keydown', function (e) {
	        if (e.which == 13) {
	          if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
	            e.preventDefault();
	            $(this).popover('show');
	          }
	        }
	      }).on('mouseleave focusout', '.popover', {
	        selector: selector,
	        content: _content3
	      }, this.popoverLeave)
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	        $(this).find('.popover').addClass('top50pixels');
	        $(this).find('.popover-content').attr('role', 'region');
	        // used to create ada attributes on popover
	        var identifierSrting = $(selector)[0].id;
	        $(this).find('.popover-content').attr('id', identifierSrting + '_id');
	        $(this).find('.popover-content').attr('aria-label', identifierSrting + '_label');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	    },
	    /*
	     * Function used to handle closing the pop-over based on which element is receiving focus
	     * If it is not a child element of the pop-over the pop-over will close
	     */
	    popoverLeave: function popoverLeave(event) {
	      var eventType = event.type;
	      var isInput = $(event.target).is('input');
	      // relatedTarget of a focusout event is the element which is receiving focus.
	      var relatedTargetIsContained = $(event.data.selector).get(0) == event.relatedTarget || $.contains($(event.data.selector).get(0), event.relatedTarget);
	      // the first condition is to stop popover from closing if the user tries to select from the browser autocomplete box
	      // the second condition is to keep popover open if focus stays within the popover.
	      if (eventType == 'mouseleave' && !isInput || eventType == 'focusout' && event.target && !relatedTargetIsContained) {
	        if (eventType == 'mouseleave' && COSTCO.Header.checkIsZipSetByAkamai() && COSTCO.zipCodeModal) {
	          // If ZIP code is set by Akamai, force-submit on popover leave
	          COSTCO.zipCodeModal.forceSubmitZipCode();
	        } else {
	          $(event.data.selector).popover('destroy');
	          COSTCO.util.hover_click_popover(event.data.selector, event.data.content, undefined, event.data.placement);
	        }
	      }
	    },
	    clickpopoverLeave: function clickpopoverLeave(event) {
	      event.stopPropagation();
	      var eventType = event.type;
	      var isInput = $(event.target).is('input');
	      // relatedTarget of a focusout event is the element which is receiving focus.
	      var relatedTargetIsContained = $(event.data.selector).get(0) == event.relatedTarget || $.contains($(event.data.selector).get(0), event.relatedTarget);
	      // the first condition is to stop popover from closing if the user tries to select from the browser autocomplete box
	      // the second condition is to keep popover open if focus stays within the popover.
	      if (eventType == 'click' && !isInput && isInput.length === 0 || eventType == 'focusout' && event.target && !relatedTargetIsContained) {
	        if (eventType == 'mouseleave' && COSTCO.Header.checkIsZipSetByAkamai() && COSTCO.zipCodeModal) {
	          // If ZIP code is set by Akamai, force-submit on popover leave
	          COSTCO.zipCodeModal.forceSubmitZipCode();
	        } else {
	          setTimeout(function () {
	            $(event.data.selector).popover('destroy');
	            COSTCO.util.click_popover(event.data.selector, event.data.content, undefined, event.data.placement);
	          }, 100);
	        }
	      }
	    },
	    /*
	     * Function used to get whether or not the element is within the last or first
	     * link within the target level container
	     *
	     * If the need arise we can actually return the decimal position of the element
	     * by looping through the array not exactly needed here
	     *
	     * If the element is the first function will return 0
	     * If the element is the last function will return 1
	     * If other -1
	     */
	    get_element_position: function get_element_position(element, searchCriteria) {
	      var containerDivLinkArr = $(searchCriteria);
	      if (containerDivLinkArr.first()[0] == element) return 0;
	      if (containerDivLinkArr.last()[0] == element) return 1;
	      return -1;
	    },
	    /**
	     * This function makes icons in social networks popover content tabbable for ADA purposes
	     * @param {string} selector - the element which contains a social networks popover
	     * @return {void}
	     */
	    socialNetworksPopover: function socialNetworksPopover(selector) {
	      var popoverElement = $('.' + selector);
	      var popoverContent = $(".social-popover-container").html();
	      popoverElement.attr({
	        'data-content': popoverContent,
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false',
	        'tabindex': 0,
	        'role': 'tooltip'
	      });
	      popoverElement.popover({ sanitize: false }).on('keydown', function (event) {
	        //Enter event keycode
	        if (event.which === 13) {
	          $(this).popover('toggle');
	          //Esc event keycode
	        } else if (event.which === 27) {
	          $(this).popover('hide');
	          //Shift+Tab event keycode
	        } else if (event.shiftKey && event.keyCode === 9) {
	          $(this).popover('hide');
	        }
	      }).on('focus', function () {
	        $(this).popover('toggle');
	        var tooltipElement = $(this);
	        var lastIconArr = document.getElementsByClassName('last-icon');
	        var popoverContentId = $(this).attr('aria-describedby');
	        $.each(lastIconArr, function (index, value) {
	          if (popoverContentId !== undefined && $(lastIconArr[index]).length !== 0) {
	            $(lastIconArr[index]).on('blur', function () {
	              tooltipElement.popover('hide');
	            });
	          }
	        });
	        var contentElements = $('body').find('.social-popover');
	        contentElements.find('img').each(function () {
	          $(this).on('keypress', function () {
	            this.onclick();
	          });
	        });
	      }).on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	      $(':not(.' + selector + ')').on('click', function () {
	        $('.co-help').each(function () {
	          if ($(this).attr('aria-expanded') === 'true') {
	            $(this).popover('hide');
	          }
	        });
	      });
	    },
	
	    /**
	     * Function used to simply show/hide popover capability to add accesibility features
	     * function popover parameters are expected to be defined in the element as normal bootsrap popover
	     *  hover and focus been triggered using data-trigger functionality. 
	     */
	    swatch_accesible_popover: function swatch_accesible_popover(selector) {
	      var popoverElement = $(selector);
	      popoverElement.attr({
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false',
	        'tabindex': 0,
	        'role': 'tooltip'
	      });
	      popoverElement.popover().on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	    },
	    signupFormValidation: function signupFormValidation(element) {
	      $(element).validate({
	        rules: {
	          emailSignUp: {
	            required: true,
	            email: true
	          }
	        },
	        messages: {
	          emailSignUp: messages.ERR_INVALID_EMAIL
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          var p = element.parent('div');
	          error.addClass('emailSignUp');
	          p.after(error);
	        }
	      });
	
	      if ($(element).valid()) {
	        if ($('input[name="emailSignUpFeatureV2"]').val() === 'true') {
	          COSTCO.util.emailSignUpV2Submit('footer');
	        } else {
	          util.emailSubmit(element);
	        }
	      }
	
	      return false;
	    },
	    getMemberCookie: function getMemberCookie() {
	      var isSignedIn = void 0,
	          isMember = false,
	          isValidated = false,
	          isVerified = false,
	          isActive = false,
	          usage = '',
	          membershipNumber = '';
	      var m = $.cookie('wcMember'),
	          h = $.cookie('hashedUserId'),
	          p = $.cookie('rrDisabledPref'),
	          r = $.cookie('rrStoreFlag');
	      if (h != null && h == '""' || h == null && p == null && r == null || h == null && (p != null && p == '""' || r != null && r == '""')) {
	        isSignedIn = false;
	      } else if (h != null && h == '' || h == null && p == null && r == null || h == null && (p != null && p == '' || r != null && r == '')) {
	        isSignedIn = false;
	      } else if (h != null & h != '""' || h == null && p != null && p != '""' && r != null && r != '""') {
	        isSignedIn = true;
	      } else {
	        isSignedIn = 'undefined';
	      }
	      if (m != null && m != 'undefined') {
	        var cArray = m.split(',');
	        if (cArray.length > 1) {
	          if (cArray[1] == '1') {
	            isMember = true;
	          }
	          if (typeof cArray[3] !== 'undefined') {
	            usage = cArray[3];
	          }
	          if (cArray[4] == '1') {
	            isValidated = true;
	          }
	          if (cArray[5] == '1') {
	            isVerified = true;
	          }
	          if (cArray[6] == 'E0002') {
	            isActive = true;
	          }
	          if (typeof cArray[8] !== 'undefined') {
	            membershipNumber = cArray[8];
	          }
	        }
	      } else {
	        isMember = 'undefined';
	      }
	      return {
	        signedIn: isSignedIn,
	        costcoMember: isMember,
	        validated: isValidated,
	        verified: isVerified,
	        active: isActive,
	        usage: usage,
	        membershipNumber: membershipNumber
	      };
	    },
	    /**
	     * This function checks if the user has signed in
	     */
	    isUserSignedIn: function isUserSignedIn() {
	      return this.getMemberCookie().signedIn === "true";
	    },
	    checkSsoLogin: function checkSsoLogin(aTag) {
	      aTag.href += aTag.href.indexOf("?") < 0 ? "?redirectLogin=" + COSTCO.util.isUserLoggedIn() : "&redirectLogin=" + COSTCO.util.isUserLoggedIn();
	    },
	    disbleElementById: function disbleElementById(id) {
	      $("#" + id).hide();
	    },
	    checkAndDisableSignInButton: function checkAndDisableSignInButton() {
	      if (this.isUserLoggedIn()) this.disbleElementById("bd-specific-sign-in-button");
	    },
	
	    /**
	     * This function checks if the user has valid membership
	     */
	    isCostcoMember: function isCostcoMember() {
	      return this.getMemberCookie().costcoMember != 'undefined' ? userInfo.costcoMember : false;
	    },
	    /**
	     * sets a cookie with given name, value, expiration and domain
	     *
	     * @param  {[string]} cookieName - The name of the cookie to set
	     * @param  {[string]} cookieValue - The value for the cookie to set
	     * @param  {[int]} cookieExpires - The number of days until the cookie expires
	     * @parm   {[string]} cookieDomain - The domain of the cookie to set
	     * @return {void}
	     */
	    setCookie: function setCookie(cookieName, cookieVal, cookieExpires, cookieDomain) {
	      cookieExpires = parseInt(cookieExpires);
	      if (typeof cookieDomain !== 'undefined') {
	        $.cookie(cookieName, cookieVal, {
	          expires: cookieExpires,
	          path: '/',
	          domain: cookieDomain
	        });
	      } else {
	        $.cookie(cookieName, cookieVal, {
	          expires: cookieExpires,
	          path: '/'
	        });
	      }
	    },
	
	    /**
	     * Gets the language id of the users's session. default is -1(English)
	     * for US and -24(English) for CA
	     * @return {[int]} the langId
	     */
	    getLangId: function getLangId() {
	      var selectedLang = $.cookie(cookies.SELECTED_LANG_COOKIE);
	      var host = window.location.host;
	      var cookieDomain = wcs.domain;
	      if (host.indexOf('bd-cmc.vqa') > -1 || host.indexOf('bd-cmc.vuat') > -1 || host.indexOf('bd-cmc.ecom') > -1) {
	        cookieDomain = '.costco.com';
	      }
	      if (typeof selectedLang == 'undefined' || !selectedLang) {
	        if (wcs.hasOwnProperty('langId')) {
	          COSTCO.util.setCookie(cookies.SELECTED_LANG_COOKIE, wcs.langId, cookies.SELECTED_LANG_EXPIRES, cookieDomain);
	          return parseInt(wcs.langId);
	        } else {
	          // check for stgbrowse costco domains
	          if (host.indexOf('stgbrowseca') > -1 || host.indexOf('stgbrowse-ca') > -1 || host.indexOf('ca-cmc') > -1 || host.indexOf('ca-stage') > -1) {
	            return -24;
	          }
	          if (host.indexOf('.com') > -1) {
	            return -1; // Default .com lang
	          } else {
	            COSTCO.util.setCookie(cookies.SELECTED_LANG_COOKIE, "-24", cookies.SELECTED_LANG_EXPIRES, cookieDomain);
	            return -24; // Default .ca lang
	          }
	        }
	      } else {
	        // The selectedLanguage cookie exists and the selectedLanguageOld cookie does not exist. 
	        this.registerLanguageListener();
	      }
	      return selectedLang;
	    },
	    /**
	     * Get the warehouse number for the user's session - used mainly for image templates
	     */
	    getWarehouseNumber: function getWarehouseNumber() {
	      var langId = this.getLangId();
	      if (langId < -1) {
	        return 894;
	      } else {
	        return 847;
	      }
	    },
	    /**
	     * Gets the string value of the user's region. Default is null.
	     * @return {[string]} the string value of SELECTED_REGION_COOKIE
	     */
	    getRegion: function getRegion() {
	      var selectedRegion = $.cookie(cookies.SELECTED_REGION_COOKIE);
	      if (typeof selectedRegion == 'undefined' || !selectedRegion) {
	        selectedRegion = null;
	      }
	      return selectedRegion;
	    },
	    getScreenType: function getScreenType() {
	      var width = $(window).width();
	      if (width >= 1025) return 'DESKTOP';
	      if (width >= 769) return 'TABLET-LANDSCAPE';
	      if (width >= 668) return 'TABLET-PORTRAIT';
	      if (width >= 376) return 'PHONE-LANDSCAPE';
	      return 'PHONE-PORTRAIT';
	    },
	    is_touch_device: function is_touch_device() {
	      return 'ontouchstart' in window // works on most browsers
	      || navigator.maxTouchPoints; // works on IE10/11 and Surface
	    },
	    buildEmailSignUpV2Req: function buildEmailSignUpV2Req(sel) {
	      var userEmail = '';
	      var userMemberNum = '';
	      var userWhNum = '';
	      var userLangPref = '';
	      var userSite = '';
	      var dataSource = '';
	
	      var zipCookieKey = 'invCheckPostalCode';
	      if (COSTCO.util.isBDStore()) {
	        zipCookieKey = 'WC_BD_ZIP';
	      }
	      var rawZip = COSTCO.util.getCookieByName(zipCookieKey) || '';
	      var userZip = decodeURIComponent(rawZip);
	
	      if (COSTCO.util.isBDStore()) {
	        userWhNum = COSTCO.util.getCookieByName('WC_BD_WHS') || '';
	      } else {
	        var prefWhDetails = localStorage.getItem('preferredWarehouse');
	        var pWhDetailsJSON = prefWhDetails ? JSON.parse(prefWhDetails) : {};
	        userWhNum = pWhDetailsJSON.warehouseId || '';
	      }
	
	      var signUpForm = $('form[id="signup_form"]');
	      var emailOffersForm = $('form[id="EmailOffersForm"]');
	
	      if (sel === 'page' && signUpForm.length > 0) {
	        dataSource = 'Signup page';
	        userEmail = signUpForm.find('input[name="email"]').val().trim() || '';
	        userMemberNum = signUpForm.find('input[name="custom_membernumber"]').val().trim() || '';
	
	        if (COSTCO.util.isUSStore()) {
	          userWhNum = signUpForm.find('select[name="custom_local_whse_number"]').val() || '';
	        } else if (COSTCO.util.isCAStore()) {
	          userWhNum = signUpForm.find('select[name="custom_warehouse_number"]').val() || '';
	        }
	
	        if (COSTCO.util.isUSBDStore()) {
	          userZip = signUpForm.find('input[name="zip"]').val().trim() || '';
	        } else if (COSTCO.util.isCABDStore()) {
	          userZip = signUpForm.find('input[name="custom_postalcode"]').val().trim() || '';
	        }
	      } else if (sel === 'footer' && emailOffersForm.length > 0) {
	        dataSource = 'Footer Signup';
	        userEmail = emailOffersForm.find('input[name="emailSignUp"]').val().trim() || '';
	
	        var wcMember = COSTCO.util.getCookieByName('wcMember');
	        if (wcMember !== null && typeof wcMember !== 'undefined') {
	          var cArray = wcMember.split(',');
	          if (cArray.length > 1) {
	            if (typeof cArray[8] !== 'undefined') {
	              membershipNumber = cArray[8];
	            }
	          }
	        }
	      }
	
	      var enCheck = signUpForm.find('input[name="slid_1"][id="en"]:not([type="hidden"])');
	      var frCheck = signUpForm.find('input[name="slid_1"][id="fr"]:not([type="hidden"])');
	      if (enCheck.length > 0 && enCheck.prop('checked')) {
	        userLangPref = 'EN';
	      } else if (frCheck.length > 0 && frCheck.prop('checked')) {
	        userLangPref = 'FR';
	      } else {
	        userLangPref = COSTCO.util.getLocale().slice(0, 2).toUpperCase();
	      }
	
	      if (COSTCO.util.isUSStore()) {
	        userSite = 'USBC';
	      } else if (COSTCO.util.isCAStore()) {
	        userSite = 'CABC';
	      } else if (COSTCO.util.isUSBDStore()) {
	        userSite = 'USBD';
	      } else if (COSTCO.util.isCABDStore()) {
	        userSite = 'CABD';
	      } else {
	        userSite = 'USBC';
	      }
	
	      var reqBody = {
	        'emailAddress': userEmail,
	        'memberNumber': userMemberNum,
	        'warehouse': userWhNum,
	        'languagePref': userLangPref,
	        'zip': userZip,
	        'site': userSite,
	        'dataSource': dataSource
	      };
	
	      return reqBody;
	    },
	    emailSignUpV2Submit: function emailSignUpV2Submit(sel) {
	      var emailSignUpV2URL = $('input[name="emailSignUpV2URL"]').val();
	      var emailSignUpV2ClientId = $('input[name="emailSignUpV2ClientId"]').val();
	
	      var requestBody = COSTCO.util.buildEmailSignUpV2Req(sel);
	
	      if (!requestBody.emailAddress || !requestBody.emailAddress.trim()) {
	        return;
	      }
	
	      var requestOptions = {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	          'client-identifier': emailSignUpV2ClientId
	        },
	        body: JSON.stringify(requestBody)
	      };
	
	      fetch(emailSignUpV2URL, requestOptions).then(function (response) {
	        if (!response.ok) throw new Error(response.status);
	        return response.json();
	      }).then(function (data) {
	        if (sel === 'footer') {
	          var successP = '<p class=\'success emailSignUp\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
	          $('form[id="EmailOffersForm"]').after(successP);
	          $('form[id="EmailOffersForm"]').addClass('hide');
	        }
	      }).catch(function (error) {
	        return console.error(error);
	      });
	    },
	    emailSubmit: function emailSubmit(form) {
	      var locale = COSTCO.util.getLocale();
	      var isWhatCountsEnabled = $("input[name='whatCountsEventsFeatureFlagFooter']").val();
	      var isAdobeEnabled = $("input[name='adobePreferencesFeatureFlagFooter']").val();
	      if (isAdobeEnabled == 'true') {
	        if (locale != 'en-US') {
	          var url = form.action;
	          document.location.href = url;
	        } else {
	          var data = {
	            memberNumber: '',
	            emailAddress: $('#footer-email-offers').val().trim(),
	            listSource: 'Footer SignUp'
	          };
	          COSTCO.AdobeEvents.sendEmailSubscriptionEvent($("input[name='adobeSubscribeEndpointFooter']").val(), contextVariables, data);
	        }
	      }
	      if (isWhatCountsEnabled == 'true' || isWhatCountsEnabled === '1') {
	        if (locale != 'en-US') {
	          var _url = form.action;
	          document.location.href = _url;
	        } else {
	          $.ajax({
	            type: 'POST',
	            url: form.action,
	            data: 'emailSignUp=' + form['emailSignUp'].value,
	            success: function success() {
	              $(form).find('input[type=text]').each(function () {
	                $(this).val('');
	              });
	            }
	          });
	        }
	      }
	      var successP = '<p class=\'success emailSignUp\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
	      $(form).after(successP);
	      $(form).addClass('hide');
	      return false;
	    },
	
	    emailSubscribeForm: function emailSubscribeForm(element) {
	      $.validator.addMethod('countryspecificpostalcodePassCountrySelectorModal', function (value, element) {
	        return !(COSTCO.util.getLangId() == -1) ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
	      }, messages.ERR_ENTER_ZIPCODE);
	      $.validator.addMethod('email', function (value, element) {
	        return (/^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/.test(value.toLowerCase())
	        );
	      }, messages.JS_VALID_EMAIL);
	      $(element).validate({
	        rules: {
	          emailAddress: {
	            required: true,
	            email: true
	          },
	          deliveryZipCode: {
	            required: true,
	            countryspecificpostalcodePassCountrySelectorModal: true
	          }
	        },
	        messages: {
	          emailAddress: messages.ERR_INVALID_EMAIL,
	          deliveryZipCode: messages.ERR_ENTER_ZIPCODE
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          if (element.attr('name') == 'emailAddress') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=emailAddress]'));
	          } else if (element.attr('name') == 'deliveryZipCode') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=deliveryZipCode]'));
	          } else {
	            error.insertAfter(element);
	          }
	        }
	      });
	      if ($(element).valid()) {
	        util.emailSubscribeSubmit(element);
	      }
	      return false;
	    },
	
	    emailSubscribeSubmit: function emailSubscribeSubmit(form) {
	      $.ajax({
	        type: 'POST',
	        url: form.action,
	        data: 'emailAddress=' + form['emailAddress'].value + '&deliveryZipCode=' + form['deliveryZipCode'].value + '&newLocation=' + form['newLocation'].value,
	        success: function success() {
	          $(form).find('input[type=text]').each(function () {
	            $(this).val('');
	          });
	        }
	      });
	      var successP = '<p class=\'success emailAddress\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
	      $(form).after(successP);
	      $(form).addClass('hide');
	      return false;
	    },
	
	    emailTruckloadSubscribeForm: function emailTruckloadSubscribeForm(element) {
	      var errorElement = null; // Variable to store the first error element
	      $.validator.addMethod('email', function (value, element) {
	        return this.optional(element) || /^.+@(([^.])+\.)+([^.])+$/i.test(value);
	      }, messages.ERR_INVALID_EMAIL);
	      $.validator.addMethod('costcoMembership', function (value, element) {
	        return this.optional(element) || /^\d{12,16}$/.test(value);
	      }, messages.ERR_INVALID_MEMBERSHIP_NO_BD);
	      $(element).validate({
	        rules: {
	          userName: { required: true },
	          membershipNo: { required: true, costcoMembership: true },
	          emailAddress: { required: true, email: true }
	        },
	        messages: {
	          userName: messages.ERR_USERNAME_REQUIRED,
	          membershipNo: { required: messages.ERR_MEMBERSHIP_NUMBER_REQUIRED, costcoMembership: messages.ERR_INVALID_MEMBERSHIP },
	          emailAddress: { required: messages.ERR_REQUIRED_EMAIL_MY, email: messages.ERR_INVALID_EMAIL }
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          if (!errorElement) {
	            // Store the first error element
	            errorElement = element;
	          } else if (element.attr('name') == 'userName') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=userName]'));
	          } else if (element.attr('name') == 'membershipNo') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=membershipNo]'));
	          } else if (element.attr('name') == 'emailAddress') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=emailAddress]'));
	          } else {
	            error.insertAfter(element);
	          }
	        }
	      });
	      if ($(element).valid()) {
	        util.emailTruckloadSubscribeSubmit(element);
	      } else {
	        errorElement.focus();
	      }
	      return false;
	    },
	
	    emailTruckloadSubscribeSubmit: function emailTruckloadSubscribeSubmit(form) {
	      event.preventDefault();
	      $.ajax({
	        type: 'POST',
	        url: form.action,
	        data: 'emailAddress=' + form['emailAddress'].value + '&userName=' + form['userName'].value + '&membershipNo=' + form['membershipNo'].value + '&BusinessName=' + form['BusinessName'].value + '&Address1=' + form['Address1'].value + '&Address2=' + form['Address2'].value + '&City=' + form['City'].value + '&State=' + form['State'].value + '&zipcode=' + form['zipcode'].value + '&phonenumber=' + form['phonenumber'].value + '&items=' + form['items'].value,
	        success: function success() {
	          $(form).find('input[type=text]').each(function () {
	            $(this).val('');
	          });
	          $(form).find('input[type=email]').each(function () {
	            $(this).val('');
	          });
	        }
	      });
	      var successP = '<p id="successP" tabindex="0" class=\'success emailAddress\'><i class=\'co-checkmark\'></i>' + " " + messages.MSG_EMAIL_RECEIVED + '.</p>';
	      $(form).before(successP);
	      $(form).addClass('hide');
	      document.getElementById('successP').focus();
	      return false;
	    },
	
	    /**
	     * This function appends an additional panel to an existing accordion using
	     * the accordion_id. The header and body represent the HTML that will display
	     * for this add on.
	     * @param  {[string]} accordion_id - The accordion data structure's id
	     * @param  {[string]} header - String (html) to display as the panel header
	     * @param  {[string]} body - String (html) to display as the panel body
	     * @return {[void]}
	     */
	    accordion_addon: function accordion_addon(accordion_id, header, body, handlers, parent) {
	      var position = $('#' + accordion_id).children().length + 1;
	      var handlerTemplate = void 0;
	      if (typeof handlers == 'undefined') {
	        handlerTemplate = '';
	      } else {
	        handlerTemplate = handlers;
	      }
	      $('#' + accordion_id).append(this.tmpl('tmpl_accordion_addon', {
	        accordion_id: accordion_id,
	        pos: position,
	        header: header,
	        body: body,
	        handlers: handlerTemplate,
	        parent: parent !== 'undefined' ? parent : true
	      }));
	    },
	    /**
	     * Retrieve the value of the 'rememberedShowMemberItem' cookie
	     * used to display member-only pricing without the need to sign in
	     */
	    getRememberedShowMemberItem: function getRememberedShowMemberItem() {
	      var rememberMeCookie = $.cookie('rememberedShowMemberItem');
	      var cookieExists = rememberMeCookie === undefined || rememberMeCookie === null ? false : true;
	      return cookieExists;
	    },
	    /**
	     * If the user is signed in and has a Costco membership number stored,
	     * show the member-only prices else don't.
	     * @return {[void]}
	     */
	    display_member_prices: function display_member_prices() {
	      var member_cookie = this.getMemberCookie(),
	          signed_in = member_cookie.signedIn || false,
	          is_member = member_cookie.costcoMember || false,
	          is_validated = member_cookie.validated || false,
	          is_active = member_cookie.active || false,
	          is_bd = util.isBusinessDelivery();
	      var rememberMe = this.getRememberedShowMemberItem();
	      // This check is added to keep BD flow unaffected by the change in BC flow
	      var display_moi_price = COSTCO.util.isBusinessDelivery() ? signed_in && is_member : signed_in && is_member && is_validated && is_active;
	      if (display_moi_price) {
	        $('.moi,.mapi').show();
	      } else if (signed_in) {
	        $('.mapi').show();
	        $('.moi').hide();
	      } else if (rememberMe) {
	        $('.mapi').hide();
	        $('.moi').show();
	      } else {
	        $('.moi,.mapi').hide();
	        $('.mapi').parent().find('.map-item').removeClass('hide');
	      }
	    },
	
	    /**
	     * If the user is signed in and has a Costco membership number stored,
	     * show the Select Options or Sign in for Price Button
	     * @return {[void]}
	     */
	    display_SelectOrSignInButton: function display_SelectOrSignInButton() {
	      var member_cookie = this.getMemberCookie();
	      $('.product-tile-set').each(function (element, index) {
	        if ($(this).find('.member-only').length > 0) {
	          if (member_cookie.signedIn) {
	            $(this).find('.select-option-button, .see-details-button').removeClass('hide');
	          } else {
	            $(this).find('.sign-in-button').removeClass('hide');
	          }
	        } else if ($(this).find('#mapItem').length > 0 && !member_cookie.signedIn) {
	          $(this).find('.sign-in-button').removeClass('hide');
	        } else {
	          $(this).find('.select-option-button, .see-details-button').removeClass('hide');
	        }
	      });
	    },
	    /**
	     * This is used by inline links to pop the email offers modal. It is
	     * attached to the TopRow_ESpot_4 "Sign Up" link but can be used anywhere
	     * a "get email offers" modal is necessary.
	     * @return {[void]}
	     */
	    get_email_offers: function get_email_offers() {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.RWD_GET_EMAIL_OFFERS,
	        body: this.tmpl('tmpl_email_offers', {}),
	        primary: messages.EMAIL_BUTTON_TITLE,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          !$('#costcoModal p.success').length > 0 ? $('#costcoModal form').submit() : $('#costcoModalBtn2').hide();
	        }
	      });
	    },
	    /**
	     * This function is the entry point for the front-end citi credit card
	     * application process.  The business includes this javascript in an <a onclick/>,
	     * which will initiate the ajax call.  From here, the path can go 2 different ways
	     * 1.  	If the user has authorized users, they are provided with a dialog, allowing
	     * 		them to choose from a list of authorized users, or none at all.
	     * 2.	If the baseUrl is not included an the whitelist, it will show the
	     * 		external link dialog to user, otherwise it will open a new tab to the url.
	     */
	    getBrandFolderVideo: function getBrandFolderVideo(assetKey, folderkey) {
	      var baseUriForBrandfolder = $('#baseUriForBrandfolder' + folderkey).val();
	      var bearerTokenForBrandfolder = $('#bearerTokenForBrandfolder').val();
	      var bfHeaders = {};
	      bfHeaders["Authorization"] = bearerTokenForBrandfolder;
	      fetch(baseUriForBrandfolder + assetKey, {
	        method: "GET",
	        headers: bfHeaders
	      }).then(function (response) {
	        if (response.status >= 200 && response.status <= 299) {
	          return response.json();
	        } else {
	          throw Error(response.statusText);
	        }
	      }).then(function (jsonResponse) {
	        var title = "";
	        try {
	          title = jsonResponse.data[0].attributes.name;
	        } catch (e) {
	          console.log('Title could not be retrieved from BrandFolder');
	        }
	        window.eventBus.publish('popupShow', { asset_key: assetKey, title: title, bfFolderType: folderkey });
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    applyForCostcoCredit: function applyForCostcoCredit(baseUrl, authorizedMemNum) {
	      COSTCO.util.ajaxSend();
	      if (typeof PageAnalyticsInfo !== 'undefined') {
	        var pageType = PageAnalyticsInfo.pageType;
	      }
	      $.ajax({
	        type: 'POST',
	        url: 'https://' + location.hostname + '/ApplyForCostcoCredit',
	        dataType: 'jsonp',
	        data: {
	          'authorizedMemNum': authorizedMemNum,
	          'pageType': pageType
	        },
	        success: function success(parsedDataJson) {
	          // Show dropdown of member numbers to choose
	          if (parsedDataJson.errorCode) {
	            if (parsedDataJson.errorCode == 2510) // session timeout
	              {
	                document.location.href = 'Logoff?URL=ReLogonFormView&storeId=' + wcs.storeId;
	                return;
	              }
	          }
	
	          var data = parsedDataJson.applicationPrepopData;
	          var token = '';
	          var citiRedirectUrl = '';
	          var authorizedMembersJsonArray = [];
	
	          if (data) {
	            token = data.CITI_MEMBERDATA_SIGNED_ENCRYPTED;
	          }
	
	          if (baseUrl && token) {
	            citiRedirectUrl = '' + baseUrl + token;
	          }
	
	          var payloadJson = {
	            'applicationPrepopData': data
	          };
	
	          if (parsedDataJson.authorizedMembers) {
	            authorizedMembersJsonArray = $.parseJSON(parsedDataJson.authorizedMembers);
	          }
	          //TO-DO: hiding authorizedMember selection modal until funitonality is implemented on backend. 
	          // if (authorizedMembersJsonArray != undefined && authorizedMembersJsonArray.length > 0) {
	          //   util.createMemberNumberSelectDialog(baseUrl, payloadJson, authorizedMembersJsonArray);
	          // } else 
	          if (citiRedirectUrl) {
	            util.createCostcoCreditApplyExtPrefillDialog(citiRedirectUrl);
	          } else {
	            util.createCostcoCreditApplyExtPrefillDialog(baseUrl);
	          }
	        },
	        error: function error(x, t, m) {
	          COSTCO.util.LoginTimeout.updateActivity();
	          if (t === 'timeout') {
	            console.log('timout with server');
	          } else {
	            console.log('unexpected error TODO');
	          }
	          console.log('set return codes for caller of this service TODO');
	        },
	        complete: function complete() {
	          COSTCO.util.ajaxComplete();
	        }
	      });
	      return false;
	    },
	    /**
	     * This is the dialog, allowing users to select authorized users for their citi
	     * application.  This function is referenced solely in applyForCostcoCredit().
	     */
	    createMemberNumberSelectDialog: function createMemberNumberSelectDialog(baseUrl, payloadJson, authorizedMembersJsonArray) {
	      var dialogDiv = $(this.tmpl('tmpl_costco_cc_additional_member', {}));
	      dialogDiv.find(':selected').val(payloadJson);
	      var memberSelect = dialogDiv.find('select');
	      for (var i = 0; i < authorizedMembersJsonArray.length; i++) {
	        memberSelect.append($('<option>', {
	          value: {
	            'applicationPrepopData': authorizedMembersJsonArray[i].memberPayload
	          }
	        }).text(authorizedMembersJsonArray[i].name));
	      }
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_AUTHORIZED_USER_TITLE,
	        body: dialogDiv,
	        primary: messages.JS_DIALOG_AUTHORIZED_USER_OK,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          var authorizedMemNum = $('#authorized-member-select').val();
	          COSTCO.util.dynamicExternalFormPost(baseUrl, payloadJson);
	          $('.costcoModalBtn1').first().click();
	        }
	      });
	      return false;
	    },
	    createCostcoCreditApplyExtDialog: function createCostcoCreditApplyExtDialog(baseUrl, payloadJson) {
	      var dialogDiv = $(this.tmpl('tmpl_costco_cc_apply_confirm', {}));
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_LEAVING_SITE_TITLE,
	        body: dialogDiv,
	        primary: messages.JS_DIALOG_AUTHORIZED_USER_OK,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          COSTCO.util.dynamicExternalFormPost(baseUrl, payloadJson);
	          $('.costcoModalBtn1').first().click();
	        }
	      });
	      return false;
	    },
	    /**
	    * External link dialog for Citi application prefill.
	    */
	    createCostcoCreditApplyExtPrefillDialog: function createCostcoCreditApplyExtPrefillDialog(url) {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_EXTERNAL_LINK,
	        body: messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.JS_DIALOG_EXTERNAL_LINK,
	        primary_event: function primary_event() {
	          document.location.href = url;
	          COSTCO.dialog.close();
	        }
	      });
	    },
	    /**
	     * This shows or hides all citi application links based on certain criteria.
	     */
	    showAllCappLinks: function showAllCappLinks(isShow) {
	      if (isShow == undefined || isShow) {
	        $('.citi_credit_app_link').show();
	      } else {
	        $('.citi_credit_app_link').hide();
	      }
	    },
	    /**
	     * This processes the business cases for when users should not be allowed to apply
	     * for citi credit cards.  Links will be hidden, and other text will be shown instead.
	     * For the case where text is shown instead, the business must set this up via CMC.  Please
	     * reference the run documentation provided.
	     */
	    processCappLogic: function processCappLogic() {
	      var capp_json = util.getCappJson();
	      if (capp_json != null) {
	        if (capp_json.coBrandedCreditMax) {
	          // hide all application links
	          util.showAllCappLinks(false);
	        } else if (capp_json.displayErrorForRenew) {
	          // show message and hide all application link
	          $('#displayErrorForRenew').show();
	          util.showAllCappLinks(false);
	        } else if (capp_json.displayErrorForCancel) {
	          // show message and hide all application links
	          $('#displayErrorForCancel').show();
	          util.showAllCappLinks(false);
	        } else if (capp_json.displayErrorForRenewGSHousehold) {
	          // show message and hide all application links
	          $('#displayErrorForRenewGSHousehold').show();
	          util.showAllCappLinks(false);
	        } else {
	          // show credit app links
	          util.showAllCappLinks(true);
	        }
	      } else {
	        // show credit app links
	        util.showAllCappLinks(true);
	      }
	    },
	    /**
	     * Updates the cookie json with the business logic encapsulated in these
	     * attributes.
	     */
	    updateCappJson: function updateCappJson(data) {
	      var capp_json = {};
	      capp_json.coBrandedCreditMax = typeof data !== 'undefined' ? data.coBrandedCreditMax : MembershipMetaData.payload.caller.coBrandedCreditMax;
	      capp_json.displayErrorForRenew = typeof data !== 'undefined' ? data.displayErrorForRenew : MembershipMetaData.payload.caller.displayErrorForRenew;
	      capp_json.displayErrorForCancel = typeof data !== 'undefined' ? data.displayErrorForCancel : MembershipMetaData.payload.caller.displayErrorForCancel;
	      capp_json.displayErrorForRenewGSHousehold = typeof data !== 'undefined' ? data.displayErrorForRenewGSHousehold : MembershipMetaData.payload.caller.displayErrorForRenewGSHousehold;
	      $.cookie('capp_json', JSON.stringify(capp_json), {
	        expires: 30,
	        path: '/'
	      });
	    },
	    /**
	     * Retrieves citi cookie and converts to json.
	     */
	    getCappJson: function getCappJson() {
	      var capp_json = $.cookie('capp_json');
	      if (capp_json != null) {
	        capp_json = JSON.parse(capp_json);
	      }
	      return capp_json;
	    },
	    /**
	     * Create external post form, to be used in a dialog (if on whitelist)
	     * or incorporated into the external link dialog.  dataJson is converted
	     * into hidden inputs to pass in the form. Form opens to new tab.
	     */
	    dynamicExternalFormPost: function dynamicExternalFormPost(url, dataJson) {
	      var dynamicPostForm = $('<form method=\'POST\' action=\'' + url + '\' target=\'_blank\' enctype=\'multipart/form-data\'></form>');
	      for (var key in dataJson) {
	        if (dataJson.hasOwnProperty(key)) {
	          dynamicPostForm.append($('<input type=\'hidden\' name=\'' + key + '\' value=\'' + dataJson[key] + '\'/>'));
	        }
	      }
	      // Pushing the form into the DOM and then submitting, IE complains if not done.
	      $('body').append($('<div id=\'external_link\' style=\'display:hidden\'/>').append(dynamicPostForm.clone()));
	      $('#external_link form').submit();
	      $('#external_link form').remove();
	    },
	    /**
	     * Ajax spinner for send.
	     */
	    ajaxSend: function ajaxSend() {
	      if ($('#dataGlobalSpinner').length == 0) {
	        var spinner = '<div class="ui-widget-overlay ui-front r1_spinner" id="dataGlobalSpinner"></div>';
	        $('body').append(spinner);
	      } else {
	        $('#dataGlobalSpinner').append('<div/>');
	      }
	    },
	    /**
	     * Ajax spinner for completion.  Multiple ajax spinners could be going, so this
	     * will only take one out with each call.
	     */
	    ajaxComplete: function ajaxComplete() {
	      var spinner = $('#dataGlobalSpinner');
	      if (spinner.length > 0 && spinner.children().length == 0) {
	        spinner.remove();
	      } else {
	        $(spinner.children()[0]).remove();
	      }
	    },
	    /**
	     * Login timeout logic incorporated from legacy js that is referenced.
	     */
	    LoginTimeout: {
	      redirectView: '/LogonForm',
	      lastActivity: '',
	      checkTimeout: function checkTimeout() {
	        if (COSTCO.util.LoginTimeout.lastActivity == '') {
	          return;
	        }
	        var now = new Date().getTime();
	        var diff = now - COSTCO.util.LoginTimeout.lastActivity;
	        if (diff > wcs.loginTimeOut) {
	          window.location.href = COSTCO.util.LoginTimeout.redirectView;
	          throw new Error('Stale browser - redirecting');
	        }
	      },
	      updateActivity: function updateActivity() {
	        COSTCO.util.LoginTimeout.lastActivity = new Date().getTime();
	      }
	    },
	    /**
	     * Get a parsed object from localStorage (if localStorage is available).
	     * @param  {[item]} item - the key to pull from localStorage
	     * @return {[object]} storage_item - the object representing the string
	     *  in local storage (or empty object in the case of the item not existing)
	     */
	    getFromStorage: function getFromStorage(item) {
	      var storage_item = {};
	      if (localStorage) {
	        storage_item = localStorage.getItem(item) ? JSON.parse(localStorage.getItem(item)) : {};
	      }
	      return storage_item;
	    },
	    /**
	     * Set a string/object in localStorage for later use (if localStorage is available)
	     * @param {[string]} name - key to reference the value
	     * @param {[string|object]} item - value to store in localStorage
	     */
	    setInStorage: function setInStorage(name, item) {
	      var item = typeof item === 'string' ? item : JSON.stringify(item);
	      if (localStorage) {
	        localStorage.setItem(name, item);
	      }
	    },
	    /**
	     * Get a parsed object from sessionStorage (if sessionStorage is available).
	     * @param  {[item]} item - the key to pull from sessionStorage
	     * @return {[object]} storage_item - the object representing the string
	     *  in session storage (or empty object in the case of the item not existing)
	     */
	    getFromSession: function getFromSession(item) {
	      var storage_item = {};
	      if (sessionStorage) {
	        storage_item = sessionStorage.getItem(item) ? JSON.parse(sessionStorage.getItem(item)) : {};
	      }
	      return storage_item;
	    },
	    /**
	     * Set a string/object in sessionStorage for later use (if sessionStorage
	     * is available)
	     * @param {[string]} name - key to reference the value
	     * @param {[string|object]} item - value to store in sessionStorage
	     */
	    setInSession: function setInSession(name, item) {
	      var item = typeof item === 'string' ? item : JSON.stringify(item);
	      if (sessionStorage) {
	        sessionStorage.setItem(name, item);
	      }
	    },
	    /**
	     * Remove object from sessionStorage (if sessionStorage is available).
	     * @param  {[name]} name - key for item to be removed from sessionStorage
	     * @return none
	     *
	     */
	    removeFromSession: function removeFromSession(name) {
	      if (sessionStorage) {
	        sessionStorage.removeItem(name);
	      }
	    },
	    /**
	     * Shamelessly stolen from stackoverflow. Get the query string by name
	     * @param  {[type]}
	     * @param  {[type]}
	     * @return {[type]}
	     */
	    getParameterByName: function getParameterByName(name, url) {
	      if (!url) url = window.location.href;
	      name = name.replace(/[\[\]]/g, '\\$&');
	      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
	          results = regex.exec(url);
	      if (!results) return null;
	      if (!results[2]) return '';
	      return decodeURIComponent(results[2].replace(/\+/g, ' '));
	    },
	    /**
	     * Shamelessly stolen from stackoverflow. Adds a single parameter to the URL 
	     * @param  {[type]}
	     * @param  {[type]}
	     * @return {[type]}
	     */
	    insertParamInUrl: function insertParamInUrl(key, value) {
	      key = encodeURIComponent(key);
	      value = encodeURIComponent(value);
	      var kvp = document.location.search.substr(1).split('&');
	      var i = 0;
	      for (; i < kvp.length; i++) {
	        if (kvp[i].startsWith(key + '=')) {
	          var pair = kvp[i].split('=');
	          pair[1] = value;
	          kvp[i] = pair.join('=');
	          break;
	        }
	      }
	      if (i >= kvp.length) {
	        kvp[kvp.length] = [key, value].join('=');
	      }
	      var params = kvp.join('&');
	      return params;
	    },
	    /**
	     * Returns an object representing query string parameters.
	     * @return {[object]} The object represeting query strings
	     *                        &isAwesome=true becomes
	     *                        {"isAwesome":"true"}
	     */
	    get_parameters_as_object: function get_parameters_as_object() {
	      return document.location.search.replace(/(^\?)/, '').split('&').map(function (n) {
	        return n = n.split('='), this[n[0]] = n[1], this;
	      }.bind({}))[0];
	    },
	    all: function all(arr, p) {
	      // from haskell's data.list
	      var test = true;
	      arr.forEach(function (x) {
	        if (!p(x)) {
	          test = false;
	          return;
	        }
	      });
	      return test;
	    },
	    /**
	     * Returns True if at least one item in the array fulfills the condition
	     * @param  {[array]}    arr - the array to test
	     * @param  {[function]} p - the predicate function to test against the array
	     * @return {Boolean}
	     */
	    any: function any(arr, p) {
	      var answer = false;
	      for (var i = 0, len = arr.length; i < len; i++) {
	        if (answer) break;
	        if (p(arr[i])) {
	          answer = true;
	          break;
	        }
	      }
	      return answer;
	    },
	    hasElem: function hasElem(elem, array) {
	      var hasit = false;
	      array.forEach(function (e, i) {
	        if (elem === e) hasit = true;
	        return;
	      });
	      return hasit;
	    },
	    localeSpecificCurrency: function localeSpecificCurrency(v, loc, c) {
	      var n = parseFloat(v);
	      if (isNaN(v)) return v;
	      c = typeof c != 'undefined' ? c : 2;
	      switch (loc) {
	        case 'fr':
	          return this.formatCurrency(n, c, ',', ' ') + ' $';
	        default:
	          return '$' + this.formatCurrency(n, c, '.', ',');
	      }
	    },
	    formatCurrency: function formatCurrency(n, c, d, t) {
	      var c = isNaN(c = Math.abs(c)) ? 2 : c,
	          d = d == undefined ? ',' : d,
	          t = t == undefined ? '.' : t,
	          s = n < 0 ? '-' : '',
	          i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + '',
	          j = (j = i.length) > 3 ? j % 3 : 0;
	      return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
	    },
	    formatMoney: function formatMoney(number, has_symbol) {
	      var number = (Math.round(number * 100) / 100).toString(),
	          dollars = number.split('.')[0],
	          cents = (number.split('.')[1] || '') + '00';
	      dollars = dollars.split('').reverse().join('').replace(/(\d{3}(?!$))/g, '$1,').split('').reverse().join(''), symbol = has_symbol ? '$' : '';
	      var locale = COSTCO.util.getLocale();
	      if (locale == 'fr-CA') {
	        return dollars.split(',').join(' ') + ',' + cents.slice(0, 2) + ' ' + symbol;
	      }
	      return symbol + dollars + '.' + cents.slice(0, 2);
	    },
	    formatPhone: function formatPhone(number) {
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
	        return number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
	      } else {
	        return number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
	      }
	    },
	    // public method for encoding
	    encode: function encode(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0,
	          enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = COSTCO.util._utf8_encode(input);
	      while (i < input.length) {
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	        enc1 = chr1 >> 2;
	        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	        enc4 = chr3 & 63;
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	        output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
	      }
	      return output;
	    },
	    // public method for decoding
	    decode: function decode(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0;
	      var enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	      while (i < input.length) {
	        enc1 = this._keyStr.indexOf(input.charAt(i++));
	        enc2 = this._keyStr.indexOf(input.charAt(i++));
	        enc3 = this._keyStr.indexOf(input.charAt(i++));
	        enc4 = this._keyStr.indexOf(input.charAt(i++));
	        chr1 = enc1 << 2 | enc2 >> 4;
	        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	        chr3 = (enc3 & 3) << 6 | enc4;
	        output = output + String.fromCharCode(chr1);
	        if (enc3 != 64) {
	          output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	          output = output + String.fromCharCode(chr3);
	        }
	      }
	      output = COSTCO.util._utf8_decode(output);
	      return output;
	    },
	    // private method for UTF-8 decoding
	    _utf8_decode: function _utf8_decode(utftext) {
	      var string = '';
	      var i = 0;
	      var c = c1 = c2 = 0;
	      while (i < utftext.length) {
	        c = utftext.charCodeAt(i);
	        if (c < 128) {
	          string += String.fromCharCode(c);
	          i++;
	        } else if (c > 191 && c < 224) {
	          c2 = utftext.charCodeAt(i + 1);
	          string += String.fromCharCode((c & 31) << 6 | c2 & 63);
	          i += 2;
	        } else {
	          c2 = utftext.charCodeAt(i + 1);
	          c3 = utftext.charCodeAt(i + 2);
	          string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
	          i += 3;
	        }
	      }
	      return string;
	    },
	    // private method for UTF-8 encoding
	    _utf8_encode: function _utf8_encode(string) {
	      string = string.replace(/\r\n/g, '\n');
	      var utftext = '';
	      for (var n = 0; n < string.length; n++) {
	        var c = string.charCodeAt(n);
	        if (c < 128) {
	          utftext += String.fromCharCode(c);
	        } else if (c > 127 && c < 2048) {
	          utftext += String.fromCharCode(c >> 6 | 192);
	          utftext += String.fromCharCode(c & 63 | 128);
	        } else {
	          utftext += String.fromCharCode(c >> 12 | 224);
	          utftext += String.fromCharCode(c >> 6 & 63 | 128);
	          utftext += String.fromCharCode(c & 63 | 128);
	        }
	      }
	      return utftext;
	    },
	    /**
	     * Hard coded the locales as our current implementation only supports 3
	     * locales. Also application logic can override the default browser
	     * locale
	     */
	    getLocale: function getLocale() {
	      var langId = this.getLangId();
	      if (langId == -1) return 'en-US';
	      if (langId == -24) return 'en-CA';
	      if (langId == -25) return 'fr-CA';
	      return 'en-US';
	    },
	    isSafari: function isSafari() {
	      var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
	      var is_safari = navigator.userAgent.indexOf('Safari') > -1;
	      if (is_chrome && is_safari) {
	        is_safari = false;
	      }
	      return is_safari;
	    },
	    /**
	     * Function once ran will copy the dom to nodes as needed - helps to avoid a server "DOM Bomb", but places that load on the client
	     *
	     * Required to define placement and content params
	     *
	     * Options can be overriden as needed to use different classes depending how the responsive content is setup.
	     */
	    responsivePlacement: function responsivePlacement(options) {
	      var opt = {
	        placement: '',
	        content: '',
	        useInnerContent: true,
	        display: 'block',
	        DESKTOP: '.visible-xl-',
	        TABLETLANDSCAPE: '.visible-lg-',
	        TABLETPORTRAIT: '.visible-md-',
	        PHONELANDSCAPE: '.visible-sm-',
	        PHONEPORTRAIT: '.visible-xs-'
	      };
	      $.extend(opt, options);
	      var node = $(opt.placement + opt.content);
	      if (node.length < 1) {
	        console.log('Missing Content for RespnsivePlacement');
	        return;
	      }
	      var content = '';
	      if (opt.useInnerContent) content = node.html();else {
	        content = node;
	      }
	      if ($(opt.placement).find('[itemprop=name]')) {
	        $(opt.placement).find('[itemprop=name]').removeAttr('itemprop');
	      }
	
	      COSTCO.util.responsiveContent(opt.placement, opt.DESKTOP + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.TABLETLANDSCAPE + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.TABLETPORTRAIT + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.PHONELANDSCAPE + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.PHONEPORTRAIT + opt.display, content);
	      return;
	    },
	    responsiveContent: function responsiveContent(selector, nodeClass, content) {
	      var node = $(selector + nodeClass);
	      if (node.length <= 0) {
	        return;
	      }
	      if (node.html().trim().length <= 0) {
	        node.append(content);
	      }
	      return;
	    },
	    getQueryStringArray: function getQueryStringArray() {
	      var queryString = [];
	      var a = window.location.search.substr(1).split('&'),
	          b = void 0;
	      for (var i = 0; i < a.length; i++) {
	        b = a[i].split('=');
	        queryString[decodeURIComponent(b[0])] = decodeURIComponent(b[1]);
	      }
	      return queryString;
	    },
	    /**
	     * Taken from Underscore.js (http://underscorejs.org/)
	     * Returns a function, that, as long as it continues to be invoked, will not
	     * be triggered. The function will be called after it stops being called for
	     * N milliseconds. If `immediate` is passed, trigger the function on the
	     * leading edge, instead of the trailing.
	     */
	    debounce: function debounce(func, wait, immediate) {
	      var timeout = void 0;
	      return function () {
	        var context = this,
	            args = arguments;
	        clearTimeout(timeout);
	        timeout = setTimeout(function () {
	          timeout = null;
	          if (!immediate) func.apply(context, args);
	        }, wait);
	        if (immediate && !timeout) func.apply(context, args);
	      };
	    },
	    isElementInViewport: function isElementInViewport(el) {
	      if (el.length <= 0) {
	        return false;
	      }
	      var rect = el[0].getBoundingClientRect();
	      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 600 && /* or $(window).height() */rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */;
	    },
	    onVisibilityChange: function onVisibilityChange(el, callback) {
	      return function () {
	        var visible = COSTCO.util.isElementInViewport(el);
	        if (visible == true) {
	          if (typeof callback == 'function') {
	            callback();
	          }
	        }
	      };
	    },
	    /**
	     * Decode an HTML encoded string. Turns stuff like this
	     * '&lt;p&gt;name&lt;/p&gt;&lt;' and converts it to '<p>name</p>'
	     * @param  {String} encodedHtmlString The html string to decode
	     * @return {String}                   The decoded html string.
	     */
	    get_decoded_html: function get_decoded_html(encodedHtmlString) {
	      var textArea = document.createElement('textarea');
	      textArea.innerHTML = encodedHtmlString;
	      return textArea.value;
	    },
	    /**
	     * Inject an arbitrary number of hidden inputs into a given form. Meant
	     * to be a utility to prevent statically adding key/values to $.ajax.
	     * Just use this function and then serialize the form with $.fn.serialize.
	     * Note that this function will only inject an input into a form if the
	     * named input doesn't already exist.
	     * @param  {String} form   The form selector
	     * @param  {Object} inputs The object representing the key/values to
	     *                         be inserted into the form as inputs
	     *                         {key:'value'}
	     * @return {void}
	     */
	    input_injector: function input_injector(form, inputs) {
	      var html = '';
	      Object.keys(inputs).forEach(function (key) {
	        if ($(form + ' input[name=' + key + ']').length == 0) {
	          html += '<input type=\'hidden\' name=\'' + key + '\' value=\'' + inputs[key] + '\'/>';
	        } else if (key === 'prescriptionId' || key === 'isPharmacy') {
	          $(form + ' input[name=' + key + ']').val(inputs[key]);
	        }
	      });
	      $(form).append(html);
	    },
	    iosModalWhiteSpace: function iosModalWhiteSpace(selectorArray) {
	      // hide the native soft keyboards
	      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
	        selectorArray.forEach(function (selector) {
	          var formElements = $(selector + ' input,' + selector + ' select,' + selector + ' textarea');
	          $(formElements).unbind('focus.iosModalWhiteSpace').on('focus.iosModalWhiteSpace', function () {
	            $(selector).css({
	              position: 'absolute'
	            });
	          });
	          $(formElements).unbind('blur.iosModalWhiteSpace').on('blur.iosModalWhiteSpace', function () {
	            $(selector).css({
	              position: 'fixed'
	            });
	            window.scrollTo(0, 0);
	          });
	        });
	      }
	    },
	    /**
	     * This fixes the case where the cursor sits outside of the focused input
	     * on iOS devices. It has the unfortunate side effect of scrolling
	     * to the top of the page when the modal is overlayed.
	     * @return {void}
	     */
	    iosPositionFix: function iosPositionFix() {
	      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
	        var style = $('<style>body.modal-open { position: fixed; }</style>');
	        $('html > head').append(style);
	      }
	    },
	    /**
	     * Check if the application is running on the costco mobile app
	     */
	    isRunningOnMobileApp: function isRunningOnMobileApp() {
	      return typeof Android != 'undefined' || typeof webkit != 'undefined';
	      //return true;
	    },
	    /**
	     * This function compares UserAgent header with mobile pattern regex. If mobile browser is not detected with this way,
	     * it checks if screen width is 1024 or less, which is also being treated as a mobile browser.
	     * 
	     * @returns True if mobile browser is detected
	     */
	    isMobile: function isMobile() {
	      var detectedMobileWithRegex = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune|Nokia|UCWEB/i.test(navigator.userAgent.toLowerCase());
	      var detectedMobileByScreenSize = $(window).width() <= 1024;
	      return detectedMobileWithRegex || detectedMobileByScreenSize;
	    },
	    /**
	     * Generates random UUID number
	     */
	    createUUID: function createUUID() {
	      var dt = new Date().getTime();
	      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = (dt + Math.random() * 16) % 16 | 0;
	        dt = Math.floor(dt / 16);
	        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	      });
	      return uuid;
	    },
	    /**
	     * Generic ajax wrapper. Set promise handlers inside the options
	     * object. ie options.done: function(){} will be called when the
	     * request is finished. Options object also gets passed back the
	     * the promise functions. Look at the signures below.
	     * @param  {Object} options The object used to pass options.
	     *                          {done: function(){}, hi: 'robert'}
	     * @return {jQuery.Deferred} The deferred object generated by calling
	     *                           $.ajax which can be chained.
	     */
	    ajax: function ajax(options) {
	      var done = void 0;
	      var fail = void 0;
	      var always = void 0;
	      var beforeSend = options.beforeSend || undefined;
	      var complete = options.complete || undefined;
	      options.done ? done = options.done : undefined;
	      options.fail ? fail = options.fail : undefined;
	      options.always ? always = options.always : undefined;
	      // Defaulting adding/removing the "busy" class as a decorator
	      // for beforeSend and complete
	      beforeSend ? options.beforeSend = function (jqXHR, settings) {
	        $('.order-ajax').addClass('ajax-busy');
	        beforeSend(jqXHR, settings);
	      } : options.beforeSend = function (jqXHR, settings) {
	        $('.order-ajax').addClass('ajax-busy');
	      };
	      complete ? options.complete = function (jqXHR, textStatus) {
	        $('.order-ajax, .permanent-ajax-busy').removeClass('ajax-busy');
	        complete(jqXHR, textStatus);
	      } : options.complete = function (jqXHR, textStatus) {
	        if (!options.keepBusy) {
	          $('.order-ajax, .permanent-ajax-busy').removeClass('ajax-busy');
	        }
	      };
	      return $.ajax(options).done(function (data, textStatus, jqXHR) {
	        if (done) done(data, textStatus, jqXHR, options);
	      }).fail(function (jqXHR, textStatus, errorThrown) {
	        if (fail) fail(jqXHR, textStatus, errorThrown, options);
	      }).always(function (data, textStatus, jqXHR) {
	        if (always) always(data, textStatus, jqXHR, options);
	      });
	    },
	    /**
	     * Used by jquery.validate on "validate" function options to scroll to the
	     * first error in the list.
	     * @param  {object} event     The event on the form
	     * @param  {object} validator The validator object associated with the form
	     * @return {void}
	     */
	    invalid_handler: function invalid_handler(event, validator) {
	      if (!validator.numberOfInvalids()) return;
	      var base = $('#costcoModal').hasClass('in') ? '#costcoModal' : 'html, body';
	      base == '#costcoModal' ? $(base).scrollTo(validator.errorList[0].element, 100) : $(base).scrollToElem(validator.errorList[0].element, 100);
	      validator.errorList[0].element.focus();
	    },
	    /**
	     * Check to see if a particular path is part of the checkout flow.
	     * @param  {String}  pathname The path (document.location.pathname)
	     * @return {Boolean}          Is this path part of the checkout flow?
	     */
	    isCheckout: function isCheckout(pathname) {
	      var isCheckout = false;
	      if (pathname == '/CheckoutCartView' || pathname == '/CheckoutCartDisplayView' || pathname == '/CheckoutPaymentView' || pathname == '/CheckoutShippingView' || pathname == '/CheckoutReviewView') {
	        isCheckout = true;
	      }
	      return isCheckout;
	    },
	    triggerClickOnEnterKeyPress: function triggerClickOnEnterKeyPress(inputSelector, clickSelector) {
	      $(inputSelector).unbind('keypress').on('keypress', function (event) {
	        if (event.which == 13) {
	          $(clickSelector).click();
	          return false;
	        }
	      });
	    },
	    /**
	     * Takes a base url and appends query strings to it. Joining the
	     * base and querystring with the appropriate separator '&' or '?'
	     * @param  {string} base           The string to append query strings to
	     *                                 '/order-item-update' or 'www.costco.com'
	     * @param  {object} querystringObj The object representing the querystrings
	     *                                 to append ie '{checkoutPage: 'review'}'
	     * @return {string}                The made url with querystrings attached.
	     */
	    makeUrl: function makeUrl(base, querystringObj) {
	      var sep = base.indexOf('?') > -1 ? '&' : '?';
	      return base + sep + $.param(querystringObj);
	    },
	    /**
	     * Did the ajax response object return any application or system errors?
	     * @param  {object}  response_obj The parsed response object from calling
	     *                                any backend class that resolves to
	     *                                JSONLayout.jsp
	     * @return {Boolean}              Does it have application or system errors?
	     */
	    has_errors: function has_errors(response_obj) {
	      var application = response_obj.error.application;
	      var exception = response_obj.error.exception;
	      return application.length > 0 || exception.length > 0;
	    },
	    messageFormat: function messageFormat(format) {
	      var args = Array.prototype.slice.call(arguments, 1);
	      return format.replace(/{(\d+)}/g, function (match, number) {
	        return typeof args[number] != 'undefined' ? args[number] : match;
	      });
	    },
	    /**
	     * This function restricts membership number inputs to numeric user input.
	     * The input must be of type=text for it to work.
	     * @return {void}
	     */
	    maskMembershipInput: function maskMembershipInput() {
	      $('[name=userField2], [name=membershipNumber], [name=membershipId], [name=membershipNumberToVerify]').mask('#');
	    },
	    addToWishList: function addToWishList(catentryId, fromPage) {
	      window.location.href = COSTCO.util.makeUrl('/AddToWishListView', {
	        catentryId: catentryId,
	        fromPage: fromPage || ''
	      });
	    },
	    isBusinessDelivery: function isBusinessDelivery() {
	      if ($('#isBDAppVar') && $('#isBDAppVar').length > 0) {
	        currentSite = $('#isBDAppVar').val();
	        if (currentSite == 'BD') {
	          return true;
	        }
	      }
	      return false;
	    },
	
	    /**
	     * To initialize global grocery flag. Determine whether grocery product is displayed in the page or not.
	     * @return {Boolean} hasGroceryProducts
	     */
	    hasGroceryProducts: function hasGroceryProducts() {
	      var hasGroceryProducts = false;
	      if ($('#hasGroceryPdts').length > 0) {
	        var globalFlag = $('#hasGroceryPdts').val();
	        if (null != globalFlag && globalFlag == 'true') {
	          hasGroceryProducts = true;
	        }
	      }
	      return hasGroceryProducts;
	    },
	    /**
	     * Determine the default grocery home page url
	     * @return {String} groceryHomepageURL
	     */
	    groceryDefaultHomepage: function groceryDefaultHomepage() {
	      var groceryHomepageURL = '';
	      if ($('#groceryDefaultHomepage').length > 0) {
	        groceryHomepageURL = $('#groceryDefaultHomepage').val();
	      }
	      return groceryHomepageURL;
	    },
	    isCAStore: function isCAStore() {
	      var isCAStore = false;
	      if (null != wcs.storeId && wcs.storeId == '10302') {
	        isCAStore = true;
	      }
	      return isCAStore;
	    },
	    isCABDStore: function isCABDStore() {
	      var isCAStore = false;
	      if (null != wcs.storeId && wcs.storeId == '11303') {
	        isCAStore = true;
	      }
	      return isCAStore;
	    },
	    isUSBDStore: function isUSBDStore() {
	      var isBDStore = false;
	      if (null != wcs.storeId && wcs.storeId == '11301') {
	        isBDStore = true;
	      }
	      return isBDStore;
	    },
	    isBDStore: function isBDStore() {
	      var isBDStore = false;
	      if (null != wcs.storeId && wcs.storeId != '10301' && wcs.storeId != '10302') {
	        isBDStore = true;
	      }
	      return isBDStore;
	    },
	    isUSStore: function isUSStore() {
	      var isUSStore = false;
	      if (null != wcs.storeId && wcs.storeId == '10301') {
	        isUSStore = true;
	      }
	      return isUSStore;
	    },
	    is2DayEligbleRegn: function is2DayEligbleRegn() {
	      var isRegionValid = 'false';
	      if ($.cookie('C_2LOC') != null) {
	        isRegionValid = $.cookie('C_2LOC');
	      }
	      if (isRegionValid != null && COSTCO.util.isCAStore() && isRegionValid == 'false') {
	        return false;
	      }
	      return true;
	    },
	    logToClickTale: function logToClickTale(message, url, lineNumber) {
	      if (typeof window.onerror !== 'function') {
	        console.log('onerror is not a function');
	      }
	      try {
	        if ((typeof message === 'undefined' ? 'undefined' : _typeof(message)) === 'object') {
	          message = JSON.stringify(message);
	        }
	        window.onerror(message, url, lineNumber);
	      } catch (e) {
	        console.log('Unknown error logging to Clicktale');
	      }
	    },
	    getSource: function getSource() {
	      var locale = util.getLocale().slice(3, 5).toUpperCase();
	      var store = util.isBDStore() ? 'BD' : 'BC';
	      return locale + store;
	    },
	    // Begin Business Delivery Client Cookies
	    getBDZipCookie: function getBDZipCookie() {
	      var z = $.cookie('WC_BD_ZIP'),
	          w = $.cookie('WC_BD_WHS'),
	          ec = '',
	          originalZipCode = $.cookie('WC_BD_ZIP_ORIGINAL');
	      if (z == null || z == '""') {
	        z = '';
	      }
	      if (originalZipCode == null || originalZipCode == '""') {
	        originalZipCode = '';
	      }
	      if (w == null || w == '""') {
	        w = '';
	      } else {
	        if (w.indexOf('-') != -1) {
	          //STRY0140687 BD-National Delivery-Check the presence of EC to identify the residential flow.
	          if (w.indexOf('ND') != -1) {
	            var whsArray = w.split('-');
	            if (whsArray.includes('ND')) {
	              ec = 'ND';
	            }
	          }
	          w = w.substring(0, w.indexOf('-'));
	        }
	      }
	      z = z.replace(/\+/g, ' ');
	      originalZipCode = originalZipCode.replace(/\+/g, ' ');
	      return {
	        zipCode: z,
	        warehouseNumber: w,
	        externalCarrier: ec,
	        originalZipCode: originalZipCode
	      };
	    },
	    getMaxOutherHeight: function getMaxOutherHeight(elems) {
	      return Math.max.apply(null, elems.map(function () {
	        return $(this).outerHeight(true);
	      }).get());
	    },
	    isDepotCatalogEnabled: function isDepotCatalogEnabled() {
	      var depotCatalogEnableFlag = $('#depotCatalogEnableFlag').length > 0 && $('#depotCatalogEnableFlag').val() == 'true' ? true : false;
	      return depotCatalogEnableFlag;
	    },
	    isNdEnabled: function isNdEnabled() {
	      if ($('#isNdEnabled').val() == 'true') {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    isEDDEnabled: function isEDDEnabled() {
	      var eddEnabled = true;
	      if (COSTCO.util.checkElementById('#vendorName', 'EDD:CHUBSmallPack') && !COSTCO.util.checkElementById('#eddSmallPackEnabled', 'true')) {
	        eddEnabled = false;
	      }
	      return eddEnabled;
	    },
	
	    isExternalCarrierShipmode: function isExternalCarrierShipmode() {
	      var shipmodeId = '';
	      if (COSTCO.util.isNdEnabled() && ($('input[name="deliveryMethod"]').length > 0 || $('#shipmodeId').length > 0)) {
	        shipmodeId = $('input[name="deliveryMethod"]').length > 0 ? $('input[name="deliveryMethod"]:checked').val() : $('#shipmodeId').val();
	      }
	      if (shipmodeId == '10102' || shipmodeId == '10104') {
	        return true;
	      } else {
	        return false;
	      }
	    },
	
	    isExternalCarrierShipmodeValue: function isExternalCarrierShipmodeValue(shipmodeId) {
	      if (COSTCO.util.isNdEnabled() && shipmodeId.length > 0 && (shipmodeId == '10102' || shipmodeId == '10104')) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	
	    /**
	     * Check if first search suggestion exists and set it to
	     * screen reader announcement div
	     */
	    setFirstSuggestionAnnouncement: function setFirstSuggestionAnnouncement() {
	      if ($('.tt-suggestion').length > 0 && $('#announce-first-suggestion').length > 0 && $('.tt-menu').find('.tt-cursor').length === 0) {
	        var firstSuggestion = $('.tt-suggestion:first').text();
	        $('#announce-first-suggestion').text(firstSuggestion);
	      }
	    },
	
	    /**
	       * Announce first suggestion (if any) after user's inactivity 
	       */
	    announceFirstSuggestion: function announceFirstSuggestion() {
	      if ($('#announce-first-suggestion').length > 0) {
	        $('#announce-first-suggestion').text('');
	      }
	      window.clearTimeout(this.timeout);
	      timeout = window.setTimeout(this.setFirstSuggestionAnnouncement, 2000);
	    },
	    /**
	     * This is to define the constants for the product availablity check
	     */
	    productConstants: {
	      inv_backorderd: 'BACK_ORDER',
	      inv_outOfStock: 'OUT_STOCK',
	      inv_invalidSku: 'INVALID_ITEM',
	      zipcodeAvailCheck_StatusFail: 'FAIL',
	      check_StatusSuccess: 'success',
	      edd_shiprestricted: 'SHIPRESTRICTED',
	      edd_backordered: 'BACKORDERED',
	      edd_presell: 'PRESELL'
	    },
	    /**
	     * Notification object for notification message display.
	     */
	    notification: {
	      /**
	       * Constants for notification display.
	       */
	      type: {
	        SUCCESS: 'SUCCESS',
	        WARNING: 'WARNING',
	        ERROR: 'ERROR'
	      },
	      /**
	       * Displays notification on screen.
	       * @param {string}  notificationType     Type of notification message to display (SUCCESS | WARNING | ERROR)
	       * @param {Array}   notifications        Array of notification messages to be displayed in the notification box
	       * @param {boolean} scrollToNotification Scroll window to notification message
	       * @param {Jquery element}  element           Jquery element for notification display
	       */
	      displayNotification: function displayNotification(notificationType, notifications, scrollToNotification, $element, wrapper) {
	        $element = $element && $($element).length > 0 ? $($element) : $('#notification-message');
	        scrollToNotification = scrollToNotification ? scrollToNotification : false;
	
	        this.clearNotification($element);
	
	        var topNotificationClass = '';
	        var topNotificationInnerHtml = '';
	
	        switch (notificationType) {
	          case this.type.SUCCESS:
	            topNotificationClass = 'success-notification';
	            break;
	          case this.type.WARNING:
	            topNotificationClass = 'warning';
	            break;
	          case this.type.ERROR:
	            topNotificationClass = 'critical-notification';
	            break;
	          default:
	            break;
	        }
	        var elementWrapper = wrapper ? wrapper : 'p';
	        notifications.forEach(function (notification) {
	          if ((typeof notification === 'undefined' ? 'undefined' : _typeof(notification)) === 'object') {
	            for (var errorKey in notification) {
	              topNotificationInnerHtml += '<' + elementWrapper + ' role=\"alert\">' + notification[errorKey] + '</' + elementWrapper + '>';
	            }
	          } else {
	            topNotificationInnerHtml += '<' + elementWrapper + ' role=\"alert\">' + notification + '</' + elementWrapper + '>';
	          }
	        });
	
	        $element.addClass(topNotificationClass);
	
	        topNotificationInnerHtml = COSTCO.util.get_decoded_html(topNotificationInnerHtml);
	        $element.html(topNotificationInnerHtml);
	
	        if (scrollToNotification) {
	          $('body, html').animate({
	            scrollTop: $element.offset().top - 30
	          }, 800);
	        }
	
	        $element.attr('tabindex', -1);
	        $element.focus();
	      },
	      /**
	       * Clears displayed notifications on screen.
	       * @param {Jquery element} Jquery element for notification display.
	       */
	      clearNotification: function clearNotification($element) {
	        $element = $element ? $($element) : $('#notification-message');
	
	        $element.removeClass();
	        $element.html('');
	      }
	    },
	
	    /**
	     * Redirects the pages to generic error/cart on inactive conditions
	     * @param page 
	     * @param orderStatus 
	     */
	    redirectCartOnInactive: function redirectCartOnInactive(page, status) {
	      if ($('#orderStatus').val() !== '' && $('#orderStatus').val() !== undefined) {
	        if ((page === 'SHIPPING' || page === 'payment' || page === 'review') && status === 'INACTIVE') {
	          window.location.href = "/CheckoutCartView";
	        } else if ((page === 'quick-membership' || page === 'quick-membership-renew') && status === 'INACTIVE') {
	          window.location.href = "/GenericError";
	        }
	      }
	    },
	
	    /**
	     * Gets element with back to top link
	     * and (if exists) binds keydown and click event
	     * that moves focus to top of the page
	     * @param backToTopLink
	     */
	    setEventOnBackToTopLink: function setEventOnBackToTopLink(backToTopLinkClass) {
	      var $backToTopLink = $(backToTopLinkClass).find("a").length > 0 ? $(backToTopLinkClass).find("a") : $(backToTopLinkClass);
	      /* ADA STRY0169325 - Back to top functionality */
	      $backToTopLink.attr("href", "#headerskip");
	      $backToTopLink.click(function () {
	        COSTCO.util.scrollToTop();
	      });
	      $backToTopLink.keydown(function (e) {
	        if (e.keyCode === 13) COSTCO.util.scrollToTop();
	      });
	    },
	
	    /**
	     * Function used to add a label with error message accessible only to screen reader
	     * @param element that error label should be attached to
	     */
	    addErrorLabelForAda: function addErrorLabelForAda(element) {
	      if (typeof element !== 'undefined' && element !== null) {
	        var $element = $(element);
	        if ($element.hasClass("error") && !$element.siblings('.sr-only').length) {
	          $element.before("<span for=\"" + $element[0].id + "\" class=\"sr-only\">" + messages.ERROR + "</span>");
	        }
	      }
	    },
	
	    /**
	     * Function used for fetching first global error message on page
	     * @param containerElement - specifies the element in which the global error is searched for
	     * @return first element with global error class
	     */
	    getFirstGlobalErrorOnPage: function getFirstGlobalErrorOnPage(containerElement) {
	      var errorClasses = COSTCO.util.globalErrorElementClasses;
	      //create jquery selector from an array of classes
	      var selector = errorClasses.join(", .");
	      var firstElementWithClass = containerElement.find('.' + selector).html() !== undefined ? containerElement.find('.' + selector).first() : null;
	      var iterationValue = firstElementWithClass;
	      while (iterationValue !== undefined && iterationValue !== null) {
	        firstElementWithClass = iterationValue;
	        iterationValue = COSTCO.util.getFirstGlobalErrorOnPage(firstElementWithClass);
	      }
	      return firstElementWithClass;
	    },
	
	    /**
	     * Function that creates an error label accessible only to screen reader
	     * @param errorMessage that should be appended with screen reader label
	     * @return string containing both the error message and the screen reader only error label
	     */
	    createErrorAdaLabel: function createErrorAdaLabel(errorMessage) {
	      return "<span class='sr-only'>" + messages.ERROR + "</span>" + errorMessage;
	    },
	
	    /**
	     * Function used to remove a label with error message accessible only to screen reader
	     * @param element whose label should be removed
	     */
	    removeErrorLabelForAda: function removeErrorLabelForAda(element) {
	      if (typeof element !== 'undefined' && element !== null) {
	        var $element = $(element);
	        $element.siblings('label').remove(".sr-only");
	        $element.siblings().children('label').remove(".sr-only");
	        $element.parent().siblings('label').remove(".sr-only");
	      }
	    },
	
	    /**
	     * jquery validator 'highlight' method,
	     * with ADA error label added
	     */
	    highlightWithErrorLabel: function highlightWithErrorLabel(element, errorClass, validClass) {
	
	      if (element.type === 'radio') {
	        this.findByName(element.name).addClass(errorClass).removeClass(validClass);
	      } else {
	        $(element).addClass(errorClass).removeClass(validClass);
	        $(element).attr("aria-describedby", this.idOrName(element) + this.settings.idSuffix);
	      }
	      COSTCO.util.addErrorLabelForAda(element);
	    },
	
	    /**
	        * jquery validator 'unhighlight' method,
	        * with ADA error label added
	        */
	    unhighlightWithErrorLabel: function unhighlightWithErrorLabel(element, errorClass, validClass) {
	      if (element.type === 'radio') {
	        this.findByName(element.name).removeClass(errorClass).addClass(validClass);
	      } else {
	        $(element).removeClass(errorClass).addClass(validClass);
	        $(element).removeAttr("aria-describedby");
	      }
	      COSTCO.util.removeErrorLabelForAda(element);
	    },
	
	    /**
	     * Function used to inject message in screen reader placeholder announcement div
	     * @param message to be injected
	     */
	    announceSRMessage: function announceSRMessage(message) {
	      var adaMessageDiv = $('#screen-reader-announcement');
	      if (message !== undefined && message.length !== 0 && message !== "") {
	        adaMessageDiv.empty();
	        adaMessageDiv.html(message);
	
	        //after a 2sec delay, remove the message so SR users don't unneccessarily revisit it when navigating DOM
	        setTimeout(function () {
	          adaMessageDiv.empty();
	        }, 2000);
	      }
	    },
	
	    /**
	     * Calling function onclick by pressing enter key (keyCode = 13)
	     * @param id
	     */
	    clickElementOnEnter: function clickElementOnEnter(elementId) {
	      if (event.keyCode === 13 && $('#' + elementId).length > 0) {
	        $('#' + elementId).click();
	      }
	    },
	
	    /**
	     * Calling function onclick by pressing enter key (keyCode = 13)
	     * or pressing space key (keyCode = 32)
	     * @param id
	     */
	    clickElementOnEnterOrSpace: function clickElementOnEnterOrSpace(elementId) {
	      if ((event.keyCode === 13 || event.keyCode === 32) && $('#' + elementId).length > 0) {
	        //Prevents from window scrolling
	        if (event.keyCode === 32) {
	          event.preventDefault();
	        }
	        //If element is tooltip, do not perfrom action
	        if ($(".span-inline-block").is(":focus")) {
	          return false;
	        }
	        $('#' + elementId).click();
	      }
	    },
	
	    //Workarround for FireFox locked tabbing on radio buttons ALM #22811
	    /**
	     * Calling function onfocus event 
	     * and changing label tabindex attr to -1
	     */
	    changeTabIndex: function changeTabIndex() {
	      var element = $("label[role=radio]");
	      element.each(function () {
	        $(this).attr('tabindex', '-1');
	      });
	    },
	
	    /**
	     * Calling function onblur event making element unfocusable
	     * and changing label tabindex attr back to 0
	     * @param el (date input name)
	     */
	    changeTabIndexOut: function changeTabIndexOut(el) {
	      if (el) {
	        $(el).attr('tabindex', '0');
	      }
	      var element = $("label[role=radio]");
	      element.each(function () {
	        $(this).attr('tabindex', '0');
	      });
	    },
	
	    /**
	     * Calling function onfocus event making date input focusable
	     * @param element (date input name)
	     */
	    setTabIndex: function setTabIndex(el) {
	      var element = $("input[name=" + el + "]");
	      element.attr('tabindex', '0');
	    },
	
	    /**
	     * Calling function onclick by pressing Space key (keyCode = 32) 
	     * referencing element by element's ID
	     * @param elementId
	     */
	    clickElementOnSpaceBtn: function clickElementOnSpaceBtn(elementId) {
	      if (event.keyCode === 32 && $('#' + elementId).length > 0) {
	        //Prevents from window scrolling
	        event.preventDefault();
	        //If element is tooltip, do not perfrom action
	        if ($(".span-inline-block").is(":focus")) {
	          return false;
	        }
	        $('#' + elementId).click();
	      }
	    },
	    /**
	     * Returns all focusable elements inside parent element
	     * @parentElement
	     */
	    returnAllFocusableElements: function returnAllFocusableElements(parentElement) {
	      var focusableElements = parentElement.querySelectorAll('a[href]:not([disabled]), button:not([disabled]),' + 'textarea:not([disabled]),input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]),' + 'input[type="checkbox"]:not([disabled]), select:not([disabled]), *[tabindex="0"], area');
	      return focusableElements;
	    },
	    /**
	     * Returns all visible focusable elements from list of elements
	     * @focusableElements
	     */
	    returnAllFocusableVisibleElements: function returnAllFocusableVisibleElements(focusableElements) {
	      var visibleFocusable = [];
	
	      function findVisibleElements(item, index) {
	        $(item).unbind('keydown');
	        //Does element or its parent has display none
	        if (item.style.display !== "none" && item.offsetParent !== null) {
	          if ($(item).is(':visible')) {
	            visibleFocusable.push(item);
	          }
	        }
	      }
	
	      for (var i = 0; i < focusableElements.length; i++) {
	        findVisibleElements(focusableElements[i]);
	      }
	      return visibleFocusable;
	    },
	    /**
	     * Returns focus to first/last focusable element in modal
	     */
	    setElementFocus: function setElementFocus(firstElement, lastElement, e) {
	      var KEYCODE_TAB = 9;
	      if (e.key === 'Tab' || e.keyCode === KEYCODE_TAB) {
	        if (e.shiftKey && document.activeElement === firstElement) /* shift + tab */{
	            lastElement.focus();
	            e.preventDefault();
	          } else if (!e.shiftKey && document.activeElement === lastElement) {
	          firstElement.focus();
	          e.preventDefault();
	        }
	      }
	    },
	
	    /**
	     * Scrolls page to top
	     */
	    scrollToTop: function scrollToTop() {
	      $('#headerskip').get(0).scrollIntoView(true);
	      $('#headerskip').focus();
	    },
	
	    /**
	     * Focuses on an element without scrolling to it
	     */
	    focusWithoutScroll: function focusWithoutScroll(elem) {
	      var x = window.scrollX;
	      var y = window.scrollY;
	      elem.focus();
	      window.scrollTo(x, y);
	    },
	
	    /**
	     * Sets lisener on first and last
	     * element on modal, and traps focus inside them
	     */
	    bindModalFocusEvents: function bindModalFocusEvents(firstElement, lastElement) {
	      $(firstElement).unbind('keydown').bind('keydown', function (e) {
	        COSTCO.util.setElementFocus(firstElement, lastElement, e);
	      });
	      $(lastElement).unbind('keydown').bind('keydown', function (e) {
	        COSTCO.util.setElementFocus(firstElement, lastElement, e);
	      });
	    },
	    trapFocusInsideModal: function trapFocusInsideModal() {
	      var modalBody = $(".modal-dialog").get(0);
	      if (modalBody != undefined) {
	        var focusableElements = COSTCO.util.returnAllFocusableElements(modalBody);
	        var focusableVisible = COSTCO.util.returnAllFocusableVisibleElements(focusableElements);
	        if (focusableVisible.length > 0) {
	          var firstElement = focusableVisible[0];
	          var lastElement = focusableVisible[focusableVisible.length - 1];
	          COSTCO.util.bindModalFocusEvents(firstElement, lastElement);
	        }
	      }
	    },
	    /**
	     * Showes and hides elemenet based on flag parameter
	     * @param element
	     * @param flag
	     */
	    showHtmlElementByFlag: function showHtmlElementByFlag(element, flag) {
	      if (element == undefined || flag == undefined) {
	        return false;
	      }
	      if (flag === true) {
	        element.removeClass('hide');
	      } else {
	        element.addClass('hide');
	      }
	    },
	    /**
	     * Test if this page is part of new design.
	     * @return true if page is part of new design, false otherwise
	     */
	    isPDPCartCheckoutEnabled: function isPDPCartCheckoutEnabled() {
	      return costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE;
	    },
	
	    /**
	     * Method to convert the date input string to Timestamp format
	     */
	    convertDateToTimestamp: function convertDateToTimestamp(dateSring) {
	      var dateTimeParts = dateSring,
	          dateParts = dateTimeParts.split('-'),
	          date;
	      date = new Date(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2], '00', '00');
	      return date.getTime();
	    },
	    globalErrorElementClasses: ['critical-notification', 'error', 'lists-error', 'form-error-text'],
	    base64test: /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/,
	    _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
	    _keyStrExcl: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
	    getUrlToLangMap: function getUrlToLangMap() {
	      var urlToLanguageMap = sessionStorage.getItem("urlToLanguageMap");
	      if (urlToLanguageMap == null) {
	        return JSON.parse("{}");
	      } else {
	        return JSON.parse(urlToLanguageMap);
	      }
	    },
	    addUrlToLangMap: function addUrlToLangMap(url, selectedLang) {
	      var urlToLanguageMap = COSTCO.util.getUrlToLangMap();
	      // Checked with business and we will accommodate 50 items in history to 
	      // check for language to reasonably meet most of customers' activities.
	      if (Object.keys(urlToLanguageMap).length >= 50) {
	        var keyToDelete = Object.keys(urlToLanguageMap)[0];
	        delete urlToLanguageMap[keyToDelete];
	      }
	      urlToLanguageMap[url] = selectedLang;
	      sessionStorage.setItem("urlToLanguageMap", JSON.stringify(urlToLanguageMap));
	    },
	    removeUrlFromLangMap: function removeUrlFromLangMap(url) {
	      var urlToLanguageMap = COSTCO.util.getUrlToLangMap();
	      delete urlToLanguageMap[url];
	      sessionStorage.setItem("urlToLanguageMap", JSON.stringify(urlToLanguageMap));
	    },
	    /**
	     * 1. Create a map of url pathname and the language at the time the url was accessed 
	     * 2. During browser history back and forward, if the selectedLanguage and value of the language from the map
	     * 		do not match, then do a hard load of the page
	     */
	    registerLanguageListener: function registerLanguageListener() {
	      // Register event if event function is not already defined
	      if (typeof window.onpageshow !== "function") {
	        window.onpageshow = function (event) {
	          var currentLang = $.cookie(cookies.SELECTED_LANG_COOKIE);
	          var currentUrl = window.location.pathname;
	          // event.persisted is faulty, so use window.performance.navigation.type also
	          if (event.persisted || window.performance && window.performance.navigation.type == 2) {
	            // window.performance.navigation.type = 2 means back or forward
	            var langSettingForCurrentUrl = COSTCO.util.getUrlToLangMap()[currentUrl];
	            if (langSettingForCurrentUrl !== undefined && langSettingForCurrentUrl !== currentLang) {
	              console.log("Doing hard reload since language has changed");
	              COSTCO.util.removeUrlFromLangMap(currentUrl);
	              if (isMobileApp == 'true') {
	                COSTCO.myLocation.reloadWithNewLanguage(currentLang);
	              }
	            }
	          } else {
	            COSTCO.util.addUrlToLangMap(currentUrl, currentLang);
	          }
	        };
	      }
	    },
	    /*
	     * A11Y STRY0166460
	     */
	    closeDropdownWhenOutOfFocus: function closeDropdownWhenOutOfFocus() {
	      $('.list-group-item').find('a').focusin(function () {
	        if (!$(this).parents('.dropdown-container').hasClass('open')) {
	          $('.dropdown-container.open').removeClass('open');
	        }
	      });
	      $('#search-field').focusin(function () {
	        $('.dropdown-container.open').removeClass('open');
	      });
	    },
	
	    /* A screen reader user should only be able to access one search field 
	     * ADA STRY0166458
	     */
	
	    addAriaHiddenToHiddenInput: function addAriaHiddenToHiddenInput() {
	      $("input[type=text].tt-hint").attr("aria-hidden", "true");
	    },
	
	    /** DSR Membership Enquiry - used to open Membership inquiry modal
	     * 
	    */
	    membershipDetailedEnquiry: function membershipDetailedEnquiry() {
	      var modalOptions = {
	        title: messages.RWD_MEMBERSHIP_NUMBER,
	        body: COSTCO.util.tmpl('tmpl_membership_modal'),
	        primary: messages.CLOSE,
	        primary_button_fullspan: false,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	        }
	      };
	      COSTCO.dialog.showAndHideModal(modalOptions);
	    },
	    /**
	        * Method return timeout function for fetch method to call API services
	        */
	    getTimeoutController: function getTimeoutController() {
	      /**
	        * Timeout function
	        * @param {Integer} time (miliseconds)
	        * @param {Promise} promise
	        */
	      var timeout = function timeout(time, promise) {
	        return new Promise(function (resolve, reject) {
	          setTimeout(function () {
	            reject(new Error('API_TIMEOUT'));
	          }, time);
	          promise.then(resolve, reject);
	        });
	      };
	      return timeout;
	    },
	    /**
	        * Method to check if a DOM element is present using its ID and verify the value of the element
	        * return true if the value matches, else false.
	        */
	    checkElementById: function checkElementById(elementId, value) {
	      var elementValueMatch = false;
	      if ($(elementId).length > 0 && $(elementId).val() === value) {
	        elementValueMatch = true;
	      }
	      return elementValueMatch;
	    },
	
	    parseURL: function parseURL(url) {
	      var a = document.createElement('a');
	      a.href = url;
	      return {
	        source: url,
	        protocol: a.protocol.replace(':', ''),
	        host: a.hostname,
	        port: a.port,
	        query: a.search,
	        params: function () {
	          var ret = {},
	              seg = a.search.replace(/^\?/, '').split('&'),
	              len = seg.length,
	              i = 0,
	              s;
	          for (; i < len; i++) {
	            if (!seg[i]) {
	              continue;
	            }
	            s = seg[i].split('=');
	            ret[s[0]] = s[1];
	          }
	          return ret;
	        }(),
	        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
	        hash: a.hash.replace('#', ''),
	        path: a.pathname.replace(/^([^\/])/, '/$1'),
	        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
	        segments: a.pathname.replace(/^\//, '').split('/')
	      };
	    },
	
	    getParamVal: function getParamVal(url, key) {
	      var urlMap = COSTCO.util.parseURL(url);
	      return urlMap.params[key];
	    },
	
	    /**
	     * Utility function detect is browser IE11 or older version
	     * return boolean
	     */
	    isIE11OrOlder: function isIE11OrOlder() {
	      var ua = window.navigator.userAgent;
	      var msie = ua.indexOf('MSIE ');
	      if (msie > 0) {
	        // IE 10 or older 
	        return true;
	      }
	      var trident = ua.indexOf('Trident/');
	      if (trident > 0) {
	        // IE 11 
	        return true;
	      }
	      return false;
	    },
	
	    /**
	     * Utility function to check if user is logged in
	     * return boolean
	     */
	    isUserLoggedIn: function isUserLoggedIn() {
	
	      try {
	        $.cookie("hashedUserId").length;
	        return true;
	      } catch (e) {
	        return false;
	      }
	    },
	
	    objectExistsAndNonEmpty: function objectExistsAndNonEmpty(obj) {
	      if (typeof obj == 'undefined') {
	        return false;
	      } else if (obj == null) {
	        return false;
	      } else if (obj == '') {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    filterItems: function filterItems(arr, query) {
	      return arr.filter(function (el) {
	        return el.toLowerCase() != query.toLowerCase();
	      });
	    },
	
	    signoutNextAuth: function signoutNextAuth() {
	      // Fetch CSRF token
	      fetch("/api/auth/csrf", {
	        method: "GET",
	        headers: {
	          "Accept": "*/*",
	          "Cache-Control": "no-cache",
	          "Content-Type": "application/json",
	          "Pragma": "no-cache",
	          "Sec-Fetch-Mode": "cors",
	          "Sec-Fetch-Site": "same-origin",
	          "Credentials": "include"
	        }
	      }).then(function (response) {
	        if (!response.ok) {
	          throw new Error('Failed to fetch CSRF token');
	        }
	        return response.json();
	      }).then(function (data) {
	        var csrfToken = data.csrfToken;
	
	        // Sign out using CSRF token
	        return fetch("/api/auth/signout", {
	          method: "POST",
	          headers: {
	            "Accept": "*/*",
	            "Cache-Control": "no-cache",
	            "Content-Type": "application/x-www-form-urlencoded",
	            "Pragma": "no-cache",
	            "Sec-Fetch-Mode": "cors",
	            "Sec-Fetch-Site": "same-origin",
	            "Credentials": "include"
	          },
	          body: new URLSearchParams({
	            csrfToken: csrfToken,
	            callbackUrl: new URL(window.location.href).origin + "/?ao=yes",
	            json: true
	          })
	        });
	      }).then(function (response) {
	        if (!response.ok) {
	          throw new Error('Failed to sign out');
	        }
	        return response.json();
	      }).then(function (data) {
	        console.log(data.message);
	        // Handle success message as needed
	      }).catch(function (error) {
	        console.error('Error signing out:', error);
	        // Provide user feedback here if needed
	      });
	    },
	    logoutSso: function logoutSso(obj, logOffUrls, isSsoEnabled, isMobileApp) {
	      sessionStorage.removeItem("SelectedPatientIndex");
	      $.cookie('PrescriptionCount', null, { path: '/' });
	      try {
	        console.log("Sign out ");
	        if (typeof Android != 'undefined') {
	          console.log("Android sign out ");
	          Android.onSignOut();
	        } else if (typeof webkit != 'undefined') {
	          console.log("Webkit sign out ");
	          webkit.messageHandlers.onSignOut.postMessage('');
	        }
	        console.log("Sign out finished");
	        if (isSsoEnabled == '0' || isSsoEnabled == null || isSsoEnabled == '' || isSsoEnabled == false || isMobileApp == null || isMobileApp == '' || isMobileApp == 'true') {
	          window.location = window.location.origin + "/Logoff?usrClk=true";
	          return;
	        }
	
	        var logOffAcion = "/security/v1/users/session/ssologoff";
	
	        //New home page support.
	        try {
	          COSTCO.util.signoutNextAuth();
	        } catch (k) {}
	
	        $.cookie('C_GOP', null, { path: '/' });
	        if (logOffUrls == null || logOffUrls == undefined || logOffUrls == "") {
	          window.location = window.location.origin + "/Logoff?usrClk=true";
	          return;
	        }
	
	        logOffUrls = logOffUrls.split(",");
	        logOffUrls = COSTCO.util.filterItems(logOffUrls, window.location.origin);
	
	        if (logOffUrls != null && logOffUrls.length > 0) {
	          var targetUri = '';
	
	          if (costcoStoreFeatures.OCUCO_LOGOUT_ENABLED === true) {
	            targetUri = logOffUrls[0] + logOffAcion + '?' + 'a=' + logOffUrls[1] + logOffAcion + '&b=' + logOffUrls[2] + logOffAcion + '&c=' + logOffUrls[3] + "/Account/Logout";
	          } else {
	            targetUri = logOffUrls[0] + logOffAcion + '?' + 'a=' + logOffUrls[1] + logOffAcion + '&b=' + logOffUrls[2] + logOffAcion;
	          }
	          var logoffWindow = window.open(targetUri, '_blank');
	          setTimeout(function () {
	            logoffWindow.close();
	            window.location = window.location.origin + "/Logoff?usrClk=true";
	          }, 3800); //milliseconds
	        } else {
	          window.location = window.location.origin + "/Logoff?usrClk=true";
	        }
	      } catch (e) {
	        console.log(e);
	        window.location = window.location.origin + "/Logoff?usrClk=true";
	      }
	    },
	
	    /**
	    * This function strips anything that isn't a number
	     * Intended for quantity selector 
	    * @param {[string] inputValue}  
	    * @returns {[number] outputValue}
	    */
	    stripStringOfNonNumberTypes: function stripStringOfNonNumberTypes(inputValue) {
	      var outputValue = inputValue.replace(/[^\d]/g, "");
	      return outputValue;
	    },
	    /**
	     * Checks if the current context is related to a locationControlledInventory product. 
	     */
	    islocationControlledInventoryFlow: function islocationControlledInventoryFlow() {
	      var islocationControlledInventoryFlow = $('#regionalIdentifier').length > 0 && $('#regionalIdentifier').val() == 'true' ? true : false;
	      return islocationControlledInventoryFlow;
	    },
	
	    /**
	     * Checks if the current context is related to a siteControlledInventory product. 
	     */
	    issiteControlledInventoryFlow: function issiteControlledInventoryFlow() {
	      var issiteControlledInventoryFlow = $('#regionalIdentifier').length > 0 && $('#regionalIdentifier').val() == 'false' ? true : false;
	      return issiteControlledInventoryFlow;
	    },
	
	    getFiveDigitPostalCode: function getFiveDigitPostalCode(postalCode) {
	      var zipCode = postalCode;
	      var finalZip = '';
	      var zipCodeWithoutExtraFour = zipCode.split('-');
	      if (zipCodeWithoutExtraFour.length > 1) {
	        finalZip = zipCodeWithoutExtraFour[0];
	      } else {
	        finalZip = zipCode;
	      }
	      return finalZip;
	    },
	
	    formatPhoneNumber: function formatPhoneNumber(number) {
	      var phNumber = number.replace(/\D/g, '');
	      return phNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
	    },
	
	    cancelMemberApplication: function cancelMemberApplication(partNumber) {
	      var appTrackingCookie = $.cookie('APPLICATION_TRACKING_COOKIE');
	      var currentPage = window.location.pathname.substr(1);
	
	      if (document.referrer === "") {
	        window.location.href = '/CheckoutCartView';
	      } else {
	
	        if (appTrackingCookie !== 'null' || 'undefined') {
	          if ($('#isBDAppVar').val() === 'BD' && $.cookie('cartCountCookie') > 1) {
	            path = '/MembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
	          } else {
	            path = '/QuickMembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
	          }
	          console.log('path: ', path);
	          window.location.href = path;
	          return;
	        }
	        window.location.href = COSTCO.util.scrubSpecialChars(document.referrer);
	      }
	    },
	
	    /** selects the input radio buttons inside the given element
	    * used for all the radio buttons/selection-boxes combined elements */
	    selectRadioBox: function selectRadioBox(element) {
	      $(element).find('input').prop('checked', true);
	    },
	
	    /** used on onblur event of all fields so that the screen reader 
	    * would announce the error when focus moves out of the field */
	    alertScreenReader: function alertScreenReader(element) {
	      if ($(element).attr('aria-invalid') === 'true') {
	        var elementName = $(element).attr('name');
	        var errorElement = $('#' + elementName + 'Error');
	
	        errorElement.removeAttr('role');
	        errorElement.attr('role', 'alert');
	      }
	    },
	
	    ariaSetElementAsValid: function ariaSetElementAsValid(element) {
	      if (element) {
	        element.removeAttr('aria-describedby');
	        element.attr('aria-invalid', 'false');
	      }
	    },
	
	    ariaSetElementAsInvalid: function ariaSetElementAsInvalid(element, describedByElementId) {
	      if (element) {
	        element.attr('aria-describedby', describedByElementId);
	        element.attr('aria-invalid', 'true');
	      }
	    },
	    /**
	     * Gets element with back to top link and (if exists) binds keydown and click event
	     * that moves focus to top of the page. For Gatsby enabled pages # routing is implemented
	     * so we have add event to div rather than adding a new hash to current url
	     *
	     * @param backToTopLink
	     */
	    setEventOnBackToTopLinkGatsby: function setEventOnBackToTopLinkGatsby(backToTopLinkClass) {
	      /* ADA to move focus on skip link click */
	      var $backToTopLink = $(backToTopLinkClass).find("a").length > 0 ? $(backToTopLinkClass).find("a") : $(backToTopLinkClass);
	      //Added for gatsby body focus
	      $backToTopLink.click(function () {
	        $backToTopLink.attr("href", window.location.href);
	        COSTCO.util.scrollToTopGatsby();
	      });
	      $backToTopLink.keydown(function (e) {
	        $backToTopLink.attr("href", window.location.href);
	        if (e.keyCode === 13) COSTCO.util.scrollToTopGatsby();
	      });
	    },
	
	    /**
	    * This function opens and closes accordion that contains drugs list
	    * @param  {String} letter capital letter of drugs
	    * @param  {String} html element that was clicked
	    * @param  {String} hostProtocolURL 
	    * @return {void}
	    */
	    show_drug_list_by_capital_letter: function show_drug_list_by_capital_letter(letter, hostProtocolURL, element) {
	      if ($('#cmpp-drugs-by-letter-accordion-collapse').hasClass('in') && $('#cmpp-drugs-by-letter-accordion-collapse').attr('data-letter') == letter) {
	        $('#cmpp-drugs-by-letter-accordion-collapse').collapse('hide');
	        $(element).children(".cmpp-close").addClass("hidden");
	        $(element).removeClass("cmpp-title-active");
	        $('html, body').animate({ scrollTop: $(element).offset().top }, 800);
	      } else {
	
	        if ($('#cmpp-drugs-by-letter-accordion-collapse').hasClass('in')) {
	
	          $('#cmpp-drugs-by-letter-accordion-collapse').collapse('hide');
	
	          setTimeout(function () {
	            COSTCO.util.drug_list_by_capital(letter, hostProtocolURL, element);
	          }, 700);
	        } else {
	          COSTCO.util.drug_list_by_capital(letter, hostProtocolURL, element);
	        }
	      }
	    },
	    /**
	     * This function handles building the drug list that corresponds
	     * with first letter of drug name.
	     * @param  {String} stateCode used to filter list of all cmpps
	     * @param  {String} html element that was clicked
	     * @param  {String} hostProtocolURL
	     * @return {void}
	     */
	    drug_list_by_capital: function drug_list_by_capital(letter, hostProtocolURL, element) {
	
	      $('#cmpp-drugs-by-letter-accordion-collapse').remove();
	      $('html, body').animate({ scrollTop: $(element).offset().top }, 800);
	
	      $(".panel-group div div div").removeClass("cmpp-title-active");
	      $(".panel-group div div .cmpp-close").addClass("hidden");
	      $(element).addClass("cmpp-title-active");
	      $(element).children(".cmpp-close").removeClass("hidden");
	
	      $(element).parent().after(COSTCO.util.tmpl('tmpl_drugs_by_letter', {
	        letter: letter
	      }));
	      var windowWidth = $(window).width();
	      var colNum = 1;
	      if (windowWidth > 1025) {
	        colNum = 3;
	      } else if (windowWidth > 667) {
	        colNum = 2;
	      };
	      var drugNamesObj = JSON.parse(allDrugNamesMap[0].jsonDrugNameURL);
	      var drugArr = [];
	      for (var el in drugNamesObj) {
	        if (el.substring(0, 1) === letter) {
	          var obj = {
	            drugName: el,
	            drugUrl: drugNamesObj[el]
	          };
	          drugArr.push(obj);
	        }
	      }
	      var numOfItems = drugArr.length;;
	      var numOfRows = Math.ceil(numOfItems / colNum);
	      for (var i = 0; i < numOfRows; i++) {
	        $('#cmpp-drugs-by-letter-accordion-collapse-panel').append(COSTCO.util.tmpl('tmpl_drugs_list_by_capital_letter', {
	          drugLink1: drugArr[i] && hostProtocolURL + drugArr[i].drugUrl,
	          drugLink2: drugArr[i + numOfRows] && hostProtocolURL + drugArr[i + numOfRows].drugUrl,
	          drugLink3: drugArr[i + 2 * numOfRows] && hostProtocolURL + drugArr[i + 2 * numOfRows].drugUrl,
	          drugName1: drugArr[i].drugName && drugArr[i].drugName,
	          drugName2: drugArr[i + numOfRows] && drugArr[i + numOfRows].drugName,
	          drugName3: drugArr[i + 2 * numOfRows] && drugArr[i + 2 * numOfRows].drugName,
	          numOfCol: colNum
	
	        }));
	      }
	      $('#cmpp-drugs-by-letter-accordion-collapse').collapse('show');
	    },
	    /**
	     * Scrolls page to top
	    */
	    scrollToTopGatsby: function scrollToTopGatsby() {
	      document.getElementById("gatsbyIndex").scrollIntoView(true);
	      document.getElementById("gatsbyIndex").focus();
	    },
	
	    /**
	      * Util to give an interactive character count down
	      * @param  {ojbect} label    pass the jquery obj where you want the
	      *                           countdown to reflect
	      * @param  {object} textarea pass a 'text' input
	      *                           (input[type='text'],textarea) to count
	      * @return {void}
	    */
	    character_count: function character_count(label, textarea) {
	      if ($(label).length > 0 && $(textarea).length > 0) {
	        var updateLabelCount = function updateLabelCount(textarea, label) {
	          var count = $(textarea).val().length;
	          $(label).text(max - count);
	        };
	
	        var max = parseInt($(textarea).attr('maxlength'));
	        $(label).text(max - $(textarea).val().length);
	        $(textarea).unbind('keyup').on('keyup', function () {
	          updateLabelCount(this, label);
	        });
	        $(textarea).unbind('change').on('change', function () {
	          updateLabelCount(this, label);
	        });
	      }
	    },
	    getCookieByName: function getCookieByName(name) {
	      var value = '; ' + document.cookie;
	      var parts = value.split('; ' + name + '=');
	      if (parts.length === 2) return parts.pop().split(';').shift();
	    },
	
	    // function for sanitizing data to prevent XSS attacks
	    replaceSpecialChars: function replaceSpecialChars(obj) {
	      var result = new String(obj);
	
	      result = result.replace(/&/g, "&amp;");
	      result = result.replace(/</g, "&lt;");
	      result = result.replace(/>/g, "&gt;");
	      result = result.replace(/'/g, "&#39;");
	      result = result.replace(/"/g, "&quot;");
	      result = result.replace(/\//g, "&#47;");
	      result = result.replace(/\\/g, "&#92;");
	
	      return result;
	    },
	    /**
	     * Async SHA256 encryption
	     * @param {} message text that will be hashed
	     * @param {} callback 
	     */
	    sha256: function sha256(message, callback) {
	      var encoder = new TextEncoder();
	      var data = encoder.encode(message);
	      crypto.subtle.digest('SHA-256', data).then(function (hashBuffer) {
	        var hashArray = Array.from(new Uint8Array(hashBuffer));
	        var hashHex = hashArray.map(function (byte) {
	          return byte.toString(16).padStart(2, '0');
	        }).join('');
	        callback(hashHex);
	      }).catch(function (error) {
	        console.error('Error calculating SHA-256 hash: ', error);
	        callback(null);
	      });
	    },
	    getCookieStartingWith: function getCookieStartingWith(prefix) {
	      var cookies = document.cookie.split(';');
	
	      for (var i = 0; i < cookies.length; i++) {
	        var cookie = cookies[i].trim();
	
	        // Check if the cookie starts with the specified prefix
	        if (cookie.startsWith(prefix)) {
	          // Extract the value of the cookie
	          return cookie.substring(prefix.length + 1);
	        }
	      }
	
	      // Return null if no matching cookie is found
	      return null;
	    },
	
	    /**
	     * Decode JWT and check for validity.  
	     * */
	    checkJWTExpiry: function checkJWTExpiry(JWT) {
	      var expired = true;
	      var JWT_payload = JSON.parse(atob(JWT.split('.')[1]));
	      if (typeof JWT_payload != 'undefined' && JWT_payload != null) {
	        var currentTimeInMiliseconds = Date.now();
	        var validUntil = Number(JWT_payload.created_at) + Number(JWT_payload.expires_in) - 3600000;
	        if (currentTimeInMiliseconds < validUntil) {
	          expired = false;
	        }
	      }
	      return expired;
	    },
	    sentenceToPascalCase: function sentenceToPascalCase(sentence) {
	      return sentence.split(' ').map(function (word) {
	        // Keeps only letters and numbers (including accented/Unicode letters)
	        return (word.match(/[A-Za-zÀ-ÖØ-öø-ÿ0-9]+/g) || []).join('');
	      }).map(function (word) {
	        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
	      }).join(' ');
	    },
	    isElementEmpty: function isElementEmpty(elementValue) {
	      if (typeof elementValue === 'undefined' || elementValue === null || elementValue === '') return true;
	      return false;
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.util = util;
	
	  return util;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title utility2.js: Global sub-module
	 * @description A collection of functions used application wide, except Home, Browse & Product pages.
	 * Functions that are not needed for Home, Browse & Product pages should live in this file
	 * This module should contain generic utility code. No module specifics.
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var util = {
	    POSTAL_CODE_REGEX_US: /^(\d{5}(-\d{4})?$)$/,
	    POSTAL_CODE_REGEX_CA: /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/,
	    ATLEAST_ONE_ALPHABET: /^(?=.*[A-Za-z\u00C0-\u017F]).+/,
	    CC_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\&\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	    LAST_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	    /*
	     * Function used to escape double ticks (ADA)
	     **/
	    encode_html: function encode_html(input) {
	      input = input.replace('"', '&#34');
	      input = input.replace('\'', '&#39');
	      input = input.replace(';', '&#59');
	      return input;
	    },
	    /**
	     * Function used to "extend" the bootstap popover capability to add accesibility features
	     * function add a couple of the ADA needed attributes and a couple of keyboard navigation listener
	     * popover parameters are expected to be defined in the element as normal bootsrap popover
	     */
	    accesible_popover: function accesible_popover(selector) {
	      var popoverElement = $(selector);
	      popoverElement.popover().on('keydown', function (event) {
	        if (event.which == 13) $(this).popover('toggle');
	        if (event.which == 27) $(this).popover('hide');
	      }).on('blur', function () {
	        $(this).popover('hide');
	      }).on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	    },
	    /**
	     * This function makes images in popover content tabbable for ADA purposes
	     * @param {string} tooltipClass - Tooltip class.
	     * @return {void}
	     */
	    activateKeyboardAccesiblePopover: function activateKeyboardAccesiblePopover(selector) {
	      var popoverElement = $('.' + selector);
	      popoverElement.popover().on('keydown', function (event) {
	        //Enter event keycode
	        if (event.which === 13) {
	          $(this).popover('toggle');
	          //Esc event keycode
	        } else if (event.which === 27) {
	          $(this).popover('hide');
	          //Shift+Tab event keycode
	        } else if (event.shiftKey && event.keyCode === 9) {
	          $(this).popover('hide');
	        }
	      }).on('focus', function () {
	        $(this).popover('toggle');
	        var tooltipElement = $(this);
	        var popoverContentId = $(this).attr('aria-describedby');
	        if (popoverContentId !== undefined && $('#' + popoverContentId).find('img').length !== 0) {
	          $('#' + popoverContentId).find('img').on('blur', function () {
	            tooltipElement.popover('hide');
	          });
	        }
	      }).on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	      $(':not(.' + selector + ')').on('click', function () {
	        $('.co-help').each(function () {
	          if ($(this).attr('aria-expanded') === 'true') {
	            $(this).popover('hide');
	          }
	        });
	      });
	    },
	    isMinimumScreen: function isMinimumScreen(min) {
	      var width = $(window).width();
	      if (min == 'DESKTOP' && width >= 1025) return true;
	      if (min == 'TABLET-LANDSCAPE' && width >= 769) return true;
	      if (min == 'TABLET-PORTRAIT' && width >= 668) return true;
	      if (min == 'PHONE-LANDSCAPE' && width >= 376) return true;
	      if (min == 'PHONE-PORTRAIT' && width >= 0) return true;
	      return false;
	    },
	    isMaxScreen: function isMaxScreen(min) {
	      var width = $(window).width();
	      if (min == 'DESKTOP' && width < 1024) return true;
	      if (min == 'TABLET-LANDSCAPE' && width < 769) return true;
	      if (min == 'TABLET-PORTRAIT' && width < 668) return true;
	      if (min == 'PHONE-LANDSCAPE' && width < 376) return true;
	      if (min == 'PHONE-PORTRAIT' && width >= 0) return true;
	      return false;
	    },
	    /**
	     * External link dialog for FORMS ONLY.
	     */
	    createExternalLinkDialogForForm: function createExternalLinkDialogForForm(link, form, submitButtonTitle) {
	      var dialogDiv = $('<div id="external_link_dialog">' + $('<div>').append(form.clone()).html() + '<span>' + messages.JS_LEAVING_DOMAIN_ALERT.replace('{0}', this.hostname) + '</span></div>');
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_EXTERNAL_LINK,
	        body: dialogDiv,
	        primary: submitButtonTitle,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          $('#external_link_dialog form').submit();
	          $('.costcoModalBtn1').first().click();
	        }
	      });
	      return false;
	    },
	    /**
	     * Return an array with only unique members. unique([1,2,1])
	     * returns [2,1]
	     * @param  {[array]} arr - The array with duplicated members
	     * @return {[array]} out - The array with unique members
	     */
	    unique: function unique(arr) {
	      var seen = {},
	          out = [],
	          len = arr.length,
	          j = 0;
	      for (var i = 0; i < len; i++) {
	        var item = arr[i];
	        if (seen[item] !== 1) {
	          seen[item] = 1;
	          out[j++] = item;
	        }
	      }
	      return out;
	    },
	    /**
	     * Return an array with a string interpolated between
	     * each member i.e. interpolate([1,2],'+') returns [1,"+",2]
	     * @param  {[array]} array - The array to interpolate
	     * @param  {[type]} string - the element to interpolate in the array
	     * @return {[type]} _array - The interpolated array
	     */
	    interpolate: function interpolate(array, _string) {
	      var _array = [];
	      for (var i = 0, len = array.length; i < len; i++) {
	        _array.push(array[i]);
	        if (i != array.length - 1) {
	          _array.push(_string);
	        }
	      }
	      return _array;
	    },
	    // Added for submitting encoded values without special characters
	    encodeExclSpecialChars: function encodeExclSpecialChars(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0,
	          enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = COSTCO.util._utf8_encode(input);
	      while (i < input.length) {
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	        enc1 = chr1 >> 2;
	        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	        enc4 = chr3 & 63;
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	        output = output + this._keyStrExcl.charAt(enc1) + this._keyStrExcl.charAt(enc2) + this._keyStrExcl.charAt(enc3) + this._keyStrExcl.charAt(enc4);
	      }
	      return output;
	    },
	    // public method for decoding
	    decodeExclSpecialChars: function decodeExclSpecialChars(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0;
	      var enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	      while (i < input.length) {
	        enc1 = this._keyStrExcl.indexOf(input.charAt(i++));
	        enc2 = this._keyStrExcl.indexOf(input.charAt(i++));
	        enc3 = this._keyStrExcl.indexOf(input.charAt(i++));
	        enc4 = this._keyStrExcl.indexOf(input.charAt(i++));
	        chr1 = enc1 << 2 | enc2 >> 4;
	        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	        chr3 = (enc3 & 3) << 6 | enc4;
	        output = output + String.fromCharCode(chr1);
	        if (enc3 != 64) {
	          output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	          output = output + String.fromCharCode(chr3);
	        }
	      }
	      output = COSTCO.util._utf8_decode(output);
	      output = output.replace(/[\u0000-\u0019]+/g, ''); // For removing the non-printable & Invalid JSON characters.
	      return output;
	    },
	    addresses: [],
	    addressLoadState: {
	      shipping: {
	        requested: 0,
	        loaded: 0
	      },
	      billing: {
	        requested: 0,
	        loaded: 0
	      }
	    },
	    resetAddressLoadState: function resetAddressLoadState() {
	      COSTCO.util.addresses = [];
	      COSTCO.util.addressLoadState = {
	        shipping: {
	          requested: 0,
	          loaded: 0
	        },
	        billing: {
	          requested: 0,
	          loaded: 0
	        }
	      };
	    },
	    getAddressBatchPage: function getAddressBatchPage(addressType, filterName, filterOrder, total, processBatch, processPagination) {
	      var start = 1,
	          end = total;;
	      if (addressType == 'S') {
	        addressLoadState = COSTCO.util.addressLoadState.shipping;
	      } else {
	        addressLoadState = COSTCO.util.addressLoadState.billing;
	      }
	      if (addressLoadState.requested == 0) {
	        COSTCO.util.getAddressBatch(addressType, filterName, filterOrder, start, total, processBatch, processPagination);
	      } else {
	        if (total > addressLoadState.requested) {
	          COSTCO.util.getAddressBatch(addressType, filterName, filterOrder, addressLoadState, total + addressLoadState.requested, processBatch, processPagination);
	        } else {
	          if (typeof processBatch === 'function') processBatch(COSTCO.util.addresses);
	          if (typeof processPagination === 'function') processPagination(COSTCO.util.addresses);
	        }
	      }
	    },
	    /* getAddresses
	     * arguments can contain a list of callback functions to be executed on .done.  The last arg is a optional addressType (S || B) that retrieves a filtered list of addresses
	     * */
	    getAddressBatch: function getAddressBatch(addressType, filterName, filterOrder, start, end, processBatch, processPagination) {
	      // request the user's addresses 
	
	      COSTCO.util.ajax({
	        url: '/AjaxCostcoGetAddressCmd?requesttype=ajax',
	        method: 'GET',
	        dataType: 'json',
	        data: {
	          addressType: encodeURIComponent(addressType),
	          filterName: encodeURIComponent(filterName),
	          filterOrder: encodeURIComponent(filterOrder),
	          start: encodeURIComponent(start),
	          end: encodeURIComponent(end)
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          try {
	            if (addressType == 'S') {
	              COSTCO.util.addressLoadState.shipping.requested += parseInt(end);
	              COSTCO.util.addressLoadState.shipping.loaded += parseInt(data.totalrecords);
	            } else {
	              COSTCO.util.addressLoadState.billing.requested += parseInt(end);
	              COSTCO.util.addressLoadState.billing.loaded += parseInt(data.totalrecords);
	            }
	            if (typeof data.addresses !== 'undefined') {
	              COSTCO.util.mergeAddresses(JSON.parse(data.addresses));
	            }
	          } catch (err) {
	            //
	            console.error(err, 'Parse error');
	          }
	          if (typeof processBatch === 'function') processBatch(data);
	          if (typeof processPagination === 'function') processPagination(data);
	        }
	      });
	    },
	    mergeAddresses: function mergeAddresses(data) {
	      for (var i = 0; i < data.length; i++) {
	        if (data[i].hasOwnProperty('addressId')) {
	          COSTCO.util.renameArray(data[i], COSTCO.util.addressNamingMap);
	        }
	      }
	      COSTCO.util.addresses = COSTCO.util.addresses.concat(data);
	    },
	    /**
	     * Add every unique address from 'addresses' to
	     * COSTCO.util.addresses
	     * @param  {array} addresses [
	     * @return {void}
	     */
	    concatNonDuplicates: function concatNonDuplicates(addresses) {
	      var _this = this;
	
	      addresses.forEach(function (address) {
	        if (!_this.any(_this.addresses, function (x) {
	          return x.id == address.id;
	        })) {
	          _this.addresses.push(address);
	        }
	      });
	    },
	    /*
	     * Address naming is a mess
	     */
	    addressNamingMap: {
	      addressId: 'id',
	      addressTypeId: 'addressType',
	      addressLine1: 'line1',
	      addressLine2: 'line2',
	      firstName: 'first',
	      lastName: 'last',
	      companyName: 'company',
	      primary: 'isPrimary',
	      postalCode: 'zip',
	      middleName: 'mInitial',
	      emailAddress: 'email',
	      fName: 'first',
	      lName: 'last',
	      pNumber: 'phone'
	    },
	    renameArray: function renameArray(data, map) {
	      for (var key in data) {
	        if (data.hasOwnProperty(key) && map.hasOwnProperty(key)) {
	          data[map[key]] = data[key];
	          delete data[key];
	        }
	      }
	    },
	    unbindEvents: function unbindEvents(obj) {
	      Object.keys(obj).forEach(function (key) {
	        $(obj[key]).unbind('click').unbind('blur').unbind('change').unbind('touchstart');
	      });
	    },
	    /**
	     * Function used to notify the native web application that the user has been sucessfully
	     * logged out of the costco website. This is needed as the app relies upon web view
	     */
	    notifyAppLogout: function notifyAppLogout() {
	      console.log('notifying app of logout');
	      try {
	        if (typeof Android != 'undefined') {
	          Android.logoutCostcoApp();
	        } else if (typeof webkit != 'undefined') {
	          webkit.messageHandlers.logoutAction.postMessage('success');
	        }
	      } catch (e) {
	        console.warn(e);
	      }
	    },
	    removeParam: function removeParam(key, sourceURL) {
	      var rtn = sourceURL.split('?')[0],
	          param = void 0,
	          params_arr = [],
	          queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
	      if (queryString !== '') {
	        params_arr = queryString.split('&');
	        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
	          param = params_arr[i].split('=')[0];
	          if (param === key) {
	            params_arr.splice(i, 1);
	          }
	        }
	        rtn = rtn + '?' + params_arr.join('&');
	      }
	      return rtn;
	    },
	    /**
	     * Politically incorrect method for turning an array of objects in the form
	     * of [{name:'hi',value:'robert'},{}..] into an equivalent object
	     * '{hi: 'robert', hey: 'robert'}'. $(form).serializeArray() will return
	     * the array of objects we're looking to convert
	     * @param  {Array} arr The array of objects.
	     * @return {Object}    The object equivalent of arr
	     */
	    objectifyArray: function objectifyArray(arr) {
	      var obj = {};
	      arr.forEach(function (arrObj) {
	        obj[arrObj.name] = arrObj.value;
	      });
	      return obj;
	    },
	
	    /**
	     * Utility function for adjusting heights of arbitrary numbner of divs, setting it to the 'tallest' value
	     * For this to happen two things must be the case:
	     * #1 All the DIVs that need to be aligned should have same unique css class applied (convention is costco-align-height-some-arbitrary-name)
	     * #2 call the function with string denoting applied class name, e.g. :
	     *		adjustDivHeights('.costco-align-height-some-arbitrary-name');
	     */
	
	    /* Compare heights of all divs with applied css class and increase the 'smaller' ones to the height of the tallest */
	    adjustDivHeights: function adjustDivHeights(alignClass, defaultHeight) {
	      $arrDivs = $(alignClass);
	      if ($arrDivs != null && $arrDivs.length > 0) {
	        max = 0;
	        $arrDivs.each(function () {
	          max = Math.max(max, parseInt($(this).height()));
	        });
	        if (max == 0 && typeof defaultHeight != 'undefined') {
	          max = defaultHeight;
	        }
	        $arrDivs.each(function () {
	          if ($(this).height() != max) {
	            $(this).height(max);
	          }
	        });
	      }
	    },
	    /**
	     * Capitalize a given string. Takes a string of form "Hi there Robert" and
	     * returns "Hi There Robert".
	     * @param  {String} str The string to capitalize
	     * @return {String}     The capitalized string.
	     */
	    capitalize: function capitalize(str) {
	      return str.split(' ').map(function (x) {
	        return x.charAt().toUpperCase().concat(x.substr(1));
	      }).join(' ');
	    },
	    isUsOrCaZipCode: function isUsOrCaZipCode() {
	      if ($('#B_countryId').length > 0 || $('#countryId').length > 0) {
	        return COSTCO.util.isUSOrCaAddressZip();
	      } else {
	        var storeId = wcs.storeId;
	        switch (storeId) {
	          case '10301':
	            return true;
	          case '10302':
	            return false;
	          case '11301':
	            return true;
	          default:
	            return false;
	        }
	      }
	    },
	    isUSOrCaAddressZip: function isUSOrCaAddressZip() {
	      var selCountry = $('#B_countryId').length > 0 ? $('#B_countryId').val() : $('#countryId').val();
	      selCountry = selCountry + wcs.storeId;
	      switch (selCountry) {
	        case 'US10301':
	          return true;
	        case 'CA10301':
	          return false;
	        case 'US10302':
	          return true;
	        case 'CA10302':
	          return false;
	        case 'US11301':
	          return true;
	        case 'CA11301':
	          return false;
	        case 'US11303':
	          return true;
	        case 'CA11303':
	          return false;
	        default:
	          return 'false';
	      }
	    },
	    getMaxHeight: function getMaxHeight(elems) {
	      return Math.max.apply(null, elems.map(function () {
	        return $(this).height();
	      }).get());
	    },
	    /**
	     * Checks if the current context is related to a grocery product. 
	     */
	    is2DayFlow: function is2DayFlow() {
	      var is2DayFlow = $('#groceryIdentifier').length > 0 && $('#groceryIdentifier').val() == 'true' ? true : false;
	      return is2DayFlow;
	    },
	    isLTLDeliveryServicesEnabled: function isLTLDeliveryServicesEnabled() {
	      var ltlDeliveryServicesEnableFlag = $('#deliveryServicesEnabled').length > 0 && $('#deliveryServicesEnabled').val() == 'true' ? true : false;
	      return ltlDeliveryServicesEnableFlag;
	    },
	
	    /**
	     * dob Validation- Month and date range validation and leap year validation.
	     * @param month 
	     * @param day
	     * @param year 
	     */
	    dateValidation: function dateValidation(month, day, year) {
	      var isDateValid = false;
	      var currentYear = new Date().getFullYear();
	      var beginningYear = currentYear - 100;
	      if (typeof year !== 'undefined' && year !== "" && (year < beginningYear || year > currentYear)) {
	        isDateValid = false;
	      } else if ((month === "04" || month === "06" || month === "09" || month === "11") && day <= 30 && day >= 1) {
	        isDateValid = true;
	      }
	      // check for february 29th
	      else if (month === "02") {
	          var isleap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
	          if (day >= 1 && (day < 29 || day === "29" && isleap)) {
	            isDateValid = true;
	          }
	        }
	        // Check for month and day range
	        else if (month >= 1 && month <= 12 && day <= 31 && day >= 1) {
	            isDateValid = true;
	          } else {
	            if ((month === "" || typeof month === 'undefined') && (year === "" || typeof year === 'undefined') && (COSTCO.util.isCAStore() || day === "" || typeof day === 'undefined')) {
	              isDateValid = true;
	            }
	          }
	      return isDateValid;
	    },
	    /**
	     * Function used to check if Global error exists on page.
	     * @return {Boolean}
	     */
	    isGlobalErrorOnPage: function isGlobalErrorOnPage() {
	      var isGlobalError = false;
	      var errorClasses = COSTCO.util.globalErrorElementClasses;
	
	      jQuery.each(errorClasses, function (index, value) {
	        $('.' + value).each(function () {
	          if ($(this) !== 'undefined' && $(this).html() !== 'undefined' && $(this).html().trim().lenght > 0 || $(this).children() !== 'undefined' && $(this).children().html() !== undefined && $(this).children().html().trim().length > 0) {
	            var innerContent = $(this).children().html() !== undefined ? $(this).children().html() : $(this).html();
	            if ($(this).length > 0 && innerContent.length > 1) {
	              isGlobalError = true;
	            }
	          }
	        });
	      });
	
	      return isGlobalError;
	    },
	
	    /**
	     * Populates announcement screen reader div on page load
	     */
	    announceSRGlobalErrorMessage: function announceSRGlobalErrorMessage() {
	      if (COSTCO.util.isGlobalErrorOnPage()) {
	        var errorElement = COSTCO.util.getFirstGlobalErrorOnPage($('body'));
	        if (errorElement !== undefined && errorElement !== null && errorElement.text() !== "") {
	          var eMessage = errorElement.text();
	          COSTCO.util.announceSRErrorMessage(eMessage);
	        }
	      }
	    },
	
	    /**
	     * Function used to monitor screen reader announcement div element for changes
	     */
	    resetScreenReaderAnnouncement: function resetScreenReaderAnnouncement() {
	      var targetObject = document.querySelector("#screen-reader-announcement");
	      var observerObject = new MutationObserver(function (mutationRecordsList) {
	        mutationRecordsList.forEach(function (mutation) {
	          if ("attributes" === mutation.type || "childList" === mutation.type || "subtree" === mutation.type) {
	            setTimeout(function () {
	              $(targetObject).empty();
	            }, 2000);
	          }
	        });
	      });
	      if (targetObject !== undefined && targetObject !== null) {
	        observerObject.observe(targetObject, {
	          attributes: true,
	          attributeOldValue: true,
	          childList: true,
	          subtree: true,
	          characterData: true
	        });
	      }
	    },
	
	    /**
	     * Function used to inject error message in screen reader placeholder announcement div
	     * @param error message to be injected
	     */
	
	    announceSRErrorMessage: function announceSRErrorMessage(errorMessage) {
	      try {
	        errorMessage = errorMessage.trim();
	        var htmlContent = $.parseHTML(errorMessage);
	
	        if (htmlContent != null && !htmlContent.filter(function (e) {
	          return e instanceof HTMLElement;
	        }).length) {
	          errorMessage = '<p>' + errorMessage + '</p>';
	        }
	
	        var errorToAnnounce = $(errorMessage).html() !== undefined ? $(errorMessage).html() : errorMessage;
	        COSTCO.util.announceSRMessage(messages.ERROR + ' ' + errorToAnnounce);
	      } catch (error) {
	        console.log("Error occurred while announcing SR message! Error: " + error);
	      }
	    },
	
	    /**
	     * Moves the specified section to keep it in view when user scrolls.
	     * The section only moves if the screen is Tablet Landscape or wider.
	     * @param {string} elementId	ID of html element which is in view when user scrolls
	     * @param {string} topReferenceElementId	ID of element which is initially top-aligned with "sticky element"
	     * @param {string} bottomReferenceElementId ID of an element which presents a bottom limit to a moving "sticky element"
	     */
	    makeElementSticky: function makeElementSticky(elementId, topReferenceElementId, bottomReferenceElementId) {
	
	      var makeElementStickyFunction = function makeElementStickyFunction() {
	
	        var stickyElement = $('#' + elementId);
	        var topReferenceElement = $('#' + topReferenceElementId);
	        var bottomReferenceElement = $('#' + bottomReferenceElementId);
	
	        var bottomReference = bottomReferenceElement.offset().top;
	
	        if (stickyElement.length > 0 && topReferenceElement.length > 0) {
	          var topReference = topReferenceElement.offset().top + topReferenceElement.height();
	
	          var currentTranslateY = parseFloat(stickyElement.css('transform').split(',')[5]) || 0;
	          var translateY = -stickyElement[0].getBoundingClientRect().top + currentTranslateY;
	          var maxDistance = bottomReference - topReference - stickyElement.height();
	
	          if (translateY > maxDistance) {
	            translateY = maxDistance;
	          } else if (translateY < 0) {
	            translateY = 0;
	          }
	
	          stickyElement.css({
	            '-webkit-transform': 'translateY(' + translateY + 'px)',
	            '-moz-transform': 'translateY(' + translateY + 'px)',
	            '-ms-transform': 'translateY(' + translateY + 'px)',
	            '-o-transform': 'translateY(' + translateY + 'px)',
	            'transform': 'translateY(' + translateY + 'px)'
	          });
	        }
	      };
	      $(window).on('scroll wheel DOMMouseScroll mousewheel resize', function (evt) {
	        // remove all transforms if screen is not at least tablet landscape
	        if (COSTCO.util.isMaxScreen('TABLET-LANDSCAPE')) {
	          $('#' + elementId).css({
	            '-webkit-transform': '',
	            '-moz-transform': '',
	            '-ms-transform': '',
	            '-o-transform': '',
	            'transform': ''
	          });
	        } else {
	          makeElementStickyFunction();
	        }
	      });
	    },
	    preventBackButtonForSso: function preventBackButtonForSso(referer) {
	
	      try {
	        setTimeout(function () {
	          history.pushState(null, null, window.location);
	          window.addEventListener('popstate', function (event) {
	            if (referer != null && referer != undefined && referer != '' && (referer.indexOf('signin-qa.costco.com') > -1 || referer.indexOf('signin.costco.com') > -1)) {
	              alert(1);
	              history.pushState(null, null, window.location);
	            }
	          });
	        }, 5000);
	      } catch (e) {
	        console.error(e);
	      }
	    },
	    /**
	     * Method return date in yyyy-dd-mm-dd format
	     */
	    formatCalendarDate: function formatCalendarDate(date, separator) {
	      var d = new Date(date),
	          month = '' + (d.getMonth() + 1),
	          day = '' + d.getDate(),
	          year = d.getFullYear();
	
	      if (month.length < 2) month = '0' + month;
	      if (day.length < 2) day = '0' + day;
	      if (separator === '-') {
	        return [year, month, day].join('-');
	      } else {
	        return [month, day, year.toString().substr(-2)].join('/');
	      }
	    },
	    getAllCalendarAvailableDates: function getAllCalendarAvailableDates(dates) {
	      var availableDates = [];
	      dates.forEach(function (allowed_obj) {
	        if (allowed_obj.date_str) {
	          var date = new Date(allowed_obj.date_obj);
	          var timeZoneCorrectDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
	          // East of GMT
	          if (date.getTimezoneOffset() < 0) {
	            timeZoneCorrectDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
	          }
	          var formattedDate = timeZoneCorrectDate.toJSON().split("T")[0];
	          var availableFormatedDate = formattedDate.split('-')[1] + '/' + formattedDate.split('-')[2] + '/' + formattedDate.split('-')[0];
	          availableDates.push(availableFormatedDate);
	        }
	      });
	      return availableDates;
	    },
	
	    //Controls continue button on Membership Privileges and Conditions page
	    continueAfterTermsAccepted: function continueAfterTermsAccepted() {
	      if ($("#tnc-checkbox").attr("value") == "true") {
	        if ($('#upgradeOnly').val() == "true") {
	          window.location.href = '/QuickMembershipCheckoutCmd?isTandCAccepted=true&upgradeOnly=true';
	        } else {
	          window.location.href = '/QuickMembershipCheckoutCmd?isTandCAccepted=true';
	        }
	      } else {
	
	        $(".membership-tnc-checkbox-main").css({ 'border': '2px solid #D32029', 'margin': '0px' });
	        $("#terms-conditions-error").removeClass("hidden").css('margin-bottom', '20px');
	        $('#tnc-checkbox').focus();
	        $("#tnc-checkbox").attr("aria-describedby", "terms-conditions-error");
	      }
	    },
	
	    //Functionality for accept check box on Membership Privileges and Conditions page 
	    toggleTermsCheckbox: function toggleTermsCheckbox() {
	      if ($("#tnc-checkbox").attr("value") == "false") {
	        $("#tnc-checkbox").removeAttr("aria-describedby");
	        $("#tnc-checkbox").attr("value", "true");
	        $("#tnc-checkbox").attr("checked", "checked");
	        if (!$("#terms-conditions-error").hasClass("hidden")) {
	          $("#terms-conditions-error").addClass("hidden");
	          $(".membership-tnc-checkbox-main").css({ 'border': '1px solid #cccccc', 'margin': '5px 0px 20px 0px' });
	        }
	      } else {
	        $("#tnc-checkbox").attr("value", "false");
	        $("#tnc-checkbox").removeAttr("checked");
	      }
	    },
	
	    // function for sanitizing data to prevent XSS attacks
	    replaceSpecialChars: function replaceSpecialChars(obj) {
	      var result = new String(obj);
	
	      result = result.replace(/&/g, "&amp;");
	      result = result.replace(/</g, "&lt;");
	      result = result.replace(/>/g, "&gt;");
	      result = result.replace(/'/g, "&#39;");
	      result = result.replace(/"/g, "&quot;");
	      result = result.replace(/\//g, "&#47;");
	      result = result.replace(/\\/g, "&#92;");
	
	      return result;
	    },
	
	    scrubSpecialChars: function scrubSpecialChars(obj) {
	      var result = new String(obj);
	      result = result.replace(/[\%\$\`\\\*\<\>\(\)]*/g, '');
	      return result;
	    },
	
	    scrubSpecialCharsFromCompanyName: function scrubSpecialCharsFromCompanyName(obj) {
	      var result = new String(obj);
	      result = result.replace(/[\%\$\`\~\*\<\>]*/g, '');
	      return result;
	    }
	
	  };
	
	  return util;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title membership-helper.js: utility module
	 * @description Helper for membership specific modules
	 * @author kmedz
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12), __webpack_require__(13), __webpack_require__(14), __webpack_require__(17), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (membershipData, addressForm, address, addressVerification, accountHelper) {
	  var MembershipHelper = {
	    /**
	     * Initializes the module with the specific membership type, which is
	     * defined in MembershipApplication_PreloadData.jspf
	     * @return {void} [description]
	     */
	    init: function init() {
	      this.membershipType = membershipType;
	
	      if (typeof totalFee !== 'undefined') {
	        this.totalFee = totalFee;
	      }
	      if (typeof membershipFee !== 'undefined') {
	        this.membershipFee = membershipFee;
	      }
	
	      $('#postalcode').val('');
	      $('#businessZipCode').val('');
	    },
	    isQuickMembership: false,
	    /**
	     * When we create an affiliate form we need to populate things like
	     * the date of birth selectors, do the fancy bing zip thing, etc.
	     * @param {jQuery.Element} form - The form containing the inputs we want
	     *                              to modify
	     * @return {void}
	     */
	    formWizBangs: function formWizBangs(form) {
	      // 5.2 Populate the appropriate inputs. Do the fancy masking stuff.
	      // Date of birth inputs
	      this.dobPopulate('#' + form.attr('id'), 100);
	
	      /** Membership DOB month field numeric restriction and appending 0 before 1-9 value */
	      form.find('[name=month],[name=household_month],[name=householdDobMonth],[name=dobmonth],[name=MembershipCrmCallerInfo_dobEditMonth]').on({
	        'focusout': function focusout(event) {
	          MembershipHelper.prependZero(event);
	        }
	      });
	
	      /** Membership DOB day field numeric restriction and appending 0 before 1-9 value */
	      form.find('[name=day],[name=household_day],[name=householdDobDay],[name=dobday],[name=MembershipCrmCallerInfo_dobEditDay]').on({
	        'focusout': function focusout(event) {
	          MembershipHelper.prependZero(event);
	        }
	      });
	
	      /** Membership DOB year field numeric restriction */
	      form.find('[name=year],[name=household_year],[name=householdDobYear],[name=dobyear],[name=MembershipCrmCallerInfo_dobEditYear]').on({});
	
	      var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
	      // Populate state select box if the DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED feature is not enabled.
	      if (form.find('.state-select').length) {
	        var stateProvList = this.getStateProvJson();
	        var stateOptions = this.getStateOptions(stateProvList);
	        var $selects = isDeriveCityStateEnabled ? form.find('.state-select') : form.find('.state-select').append(stateOptions);
	        $selects.each(function (i, select) {
	          // If the select has a readonly attribute, disable all options
	          // except the currently selected option.
	          if ($(select).attr('readonly')) {
	            // will return "readonly"
	            $(select).find('option').attr('disabled', 'disabled');
	          }
	        });
	      }
	      // Bing City State autocomplete
	      // Personal information
	      form.find('[name=postalcode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	
	        if (value != null && value != '' && value.trim().length > 4) {
	          var region = COSTCO.util.isUsOrCaZipCode();
	          if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	            this.bingCityState(event.currentTarget, '[name=city]', '[name=state]');
	          }
	          if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	            if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	              this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	            }
	            if (!region) {
	              if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	            }
	          }
	        }
	      }.bind(this));
	      // Employee Add On (Acocunt Details)
	      form.find('[name=employeeAddon_zip]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=employeeAddon_city]', '[name=employeeAddon_state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=employeeAddon_city]', '[name=employeeAddon_state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=employeeAddon_city]', '[name=employeeAddon_state]');
	          }
	        }
	      }.bind(this));
	      // Business information
	      form.find('[name=businessZipCode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
	          }
	        }
	      }.bind(this));
	      // Affiliate
	      form.find('[name=zip]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=city]', '[name=state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	          }
	        }
	      }.bind(this));
	      // Account Details - Membership Information
	      form.find('[name=MembershipCrmCallerInfo_zipCode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=MembershipCrmCallerInfo_city]', '[name=MembershipCrmCallerInfo_stateDropDown_state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=MembershipCrmCallerInfo_city]', '[name=MembershipCrmCallerInfo_stateDropDown_state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=MembershipCrmCallerInfo_city]', '[name=MembershipCrmCallerInfo_stateDropDown_state]');
	          }
	        }
	      }.bind(this));
	
	      //Business Details - Business Information
	      form.find('[name=MembershipCrmBusiness_zipCode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=MembershipCrmBusiness_city]', '[name=MembershipCrmBusiness_stateDropDown_state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=MembershipCrmBusiness_city]', '[name=MembershipCrmBusiness_stateDropDown_state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=MembershipCrmBusiness_city]', '[name=MembershipCrmBusiness_stateDropDown_state]');
	          }
	        }
	      }.bind(this));
	
	      // Mask inputs
	      this.maskInput(form);
	    },
	    /**
	     * Determine if we're working with a business membership.
	     * @return {Boolean} Is business membership?
	     */
	    isBusinessMembership: function isBusinessMembership() {
	      return this.membershipType === this.membershipTypes.ADDMEMBER_BUSINESS || this.membershipType === this.membershipTypes.ADDMEMBER_BUSINESS_EXECUTIVE;
	    },
	    /**
	     * Sets some static keys representing membership types.
	     * @type {Object}
	     */
	    membershipTypes: {
	      ADDMEMBER_BUSINESS: 'ADDMEMBER_BUSINESS',
	      ADDMEMBER_BUSINESS_EXECUTIVE: 'ADDMEMBER_BUSINESS_EXECUTIVE',
	      ADDMEMBER_GOLDSTAR: 'ADDMEMBER_GOLDSTAR',
	      ADDMEMBER_GOLDSTAR_EXECUTIVE: 'ADDMEMBER_GOLDSTAR_EXECUTIVE'
	    },
	    /**
	     * The selectors for address fields in personal information
	     * @type {Object}
	     */
	    personalAddressSelectors: {
	      label: '[name=primaryAddress]',
	      line1: '[name=address1]',
	      line2: '[name=address2]',
	      city: '[name=city]',
	      state: '[name=state]',
	      country: '[name=country]',
	      zip: '[name=postalcode]'
	    },
	    /**
	     * The selectors for address fields in business information.
	     * @type {Object}
	     */
	    businessAddressSelectors: {
	      label: '[name=businessAddress]',
	      line1: '[name=businessAddressLine1]',
	      line2: '[name=businessAddressLine2]',
	      city: '[name=businessCity]',
	      state: '[name=businessState]',
	      country: '[name=businessCountry]',
	      zip: '[name=businessZipCode]'
	    },
	    /**
	     * The selectors for address fields in the affiliate modal.
	     * @type {Object}
	     */
	    affiliateAddressSelectors: {
	      label: '[name=affiliateAddress]',
	      line1: '[name=line1]',
	      line2: '[name=line2]',
	      city: '[name=city]',
	      state: '[name=state]',
	      country: '[name=country]',
	      zip: '[name=zip]',
	      fName: '[name=fname]',
	      lName: '[name=lname]'
	    },
	    /**
	     * The selectors for address fields in the Account Details
	     * Membership Information - Primary Information.
	     * @type {Object}
	     */
	    primaryInformationSelectors: {
	      label: '.membership-address-container .title label',
	      line1: '[name=MembershipCrmCallerInfo_addressLine1]',
	      line2: '[name=MembershipCrmCallerInfo_addressLine2]',
	      city: '[name=MembershipCrmCallerInfo_city]',
	      state: '[name=MembershipCrmCallerInfo_stateDropDown_state]',
	      country: '[name=MembershipCrmCallerInfo_stateDropDown_country]',
	      zip: '[name=MembershipCrmCallerInfo_zipCode]',
	      month: '[name=MembershipCrmCallerInfo_dobEditMonth]',
	      day: '[name=MembershipCrmCallerInfo_dobEditDay]',
	      year: '[name=MembershipCrmCallerInfo_dobEditYear]'
	    },
	    /**
	     * The selectors for address fields in the Business Details
	     * Membership Information - Primary Information.
	     * @type {Object}
	     */
	    businessInformationSelectors: {
	      label: '.business-address-container .title label',
	      line1: '[name=MembershipCrmBusiness_addressLine1]',
	      line2: '[name=MembershipCrmBusiness_addressLine2]',
	      city: '[name=MembershipCrmBusiness_city]',
	      state: '[name=MembershipCrmBusiness_stateDropDown_state]',
	      country: '[name=MembershipCrmBusiness_stateDropDown_country]',
	      zip: '[name=MembershipCrmBusiness_zipCode]'
	    },
	    /**
	     * The selectors for address fields in the employee add on section for when
	     * the user is a Employee Primary.
	     * @type {Object}
	     */
	    employeeAddOnSelectors: {
	      label: '.employee-addon > .title span',
	      line1: '[name=employeeAddon_addressLine1]',
	      line2: '[name=employeeAddon_addressLine2]',
	      city: '[name=employeeAddon_city]',
	      state: '[name=employeeAddon_state]',
	      country: '[name=employeeAddon_country]',
	      zip: '[name=employeeAddon_zip]',
	      fName: '[name=employeeAddon_first_name]',
	      lName: '[name=employeeAddon_last_name]'
	    },
	
	    /**
	     * Business specific rules object. Used for clientside validation
	     * @type {Object}
	     */
	    business: {
	      rules: {
	        first_name: { required: true, firstNameValidation: true },
	        lastName: { required: true, lastNameValidation: true },
	        month: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        day: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        year: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        address1: {
	          required: true,
	          valid_address: true,
	          maxlength: 60
	        },
	        address2: {
	          valid_address: true,
	          maxlength: 40
	        },
	        city: {
	          required: true,
	          valid_cityState: true
	        },
	        state: {
	          required: true,
	          valid_cityState: true,
	          notEqual: 'NO_STATE_TYPE_SELECTED',
	          hasvalidationerror: true
	        },
	        postalcode: {
	          required: true,
	          minlength: 5
	        },
	        email: {
	          required: true,
	          singleemail: true,
	          email: false
	        },
	        emailConfirm: {
	          required: true,
	          singleemail: true,
	          equalTo: '#email',
	          email: false
	        },
	        // country : 'required',
	        contactPhoneNumber: {
	          required: true,
	          phone: true
	        },
	        mobilePhoneNumber: {
	          required: false,
	          phone: true,
	          promo: true
	        },
	        // awarenessCode: {required: false, validCode : true},
	        shippingNickname: {
	          copyAddress: true
	        },
	        billingNickname: {
	          copyAddress: true
	        },
	        businessNameEdit: 'required',
	        businessAddressLine1: {
	          required: true,
	          valid_address: true,
	          maxlength: 30
	        },
	        businessAddressLine2: {
	          valid_address: true,
	          maxlength: 30
	        },
	        businessCity: {
	          required: true,
	          valid_cityState: true
	        },
	        businessState: {
	          required: true,
	          valid_cityState: true,
	          notEqual: 'NO_STATE_TYPE_SELECTED',
	          hasvalidationerror: true
	        },
	        // businessCountry : 'required',
	        businessZipCode: {
	          required: true,
	          minlength: 5
	        },
	        businessPhone: {
	          required: true,
	          phone: true
	        },
	        businessEmail: {
	          required: true,
	          singleemail: true,
	          email: false
	        },
	        businessEmailConfirm: {
	          required: true,
	          singleemail: true,
	          email: false,
	          equalTo: '#businessEmail'
	        }
	      },
	
	      messages: function (_messages) {
	        function messages() {
	          return _messages.apply(this, arguments);
	        }
	
	        messages.toString = function () {
	          return _messages.toString();
	        };
	
	        return messages;
	      }(function () {
	        return {
	          month: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	          year: { required: messages.ERR_INVALID_YEAR_REQUIRED },
	          businessNameEdit: messages.ERR_INVALID_BUSINESS_NAME,
	          businessAddressLine1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH
	          },
	          businessAddressLine2: {
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH
	          },
	          businessCity: { required: messages.ERR_INVALID_CITY_REQUIRED, valid_cityState: messages.ERR_INVALID_CITY_NAME },
	          businessState: { required: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED, valid_cityState: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED },
	          // businessCountry : messages.ERR_INVALID_COUNTRY,
	          businessZipCode: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          businessPhone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          businessEmail: messages.ERR_INVALID_EMAIL_ADDRESS,
	          businessEmailConfirm: {
	            required: messages.ERR_REQUIRED_CONFIRM_EMAIL,
	            equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH
	          },
	          first_name: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          lastName: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          address1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE
	          },
	          address2: {
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH
	          },
	          city: { required: messages.ERR_INVALID_CITY_REQUIRED, valid_cityState: messages.ERR_INVALID_CITY_NAME },
	          state: { required: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED, valid_cityState: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED },
	          postalcode: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          email: messages.ERR_INVALID_EMAIL_ADDRESS,
	          emailConfirm: {
	            required: messages.ERR_REQUIRED_CONFIRM_EMAIL,
	            equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH
	          },
	          // country : messages.ERR_INVALID_COUNTRY,
	          contactPhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
	          mobilePhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
	          // awarenessCode : messages.ERR_AWARENESS_CODE,
	          shippingNickname: messages.ERR_ENTER_UNIQUE_NICKNAME,
	          billingNickname: messages.ERR_INVALID_SHIPPINGNICKNAME
	        };
	      })
	    },
	    /**
	     * Goldstar specific rules object. Used for clientside validation
	     * @type {Object}
	     */
	    goldstar: {
	      rules: {
	        // primary
	        first_name: { required: true, firstNameValidation: true },
	        // alternate name for affiliate
	        fname: { required: true, firstNameValidation: true },
	        // alternate name for employee addon
	        employeeAddon_first_name: { required: true, firstNameValidation: true },
	        lastName: { required: true, lastNameValidation: true },
	        // alternate name for affiliate
	        lname: { required: true, lastNameValidation: true },
	        // alternamte name for employee addon
	        employeeAddon_last_name: { required: true, lastNameValidation: true },
	        month: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        MembershipCrmCallerInfo_dobEditMonth: {
	          required: false,
	          dob: true
	        },
	        MembershipCrmCallerInfo_dobEditDay: {
	          required: false,
	          dob: true
	        },
	        MembershipCrmCallerInfo_dobEditYear: {
	          required: false,
	          dob: true
	        },
	
	        // alternate name for affiliate
	        dobmonth: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        day: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        // alternate name for affiliate
	        dobday: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        year: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        // alternate name for affiliate
	        dobyear: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        address1: {
	          required: true,
	          valid_address: true,
	          maxlength: 60
	        },
	        address2: {
	          maxlength: 40,
	          valid_address: true
	        },
	        // alternate names for employee addon
	        employeeAddon_addressLine1: {
	          required: true,
	          valid_address: true
	        },
	        employeeAddon_addressLine2: {
	          valid_address: true
	        },
	        employeeAddon_city: {
	          required: true,
	          valid_cityState: true
	        },
	        employeeAddon_state: {
	          required: true,
	          valid_cityState: true,
	          notEqual: 'NO_STATE_TYPE_SELECTED',
	          hasvalidationerror: true
	        },
	        employeeAddon_zip: {
	          required: true,
	          minlength: 5
	        },
	        // alternate name for affiliate
	        line1: {
	          required: true,
	          valid_address: true
	        },
	        line2: {
	          valid_address: true
	        },
	        city: {
	          required: true,
	          valid_cityState: true
	        },
	        state: {
	          required: true,
	          valid_cityState: true,
	          notEqual: 'NO_STATE_TYPE_SELECTED',
	          hasvalidationerror: true
	        },
	        postalcode: {
	          required: true,
	          minlength: 5
	        },
	        // alternate name for affiliate
	        zip: {
	          required: true,
	          minlength: 5
	        },
	        email: {
	          required: true,
	          singleemail: true,
	          email: false,
	          emailEmpty: true
	        },
	        emailConfirm: {
	          required: true,
	          singleemail: true,
	          equalTo: '#email',
	          email: false,
	          emailEmpty: true
	        },
	        // alternate name for employee add on
	        employeeAddon_email: {
	          required: false,
	          singleemail: true
	        },
	        employeeAddOn_email_confirm: {
	          required: false,
	          singleemail: true,
	          equalTo: '#employeeAddon_email'
	        },
	        // country : 'required',
	        contactPhoneNumber: {
	          required: true,
	          phone: true
	        },
	        // alternate name for affiliate
	        cphone: {
	          required: false,
	          phone: true
	        },
	        mobilePhoneNumber: {
	          required: false,
	          phone: true,
	          promo: true
	        },
	        // alternate name for affiliate
	        mphone: {
	          required: false,
	          phone: true,
	          promo: true
	        },
	        // alternate name for employee add on
	        employeeAddon_contact_phone: {
	          required: true,
	          phone: true
	        },
	        employeeAddon_mobile: {
	          required: false,
	          phone: true,
	          promo: true
	        }
	      },
	      messages: function (_messages2) {
	        function messages() {
	          return _messages2.apply(this, arguments);
	        }
	
	        messages.toString = function () {
	          return _messages2.toString();
	        };
	
	        return messages;
	      }(function () {
	        return {
	          first_name: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          month: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	          year: { required: messages.ERR_INVALID_YEAR_REQUIRED },
	          dobmonth: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	          householdDobYear: { required: messages.ERR_INVALID_YEAR_REQUIRED },
	          householdDobMonth: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	          dobyear: { required: messages.ERR_INVALID_YEAR_REQUIRED },
	          // alternate for affiliate
	          fname: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          // For Account Details
	          householdFname: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          // For Employee Add On
	          employeeAddon_first_name: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          lastName: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          // alternate for affiliate
	          lname: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          // For Account Details
	          householdLname: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          // For Employee Add On
	          employeeAddon_last_name: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          address1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE
	          },
	          address2: {
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH
	          },
	          // alternate for employee add on
	          employeeAddon_addressLine1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          employeeAddon_addressLine2: {
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          employeeAddon_city: {
	            required: messages.ERR_INVALID_CITY_REQUIRED,
	            valid_cityState: messages.ERR_INVALID_CITY_NAME
	          },
	          employeeAddon_state: {
	            required: messages.ERR_INVALID_STATE_NAME,
	            valid_cityState: messages.ERR_INVALID_STATE_NAME
	          },
	          employeeAddon_zip: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          // alternate for affiliate
	          line1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          line2: {
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          city: {
	            required: messages.ERR_INVALID_CITY_REQUIRED,
	            valid_cityState: messages.ERR_INVALID_CITY_NAME
	          },
	          state: {
	            required: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED,
	            valid_cityState: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED
	          },
	          postalcode: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          // alternate for affiliate
	          zip: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          email: messages.ERR_INVALID_EMAIL,
	          emailConfirm: {
	            required: messages.ERR_REQUIRED_CONFIRM_EMAIL,
	            equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH
	          },
	          equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH,
	          // alternate for employee add on
	          employeeAddon_email: messages.ERR_INVALID_EMAIL,
	          // country : messages.ERR_INVALID_COUNTRY,
	          contactPhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
	          // alternate for affiliate
	          cphone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          mobilePhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
	          // alternate for affiliate
	          mphone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          // alternate for employee add on
	          employeeAddon_contact_phone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          employeeAddon_mobile: messages.ERR_INVALID_PHONE_10_DIGIT
	        };
	      })
	    },
	    /**
	     * Extend a 'business' or 'goldstar' rules object with household
	     * rules.
	     * @param  {Object} rules The rules object to extend
	     * @param  {boolean} required OPTIONAL make something required
	     * @return {void}
	     */
	    addHouseholdRules: function addHouseholdRules(rules, required, validator_messages) {
	      required = required || false;
	      $.extend(rules, {
	        household_first_name: {
	          required: false,
	          firstNameValidation: true,
	          household_gold: true
	        },
	        // Affiliate alternate
	        householdFname: {
	          required: required || false,
	          firstNameValidation: true,
	          household_gold: required === true ? false : true
	        },
	        household_lastName: {
	          required: false,
	          lastNameValidation: true,
	          household_gold: true
	        },
	        // Affiliate alternate
	        householdLname: {
	          required: required || false,
	          lastNameValidation: true,
	          household_gold: required === true ? false : true
	        },
	        household_month: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        // Affiliate alternate
	        householdDobMonth: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        household_day: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        // Affiliate alternate
	        householdDobDay: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        household_year: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        // Affiliate alternate
	        householdDobYear: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        household_email: {
	          required: false,
	          singleemail: true,
	          household_gold: false,
	          email: false,
	          emailEmpty: true
	        },
	        household_emailConfirm: {
	          required: false,
	          singleemail: true,
	          equalTo: '#household_email',
	          email: false,
	          emailEmpty: true
	        },
	        // Affiliate alternate
	        householdEmail: {
	          required: false,
	          singleemail: true,
	          household_gold: false,
	          email: false,
	          emailEmpty: true
	        },
	        // Affiliate alternate
	        householdEmailConfirm: {
	          required: false,
	          singleemail: true,
	          equalTo: '#household_email_affiliate',
	          email: false,
	          emailEmpty: true
	        },
	        // Alternate for Account Details
	        householdEmailConfirmdetails: {
	          required: false,
	          singleemail: true,
	          equalTo: '#email-details',
	          email: false,
	          emailEmpty: true
	        },
	        household_primaryPhoneNumber: {
	          required: false,
	          phone: true,
	          household_gold: false
	        },
	        // Affiliate alternate
	        householdPrimaryPhoneNumber: {
	          required: false,
	          phone: true,
	          household_gold: false
	        }
	      });
	      $.extend(validator_messages, {
	        household_month: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	        household_year: { required: messages.ERR_INVALID_YEAR_REQUIRED }
	      });
	    },
	    /**
	     * Validation methods for membership specific forms.
	     * @param  {jQuery} form The form we're validating
	     * @return {void}
	     */
	    addValidationMethods: function addValidationMethods(form) {
	      var memberValidationRegex = new RegExp($('#memberValidationRegex').val());
	      var addressValidationRegex = new RegExp($('#addressValidationRegex').val());
	      var cityStateValidationRegex = new RegExp($('#cityStateValidationRegex').val());
	      $.validator.addMethod('notEqual', function (value, element, param) {
	        return this.optional(element) || value != param;
	      }, messages.ERR_INVALID_STATE_NAME);
	      $.validator.addMethod("hasvalidationerror", function (value, element) {
	        return element.getAttribute('hasvalidationerror') == undefined || element.getAttribute('hasvalidationerror') == null || element.getAttribute('hasvalidationerror') == "false";
	      }, messages.ERR_INVALID_STATE);
	      // custom validate mobile phone number when promo notification via text message is selected.
	      $.validator.addMethod('promo', function (value, element, param) {
	        var valid = true;
	        var phone = $.trim(form.find('input[name=mobilePhoneNumber]').val());
	        var promo = $('input[name=receivePromosAndMarketingTxtMsg]').val();
	        if (promo == 'on' && phone.length == 0) {
	          valid = false;
	        }
	        return valid;
	      }, '');
	      // custom validation for date of birth
	      $.validator.addMethod('dob', function (value, element, param) {
	        var valid = true;
	        var month = void 0;
	        var day = void 0;
	        var year = void 0;
	        var monthVal = void 0;
	        var dayVal = void 0;
	        var yearVal = void 0;
	        var errField = void 0;
	        var message = void 0;
	        var dateCondition = false;
	        var idate = void 0;
	        var isFuture = false;
	        var isFutureDate = function isFutureDate(idate) {
	          var today = new Date().getTime();
	          idate = idate.split('/');
	          idate = new Date(idate[2], idate[0] - 1, idate[1]).getTime();
	          return today - idate < 0 ? true : false;
	        };
	        if (element.name == 'month' || element.name == 'day' || element.name == 'year') {
	          month = form.find('[name=month]');
	          day = form.find('[name=day]');
	          year = form.find('[name=year]');
	          errField = '#dob_error';
	        } else if (element.name == 'MembershipCrmCallerInfo_dobEditMonth' || element.name == 'MembershipCrmCallerInfo_dobEditDay' || element.name == 'MembershipCrmCallerInfo_dobEditYear') {
	          month = form.find('[name=MembershipCrmCallerInfo_dobEditMonth]');
	          day = form.find('[name=MembershipCrmCallerInfo_dobEditDay]');
	          year = form.find('[name=MembershipCrmCallerInfo_dobEditYear]');
	          errField = '#MembershipCrmCallerInfo-dob-error';
	        } else if (element.name == 'household_month' || element.name == 'household_day' || element.name == 'household_year') {
	          month = form.find('[name=household_month]');
	          day = form.find('[name=household_day]');
	          year = form.find('[name=household_year]');
	          errField = '#household_dob_error';
	        } else if (element.name == 'dobmonth' || element.name == 'dobday' || element.name == 'dobyear') {
	          month = form.find('[name=dobmonth]');
	          day = form.find('[name=dobday]');
	          year = form.find('[name=dobyear]');
	          errField = '#dob_error_affiliate';
	        } else if (element.name == 'householdDobMonth' || element.name == 'householdDobDay' || element.name == 'householdDobYear') {
	          month = form.find('[name=householdDobMonth]');
	          day = form.find('[name=householdDobDay]');
	          year = form.find('[name=householdDobYear]');
	          errField = element.form.id == 'household-form-details' ? '#household_dob_error_details' : '#household_dob_error_affiliate';
	        }
	
	        var dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	        var isDayElement = element.name === 'day' || element.name == 'household_day' || element.name == 'dobday' || element.name == 'householdDobDay';
	
	        monthVal = month.val();
	        dayVal = day.val();
	        if (dayIsOptional && dayVal == "") {
	          dayVal = "1";
	        }
	        yearVal = year.val();
	
	        if (!dayIsOptional) {
	          if (wcs.storeId == '10301') {
	            dateCondition = monthVal == 'Month' && dayVal == 'Day' && yearVal == 'Year' || monthVal != 'Month' && dayVal != 'Day' && yearVal != 'Year';
	            if (monthVal.length > 0 || dayVal.length > 0 || yearVal.length > 0) {
	              if (monthVal.length == 0 || dayVal.length == 0 || yearVal.length == 0) {
	                dateCondition = false;
	              }
	            }
	          } else if (wcs.storeId == '10302') {
	            dayVal = 1;
	            dateCondition = monthVal == 'Month' && yearVal == 'Year' || monthVal != 'Month' && yearVal != 'Year';
	            if (monthVal.length > 0 || yearVal.length > 0) {
	              if (monthVal.length == 0 || yearVal.length == 0) {
	                dateCondition = false;
	              }
	            }
	          }
	        } else {
	          dateCondition = true;
	        }
	        if (monthVal != 'Month' && dayVal != 'Day' && yearVal != 'Year') {
	          idate = monthVal + '/' + dayVal + '/' + yearVal;
	          if (isFutureDate(idate)) isFuture = true;
	        }
	        if (dateCondition && !isFuture && COSTCO.util.dateValidation(monthVal, dayVal, yearVal)) {
	          $(errField).hide();
	          month.removeClass('error');
	          day.removeClass('error');
	          year.removeClass('error');
	          valid = true;
	        } else {
	          if (dayIsOptional && day.val() === "" && month.val() === "" && year.val() === "" && isDayElement) {
	            valid = true;
	          } else {
	            month.addClass('error');
	            if (!dayIsOptional) {
	              day.addClass('error');
	            } else {
	              if (day.val() !== "") {
	                day.addClass('error');
	              }
	            }
	            year.addClass('error');
	            $(errField).show();
	            $(errField)[0].innerHTML = messages.ERR_ENTER_DOB;
	            valid = false;
	          }
	        }
	        return valid;
	      }, '');
	      // custom validation for checking if the member is over 18
	      $.validator.addMethod('isMinor', function (value, element, param) {
	        var errorField = void 0;
	        var year = void 0;
	        var month = void 0;
	        var day = void 0;
	        var now = new Date();
	        var graymsg = false;
	        var houseHoldForm = false;
	        var employeeAddOn = false;
	
	        if (element.name == 'month' || element.name == 'day' || element.name == 'year') {
	          month = form.find('[name=month]');
	          day = form.find('[name=day]');
	          year = form.find('[name=year]');
	          errorField = '.member-dob-disclaimer';
	          graymsg = true;
	        } else if (element.name == 'household_month' || element.name == 'household_day' || element.name == 'household_year') {
	          month = form.find('[name=household_month]');
	          day = form.find('[name=household_day]');
	          year = form.find('[name=household_year]');
	          errorField = '#is_minor_household';
	          houseHoldForm = true;
	        } else if (element.name == 'householdDobMonth' || element.name == 'householdDobDay' || element.name == 'householdDobYear') {
	          month = form.find('[name=householdDobMonth]');
	          day = form.find('[name=householdDobDay]');
	          year = form.find('[name=householdDobYear]');
	          errorField = element.form.id == 'household-form-details' ? '#is_minor_household' : '.household-dob-disclaimer';
	          graymsg = element.form.id == 'household-form-details' ? false : true;
	          houseHoldForm = true;
	        } else if (element.name == 'dobmonth' || element.name == 'dobday' || element.name == 'dobyear') {
	          month = form.find('[name=dobmonth]');
	          day = form.find('[name=dobday]');
	          year = form.find('[name=dobyear]');
	          errorField = '.member-dob-disclaimer';
	          graymsg = true;
	        }
	
	        var ageYears = now.getFullYear() - year.val();
	        var ageMonths = now.getMonth() - month.val();
	        var ageDays = now.getDate() - day.val();
	        var isValidAge = true;
	        var primaryMinAge = $('#membership_primary_min_age').val();
	        var addOnMinAge = $('#employee-addOn').val();
	
	        var isAgeAllowed = function isAgeAllowed(minAge) {
	          var dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	          var d = day.val();
	          if (dayIsOptional && d == "") {
	            d = "1";
	          }
	          var idate = new Date(year.val(), month.val() - 1, d);
	          var today = new Date();
	          var birthDate = new Date(idate);
	          var age = today.getFullYear() - birthDate.getFullYear();
	          var m = today.getMonth() - birthDate.getMonth();
	          if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
	            age--;
	          }
	          return age >= minAge ? true : false;
	        };
	
	        //household member age dropped from 18 to 16
	        if (!month.val() == "" && !year.val() == "") {
	          if (houseHoldForm) {
	            if (!isAgeAllowed(16)) {
	              isValidAge = false;
	            }
	          } else if (addOnMinAge) {
	            if (!isAgeAllowed(addOnMinAge)) {
	              isValidAge = false;
	            }
	          } else {
	            if (!isAgeAllowed(primaryMinAge)) {
	              isValidAge = false;
	            }
	          }
	        }
	
	        if (!isValidAge) {
	          month.addClass('error');
	          day.addClass('error');
	          year.addClass('error');
	          if (graymsg) {
	            $(errorField).css('color', '#d32029');
	          } else {
	            $(errorField).show();
	            if (houseHoldForm) {
	              $(errorField).innerHTML = messages.ERR_HOUSE_DOB_MINOR;
	            } else {
	              $(errorField).innerHTML = messages.ERR_DOB_MINOR.replace('{0}', primaryMinAge);
	            }
	          }
	          return false;
	        } else {
	          if (graymsg) {
	            $(errorField).css('color', '#707070');
	          } else {
	            month.removeClass('error');
	            day.removeClass('error');
	            year.removeClass('error');
	            $(errorField).hide();
	          }
	          return true;
	        }
	      }, '');
	      $.validator.addMethod('valid_address', function (value, element) {
	        return value !== null && value !== '' ? addressValidationRegex.test(value.trim()) : true;
	      }, '');
	      $.validator.addMethod('valid_cityState', function (value, element) {
	        return value !== null && value !== '' ? cityStateValidationRegex.test(value.trim()) : true;
	      }, '');
	      // custom validation for household_goldstar
	      $.validator.addMethod('household_gold', function (value, element, param) {
	        var fName = void 0;
	        var lName = void 0;
	        var email = void 0;
	        var emailConf = void 0;
	        var phone = void 0;
	        var errorFirst = void 0;
	        var errorLast = void 0;
	        var valid = true;
	        if (element.name == 'household_first_name' || element.name == 'household_lastName' || element.name == 'household_email' || element.name == 'household_primaryPhoneNumber' || element.name == 'household_emailConfirm') {
	          fName = form.find('input[name=household_first_name]').val();
	          lName = form.find('input[name=household_lastName]').val();
	          email = form.find('input[name=household_email]').val();
	          emailConf = form.find('input[name=household_emailConfirm]').val();
	          phone = form.find('input[name=household_primaryPhoneNumber]').val();
	          errorFirst = '#household_first_name_error';
	          errorLast = '#household_last_name_error';
	        } else if (element.name == 'householdFname' || element.name == 'householdLname' || element.name == 'householdEmail' || element.name == 'householdPrimaryPhoneNumber' || element.name == 'householdEmailConfirm') {
	          fName = form.find('input[name=householdFname]').val();
	          lName = form.find('input[name=householdLname]').val();
	          email = form.find('input[name=householdEmail]').val();
	          emailConf = form.find('input[name=householdEmailConfirm]').val();
	          phone = form.find('input[name=householdPrimaryPhoneNumber]').val();
	          errorFirst = '#household_first_name_error_affiliate';
	          errorLast = '#household_last_name_error_affiliate';
	        }
	        $(errorFirst).hide();
	        $(errorLast).hide();
	        if (fName.length == 0 && lName.length == 0 && email.length == 0 && emailConf.length == 0 && phone.length == 0) {
	          $(errorFirst).hide();
	          $(errorLast).hide();
	          valid = true;
	        } else if (fName.length == 0 && lName.length == 0 && (email.length > 0 || phone.length > 0 || emailConf.length > 0)) {
	          $(errorFirst).innerHTML = messages.ERR_INVALID_FNAME_REQUIRED;
	          $(errorLast).innerHTML = messages.ERR_INVALID_LNAME_REQUIRED;
	          $(errorFirst).show();
	          $(errorLast).show();
	          valid = false;
	        } else if (!(fName.length > 0 && lName.length > 0)) {
	          if (fName.length > 0 && lName.length == 0) {
	            $(errorFirst).hide();
	            $(errorLast).innerHTML = messages.ERR_INVALID_LNAME_REQUIRED;
	            $(errorLast).show();
	            if (element.name == 'household_first_name' || element.name == 'householdFname') {
	              valid = true;
	            } else if (element.name == 'household_lastName' || element.name == 'householdLname') {
	              valid = false;
	            }
	          } else if (fName.length == 0 && lName.length > 0) {
	            $(errorLast).hide();
	            $(errorFirst).innerHTML = messages.ERR_INVALID_FNAME_REQUIRED;
	            $(errorFirst).show();
	            if (element.name == 'household_first_name' || element.name == 'householdFname') {
	              valid = false;
	            } else if (element.name == 'household_lastName' || element.name == 'householdLname') {
	              valid = true;
	            }
	          }
	        }
	        return valid;
	      }, '');
	      $.validator.addMethod('copyAddress', function (value, element, param) {
	        var valid = true;
	        var checked = $('input[name=copyMembershipAddressToShippingBilling]').attr('checked');
	        if (checked == 'checked' && ($(element).val() == '' || $('input[name=shippingNickname]').val() == $('input[name=billingNickname]').val())) {
	          valid = false;
	        }
	        return valid;
	      }, '');
	      $.validator.addMethod('phone', function (value, element) {
	        if (value.startsWith("0") || value.startsWith("1")) {
	          return false;
	        }
	        // costco phone numbers are 10 digits with optional .-() and space
	        else return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
	      }, messages.ERR_INVALID_PHONE_10_DIGIT);
	      // custom validation rule for single email
	      $.validator.addMethod('singleemail', function (value, element) {
	        var flag = true;
	        flag = flag && /^\s*((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?\s*$/.test(value.toLowerCase());
	        return this.optional(element) || flag;
	      }, messages.ERR_INVALID_EMAIL_ADDRESS);
	      $.validator.addMethod('equalTo', function (value, element, param) {
	        var flag = true;
	        flag = flag && value === $(param).val();
	        return this.optional(element) || flag;
	      }, messages.ERR_CONFIRM_EMAIL_MISMATCH);
	      $.validator.addMethod('emailEmpty', function (value, element) {
	        var email = void 0;
	        if (element.name == 'household_emailConfirm') {
	          email = form.find('input[name=household_email]').val();
	        } else if (element.name == 'householdEmailConfirm' || element.name == 'householdEmailConfirmdetails') {
	          email = form.find('input[name=householdEmail]').val();
	        } else if (element.name == 'household_email') {
	          email = form.find('input[name=household_emailConfirm]').val();
	        } else if (element.name == 'householdEmail') {
	          if (form.find('input[name=householdEmailConfirm]').length) {
	            email = form.find('input[name=householdEmailConfirm]').val();
	          } else {
	            email = form.find('input[name=householdEmailConfirmdetails]').val();
	          }
	        } else if (element.name == 'emailConfirm') {
	          if ($(element).attr('id') == 'affiliate-emailConfirm') {
	            email = form.find('input[name=email]').val();
	          } else {
	            return true;
	          }
	        } else if (element.name == 'email') {
	          if ($(element).attr('id') == 'affiliate-email') {
	            email = form.find('input[name=emailConfirm]').val();
	          } else {
	            return true;
	          }
	        }
	        var isOtherFieldEmpty = email == null || email == '';
	        if (!isOtherFieldEmpty && (value == null || value == '')) {
	          return false;
	        } else return true;
	      }, messages.ERR_INVALID_EMAIL_ADDRESS);
	      /** STRY0157080 Require at least ONE alphabet in each of the name fields */
	      $.validator.addMethod("firstNameValidation", function (value, element) {
	        return value !== null && value !== '' ? COSTCO.util.ATLEAST_ONE_ALPHABET.test(value) && memberValidationRegex.test(value.trim()) : true;
	      }, messages.ERR_INVALID_FNAME);
	      $.validator.addMethod("lastNameValidation", function (value, element) {
	        return value !== null && value !== '' ? COSTCO.util.ATLEAST_ONE_ALPHABET.test(value) && memberValidationRegex.test(value.trim()) : true;
	      }, messages.ERR_INVALID_LNAME);
	    },
	    /**
	     * If 'configProduct' exists with the appropriate properties,
	     * prepopulate the inputs. This function uses the data-configproduct
	     * attribute on inputs in the MembershipApplicationTemplates.jsp.
	     * @param {Object} data The data returned from a call to the server
	     *                      for application meta data.
	     * @return {Object} The data passed to the function
	     */
	    prepopulateForm: function prepopulateForm(data) {
	      var configProduct = data.configProduct || this.getConfigProduct();
	      if (configProduct) {
	        var locale = COSTCO.util.getLocale();
	        // Do the populating
	        Object.keys(configProduct).forEach(function (key) {
	          // These keys have to handled specialy because of our Canadian friends.
	          if (key == 'thirdPartyInformationSharing' || key == 'costcoMail' || key == 'costcoEmail') {
	            if (locale == 'en-US' || locale != 'en-US' && key == 'costcoMail') {
	              // The old logic in NewMembershipApplicationHelper.js says
	              // only prepopulate the costcoMail preference if we're in Canada
	              configProduct[key].toLowerCase() == 'yes' ? $('[data-configproduct=' + key + ']').prop('checked', true) : $('[data-configproduct=' + key + ']').prop('checked', false);
	            }
	          } else {
	            $('[data-configproduct=' + key + ']').val(configProduct[key]);
	          }
	        });
	        if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	          COSTCO.MembershipHelper.populateCityStateForDefaultZip(configProduct);
	        }
	      }
	      return data;
	    },
	    /**
	     * Uses the default address zip code obtained from the 'configProduct' (from
	     * the data returned from a call to the server), in order to make a geocodeAPI 
	     * call and populate the city and state fields with the values from the service 
	     * response for the user to choose from (if editing the address)
	     */
	    populateCityStateForDefaultZip: function populateCityStateForDefaultZip(configProduct) {
	
	      if ($('#postalcode')) {
	        var defaultAddrCity = configProduct.city;
	        var defaultAddrState = configProduct.state;
	        var defaultAddrZip = configProduct.zip || configProduct.zipCode;
	        if (defaultAddrZip && defaultAddrCity && defaultAddrState && $('#postalcode').val()) {
	          COSTCO.CAddress.geocodeApiCityState($('#postalcode'), '[name=city]', '[name=state]', defaultAddrCity, defaultAddrState);
	        }
	      }
	
	      if ($('#businessZipCode')) {
	        var defaultCompAddrCity = configProduct.companyCity;
	        var defaultCompAddrState = configProduct.companyState;
	        var defaultCompAddrZip = configProduct.companyZip || configProduct.companyZipCode;
	        if (defaultCompAddrZip && defaultCompAddrCity && defaultCompAddrState && $('#businessZipCode').val()) {
	          COSTCO.CAddress.geocodeApiCityState($('#businessZipCode'), '[name=businessCity]', '[name=businessState]', defaultCompAddrCity, defaultCompAddrState);
	        }
	      }
	    },
	
	    /**
	     * Populates a given element with keys from the obj who's property
	     * names match data-configProduct assigned on inputs of the element.
	     * @param  {jQuery} element The element we want to populate.
	     * @param  {Object} obj  The object who's keys want want to iterate
	     *                       through
	     * @return {jQuery}      Returns the processed element to manipulate further.
	     */
	    populateElement: function populateElement(element, obj) {
	      Object.keys(obj).forEach(function (key) {
	        $(element).find('[data-configproduct=' + key + ']').val(obj[key]);
	      });
	      if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	        COSTCO.MembershipHelper.populateCityStateForDefaultZip(obj);
	      }
	
	      return element;
	    },
	
	    /**
	     * Populate a form using a serilized array ($.fn.serializeArray).
	     * serilizeArray returns an array of objects where each object represents
	     * an input/select/... element who's "name" attribute matches the "name"
	     * property
	     * @param  {jQuery.Object}  form  The form to populate
	     * @param  {Array}          arr   The array of objects to use to populate
	     * @return {void}
	     */
	    populateByName: function populateByName(form, arr) {
	      arr.forEach(function (obj) {
	        $(form).find('[name=' + obj.name + ']').val(obj.value);
	      });
	    },
	
	    /**
	     * Uses the provided affiliate object to build a serialized array of
	     * objects using the form fields from the affiliate template.
	     * @param  {Object} affiliate The object which is the source
	     * @return {Array}            The array of objects
	     */
	    getSerializedAffiliateData: function getSerializedAffiliateData(affiliate) {
	      var $form = $(COSTCO.util.tmpl('tmpl_affiliate', {
	        affiliateHousehold: COSTCO.util.tmpl('tmpl_household_info_affiliate', {})
	      }));
	      // We need to populate the options for dob
	      this.dobPopulate($form, 100);
	      if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	        // We need to populate the form's state drop down
	        if ($form.find('.state-select').length) {
	          var stateProvList = this.getStateProvJson();
	          var stateOptions = this.getStateOptions(stateProvList);
	          $form.find('.state-select').append(stateOptions);
	        }
	      }
	      // Prepopulate the form with existing affiliate data
	      $form = this.populateElement($form, affiliate);
	      // If theres a household attached to affiliate, populate it
	      if (affiliate.houseHold) {
	        $form.find('#affiliate-household').prop('checked', true);
	        $form.find('#affiliate-household').val(true);
	        this.populateElement($form.find('#affiliate-household-container'), affiliate.houseHold);
	      } else {
	        $form.find('#affiliate-household').prop('checked', false);
	        $form.find('#affiliate-household').val(false);
	      }
	      return $form.serializeArray();
	    },
	
	    /**
	     * TRAIL: Refactor - this is not the best way how this function should be
	     * implemented
	     * Populate date of birth selects: month, day, year
	     * Structure of html
	     * <div class="dobPopulate">
	     * <select class="month"/>
	     * <select class="day"/>
	     * <select class="year"/>
	     * </div>
	     * Using this JS - dobPopulate("100") Populates the difference of 100 from
	     * the current year (20XX - 100)
	     * @param  {[type]} template      [description]
	     * @param  {[type]} appConfigYear [description]
	     * @return {void}               [description]
	     */
	    dobPopulate: function dobPopulate(template, appConfigYear) {
	      var elements = $(template).find('.dobPopulate');
	      elements.each(function (index, el) {
	        var currentYear = new Date().getFullYear();
	        var beginningYear = currentYear - parseInt(appConfigYear);
	        var $monthSelect = $(el).find('.month');
	        var $daySelect = $(el).find('.day');
	        var $yearSelect = $(el).find('.year');
	        // Populate year select
	        var _yearSelect = $('<select>');
	        for (var i = currentYear; i >= beginningYear; i--) {
	          _yearSelect.append($('<option></option>').val(i).html(i));
	        }
	        if ($yearSelect.find('option').length <= 1) {
	          $yearSelect.append(_yearSelect.html());
	        }
	        // Populate month select
	        var _monthSelect = $('<select>');
	        for (var _i = 1; _i <= 12; _i++) {
	          _monthSelect.append($('<option></option>').val(_i).html(_i));
	        }
	        if ($monthSelect.find('option').length <= 1) {
	          $monthSelect.append(_monthSelect.html());
	        }
	        // Initialize day select options
	        var _daySelect = $('<select>');
	        for (var _i2 = 1; _i2 <= 31; _i2++) {
	          _daySelect.append($('<option></option>').val(_i2).html(_i2));
	        }
	        if ($daySelect.find('option').length <= 1) {
	          $daySelect.append(_daySelect.html());
	        }
	        // Event handler for changing year and month
	        $yearSelect.change(function () {
	          MembershipHelper.getDaysOfMonth({
	            year: $yearSelect.find('option:selected').val(),
	            month: $monthSelect.find('option:selected').val(),
	            daySelect: $daySelect
	          });
	        });
	        $monthSelect.change(function () {
	          MembershipHelper.getDaysOfMonth({
	            year: $yearSelect.find('option:selected').val(),
	            month: $monthSelect.find('option:selected').val(),
	            daySelect: $daySelect
	          });
	        });
	        $monthSelect.add($daySelect).add($yearSelect).each(function (i, select) {
	          // If the select has a readonly attribute, disable all options
	          // except the currently selected option.
	          if ($(select).attr('readonly')) {
	            // will return "readonly"
	            $(select).find('option').attr('disabled', 'disabled');
	          }
	        });
	      });
	    },
	    /**
	     * Get the days of the month specific to the context year/month
	     * @param  {Object} options The object with year, month and the day <select>
	     * @return {void}
	     */
	    getDaysOfMonth: function getDaysOfMonth(options) {
	      var selected = void 0;
	      var $daySelect = options.daySelect;
	      if (!isNaN(parseInt($daySelect.find('option:selected').val()))) {
	        selected = $daySelect.find('option:selected').val();
	      }
	      if (!isNaN(parseInt(options.year)) && !isNaN(parseInt(options.month))) {
	        // Remove numbered options from day select
	        $daySelect.find('option').each(function (index, element) {
	          if (!isNaN(element.value)) {
	            try {
	              element.remove(); // ie fail
	            } catch (err) {}
	          }
	        });
	        var daysInMonth = new Date(options.year, options.month, 0).getDate();
	        var _daySelect = $('<select>');
	        for (var i = 1; i <= daysInMonth; i++) {
	          _daySelect.append($('<option></option>').val(i).html(i));
	        }
	        $daySelect.append(_daySelect.html());
	        if (typeof selected != 'undefined') {
	          $daySelect.find('option[value="' + selected + '"]').prop('selected', true);
	        }
	      }
	    },
	    /**
	     * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val()
	     * to get unformatted value
	     * @param  {[type]} template [description]
	     * @return {void}          [description]
	     */
	    maskInput: function maskInput(template) {
	      $(template).find('[name=contactPhoneNumber],[name=cphone],[name=MembershipCrmCallerInfo_phone]').unmask().mask('000-000-0000');
	      $(template).find('[name=mobilePhoneNumber],[name=mphone],[name=MembershipCrmCallerInfo_mobile]').unmask().mask('000-000-0000');
	      $(template).find('[name=businessPhone]').unmask().mask('000-000-0000');
	      $(template).find('[name=household_primaryPhoneNumber],[name=householdPrimaryPhoneNumber]').unmask().mask('000-000-0000');
	      $(template).find('[name=month],[name=household_month],[name=householdDobMonth],[name=dobmonth],[name=MembershipCrmCallerInfo_dobEditMonth],[name=day],[name=household_day],[name=householdDobDay],[name=dobday],[name=MembershipCrmCallerInfo_dobEditDay]').unmask().mask('00');
	
	      $(template).find('[name=year],[name=household_year],[name=householdDobYear],[name=dobyear],[name=MembershipCrmCallerInfo_dobEditYear]').unmask().mask('0000');
	      if (addressForm.isUS()) {
	        $(template).find('[name=postalcode],[name=zip],[name=MembershipCrmCallerInfo_zipCode]').unmask().mask('00000-0000');
	        $(template).find('[name=businessZipCode]').unmask().mask('00000-0000');
	        $(template).find('[name=employeeAddon_zip]').unmask().mask('00000-0000');
	      } else {
	        $(template).find('[name=postalcode],[name=zip],[name=MembershipCrmCallerInfo_zipCode]').unmask().mask('S0S 0S0');
	        $(template).find('[name=businessZipCode]').unmask().mask('S0S 0S0');
	        $(template).find('[name=employeeAddon_zip]').unmask().mask('S0S 0S0');
	      }
	    },
	    /**
	     * This function is used showing server side errors returned from
	     * calling various membership related ajax services. If we have an
	     * error, we show it at the top and scroll to it.
	     * @param  {Object} data The membership application meta data
	     * @return {Object}      The membership application meta data
	     */
	    handleErrors: function handleErrors(data) {
	      var hasErrors = data && data.error && data.errorMessages && data.errorMessages.length > 0;
	      var errorHtml = '';
	      var $selectors = $('#server-error, #notification-message');
	      if (data && !data.retainNotification || hasErrors) {
	        $selectors.addClass('hide').children().remove();
	      }
	      if (data && data.status && data.status === 500) {
	        data = {
	          error: true,
	          errorMessages: ['Unexpected Error']
	        };
	      }
	      if (data && data.error && data.errorMessages) {
	        // First clear div#notification-message (needed on Add People Outside Renewal page)
	        COSTCO.util.notification.clearNotification();
	        $selectors.addClass('critical-notification');
	        for (var i = 0, len = data.errorMessages.length; i < len; i++) {
	          if (data.errorMessages[i] === '_ERR_INVALID_SHIP_ADDR') {
	            data.errorMessages[i] = messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR;
	            var formId = $('#MemberAddressBookForm');
	            var addressField = '#address1';
	            COSTCO.dialog.sameAddressValidation(formId, addressField);
	          }
	          console.error(data.errorMessages[i]);
	          errorHtml += i === len - 1 ? '<span>' + data.errorMessages[i] + '</span>' : '<p>' + data.errorMessages[i] + '</p>';
	          if (data.errorMessages[0] == 'APPLICATION_ORDER_ITEM_ID_MISSING') {
	            var appType = $('#applicationType').val();
	            // Stale browser
	            if (appType === 'BD') {
	              window.location.href = '/CheckoutCartView';
	              return;
	            }
	          }
	        };
	        $selectors.removeClass('hide').append(errorHtml);
	        $('html, body').scrollToElem($selectors, 100);
	      } else {
	        $selectors.removeClass('critical-notification');
	        // Clear previous error on success (needed on Add People Outside Renewal page)
	        COSTCO.util.notification.clearNotification();
	      }
	      return data;
	    },
	    /**
	     * A wrapper around membershipData. We use this so we dont need to
	     * include membershipData everywhere
	     * @return {Object} The object from sessionStorage representing the
	     *                      configProduct application metadata
	     */
	    getConfigProduct: function getConfigProduct() {
	      return membershipData.getConfigProduct();
	    },
	    /**
	     * A wrapper around membershipData. We use this so we dont need to
	     * include membershipData everywhere
	     * @param  {Object} data The object (represetning the membership application
	     *                       metadata) to set in sessionStorage.
	     * @return {Object}      Returns the same data object passed as an argument
	     *                               (meant to be a chainable action)
	     */
	    setConfigProduct: function setConfigProduct(data) {
	      return membershipData.setConfigProduct(data);
	    },
	    /**
	     * Pull a specific address by label from an array of addresses. For example
	     * 'Primary' in theory return the primary address if it matches the label.
	     * @param  {[type]} addressLabel [description]
	     * @param  {[type]} addressArray [description]
	     * @return {[type]}              [description]
	     */
	    findAddressByLabel: function findAddressByLabel(addressLabel, addressArray) {
	      var address = {};
	      $(addressArray).each(function (index, value) {
	        if (value.label == addressLabel) {
	          address = value;
	          return false;
	        }
	      });
	      return address;
	    },
	    /**
	     * Returns a chainable address verification object. Right now this
	     * is specific to the membership application. Maybe parameterize this
	     * to accept a specific form and selectors.
	     * @param {Object} selectors The object that contains selectors
	     * @return {jQuery.Deferred} Returns a deferred, thenable object.
	     */
	    verifyAddresses: function verifyAddresses(selectors) {
	      var addressObjects = this.buildAddressArray($(selectors.form), {
	        primary: selectors.primary,
	        business: selectors.business
	      });
	      $('.order-ajax').addClass('ajax-busy');
	      return COSTCO.util.ajax({
	        url: '/AjaxAddressVerificationCmd',
	        type: 'POST',
	        dataType: 'json',
	        timeout: 15000,
	        // Turn off glboal event handlers. ajaxComplete and ajaxError are
	        // global events defined in global.js
	        global: false,
	        data: {
	          formdata: encodeURIComponent(JSON.stringify(addressObjects))
	        },
	        always: function always() {
	          $('.permanent-ajax-busy').removeClass('ajax-busy');
	        },
	        complete: function complete() {}
	      });
	    },
	    /**
	     * [description]
	     * @param  {[type]} form [description]
	     * @param  {[type]} obj  [description]
	     * @return {[type]}      [description]
	     */
	    buildAddressArray: function buildAddressArray(form, obj) {
	      var addressObjects = [];
	      var primaryAVSObj = addressVerification.buildRequestElement(form, obj.primary);
	      if (typeof primaryAVSObj.fName == 'undefined' || primaryAVSObj.fName == '') {
	        primaryAVSObj.fName = $("#MemberAddressBookForm input[name='first_name']").val();
	        primaryAVSObj.lName = $("#MemberAddressBookForm input[name='lastName']").val();
	      }
	      addressObjects.push(primaryAVSObj);
	      if (this.isBusinessMembership() && obj.business) {
	        var businessAVSObj = addressVerification.buildRequestElement(form, obj.business);
	        if (typeof businessAVSObj.fName == 'undefined' || businessAVSObj.fName == '') {
	          businessAVSObj.fName = $("#MemberAddressBookForm input[name='first_name']").val();
	          businessAVSObj.lName = $("#MemberAddressBookForm input[name='lastName']").val();
	        }
	        addressObjects.push(businessAVSObj);
	      }
	      $.each(addressObjects, function (index, value) {
	        if (value.id == '') {
	          addressObjects[index].id = index;
	        }
	      });
	      return addressObjects;
	    },
	    /**
	     * This function serves as an intermediary to invoking the verification
	     * modal. It prepares data appropriately and then invokes. If the verification
	     * response has all "no suggestions", we simply invoke the callback on the
	     * entered addresses.
	     * @param  {Object}   addressObj The response from calling
	     *                               /AjaxAddressVerificationCmd. The data
	     *                               structure looks like
	     *                                {Address:[], Validated_Address: []}
	     * @param  {Function} callback   The function which ends up being the
	     *                               primary event on the verification modal.
	     *                               It could submit a form, etc.
	     * @return {void}
	     */
	    invokeMultiAVS: function invokeMultiAVS(addressObj, callback) {
	      $('.order-ajax').removeClass('ajax-busy');
	      if (typeof addressObj !== 'undefined' && addressObj != null && addressObj.Validated_Address != null) {
	        var multiAVSModal = addressVerification.showMultiAddressVerificationModal;
	
	        if (addressVerification.hasAllNoSuggestion(addressObj.Validated_Address)) {
	          // In this case we just want to use the user inputted addresses
	          callback(addressObj.Address);
	          COSTCO.dialog.close();
	        } else if (addressVerification.hasAllSameAsSuggested(addressObj)) {
	          // Prefering the validate_address as it will contain the 4 digits
	          // appended to the zip code.
	          callback(addressObj.Validated_Address);
	          COSTCO.dialog.close();
	        } else {
	          // We have at least one suggested address. We want to show the modal.
	          var validAddresses = MembershipHelper.removeValidAddressFromArray(addressObj);
	          multiAVSModal(validAddresses, callback);
	        }
	      } else {
	        elementObj = $('[name=' + addressObj.errorMessageParam[0] + ']');
	        if (elementObj.length > 0) {
	          elementObj.parent().addClass('error');
	          elementObj.attr('hasvalidationerror', true);
	          $(elementObj).parent().parents("form:first").valid();
	        }
	      }
	    },
	    /**
	     * This function populates a given form. Its meant to replace the values
	     * of each designated field with what the addresses selected after the
	     * verification process. We then can just serialize the form to send to the
	     * backend.
	     * @param  {jQuery} form        The form to populate
	     * @param  {Array} addresses    Array of validated addresses to get address
	     *                              details from it and send with membership
	     *                              application form.
	     * @param  {boolean} isAffiliate Are we populating the affiliate form?
	     * @return {void}
	     */
	    populateAddressData: function populateAddressData(form, addresses, isAffiliate) {
	      var primaryAddress = isAffiliate ? this.findAddressByLabel('Affiliate Address', addresses) : this.findAddressByLabel('Primary Address', addresses);
	      form.find('input[name=address1],input[name=line1]').val(primaryAddress.line1 != null ? primaryAddress.line1.trim() : "");
	      form.find('input[name=address2],input[name=line2]').val(primaryAddress.line2);
	      form.find('input[name=city]').val(primaryAddress.city);
	      form.find('select[name=state]').val(primaryAddress.state);
	      form.find('input[name=postalcode],input[name=zip]').val(primaryAddress.zip);
	      form.find('input[name=country]').val(primaryAddress.country);
	      if (this.isBusinessMembership() && !isAffiliate) {
	        var businessAddress = this.findAddressByLabel('Business Address', addresses);
	        form.find('input[name=businessAddressLine1]').val(businessAddress.line1);
	        form.find('input[name=businessAddressLine2]').val(businessAddress.line2);
	        form.find('input[name=businessCity]').val(businessAddress.city);
	        form.find('select[name=businessState]').val(businessAddress.state);
	        form.find('input[name=businessZipCode]').val(businessAddress.zip);
	        form.find('input[name=businessCountry]').val(businessAddress.country);
	      }
	    },
	    /**
	     * Removes valid addresses and No Suggested addresses from the AVS response array
	     * @param  {Array} addressObj AVS address array
	     * @return {Array} Array of addresses to be validated
	     */
	    removeValidAddressFromArray: function removeValidAddressFromArray(addressObj) {
	      var addressesToVerify = {
	        Address: [],
	        Validated_Address: [],
	        size: 0
	      };
	
	      $.each(addressObj.Validated_Address, function (index, value) {
	        // Ensure each validated address has an `id` attribute
	        if (!value.id) {
	          console.warn('Missing id for validated address at index ' + index + '. Assigning id ' + index + '.');
	          value.id = index.toString(); // Assign the index as the id
	        }
	
	        var entered = addressVerification.findAddressById(value.id, addressObj.Address);
	
	        // Push all validated addresses into the Validated_Address array
	        addressesToVerify.Validated_Address.push(value);
	
	        // Add the corresponding entered address to the Address array
	        if (entered) {
	          addressesToVerify.Address.push(entered);
	        }
	      });
	
	      // Update the size property to reflect the number of validated addresses
	      addressesToVerify.size = addressesToVerify.Validated_Address.length;
	
	      return addressesToVerify;
	    },
	    /**
	     * [description]
	     * @param  {[type]} stateProvList [description]
	     * @return {[type]}               [description]
	     */
	    getStateOptions: function getStateOptions(stateProvList) {
	      return addressForm.getStateOptions(stateProvList);
	    },
	    /**
	     * Make a call to grab the application meta data from
	     * the membershipData module.
	     * @return {jQuery.Promise} The returned promise to chain
	     */
	    getApplicationData: function getApplicationData() {
	      return membershipData.getApplicationData();
	    },
	    /**
	     * Get the membership meta data from the server
	     * @return {jQuery.Promise} The returned promise to chain
	     */
	    getMembershipData: function getMembershipData() {
	      return membershipData.getMembershipData();
	    },
	    /**
	     * [description]
	     * @return {[type]} [description]
	     */
	    getStateProvJson: function getStateProvJson() {
	      return address.getStateProvJson();
	    },
	    /**
	     * [description]
	     * @param  {[type]} x [description]
	     * @param  {[type]} y [description]
	     * @param  {[type]} z [description]
	     * @return {[type]}   [description]
	     */
	    bingCityState: function bingCityState(x, y, z) {
	      return address.bingCityState(x, y, z);
	    },
	    geocodeApiCityState: function geocodeApiCityState(x, y, z) {
	      return address.geocodeApiCityState(x, y, z);
	    },
	    /**
	     * Builds the existing affiliates block. Provide a template and a target
	     * to append the HTML too.
	     * @param  {[type]} template [description]
	     * @param  {[type]} target   [description]
	     * @return {void}
	     */
	    buildExistingAffiliates: function buildExistingAffiliates(template, target) {
	      $('.affiliate-block, .affiliate-clearfix').remove();
	      var affiliateHtml = '';
	
	      this.getAffiliates().forEach(function (affiliate, i) {
	        affiliateHtml += COSTCO.util.tmpl(template, {
	          affiliate: affiliate,
	          // Needed to inject clearfix where ever needed
	          index: i + 1
	        });
	      });
	      $(target).prepend(affiliateHtml);
	    },
	    /**
	     * Gets the array of affiliates attached to the configProduct
	     * @return {Array} The array of objects representing the affiliates
	     */
	    getAffiliates: function getAffiliates() {
	      var affiliates = [];
	      var c = this.getConfigProduct();
	      if (!$.isEmptyObject(c) && c.affilatedMemberships && c.affilatedMemberships.affilatedMember) {
	        affiliates = c.affilatedMemberships.affilatedMember.map(function (affiliate) {
	          // These fields are used by MemberApplicationAffiliateUpdateCmd
	          // Some of them are duplicates of whats already defined
	          // on configProduct.affilatedMemberships.affilatedMember because
	          // theres no standard
	          affiliate.affiliateMembershipNumber = affiliate.membershipNumber || '';
	          affiliate.parentMembershipNumber = c.membershipNumber || '';
	          affiliate.organizationId = c.organizationId || '';
	          affiliate.first = affiliate.firstName || '';
	          affiliate.last = affiliate.lastName || '';
	          affiliate.mi = affiliate.mi || '';
	          return affiliate;
	        });
	      }
	      return affiliates;
	    },
	    /**
	     * Using the AllMembershipInfoDataBean as the source of data, locate the
	     * specific affiliate by number
	     * @param  {Object} data   The AllMembershipInfoDataBean serielized
	     *                         as a JS object
	     * @param  {Number} number The affiliate membership number
	     * @return {Object}        The JS object representing the affiliate from
	     *                             AllMembershipInfoDataBean
	     */
	    getAffiliateFromDataBeanByNumber: function getAffiliateFromDataBeanByNumber(data, number) {
	      var affiliate = undefined;
	      if (data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
	        var affiliates = data.caller.businessInfo.affiliates;
	        affiliates.forEach(function (aff) {
	          if (aff.cardNumber && aff.cardNumber.value && aff.cardNumber.value == number) {
	            affiliate = aff;
	          }
	        });
	      }
	      return affiliate;
	    },
	
	    /**
	     * Gets the affiliate object from the configProduct if one exists.
	     * @param  {Number} membershipNumber The affiliate membershipNumber
	     * @return {Object}                  The affiliate object
	     */
	    getAffiliateByNumber: function getAffiliateByNumber(membershipNumber) {
	      var affiliate = undefined;
	      this.getAffiliates().forEach(function (aff) {
	        if (membershipNumber == aff.membershipNumber) {
	          affiliate = aff;
	          return;
	        }
	      });
	      return affiliate;
	    },
	
	    /**
	     * Gets the affiliate household from the configProduct if one exists
	     * @param  {Number} membershipNumber The affiliate household membership number
	     * @return {Object}                  The affiliate household object
	     */
	    getAffiliateHouseholdByNumber: function getAffiliateHouseholdByNumber(membershipNumber) {
	      var affHousehold = undefined;
	      this.getAffiliates().forEach(function (aff) {
	        if (aff.houseHold && aff.houseHold.membershipNumber == membershipNumber) {
	          affHousehold = aff.houseHold;
	          return;
	        }
	      });
	      return affHousehold;
	    },
	
	    /**
	     * Gets the affiliate object using the affiliate's household membership number.
	     * @param  {Number} membershipNumber The affiliate household membership number
	     * @return {Object}                  The affiliate object
	     */
	    getAffiliateByHouseholdNumber: function getAffiliateByHouseholdNumber(membershipNumber) {
	      var affiliate = undefined;
	      this.getAffiliates().forEach(function (aff) {
	        if (aff.houseHold && aff.houseHold.membershipNumber == membershipNumber) {
	          affiliate = aff;
	          return;
	        }
	      });
	      return affiliate;
	    },
	
	    /**
	     * Gets the affiliate object using the affiliate's household membership number.
	     * @param  {Object} data   The AllMembershipInfoDataBean serielized
	     *                         as a JS object
	     * @param  {Number} membershipNumber The affiliate household membership number
	     * @return {Object}                  The affiliate object
	     */
	    getAffByHouseholdNumber: function getAffByHouseholdNumber(data, membershipNumber) {
	      var affiliate = undefined;
	      if (data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
	        var affiliates = data.caller.businessInfo.affiliates;
	        affiliates.forEach(function (aff) {
	          if (aff.household && aff.household.cardNumber && aff.household.cardNumber.value == membershipNumber) {
	            affiliate = aff;
	            return;
	          }
	        });
	      }
	      return affiliate;
	    },
	
	    /**
	     * Takes the request data serialized from the affiliate form template
	     * (tmpl_affiliate) and transforms it to the appropriate namespace for
	     * the MemberAffiliateAddCmd used by renew membership / business
	     * details flows.
	     * @method
	     * @param  {Object} requestData The object representing the form inputs
	     *                              from form#affiliate-form
	     * @return {Object}             The transformed inputs in an object.
	     */
	    transformAffiliateInputNames: function transformAffiliateInputNames(requestData) {
	      var newRequestData = {};
	      var prefix = 'MembershipCrmAddAffiliate_';
	      Object.keys(requestData).forEach(function (key) {
	        switch (key) {
	          case 'fname':
	            newRequestData[prefix + 'firstName'] = requestData[key];
	            break;
	          case 'lname':
	            newRequestData[prefix + 'lastName'] = requestData[key];
	            break;
	          case 'dobday':
	            newRequestData[prefix + 'dobEditDay'] = requestData[key];
	            break;
	          case 'dobmonth':
	            newRequestData[prefix + 'dobEditMonth'] = requestData[key];
	            break;
	          case 'dobyear':
	            newRequestData[prefix + 'dobEditYear'] = requestData[key];
	            break;
	          case 'line1':
	            newRequestData[prefix + 'addressLine1'] = requestData[key];
	            break;
	          case 'line2':
	            newRequestData[prefix + 'addressLine2'] = requestData[key];
	            break;
	          case 'cphone':
	            newRequestData[prefix + 'phone'] = requestData[key];
	            break;
	          case 'mphone':
	            newRequestData[prefix + 'mobile'] = requestData[key];
	            break;
	          case 'householdPrefix':
	            newRequestData[prefix + 'household_prefix'] = requestData[key];
	            break;
	          case 'householdFname':
	            newRequestData[prefix + 'household_firstName'] = requestData[key];
	            break;
	          case 'householdMi':
	            newRequestData[prefix + 'household_mi'] = requestData[key];
	            break;
	          case 'householdLname':
	            newRequestData[prefix + 'household_lastName'] = requestData[key];
	            break;
	          case 'householdSuffix':
	            newRequestData[prefix + 'household_suffix'] = requestData[key];
	            break;
	          case 'householdDobMonth':
	            newRequestData[prefix + 'household_dobEditMonth'] = requestData[key];
	            break;
	          case 'householdDobDay':
	            newRequestData[prefix + 'household_dobEditDay'] = requestData[key];
	            break;
	          case 'householdDobYear':
	            newRequestData[prefix + 'household_dobEditYear'] = requestData[key];
	            break;
	          case 'householdEmail':
	            newRequestData[prefix + 'household_email'] = requestData[key];
	            break;
	          case 'householdPrimaryPhoneNumber':
	            newRequestData[prefix + 'household_phone'] = requestData[key];
	            break;
	          case 'householdCheckbox':
	            newRequestData[prefix + 'includeHousehold'] = requestData[key];
	            break;
	          default:
	            newRequestData['' + prefix + key] = requestData[key];
	        }
	      });
	      return newRequestData;
	    },
	    /**
	     * Similar to above method. Take the old input names and transform them to
	     * what the backend is expecting (for /MemberHouseholdAddCmd)
	     * @param  {Object} requestData The object representing the form inputs
	     *                              from form#affiliate-form
	     * @return {Object}             The transformed inputs in an object.
	     */
	    transformAffiliateHouseholdInputNames: function transformAffiliateHouseholdInputNames(requestData) {
	      var newRequestData = {};
	      Object.keys(requestData).forEach(function (key) {
	        switch (key) {
	          case 'householdPrefix':
	            newRequestData['prefix'] = requestData[key];
	            break;
	          case 'householdFname':
	            newRequestData['first_name'] = requestData[key];
	            break;
	          case 'householdMi':
	            newRequestData['middle_name'] = requestData[key];
	            break;
	          case 'householdLname':
	            newRequestData['last_name'] = requestData[key];
	            break;
	          case 'householdSuffix':
	            newRequestData['suffix'] = requestData[key];
	            break;
	          case 'householdDobMonth':
	            newRequestData['month'] = requestData[key];
	            break;
	          case 'householdDobDay':
	            newRequestData['day'] = requestData[key];
	            break;
	          case 'householdDobYear':
	            newRequestData['year'] = requestData[key];
	            break;
	          case 'householdEmail':
	            newRequestData['email'] = requestData[key];
	            break;
	          case 'householdPrimaryPhoneNumber':
	            newRequestData['contact_phone'] = requestData[key];
	            break;
	          default:
	            newRequestData[key] = requestData[key];
	        }
	      });
	      return newRequestData;
	    },
	    /**
	     * First show the user the affiliates as registered with their
	     * xorderitems.crmmemberinfo (configProduct) on the application page.
	     * If they have 6, we don't allow anymore.
	     * @param  {[type]} data [description]
	     * @return {[type]}      [description]
	     */
	    reflectAffiliates: function reflectAffiliates(data) {
	      // First show the affiliates returned from submission
	      COSTCO.MembershipHelper.buildExistingAffiliates('tmpl_affiliate_block', '#add-person-container');
	      // Hide add person button if we're >= 6 affiliates
	      COSTCO.AffiliateForm.checkAffiliateNumber(data);
	      return data;
	    },
	    /**
	     * Build the affiliate list for renew / account details view using the response
	     * from some crud operation.
	     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
	     * @return {Object}      Same as parameter - used for chaining to the next method.
	     */
	    reflectAffiliatesAlternate: function reflectAffiliatesAlternate(data) {
	      if (data && data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
	        COSTCO.RenewMembership.membershipData = /* COSTCO.AccountDetails.membershipData = */data;
	        var affiliateHtml = '';
	        var affiliates = data.caller.businessInfo.affiliates || [];
	        affiliates.length > 0
	        // Remove the empty class (if it exists), which has a border-top
	        // attribute. The following affiliate blocks have border-tops.
	        ? $('#affiliate-list-container').removeClass('empty') : $('#affiliate-list-container').addClass('empty');
	        affiliates.forEach(function (a) {
	          affiliateHtml += COSTCO.util.tmpl('tmpl_affiliate_row', {
	            affiliateCardNumber: a.cardNumber.value,
	            affiliateFirstName: a.firstName.value,
	            affiliateLastName: a.lastName.value,
	            isNewAffiliate: a.statusReasonDesc && (a.statusReasonDesc.value == 'Created' || a.statusReasonDesc.value == 'Opened'),
	            hasHousehold: a.household && a.household.cardNumber.value,
	            affiliateHouseholdNumber: a.household.cardNumber.value,
	            affiliateHouseholdFirstName: a.household.firstName.value,
	            affiliateHouseholdLastName: a.household.lastName.value
	          });
	        });
	        $('#affiliate-list-container').html(affiliateHtml);
	      }
	      return data;
	    },
	    /**
	     * Build the affiliate list for Add Additional People outside renewal view using
	     * the response from some crud operation.
	     * @param {Object} data The JSON object representing the AllMembershipInfoDataBean.
	     * @return {Object} Same as parameter - used for chaining to the next method.
	     */
	    reflectAffiliatesBussinessOutsideRenewal: function reflectAffiliatesBussinessOutsideRenewal(data) {
	      COSTCO.AddAdditionalPeople.membershipData = /* COSTCO.AccountDetails.membershipData = */data;
	      var newAffiliateHtml = '';
	      var affiliateHtml = '';
	      var affiliates = data.caller.businessInfo.affiliates || [];
	      var newAffiliatesCount = 0;
	      var individualFee = 0;
	      affiliates.forEach(function (a) {
	        if (a.statusReasonDesc && (a.statusReasonDesc.value == 'Created' || a.statusReasonDesc.value == 'Opened')) {
	          newAffiliatesCount++;
	        }
	      });
	      var totalFee = parseFloat(data.caller.addAffiliateAmount);
	      if (newAffiliatesCount > 0) {
	        // Remove the empty class (if it exists), which has a border-top
	        // attribute. The following affiliate blocks have border-tops.
	        $('#new-people-on-my-membership').removeClass('empty');
	        individualFee = totalFee / newAffiliatesCount;
	        // Display info message if there are no errors
	        if (!$('#notification-message').hasClass('critical-notification')) {
	          if (costcoStoreFeatures.GMP_ENABLED) {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.WARNING, [messages.ACCOUNT_RWD__AddAdditionalPeople_AdditionalPersonCost_InfoText_GMP]);
	          } else {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [messages.ACCOUNT_RWD__AddAdditionalPeople_AdditionalPersonCost_InfoText]);
	          }
	        }
	      } else {
	        $('#new-people-on-my-membership').addClass('empty');
	        // Remove info message if there are no errors
	        if (!$('#notification-message').hasClass('critical-notification')) {
	          COSTCO.util.notification.clearNotification();
	        }
	      }
	      affiliates.forEach(function (a) {
	        if (a.statusReasonDesc && (a.statusReasonDesc.value == 'Created' || a.statusReasonDesc.value == 'Opened')) {
	          newAffiliateHtml += COSTCO.util.tmpl('tmpl_add_new_affiliate_row', {
	            affiliateCardNumber: a.cardNumber.value,
	            affiliateFirstName: a.firstName.value,
	            affiliateLastName: a.lastName.value,
	            isNewAffiliate: true,
	            hasHousehold: a.household && a.household.cardNumber.value,
	            affiliateHouseholdNumber: a.household.cardNumber.value,
	            affiliateHouseholdFirstName: a.household.firstName.value,
	            affiliateHouseholdLastName: a.household.lastName.value,
	            individualFeeJS: individualFee.toFixed(2)
	          });
	        } else {
	          affiliateHtml += COSTCO.util.tmpl('tmpl_affiliate_row', {
	            affiliateCardNumber: a.cardNumber.value,
	            affiliateFirstName: a.firstName.value,
	            affiliateLastName: a.lastName.value,
	            isNewAffiliate: false,
	            hasHousehold: a.household && a.household.cardNumber.value,
	            affiliateHouseholdNumber: a.household.cardNumber.value,
	            affiliateHouseholdFirstName: a.household.firstName.value,
	            affiliateHouseholdLastName: a.household.lastName.value
	          });
	        }
	      });
	      $('#new-people-on-my-membership').html(newAffiliateHtml);
	      $('#affiliate-list-container').html(affiliateHtml);
	      if (totalFee) {
	        $('#total-fee').html('$' + totalFee.toFixed(2));
	      }
	      // In border cases, when newAffiliatesCount changes from 0 to 1, or from 1 to 0,
	      // hide/show appropriate sections to have verbiage in singular/plural, show/hide
	      // total cost, and enable/disable Add to Cart button.
	      if (newAffiliatesCount == 0) {
	        $('#add-a-person-outside-renewal').removeClass('hide');
	        $('#add-another-person-outside-renewal').addClass('hide');
	        $('#total-price-section').addClass('hide');
	        $('#add-to-cart').attr('disabled', 'disabled');
	      } else if (newAffiliatesCount == 1 && $('#add-another-person-outside-renewal').hasClass('hide')) {
	        $('#add-a-person-outside-renewal').addClass('hide');
	        $('#add-another-person-outside-renewal').removeClass('hide');
	        $('#total-price-section').removeClass('hide');
	        $('#add-to-cart').removeAttr('disabled');
	      }
	      // Hide the option to add more affiliates if there are more than six
	      if (affiliates.length >= 6) {
	        $('#add-another-person-outside-renewal').addClass('hide');
	      }
	      return data;
	    },
	    /**
	     * If the response has affiliates, we want the the link to show
	     * "Add Another Person". If we have zero, we want the link to say
	     * "Add a Person".
	     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
	     * @return {Object}      Same as parameter - used for chaining to the next method.
	     */
	    addPersonLink: function addPersonLink(data) {
	      if (data && data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates && data.caller.businessInfo.affiliates.length > 0) {
	        $('#add-another-person-text').removeClass('hide');
	        $('#add-a-person-text').addClass('hide');
	      } else {
	        $('#add-another-person-text').addClass('hide');
	        $('#add-a-person-text').removeClass('hide');
	      }
	      return data;
	    },
	    /**
	     * If we already have 6 newly added affiliates, we don't want to allow the
	     * user to add any more. This function checks that and then hides/disables
	     * the "Add Another Person" link.
	     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
	     * @return {Object}      Same as parameter - used for chaining to the next method.
	     */
	    canAddAffiliate: function canAddAffiliate(data) {
	      var counter = 0;
	      if (data && data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
	        (data.caller.businessInfo.affiliates || []).forEach(function (a) {
	          if (a.statusReasonDesc && (a.statusReasonDesc.value == 'Created' || a.statusReasonDesc.value == 'Opened')) {
	            counter++;
	          }
	        });
	        // Handle hide/show of Add Person/Add Another Person
	        if (COSTCO.MembershipHelper.isQuickMembership) {
	          if (counter == 0) {
	            $('#add-a-person-text').removeClass('hide');
	            $('#add-another-person-text').addClass('hide');
	          } else if (counter > 0 && counter < 6) {
	            $('#add-a-person-text').addClass('hide');
	            $('#add-another-person-text').removeClass('hide');
	          } else {
	            $('#add-a-person-text').addClass('hide');
	            $('#add-another-person-text').addClass('hide');
	          }
	        } else if (counter >= 6) {
	          $('#add-another-person').addClass('hide');
	        } else {
	          $('#add-another-person').removeClass('hide');
	        }
	      }
	      return data;
	    },
	    /**
	     * This takes the renewal price from the AllMembershipInfoDataBean
	     * (caller.renewAmount) and replaces the value of span#renewal-amount
	     * located at MembershipRenewInfo_Business_UI.jspf
	     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
	     * @param  {Boolean} isUpgrade
	     * @return {Object}      Same as parameter - used for chaining to the next method.
	     */
	    updateTotalPrice: function updateTotalPrice(data, isUpgrade) {
	      if (data && data.caller && data.caller.renewAmount) {
	        var locale = COSTCO.util.getLocale().substr(0, 2);
	        $('#renewal-amount').text(COSTCO.util.localeSpecificCurrency(isUpgrade ? data.caller.renewAndUpgradeAmount : data.caller.renewAmount, locale));
	      }
	      return data;
	    },
	    /**
	     * In Account Details, when a user has a validated profile with a internal
	     * card (usage = 'Z050') wants to change their email address, we invalidate
	     * them unless they're changing their email that includes the costco domain.
	     * (<username>@costco.com)
	     * @param  {DOMElement} form The form to pull the profile email from
	     * @return {boolean}     Does this profile need to be invalidated?
	     */
	    isInternalInvalidated: function isInternalInvalidated(form) {
	      var email = $(form).find('#update-email').val();
	      return COSTCO.util.getMemberCookie().usage == 'Z050' && !(email.includes('@costco.com') || email.includes('@costco.ca'));
	    },
	    /** Adding zero the left of the input if its lenght is 1 */
	    prependZero: function prependZero(event) {
	      var value = $(event.currentTarget).val();
	      if (value != null && value != '') {
	        if (value.length == 1 && value != '0') {
	          value = '0' + value;
	        }
	        $(event.currentTarget).val(value);
	      }
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.MembershipHelper = MembershipHelper;
	  return MembershipHelper;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title membership-data.js: Submodule
	 * @description A submodule that retrieves the users membership data. Used
	 *              for prepopulating forms.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var MembershipData = {
	    /**
	     * Returns a 'thenable' promise  that contains a 'configproduct' from
	     * the database. On the backend this ajax request maps to
	     * MembershipApplicationDataBeanAjax.java. The 'configproduct' is the user's
	     * data and the command builds this object with the following priority:
	     *  1. If CRM data exists for this user, use it
	     *  2. Else if the user has a defaulted billing address, use it.
	     * @return {Object} The promise to be used for further processing. Use it
	     *                      like ...getApplicationData().done(callbackFn(data))
	     */
	    getApplicationData: function getApplicationData() {
	      var configProduct = this.getConfigProduct();
	      var deferred = $.Deferred();
	      var orderItemId = applicationTrackingCookie || $.cookie('APPLICATION_TRACKING_COOKIE');
	      var querystrings = {
	        requesttype: 'ajax',
	        orderItemId: orderItemId || ''
	      };
	      var url = '/AjaxMembershipApplicationMetaDataView?' + $.param(querystrings);
	      // If we have the data already, lets use it instead of making a call.
	      if (!$.isEmptyObject(configProduct) && orderItemId == configProduct.applicationTrackingCookie) {
	        var data = {};
	        data.configProduct = configProduct;
	        return deferred.resolve(data);
	      }
	      COSTCO.util.ajax({
	        url: url,
	        type: 'GET',
	        dataType: 'json',
	        done: function done(data, textStatus, jqXHR, options) {
	          // We'll set this in cache in case we want to use it elsewhere
	          if (data.configProduct) {
	            // If we returned with a configProduct, we cool
	            MembershipData.setConfigProduct(data);
	          } else {
	            // Otherwise, set this to empty and dont track this orderItemsId
	            data.configProduct = {};
	            MembershipData.setConfigProduct(data, true);
	          }
	          if (data.error) {
	            deferred.reject(data, textStatus, jqXHR, options);
	          }
	          deferred.resolve(data, textStatus, jqXHR, options);
	        },
	        fail: function fail(jqXHR, textStatus, errorThrown, options) {
	          deferred.reject(jqXHR, textStatus, errorThrown, options);
	        }
	      });
	      return deferred.promise();
	    },
	    /**
	     * Makes a call to the server to fetch the membership meta data. Stores
	     * it in sessionStorage and returns it with subsequent calls instead of
	     * making additional calls.
	     * @return {jQuery.Deferred} Returns a thenable promise that resolves the
	     *                                   membership meta data.
	     */
	    getMembershipData: function getMembershipData() {
	      var _this = this;
	
	      var membershipData = this._getMembershipData();
	      if (!$.isEmptyObject(membershipData)) {
	        return $.Deferred().resolve(membershipData);
	      }
	      return COSTCO.util.ajax({
	        url: COSTCO.util.makeUrl('/AjaxMembershipMetaDataView', {
	          pseudo: new Date().getTime()
	        }),
	        dataType: 'json'
	      }).then(function (data) {
	        // 	@KMED - COPY HOW WE HANDLE ERRORS FROM MEMBERSHIP APPLICATION
	        // 	<%-- Print Global errors --%>
	        // 	if (MembershipMetaData.payload.errorMessages.length > 0){
	        // 		for (var i = 0; i < MembershipMetaData.payload.errorMessages.length; ++i) {
	        // 			$('#crmMetaDataGlobalError').html(MembershipMetaData.payload.errorMessages[i]);
	        // 		}
	        // 		$('#crmMetaDataGlobalError').show();
	        // 		$('html, body').animate({ scrollTop: $('#crmMetaDataGlobalError') });
	        // 	}else{
	        // 		$('#crmMetaDataGlobalError').hide();
	        // 	}
	        // 	if(data.caller.usageRole != '01'){
	        // 		$('#digitalConnection').remove();
	        // 		$('#mailConnection').remove();
	        // 	}
	        //
	        //  @KMED - WE NEED TO DECOUPLE CITI STUFF. NEED TO FIGURE OUT
	        //  WHATS HAPPENING HERE
	        // 	COSTCO.util.updateCappJson();
	        // 	COSTCO.util.processCappLogic();
	        //
	        // 	@KMED - HERE WE SET AND RETURN
	        return _this.setMembershipData(data);
	      });
	    },
	    /**
	     * Sets the membership meta data in session storage.
	     * @param  {Object} data The membership meta data to set
	     * @return {Object}      Returns the membership meta data for chainable
	     *                               processing.
	     */
	    setMembershipData: function setMembershipData(data) {
	      var u = COSTCO.util;
	      if (data) {
	        u.setInSession('membershipData', data);
	      }
	      return data;
	    },
	    /**
	     * Private method used by "getMembershipData" to return the membership
	     * meta data.
	     * @return {[type]} [description]
	     */
	    _getMembershipData: function _getMembershipData() {
	      return COSTCO.util.getFromSession('membershipData');
	    },
	    /**
	     * If configProduct exists as part of the response, store it. Return
	     * the data for further processing. applicationTrackingCookie = orderItemsId
	     * @param  {Object} data        The application meta data
	     * @param  {Boolean} notTracking The flag to say 'dont use this orderItemsId'.
	     *                               If not included, will add property
	     *                               applicationTrackingCookie
	     * @return {Object}             The application meta data
	     */
	    setConfigProduct: function setConfigProduct(data, notTracking) {
	      var u = COSTCO.util;
	      if (data && data.configProduct) {
	        if (!notTracking) {
	          data.configProduct.applicationTrackingCookie = applicationTrackingCookie;
	        }
	        u.setInSession('configProduct', data.configProduct);
	      }
	      return data;
	    },
	    /**
	     * Gets the configProduct from the session storage
	     * @return {Object} The object representing the configProduct
	     */
	    getConfigProduct: function getConfigProduct() {
	      return COSTCO.util.getFromSession('configProduct');
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.MembershipData = MembershipData;
	  return MembershipData;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * @title addressForm.js: Feature level module
	 * @description Address utility module
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14), __webpack_require__(17), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (address, addressVerification, preauthchargesmodal) {
		var CAddressForm = {
			addressVal: address,
			validationRulesApplied: false,
			// Set of rules used only for address validation
			// This method should be ran once with initialization
			validationRules: function validationRules() {
	
				if (!CAddressForm.validationRulesApplied) {
	
					$.validator.setDefaults({ ignore: ".ignoreHide" });
					$.validator.addMethod("companyrequiredcheck", function (value, element) {
						if ($('#isBDAppVar').val() == 'BD') {
							return value != "";
						} else {
							return true;
						}
					}, messages.ERR_INVALID_COMPANY);
					$.validator.addMethod("pobox", function (value, element) {
						if ($('#isBDAppVar').val() == 'BD') {
							var addressBookBool = typeof element.form.addressType[0] !== 'undefined' ? element.form.addressType[0].value == 'S' ? true : false : false;
							var poRegex = /^[^a-z]*(((num(ber)?|#) *\d+)|((box|bin|b)[-. \/\\]? *(num(ber)?|#)? *\d+)|((.*[^a-z])?p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(num(ber)?|#)?\d+)([^a-z]|$))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *(num(ber)?|#)? *\d+)|(p *-?\/?(o)? *-?box([^a-z]|$))|post office box)/i;
							var poCheck = element.form.addressType.value == 'S' || addressBookBool ? !poRegex.test(value) : true;
							return this.optional(element) || poCheck;
						} else {
							return true;
						}
					}, messages.ERR_INVALID_POBOX);
					$.validator.addMethod("notEqual", function (value, element, param) {
						return this.optional(element) || value != param;
					}, messages.ERR_INVALID_STATE);
					$.validator.addMethod("countryspecificpostalcodePassCountrySelectorModal", function (value, element) {
						var form = element.form;
						var country = $(form).find('[name=country]');
						if (country.val() === undefined) {
							return !COSTCO.CAddressForm.isUS({ input: element }) ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
						}
						return country.val() != 'US' ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
					}, messages.ERR_ENTER_ZIPCODE);
					$.validator.addMethod("hasvalidationerror", function (value, element) {
						return element.getAttribute('hasvalidationerror') == undefined || element.getAttribute('hasvalidationerror') == null || element.getAttribute('hasvalidationerror') == "false";
					}, messages.ERR_INVALID_STATE);
					$.validator.addMethod("validateAdditionalTerritories", function (value, element, param) {
						var form = element.form;
						var stateCode = $(form).find('[name=state]').val();
						var additionalBillingStatesCode = CAddressForm.getAdditionalBillingStates();
						if (wcs.isPharmacy === "true") {
							if (!additionalBillingStatesCode.includes(stateCode)) {
								return true;
							} else {
								return false;
							}
						}
						if (param == 'S') {
							if (!additionalBillingStatesCode.includes(stateCode)) {
								return true;
							} else {
								return false;
							}
						} else {
							return true;
						}
					}, messages.ERR_INVALID_STATE);
					$.validator.addMethod("validateCity", function (value, element) {
						var cityValidationRegex = new RegExp($('#cityValidationRegex').val());
						return value !== null && value !== '' ? cityValidationRegex.test(value.trim()) : true;
					}, messages.ERR_INVALID_CITY_NAME);
					$.validator.addMethod("email", function (value, element) {
						return (/^[_a-zA-Z0-9-+]+(\.[_a-zA-Z0-9-+]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,10})$/.test(value.toLowerCase())
						);
					}, messages.JS_VALID_EMAIL);
					$.validator.addMethod("phone", function (value, element) {
						if (value.startsWith("0") || value.startsWith("1")) {
							return false;
						}
						//Method phone is already used for Patient Insurance phone, when there is an address creation this overrides the old bind
						try {
							if (element && element.id === "insurancePhone") {
								return this.optional(element) || /\(?([0-9]{3})\)\s([0-9]{3})\2?([-]?)([0-9]{4})/.test(value);
							}
						} catch (e) {
							console.log(e);
							return true; //if element is empty , no validation required
						}
						return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
					}, messages.ERR_INVALID_PHONE1);
					$.validator.addMethod("contactPhone", function (value, element) {
						if (value.startsWith("0") || value.startsWith("1")) {
							return false;
						}
						return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
					}, messages.ERR_INVALID_PHONE1);
					/** STRY0157080 Require at least ONE alphabet in each of the name fields */
					$.validator.addMethod("firstNameValidation", function (value, element) {
						return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
					}, messages.ERR_INVALID_FNAME);
					$.validator.addMethod("lastNameValidation", function (value, element) {
						return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
					}, messages.ERR_INVALID_LNAME);
					/** SFSTRY0039312 Implement special characters restrictions for Company name as First and Last Name fields */
					$.validator.addMethod("companyNameValidation", function (value, element) {
						if ($('#isBDAppVar').val() == 'BD' && element.form.addressType.value != 'B') {
							return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
						} else {
							return true;
						}
					}, messages.ERR_INVALID_COMPANY);
					CAddressForm.validationRulesApplied = true;
				}
			},
	
			/**
	   * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val() to get unformatted value
	   */
			maskInput: function maskInput(template) {
				$(template).find('[name=phone]').unmask().mask('000-000-0000');
				$(template).find('#contactPhNo').unmask().mask('000-000-0000');
				$(template).find('#contactPhNo-inline').unmask().mask('000-000-0000');
				$(template).find('.phoneNumber').unmask().mask('000-000-0000');
	
				if (COSTCO.CAddressForm.isUS({ form: template })) {
					$(template).find('[name=postal]').unmask().mask('00000-0000');
				} else {
					$(template).find('[name=postal]').unmask().mask('S0S 0S0');
				}
			},
			/**
	   * Determine if the form or input is should be interpretted as US.
	   * In the case of a form, we look at the select[name=country]. In the case
	   * of a input, we use the data-country attribute to get the value of
	   * a designated select[name=country] which will have the US/CA value,
	   * otherwise we check the lang ID as a last resort.
	   * @param {object} elementsObj - OPTIONAL - Object with the structure
	   * of {form: formElement, input: inputElement}. Pass inputElement must 
	   * contain a data-attribute that maps to the country select to pull the value.
	   */
			isUS: function isUS(elementsObj) {
				var $form = elementsObj && elementsObj.form ? $(elementsObj.form) : COSTCO.CAddressForm.getForm();
				var $input = elementsObj && elementsObj.input ? $(elementsObj.input) : $('');
				var country = 'US';
	
				if ($input.data('country')) {
					// If passed an input, it needs to have a data-country attribute
					// that maps to the country select we want to interogate if we're
					// US or not.
					var countrySelectId = $input.data('country');
					country = $(countrySelectId).val();
				} else if ($form.find('[name=country]').val()) {
					// Interrogates the form to see if we have a select[name=country] 
					// to determine if US
					country = $form.find('[name=country]').val();
				} else {
					// Last resort is to use the lang ID
					if (COSTCO.util.getLangId() != -1) {
						country = 'CA';
					}
				}
	
				return country == 'US';
			},
	
			createAddressForm: function createAddressForm(obj) {
				var data;
				if (typeof obj === 'number') {
					var addressJson = address.getAddressJson(obj)[0];
					if (addressJson.length == 0) return '';
					data = addressJson[0];
				} else {
					data = obj;
				}
	
				return COSTCO.util.tmpl('tmpl_address_form', obj);
			},
			/**
	   * 
	   * Function used to setup the data and parameter to open the
	   * Address Form modal.
	   * 
	   * Param
	   * 	type		- 1 character denoting S for Shipping B for Billing
	   *  obj			- can be either address id or the address json object
	   *  orderItemId - order item id that we are trying to edit the address for
	   *  multiAddress	- whether or not the order is multiShipping address
	   * 
	   */
			editAddress: function editAddress(type, obj, orderItemId, multiAddress) {
				var data;
				if (typeof obj === 'number') {
					var addressJson = address.getAddressJson(obj, null, type)[0];
					data = addressJson;
				} else {
					data = obj;
				}
	
				if (data == null) {
					data = window['ajaxAddressObject_' + obj];
				}
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
	
				if (typeof addressOptions.url === 'undefined') {
					addressOptions.url = '/AjaxAddressAddCmd';
				}
				//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
				else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
						addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, { mode: 'UPDATE' });
					}
	
				if (multiAddress) {
					addressOptions.orderItemId = orderItemId;
					addressOptions.multiAddress = multiAddress;
				}
				//National delivery UX change to remove Terms and Condition Modal in Address book for BD US
				if ($('#isBDAppVar').val() == 'BD' && type == 'S' && !COSTCO.util.isNdEnabled()) {
					CAddressForm.showBusinessDeliveryQuestionnaireModal(type, data, 'edit', addressOptions);
				} else {
					CAddressForm.openAddressAddModal(type, data, 'edit', addressOptions);
				}
			},
	
			editAddress_v2: function editAddress_v2(type, obj, orderItemId, multiAddress) {
				var data;
				if (typeof obj === 'number') {
					var addressJson = address.getAddressJson(obj, null, type)[0];
					data = addressJson;
				} else {
					data = obj;
				}
	
				if (data == null) {
					data = window['ajaxAddressObject_' + obj];
				}
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
	
				if (typeof addressOptions.url === 'undefined') {
					addressOptions.url = '/AjaxAddressAddCmd';
				}
				//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
				else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
						addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, { mode: 'UPDATE' });
					}
	
				if (multiAddress) {
					addressOptions.orderItemId = orderItemId;
					addressOptions.multiAddress = multiAddress;
				}
	
				if ($('#isBDAppVar').val() == 'BD' && type == 'S') {
					CAddressForm.showBusinessDeliveryQuestionnaireModal_v2(type, data, 'edit', addressOptions);
				} else {
					CAddressForm.openAddressAddModal_v2(type, data, 'edit', addressOptions);
				}
			},
			/**
	   * Opens an edit address modal directly on the page (without first opening choose address modal).
	   * 
	   * This is because regularly the address batch retrieve is being invoked on the choose address modal opening
	   */
			directEditAddress: function directEditAddress(type, addressId, orderItemId, multiAddress) {
				if (typeof COSTCO.util == 'undefined' || COSTCO.util.addresses.length == 0) {
					COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function (data) {
						CAddressForm.editAddress(type, addressId, orderItemId, multiAddress);
					});
				} else {
					CAddressForm.editAddress(type, addressId, orderItemId, multiAddress);
				}
			},
	
			createNewAddress: function createNewAddress(type, orderItemId, multiAddress) {
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
				if (typeof orderItemId !== 'undefined' && orderItemId > 0) {
					addressOptions.orderItemId = orderItemId;
				}
				if (typeof addressOptions.url === 'undefined') {
					addressOptions.url = '/AjaxAddressAddCmd';
				}
				//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
				else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
						addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, { mode: 'ADD' });
					}
				//National delivery UX change to remove Terms and Condition Modal in Address book for BD US
				if ($('#isBDAppVar').val() == 'BD' && type == 'S' && !COSTCO.util.isNdEnabled()) {
					CAddressForm.showBusinessDeliveryQuestionnaireModal(type, undefined, 'add', addressOptions);
				} else {
					CAddressForm.openAddressAddModal(type, undefined, 'add', addressOptions);
				}
			},
	
			createNewAddress_v2: function createNewAddress_v2(type, orderItemId, multiAddress) {
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
				if (typeof orderItemId !== 'undefined' && orderItemId > 0) {
					addressOptions.orderItemId = orderItemId;
				}
				if (typeof addressOptions.url === 'undefined') {
					addressOptions.url = '/AjaxAddressAddCmd';
				}
				//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
				else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
						addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, { mode: 'ADD' });
					}
	
				if ($('#isBDAppVar').val() == 'BD' && type == 'S') {
					CAddressForm.showBusinessDeliveryQuestionnaireModal_v2(type, undefined, 'add', addressOptions);
				} else {
					CAddressForm.openAddressAddModal_v2(type, undefined, 'add', addressOptions);
				}
			},
	
			createInline: function createInline(selector, type, checkoutPage, multi) {
	
				var html = COSTCO.CAddressForm.createHtml(type, undefined, 'add', 'inline', checkoutPage, multi);
	
				$(selector).html(html);
	
				COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function (data) {
	
					if (data.totalRecords > 0) {
						COSTCO.CAddressForm.createChooseLink(selector, type);
					} else {
						$(selector).find('#select-saved').addClass('hide');
					}
				});
			},
	
			createInline_v2: function createInline_v2(selector, type, checkoutPage, multi, smsNotificationData) {
				var html;
				if (typeof smsNotificationData !== 'undefined') {
					html = COSTCO.CAddressForm.createHtml_v2(type, undefined, 'add', 'inline', checkoutPage, multi, null, smsNotificationData);
				} else {
					html = COSTCO.CAddressForm.createHtml_v2(type, undefined, 'add', 'inline', checkoutPage, multi);
				}
	
				$(selector).html(html);
	
				COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function (data) {
	
					if (data.totalRecords > 0) {
						COSTCO.CAddressForm.createChooseLink(selector, type);
					} else {
						$(selector).find('#select-saved').addClass('hide');
					}
				});
	
				var isPreventSameAddressEnabled = $('input[name="isPreventSameAddressEnabled"]');
	
				if (isPreventSameAddressEnabled.length > 0 && isPreventSameAddressEnabled.val()) {
					$('body').unbind("costco.address.error").bind("costco.address.error", function (event, error) {
						if (typeof error != 'undefined') {
							if (error == '_ERR_INVALID_SHIP_ADDR') {
								COSTCO.CAddress.closeModal();
								$('#notification-message').html(messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR).addClass('critical-notification');
								var formId = $('#address-modal-inline');
								var addressField = '#S_address1Id';
								COSTCO.dialog.sameAddressValidation(formId, addressField);
							}
						}
					});
				}
			},
	
			createChooseLink: function createChooseLink(selector, type) {
	
				var chooseLink = "<a href=\"javascript:void(0)\" onclick=\"COSTCO.CAddressSelectionDialog.showAddressSelectionDialog(null,'{0}');return false;\">{1}</a>";
	
				var html = COSTCO.util.messageFormat(chooseLink, type, addressInputLabels.choosesaved);
	
				$(selector).find('#select-saved div').html(html);
			},
	
			insertSmsNotificationAgreement: function insertSmsNotificationAgreement(orderId, orderSmsPhone) {
	
				var check = orderSmsPhone.length > 0 ? 'checked' : '';
				if (orderSmsPhone.length == 10) {
					// Insert '-' to avoid onchange event fired on tab and other keys which don't change input field value. 
					var formatted = orderSmsPhone.substr(0, 3) + '-' + orderSmsPhone.substr(3, 3) + '-' + orderSmsPhone.substr(6, 4);
					orderSmsPhone = formatted;
				}
				var hide = orderSmsPhone.length > 0 ? '' : 'hidden';
				var data = {
					orderId: orderId,
					smsPhone: orderSmsPhone,
					check: check,
					hide: hide
				};
				var template = COSTCO.util.tmpl('tmpl_sms_notification_agreement_block', data);
				$('.smsNotificationBlock').html(template);
			},
	
			insertSmsNotificationAgreement_v2: function insertSmsNotificationAgreement_v2(arg, smsPhoneNumber, updateAction, checkCheckbox) {
				var check = smsPhoneNumber.length > 0 ? 'checked' : '';
				if (smsPhoneNumber.length == 10) {
					// Insert '-' to avoid onchange event fired on tab and other keys which don't change input field value. 
					var formatted = smsPhoneNumber.substr(0, 3) + '-' + smsPhoneNumber.substr(3, 3) + '-' + orderSmsPhone.substr(6, 4);
					smsPhoneNumber = formatted;
				}
				var hide = smsPhoneNumber.length > 0 ? '' : 'hidden';
				var data = {
					arg: arg,
					smsPhoneNumber: smsPhoneNumber,
					updateAction: updateAction,
					checkCheckbox: checkCheckbox,
					hide: hide
				};
				var template = COSTCO.util.tmpl('tmpl_sms_notification_agreement_block_v2', data);
				$('.smsNotificationBlock').html(template);
			},
	
			createHtml: function createHtml(type, addressObj, mode, modaltypeOverride, checkoutPage, multi, error) {
	
				var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
	
				var stateProvList = address.getStateProvJson();
				COSTCO.CAddressForm.addressVal = stateProvList;
				var stateOptions = CAddressForm.getStateOptions(stateProvList, type, addressObj);
				var countryOptions = CAddressForm.getCountryOptions(type);
	
				var data = addressInputLabels;
	
				var headerLabels = address.getHeaderLabels(type, mode);
	
				data.primaryMessage = headerLabels.primaryMessage;
				var modaltype = 'modal';
				if (typeof modaltypeOverride !== 'undefined') {
					modaltype = modaltypeOverride;
				}
	
				var template = COSTCO.util.tmpl('tmpl_address_form_' + modaltype, data);
				template = $(template);
	
				if (!isDeriveCityStateEnabled) {
					template.find('.stateprov-select').append(stateOptions);
				}
	
				template.find('.country-select').append(countryOptions).change(function () {
	
					var country = $(this).val();
					var stateOptions = CAddressForm.getStateOptions(stateProvList, type, { country: country });
					if (!isDeriveCityStateEnabled) {
						template.find('.stateprov-select').empty().append(stateOptions);
					}
					updateCountryLabels(country);
					CAddressForm.maskInput(template);
				});
	
				if (typeof error != 'undefined') {
					if (error == '_ERR_INVALID_SHIP_ADDR') {
						template.append('<input type="hidden" name="invalid-ship-addr" value="true" />');
					} else {
						template.find('.error').html(error);
					}
				}
	
				var updateCountryLabels = function updateCountryLabels(country) {
					if (country == 'US') {
						template.find('label[for="postalId"]').html(data.uspostallabel);
						template.find('label[for="stateId"]').html(data.usstatelabel);
					} else {
						template.find('label[for="postalId"]').html(data.capostallabel);
						template.find('label[for="stateId"]').html(data.castatelabel);
					}
				};
	
				if (addressObj) {
					updateCountryLabels(addressObj.country);
				}
	
				template.find('[name=postal]').on('input', { modaltype: modaltype }, function (event) {
					var value = $(this).val();
					var region = COSTCO.util.isUsOrCaZipCode();
					if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
						COSTCO.CAddress.bingCityState(this, '[name=city]', '[name=state]');
						if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
							if ($('#isBDAppVar').val() != 'BD') {
								COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
							}
						}
					}
					if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
						if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
							COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
						}
						if (!region) {
							if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
						}
						if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
							if ($('#isBDAppVar').val() != 'BD') {
								COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
							}
						}
					}
				});
	
				if (type == 'B') {
					template.find('#country-row').removeClass('hide');
				}
				if (mode == 'add') {
					template.find('[name=email]').val($('#defaultEmail').val());
				}
				if (type == 'S') {
					template.find('#delIntsr-row').removeClass('hide');
					template.find('#contactName').removeClass('ignoreHide');
					template.find('#contactPhNo').removeClass('ignoreHide');
				}
	
				if (mode == 'edit') {
					template.find('.address-checkboxes').hide();
					if (addressObj.isPrimary == '1' && type == 'S') {
						template.find(".defaultWarning").removeClass('hide');
					} else {
						template.find(".defaultWarning").addClass('hide');
					}
				}
	
				/*
	    * Show the default shipping warning
	    */
	
				var updateWarning = function updateWarning(modaltype) {
	
					if (template.find('#set-default-' + modaltype).prop('checked')) {
						template.find(".defaultWarning").removeClass('hide');
					} else {
						template.find(".defaultWarning").addClass('hide');
					}
				};
	
				if (mode == 'add') {
					if (type == 'S') {
	
						/* Below click binding function was added to the set-default checkbox to toggle setAsDefaultShippingAddress hidden field 
	      * on the page. This hidden field has to change based on the checkbox status so that page submit reads the right value to
	      * set on IsPrimary field of address record. */
						template.find('#set-default-' + modaltype).bind("click", function () {
							if ($('#set-default-' + modaltype).is(':checked')) {
								$('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('true');
							} else {
								$('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('false');
							}
						});
	
						template.find('#set-default-' + modaltype).click(function () {
							updateWarning(modaltype);
						});
					}
	
					var detectedCheckoutPage = typeof checkoutPage !== 'undefined' ? checkoutPage : window.checkoutPage;
	
					if (detectedCheckoutPage === 'shipping' || detectedCheckoutPage === 'multi-shipping' || detectedCheckoutPage === 'payment') {
						template.find('#set-default-' + modaltype).prop('checked', modaltype === 'inline');
					} else if (detectedCheckoutPage === 'review' || detectedCheckoutPage === 'live-tickets') {
						template.find('#set-default-' + modaltype).prop('checked', false);
					}
					updateWarning(modaltype);
				}
	
				template.find('#set-default-' + modaltype).click(function () {
					if ($(this).prop('checked')) {
						template.find('#save-address-' + modaltype).prop('checked', true);
					}
					if (checkoutPage == 'shipping') {
						updateWarning(modaltype);
					}
				});
	
				template.find('#save-address-' + modaltype).click(function () {
					if (!$(this).prop('checked')) {
						$('#set-default-' + modaltype).prop('checked', false);
					}
					if (checkoutPage == 'shipping') {
						updateWarning(modaltype);
					}
				});
	
				if (typeof addressObj !== 'undefined') {
					CAddressForm.populateAddressModal(template, addressObj, modaltype);
				} else {
					template.find('[name=addressType]').val(type);
				}
	
				if ((checkoutPage === 'payment' || checkoutPage === 'review' || checkoutPage === 'live-tickets') && type == 'B' && modaltype == 'inline') {
					template.find('#address-same-as-ship').removeClass('hide');
				}
	
				if (type == 'B') {
					template.find(".defaultWarning").addClass('hide');
				}
	
				CAddressForm.maskInput(template);
	
				return template;
			},
			// returns id of matching template element, or null
			findTemplateId_v2: function findTemplateId_v2(type, templateName, modalType) {
				var result = null;
				modalType = modalType == null || modalType == undefined || modalType == '' ? '' : '_' + modalType;
				var template = $('#tmpl_' + type + '_' + templateName + modalType + '_v2');
				if (template.length == 0) {
					// look for template with the "_gift" suffix
					template = $('#tmpl_' + type + '_' + templateName + modalType + '_gift_v2');
				}
				if (template.length == 0) {
					var orderItemInputs = $('input[name^="orderItem_"]');
					for (var i = 0; i < orderItemInputs.length && template.length == 0; i++) {
						var orderItemId = orderItemInputs.get(i).value;
						// look for template with the orderItemId
						template = $('#tmpl_' + type + '_' + templateName + modalType + ('_' + orderItemId) + '_v2');
						if (template.length == 0) {
							// look for template with the orderItemId and the "_gift" suffix
							template = $('#tmpl_' + type + '_' + templateName + modalType + ('_' + orderItemId) + '_gift_v2');
						}
					}
				}
				if (template.length == 1) {
					result = template.attr('id');
				}
				return result;
			},
	
			createHtml_v2: function createHtml_v2(type, addressObj, mode, modaltypeOverride, checkoutPage, multi, error, smsNotificationData) {
	
				var stateProvList = address.getStateProvJson();
	
				var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
	
				var stateOptions = CAddressForm.getStateOptions(stateProvList, type, addressObj);
				var countryOptions = CAddressForm.getCountryOptions(type);
	
				var addrType = typeof addressObj == 'undefined' ? type : addressObj.addressType;
	
				var data = addressInputLabels;
				if (typeof smsNotificationData !== 'undefined') {
					data.smsNotificationData = smsNotificationData;
					data.showSMSNotificationCheckbox = true;
				} else {
					data.smsNotificationData = {};
					data.showSMSNotificationCheckbox = false;
				}
				var headerLabels = address.getHeaderLabels(type, mode);
	
				data.primaryMessage = headerLabels.primaryMessage;
	
				var modaltype = 'modal';
				if (typeof modaltypeOverride !== 'undefined') {
					modaltype = modaltypeOverride;
				}
	
				var templateId = CAddressForm.findTemplateId_v2(type, 'address_form', modaltype);
				var template = COSTCO.util.tmpl(templateId, data);
	
				template = $(template);
				if (!data.showSMSNotificationCheckbox) {
					template.find('#smsNotificationCheckBox').remove();
				}
	
				if (!isDeriveCityStateEnabled) {
					template.find('.stateprov-select').append(stateOptions);
				}
	
				template.find('.country-select').append(countryOptions).change(function () {
	
					var country = $(this).val();
					var stateOptions = CAddressForm.getStateOptions(stateProvList, type, { country: country });
					if (!isDeriveCityStateEnabled) {
						template.find('.stateprov-select').empty().append(stateOptions);
					}
					template.find('#city-state').addClass('hide');
					template.find('input[id=' + addrType + '_postalId]').val('');
					template.find('label[for=' + addrType + '_postalId]').removeClass('active');
					updateCountryLabels(country);
					CAddressForm.maskInput(template);
				});
	
				if (typeof error != 'undefined') {
					if (error == '_ERR_INVALID_SHIP_ADDR') {
						template.append('<input type="hidden" name="invalid-ship-addr" value="true" />');
						template.find('.error').html(messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR).addClass('critical-notification cds-u-space-mb-md');
					} else {
						template.find('.error').html(error);
					}
				}
	
				var updateCountryLabels = function updateCountryLabels(country) {
					if (country == 'US') {
						template.find('label[for="' + addrType + '_postalId"]').html(data.uspostallabel);
						template.find('label[for="' + addrType + '_stateId"]').html(data.usstatelabel);
						template.find('label[id="zip-info-text"]').html(data.usZipInfoText);
					} else {
						template.find('label[for="' + addrType + '_postalId"]').html(data.capostallabel);
						template.find('label[for="' + addrType + '_stateId"]').html(data.castatelabel);
						template.find('label[id="zip-info-text"]').html(data.caZipInfoText);
					}
				};
	
				if (addressObj) {
					updateCountryLabels(addressObj.country);
				}
	
				template.find('[name=postal]').on('input', { modaltype: modaltype }, function (event) {
					var value = $(this).val();
					var region = COSTCO.util.isUsOrCaZipCode();
					if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
						COSTCO.CAddress.bingCityState(this, '[name=city]', '[name=state]');
						if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
							if ($('#isBDAppVar').val() != 'BD') {
								COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
							}
						}
					}
					if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
						if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
							COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
						}
						if (!region) {
							if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) {
								COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
							}
						}
						if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
							if ($('#isBDAppVar').val() != 'BD') {
								COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
							}
						}
					}
				});
				if (type == 'B') {
					template.find('#country-row').removeClass('hide');
				}
				if (mode == 'add') {
					template.find('[name=email]').val($('#defaultEmail').val());
				}
				if (type == 'S') {
					template.find('#delIntsr-row').removeClass('hide');
					template.find('#contactName').removeClass('ignoreHide');
					template.find('#contactPhNo').removeClass('ignoreHide');
					$('#contact-information-phone').css('padding-left', '0');
				}
	
				if (mode == 'edit') {
					if (addressObj.addressType !== 'T') {
						template.find('#save-to-address-book').hide();
					}
					if (addressObj.isPrimary == '1') {
						template.find('#set-default-address').hide();
					}
					if (addressObj.isPrimary == '1' && type === 'S') {
						template.find(".defaultWarning").show();
					} else {
						template.find(".defaultWarning").hide();
					}
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
						if (template.find('#save-to-address-book').is(':hidden') === true && template.find('#set-default-address').is(':hidden') === true) {
							template.find('.checkbox-separator').addClass('hide');
						}
					}
				}
	
				/*
	    * Show the default shipping warning
	    */
	
				var updateWarning = function updateWarning(modaltype) {
	
					if (template.find('#set-default-' + modaltype).prop('checked')) {
						template.find(".defaultWarning").removeClass('hide');
					} else {
						template.find(".defaultWarning").addClass('hide');
					}
				};
	
				if (mode == 'add') {
					if (type == 'S') {
	
						/* Below click binding function was added to the set-default checkbox to toggle setAsDefaultShippingAddress hidden field 
	      * on the page. This hidden field has to change based on the checkbox status so that page submit reads the right value to
	      * set on IsPrimary field of address record. */
						template.find('#set-default-' + modaltype).bind("click", function () {
							if ($('#set-default-' + modaltype).is(':checked')) {
								$('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('true');
							} else {
								$('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('false');
							}
						});
	
						template.find('#set-default-' + modaltype).click(function () {
							updateWarning(modaltype);
						});
					}
	
					var detectedCheckoutPage = typeof checkoutPage !== 'undefined' ? checkoutPage : window.checkoutPage;
	
					if (detectedCheckoutPage === 'multi-shipping') {
						template.find('#set-default-' + modaltype).prop('checked', modaltype === 'inline');
					} else if (detectedCheckoutPage === 'review') {
						template.find('#set-default-' + modaltype).prop('checked', false);
					}
					updateWarning(modaltype);
				}
	
				template.find('#set-default-' + modaltype).click(function () {
					if ($(this).prop('checked')) {
						template.find('#save-address-' + modaltype).prop('checked', true);
						$('#set-default-' + modaltype).prop('value', true);
						$('.defaultWarning.kb-OOS-banner').show();
					} else {
						$('#set-default-' + modaltype).prop('value', false);
						$('.defaultWarning.kb-OOS-banner').hide();
					}
				});
	
				template.find('#save-address-' + modaltype).click(function () {
					if (!$(this).prop('checked')) {
						$('#set-default-' + modaltype).prop('checked', false);
						$('.defaultWarning.kb-OOS-banner').hide();
					}
					if (checkoutPage == 'shipping') {
						updateWarning(modaltype);
					}
				});
	
				if (typeof addressObj !== 'undefined') {
					CAddressForm.populateAddressModal_v2(template, addressObj, modaltype);
				} else {
					template.find('[name=addressType]').val(type);
				}
	
				if (type === 'B' && modaltype === 'inline') {
					template.find('#address-same-as-ship').removeClass('hide');
				}
	
				if (type == 'B') {
					template.find(".defaultWarning").addClass('hide');
				}
	
				CAddressForm.maskInput(template);
	
				//SFSTRY0015679 make company name mandatory in USBD for Local Business Delivery
				var isLocalBusinessDelivery = typeof shipModeLocalND !== 'undefined' && ($("input[name='deliveryMethod']:checked").val() == shipModeLocalND || $("input[name='deliveryMethod']:checked").val() == shipModeLocal);
				if ($('#isBDAppVar').val() === 'BD') {
					//SFSTRY0020930 - check if xapp flag for company name mandate is enabled
					var isCompanyMandateEnabled = $("#isCompanyMandateEnabled").val();
					if (wcs.storeId === '11303' || wcs.storeId === '11301' && isLocalBusinessDelivery && isCompanyMandateEnabled === "true") {
						$(template).find('[name=company]').parent().parent().removeClass('hide');
						$(template).find('#showCompanyField').parent().addClass('hide');
					}
				}
	
				return template;
			},
	
			populateAddressModal: function populateAddressModal(template, addressObject, modaltype) {
	
				template.find('[name=addressId]').val(addressObject['id']);
				template.find('#firstId').val(addressObject['first']);
				template.find('#lastId').val(addressObject['last']);
				var companyName = COSTCO.util.get_decoded_html(addressObject['company']);
				if (companyName != undefined && companyName != "undefined" && companyName != "") {
					template.find('#companyId').val(companyName);
				} else {
					template.find('#companyId').val("");
				}
				template.find('[name=country]').val(addressObject['country']);
				template.find('[name=address1]').val(addressObject['line1']);
				template.find('[name=address2]').val(addressObject['line2']);
				template.find('[name=postal]').val(addressObject['zip']);
	
				if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
					var editAddrCity = addressObject['city'];
					var editAddrState = addressObject['state'];
					var postalField = template.find('[name=postal]');
					COSTCO.CAddress.geocodeApiCityState(postalField, '[name=city]', '[name=state]', editAddrCity, editAddrState);
				} else {
					template.find('[name=city]').val(addressObject['city']);
					template.find('[name=state]').val(addressObject['state']);
					template.find('#city-state').removeClass('hide');
				}
	
				if (addressObject['phone'] != undefined && addressObject['phone'] != "") {
					if ($('#isBDAppVar').val() == 'BD') {
						template.find('#phoneId').val(addressObject['phone'].split(/EXT.|x/g)[0]);
						var extension = addressObject['phone'].split(/EXT.|x/g)[1];
						if (extension) {
							template.find('[name=ext1]').val(extension.trim());
						}
					} else {
						template.find('#phoneId').val(addressObject['phone'].split('x')[0]);
						template.find('[name=ext1]').val(addressObject['phone'].split('x')[1]);
					}
				} else {
					template.find('#phoneId').val(addressObject['phone']);
					template.find('[name=ext1]').val(addressObject['phone']);
				}
				template.find('[name=nickname]').val(addressObject['nickname']);
				template.find('[name=email]').val(addressObject['email']);
				template.find('[name=addressType]').val(addressObject.addressType);
				template.find('[name=addressId]').val(addressObject.id);
				if (addressObject['deliveryInstructions']) {
					var deliveryInst = COSTCO.util.get_decoded_html(addressObject['deliveryInstructions']);
				} else if (addressObject['deliveryInst']) {
					var deliveryInst = COSTCO.util.get_decoded_html(addressObject['deliveryInst']);
				}
				template.find('[name=deliveryInstructions]').val(deliveryInst);
				template.find('[name=contactName]').val(addressObject['contactName']);
				template.find('[name=contactPhone]').val(addressObject['contactPhNo']);
	
				if (addressObject.addressType != 'T') {
					template.find('#save-address-' + modaltype).prop('checked', true);
				}
	
				if (addressObject.isPrimary == '1') {
					template.find('#set-default-' + modaltype).prop('checked', true);
				}
	
				if (addressObject.isPrimary === '1' && addressObject.addressType === 'S' && typeof checkoutPage !== 'undefined' && checkoutPage === 'shipping') {
					template.find('.defaultWarning').removeClass('hide');
				}
				$(template).find('#phoneId').unmask().mask('000-000-0000');
			},
	
			populateAddressModal_v2: function populateAddressModal_v2(template, addressObject, modaltype) {
	
				template.find('[name=addressId]').val(addressObject['id']);
	
				template.find('[name=firstModal]').val(addressObject['first']);
				template.find('label[for="' + addressObject.addressType + '_firstId"]').addClass('active');
	
				template.find('[name=lastModal]').val(addressObject['last']);
				template.find('label[for="' + addressObject.addressType + '_lastId"]').addClass('active');
	
				var companyName = COSTCO.util.get_decoded_html(addressObject['company']);
				if (companyName !== undefined && companyName !== "undefined" && companyName !== "") {
					template.find('#' + addressObject.addressType + '_companyId').val(companyName);
					template.find('label[for="' + addressObject.addressType + '_companyId"]').addClass('active');
					COSTCO.CAddressForm.showInputFiled(template.find('#showCompanyField'));
				} else {
					template.find('#' + addressObject.addressType + '_companyId').val('');
				}
				template.find('[name=country]').val(addressObject['country']);
				template.find('label[for="' + addressObject.addressType + '_countryId"]').addClass('active');
	
				template.find('[name=address1]').val(addressObject['line1']);
				template.find('label[for="' + addressObject.addressType + '_address1Id"]').addClass('active');
	
				if (addressObject['line2'] !== undefined && addressObject['line2'] !== "undefined" && addressObject['line2'] !== "") {
					template.find('[name=address2]').val(addressObject['line2']);
					template.find('label[for="' + addressObject.addressType + '_address2Id"]').addClass('active');
					COSTCO.CAddressForm.showInputFiled(template.find('#showAptField'));
				} else {
					template.find('[name=address2]').val('');
				}
	
				template.find('[name=postal]').val(addressObject['zip']);
				template.find('label[for="' + addressObject.addressType + '_postalId"]').addClass('active');
	
				if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
					var editAddrCity = addressObject['city'];
					var editAddrState = addressObject['state'];
					var postalField = template.find('[name=postal]');
					COSTCO.CAddress.geocodeApiCityState(postalField, '[name=city]', '[name=state]', editAddrCity, editAddrState);
				} else {
					template.find('[name=city]').val(addressObject['city']);
					template.find('[name=state]').val(addressObject['state']);
				}
	
				template.find('label[for="' + addressObject.addressType + '_cityId"]').addClass('active');
				template.find('label[for="' + addressObject.addressType + '_stateId"]').addClass('active');
	
				template.find('#city-state').removeClass('hide');
	
				if (addressObject['phone'] != undefined && addressObject['phone'] != "") {
					if ($('#isBDAppVar').val() == 'BD') {
						template.find('[name=phone]').val(addressObject['phone'].split(/EXT.|x/g)[0]);
						template.find('label[for="' + addressObject.addressType + '_phoneId"]').addClass('active');
						var extension = addressObject['phone'].split(/EXT.|x/g)[1];
						if (extension) {
							template.find('[name=ext1]').val(extension.trim());
							template.find('label[for="ext1"]').addClass('active');
						}
					} else {
						template.find('[name=phone]').val(addressObject['phone'].split('x')[0]);
						template.find('label[for="' + addressObject.addressType + '_phoneId"]').addClass('active');
						template.find('[name=ext1]').val(addressObject['phone'].split('x')[1]);
					}
				} else {
					template.find('[name=phone]').val(addressObject['phone']);
					template.find('[name=ext1]').val(addressObject['phone']);
				}
				template.find('[name=nickname]').val(addressObject['nickname']);
	
				template.find('[name=email]').val(addressObject['email']);
				template.find('label[for="' + addressObject.addressType + '_emailId"]').addClass('active');
	
				template.find('[name=addressType]').val(addressObject.addressType);
				template.find('[name=addressId]').val(addressObject.id);
				template.find('[name=deliveryInstructions]').val(addressObject['deliveryInstructions']);
				if (addressObject['deliveryInstructions'] != undefined && addressObject['deliveryInstructions'].length > 0) {
					template.find('label[for=deliveryInstructions-modal]').addClass('active');
				}
				template.find('[name=contactName]').val(addressObject['contactName']);
				if (addressObject['contactName'] != undefined && addressObject['contactName'].length > 0) {
					template.find('label[for=contactName]').addClass('active');
				}
				template.find('[name=contactPhone]').val(addressObject['contactPhNo']);
				if (addressObject['contactPhNo'] != undefined && addressObject['contactPhNo'].length > 0) {
					template.find('label[for=contactPhNo]').addClass('active');
				}
	
				if (addressObject.addressType != 'T') {
					template.find('#save-address-' + modaltype).prop('checked', true);
				}
	
				if (addressObject.isPrimary == '1') {
					template.find('#set-default-' + modaltype).prop('checked', true);
				}
	
				if (addressObject.isPrimary === '1' && addressObject.addressType === 'S' && typeof checkoutPage !== 'undefined' && checkoutPage === 'shipping') {
					template.find('.defaultWarning').removeClass('hide');
				}
	
				if (addressObject === '') {
					COSTCO.CAddressForm.restoreLabelsAndHiddenFieldsForEmptyAddressObject(template);
				}
				template.find('#' + addressObject.addressType + '_phoneId').unmask().mask('000-000-0000');
	
				if (template.find('#phoneId').length > 0) {
					$(template).find('#phoneId').unmask().mask('000-000-0000');
				}
			},
	
			restoreLabelsAndHiddenFieldsForEmptyAddressObject: function restoreLabelsAndHiddenFieldsForEmptyAddressObject(template) {
				template.find('#city-state').addClass('hide');
				template.find('label').each(function () {
					if ($(this).hasClass("active")) {
						$(this).removeClass("active");
					}
				});
				COSTCO.CAddressForm.hideInputFiled(template.find('#showAptField'));
				COSTCO.CAddressForm.hideInputFiled(template.find('#showCompanyField'));
			},
	
			/**
	   * function that populates address form with given address
	   * @param input
	   * 			input address form that needs to be populated
	   * @param addressId
	   * 			address that will be populated in address form
	   * @param modaltype
	   * 			param that determines if form is modal or inline
	   */
			populateAddressFormWithAddressData: function populateAddressFormWithAddressData(input, addressId, modaltype) {
	
				var data = '';
				if (input.checked && addressId !== '') {
					data = window['ajaxAddressObject_' + addressId];
					delete data['id'];
					delete data['nickname'];
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === false) {
						data.isPrimary = '1';
					}
				}
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
					// Add right prefix for address form input ids
					data.addressType = $(input).get(0).name === "same-as-billing" ? 'S' : 'B';
					CAddressForm.populateAddressModal_v2($(input.form), data, modaltype);
				} else {
					CAddressForm.populateAddressModal($(input.form), data, modaltype);
				}
			},
			addressNotServicedModal: function addressNotServicedModal(verifiedAddress, cancelFn, submitFn, message) {
				// Workaround for undefined verifiedAddress 
				var addressObject = {
					addressNotServicedMsg1: messages.ERR_MODAL_ADDRESS_NOT_SERVICED,
					firstName: '',
					lastName: '',
					address1: '',
					city: '',
					state: '',
					zip: '',
					addressNotServicedMsg2: messages.MODAL_ADDRESS_NOT_SERVICED
				};
				if (typeof verifiedAddress !== 'undefined') {
					addressObject = {
						addressNotServicedMsg1: messages.ERR_MODAL_ADDRESS_NOT_SERVICED,
						firstName: verifiedAddress.first,
						lastName: verifiedAddress.last,
						address1: verifiedAddress.line1,
						city: verifiedAddress.city,
						state: verifiedAddress.state,
						zip: verifiedAddress.zip,
						addressNotServicedMsg2: messages.MODAL_ADDRESS_NOT_SERVICED
					};
				}
				if (COSTCO.util.isNdEnabled()) {
					var modalAddressNotServicedForResidentialMessage = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true ? messages.MODAL_ADDRESS_NOT_SERVICED_FOR_RESIDENTIAL_v2 : messages.MODAL_ADDRESS_NOT_SERVICED_FOR_RESIDENTIAL;
					if (message != null && message == "residentialNotServiced") {
						addressObject.addressNotServicedMsg1 = messages.ERR_MODAL_ADDRESS_NOT_SERVICED_FOR_RESIDENTIAL;
						addressObject.addressNotServicedMsg2 = modalAddressNotServicedForResidentialMessage;
					} else {
						addressObject.addressNotServicedMsg1 = messages.ERR_MODAL_ADDRESS_NOT_SERVICED_CART_MERGE;
						addressObject.addressNotServicedMsg2 = messages.MODAL_ADDRESS_NOT_SERVICED_CART_MERGE;
					}
					addressObject.address2 = verifiedAddress.line2;
				}
				var template = COSTCO.util.tmpl('tmpl_address_not_serviced_modal', addressObject);
				address.baseModal('S', 'addrnotserviced', {
					title: messages.MODAL_ADDRESS_NOT_SERVICED_TITLE,
					body: template,
					primary: messages.ADDRESS_NOT_SERVICED_SHOP,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						if (submitFn) {
							submitFn();
						} else {
							COSTCO.dialog.close();
						}
					},
					secondary_event: function secondary_event() {
						if (cancelFn) {
							cancelFn();
						} else {
							COSTCO.dialog.close();
						}
					}
				});
			},
	
			openAddressAddModal: function openAddressAddModal(type, addressObj, mode, addressOptions) {
				var openAddress = function openAddress(error) {
					var htmlBody = CAddressForm.createHtml(type, addressObj, mode, undefined, undefined, undefined, error);
					// if it is edit mode, trigger jQuery validation immediately
					if (mode == "edit") {
						CAddressForm.validate(type, htmlBody);
					}
					var validateAddressTypeModal = [];
					if (addressObj != undefined) {
						validateAddressTypeModal[0] = addressObj.line1;
						validateAddressTypeModal[1] = addressObj.zip;
						validateAddressTypeModal[2] = addressObj.city;
						if (addressObj.userAddressType != 'U') {
							validateAddressTypeModal[3] = addressObj.userAddressType;
						}
					}
					addressOptions.validateParams = validateAddressTypeModal;
					address.baseModal(type, mode, {
						body: htmlBody,
						primary_event: function primary_event() {
							if (CAddressForm.validate(type)) {
								var addressEnteredForCheck = $('#addressEnteredForCheck');
								var address1 = $('FORM[id="address-modal-modal"]').find("#address1Id").val();
								if (!addressEnteredForCheck.length) {
									addressEnteredForCheck = $('<INPUT TYPE="hidden" ID="addressEnteredForCheck" />').appendTo(document.body);
								}
								addressEnteredForCheck.val(address1);
								CAddressForm.submit(type, false, addressOptions);
							}
						},
						onshown: function onshown() {
							if (addressOptions.setAsDefaultAddress) {
								$('#set-default').val('true').attr('checked', true);
							} else {
								$('#set-default').val('false').attr('checked', false);
							}
							var invalidShipAddr = $('input[name=invalid-ship-addr]');
							if (invalidShipAddr.length > 0 && invalidShipAddr.val() === 'true') {
								var formId = $('#address-modal-modal');
								var addressField = '#address1Id';
								COSTCO.dialog.sameAddressValidation(formId, addressField);
							}
						}
					});
				};
				openAddress(undefined);
	
				$('body').unbind("costco.address.error").bind("costco.address.error", function (event, error) {
					openAddress(error);
				});
			},
	
			openAddressAddModal_v2: function openAddressAddModal_v2(type, addressObj, mode, addressOptions) {
				var openAddress = function openAddress(error) {
					var htmlBody = CAddressForm.createHtml_v2(type, addressObj, mode, undefined, undefined, undefined, error);
					if (mode == "edit") {
						CAddressForm.validate(type, htmlBody);
					}
					address.baseModal(type, mode, {
						body: htmlBody,
						primary_event: function primary_event() {
	
							if (CAddressForm.validate(type)) {
								CAddressForm.submit(type, false, addressOptions);
							}
						},
						onshown: function onshown() {
							if ($('input[name=invalid-ship-addr]').length > 0 && $('input[name=invalid-ship-addr]').val() === 'true') {
								var formId = $('#address-modal-modal');
								var addressField = '#S_address1Id';
								COSTCO.dialog.sameAddressValidation(formId, addressField);
							}
						}
					});
				};
				openAddress(undefined);
	
				$('body').unbind("costco.address.error").bind("costco.address.error", function (event, error) {
					openAddress(error);
				});
			},
	
			/**This function checks if the address line has reached max length, and if that is the case shows friendly message
	   * 
	   * Param 
	   * data:	data from children's element 
	   */
			validateAddressLineLength: function validateAddressLineLength(data) {
				var maxLength = 30;
				var errorElement = document.getElementById("address-error-message-" + data.id);
				if (data.value.length === maxLength) {
					//check if errorElement has error class
					if ($(errorElement).hasClass("hide")) {
						$(errorElement).removeClass("hide");
					}
				} else {
					$(errorElement).addClass("hide");
				}
			},
			submit: function submit(type, preventHtmlReload, addressOptions) {
				var addressArray = CAddressForm.buildAddressArray(type);
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
				if ($('#isBDAppVar').val() == 'BD' && type == 'S') {
					var page = $('div#address').data('page') || '';
	
					if (!COSTCO.CAddressForm.isFormCompleted('S') && !(page === 'Home,MyAccount,AccountAddressBook') && !COSTCO.util.isNdEnabled()) {
						CAddressForm.showBDQuestionnaireModalForInlineForm(type, preventHtmlReload, addressOptions, addressArray);
					} else {
						addressOptions.successCallback = CAddressForm.addressVerifiedCallback;
						addressVerification.addressVerification(addressArray, type, preventHtmlReload, addressOptions);
					}
				} else {
					// BEGIN
					// NOTE: Below code is introduced with following commit/fix:
					// Grocery- Defect Fix 9968 Change-Id: Ifdb9bcbc501a5abc9c95733eeffe5140cd7ac55b
					//
					// We probably do not need it any more.
					// If encountering issues, please contact developer
					// 
					// if(typeof orderItemId != 'undefined'){
					// 	if(typeof(orderItemId) == 'number'){
	
					// 		addressOptions.orderItemId=orderItemId;
					// 	}
					// 	else{
					//  	addressOptions.orderItemId=orderItemId.orderItemId;
	
					// 	}
					// }
					// else{
					// 	addressOptions.orderItemId='';
					// }
					// END
					addressOptions.successCallback = CAddressForm.addressVerifiedCallback;
	
					addressVerification.addressVerification(addressArray, type, preventHtmlReload, addressOptions);
				}
			},
			/**
	   * Callback function for address form, on completed address verification service call
	   * @param {}
	   */
			addressVerifiedCallback: function addressVerifiedCallback(addressObj, type, preventajaxhtml, addressOptions) {
	
				if (typeof addressObj !== 'undefined' && addressObj != null && addressObj.Validated_Address != undefined && addressObj.Validated_Address != null) {
					if (addressObj.errorMessage != null && addressObj.errorMessage.length > 0) {
						$('.address-text-error').text(addressObj.errorMessage);
					} else if (addressObj.Validated_Address[0].result == 'ADDRESS_SUGGESTION_AVAILABLE' || addressObj.Validated_Address[0].result == 'ADDRESS_WRONG_NO_SUGGESTION' || addressObj.Validated_Address[0].result == 'ADDRESS_CORRECT_NO_SUGGESTION') {
						var additionalBillingStates = CAddressForm.getAdditionalBillingStates();
						if (addressObj.Validated_Address[0].result == 'ADDRESS_SUGGESTION_AVAILABLE' && additionalBillingStates.includes(addressObj.Validated_Address[0].state) && type == 'S') {
							// SFSTRY0038578: Do not suggest address from unsupported territories for shipping address
							addressObj.Validated_Address[0].result = 'ADDRESS_WRONG_NO_SUGGESTION';
						}
						if (addressVerification.isSuggestedSameAsEntered(addressObj)) {
							var validatedAddress = addressVerification.extractValidatedAddress(addressObj, type);
							COSTCO.CAddressVerification.entered = validatedAddress;
							addressVerification.useAddress(preventajaxhtml, addressOptions);
							//address.addEditAddress(validatedAddress, preventajaxhtml, addressOptions);
						} else {
							addressVerification.showAddressVerificationModal(addressObj, preventajaxhtml, addressOptions);
						}
					} else if (addressObj.Validated_Address[0].result == 'ADDRESS_SERVICE_UNAVAILABLE') {
						var validatedAddress = addressObj.Validated_Address[0];
						address.addEditAddress(validatedAddress, preventajaxhtml, addressOptions);
					} else {
						var validatedAddress = addressVerification.extractValidatedAddress(addressObj, type);
						address.addEditAddress(validatedAddress, preventajaxhtml, addressOptions);
					}
				} else {
					if (addressObj.errorMessageParam != null && addressObj.errorMessageParam.length > 0) {
						elementObj = $('[name=' + addressObj.errorMessageParam[0] + ']');
	
						if (elementObj.length > 0) {
	
							elementObj.parent().addClass('error');
							elementObj.attr('hasvalidationerror', true);
							elementObj.attr('firstNameValidation', true);
							elementObj.attr('lastNameValidation', true);
							COSTCO.CAddressForm.getForm().valid();
						}
					} else if (addressObj.errorMessage != null && addressObj.errorMessage.length > 0) {
						if ($('#address-modal-inline').length > 0) {
							COSTCO.CAddress.closeModal();
						}
						$('.address-text-error').text(addressObj.errorMessage);
					}
				}
			},
	
			getAdditionalBillingStates: function getAdditionalBillingStates() {
				var states = [];
				var territories = $('#additional_Billling_Territories').val();
				if (territories !== null && territories !== undefined && territories !== "") {
					var codeAndDisplayNameOfTerritories = territories.split('|');
					if (codeAndDisplayNameOfTerritories.length !== 0) {
						$.each(codeAndDisplayNameOfTerritories, function (index, codeAndDisplayName) {
							var code = codeAndDisplayName.split(':')[0];
							if (code !== null && code !== undefined && code !== "") {
								var displayName = codeAndDisplayName.split(':')[1];
								if (displayName !== null && displayName !== undefined && displayName !== "") {
									var state = { code: code, displayName: displayName };
									states.push(state);
								}
							}
						});
						return states.map(function (state) {
							return state.code;
						});
					}
				}
				return states;
			},
	
			getStateOptions: function getStateOptions(stateProvList, type, address) {
				var locale = 'en-US';
				locale = COSTCO.util.getLocale();
	
				var defaultCountry = locale.split('-')[1];
				var additionalBillingStatesCode = CAddressForm.getAdditionalBillingStates();
	
				$('#state').on('change', function () {
					CAddressForm.hideCheckboxForAdditionalTerritories(this.value, additionalBillingStatesCode);
				});
	
				if (type == 'S') {
					var _states = CAddressForm.getStates(stateProvList, defaultCountry);
					var filterOutStates = [].concat(_toConsumableArray(additionalBillingStatesCode), ['VI']);
					var filteredStates = _states.filter(function (state) {
						return !filterOutStates.includes(state.code);
					});
					return CAddressForm.getStateProvDropDown(filteredStates);
				} else {
					var states = '';
					if (typeof address !== 'undefined' && typeof address.country !== 'undefined') {
						states = CAddressForm.getStates(stateProvList, address.country);
					} else {
						states = CAddressForm.getStates(stateProvList, defaultCountry);
					}
					if (wcs.isPharmacy === "true") {
						var _filteredStates = states.filter(function (state) {
							return !additionalBillingStatesCode.includes(state.code);
						});
						return CAddressForm.getStateProvDropDown(_filteredStates);
					}
					return CAddressForm.getStateProvDropDown(states);
				}
	
				return '';
			},
			hideCheckboxForAdditionalTerritories: function hideCheckboxForAdditionalTerritories(enteredCode, additionalBilllingStatesCodes) {
				if (additionalBilllingStatesCodes !== null && additionalBilllingStatesCodes !== undefined) {
					if (additionalBilllingStatesCodes.length !== 0) {
						if ($.inArray(enteredCode, additionalBilllingStatesCodes) !== -1) {
							$('#set-default').prop('checked', false);
							$('.save-address-in-book').prop('checked', false);
							$('.defaultWarning').addClass('hide');
							$('#default-address-checkbox').addClass('hide');
							$("#add-to-address-book-checkbox").addClass('hide');
						} else {
							$('.save-address-in-book').prop('checked', true);
							$('#default-address-checkbox').removeClass('hide');
							$('#add-to-address-book-checkbox').removeClass('hide');
						}
					}
				}
			},
	
			getCountryOptions: function getCountryOptions(type) {
	
				if (type == 'S') {
					return CAddressForm.getCountryDropDown(shippingCountries);
				} else {
					return CAddressForm.getCountryDropDown(billingCountries);
				}
	
				return '';
			},
	
			getStates: function getStates(stateProvList, country) {
	
				for (var i = 0; i < stateProvList.length; i++) {
					var stateProvCountry = stateProvList[i].code;
					if (stateProvCountry == country) {
						return stateProvList[i].states;
					}
				}
			},
	
			getStateProvDropDown: function getStateProvDropDown(states) {
	
				html = '';
				for (var i = 0; i < states.length; i++) {
					html += '<option value="' + states[i].code + '">' + states[i].displayName + '</option>';
				}
				return html;
			},
	
			getCityDropDown: function getCityDropDown(cities) {
	
				html = '';
				for (var i = 0; i < cities.length; i++) {
					html += '<option value="' + cities[i] + '">' + cities[i] + '</option>';
				}
				return html;
			},
	
			getCountryDropDown: function getCountryDropDown(countriesList) {
	
				html = '';
	
				var langId = COSTCO.util.getLangId();
				if (langId == -1) {
					countries.sort(function (a, b) {
						return a.code < b.code ? 1 : -1;
					});
				}
	
				for (var k = 0; k < countries.length; k++) {
	
					if (countriesList.indexOf(countries[k].code) >= 0) {
						html += '<option value="' + countries[k].code + '">' + countries[k].displayName + '</option>';
					}
				}
				return html;
			},
	
			getForm: function getForm() {
	
				var forms = $('.address-form');
	
				if (forms.length > 1) {
					return $('#address-modal-modal');
				} else {
					return forms;
				}
			},
	
			validate: function validate(type, formToValidate, isEditDefaultShippingAddress) {
	
				CAddressForm.validationRules();
	
				function getAddressLine1MaxCharLength() {
					var addressLine1MaxChar = 30;
					if ($('#isBDAppVar').val() == 'BD') {
						addressLine1MaxChar = 35;
					}
					return addressLine1MaxChar;
				}
	
				function getFirstLastNameRule() {
					var firstLastNameMaxChar = 40;
					var firstLastNameRule = {
						required: true
					};
					if ($('#isBDAppVar').val() == 'BD') {
						firstLastNameRule.maxlength = firstLastNameMaxChar;
					}
					return firstLastNameRule.required;
				}
	
				function isCompanyRequired() {
					if ($('#isBDAppVar').val() == 'BD') {
						//SFSTRY0020930 - check if xapp flag for company name mandate is enabled
						var isCompanyMandateEnabled = $("#isCompanyMandateEnabled").val();
						var isLocalDelivery = typeof shipModeLocalND !== 'undefined' && ($("input[name='deliveryMethod']:checked").val() == shipModeLocalND || $("input[name='deliveryMethod']:checked").val() == shipModeLocal);
						var modalTitle = $('#costcoModalTitle').text();
						window.digitalDataEvents = window.digitalDataEvents || [];
						if (type == 'S') {
							//SFSTRY0015679 - Company name mandated for Local business delivery.
							if (shippingCountries[0] == "US") {
								if (isCompanyMandateEnabled === "true" && isLocalDelivery) {
									if (typeof modalTitle != 'undefined' && modalTitle != null && $("#S_companyId").val() == '') {
										if (modalTitle.toLocaleLowerCase() === 'add new address') {
											digitalDataEvents.push({ uimsg: "Add New Address Modal | Enter your company name" });
										}
										if (modalTitle.toLocaleLowerCase() === 'edit delivery address') {
											digitalDataEvents.push({ uimsg: "Edit Address Modal | Enter your company name" });
										}
									}
									return true;
								}
								return false;
							} else {
								return true;
							}
						}
						if (type == 'B') {
							if (shippingCountries[0] == "US" && isCompanyMandateEnabled === "true" && isLocalDelivery) {
								if (typeof modalTitle != 'undefined' && modalTitle != null && $("#B_companyId").val() == '') {
									if (modalTitle.toLocaleLowerCase() === 'add new address') {
										digitalDataEvents.push({ uimsg: "Add New Address Modal | Enter your company name" });
									}
									if (modalTitle.toLocaleLowerCase() === 'edit billing address') {
										digitalDataEvents.push({ uimsg: "Edit Address Modal | Enter your company name" });
									}
								}
								return true;
							}
							return false;
						}
					}
					// Was always false before change related to STRY0144246
					return false;
				}
				//Tries to reach the form. First attempt form parameter, second attempt throw COSTCO.CAddressForm.getForm. 
				//And if the form is not undefined, do validation
				var form = void 0;
				if (formToValidate != undefined) {
					form = formToValidate;
				}
				if (form == undefined && COSTCO.CAddressForm.getForm().length != 0) {
					form = COSTCO.CAddressForm.getForm();
				}
				if (form != undefined) {
					if (!isEditDefaultShippingAddress) {
						form.validate({
							rules: {
								firstModal: { required: getFirstLastNameRule(), firstNameValidation: true },
								lastModal: { required: getFirstLastNameRule(), lastNameValidation: true },
								country: "required",
								address1: { required: true, maxlength: getAddressLine1MaxCharLength, pobox: true },
								address2: { maxlength: 30, pobox: true },
								//company : {maxlength: 40, companyrequiredcheck: true},
								company: { required: isCompanyRequired(), maxlength: 40, companyNameValidation: true },
								postal: { required: true, countryspecificpostalcodePassCountrySelectorModal: true },
								city: { required: true, validateCity: true },
								state: { required: true, notEqual: "NO_STATE_TYPE_SELECTED", hasvalidationerror: true, validateAdditionalTerritories: type },
								phone: { required: true, phone: true },
								email: { required: true, email: true, maxlength: 254 },
								deliveryInstructions: { required: false },
								contactName: "required",
								contactPhone: "phone",
								ext1: "digits"
							},
							messages: {
								firstModal: { required: messages.ERR_INVALID_FIRSTNAME, firstNameValidation: messages.ERR_INVALID_FNAME },
								lastModal: { required: messages.ERR_INVALID_LASTNAME, lastNameValidation: messages.ERR_INVALID_LNAME },
								country: messages.ERR_INVALID_COUNTRY,
								address1: { required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE, pobox: messages.ERR_INVALID_POBOX },
								address2: { maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH, pobox: messages.ERR_INVALID_POBOX },
								company: { maxlength: messages.ERR_INVALID_COMPANY_NAME_LENGTH, required: messages.ERR_COMPANY_REQUIRED, companyrequiredcheck: messages.ERR_INVALID_COMPANY, companyNameValidation: messages.ERR_INVALID_COMPANY },
								postal: messages.ERR_ENTER_ZIPCODE,
								city: { required: messages.ERR_INVALID_CITY, validateCity: messages.ERR_INVALID_CITY_NAME },
								state: messages.ERR_INVALID_STATE,
								phone: { required: messages.ERR_INVALID_PHONE1, phone: messages.ERR_INVALID_PHONE1 },
								email: { required: messages.ERR_REQUIRED_EMAIL_MY, email: messages.ERR_INVALID_EMAIL, maxlength: messages.ERR_INVALID_EMAIL },
								contactName: messages.ERR_INVALID_CONTACT_NAME,
								contactPhone: messages.ERR_INVALID_PHONE1,
								ext1: messages.ERR_INVALID_EXTN_NUMBER
							},
							invalidHandler: COSTCO.util.invalid_handler,
							highlight: COSTCO.util.highlightWithErrorLabel,
							unhighlight: COSTCO.util.unhighlightWithErrorLabel,
							errorPlacement: function errorPlacement(error, element) {
								if (element.attr("name") == "state") {
									element.parent().addClass('error');
									error.insertAfter($('[name=state]').parent());
								} else if (element.attr("name") == "country") {
									element.parent().addClass('error');
									error.insertAfter($('[name=country]').parent());
								} else {
									error.insertAfter(element);
								}
							}
						}).form();
					} else {
						// validation rules and messages for edit default shipping address
						form.validate({
							rules: {
								firstModal: { required: getFirstLastNameRule(), firstNameValidation: true },
								lastModal: { required: getFirstLastNameRule(), lastNameValidation: true },
								country: "required",
								address1: { required: true, maxlength: getAddressLine1MaxCharLength, pobox: true },
								address2: { maxlength: 30, pobox: true },
								//company : {maxlength: 40, companyrequiredcheck: true},
								company: { required: isCompanyRequired(), maxlength: 40, companyNameValidation: true },
								postal: { required: true, countryspecificpostalcodePassCountrySelectorModal: true },
								city: { required: true, validateCity: true },
								state: { required: true, notEqual: "NO_STATE_TYPE_SELECTED", hasvalidationerror: true, validateAdditionalTerritories: type },
								phone: { required: true, phone: true },
								email: { required: true, email: true, maxlength: 254 },
								deliveryInstructions: { required: false },
								contactName: "required",
								contactPhone: "phone",
								ext1: "digits"
							},
							messages: {
								firstModal: { required: messages.ERR_INVALID_FIRSTNAME, firstNameValidation: messages.ERR_INVALID_FNAME },
								lastModal: { required: messages.ERR_INVALID_LASTNAME, lastNameValidation: messages.ERR_INVALID_LNAME },
								country: messages.ERR_INVALID_COUNTRY,
								address1: { required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE, pobox: messages.ERR_INVALID_POBOX },
								address2: { maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH, pobox: messages.ERR_INVALID_POBOX },
								company: { maxlength: messages.ERR_INVALID_COMPANY_NAME_LENGTH, required: messages.ERR_INVALID_COMPANY, companyrequiredcheck: messages.ERR_INVALID_COMPANY, companyNameValidation: messages.ERR_INVALID_COMPANY },
								postal: messages.ERR_ENTER_ZIPCODE,
								city: { required: messages.ERR_INVALID_CITY, validateCity: messages.ERR_INVALID_CITY_NAME },
								state: messages.ERR_INVALID_STATE,
								phone: { required: messages.ERR_INVALID_PHONE2, phone: messages.ERR_INVALID_PHONE2 },
								email: { required: messages.ERR_EMAIL_ADDRESS_REQUIRED, email: messages.ERR_INVALID_EMAIL, maxlength: messages.ERR_INVALID_EMAIL },
								contactName: messages.ERR_INVALID_CONTACT_NAME,
								contactPhone: messages.ERR_INVALID_PHONE1,
								ext1: messages.ERR_INVALID_EXTN_NUMBER
							},
							invalidHandler: COSTCO.util.invalid_handler,
							highlight: COSTCO.util.highlightWithErrorLabel,
							unhighlight: COSTCO.util.unhighlightWithErrorLabel,
							errorPlacement: function errorPlacement(error, element) {
								if (element.attr("name") == "state") {
									element.parent().addClass('error');
									error.insertAfter($('[name=state]').parent());
								} else if (element.attr("name") == "country") {
									element.parent().addClass('error');
									error.insertAfter($('[name=country]').parent());
								} else {
									error.insertAfter(element);
								}
							}
						}).form();
					}
	
					var selectsValid = true;
	
					form.find('.style-select > select').each(function () {
						$(this).unbind('change').change(function () {
							if ($(this).val() === "NO_STATE_TYPE_SELECTED") {
								selectsValid = false;
								$(this).parent().addClass('error');
							} else {
								$(this).parent().removeClass('error');
								if ($(this).attr('hasvalidationerror') != undefined && $(this).attr('hasvalidationerror') != null) {
									$(this).attr('hasvalidationerror', false);
								}
							}
						});
					});
	
					form.find('.style-select > select').change();
	
					return form.valid() && selectsValid;
				}
			},
	
			/*
	   * Build Address Array from a query selector
	   */
			buildAddressArray: function buildAddressArray(type) {
				var addressObject = {};
				var addressArray = [];
				var _baseAddr = COSTCO.CAddressForm.getForm();
				var addressPrefix = '';
	
				if (_baseAddr.length > 0 && _baseAddr[0].id == 'quick-renew-address-form') {
					if (type == "S" || type == 'S') addressPrefix = 'shipping_';else addressPrefix = 'billing_';
				}
	
				addressObject['id'] = _baseAddr.find('[name=' + addressPrefix + 'addressId]').val();
				addressObject['fName'] = _baseAddr.find('[name=' + addressPrefix + 'firstModal]').val();
				addressObject['lName'] = _baseAddr.find('[name=' + addressPrefix + 'lastModal]').val();
				addressObject['company'] = _baseAddr.find('[name=' + addressPrefix + 'company]').val();
				addressObject['country'] = _baseAddr.find('[name=' + addressPrefix + 'country]').val();
				addressObject['line1'] = _baseAddr.find('[name=' + addressPrefix + 'address1]').val();
				addressObject['line2'] = _baseAddr.find('[name=' + addressPrefix + 'address2]').val();
				addressObject['zip'] = _baseAddr.find('[name=' + addressPrefix + 'postal]').val();
				addressObject['city'] = _baseAddr.find('[name=' + addressPrefix + 'city]').val();
				addressObject['state'] = _baseAddr.find('[name=' + addressPrefix + 'state]').val();
				addressObject['pNumber'] = _baseAddr.find('[name=' + addressPrefix + 'phone]').unmask().val();
				addressObject['ext1'] = _baseAddr.find('[name=' + addressPrefix + 'ext1]').val();
				addressObject['nickname'] = _baseAddr.find('[name=' + addressPrefix + 'nickname]').val();
				addressObject['email'] = _baseAddr.find('[name=' + addressPrefix + 'email]').val();
				addressObject['mInitial'] = _baseAddr.find('[name=mInitial]').val();
				addressObject['saveAddress'] = address.getSaveAddress(addressObject['id'], _baseAddr.find('[name=' + addressPrefix + 'save-address]:checked').length > 0);
				addressObject['setDefault'] = address.getDefaultAddress(addressObject['id'], _baseAddr.find('[name=' + addressPrefix + 'set-default]:checked').length > 0);
				addressObject['addressType'] = address.getAddressType(addressObject['id'], type);
				addressObject['addressType2'] = address.getAddressType(addressObject['id'], type);
				addressObject['deliveryInst'] = _baseAddr.find('[name=' + addressPrefix + 'deliveryInstructions]').val();
				addressObject['contactName'] = _baseAddr.find('[name=' + addressPrefix + 'contactName]').val();
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
					addressObject['contactPhNo'] = _baseAddr.find('[name=' + addressPrefix + 'contactPhone]').length > 0 ? _baseAddr.find('[name=' + addressPrefix + 'contactPhone]').cleanVal() : _baseAddr.find('[name=' + addressPrefix + 'contactPhone]').val();
				} else {
					addressObject['contactPhNo'] = _baseAddr.find('[name=' + addressPrefix + 'contactPhone]').val();
				}
				addressObject['smsPhone'] = $('#receiveSMS').is(':checked') ? _baseAddr.find('#' + addressPrefix + 'smsPhoneId').cleanVal() : "";
	
				if (addressObject.addressType == '') {
					addressObject.addressType = type;
				}
	
				addressArray.push(addressObject);
				return addressArray;
			},
	
			populateCityState: function populateCityState(form, city, state, cityQuery, stateQuery) {
	
				var form = $(form);
	
				var cityQueryNameValue = cityQuery.match(/\[name=(.*?)\]/)[1];
				var cityFieldType = COSTCO.CAddressForm.getCityFieldType(form, cityQueryNameValue);
				if (form.find('select' + cityQuery).length) {
					COSTCO.CAddressForm.setCorrectCityField(form, cityQueryNameValue, cityFieldType);
				}
	
				form.find(cityQuery).val(city);
				form.find(stateQuery).val(state);
				form.find(cityQuery).focusout().change();
				form.find(stateQuery).focusout().change();
				//STRY0148134 checkout redesign - show city state inputs
				form.find('#' + cityFieldType + 'city-state').removeClass('hide');
			},
	
			matchCityOption: function matchCityOption(citySelect, editAddrCity) {
	
				var options = citySelect.find('option');
				var matchingValue = null;
				var normalizedEditAddrCity = editAddrCity.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
	
				options.each(function () {
					var optionValue = $(this).val();
					var normalizedOptionValue = optionValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
					if (normalizedOptionValue == normalizedEditAddrCity) {
						matchingValue = optionValue;
						return false;
					}
				});
	
				return matchingValue;
			},
	
			/* ALM52674 - This method is used for the modal to display the correct city field type
	   * depending on the geo location service response - if the service is down, 
	   * a text input field is used, while if the service call is successful, a 
	   * select field with valid city options for the given zip/postal code is displayed
	  */
			setCorrectCityField: function setCorrectCityField(form, cityQueryNameValue, cityFieldType) {
	
				var alternativeCityQueryNameValue = cityFieldType + 'city2';
	
				//correctCityField is the city field that should be displayed, instead of the incorrectCityField
				var correctCityField = '[name=' + alternativeCityQueryNameValue + ']';
				var incorrectCityField = '[name=' + cityQueryNameValue + ']';
	
				/*whatever city field is displayed, it should have the idForCurrentCityField and nameForCurrentCityField
	   values as the 'id', and 'name' attribute values, while the alternative field (not displayed) should have
	   idForAltCityField and nameForAltCityField as 'id' and 'name'*/
	
				var idForCurrentCityField = form.find('[name=' + cityQueryNameValue + ']').attr('id');
				var idForAltCityField = form.find('[name=' + alternativeCityQueryNameValue + ']').attr('id');
	
				var nameForCurrentCityField = cityQueryNameValue;
				var nameForAltCityField = alternativeCityQueryNameValue;
	
				var parentDivId = cityFieldType + 'city-state';
	
				var incorrParentDiv = form.find(incorrectCityField).parent();
				while (incorrParentDiv.attr('id') !== parentDivId) {
					incorrParentDiv.addClass('hide');
					incorrParentDiv = incorrParentDiv.parent();
				}
				form.find(incorrectCityField).removeAttr('id required aria-required');
	
				var corrParentDiv = form.find(correctCityField).parent();
				while (corrParentDiv.attr('id') !== parentDivId) {
					corrParentDiv.removeClass('hide');
					corrParentDiv = corrParentDiv.parent();
				}
				form.find(correctCityField).attr('id', idForCurrentCityField);
				form.find('#' + idForCurrentCityField).removeAttr('name required aria-required');
				form.find('#' + idForCurrentCityField).attr({
					'required': 'true',
					'aria-required': 'true'
				});
	
				form.find(incorrectCityField).attr('id', idForAltCityField);
				form.find('#' + idForAltCityField).attr('name', nameForAltCityField);
	
				form.find('#' + idForCurrentCityField).attr('name', nameForCurrentCityField);
	
				CAddressForm.moveMissplacedElements(form, idForAltCityField, idForCurrentCityField);
			},
	
			moveMissplacedElements: function moveMissplacedElements(form, idForAltCityField, idForCurrentCityField) {
				var altParentDiv = form.find('#' + idForAltCityField).parent();
				var currElements = altParentDiv.find('[for=' + idForCurrentCityField + ']');
				if (currElements.length) {
					form.find('#' + idForCurrentCityField).parent().append(currElements);
				}
				return currElements;
			},
	
			/* SFSTRY0028209 - The address modal City and State fields will be displayed/populated
	   *  based on the geo location service response 
	  */
			populateCityStateForZipPostalCode: function populateCityStateForZipPostalCode(form, cityList, stateList, cityQuery, stateQuery, editAddrCity, editAddrState) {
	
				var form = $(form);
	
				var editAddrCityOptionMatch = undefined;
				var cityQueryNameValue = cityQuery.match(/\[name=(.*?)\]/)[1];
				var cityFieldType = COSTCO.CAddressForm.getCityFieldType(form, cityQueryNameValue);
	
				if (cityList.length && stateList.length) {
	
					if (form.find(cityQuery).attr('type') == "text") {
						COSTCO.CAddressForm.setCorrectCityField(form, cityQueryNameValue, cityFieldType);
					}
					var cityOptions = CAddressForm.getCityDropDown(cityList);
	
					var stateOptions = CAddressForm.getStateProvDropDown(stateList);
					form.find(cityQuery).empty().append(cityOptions);
					form.find(stateQuery).empty().append(stateOptions);
	
					if (editAddrCity != undefined) {
						editAddrCityOptionMatch = COSTCO.CAddressForm.matchCityOption(form.find(cityQuery), editAddrCity);
					}
				} else {
					var stateProvList = address.getStateProvJson();
					var stateOptions = CAddressForm.getStateOptions(stateProvList);
					form.find(stateQuery).empty().append(stateOptions);
					form.find(cityQuery).empty();
					var alternativeCityQuery = '[name=' + cityFieldType + 'city2]';
					if (form.find(alternativeCityQuery).length > 0 && form.find(alternativeCityQuery).attr('type') == "text") {
						COSTCO.CAddressForm.setCorrectCityField(form, cityQueryNameValue, cityFieldType);
					} else {
						form.find(cityQuery).val('');
					}
				}
	
				if (editAddrState != undefined && editAddrCity != undefined) {
					var editAddrSavedCity = editAddrCityOptionMatch ? editAddrCityOptionMatch : editAddrCity;
					form.find(cityQuery).val(editAddrSavedCity);
					form.find(stateQuery).val(editAddrState);
				}
	
				form.find(cityQuery).focusout().change();
				form.find(stateQuery).focusout().change();
				//STRY0148134 checkout redesing - show city state inputs
				//form.find('#city-state').removeClass('hide');
	
				form.find('#' + cityFieldType + 'city-state').removeClass('hide');
			},
	
			/**
	   * Gets the City field form type 
	   */
			getCityFieldType: function getCityFieldType(form, cityQueryNameValue) {
				var fieldType = '';
				if (cityQueryNameValue.indexOf('business') !== -1) {
					fieldType = 'business_';
				} else if (cityQueryNameValue.indexOf('shipping') !== -1) {
					fieldType = 'shipping_';
				} else if (cityQueryNameValue.indexOf('billing') !== -1) {
					fieldType = 'billing_';
				} else if (cityQueryNameValue.indexOf('affiliate') !== -1 || form.attr('id').indexOf('affiliate') !== -1) {
					fieldType = 'affiliate_';
				}
	
				return fieldType;
			},
	
			/**
	   * Gets shipping address id from html address display block
	   */
			getShippingId: function getShippingId() {
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true && !COSTCO.MembershipHelper.isQuickMembership) {
					return $('#shipping .address-display').data('addressid');
				} else {
					return $('.address-display').data('addressid');
				}
			},
	
			/**
	   * Gets billing address id from html address display block
	   */
			getBillingId: function getBillingId() {
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true && !COSTCO.MembershipHelper.isQuickMembership) {
					return $('#billing .address-display').data('addressid');
				} else {
					return $('.address-display').data('addressid');
				}
			},
	
			/**
	   * Checks if address form has been completed. For give address type if address block with address id is found on page,
	   * it is considered that address form is completed.
	   */
			isFormCompleted: function isFormCompleted(type) {
				if (type === 'S') {
					return this.getShippingId() != null;
				} else {
					return this.getBillingId() != null;
				}
			},
			initiatePopovers: function initiatePopovers() {
				var helper = "#deliveryInstructionsPopover";
	
				var popOverSettings = {
					trigger: 'focus',
					placement: 'top',
					html: true,
					selector: helper,
					content: function content() {
						return $(helper).data().popupcontent;
					}
				};
				$('body').popover(popOverSettings);
			},
			showBusinessDeliveryQuestionnaireModal: function showBusinessDeliveryQuestionnaireModal(type, data, action, addressOptions) {
				address.baseModal(type, 'bdquestionnaire', {
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: COSTCO.util.tmpl('tmpl_bd_questionnaire_modal'),
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						if (action == 'edit') {
							CAddressForm.openAddressAddModal(type, data, 'edit', addressOptions);
						} else {
							CAddressForm.openAddressAddModal(type, data, 'add', addressOptions);
						}
					}
				});
			},
			showBusinessDeliveryQuestionnaireModal_v2: function showBusinessDeliveryQuestionnaireModal_v2(type, data, action, addressOptions) {
				address.baseModal(type, 'bdquestionnaire', {
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: COSTCO.util.tmpl('tmpl_bd_questionnaire_modal'),
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						if (action == 'edit') {
							CAddressForm.openAddressAddModal_v2(type, data, 'edit', addressOptions);
						} else {
							CAddressForm.openAddressAddModal_v2(type, data, 'add', addressOptions);
						}
					}
				});
			},
			showBDQuestionnaireModalForInlineForm: function showBDQuestionnaireModalForInlineForm(type, preventHtmlReload, addressOptions, addressArray) {
				COSTCO.dialog.createExtDialogBox({
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: COSTCO.util.tmpl('tmpl_bd_questionnaire_modal'),
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						CAddressForm.agreeFromBDQuestionnaireModal(type, preventHtmlReload, addressOptions, addressArray);
					}
				});
			},
			agreeFromBDQuestionnaireModal: function agreeFromBDQuestionnaireModal(type, preventHtmlReload, addressOptions, addressArray) {
				addressOptions.successCallback = CAddressForm.addressVerifiedCallback;
				addressVerification.addressVerification(addressArray, type, preventHtmlReload, addressOptions);
			},
			//hides the link, shows input field
			showInputFiled: function showInputFiled(input) {
				var selectedElementParent = $(input).parent();
				selectedElementParent.siblings().removeClass('hide');
				selectedElementParent.siblings().find('input').focus();
				selectedElementParent.siblings().find('input').select();
				//timout set so that NVDA can focus the input field
				setTimeout(function () {
					selectedElementParent.addClass('hide');
				}, 120);
			},
	
			hideInputFiled: function hideInputFiled(input) {
				$(input).parent().siblings().addClass('hide');
				$(input).parent().removeClass('hide');
			},
	
			/**
	   * This function is used to trigger character counting functionality
	   */
			countTextareaCharacters: function countTextareaCharacters(element) {
				var additionalParam = $(element).data('param-type') !== undefined ? $(element).data('param-type') : null;
				$('body').trigger('count.delivery.inst.characters', additionalParam);
			},
	
			/**
	   * This function finds the textArea and character label and calls the character counting functionality
	   * @param {the expand element for the delivery instructions area} expandLink 
	   */
			countTextareaCharactersAddressBook: function countTextareaCharactersAddressBook(expandLink) {
				var textArea = $(expandLink).parent().siblings().find('textarea');
				var countLabel = textArea.siblings().find('#delivery-message-count');
				COSTCO.util.character_count(countLabel, textArea);
			},
	
			/**
	  * This function is used to open edit block for Delivery Information
	  */
			showDeliveryInstructionsBlock: function showDeliveryInstructionsBlock(paramType) {
				$('#delivery-instructions-text').addClass('hide');
				$('#edit-delivery-instructions-text').removeClass('hide');
				var textAreaId = 'deliveryInstructions' + (paramType ? '-' + paramType : '');
				var textArea = $('#edit-delivery-instructions-text textarea[id=' + textAreaId + ']');
				textArea.attr('tabindex', 0);
				textArea.focus();
				textArea.select();
			},
			/**
	  * This function is used to open edit block for Contact Information
	  */
			showContactInformationBlock: function showContactInformationBlock() {
				$('#contact-information-text').addClass('hide');
				$('#edit-contact-information-text').removeClass('hide');
				if ($('input[id=contactPhNo-inline]').val() !== "") {
					$('label[for=contactPhNo-inline]').addClass('active');
				}
				if ($('input[id=contactName-inline]').val() !== "") {
					$('label[for=contactName-inline]').addClass('active');
				}
				$('#contactPhNo-inline').unmask().mask('000-000-0000');
			},
			/**
	  * This function is used for updating different contact information for specific addressId
	  * depending on xAddressInfoType (delivery instructions, contact name, contact phone etc.)
	  */
			updateXAddressInformation: function updateXAddressInformation(inputElement, addressId) {
				var xAddressInfoType = $(inputElement).data('xaddress-info-type');
				var inputValue = $(inputElement).val();
				var preventHtmlResponse = false;
				var nextElement = event.relatedTarget;
				if (nextElement !== null) {
					if (nextElement.name === "contactPhone" || nextElement.name === "contactName") {
						preventHtmlResponse = true;
					}
				}
				var data = [{
					name: "addressId",
					value: addressId || ""
				}, {
					name: "xAddressInfoType",
					value: xAddressInfoType || ""
				}, {
					name: "inputValue",
					value: inputValue || ""
				}, {
					name: "preventHtmlResponse",
					value: preventHtmlResponse
				}];
	
				COSTCO.AjaxModular.ajax_update_state({
					url: 'AjaxXAddressUpdateCmd',
					method: 'POST',
					dataType: 'json',
					data: data,
					scrollToError: false,
					done: function done(data, textStatus, jqXHR, options) {
						COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
						for (var i = 0; i < COSTCO.util.addresses.length; i++) {
							if (COSTCO.util.addresses[i] !== undefined && COSTCO.util.addresses[i]["addressType"] === 'S') {
								COSTCO.util.addresses[i][xAddressInfoType] = inputValue;
							}
						}
					},
					always: function always() {
						if (COSTCO.CreditCard !== undefined) {
							COSTCO.CreditCard.initComplete = false;
						}
						if (COSTCO.util.isBusinessDelivery()) {
							COSTCO.Header.miniShopCartRefresh();
							COSTCO.preauthchargesmodal.init();
						}
					}
				});
			},
			validateContactInformation: function validateContactInformation() {
				if ($.validator.methods.contactInformationPhone === undefined) {
					$.validator.addMethod("contactInformationPhone", function (value, element) {
						if (value.startsWith("0") || value.startsWith("1")) {
							return false;
						}
						return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
					}, messages.ERR_INVALID_PHONE1);
				}
				var form = $('#contact-information-form');
				form.validate({
					rules: {
						contactName: { required: true, maxlength: 40 },
						contactPhone: { contactInformationPhone: true }
					},
					messages: {
						contactName: messages.ERR_INVALID_CONTACT_NAME,
						contactPhone: messages.ERR_INVALID_PHONE1
					},
					invalidHandler: COSTCO.util.invalid_handler,
					highlight: COSTCO.util.highlightWithErrorLabel,
					unhighlight: COSTCO.util.unhighlightWithErrorLabel,
					errorPlacement: function errorPlacement(error, element) {
						error.insertAfter(element);
					}
				});
	
				return form.valid();
			},
			updateContactInformation: function updateContactInformation(inputElement, addressId) {
				if (COSTCO.CAddressForm.validateContactInformation()) {
					CAddressForm.updateXAddressInformation(inputElement, addressId);
				}
			},
	
			toggleSmsBlock: function toggleSmsBlock() {
				if ($('#receiveSMS').is(':checked')) {
					$('.smsPhoneBlock').removeClass('hidden');
				} else {
					$('.smsPhoneBlock').addClass('hidden');
				}
			},
			/*
	   * QuestionnaireModal for BD National Delivery version 2
	   */
			showNationalDeliveryQuestionnaireModal: function showNationalDeliveryQuestionnaireModal(verifiedAddress, preventhtmlajax, addressOptions, message, userSelection) {
				var deliveryMethod;
				if ($('input[name="deliveryMethod"]').length > 0) {
					deliveryMethod = $("input[name='deliveryMethod']:checked").val();
				} else if ($('#shipmodeId').length > 0) {
					deliveryMethod = parseFloat($('#shipmodeId').val());
				}
				var delObj = {
					espotContent: deliveryMethod
				};
				var template = COSTCO.util.tmpl('tmpl_bd_questionnaire_modal', delObj);
				address.baseModal('S', 'bdquestionnaire', {
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: template,
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						verifiedAddress.userAddressType = userSelection;
						address.addEditAddress(verifiedAddress, preventhtmlajax, addressOptions, message);
					}
				});
			},
			/*
	   * QuestionnaireModal for BD National Delivery
	   */
			showNationalDeliveryQuestionnaireModal_v2: function showNationalDeliveryQuestionnaireModal_v2(form, data, params, verifiedAddress) {
				var deliveryMethod;
				if ($('input[name="deliveryMethod"]').length > 0) {
					deliveryMethod = $("input[name='deliveryMethod']:checked").val();
				} else if ($('#shipmodeId').length > 0) {
					deliveryMethod = parseFloat($('#shipmodeId').val());
				}
				var delObj = {
					espotContent: deliveryMethod
				};
				var template = COSTCO.util.tmpl('tmpl_bd_questionnaire_modal', delObj);
				address.baseModal('S', 'bdquestionnaire', {
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: template,
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						if (typeof checkoutPage !== 'undefined') {
							if (checkoutPage == 'review' || checkoutPage == 'shipping') {
								isCheckoutFlow = true;
							}
						}
						if (isCheckoutFlow && !verifiedAddress) {
							COSTCO.zipCodeModal.buttonClickChange(data.SetDeliveryZip, form, params, data);
						} else if (isCheckoutFlow && !data.WarehouseChange && data.StatusMessage == data.ZipStatusMessageList[7]) {
							COSTCO.zipCodeModal.buttonClickChange(data.SetDeliveryZip, form, params, data, verifiedAddress);
						} else {
							COSTCO.zipCodeModal.changeZip_buttonClickChange(data, params, form, verifiedAddress);
						}
					}
				});
			},
			/**
	   * Reads 'Form End' when focus gets out of form
	   * @param formElement - form
	   */
			makeFormAdaCompatible: function makeFormAdaCompatible(formElement) {
				if (formElement == undefined) {
					return false;
				}
				//Adds event on all focusable elements of form
				formElement.find('a, input, select').each(function () {
					$(this).blur(function () {
						setTimeout(function () {
							//timeout is needed to wait for setting focus on next element
							if (!$.contains(formElement.get(0), document.activeElement)) {
								COSTCO.util.announceSRMessage(messages.FORM_END);
							}
						}, 30);
					});
				});
			},
	
			//Adds analytics for save/cancel/remove address buttons on the address form. 
			updateAddressModal: function updateAddressModal() {
				var modalTitle = document.getElementById('costcoModalTitle');
				var modalBtn1 = document.getElementById('costcoModalBtn1');
				var modalBtn2 = document.getElementById('costcoModalBtn2');
	
				if (typeof modalTitle != 'undefined' && modalTitle != null) {
					var text = modalTitle.innerText;
				}
	
				if (typeof modalBtn1 != 'undefined' && modalBtn1 != null) {
					$('#costcoModalBtn1').attr("data-bi-tc", "ui:My Account | Address Book | Cancel Address");
				}
				if (typeof modalBtn2 != 'undefined' && modalBtn2 != null) {
	
					if (text.toLocaleLowerCase() === 'edit shipping address' || text.toLocaleLowerCase() === 'add new address') {
						$('#costcoModalBtn2').attr("data-bi-tc", "ui:My Account | Address Book | Save Address");
					}
	
					if (text.toLocaleLowerCase() === 'remove address') {
						$('#costcoModalBtn2').attr("data-bi-tc", "ui:My Account | Address Book | Remove Address");
					}
				}
			}
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
		window.COSTCO.CAddressForm = CAddressForm;
		return CAddressForm;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title address.js: Feature level module
	 * @description Module associated with address handling
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (preauthchargesmodal) {
	  var CAddress = {
	    stateprov: '',
	    addressTools: {
	      applyAddressToOrder: "false",
	      applyAddressToOrderItems: "false",
	      addressType: '',
	      cachedAddressId: '',
	      errorContainer: ''
	    },
	    urlDelete: 'AjaxAddressAddCmd?mode=DELETE&addressId=',
	    form: '',
	    initialize: function initialize(isReloaded) {
	      COSTCO.util.getInitialAddressBatch();
	    },
	    // Hierarchy Setup for Modals -> Mode -> Type
	    getHeaderLabels: function getHeaderLabels(type, mode) {
	      var typeLabel, modeLabel;
	      if (typeof mode !== 'undefined') {
	        modeLabel = addressLabels[mode];
	      }
	      if (typeof type !== 'undefined') {
	        if (type.trim() == 'S') {
	          typeLabel = $.extend({}, addressLabels.shipping);
	          if (typeof modeLabel.shipping !== 'undefined') {
	            typeLabel = $.extend(typeLabel, modeLabel.shipping);
	          }
	        } else {
	          typeLabel = $.extend({}, addressLabels.billing);
	          if (typeof modeLabel.billing !== 'undefined') {
	            typeLabel = $.extend(typeLabel, modeLabel.billing);
	          }
	        }
	      }
	      //added empty object as the first argument so that addressHeaderLabels stays in its original state
	      return $.extend({}, addressHeaderLabels, modeLabel, typeLabel);
	    },
	    previousOptions: [],
	    previousMode: [],
	    previousType: [],
	    pushModal: function pushModal(type, mode, options) {
	      COSTCO.CAddress.previousOptions.push(options);
	      COSTCO.CAddress.previousMode.push(mode);
	      COSTCO.CAddress.previousType.push(type);
	    },
	    resetQueue: function resetQueue() {
	      COSTCO.CAddress.previousOptions = [];
	      COSTCO.CAddress.previousMode = [];
	      COSTCO.CAddress.previousType = [];
	    },
	    closeModal: function closeModal() {
	      COSTCO.CAddress.resetQueue();
	      COSTCO.dialog.closeAndUnbind();
	    },
	    baseModal: function baseModal(type, mode, options, poppin) {
	      if (COSTCO.CAddress.previousOptions.length > 0 && typeof options.secondary_event === 'undefined') {
	        var s_options = COSTCO.CAddress.previousOptions.pop();
	        var s_mode = COSTCO.CAddress.previousMode.pop();
	        var s_type = COSTCO.CAddress.previousType.pop();
	        options.secondary_event = options.close = options.afterclose = function () {
	          COSTCO.CAddress.baseModal(s_type, s_mode, s_options, true);
	        };
	      }
	      var labels = CAddress.getHeaderLabels(type, mode);
	      var addressOptions = {
	        title: labels.modalTitle,
	        primary: labels.primaryButton,
	        secondary: messages.JS_DIALOG_CANCEL,
	        secondary_event: function secondary_event() {
	          COSTCO.CAddress.closeModal();
	        },
	        close: function close() {
	          $('.order-ajax').removeClass('ajax-busy');
	          COSTCO.CAddress.closeModal();
	        },
	        afterclose: function afterclose(e) {
	          COSTCO.CAddress.closeModal();
	        }
	      };
	      options = $.extend(addressOptions, options);
	      if (typeof poppin === 'undefined') {
	        COSTCO.CAddress.pushModal(type, mode, options);
	      } else {
	        COSTCO.CAddress.resetQueue();
	        COSTCO.CAddress.pushModal(type, mode, options);
	      }
	
	      COSTCO.dialog.showAndHideModal(options);
	    },
	    urlAddUpdate: function urlAddUpdate(addressOptions) {
	      if (typeof $('#calendarServiceResponse').val() !== 'undefined') {
	        document.getElementById("calendarServiceResponse").value = "";
	      }
	
	      var url = '';
	      if (typeof addressOptions === 'undefined') {
	        url = '/AjaxAddressAddCmd';
	      } else {
	        url = addressOptions.url ? addressOptions.url : '/AjaxAddressAddCmd';
	      }
	      var orderItemId = '';
	      var multiAddress = '';
	      var addressIdsToUpdate = [];
	
	      if (typeof checkoutPage !== 'undefined' && typeof addressOptions !== 'undefined') {
	        if (!COSTCO.util.isBusinessDelivery()) {
	          orderItemId = addressOptions.orderItemId;
	        }
	        if (checkoutPage === 'multi-shipping') {
	          multiAddress = 'true';
	          var cartCount = $.cookie('cartCountCookie');
	          for (i = 0; i < cartCount; i++) {
	            addressIdsToUpdate[i] = $('#addressId_' + (i + 1)).val();
	          }
	          var addressIdsToUpdateString = encodeURIComponent(JSON.stringify(addressIdsToUpdate));
	        } else if (checkoutPage === 'shipping') {
	          multiAddress = 'false';
	        }
	      }
	
	      var queryObject = {
	        addressType: CAddress.addressTools.addressType,
	        applyAddressToOrder: CAddress.addressTools.applyAddressToOrder,
	        applyAddressToOrderItems: CAddress.addressTools.applyAddressToOrderItems,
	        orderItemId: orderItemId,
	        multiAddress: multiAddress,
	        modular: 'true',
	        requesttype: 'ajax',
	        addressIdsToUpdate: addressIdsToUpdateString
	      };
	
	      return COSTCO.util.makeUrl(url, queryObject);
	    },
	
	    urlAdd: function urlAdd(addressOptions) {
	      if (typeof $('#calendarServiceResponse').val() !== 'undefined') {
	        document.getElementById("calendarServiceResponse").value = "";
	      }
	      var url = '';
	      if (typeof addressOptions === 'undefined') {
	        url = '/AjaxAddressAddCmd';
	      } else {
	        url = addressOptions.url ? addressOptions.url : '/AjaxAddressAddCmd';
	      }
	      var orderItemId = '';
	      var multiAddress = '';
	      var addressIdsToUpdate = [];
	
	      if (typeof checkoutPage !== 'undefined' && typeof addressOptions !== 'undefined') {
	        if (!COSTCO.util.isBusinessDelivery()) {
	          orderItemId = addressOptions.orderItemId;
	        }
	        if (checkoutPage === 'multi-shipping') {
	          multiAddress = 'true';
	          var cartCount = $.cookie('cartCountCookie');
	          for (i = 0; i < cartCount; i++) {
	            addressIdsToUpdate[i] = $('#addressId_' + (i + 1)).val();
	          }
	          var addressIdsToUpdateString = encodeURIComponent(JSON.stringify(addressIdsToUpdate));
	          CAddress.addressTools.applyAddressToOrderItems = false;
	        } else if (checkoutPage === 'shipping') {
	          multiAddress = 'false';
	        }
	      }
	      var queryObject = {
	        addressType: CAddress.addressTools.addressType,
	        applyAddressToOrder: CAddress.addressTools.applyAddressToOrder,
	        applyAddressToOrderItems: CAddress.addressTools.applyAddressToOrderItems,
	        orderItemId: orderItemId,
	        multiAddress: multiAddress,
	        modular: 'true',
	        requesttype: 'ajax',
	        addressIdsToUpdate: addressIdsToUpdateString,
	        preventHtmlReload: costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && $((CAddress.addressTools.addressType === 'S' ? '#shipping' : '#billing') + ' #address-modal-inline').length > 0
	      };
	
	      return COSTCO.util.makeUrl(url, queryObject);
	    },
	    urlChoose: function urlChoose(orderItemId) {
	      return '/AjaxAddressAddCmd?mode=CHOOSE&addressType=' + CAddress.addressTools.addressType + '&applyAddressToOrder=' + CAddress.addressTools.applyAddressToOrder + '&applyAddressToOrderItems=' + CAddress.addressTools.applyAddressToOrderItems + '&orderItemId=' + orderItemId + '&modular=true&requesttype=ajax';
	    },
	    applyAddressToWhat: function applyAddressToWhat(type) {
	      // stateful change of addressTools url params
	      if (type === 'B') {
	        CAddress.addressTools.addressType = 'B';
	        CAddress.addressTools.applyAddressToOrder = 'true';
	        CAddress.addressTools.applyAddressToOrderItems = 'false';
	      } else if (type === 'S') {
	        CAddress.addressTools.addressType = 'S';
	        CAddress.addressTools.applyAddressToOrder = 'false';
	        CAddress.addressTools.applyAddressToOrderItems = 'true';
	      } else {
	        CAddress.addressTools.addressType = 'T';
	        CAddress.addressTools.applyAddressToOrder = 'false';
	        CAddress.addressTools.applyAddressToOrderItems = 'false';
	      }
	    },
	    chooseAddress: function chooseAddress(oldAddyId, newAddyId, orderItemId) {
	      var oldAddy = CAddress.getAddressElement(oldAddyId, '', true);
	      var newAddy = CAddress.getAddressElement(newAddyId, '', true);
	      var oldZipcode;
	      var orderHasEddItems = $('#orderHasEddItems').val();
	      if (newAddy.addressType === 'S' && undefined !== orderHasEddItems) {
	        if (orderHasEddItems === 'true') {
	          oldZipcode = $.cookie("invCheckPostalCode");
	          if (typeof sessionStorage !== "undefined" && null !== oldZipcode) {
	            sessionStorage.setItem('oldZipcode', oldZipcode);
	          }
	          $.cookie("invCheckPostalCode", newAddy.zip.toUpperCase());
	          $.cookie("invCheckStateCode", newAddy.state);
	          $.cookie("invCheckCity", newAddy.city);
	        }
	      }
	
	      //update WAREHOUSEDELIVERY_WHS cookie when changing shipping address
	      if (!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof oldZipcode !== 'undefined' && typeof newAddy.zip !== 'undefined') {
	        if (oldZipcode.toUpperCase() != newAddy.zip.toUpperCase()) {
	          CAddress.updateWarehouseCookie(newAddy.zip.toUpperCase());
	        }
	      }
	
	      if (!oldAddy) {
	        oldAddy = newAddy;
	      }
	      oldAddy['newAddressId'] = newAddy.id;
	      CAddress.applyAddressToWhat(oldAddy.addressType);
	      var labels = CAddress.getHeaderLabels(oldAddy['addressType'], 'choose');
	      var inputContainer = '#address_change_' + newAddyId;
	      if (orderItemId) {
	        inputContainer = '#address_change_' + newAddyId + '_' + orderItemId;
	      }
	
	      var callChooseAddress = function callChooseAddress() {
	
	        COSTCO.Checkout.ajax_update_state({
	          url: CAddress.urlChoose(orderItemId),
	          method: "POST",
	          dataType: 'json',
	          data: {
	            'authToken': COSTCO.Checkout.getAuthToken(),
	            'oldZipcode': oldZipcode,
	            formdata: encodeURIComponent(JSON.stringify(oldAddy))
	          },
	          replaceKey: {
	            original: 'address-block',
	            replace: labels.replaceKey
	          },
	          done: function done(data, textStatus, jqXHR, options) {
	            if (checkoutPage === 'review' && costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
	              COSTCO.CreditCard.initComplete = false;
	            }
	            COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	          },
	          ajax_update_post_done: function ajax_update_post_done() {
	            if (typeof checkoutPage != 'undefined') {
	              apiAlreadyCalled = undefined;
	              COSTCO.OrderItems.init();
	
	              if (checkoutPage == 'review') {
	                COSTCO.CreditCard.initComplete = false;
	                COSTCO.CreditCard.init();
	                if (COSTCO.util.isBusinessDelivery()) {
	                  COSTCO.Header.miniShopCartRefresh();
	                }
	              }
	            }
	            if (COSTCO.util.isBusinessDelivery() && newAddy.addressType == 'B') {
	              COSTCO.dialog.close();
	            }
	            $('body').trigger('costco.address.selected', newAddy);
	          },
	          ajax_handle_errors: function ajax_handle_errors(response_obj) {
	
	            var $errorContainer = $('#header-error-container');
	
	            var application = response_obj.error.application || [];
	            var exception = response_obj.error.exception || [];
	            var error_html = '';
	            if (exception.length > 0) {
	              error_html += '<p>An unexpected error has occured</p>';
	            }
	            application.forEach(function (error_message) {
	              error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
	            });
	
	            if (response_obj.error.redirect && error_html && error_html.indexOf(messages.ERR_INVALID_DUALCART_MSG) > -1) {
	              document.location.href = '/' + response_obj.error.redirect;
	              return;
	            }
	
	            var warning_data = response_obj.payload.data[0] || [];
	            var warning_status = warning_data["warning"] || [];
	            if (warning_status.length > 0) {
	              var warning_message = warning_data["message"];
	              error_html += '<p>' + warning_message + '</p>';
	            }
	
	            if (error_html == '' || error_html.length == 0) {
	              $('body').trigger('costco.ajax.content.update.sucess', response_obj);
	
	              if ($errorContainer.length > 0) {
	                $errorContainer.children().remove();
	                $errorContainer.removeClass('critical-notification');
	              }
	            } else {
	              if ($errorContainer.length > 0) {
	                $errorContainer.children().remove();
	                $errorContainer.addClass('critical-notification');
	                $errorContainer.append(error_html);
	              }
	
	              if (COSTCO.util.has_errors(response_obj)) {
	                $('body').trigger('costco.ajax.content.update.error', response_obj);
	              }
	            }
	          },
	          always: function always() {
	            COSTCO.Checkout.ajax_update_default_always(inputContainer);
	            COSTCO.preauthchargesmodal.init();
	          },
	          inputContainer: inputContainer,
	          scrollToError: false
	        });
	      };
	
	      if (newAddy.addressType === 'S' && (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) || checkoutPage != 'shipping' && checkoutPage != 'review')) {
	        var submitZipCodeForValidation = function submitZipCodeForValidation() {
	          var submitParams = [orderItemId];
	          var form = $('#formshipping');
	          var callBack = COSTCO.CAddress.addressValidateSuccessOnChooseAddress;
	          if (checkoutPage == 'review') {
	            form = $('#formreview');
	          }
	          form.find("input[name=zipCodeFormDeliveryZipCode]").val(newAddy.zip);
	          COSTCO.zipCodeModal.submitZipCodeForValidation(form, callBack, null, submitParams, oldAddy, newAddy);
	        };
	
	        var serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
	        serviceToUpdateCookies(newAddy.zip).then(function () {
	          if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof checkoutPage != 'undefined' && (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping')) {
	            submitZipCodeForValidation();
	          } else {
	            callChooseAddress();
	          }
	        }, function () {
	          //Allow the flow for CABD here, as we allow all codes if FSA is right, and delivery not segmented
	          if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isCABDStore() && typeof checkoutPage != 'undefined' && (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping')) {
	            submitZipCodeForValidation();
	          }
	        });
	      } else {
	        callChooseAddress();
	      }
	    },
	    addressSetZipSuccess: function addressSetZipSuccess(data, params, form, newAddy) {
	      if (data.errorMessage) {
	        $('#addressFormInlineButton').removeAttr('disabled');
	        COSTCO.CAddressForm.addressNotServicedModal(newAddy, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        });
	      } else {
	        //AJAX CALL to Merge Contract
	        $.ajax({
	          url: '/CheckoutCartView',
	          type: 'POST',
	          data: { skipCartRedirect: true
	          },
	          dataType: 'html',
	          success: function success(data, textStatus, xhr) {
	            if (typeof checkoutPage != 'undefined') {
	              COSTCO.OrderItems.order_prepare();
	
	              // USBD only: force re-init of COSTCO.CreditCard when changing to delivery address ZIP on Place Order
	              if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore() && checkoutPage == 'review' && typeof COSTCO.CreditCard !== 'undefined') {
	                COSTCO.CreditCard.initComplete = false;
	              }
	            } else {
	              window.location.reload();
	            }
	          },
	          error: function error(xhr, textStatus, errorThrown) {
	            if (typeof checkoutPage != 'undefined') {
	              COSTCO.OrderItems.order_prepare();
	            } else {
	              window.location.reload();
	            }
	          }
	        });
	      }
	    },
	    /**
	     * Choose new address.
	     * @return {void}
	     */
	    callChooseAddressNew: function callChooseAddressNew(orderItemId, oldAddy, newAddy, data) {
	      var labels = CAddress.getHeaderLabels(oldAddy['addressType'], 'choose');
	      var inputContainer = '#address_change_' + newAddy.id;
	      if (orderItemId) {
	        inputContainer = '#address_change_' + newAddy.id + '_' + orderItemId;
	      }
	
	      var options = {
	        url: CAddress.urlChoose(orderItemId),
	        method: "POST",
	        dataType: 'json',
	        data: {
	          'authToken': COSTCO.Checkout.getAuthToken(),
	          formdata: encodeURIComponent(JSON.stringify(oldAddy)),
	          userSelectionDeliveryMethod: data && data.userSelectionDeliveryMethod ? data.userSelectionDeliveryMethod : ''
	        },
	        replaceKey: {
	          original: 'address-block',
	          replace: labels.replaceKey
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
	            COSTCO.CreditCard.initComplete = false;
	          }
	          // BD only: Update WC_BD_LOC cookie if ZIP is also changed on address change
	          if (COSTCO.util.isBusinessDelivery() && options.changeZip) {
	            if ($('#isGeocodeService').val() != "true") {
	              COSTCO.util.callBingAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
	            } else {
	              COSTCO.util.callGeocodeApiAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
	            }
	          }
	          COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	        },
	        ajax_update_post_done: function ajax_update_post_done(data) {
	          /* Default function body, extracted so it can be combined with promises. */
	          function postDone(data) {
	            COSTCO.CAddress.closeModal();
	            COSTCO.CAddress.bindEvents();
	            COSTCO.OrderItems.init();
	
	            if (checkoutPage === 'review') {
	              COSTCO.CreditCard.initComplete = false;
	              COSTCO.CreditCard.init();
	              if (COSTCO.util.isBusinessDelivery()) {
	                COSTCO.Header.miniShopCartRefresh();
	              }
	            }
	            if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore() && $('#residential-address-notification').length) {
	              $('#residential-address-notification').remove();
	            }
	          }
	          if (typeof checkoutPage != 'undefined') {
	            // STRY0183851: BD only - in case of mismatch with Accertify.jspf cookie data, ajax-refresh Payment section
	            if (COSTCO.util.isBusinessDelivery() && checkoutPage != 'cart' && $('input#whs-cookie-accertify').length && COSTCO.util.getBDZipCookie().warehouseNumber != $('input#whs-cookie-accertify').val()) {
	              COSTCO.Checkout.ajaxRefreshAllCheckoutSections().then(function () {
	                postDone(data);
	              });
	            } else {
	              postDone(data);
	            }
	          }
	        },
	
	        always: function always() {
	          COSTCO.Checkout.ajax_update_default_always(inputContainer);
	          COSTCO.preauthchargesmodal.init();
	        },
	        inputContainer: inputContainer,
	        scrollToError: false,
	        changeZip: oldAddy.zip != newAddy.zip
	      };
	      COSTCO.Checkout.ajax_update_state(options);
	    },
	    addressValidateSuccessOnChooseAddress: function addressValidateSuccessOnChooseAddress(data, params, form, chosenAddress, oldAddy) {
	      $('#addressFormInlineButton').removeAttr('disabled');
	      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
	      var userDeliveryMethod = '';
	      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
	      //Set address type
	      if (COSTCO.util.isNdEnabled()) {
	        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
	        if (data.WarehouseChange && !data.ShowAddressTypePopup) {
	          userDeliveryMethod = 'Nationwide';
	        }
	        if (data.WarehouseChange && data.IsInBDTruckZoneOnly) {
	          userDeliveryMethod = 'Local';
	        }
	        if (data.WarehouseChange && data.IsStorePickupOnly) {
	          userDeliveryMethod = 'Store-Pick-Up';
	        }
	        data.userSelectionDeliveryMethod = userDeliveryMethod;
	      }
	      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
	        COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        }, "residentialNotServiced");
	      } else if (data.BargeOrderZip == true) {
	        if (oldAddy == null) {
	          COSTCO.CAddress.callAddressAddNew(params[2], params[3], chosenAddress, params[4]);
	        } else {
	          COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, chosenAddress);
	        }
	      } else if ((data != undefined && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data != undefined && data.WarehouseChange && userDeliveryMethod == 'Local') && isUserCurrentOrderItemsAvailable) {
	        COSTCO.CAddress.launchModalOnAddrChange(data, params, form, undefined, userDeliveryMethod, oldAddy, chosenAddress);
	      } else {
	        if (data.StatusMessage == data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
	          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	          COSTCO.CAddress.launchModalOnAddrChange(data, params, form, undefined, userDeliveryMethod, oldAddy, chosenAddress);
	        } else {
	          if (data.StatusMessage == data.ZipStatusMessageList[2] || data.StatusMessage == data.ZipStatusMessageList[0] || data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) {
	            if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data, userDeliveryMethod)) {
	              COSTCO.CAddress.launchModalOnAddrChange(data, params, form, undefined, userDeliveryMethod, oldAddy, chosenAddress);
	            } else {
	              if (oldAddy == null) {
	                COSTCO.CAddress.callAddressAddNew(params[2], params[3], chosenAddress, params[4], data);
	              } else {
	                COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, chosenAddress, data);
	              }
	            }
	          } else {
	            COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	              window.location.replace('http://' + $('#desktopHostName').val());
	            });
	          }
	        }
	      }
	    },
	    launchModalOnAddrChange: function launchModalOnAddrChange(data, params, form, verifiedAddress, userDeliveryMethod, oldAddy, newAddy) {
	
	      var fromZipCodeToDisplay = data.bdZipCookieOriginal;
	      if (fromZipCodeToDisplay == null || fromZipCodeToDisplay == "undefined" || fromZipCodeToDisplay == "") {
	        fromZipCodeToDisplay = data.CurrentDeliveryZip;
	      }
	
	      var popupMsg = "";
	      var isCheckoutFlow = false;
	      if (typeof checkoutPage !== 'undefined') {
	        if (checkoutPage == 'review' || checkoutPage == 'shipping') {
	          isCheckoutFlow = true;
	        }
	      }
	      if (!COSTCO.util.isNdEnabled()) {
	        // ND disabled flow
	        popupMsg = COSTCO.util.isUSBDStore() ? messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF_USBD : messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF;
	        popupMsg = popupMsg.replace(/\{0\}/g, fromZipCodeToDisplay);
	        popupMsg = popupMsg.replace(/\{1\}/g, data.SetDeliveryZip);
	      } else if (data.RegisteredUser) {
	        // ND enabled flow
	        if (data.InactiveZipMessage.length > 0) {
	          popupMsg = data.InactiveZipMessage;
	        } else if (data.NewWarehouseAlert.length > 0) {
	          popupMsg = data.NewWarehouseAlert;
	        } else if (!isCheckoutFlow && (data.ExternalCarrierChange || data.WarehouseChange) || isCheckoutFlow && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data.WarehouseChange && userDeliveryMethod == 'Local') {
	          var errorMessage2;
	          if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
	            errorMessage2 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
	          } else {
	            errorMessage2 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
	          }
	          errorMessage2 = errorMessage2.replace(/\{0\}/g, fromZipCodeToDisplay);
	          errorMessage2 = errorMessage2.replace(/\{1\}/g, data.SetDeliveryZip);
	          popupMsg = errorMessage2;
	        } else {
	          var errorMessage3;
	          if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
	            errorMessage3 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
	          } else {
	            errorMessage3 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
	          }
	          errorMessage3 = errorMessage3.replace(/\{0\}/g, fromZipCodeToDisplay);
	          errorMessage3 = errorMessage3.replace(/\{1\}/g, data.SetDeliveryZip);
	          popupMsg = errorMessage3;
	        }
	      } else {
	        var errorMessage1;
	        if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
	          errorMessage1 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
	        } else {
	          errorMessage1 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
	        }
	        errorMessage1 = errorMessage1.replace(/\{0\}/g, fromZipCodeToDisplay);
	        errorMessage1 = errorMessage1.replace(/\{1\}/g, data.SetDeliveryZip);
	        popupMsg = errorMessage1;
	      }
	
	      if (data.StatusMessage == data.ZipStatusMessageList[5]) {
	        COSTCO.zipCodeModal.dialogAlert(popupMsg, form);
	      } else if (data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7] && userDeliveryMethod && !(data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data.WarehouseChange && userDeliveryMethod == 'Local')) {
	        COSTCO.CAddress.changeZipDialogOnAddrChange(data, params, popupMsg, form, verifiedAddress, userDeliveryMethod, oldAddy, newAddy);
	      } else {
	        if (COSTCO.util.isNdEnabled()) {
	          COSTCO.CAddress.dialogOnAddrChange(data.SetDeliveryZip, params, popupMsg, form, data, userDeliveryMethod, oldAddy, newAddy);
	        } else {
	          COSTCO.CAddress.dialogOnAddrChange(data.SetDeliveryZip, params, popupMsg, form, null, null, oldAddy, newAddy);
	        }
	      }
	    },
	    changeZipDialogOnAddrChange: function changeZipDialogOnAddrChange(data, params, popupMsg, form, verifiedAddress, userAddressType, oldAddy, newAddy) {
	      var primaryButton = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON;
	      var titleMsg = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER;
	      var messageQues = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1;
	      COSTCO.dialog.createExtDialogBox({
	        title: titleMsg,
	        body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode', {
	          messageTxt: popupMsg,
	          msgQuestion: messageQues }),
	        primary: primaryButton,
	        secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
	        primary_event: function primary_event() {
	          if (data != null && data.ShowAddressTypePopup && data.redirectURL[0] == "SetDeliveryZip") {
	            if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
	              $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val('Local');
	              COSTCO.zipCodeModal.submitZipCode(form);
	            } else {
	              COSTCO.zipCodeModal.viewAddressTypeModal(form, data, params);
	            }
	          } else if (COSTCO.util.isNdEnabled() && data && (data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) && data.ShowDeliveryMethodPopup) {
	            COSTCO.CAddressVerification.viewDeliveryMethodModal(form, data, params, oldAddy, newAddy);
	          } else {
	            if (oldAddy == null) {
	              //add address flow
	              COSTCO.CAddress.callAddressAddNew(params[2], params[3], newAddy, params[4]);
	            } else {
	              COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, newAddy);
	            }
	          }
	        }
	      });
	      $('.close').removeClass("hidden");
	    },
	    dialogOnAddrChange: function dialogOnAddrChange(currentZip, optParams, popupMsg, form, data, userDeliveryMethod, oldAddy, newAddy) {
	      var primaryButton = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON;
	      var titleMsg = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER;
	      var messageQues = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1;
	      COSTCO.dialog.createExtDialogBox({
	        title: titleMsg,
	        body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode', {
	          messageTxt: popupMsg,
	          msgQuestion: messageQues }),
	        primary: primaryButton,
	        secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
	        primary_event: function primary_event() {
	          if (COSTCO.util.isNdEnabled() && data && data.StatusMessage == data.ZipStatusMessageList[7] && data.ShowDeliveryMethodPopup) {
	            COSTCO.CAddressVerification.viewDeliveryMethodModal(form, data, optParams, oldAddy, newAddy);
	          } else {
	            if (oldAddy == null) {
	              //add address flow
	              COSTCO.CAddress.callAddressAddNew(optParams[2], optParams[3], newAddy, optParams[4], data);
	            } else {
	              COSTCO.CAddress.callChooseAddressNew(optParams[2], oldAddy, newAddy, data);
	            }
	          }
	        }
	      });
	    },
	    /**
	     * Add new address.
	     * @return {void}
	     */
	    callAddressAddNew: function callAddressAddNew(addressType, addressOptions, verifiedAddress, preventajaxhtml, data) {
	
	      CAddress.applyAddressToWhat(addressType);
	      if (checkoutPage == 'review' || checkoutPage == 'shipping') {
	        isCheckoutFlow = true;
	      }
	      if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && !isCheckoutFlow) {
	        CAddress.addressTools.applyAddressToOrderItems = 'false';
	      }
	      var labels = CAddress.getHeaderLabels(addressType, 'add');
	      var options = {
	        url: verifiedAddress.id !== "" ? CAddress.urlAddUpdate(addressOptions) : CAddress.urlAdd(addressOptions),
	        method: "POST",
	        dataType: 'json',
	        data: {
	          'authToken': COSTCO.Checkout.getAuthToken(),
	          formdata: encodeURIComponent(JSON.stringify(verifiedAddress)),
	          userSelectionDeliveryMethod: data && data.userSelectionDeliveryMethod ? data.userSelectionDeliveryMethod : ''
	        },
	        replaceKey: {
	          original: 'address-block',
	          replace: labels.replaceKey
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && COSTCO.CreditCard !== undefined) {
	            COSTCO.CreditCard.initComplete = false;
	          }
	          if (!data.errorMessage) {
	            COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	          } else {
	            var parentNode = document.getElementById("costcoModalText");
	            if (parentNode !== null) {
	              var newDiv = document.createElement("div");
	              newDiv.innerHTML = data.errorMessage;
	              newDiv.className = 'error';
	              parentNode.prepend(newDiv);
	            }
	          }
	        },
	        ajax_update_post_done: function ajax_update_post_done(data) {
	          /* Default function body, extracted so it can be combined with promises. */
	          function postDone(data) {
	            var application = data.error.application;
	            if (application.length === 0) {
	              COSTCO.util.resetAddressLoadState();
	              COSTCO.CAddress.closeModal();
	              $('body').trigger("costco.address.added", data.payload.data[1]);
	            } else {
	              $('body').trigger("costco.address.error", application);
	            }
	            CAddress.bindEvents();
	            if (addressOptions.addressBookReinit) {
	              COSTCO.CAddressBook.init();
	            }
	            if (checkoutPage) {
	              COSTCO.OrderItems.init();
	
	              if (checkoutPage === 'review') {
	                COSTCO.CreditCard.initComplete = false;
	                COSTCO.CreditCard.init();
	                if (COSTCO.util.isBusinessDelivery()) {
	                  COSTCO.Header.miniShopCartRefresh();
	                  COSTCO.preauthchargesmodal.init();
	                }
	              }
	              if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore() && $('#residential-address-notification').length) {
	                $('#residential-address-notification').remove();
	              }
	            }
	          }
	          // STRY0183851: BD only - in case of mismatch with Accertify.jspf cookie data, ajax-refresh Payment section
	          if (typeof checkoutPage != 'undefined' && checkoutPage != 'cart' && COSTCO.util.isBusinessDelivery() && $('input#whs-cookie-accertify').length && COSTCO.util.getBDZipCookie().warehouseNumber != $('input#whs-cookie-accertify').val()) {
	            COSTCO.Checkout.ajaxRefreshAllCheckoutSections().then(function () {
	              postDone(data);
	            });
	          } else {
	            postDone(data);
	          }
	        }
	      };
	      if (preventajaxhtml) {
	        options.ajax_replace_content = function () {};
	      }
	      COSTCO.Checkout.ajax_update_state(options);
	    },
	    addressValidateSuccess: function addressValidateSuccess(data, params, form, verifiedAddress) {
	      $('#addressFormInlineButton').removeAttr('disabled');
	      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
	      var userDeliveryMethod = '';
	      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
	      if (COSTCO.util.isNdEnabled()) {
	        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
	        if (!data.ShowDeliveryMethodPopup && !data.ShowAddressTypePopup) {
	          userDeliveryMethod = 'Nationwide';
	        }
	        if (!data.ShowDeliveryMethodPopup && data.IsInBDTruckZoneOnly) {
	          userDeliveryMethod = 'Local';
	        }
	        if (!data.ShowDeliveryMethodPopup && data.IsStorePickupOnly) {
	          userDeliveryMethod = 'Store-Pick-Up';
	        }
	      }
	      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
	        COSTCO.CAddressForm.addressNotServicedModal(verifiedAddress, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        }, "residentialNotServiced");
	      } else if (data.BargeOrderZip == true) {
	        COSTCO.CAddress.submitAddress(data, params, form, verifiedAddress);
	        $('body').bind('costco.address.added', function (event, address) {
	          $('#NewAddressSingleShippingForm input[name="addressId"]').val(address.addressId);
	          $('#NewAddressSingleShippingForm').submit();
	        });
	      } else {
	        if (data.StatusMessage == data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
	          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	          COSTCO.zipCodeModal.launchModal(data, params, form, verifiedAddress);
	        } else {
	          if (data.StatusMessage == data.ZipStatusMessageList[2] || data.StatusMessage == data.ZipStatusMessageList[0] || data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) {
	            if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data)) {
	              COSTCO.zipCodeModal.launchModal(data, params, form, verifiedAddress);
	            } else {
	              if (COSTCO.util.isNdEnabled() && (data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) && userDeliveryMethod == 'Local') {
	                COSTCO.CAddressForm.showNationalDeliveryQuestionnaireModal_v2(form, data, params, verifiedAddress);
	              } else {
	                data.userSelectionDeliveryMethod = userDeliveryMethod;
	                COSTCO.CAddress.submitAddress(data, params, form, verifiedAddress);
	                $('body').bind('costco.address.added', function (event, address) {
	                  $('#NewAddressSingleShippingForm input[name="addressId"]').val(address.addressId);
	                  $('#NewAddressSingleShippingForm').submit();
	                });
	              }
	            }
	          } else {
	            COSTCO.CAddressForm.addressNotServicedModal(verifiedAddress, undefined, function () {
	              window.location.replace('http://' + $('#desktopHostName').val());
	            });
	          }
	        }
	      }
	    },
	    submitAddress: function submitAddress(data, params, form, verifiedAddress) {
	      if (data != null && data.BargeOrderZip == false) {
	        COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
	        COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	        $('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
	      }
	      var addressType = '';
	      if (verifiedAddress.addressType == null) {
	        addressType = verifiedAddress.addressType2.trim();
	      } else {
	        addressType = verifiedAddress.addressType.trim();
	      }
	      CAddress.applyAddressToWhat(addressType);
	      var labels = CAddress.getHeaderLabels(addressType, 'add');
	      var options = {
	        url: verifiedAddress.id != "" ? CAddress.urlAddUpdate() : CAddress.urlAdd(),
	        method: "POST",
	        dataType: 'json',
	        data: {
	          'authToken': COSTCO.Checkout.getAuthToken(),
	          formdata: encodeURIComponent(JSON.stringify(verifiedAddress)),
	          userSelectionDeliveryMethod: data && data.userSelectionDeliveryMethod ? data.userSelectionDeliveryMethod : ''
	        },
	        replaceKey: {
	          original: 'address-block',
	          replace: labels.replaceKey
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          if (!data.errorMessage) {
	            COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	          } else {
	            var parentNode = document.getElementById("costcoModalText");
	            if (parentNode != null) {
	              var newDiv = document.createElement("div");
	              newDiv.innerHTML = data.errorMessage;
	              newDiv.className = 'error';
	              parentNode.prepend(newDiv);
	            }
	          }
	        },
	        ajax_update_post_done: function ajax_update_post_done(data) {
	          var application = data.error.application;
	          if (application.length == 0) {
	            COSTCO.util.resetAddressLoadState();
	            COSTCO.CAddress.closeModal();
	            $('body').trigger("costco.address.added", data.payload.data[1]);
	          } else {
	            $('body').trigger("costco.address.error", application);
	          }
	          CAddress.bindEvents();
	          if (typeof checkoutPage != 'undefined' && checkoutPage) {
	            COSTCO.OrderItems.init();
	            if (checkoutPage == 'review' && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
	              COSTCO.CAddress.initializeCreditCardModule();
	            } else if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && $('#shipping #address-modal-inline').length === 0) {
	              COSTCO.CAddress.initializeCreditCardModule();
	            }
	          }
	        }
	      };
	      COSTCO.Checkout.ajax_update_state(options);
	    },
	    initializeCreditCardModule: function initializeCreditCardModule() {
	      COSTCO.CreditCard.initComplete = false;
	      COSTCO.CreditCard.init();
	    },
	    addressValidateSuccessOnPlaceOrder: function addressValidateSuccessOnPlaceOrder(data, params, form, chosenAddress) {
	      $('#addressFormInlineButton').removeAttr('disabled');
	      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
	      var userDeliveryMethod = '';
	      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
	      //Set address type
	      if (COSTCO.util.isNdEnabled()) {
	        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
	        if (data.WarehouseChange && !data.ShowAddressTypePopup) {
	          userDeliveryMethod = 'Nationwide';
	        }
	        if (data.WarehouseChange && data.IsInBDTruckZoneOnly) {
	          userDeliveryMethod = 'Local';
	        }
	        if (data.WarehouseChange && data.IsStorePickupOnly) {
	          userDeliveryMethod = 'Store-Pick-Up';
	        }
	        data.userSelectionDeliveryMethod = userDeliveryMethod;
	      }
	      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
	        COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        }, "residentialNotServiced");
	      } else if (data.BargeOrderZip == true) {
	        COSTCO.OrderSummary.placeOrder();
	      } else if ((data != undefined && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data != undefined && data.WarehouseChange && userDeliveryMethod == 'Local') && isUserCurrentOrderItemsAvailable) {
	        COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form, undefined, userDeliveryMethod);
	      } else {
	        if (data.StatusMessage == data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
	          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	          COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
	        } else {
	          if (data.StatusMessage == data.ZipStatusMessageList[0] || data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) {
	            if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data, userDeliveryMethod)) {
	              COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
	            } else {
	              COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
	              COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	              $('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
	              COSTCO.OrderSummary.placeOrder();
	            }
	          } else if (data.StatusMessage == data.ZipStatusMessageList[2]) {
	            COSTCO.OrderSummary.placeOrder();
	          } else if (data.StatusMessage == data.ZipStatusMessageList[5] && data.NewWarehouseAlert.length > 0) {
	            COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form);
	          } else {
	            COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	              window.location.replace('http://' + $('#desktopHostName').val());
	            });
	          }
	        }
	      }
	    },
	    addressValidateSuccessOnSubmitShipping: function addressValidateSuccessOnSubmitShipping(data, params, form, chosenAddress) {
	      $('#addressFormInlineButton').removeAttr('disabled');
	      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
	      var userDeliveryMethod = '';
	      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
	      //Set address type
	      if (COSTCO.util.isNdEnabled()) {
	        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
	        if (data.WarehouseChange && !data.ShowAddressTypePopup) {
	          userDeliveryMethod = 'Nationwide';
	        }
	        if (data.WarehouseChange && data.IsInBDTruckZoneOnly) {
	          userDeliveryMethod = 'Local';
	        }
	        if (data.WarehouseChange && data.IsStorePickupOnly) {
	          userDeliveryMethod = 'Store-Pick-Up';
	        }
	        data.userSelectionDeliveryMethod = userDeliveryMethod;
	      }
	      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
	        COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        }, "residentialNotServiced");
	      } else if (data.BargeOrderZip == true) {
	        $('#NewAddressSingleShippingForm input[name="addressId"]').val(chosenAddress.id);
	        $('#NewAddressSingleShippingForm').submit();
	      } else if ((data != undefined && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data != undefined && data.WarehouseChange && userDeliveryMethod == 'Local') && isUserCurrentOrderItemsAvailable) {
	        COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form, undefined, userDeliveryMethod);
	      } else {
	        if (data.StatusMessage == data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
	          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	          COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
	        } else {
	          if (data.StatusMessage == data.ZipStatusMessageList[0] || data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) {
	            if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data, userDeliveryMethod)) {
	              COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
	            } else {
	              COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
	              COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	              $('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
	              $('#NewAddressSingleShippingForm input[name="addressId"]').val(chosenAddress.id);
	              $('#NewAddressSingleShippingForm input[name="orderShipmodeId"]').val($('form#CheckoutReviewForm input[name=orderShipmodeId]').val());
	              $('#NewAddressSingleShippingForm').submit();
	            }
	          } else if (data.StatusMessage == data.ZipStatusMessageList[2]) {
	            $('#NewAddressSingleShippingForm input[name="addressId"]').val(chosenAddress.id);
	            $('#NewAddressSingleShippingForm').submit();
	          } else if (data.StatusMessage == data.ZipStatusMessageList[5] && data.NewWarehouseAlert.length > 0) {
	            COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form);
	          } else {
	            COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	              window.location.replace('http://' + $('#desktopHostName').val());
	            });
	          }
	        }
	      }
	    },
	    addEditAddress: function addEditAddress(verifiedAddress, preventajaxhtml, addressOptions, message) {
	
	      if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && !COSTCO.CAddressForm.isFormCompleted('S') && verifiedAddress.addressType != 'B' && checkoutPage) {
	        if (checkoutPage === 'shipping') {
	          //COSTCO.CAddress.submitAddress(null, verifiedAddress.id, $('#formshipping'), verifiedAddress);
	          $('#formshipping').find('[name=zipCodeFormDeliveryZipCode]').val(verifiedAddress.zip);
	          COSTCO.zipCodeModal.submitZipCodeForValidation($('#formshipping'), COSTCO.CAddress.addressValidateSuccess, COSTCO.CAddress.addressSetZipSuccess, verifiedAddress.id, undefined, verifiedAddress);
	        } else if (checkoutPage === 'review') {
	          $('#formreview').find('[name=zipCodeFormDeliveryZipCode]').val(verifiedAddress.zip);
	          COSTCO.zipCodeModal.submitZipCodeForValidation($('#formreview'), COSTCO.CAddress.addressValidateSuccess, COSTCO.CAddress.addressSetZipSuccess, verifiedAddress.id, undefined, verifiedAddress);
	        }
	      } else {
	        var callAddressAdd = function callAddressAdd(addressType) {
	          CAddress.applyAddressToWhat(addressType);
	          if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val())) {
	            CAddress.addressTools.applyAddressToOrderItems = 'false';
	          }
	          var labels = CAddress.getHeaderLabels(addressType, 'add');
	          var oldZipcode;
	          var orderHasEddItems = $('#orderHasEddItems').val();
	          if (!addressOptions.addressBookReinit && verifiedAddress.addressType === 'S' && undefined !== orderHasEddItems) {
	            if (orderHasEddItems === 'true') {
	              oldZipcode = $.cookie("invCheckPostalCode");
	              if (typeof sessionStorage !== "undefined" && null !== oldZipcode) {
	                sessionStorage.setItem('oldZipcode', oldZipcode);
	              }
	              $.cookie("invCheckPostalCode", verifiedAddress.zip.toUpperCase());
	              $.cookie("invCheckStateCode", verifiedAddress.state);
	              $.cookie("invCheckCity", verifiedAddress.city);
	            }
	
	            //update WAREHOUSEDELIVERY_WHS cookie
	            if (!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof verifiedAddress.zip !== 'undefined') {
	              CAddress.updateWarehouseCookie(verifiedAddress.zip.toUpperCase());
	            }
	          }
	          var options = {
	            url: verifiedAddress.id !== "" ? CAddress.urlAddUpdate(addressOptions) : CAddress.urlAdd(addressOptions),
	            method: "POST",
	            dataType: 'json',
	            data: { 'authToken': COSTCO.Checkout.getAuthToken(), 'oldZipcode': oldZipcode, formdata: encodeURIComponent(JSON.stringify(verifiedAddress)) },
	
	            replaceKey: {
	              original: 'address-block',
	              replace: labels.replaceKey
	            },
	            done: function done(data, textStatus, jqXHR, options) {
	              if (!data.errorMessage) {
	                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
	                  COSTCO.CreditCard.initComplete = false;
	                }
	                COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	              } else {
	                var parentNode = document.getElementById("costcoModalText");
	                if (parentNode !== null) {
	                  var newDiv = document.createElement("div");
	                  //BD ALM-3463 fix repetitive error msg
	                  if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val())) {
	                    var errorDiv = document.getElementById("addressValidationError");
	                    if (errorDiv !== null) {
	                      errorDiv.remove();
	                    }
	                    newDiv.id = 'addressValidationError';
	                  }
	                  newDiv.innerHTML = data.errorMessage;
	                  newDiv.className = 'error';
	                  parentNode.prepend(newDiv);
	                }
	              }
	            },
	            ajax_update_post_done: function ajax_update_post_done(data) {
	              var application = data.error.application;
	              if (application.length === 0) {
	                COSTCO.util.resetAddressLoadState();
	                COSTCO.CAddress.closeModal();
	                $('body').trigger("costco.address.added", data.payload.data[1]);
	              } else {
	                $('body').trigger("costco.address.error", application);
	              }
	              CAddress.bindEvents();
	              if (addressOptions.addressBookReinit) {
	                COSTCO.CAddressBook.init();
	              }
	              if (typeof checkoutPage !== 'undefined' && checkoutPage) {
	                apiAlreadyCalled = undefined;
	                COSTCO.OrderItems.init();
	
	                if (checkoutPage === 'review') {
	                  COSTCO.CreditCard.initComplete = false;
	                  COSTCO.CreditCard.init();
	                  if (COSTCO.util.isBusinessDelivery()) {
	                    COSTCO.Header.miniShopCartRefresh();
	                  }
	                }
	              }
	            },
	            always: function always() {
	              COSTCO.preauthchargesmodal.init();
	            }
	          };
	          if (preventajaxhtml) {
	            options.ajax_replace_content = function () {};
	          }
	          COSTCO.Checkout.ajax_update_state(options);
	        };
	
	        var addressType = '';
	        if (verifiedAddress.addressType === null) {
	          addressType = verifiedAddress.addressType2 !== null ? verifiedAddress.addressType2.trim() : '';
	        } else {
	          addressType = verifiedAddress.addressType.trim();
	          var uniquePageSelector = '';
	          if (typeof checkoutPage !== 'undefined' && checkoutPage) {
	            if (checkoutPage === 'multi-shipping') {
	              uniquePageSelector = '#single-page-checkout-multi-address';
	            } else {
	              uniquePageSelector = '#shipping';
	            }
	          } else {
	            uniquePageSelector = '#shippingTab';
	          }
	          $(uniquePageSelector).find('input[id="addressEnteredForCheck"]').remove();
	          $(uniquePageSelector).append('<input type="hidden" id="addressEnteredForCheck" value="' + verifiedAddress.line1 + '"/>');
	        }
	        // Prevent code breaking if checkoutPage is undefined to fix STRY0158367-Use-
	        // address-functionality-does-notrespond-from-the-address-validation-modal
	        var checkoutPageName = typeof checkoutPage === 'undefined' ? false : checkoutPage;
	
	        if (addressType === 'S' && !addressOptions.addressBookReinit && (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) || checkoutPageName != 'shipping' && checkoutPageName != 'review')) {
	          var submitZipCodeForValidation = function submitZipCodeForValidation() {
	            var submitParams = [addressType, addressOptions, preventajaxhtml];
	            var form = $('#formshipping');
	            var callBack = COSTCO.CAddress.addressValidateSuccessOnChooseAddress;
	            if (checkoutPage == 'review') {
	              form = $('#formreview');
	            }
	            form.find("input[name=zipCodeFormDeliveryZipCode]").val(verifiedAddress.zip);
	            COSTCO.zipCodeModal.submitZipCodeForValidation(form, callBack, null, submitParams, null, verifiedAddress);
	          };
	          var serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
	          serviceToUpdateCookies(verifiedAddress.zip).then(function () {
	            if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof checkoutPage != 'undefined' && (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping') && message != 'editAddressType') {
	              submitZipCodeForValidation();
	            } else {
	              callAddressAdd(addressType);
	            }
	          }, function () {
	            //Allow the flow for CABD here, as we allow all codes if FSA is right, and delivery not segmented
	            if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isCABDStore() && typeof checkoutPage != 'undefined' && (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping') && message != 'editAddressType') {
	              submitZipCodeForValidation();
	            }
	          });
	        } else {
	          callAddressAdd(addressType);
	        }
	      }
	    },
	    getAddressType: function getAddressType(addressId, type) {
	      var string = '';
	      for (var i = 0; i < COSTCO.util.addresses.length; i++) {
	        if (COSTCO.util.addresses[i].id == addressId) {
	          string = COSTCO.util.addresses[i].addressType.toUpperCase();
	          break;
	        }
	      }
	      if (string == '' && typeof type !== 'undefined') {
	        string = type;
	      }
	      return string;
	    },
	    getAddressElement: function getAddressElement(addyId, prop, wholeObj) {
	      for (var i = 0; i < COSTCO.util.addresses.length; i++) {
	        // return specific obj
	        if (wholeObj == true) {
	          if (COSTCO.util.addresses[i].id == addyId) {
	            return COSTCO.util.addresses[i];
	          }
	        } else if (COSTCO.util.addresses[i].id == addyId) {
	          // return specific property
	          return COSTCO.util.addresses[i][prop];
	        }
	      }
	    },
	    getSaveAddress: function getSaveAddress(addressId, isChecked) {
	      return addressId != '' ? CAddress.getAddressElement(addressId, 'addressType') == 'T' ? 'off' : 'on' : isChecked ? 'on' : 'off';
	    },
	    getDefaultAddress: function getDefaultAddress(addressId, isChecked) {
	      if (isChecked) return 'on';
	      return 'off';
	    },
	    isEmptyAddressType: function isEmptyAddressType(type, addyObj) {
	      for (obj in addyObj) {
	        if (addyObj[obj].addressType === type) return false;
	      }
	      return true;
	    },
	    handleServerError: function handleServerError(msg) {
	      // put msg and show associated modal
	      $(CAddress.addressTools.errorContainer).text(msg).show();
	      if ($('.address-edit[addressid=' + CAddress.addressTools.cachedAddressId + ']').length > 0) {
	        $('.address-edit[addressid=' + CAddress.addressTools.cachedAddressId + ']').click();
	      } else if (CAddress.addressTools.errorContainer == '#address-form .text-error') {
	        $('#address-form-modal').costcoModal('showPartial full-page');
	      }
	      $('div').scrollTop($(CAddress.addressTools.errorContainer).offset().top - $('div').offset().top + $('div').scrollTop());
	    },
	    /**
	     * If the user changes their address for grocery items, associate the
	     * new address with all of the grocery items. Where 'this' is the select
	     * DOM element. Called inline on MultiShippingItemAddress.jsp.
	     * @return {void}
	     */
	    groceryItemAddress: function groceryItemAddress() {
	      var selectedGroceryAddress = $(this).val();
	      var $groceryAddresses = $('.grocery-address [name^=addressId_]');
	      $groceryAddresses.val(selectedGroceryAddress);
	    },
	    //-End-Grocery changes
	    getAddressJson: function getAddressJson(addressId, startAddress, type) {
	      if (typeof addressId == 'undefined') {
	        return COSTCO.util.addresses;
	      }
	
	      if (typeof COSTCO.util == 'undefined' || COSTCO.util.addresses.length == 0) {
	        return [];
	      }
	      var returnArray = [];
	      if (isNaN(addressId)) {
	        for (var i = 0; i < COSTCO.util.addresses.length; i++) {
	          if (COSTCO.util.addresses[i].addressType.trim() == addressId) {
	            returnArray.push(COSTCO.util.addresses[i]);
	          }
	        }
	      } else {
	        for (var i = 0; i < COSTCO.util.addresses.length; i++) {
	          if (COSTCO.util.addresses[i].id == addressId) {
	            returnArray.push(COSTCO.util.addresses[i]);
	          }
	        }
	      }
	      if (typeof startAddress !== 'undefined') {
	        var foundIndex = 0;
	        for (var i = 0; i < returnArray.length; i++) {
	          if (returnArray[i].id == startAddress) {
	            foundIndex = i;
	          }
	        }
	        if (foundIndex > 0) {
	          var arrayElement = returnArray.splice(foundIndex, 1)[0];
	          returnArray.unshift(arrayElement);
	        }
	      }
	      // Need to trim address types
	      for (var i = 0; i < returnArray.length; i++) {
	        returnArray[i].addressType = returnArray[i].addressType.trim();
	      }
	      return returnArray;
	    },
	    getStateProvJson: function getStateProvJson(callback) {
	      return countries;
	    },
	    /**
	     * Function used to populate city and state in the responsive address form
	     * Function is tied to the postal code element
	     * 
	     * Params
	     * 		element -> jquery query that contain the postalCode input value
	     * 		cityQuery -> jquery query that locate the input for city
	     * 		stateQuery -> jquery query that locate the input for state
	     * 
	     */
	    bingCityState: function bingCityState(element, cityQuery, stateQuery) {
	      var query = $(element).val();
	
	      var updateFormElements = function updateFormElements(data) {
	        var province = null;
	        var country = null;
	        try {
	          //Check out if country is Puerto Rico specific
	          country = data.resourceSets[0].resources[0].address.countryRegionIso2;
	          if (country != undefined && country === 'PR') {
	            province = data.resourceSets[0].resources[0].address.countryRegionIso2;
	            country = 'US';
	          } else {
	            province = data.resourceSets[0].resources[0].address.adminDistrict;
	          }
	        } catch (e) {
	          province = "";
	        }
	        var city = null;
	        try {
	          city = data.resourceSets[0].resources[0].address.locality;
	        } catch (e) {
	          city = "";
	        }
	
	        if (COSTCO.CAddressForm !== undefined) {
	          COSTCO.CAddressForm.populateCityState(element.form, city, province, cityQuery, stateQuery);
	          //COSTCO.CAddressForm.validate();
	        }
	      };
	      COSTCO.util.callBing(query, updateFormElements);
	    },
	    /**
	        * Function used to populate city and state in the responsive address form
	        * Function is tied to the postal code element
	        * 
	        * Params
	        * 		element -> jquery query that contain the postalCode input value
	        * 		cityQuery -> jquery query that locate the input for city
	        * 		stateQuery -> jquery query that locate the input for state
	        * 
	        */
	    geocodeApiCityState: function geocodeApiCityState(element, cityQuery, stateQuery, editAddrCity, editAddrState) {
	
	      var query = $(element).val();
	
	      var updateFormElements = function updateFormElements(data) {
	        var province = null;
	        var country = null;
	        var city = null;
	        try {
	          city = data[0].city;
	          province = data[0].stateProvinceAbbreviation;
	          if (province == null) {
	            province = data[0].stateProvince;
	          }
	          country = data[0].country;
	        } catch (e) {
	          console.error('Error: ' + e.message);
	        }
	
	        if (COSTCO.CAddressForm !== undefined) {
	          COSTCO.CAddressForm.populateCityState(element.form, city, province, cityQuery, stateQuery);
	        }
	      };
	
	      var updateFormElementsFromZipPostalCode = function updateFormElementsFromZipPostalCode(data) {
	        var provinceList = [];
	        var countryList = [];
	        var cityList = [];
	        try {
	          for (var i = 0; i < data.length; i++) {
	            if (data[i].city != undefined && !cityList.find(function (city) {
	              return city === data[i].city;
	            })) {
	              cityList.push(data[i].city);
	            }
	
	            var existingProv = provinceList.find(function (prov) {
	              return prov.code === data[i].stateProvinceAbbreviation;
	            });
	            if (data[i].stateProvinceAbbreviation != undefined && !existingProv) {
	              var prov = new Object();
	              prov.code = data[i].stateProvinceAbbreviation;
	              prov.displayName = data[i].stateProvince != null ? data[i].stateProvince : data[i].stateProvinceAbbreviation;
	              provinceList.push(prov);
	            }
	
	            if (data[i].country != undefined && !countryList.find(function (country) {
	              return country === data[i].country;
	            })) {
	              countryList.push(data[i].country);
	            }
	          }
	        } catch (e) {
	          console.error('Error: ' + e.message);
	        }
	
	        if (COSTCO.CAddressForm !== undefined) {
	          var form = undefined;
	          if ($(element).form) {
	            form = $(element).form;
	          } else if ($(element).prevObject) {
	            form = $(element).prevObject;
	          } else if ($(element).closest('form')) {
	            form = $(element).closest('form');
	          }
	          if (form != undefined) {
	            COSTCO.CAddressForm.populateCityStateForZipPostalCode(form, cityList, provinceList, cityQuery, stateQuery, editAddrCity, editAddrState);
	            // COSTCO.CAddressForm.validate();
	          }
	        }
	      };
	
	      var geocodeCallback = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true" ? updateFormElementsFromZipPostalCode : updateFormElements;
	
	      COSTCO.util.callGeocodeAPI(query, geocodeCallback);
	    },
	
	    bindEvents: function bindEvents() {
	      if (typeof checkoutPage !== "undefined" && checkoutPage === 'multi-shipping') {
	        $('.addressid-selection').unbind('change').change(function () {
	          var selectedOption = $(this).find(':selected');
	          var name = selectedOption.attr('name');
	          if (typeof name !== 'undefined' && name === 'add-new-address-option') {
	            COSTCO.CAddressForm.createNewAddress('S', selectedOption.attr('orderitem-id'), true);
	          }
	        });
	        if ($('#addressId_1 option').length == 1) {
	          $('.addressid-selection').unbind('click').click(function () {
	            var selectedOption = $(this).find(':selected');
	            var name = selectedOption.attr('name');
	            if (typeof name !== 'undefined' && name === 'add-new-address-option') {
	              COSTCO.CAddressForm.createNewAddress('S', selectedOption.attr('orderitem-id'), true);
	            }
	          });
	        }
	      }
	      COSTCO.CAddressForm.initiatePopovers();
	    },
	    /**
	    * Changes the cookie and appends/removes EC as per condition
	    * 
	    */
	    isZipOrDeliveryMethodChange: function isZipOrDeliveryMethodChange(data, userSelection) {
	      var isChanged = false;
	      currentCookie = $.cookie('WC_BD_WHS');
	      if (COSTCO.util.isNdEnabled() && data && userSelection) {
	        if ((userSelection == "Nationwide" || !data.ShowAddressTypePopup) && currentCookie.search("-ND") == -1) {
	          isChanged = true;
	        } else if (userSelection == "Local" && currentCookie.search("-ND") != -1 && data.ShowAddressTypePopup) {
	          isChanged = true;
	        }
	      }
	      if (data && data.CurrentDeliveryZip != data.SetDeliveryZip) {
	        isChanged = true;
	      }
	      return isChanged;
	    },
	    /**
	     * The method sets all the required field so as to save the user selected address type to DB
	     * and calls function to show the Address Type popup
	    */
	    addUserSelectionFromDelivery: function addUserSelectionFromDelivery(obj) {
	
	      var addressJson = COSTCO.CAddress.getAddressJson(obj)[0];
	      var addresstype = addressJson.userAddressType;
	      if (document.querySelector('input[name="nd-radio-group-input"]:checked') != null) {
	        addresstype = document.querySelector('input[name="nd-radio-group-input"]:checked').value;
	      }
	      COSTCO.CAddressVerification.entered = addressJson;
	      COSTCO.CAddressVerification.entered.addressType = "S";
	      COSTCO.CAddressVerification.entered.saveAddress = "on";
	      COSTCO.CAddressVerification.entered.setDefault = "on";
	      COSTCO.CAddressVerification.entered.addressType2 = "S";
	      COSTCO.CAddressVerification.entered.userAddressType = addresstype;
	      COSTCO.CAddressVerification.entered.userAddrTypeUpdate = "Y";
	      COSTCO.CAddressVerification.viewAddressTypeModal(undefined, {}, 'editAddressType');
	    },
	    //update WAREHOUSEDELIVERY_WHS cookie
	    updateWarehouseCookie: function updateWarehouseCookie(zipcode) {
	
	      var parsedCookie = JSON.parse($.cookie('WAREHOUSEDELIVERY_WHS'));
	      var responseJson;
	      var distCenterServiceUrl = $('#distributionCentersUrl').val() + '?destinationPostalCode=' + zipcode.toUpperCase();
	      var headers = {
	        'costco.env': $('#distributionCentersEnv').val(),
	        'costco.service': 'restInventory',
	        'client-identifier': $('#distributionCentersClientId').val()
	      };
	
	      try {
	        $.ajax({
	          url: distCenterServiceUrl,
	          type: 'GET',
	          headers: headers,
	          dataType: 'json',
	          async: false,
	          success: function success(data) {
	            responseJson = data;
	            parsedCookie.distributionCenters = responseJson.distributionCenters;
	            parsedCookie.groceryCenters = responseJson.groceryCenters;
	            $.cookie('WAREHOUSEDELIVERY_WHS', JSON.stringify(parsedCookie));
	          },
	          error: function error(data) {
	            responseJson = data;
	            console.log("Error in updateWarehouseCookie: " + JSON.stringify(responseJson));
	          }
	        });
	      } catch (e) {
	        console.error("Error in updateWarehouseCookie: " + e);
	      }
	    }
	  };
	  if (typeof window.COSTCO === "undefined") {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.CAddress = CAddress;
	  return CAddress;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title preauthchargesmodal.js: Sub-module for Global pages
	 * @description This module is used to display the preauthcharges modal
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (dialog) {
	
		var preauthchargesmodal = {
	
			init: function init() {
				this.attachExternalClass();
			},
	
			attachExternalClass: function attachExternalClass() {
				$('.preauthcharges-text').unbind().on('click', this.bind_external);
			},
	
			bind_external: function bind_external(event) {
				var callerElement = event.target;
				COSTCO.dialog.returnFocusOnCallerElement(callerElement);
				preauthchargesmodal.createDialogBox(this.href);
				event.preventDefault();
			},
	
			createDialogBox: function createDialogBox(url) {
				dialog.createExtDialogBox({
					title: messages.CHECKOUT_PREAUTH_MSG,
					body: COSTCO.util.tmpl('tmpl_preauthcharges_modal', {}),
					primary: messages.CLOSE
				});
			}
	
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.preauthchargesmodal = preauthchargesmodal;
	
		return preauthchargesmodal;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title costcodialog.js: Sub-module for Global pages
	 * @description This module is used to creating Modal
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var dialog = {
	    dialogSettings: null,
	    triggerEvent: null,
	    /**
	     * Create a BS style modal that is customizable
	     * @param  {Object} settings Object with following properties:
	     * - title : string appears in the header portion of the modal
	     * - body : HTML/string that represents the body of the modal
	     * - primary : primary action button name.
	     * - secondary : secondary action button name.z
	     * - primary_event : OPTIONAL custom event to attach to primary button
	     * - url : OPTIONAL url for external link. Used if a primary_event is not provided.
	     * @return {void}
	     */
	    createExtDialogBox: function createExtDialogBox(settings) {
	      // show onetimepopup?
	      if (settings.oneTimePopup && this.isPresentInLocalStorage(settings.url)) {
	        window.open(settings.url);
	        return;
	      }
	      dialog.showAndHideModal(settings);
	    },
	
	    modalObserver: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null,
	      modalObserverState: '',
	      elementCausedModal: undefined,
	      elementCausedSecondModalId: undefined,
	      showingSecondModal: undefined
	    },
	
	    /**
	     * Function used to watch for changes of costco modal
	    */
	    returnFocusOnCallerElement: function returnFocusOnCallerElement(activeElement) {
	      if (dialog.modalObserver.modalObserverState != dialog.modalObserver.state.STARTED) {
	        dialog.modalObserver.modalObserverState = dialog.modalObserver.state.STARTED;
	        if (activeElement !== undefined) {
	          dialog.modalObserver.elementCausedModal = activeElement;
	        }
	        var targetObject = COSTCO.dialog.getModal();
	        if (targetObject.length > 0) {
	          targetObject = targetObject[0];
	          var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              var eventOnClick = false;
	              if (event !== undefined) {
	                eventOnClick = event.target.onclick ? true : false;
	              }
	              //On modal close
	              if (mutation.target.className === "modal fade" && !dialog.modalObserver.elementCausedSecondModalId && !eventOnClick) {
	                $(dialog.modalObserver.elementCausedModal).focus();
	                dialog.modalObserver.elementCausedModal = undefined;
	                COSTCO.dialog.stopModalObserver();
	              } else if (mutation.target.className === "modal fade" && dialog.modalObserver.elementCausedSecondModalId && !eventOnClick) {
	                dialog.modalObserver.showingSecondModal = undefined;
	              } else if (mutation.target.className === "modal fade" && dialog.modalObserver.elementCausedModal && eventOnClick) {
	                COSTCO.dialog.addParentElementForModalObserver(event.target);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          observerObject.observe(targetObject, {
	            attributes: true,
	            attributeFilter: ["class"]
	          });
	          if (observerObject) {
	            this.modalObserver.observer = observerObject;
	          }
	        }
	      }
	    },
	
	    addParentElementForModalObserver: function addParentElementForModalObserver(activeElement) {
	      dialog.modalObserver.elementCausedSecondModalId = activeElement.id;
	      dialog.modalObserver.showingSecondModal = true;
	    },
	
	    removeParentElementForModalObserver: function removeParentElementForModalObserver(activeElement) {
	      if ($('#' + dialog.modalObserver.elementCausedSecondModalId).get(0)) {
	        $('#' + dialog.modalObserver.elementCausedSecondModalId).get(0).focus();
	        $(document).keyup(function (e) {
	          if (e.key === "Escape") {
	            $(dialog.modalObserver.elementCausedModal).focus();
	            dialog.modalObserver.elementCausedModal = undefined;
	            COSTCO.dialog.stopModalObserver();
	          }
	        });
	      }
	
	      dialog.modalObserver.elementCausedSecondModalId = undefined;
	    },
	
	    stopModalObserver: function stopModalObserver() {
	
	      dialog.modalObserver.modalObserverState = dialog.modalObserver.state.STOPPED;
	
	      this.modalObserver.observer.disconnect();
	    },
	
	    /**
	     * Get the Modal for instances where you need to bind certain events
	     * @return {jQuery.Object} The costcoModal jquery object
	     */
	    getModal: function getModal() {
	      return $('#costcoModal');
	    },
	    /**
	     * [description]
	     * @return {[type]} [description]
	     */
	    isVisible: function isVisible() {
	      if ($('#costcoModal').css('display') == 'none') {
	        return false;
	      } else {
	        return $('#costcoModal').is(':visible');
	      }
	    },
	    /**
	     * [description]
	     * @param  {[type]} settings [description]
	     * @return {void}          [description]
	     */
	    showAndHideModal: function showAndHideModal(settings) {
	      dialog.captureDataBeforeShowingModal(settings);
	      if (COSTCO.dialog.isVisible()) {
	        $('#costcoModal').on('hidden.bs.modal', function () {
	          // Load up a new modal...
	          COSTCO.dialog.showModal(settings);
	        });
	        $('#costcoModal').modal('hide');
	      } else {
	        this.showModal(settings);
	      }
	    },
	    /**
	     * [description]
	     * @param  {[type]} settings [description]
	     * @return {void}          [description]
	     */
	    showModal: function showModal(settings) {
	      dialog.captureDataBeforeShowingModal(settings);
	      //modification for ReturnDialogMOdal.jsp
	      if (settings.url) {
	        $('#select-page').addClass('hidden');
	        $('#add-edit-page').removeClass('hidden');
	      }
	      if (settings.hideCloseButton) {
	        $('.close').addClass('hidden');
	      }
	      //end modification for ReturnDialogMOdal.jsp
	      if (settings.dialogclasses) {
	        $('.modal-dialog').addClass(settings.dialogclasses);
	      }
	      if (settings.hideHeader) {
	        $('.modal-header').hide();
	      } else {
	        $('.modal-header').show();
	        $('#costcoModalTitle').text(settings.title);
	        var modaltitle = settings.title;
	        if (modaltitle == 'Edit Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Edit Shipping Address | X Close");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Edit Shipping Address | Save Address");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Edit Shipping Address | Cancel");
	        }
	        if (modaltitle == 'Add New Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Add New Address Modal | X Close");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Add New Address Modal | Save Address");
	          $("#costcoModalBtn1").removeAttr("data-bi-tc");
	          $("#costcoModalBtn1").attr("data-bi-tc", "ui:Add New Address | Cancel");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Add New Address Modal | Cancel");
	        }
	        if (modaltitle == 'Select Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Select Address Modal | X Close");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Select Address Modal | Cancel");
	        }
	        if (modaltitle == 'Change Pick Up Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	        }
	        if (modaltitle == 'Edit Delivery Address' || modaltitle == 'Edit Billing Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Edit Address | Close Button");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Edit Address | Save Address");
	          $("#costcoModalBtn1").removeAttr("data-bi-tc");
	          $("#costcoModalBtn1").attr("data-bi-tc", "ui:Edit Address | Cancel");
	        }
	        if (settings.close) {
	          $('.close').unbind().on('click', function () {
	            settings.close();
	          });
	        }
	      }
	      // if there is a modal Label specified in the setting used it
	      // otherwise we will use the modal title
	      if (settings.modalLabel) {
	        $('#costcoModal').attr('aria-label', settings.modalLabel);
	        $('#costcoModal').removeAttr('aria-labelledby');
	      } else {
	        if (!settings.hideHeader && settings.title) {
	          $('#costcoModal').attr('aria-labelledby', 'costcoModalTitle');
	          $('#costcoModal').removeAttr('aria-label');
	        }
	      }
	
	      $('#costcoModalText').html(settings.body);
	      if (settings.replaceFooter) {
	        $('#costcoModal .modal-footer').html(settings.replaceFooter);
	      }
	      if (settings.showVerifyMeModal || settings.primary && (settings.primary_event || settings.url)) {
	        $('#costcoModalBtn2').text(settings.primary).show();
	        $('#costcoModalBtn2').removeAttr('automation-id');
	        $('#costcoModalBtn2').attr('automation-id', settings.primary.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() + "_button");
	        if (settings.primary_button_style !== undefined && settings.primary_button_style.includes('rounded')) {
	          $('#costcoModalBtn2').addClass('primary-button-v2');
	        }
	        //since primary button is visible, make the secondary button half the row again
	        if (settings.secondary != undefined || settings.setHalfButtons) {
	          $('.costcoModalBtn1').parent('.col-md-12').removeClass('col-md-12').addClass('col-md-6');
	          $('#costcoModalBtn2').parent('.col-md-12').removeClass('col-md-12').addClass('col-md-6');
	          $('.costcoModalBtn1').parent('.col-lg-12').removeClass('col-lg-12').addClass('col-lg-6');
	          $('#costcoModalBtn2').parent('.col-lg-12').removeClass('col-lg-12').addClass('col-lg-6');
	        } else {
	          $('#costcoModalBtn2').parent('.col-md-6').removeClass('col-md-6').addClass('col-md-12');
	          $('#costcoModalBtn2').parent('.col-lg-6').removeClass('col-lg-6').addClass('col-lg-12');
	        }
	        if (settings.showVerifyMeModal) {
	          $('#costcoModalBtn2').html(settings.showVerifyMeModalText);
	          $('#costcoModalBtn2').addClass('verify-me-button');
	          $('#costcoModalBtn2').removeClass('primary-button-v2');
	          $('#costcoModalBtn2').removeClass('btn-primary');
	          $('#costcoModalBtn2').addClass('no-padding');
	        } else {
	          $('#costcoModalBtn2').removeClass('verify-me-button');
	        }
	      } else {
	        $('#costcoModalBtn2').hide();
	        //since primary event button is hidden, make the secondary button span the whole row
	        $('.costcoModalBtn1').parent('.col-md-6').removeClass('col-md-6').addClass('col-md-12');
	        $('.costcoModalBtn1').parent('.col-lg-6').removeClass('col-lg-6').addClass('col-lg-12');
	      }
	      if (settings.secondary_button_style !== undefined && settings.secondary_button_style.includes('rounded')) {
	        $('.costcoModalBtn1').addClass('secondary-button-v2');
	      } else if (settings.secondary_button_style !== undefined && settings.secondary_button_style.includes('tertiary')) {
	        $('.costcoModalBtn1').addClass('tertiary-alternative-button-v2');
	        $('.costcoModalBtn1').removeClass('btn-tertiary secondary-button-v2');
	      }
	
	      if (settings.hideFooter) {
	        $('.modal-footer').hide();
	      } else {
	        $('.modal-footer').show();
	      }
	      if (settings.primaryDisabled) {
	        $('#costcoModalBtn2').addClass('btn-disabled');
	      } else {
	        $('#costcoModalBtn2').removeClass('btn-disabled');
	      }
	      if (settings.secondary) {
	        $('.costcoModalBtn1').text(settings.secondary).show();
	      } else {
	        $('.costcoModalBtn1').hide();
	      }
	      if (settings.close) {
	        $('.close').unbind().on('click', function () {
	          //modification for ReturnDialogMOdal.jsp
	          if (settings.url == undefined) {
	            $('#select-page').removeClass('hidden');
	            $('#add-edit-page').addClass('hidden');
	          }
	          //end modification for ReturnDialogMOdal.jsp
	
	          settings.close();
	        });
	      }
	
	      if (settings.footerText) {
	        $('#costcoModalFooterText').html(settings.footerText);
	        $('#costcoModalFooterText').removeClass('hide');
	      } else {
	        $('#costcoModalFooterText').addClass('hide');
	      }
	      // Hides the default modal footer and shows the alternate modal footer
	      if (settings.footerText2) {
	        $('#costcoModalFooterText2').html(settings.footerText2);
	        $('#costcoModalFooterText2').removeClass('hide');
	      } else {
	        $('#costcoModalFooterText2').addClass('hide');
	      }
	
	      $('#commercial-indicator, #residental-indicator').unbind().on('keydown keypress', function (event) {
	        if (event.which === 32) {
	          $(this).click();
	        } else if (event.which === 38 || event.which === 40) {
	          //cursors up and down
	          var $controlIndicators = $(this).closest('.control-group').find('.control__indicator');
	          var total = $controlIndicators.length;
	          var index = $controlIndicators.index(this);
	          if (event.which == 38) {
	            //cursor up
	            index = index == 0 ? total - 1 : index - 1;
	          } else if (event.which == 40) {
	            //cursor down
	            index = (index + 1) % total;
	          }
	          $controlIndicators[index].click();
	        }
	      });
	
	      $('#commercial-indicator, #residental-indicator').unbind('click').on('click', function (event) {
	        if ($(event.target).hasClass('control__indicator')) {
	          var passiveElement = $(event.target).attr('id') === "commercial-indicator" ? $('#residental-indicator') : $('#commercial-indicator');
	          COSTCO.dialog.setRadioButtonsAttributes($(event.target), passiveElement);
	        }
	        $(event.target).find('input').click();
	      });
	
	      $('#costcoModalBtn2').unbind().on('click', function () {
	        if (COSTCO.timeoutModal && COSTCO.timeoutModal.state === COSTCO.timeoutModal.TIMEDOUT) {
	          var url = "ReLogonFormView?URL=" + window.location.pathname;
	          document.location.href = url;
	        }
	        if (settings.primary_event) {
	          if (settings.primary == 'View List' || settings.primary == 'Voir la liste') {
	            COSTCO.Global.updateSelectedMenuItem('Lists.label');
	          }
	          settings.primary_event();
	        } else {
	          $('#costcoModal').modal('hide');
	          if (settings.url) {
	            window.open(settings.url);
	
	            // check for onetimepopup and add to local storage
	            if (settings.oneTimePopup) {
	              COSTCO.util.setInStorage(settings.url, {
	                'url': settings.url
	              });
	            }
	          }
	        }
	      });
	      $('.costcoModalBtn1').unbind().on('click', function () {
	        //modification for ReturnDialogMOdal.jsp
	        if (settings.url == undefined) {
	          $('#select-page').removeClass('hidden');
	          $('#add-edit-page').addClass('hidden');
	        }
	        //end modification for ReturnDialogMOdal.jsp
	
	        if (settings.secondary_event) {
	          settings.secondary_event();
	        } else {
	          $('#costcoModal').modal('hide');
	        }
	      });
	      if (settings.popover) {
	        $('#costcoModal').find('[data-toggle="popover"]').popover();
	      }
	      this.bindEvents(settings);
	      $('#costcoModal').modal({
	        backdrop: settings.preventClose ? 'static' : true,
	        keyboard: settings.preventClose ? false : true,
	        show: true
	      });
	      //Handle page load by opening in new tab
	      $('#costcoModal').show();
	      $('#costcoModal').css('display', 'block');
	    },
	
	    sameAddressValidation: function sameAddressValidation(formSelector, fieldSelector) {
	      var addressEnteredForCheck = $('#addressEnteredForCheck').val();
	      $(fieldSelector).val(addressEnteredForCheck);
	      $(fieldSelector).focus();
	      var forms = $(fieldSelector).parents('FORM');
	      var addressEnteredForCheck2 = $('#addressEnteredForCheck2');
	      if (forms.length && addressEnteredForCheck2.length) {
	        var form = $(forms[0]);
	        var address2 = addressEnteredForCheck2.val();
	        var city = $('#addressEnteredForCheckCity').val();
	        var state = $('#addressEnteredForCheckState').val();
	        var postalCode = $('#addressEnteredForCheckPostalCode').val();
	        var formFields = form.find('INPUT[type="text"]');
	        for (var i = 0; i < formFields.length; i++) {
	          var field = formFields[i];
	          if (/address2/.test(field.name)) {
	            field.value = address2;
	          } else if (/city/.test(field.name)) {
	            field.value = city;
	          } else if (/.*(zip|postal).*/.test(field.name)) {
	            field.value = postalCode;
	          }
	        }
	        formFields = form.find('SELECT');
	        for (var i = 0; i < formFields.length; i++) {
	          var field = formFields[i];
	          if (/.*(province|state).*/.test(field.name)) {
	            field.value = state;
	          }
	        }
	      }
	      $.validator.addMethod("sameAddressValidationRule", function (inputValue) {
	        return addressEnteredForCheck === inputValue ? false : true;
	      }, messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR_FIELD_VALIDATION);
	
	      $(formSelector).validate().resetForm();
	      $(formSelector).validate();
	      $(fieldSelector).rules('add', 'sameAddressValidationRule');
	      $(fieldSelector).valid();
	    },
	
	    /**
	     * Updates the modal title, body, buttons, bindings etc without closing the modal
	     * @param  {Object} settings @see COSTCO.dialog.createExtDialogBox()
	     */
	    updateModal: function updateModal(settings) {
	      dialog.showModal(settings);
	    },
	    /**
	     * [description]
	     * @return {void} [description]
	     */
	    close: function close() {
	      $('#costcoModal').modal('hide');
	      dialog.returnFocusOnPreviousElement();
	    },
	    /**
	     * [description]
	     * @return {void} [description]
	     */
	    closeAndUnbind: function closeAndUnbind() {
	      $('#costcoModal').unbind('shown.bs.modal');
	      $('#costcoModal').unbind('hidden.bs.modal');
	      $('#costcoModal').unbind('hide.bs.modal');
	      this.close();
	    },
	    /**
	     * Binds the "hidden/shown" events (ie modal is closed/opened) with some
	     * clear/show actions. Additionally you can pass a function as part
	     * of your settings object to execute custom thangs.
	     * @param  {Object} settings  The settings object that contains
	     *                            the event handlers used for various
	     *                            modal actions.
	     * @return {void}
	     */
	    bindEvents: function bindEvents(settings) {
	      $('#costcoModal').unbind('shown.bs.modal').on('shown.bs.modal', function (e) {
	        // This event is fired when the modal has been made visible to the user
	        // (will wait for CSS transitions to complete). If caused by a click,
	        // the clicked element is available as the relatedTarget property of
	        // the event.
	        if (settings.onshown) settings.onshown(e);
	        if (dialog.modalObserver.elementCausedSecondModalId && !e.target.onclick && !dialog.modalObserver.showingSecondModal) {
	          COSTCO.dialog.removeParentElementForModalObserver();
	        };
	        COSTCO.util.trapFocusInsideModal();
	      });
	      $('#costcoModal').unbind('hidden.bs.modal').on('hidden.bs.modal', function (e) {
	        if (typeof settings.dialogclasses != 'undefined') {
	          $('.modal-dialog').removeClass(settings.dialogclasses);
	        }
	        // clear and show. Execute fn if it exists
	        if (settings.onclose) settings.onclose(e);
	        $('#costcoModalTitle').empty().show();
	        if ($('#react-video-holder').length && $('#videoViewer-popup').length) $('#react-video-holder').append($('#videoViewer-popup'));
	        $('#costcoModalText').empty().show();
	        $('.costcoModalBtn1').empty().show();
	        $('#costcoModalBtn2').empty().show();
	
	        if (settings.afterclose) settings.afterclose(e);
	      });
	      $('#costcoModal').unbind('show.bs.modal').on('show.bs.modal', function (e) {
	        if (settings.onshow) settings.onshow(e);
	      });
	      $('#costcoModal').unbind('hide.bs.modal').on('hide.bs.modal', function (e) {
	        // This event is fired when the modal is going to close.
	        if (settings.onhide) settings.onhide(e);
	      });
	    },
	    /**
	     * [description]
	     * @param  {[type]} hostname [description]
	     * @return {boolean}
	     */
	    isPresentInLocalStorage: function isPresentInLocalStorage(hostname) {
	      if (JSON.stringify(COSTCO.util.getFromStorage(hostname)).indexOf(hostname) > 0) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    /**
	     * Holds previous options object used to instantiate a modal with.
	     * This is the modal stack used by modalStack function.
	     * @type {Array}
	     */
	    modalStackPreviousOptions: [],
	    /**
	     * Create a sequential stack of modals by calling this function
	     * successively.
	     *  ex.
	     *    1. COSTCO.dialog.modalStack({title:'hi', body:'robert'})
	     *      -> Invoke a hi-robert modal, pushes options to stack.
	     *    2. COSTCO.dialog.modalStack({title:'hi', body:'kurt'})
	     *      -> Closes the hi-robert modal and invokes/pushes the hi-kurt
	     *         modal to stack.
	     *    3. (Escape key, Exit Arrow, or blur)
	     *      -> Pops the currently invoked modal from the stack and
	     *         closes it. Invokes the previous modal from the stack
	     *         until the stack b gone or we call this function again.
	     * @param  {Object} options The settings object for the modal.
	     * @return {void}
	     */
	    modalStack: function modalStack(options) {
	      var stack = this.modalStackPreviousOptions;
	      options.index = stack.length + 1;
	      stack.push(options);
	      options.afterclose = function () {
	        var stack = dialog.modalStackPreviousOptions;
	        if (stack.length === this.index && stack.length !== 1) {
	          // we need to go backward
	          dialog.showAndHideModal(stack[this.index - 2]);
	          COSTCO.dialog.modalStackPreviousOptions.pop();
	        } else if (stack.length > this.index) {
	          dialog.showAndHideModal(stack[this.index]);
	        } else {
	          COSTCO.dialog.clearStack();
	        }
	      }.bind(options);
	      if (stack.length === 1) {
	        this.showAndHideModal(options);
	      } else {
	        this.close();
	      }
	    },
	
	    /**
	     * set radio buttons attributes
	     */
	    setRadioButtonsAttributes: function setRadioButtonsAttributes(activeElement, passiveElement) {
	      activeElement.addClass('active').attr('aria-checked', true).find('div').removeClass('hide');
	      passiveElement.removeClass('active').attr('aria-checked', false).find('input').removeAttr('checked');
	      passiveElement.find('div').addClass('hide');
	    },
	
	    /**
	     * Clears the modal stack.
	     * @return {void} [description]
	     */
	    clearStack: function clearStack() {
	      this.modalStackPreviousOptions = [];
	    },
	    /*
	     * Listener for opening/closing modals 
	     * to help with returning focus to original 
	     * element or input 
	     */
	    initializeReturnFocusListener: function initializeReturnFocusListener() {
	      $(document).on('hidden.bs.modal', '#costcoModal', function (e) {
	        dialog.returnFocusOnPreviousElement();
	      });
	      $(document).on('shown.bs.modal', '#costcoModal', function (e) {
	        dialog.returnFocusOnInput();
	      });
	    },
	    /*
	     * This function utilizes the triggerEvent variable
	     * to return focus on elements 
	     */
	    returnFocusOnPreviousElement: function returnFocusOnPreviousElement() {
	      var previousElement = null;
	      if (dialog.triggerEvent != null) {
	        previousElement = dialog.triggerEvent.srcElement;
	      } else if (dialog.triggerEvent == null && COSTCO.timeoutModal != null && COSTCO.timeoutModal.lastActiveElement != null) {
	        previousElement = COSTCO.timeoutModal.lastActiveElement;
	      } else {
	        previousElement = $('body');
	      }
	      $(previousElement).focus();
	    },
	
	    /*
	     * This function's use case is to return 
	     * focus to the element within a modal
	     */
	    returnFocusOnInput: function returnFocusOnInput() {
	      var previousElement = null;
	      if (COSTCO.timeoutModal != null && COSTCO.timeoutModal.lastActiveElement != null && dialog.dialogSettings.title !== messages.TIMEOUT_MODAL_HEADER) {
	        previousElement = COSTCO.timeoutModal.lastActiveElement;
	        COSTCO.timeoutModal.lastActiveElement = null;
	      }
	      $(previousElement).focus();
	    },
	
	    /*
	     * This function captures 
	     */
	    triggerEventUtil: function triggerEventUtil() {
	      if (window.event !== undefined) {
	        if (dialog.getSettings() != null && dialog.getSettings().title === messages.BD_QUESTIONNAIRE_TITLE) {
	          return;
	        } else if (dialog.getSettings() != null && dialog.getSettings().title === messages.TIMEOUT_MODAL_HEADER) {
	          return;
	        } else {
	          dialog.triggerEvent = window.event;
	        }
	      }
	    },
	    /*
	     * returns the current dialog's settings
	     */
	    getSettings: function getSettings() {
	      return dialog.dialogSettings;
	    },
	    /*
	     * Captures data upon opening a modal
	     * to grab the event and copy settings
	     */
	    captureDataBeforeShowingModal: function captureDataBeforeShowingModal(settings) {
	      dialog.triggerEventUtil();
	      dialog.dialogSettings = settings;
	    }
	
	  }; // end costcoDialog object
	  // Expose costcoDialog to the global scope.
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.dialog = dialog;
	  return dialog;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title addressVerification.js: Feature level module
	 * @description Address verification module
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14), __webpack_require__(18)], __WEBPACK_AMD_DEFINE_RESULT__ = function (address, addressDisplay) {
	  var CAddressVerification = {
	    entered: '',
	    suggested: '',
	    buildAddressVerificationModal: function buildAddressVerificationModal(entered, suggested, result) {
	      var verificationModal = $($('#tmpl_address_verification').html());
	      // Need to create a temp object for extending through jQuery
	      var tempEntered = JSON.parse(JSON.stringify(entered));
	      var extendedSuggest = $.extend(tempEntered, suggested);
	      if (result === 'ADDRESS_WRONG_NO_SUGGESTION') {
	        var enteredHtml = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_address_display_verification');
	        $(verificationModal).find('#entered-address .address').append(enteredHtml);
	        $(verificationModal).find('#entered-address input').attr('tabindex', '-1');
	        $(verificationModal).find('[role="radio"]').attr("aria-labelledby", "orderAddrVerfication_" + entered.id);
	        $(verificationModal).find('#suggested-address').hide();
	        $(verificationModal).find('#no-match').show();
	        $(verificationModal).find('#address-verify-warningInfo-header').hide();
	        $(verificationModal).find('#address-verify-warningInfo-header-no-match').show();
	        COSTCO.CAddressVerification.entered = entered;
	      } else {
	        var _enteredHtml = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_address_display_verification');
	        $(verificationModal).find('#entered-address .address').append(_enteredHtml);
	        $(verificationModal).find('#entered-address input').attr('tabindex', '-1');
	        $(verificationModal).find('[role="radio"]').attr("aria-labelledby", "orderAddrVerfication_" + entered.id);
	        var suggestedHtml = addressDisplay.createAddressVerificationDisplay(extendedSuggest, 'tmpl_address_display_verification');
	        $(verificationModal).find('#suggested-address .address').append(suggestedHtml);
	        $(verificationModal).find('#suggested-address input').attr('checked', 'true');
	        $(verificationModal).find('#suggested-address input').parent().attr('aria-checked', 'true');
	        $(verificationModal).find('#suggested-address input').attr('tabindex', '-1');
	        if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore()) {
	          if (!COSTCO.util.isNdEnabled() && "N" == suggested.isCommercial) {
	            $(verificationModal).find('#address-modal-notification').text(messages.MODAL_ADDRESS_RESIDENTIAL_WARNING);
	          }
	        }
	        COSTCO.CAddressVerification.entered = entered;
	        COSTCO.CAddressVerification.suggested = extendedSuggest;
	      }
	      return verificationModal;
	    },
	    showAddressVerificationModal: function showAddressVerificationModal(addressObj, preventhtmlajax, addressOptions) {
	      var suggested = addressObj.Validated_Address[0];
	      var entered = addressObj.Address[0];
	      var result = suggested.result;
	      var modalBody = CAddressVerification.buildAddressVerificationModal(entered, suggested, result);
	      var primaryDisabled = result === 'ADDRESS_WRONG_NO_SUGGESTION';
	      $('.order-ajax').removeClass('ajax-busy');
	      if (typeof addressOptions.primaryEventCallback === 'undefined') {
	        addressOptions.primaryEventCallback = CAddressVerification.useAddressCallback;
	      }
	      if (addressOptions.isModalStack) {
	        var labels = address.getHeaderLabels('S', 'verify');
	        COSTCO.dialog.modalStack({
	          title: labels.modalTitle,
	          body: modalBody,
	          primary_event: function primary_event() {
	            addressOptions.primaryEventCallback(preventhtmlajax, addressOptions);
	          },
	          primaryDisabled: primaryDisabled,
	          primary: labels.primaryButton,
	          secondary: messages.JS_DIALOG_CANCEL
	        });
	      } else {
	        address.baseModal(addressOptions.successCallback.arguments[1], 'verify', {
	          body: modalBody,
	          primary_event: function primary_event() {
	            addressOptions.primaryEventCallback(preventhtmlajax, addressOptions);
	          },
	          primaryDisabled: primaryDisabled
	        });
	      }
	    },
	    buildMultiAddressVerificationModal: function buildMultiAddressVerificationModal(addressObj) {
	      var verificationModal = $($('#tmpl_multi_address_verification').html());
	
	      // Iterate through each address in the Address array
	      $.each(addressObj.Address, function (index, entered) {
	        // Add the total number of addresses for display purposes
	        entered.numOfAddresses = addressObj.Address.length;
	
	        // Find the matching validated address, if any
	        var suggested = CAddressVerification.matchValidatedAddress(entered.id, addressObj.Validated_Address);
	
	        var verificationLineBlockHtml = '';
	
	        if (suggested && !suggested.result.includes('NO_SUGGESTION')) {
	          // Handle cases where a valid suggestion exists
	          var tempEntered = JSON.parse(JSON.stringify(entered));
	          var extendedSuggest = $.extend(tempEntered, suggested);
	
	          var enteredHtml = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_multi_address_verification_display_addr_element');
	
	          verificationLineBlockHtml = $(COSTCO.util.tmpl('tmpl_multi_address_verification_line_block', entered));
	          $(verificationLineBlockHtml).find('.entered-address .address').append(enteredHtml);
	
	          var suggestedHtml = addressDisplay.createAddressVerificationDisplay(extendedSuggest, 'tmpl_multi_address_verification_display_addr_element');
	          $(verificationLineBlockHtml).find('.suggested-address .address').append(suggestedHtml);
	          $(verificationLineBlockHtml).find('.suggested-address input').attr('checked', 'checked');
	        } else {
	          // Handle cases where the result is 'NO_SUGGESTION' or no validated address is found
	          console.warn('No valid suggestion found for address ID: ' + entered.id + '. Using entered address values.');
	
	          var _enteredHtml2 = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_multi_address_verification_display_addr_element');
	
	          verificationLineBlockHtml = $(COSTCO.util.tmpl('tmpl_multi_address_verification_line_block', entered));
	          $(verificationLineBlockHtml).find('.entered-address .address').append(_enteredHtml2);
	          $(verificationLineBlockHtml).find('.entered-address input').attr('tabindex', '-1');
	          $(verificationLineBlockHtml).find('.entered-address input').attr('checked', 'checked');
	          $(verificationLineBlockHtml).find('.suggested-address input').hide();
	          $(verificationLineBlockHtml).find('.no-match').show();
	        }
	
	        // Append the verification block to the modal
	        $(verificationModal).find('#address-verify-form').append(verificationLineBlockHtml);
	      });
	
	      return verificationModal;
	    },
	    showMultiAddressVerificationModal: function showMultiAddressVerificationModal(addressObj, callback) {
	      var modalBody = CAddressVerification.buildMultiAddressVerificationModal(addressObj);
	      COSTCO.dialog.modalStack({
	        title: addressLabels.verify.modalTitle,
	        body: modalBody,
	        primary: addressLabels.verify.primaryButton,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          $('.permanent-ajax-busy').addClass('ajax-busy');
	          // create final address array and pass it to callback
	          var selectedInputs = $(modalBody).find('input[name^=verify]:checked');
	          var finalAddressArray = [];
	          $.each(selectedInputs, function (index, value) {
	            var action = $(value).val();
	            var addressId = $(value).attr('data-id');
	            if (action === 'suggested') {
	              finalAddressArray.push(CAddressVerification.findAddressById(addressId, addressObj.Validated_Address));
	            } else {
	              finalAddressArray.push(CAddressVerification.findAddressById(addressId, addressObj.Address));
	            }
	          });
	          COSTCO.dialog.clearStack();
	          COSTCO.dialog.close();
	          if (callback) callback(finalAddressArray);
	          // addressOptions.primaryEventCallback(preventhtmlajax, addressOptions, finalAddressArray);
	        }
	      });
	    },
	    /**
	     * Callback function for addressForm, used for primaryEventCallback
	     * @param  {[type]} preventhtmlajax [description]
	     * @param  {[type]} addressOptions  [description]
	     * @return {void}                 [description]
	     */
	    useAddressCallback: function useAddressCallback(preventhtmlajax, addressOptions) {
	      COSTCO.CAddressVerification.useAddress(preventhtmlajax, addressOptions);
	    },
	    setAddressEnteredForCheck: function setAddressEnteredForCheck(address) {
	      var parentEl = document.body;
	      var address1 = $('#addressEnteredForCheck');
	      if (address1.length) {
	        parentEl = address1.parent().get(0);
	      } else {
	        address1 = $('<INPUT TYPE="hidden" ID="addressEnteredForCheck" />').appendTo(parentEl);
	      }
	      var address2 = $('#addressEnteredForCheck2');
	      if (!address2.length) {
	        address2 = $('<INPUT TYPE="hidden" ID="addressEnteredForCheck2" />').appendTo(parentEl);
	      }
	      var city = $('#addressEnteredForCheckCity');
	      if (!city.length) {
	        city = $('<INPUT TYPE="hidden" ID="addressEnteredForCheckCity" />').appendTo(parentEl);
	      }
	      var state = $('#addressEnteredForCheckState');
	      if (!state.length) {
	        state = $('<INPUT TYPE="hidden" ID="addressEnteredForCheckState" />').appendTo(parentEl);
	      }
	      var postalCode = $('#addressEnteredForCheckPostalCode');
	      if (!postalCode.length) {
	        postalCode = $('<INPUT TYPE="hidden" ID="addressEnteredForCheckPostalCode" />').appendTo(parentEl);
	      }
	      address1.val(address.line1);
	      address2.val(address.line2);
	      city.val(address.city);
	      state.val(address.state);
	      postalCode.val(address.zip);
	    },
	    useAddress: function useAddress(preventhtmlajax, addressOptions, action) {
	      var verifiedAddress;
	      var message = action;
	      if ($('input[name=verify]:checked').val() != undefined) {
	        action = $('input[name=verify]:checked').val();
	      }
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      if (action == 'suggested') {
	        verifiedAddress = COSTCO.CAddressVerification.suggested;
	        digitalDataEvents.push({ ui: "Address Verification Modal | Use Address |  Suggested  Address" });
	      } else {
	        verifiedAddress = COSTCO.CAddressVerification.entered;
	        digitalDataEvents.push({ ui: "Address Verification Modal | Use Address | Entered Address" });
	        // SFSTRY0039755 - Limit zip code editing to US only
	        if (COSTCO.util.isUSStore()) {
	          // SFSTRY0034758 - Use 9 digit zip code if AddressDoctor suggestion matches address
	          if (COSTCO.CAddressVerification.suggested !== 'undefined' && COSTCO.CAddressVerification.suggested !== '') {
	            if (COSTCO.CAddressVerification.suggested.zip.substring(0, 5) === COSTCO.CAddressVerification.entered.zip.substring(0, 5)) {
	              verifiedAddress.zip = COSTCO.CAddressVerification.suggested.zip;
	            }
	          }
	        }
	        //Save suggested isCommercial(RDI) flag if available, even if user selects entered address:
	        if ($('input[name=verify]:checked').val() != undefined) {
	          verifiedAddress.isCommercial = COSTCO.CAddressVerification.suggested.isCommercial;
	        }
	      }
	      COSTCO.CAddressVerification.suggested = '';
	      COSTCO.CAddressVerification.setAddressEnteredForCheck(verifiedAddress);
	      address.addEditAddress(verifiedAddress, preventhtmlajax, addressOptions, message);
	    },
	    handleRadioButtonClick: function handleRadioButtonClick(element) {
	      var passiveElementParent = $(element).parent().attr('id') === "suggested-address" ? $('#entered-address') : $('#suggested-address');
	      COSTCO.CAddressVerification.setRadioAttributes($(element), passiveElementParent);
	      $('#costcoModalBtn2').removeClass('btn-disabled');
	    },
	    addressVerification: function addressVerification(addressArray, type, preventajaxhtml, addressOptions) {
	      $('.order-ajax').addClass('ajax-busy');
	      var _dataType = 'json';
	      var _data = {};
	      _data['formdata'] = encodeURIComponent(JSON.stringify(addressArray));
	      $.ajax({
	        url: '/AjaxAddressVerificationCmd',
	        type: 'POST',
	        dataType: _dataType,
	        data: _data,
	        timeout: 15000
	      }).done(function (addressObj) {
	        addressOptions.successCallback(addressObj, type, preventajaxhtml, addressOptions);
	      }).fail(function (addressObj) {
	        // Timeout or error sets verifiedAddress to inputted array
	        // Error Calling Verification Service
	        console.log('Verification Address : ' + JSON.stringify(addressObj));
	      }).always(function () {
	        $('.order-ajax').removeClass('ajax-busy');
	      });
	    },
	    extractValidatedAddress: function extractValidatedAddress(addressObj, type) {
	      console.log('Extracting Validated Address : ' + JSON.stringify(addressObj));
	      var suggested = addressObj.Validated_Address[0];
	      var entered = addressObj.Address[0];
	      suggested.fName = entered.fName;
	      suggested.lName = entered.lName;
	      suggested.company = entered.company;
	      suggested.pNumber = entered.pNumber;
	      suggested.ext1 = entered.ext1;
	      suggested.nickname = entered.nickname;
	      suggested.saveAddress = entered.saveAddress;
	      suggested.setDefault = entered.setDefault;
	      suggested.addressType = type;
	      suggested.addressType2 = entered.addressType2;
	      suggested.mInitial = entered.mInitial;
	      suggested.email = entered.email;
	      suggested.deliveryInst = entered.deliveryInst;
	      suggested.contactName = entered.contactName;
	      suggested.contactPhNo = entered.contactPhNo;
	      return suggested;
	    },
	    isSuggestedSameAsEntered: function isSuggestedSameAsEntered(addressObj) {
	      // web service down or service reports address suggestion for correctly entered address
	      var suggested = addressObj && addressObj.Validated_Address && addressObj.Validated_Address[0] || {};
	      var entered = addressObj && addressObj.Address && addressObj.Address[0] || {};
	
	      // If service signals a "no suggestion" case or missing result, treat as not same
	      if (!suggested.result || suggested.result === 'ADDRESS_WRONG_NO_SUGGESTION') {
	        return false;
	      }
	
	      var norm = function norm(n) {
	        return (n || '').toString().trim().toUpperCase();
	      }; //Converts any value (including undefined/null) into a trimmed, uppercase string.
	      var zip5 = function zip5(z) {
	        return (z || '').toString().substring(0, 5);
	      }; //Safely returns the first five characters of a ZIP/postal code.
	
	      var isSameAddress = norm(suggested.line1) === norm(entered.line1) && norm(suggested.line2) === norm(entered.line2) && norm(suggested.city) === norm(entered.city) && (suggested.state || '') === (entered.state || '') && zip5(suggested.zip) === zip5(entered.zip) && (suggested.country || '') === (entered.country || '');
	
	      return isSameAddress;
	    },
	    /**
	     * Builds one element of the AVS request object array
	     * @param  {Object} form jquery form object which contains fields of address to be verified
	     * @param  {Object} selectors JSON object containing selectors that should be used in the form to get data from form to build request
	     * @return {Object} One element of the array to be passed to AVS service
	     */
	    buildRequestElement: function buildRequestElement(form, selectors) {
	      var addressObject = {
	        id: $(form).find(selectors.id).val() ? $(form).find(selectors.id).val() : '',
	        label: $(form).find(selectors.label).val() || $(form).find(selectors.label).text(),
	        line1: $(form).find(selectors.line1).val(),
	        line2: $(form).find(selectors.line2).val(),
	        line3: $(form).find(selectors.line3).val(),
	        city: $(form).find(selectors.city).val(),
	        state: $(form).find(selectors.state).val(),
	        country: $(form).find(selectors.country).val(),
	        zip: $(form).find(selectors.zip).val(),
	        fName: $(form).find(selectors.fName).length > 0 ? $(form).find(selectors.fName).val() : '',
	        lName: $(form).find(selectors.lName).length > 0 ? $(form).find(selectors.lName).val() : ''
	      };
	      return addressObject;
	    },
	    /**
	     * Match validated address with entered address by label.
	     * @param {String} label Label of the entered address
	     * @param {Array} validatedAddresses Array or validated addresses returned by AVS
	     * @return matched address by label
	     */
	    matchValidatedAddress: function matchValidatedAddress(id, validatedAddresses) {
	      if (!validatedAddresses || !validatedAddresses.length) return null;
	
	      // strict id match first
	      var match = validatedAddresses.find(function (v) {
	        return String(v.id || '') === String(id || '');
	      });
	      if (match) return match;
	
	      // fallback: if id is blank or numeric, use index
	      var idx = id === '' || id == null ? 0 : Number(id);
	      if (!Number.isNaN(idx) && validatedAddresses[idx]) {
	        return validatedAddresses[idx];
	      }
	      return null;
	    },
	    /**
	     * Iterate through input address array and match address by id param.
	     * @param {String} id id of the address to be matched
	     * @param {Array} addresses Array of addresses in which we need to find one by id
	     * @return {Object} Matched address
	     */
	    findAddressById: function findAddressById(id, addresses) {
	      var matchedAddress = {};
	      $.each(addresses, function (index, value) {
	        if (value.id == id) {
	          matchedAddress = addresses[index];
	          return false;
	        }
	      });
	      return matchedAddress;
	    },
	    /**
	     * Takes an array of verified addresses and determines if any of them
	     * have returned with a result of 'NO_SUGGESTION'.
	     * @param  {Array} addresses The array of addresses to check.
	     * @return {boolean}
	     */
	    hasAnyNoSuggestion: function hasAnyNoSuggestion(addresses) {
	      return COSTCO.util.any(addresses, function (address) {
	        return address.result.includes('NO_SUGGESTION');
	      });
	    },
	    /**
	     * Takes an array of verified addresses and determines if all of them have
	     * returned with a result of 'NO_SUGGESTION'.
	     * @param  {Array} addresses The array of addresses to check.
	     * @return {boolean}
	     */
	    hasAllNoSuggestion: function hasAllNoSuggestion(addresses) {
	      return COSTCO.util.all(addresses, function (address) {
	        return address.result.includes('NO_SUGGESTION');
	      });
	    },
	    /**
	     * Takes an address object returned from the address verification service
	     * and determines if all of the entered addresses match all of the suggested
	     * addresses.
	     * @param  {Object} addressObj The address object returned from AV
	     * @return {boolean}           Are all entered == suggested?
	     */
	    hasAllSameAsSuggested: function hasAllSameAsSuggested(addressObj) {
	      var result = true;
	      for (var i = 0; i < addressObj.Address.length; i++) {
	        // To reuse isSuggestedSameAsEntered, need this data structure.
	        // This assumes we always have 1:1 entered:validated in the addressObj
	        var tempObj = {
	          Address: [addressObj.Address[i]],
	          // ensure we have the matching validated address
	          Validated_Address: [this.findAddressById(addressObj.Address[i].id, addressObj.Validated_Address)]
	        };
	        if (this.isSuggestedSameAsEntered(tempObj)) {
	          continue;
	        } else {
	          result = false;
	          break;
	        }
	      }
	      return result;
	    },
	    /**
	     * Displays the new Adress Type modal so that the user sets the address type (if in BD Truck zone)
	     * @param  {String}    form - submitted form element
	    */
	    viewAddressTypeModal: function viewAddressTypeModal(preventhtmlajax, addressOptions, message, data) {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.DELIVERY_OPTIONS,
	        body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
	        primary: messages.SET_DELIVERY_METHOD,
	        popover: true,
	        dialogclasses: 'nd-delivery-method-dialog',
	        onshow: function onshow() {
	          $('#delivery_address_modal_form').append($('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset'));
	          $('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset').remove();
	          //			$('.nd-delivery-method-dialog #costcoModalBtn2').attr("data-bi-tc", "ui:Browse | Choose Delivery Method | Set Delivery Method")
	        },
	        onclose: function onclose() {
	          //			$(document).unbind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
	          $('#nd-zipcode-method-modal-body').append($('#delivery_address_modal_form #nd-zipcode-method-fieldset'));
	          $('#delivery_address_modal_form #nd-zipcode-method-fieldset').remove();
	        },
	        primary_event: function primary_event() {
	          if (document.querySelector('input[name="nd-radio-group-input"]:checked') == null) {
	            $('.addresstype-setup-notification').removeClass("hidden");
	            $('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
	          } else {
	            if (message == "suggested") {
	              COSTCO.CAddressVerification.suggested.showAddressTypePopup = false;
	            } else if (data != undefined) {
	              data.showAddressTypePopup = false;
	            } else {
	              COSTCO.CAddressVerification.entered.showAddressTypePopup = false;
	            }
	            COSTCO.CAddressVerification.useAddress(preventhtmlajax, addressOptions, message);
	          }
	        }
	      });
	      $('.close').addClass("hidden");
	    },
	    validateShowAddressTypeModal: function validateShowAddressTypeModal(verifiedAddress, addressOptions) {
	      return verifiedAddress.showAddressTypePopup == "true" && (addressOptions.addressBookReinit == undefined || addressOptions.addressBookReinit == false) && verifiedAddress.addressType == 'S' && (addressOptions.validateParams == undefined || addressOptions.validateParams != undefined && (verifiedAddress.line1 != addressOptions.validateParams[0] || verifiedAddress.zip != addressOptions.validateParams[1] || verifiedAddress.city != addressOptions.validateParams[2]));
	    },
	    handleRadioButtonEnterKey: function handleRadioButtonEnterKey(element) {
	      if (event.keyCode === 13) {
	        $(element).parent().siblings().find('input').get(0).removeAttribute('checked');
	        $(element).parent().siblings().find('div:first').get(0).removeAttribute('aria-checked');
	        $(element).children().get(0).setAttribute('checked', 'true');
	        $(element).get(0).setAttribute('aria-checked', 'true');
	        $('#costcoModalBtn2').removeClass('btn-disabled');
	      }
	    },
	    handleRadioButtonSpaceKey: function handleRadioButtonSpaceKey(element) {
	      if (event.keyCode === 32) {
	        element.click();
	        $('#costcoModalBtn2').removeClass('btn-disabled');
	      }
	    },
	
	    setRadioAttributes: function setRadioAttributes(activeElement, passiveElementParent) {
	      var passiveInput = passiveElementParent.find('input').get(0);
	      if (typeof passiveInput !== 'undefined') {
	        passiveInput.removeAttribute('checked');
	      }
	
	      var passiveLabel = passiveElementParent.find('label').get(0);
	      if (typeof passiveLabel !== 'undefined') {
	        passiveLabel.removeAttribute('aria-checked');
	      }
	
	      // set attr checked on input
	      var activeInput = activeElement.find('input').get(0);
	      if (typeof activeInput !== 'undefined') {
	        activeInput.setAttribute('checked', 'true');
	      }
	
	      // set attr aria-checked on label
	      var activeElem = activeElement.get(0);
	      if (typeof activeElem !== 'undefined') {
	        activeElem.setAttribute('aria-checked', 'true');
	      }
	    },
	    /**
	    * Displays the new Delivery Method modal so that the user sets the delivery method
	    * @param  {String}    form - submitted form element
	    */
	    viewDeliveryMethodModal: function viewDeliveryMethodModal(form, data, params, oldAddy, newAddy) {
	      var showQuestionnaireModal = false;
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.DELIVERY_OPTIONS,
	        body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
	        primary: messages.SET_DELIVERY_METHOD,
	        popover: true,
	        dialogclasses: 'nd-delivery-method-dialog',
	        onshow: function onshow() {
	          $('#delivery_address_modal_form').append($('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset'));
	          $('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset').remove();
	          $('.nd-delivery-method-dialog #costcoModalBtn2').attr("data-bi-tc", "ui:Checkout | Choose Delivery Method | Set Delivery Method");
	          $('.addresstype-setup-notification').addClass("hidden");
	          $('.addresstype-setup-notification').find("div").html('');
	
	          if (data.isBDTruckZoneEnabledForWareHouse === true) {
	            $("#nd-local-delivery-modal-section").removeClass("hidden");
	          } else {
	            $("#nd-local-delivery-modal-section").addClass("hidden");
	          }
	
	          if (data.isNationalDeliveryEnabledForWareHouse === true) {
	            $("#nd-nationwide-delivery-modal-section").removeClass("hidden");
	          } else {
	            $("#nd-nationwide-delivery-modal-section").addClass("hidden");
	          }
	
	          if (data.isStorePickupEnabledForWareHouse === true) {
	            $("#store-pickup-modal-section").removeClass("hidden");
	          } else {
	            $("#store-pickup-modal-section").addClass("hidden");
	          }
	
	          $('#nd-local-delivery-radio-button').focus();
	        },
	        onclose: function onclose() {
	          $(document).unbind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
	          if ($('#nd-zipcode-method-modal-body').children('fieldset').length == 0) {
	            $('#nd-zipcode-method-modal-body').append($('#delivery_address_modal_form #nd-zipcode-method-fieldset'));
	          }
	          $('#delivery_address_modal_form #nd-zipcode-method-fieldset').remove();
	        },
	        primary_event: function primary_event() {
	          if (document.querySelector('input[name="nd-radio-group-input"]:checked') == null) {
	            $('.addresstype-setup-notification').removeClass("hidden");
	            $('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
	
	            var isFocusSet = false;
	            if (data.isBDTruckZoneEnabledForWareHouse === true) {
	              $('#nd-local-delivery-radio-button').focus();
	              isFocusSet = true;
	            }
	
	            if (data.isNationalDeliveryEnabledForWareHouse === true && isFocusSet == false) {
	              $('#nd-nationwide-delivery-radio-button').focus();
	              isFocusSet = true;
	            }
	
	            if (data.isStorePickupEnabledForWareHouse === true && isFocusSet == false) {
	              $('#store-pickup-radio-button').focus();
	            }
	          } else {
	            var deliveryMehod;
	            if ($('input[name="deliveryMethod"]').length > 0) {
	              deliveryMethod = $("input[name='deliveryMethod']:checked").val();
	            }
	            var selectedDeliveryMethod = 'Local';
	            if (document.querySelector('input[name="nd-radio-group-input"]:checked') != null) {
	              var uiSelectedDeliveryMethod = document.querySelector('input[name="nd-radio-group-input"]:checked').value;
	              switch (uiSelectedDeliveryMethod) {
	                case "C":
	                  selectedDeliveryMethod = "Local";
	                  break;
	                case "R":
	                  selectedDeliveryMethod = "Nationwide";
	                  break;
	                case "P":
	                  selectedDeliveryMethod = "Store-Pick-Up";
	                  break;
	              }
	              $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val(selectedDeliveryMethod);
	            }
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            if (selectedDeliveryMethod === 'Local') {
	              digitalDataEvents.push({
	                browseDeliveryMethod: "Local Business Delivery"
	              });
	            } else if (selectedDeliveryMethod === 'Nationwide') {
	              digitalDataEvents.push({
	                browseDeliveryMethod: "Nationwide Delivery"
	              });
	            }
	            data.userSelectionDeliveryMethod = selectedDeliveryMethod;
	            if (oldAddy == null) {
	              //add address flow
	              COSTCO.CAddress.callAddressAddNew(params[2], params[3], newAddy, params[4], data);
	            } else {
	              COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, newAddy, data);
	            }
	          }
	          var espot = $('#delivery_address_modal_form #nd-zipcode-method-fieldset').clone();
	          $('#nd-zipcode-method-modal-body').html(espot);
	        }
	      });
	      $('.close').addClass("hidden");
	    }
	
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.CAddressVerification = CAddressVerification;
	  return CAddressVerification;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title checkout_helper.js: Feature level module
	 * @description Utility module associated with checkout
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function (address) {
	  var CAddressDisplay = {
	    createAddressDisplay: function createAddressDisplay(obj, type) {
	      var data = CAddressDisplay.buildAddressJson(obj);
	      if (obj.phone) {
	        obj.phone = COSTCO.util.formatPhone(obj.phone);
	      }
	
	      return COSTCO.util.tmpl('tmpl_address_display', obj);
	    },
	    createAddressVerificationDisplay: function createAddressVerificationDisplay(obj, template) {
	      var data = CAddressDisplay.buildAddressJson(obj);
	      if (template == null || template == '' || typeof template === 'undefined') {
	        //set default template if template is not passed in the argument
	        template = 'tmpl_address_display_verification';
	      }
	      return COSTCO.util.tmpl(template, obj);
	    },
	    buildAddressJson: function buildAddressJson(obj) {
	      var data;
	      if (typeof obj === 'number') {
	        var addressJson = address.getAddressJson(obj)[0];
	        if (addressJson.length == 0) return '';
	        data = addressJson[0];
	      } else {
	        data = obj;
	      }
	      return data;
	    }
	  };
	  if (typeof window.COSTCO === "undefined") {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.CAddressDisplay = CAddressDisplay;
	  return CAddressDisplay;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title member-verification.js: Sub-module of Account feature
	 * @description This module provides membership verification functionality.
	 * @dependency utility.js, costcodialog.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var MemberVerification = {
	
	    init: function init() {
	      this.validationRules();
	      this.maskDateInput();
	    },
	
	    membershipNumber: null,
	
	    getForm: function getForm() {
	      return $('#MemberVerificationForm');
	    },
	
	    validateNumberForm: function validateNumberForm() {
	      MemberVerification.getForm().validate({
	        rules: {
	          membershipNumberToVerify: {
	            required: true,
	            membershipNumber: true
	          }
	        },
	        messages: {
	          membershipNumberToVerify: {
	            required: messages.ERR_INVALID_MEMBERSHIP_NO,
	            membershipNumber: messages.ERR_INVALID_MEMBERSHIP_NO
	          }
	        },
	        invalidHandler: function invalidHandler(event, validator) {
	          var errors = validator.numberOfInvalids();
	          if (errors) {
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter Valid Membership Number Error" });
	          }
	        }
	      });
	
	      return MemberVerification.getForm().valid();
	    },
	
	    maskDateInput: function maskDateInput() {
	      $('#employeeStartDate').mask('00/00', {
	        placeholder: 'MM/YY'
	      });
	    },
	
	    validateZipCodeForm: function validateZipCodeForm() {
	      var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : COSTCO.MemberVerification.getForm();
	
	      form.validate({
	        rules: {
	          questionLastName: {
	            required: true
	          },
	          questionZip: {
	            'required': true,
	            'postalcode': true
	          }
	        },
	        messages: {
	          questionLastName: messages.ERR_INVALID_LASTNAME,
	          questionZip: messages.ERR_ENTER_ZIPCODE
	        },
	        invalidHandler: function invalidHandler(event, validator) {
	          var errors = validator.numberOfInvalids();
	          if (errors) {
	            for (var i = 0; i < errors; i++) {
	              COSTCO.MemberVerification.fireAnalyticsEventLastNameOrZipCodeError(validator.errorList[i].element);
	            }
	          }
	        }
	      });
	
	      return form.valid();
	    },
	
	    fireAnalyticsEventLastNameOrZipCodeError: function fireAnalyticsEventLastNameOrZipCodeError(element) {
	      var test = $(element).is("input[name='questionLastName']");
	      if (test) {
	        digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter Your Last Name Error" });
	      } else {
	        digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter a Valid Zip Code Error" });
	      }
	    },
	
	    validationRules: function validationRules() {
	      $.validator.addMethod('membershipNumber', function (value, element) {
	        // costco pins are 12 digits
	        return this.optional(element) || /^\d{12,16}$/.test(value);
	      }, messages.MEMBERVERIFICATION_MEMBERSHIP__InvalidMembershipNumber);
	
	      $.validator.addMethod('postalcode', function (value, element) {
	        return this.optional(element) || /^(\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1})$/.test($.trim(value));
	      }, messages.ERR_ENTER_ZIPCODE);
	    },
	    /**
	     * Submits request for membership verification steps
	     * @param  {String} urlWithParams Service URL with query string parameters appended
	     * @return {jQuery.Deferred}      The deferred object
	     */
	    submitRequest: function submitRequest(urlWithParams) {
	      return COSTCO.util.ajax({
	        type: 'POST',
	        url: urlWithParams,
	        dataType: 'json'
	      })
	      // This returns a chainable promise.
	      .then(function (data) {
	        if (data && data.CRM_ERROR_FRAMEWORK) {
	          var errorTmpl = isDmcPage ? 'tmpl_membership_dmc_verify_err_service_error' : 'tmpl_membership_verify_err_service_error';
	          var errorTmplData = {
	            membershipNumber: MemberVerification.membershipNumber
	          };
	
	          switch (data.CRM_ERROR_FRAMEWORK) {
	
	            case 'ERROR_EXCEEDED_MAX_AUTH_ATTEMPTS':
	              if (isDmcPage) {
	                errorTmpl = 'tmpl_membership_dmc_verify_err_max_retries_reached';
	              } else {
	                errorTmpl = 'tmpl_membership_verify_err_max_retries_reached';
	              }
	              break;
	
	            case 'ERROR_ONLINE_VERIFY_US':
	              errorTmpl = 'tmpl_membership_verify_err_service_error_us';
	              break;
	
	            case 'ERROR_PRESCREEN_ATTEMPT_FAILED':
	              switch (data.CRM_MEMBER_TYPE) {
	                case 'E':
	                  errorTmpl = 'tmpl_membership_verify_err_employee_membership';
	                  break;
	
	                case 'T':
	                  errorTmpl = 'tmpl_membership_verify_err_trial_membership';
	                  break;
	
	                case 'X':
	                  errorTmpl = 'tmpl_membership_verify_err_inactive_membership';
	                  break;
	
	                default:
	                  errorTmpl = 'tmpl_membership_verify_err_try_again';
	              }
	
	          }
	
	          MemberVerification.doAnalytics(errorTmpl);
	
	          return $.Deferred().reject(errorTmpl, errorTmplData);
	        }
	
	        return $.Deferred().resolve(data);
	      }).fail(function (errorTmpl, errorTmplData) {
	        if (errorTmpl) {
	          MemberVerification.displayErrorInModal(errorTmpl, errorTmplData);
	        }
	      });
	    },
	
	    doAnalytics: function doAnalytics(errorTmpl) {
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      switch (errorTmpl) {
	        case 'tmpl_membership_verify_err_service_error':
	          digitalDataEvents.push({ ui: "Member Verification Flow | Not Able to Verify Error" });
	          break;
	        case 'tmpl_membership_verify_err_try_again':
	          digitalDataEvents.push({ ui: "My Account | Membership | Verify Membership | No Match" });
	          break;
	        case 'tmpl_membership_verify_err_max_retries_reached':
	          digitalDataEvents.push({ uimsg: "Member Verification Flow | Exceeded Number of Attempts Error" });
	          break;
	        case 'tmpl_membership_verify_err_service_error_us':
	          digitalDataEvents.push({ uimsg: "My Account | Membership | Verify Membership | Unsuccessful" });
	          break;
	      }
	    },
	    /**
	     * Invalidates session on backend for membership verification process
	     */
	    invalidateSession: function invalidateSession() {
	      var url = MemberVerification.makeVerificationUrl({
	        membershipNumber: MemberVerification.membershipNumber,
	        invalidSession: true
	      });
	
	      MemberVerification.submitRequest(url);
	    },
	    /**
	     * Makes URL with string params for membership account verification services
	     * @param  {Object} params  JSON obj with params to be put in URL as a query string e.g. {membershipNumber: 4444333322221111, invalidSession: true}
	     * @return {String}         URL for membership account verification services with query string paramaters
	     *                          e.g. /AjaxMembershipAccountVerificationCmd?membershipNumber=4444333322221111&invalidSession=true
	     */
	    makeVerificationUrl: function makeVerificationUrl(params) {
	      return COSTCO.util.makeUrl('/AjaxMembershipAccountVerificationCmd', params);
	    },
	    /**
	     * Opens membership verification dialog
	     * @param  {number} membershipNum Membership number
	     */
	    openMembershipVerificationDialog: function openMembershipVerificationDialog(membershipNum) {
	      MemberVerification.membershipNumber = membershipNum;
	
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      digitalDataEvents.push({ uimsg: "navName:DMC | Verify Your Membership | Verify Now" });
	
	      var doNotCloseModalFlag = false;
	      isDmcPage = typeof isDmcPage !== "undefined" && isDmcPage === "true";
	      if (isDmcPage) {
	        doNotCloseModalFlag = true;
	        $('#costcoModalBtn2').parent().removeClass().addClass('col-xs-12 col-sm-12 col-md-12 col-lg-12');
	      }
	
	      var settings = {
	        dialogclasses: 'verify-membership-dialog',
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: COSTCO.util.tmpl('tmpl_membership_verify_number', {
	          membershipNumber: MemberVerification.membershipNumber
	        }),
	        footerText: isDmcPage ? COSTCO.util.tmpl('tmpl_membership_verify_buy_membership') : '',
	        preventClose: doNotCloseModalFlag,
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        secondary: !isDmcPage ? messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText : '',
	        primary_event: function primary_event() {
	
	          if (MemberVerification.validateNumberForm()) {
	            MemberVerification.membershipNumber = parseInt($('#membershipNumberToVerify').val());
	
	            var url = MemberVerification.makeVerificationUrl({
	              membershipNumber: MemberVerification.membershipNumber
	            });
	
	            MemberVerification.submitRequest(url).then(function (data) {
	              if (isDmcPage) {
	                $('#costcoModalBtn2').parent().removeClass().addClass('col-xs-12 col-md-6');
	              }
	              if (data.CRM_AUTH_QUESTION && data.CRM_AUTH_QUESTION.answers && data.CRM_AUTH_QUESTION.answers.length > 0) {
	                MemberVerification.showQuestionsStep(data);
	              } else {
	                MemberVerification.showPrescreen(data);
	              }
	            });
	          } else {
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter Valid Membership Number Error" });
	          }
	        },
	        secondary_event: function secondary_event() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	          }
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      };
	
	      COSTCO.dialog.createExtDialogBox(settings);
	    },
	    /**
	     * Shows prescreen (last name / zip code form)
	     * @param  {Object} data Data response returned from server
	     */
	    showPrescreen: function showPrescreen(data) {
	      COSTCO.dialog.updateModal({
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: COSTCO.util.tmpl('tmpl_membership_verify_prescreen', {}),
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
	        primary_event: function primary_event() {
	          if (MemberVerification.validateZipCodeForm()) {
	            var url = MemberVerification.makeVerificationUrl({
	              lastName: $('#questionLastName').val(),
	              zipCode: $('#questionZip').val()
	            });
	
	            MemberVerification.submitRequest(url).then(MemberVerification.showQuestionsStep);
	          }
	        },
	        secondary_event: function secondary_event() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	          }
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      });
	    },
	
	    /**
	     * Updates modal with questions to select. If there is another question returned from backend, call it self again to display new question.
	     * @param  {Object} data Response data from previous step
	     */
	    showQuestionsStep: function showQuestionsStep(data) {
	      var questionsBodyTmpl = '';
	
	      if (data.CRM_AUTH_QUESTION) {
	        questionsBodyTmpl = $(COSTCO.util.tmpl('tmpl_membership_verify_questions', {
	          membershipNumber: MemberVerification.membershipNumber,
	          verificationQuestion: data.CRM_AUTH_QUESTION.question
	        }));
	
	        var questionsTmpl = questionsBodyTmpl.find('#verification-questions');
	
	        if (questionsTmpl.length) {
	          $.each(data.CRM_AUTH_QUESTION.answers, function (index, value) {
	            questionsTmpl.append(COSTCO.util.tmpl('tmpl_membership_verify_question_item', {
	              answerId: index,
	              verificationAnswer: value
	            }));
	          });
	        }
	      }
	
	      COSTCO.dialog.updateModal({
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: questionsBodyTmpl,
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
	        primary_event: function primary_event() {
	          var selectedAnswer = $('input[name=CRManswer]:checked').val();
	
	          var url = MemberVerification.makeVerificationUrl({
	            answerNumber: selectedAnswer
	          });
	
	          var loadingTmpl = 'tmpl_membership_questions_loading';
	          if (data.CRM_AUTH_LAST_STEP) {
	            loadingTmpl = 'tmpl_membership_verify_loading';
	          }
	
	          COSTCO.dialog.updateModal({
	            title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	            body: COSTCO.util.tmpl(loadingTmpl, {}),
	            onshown: function onshown() {
	              COSTCO.util.maskMembershipInput();
	            }
	          });
	
	          MemberVerification.submitRequest(url).then(function (data) {
	            if (data.CRM_AUTH_QUESTION && data.CRM_AUTH_QUESTION.answers && data.CRM_AUTH_QUESTION.answers.length > 0) {
	              MemberVerification.showQuestionsStep(data);
	            } else if (data.CRM_AUTH_PASSED == true) {
	              MemberVerification.showSuccessStep();
	            } else {
	              MemberVerification.displayErrorInModal(isDmcPage ? 'tmpl_membership_dmc_verify_err_service_error' : 'tmpl_membership_verify_err_service_error');
	            }
	          });
	        },
	        secondary_event: function secondary_event() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	          }
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      });
	    },
	    /**
	     * Transfer request to DMC handler
	     */
	    proceedeToDMCCheck: function proceedeToDMCCheck(action, actionSuccessful) {
	
	      COSTCO.dialog.close();
	      var command = "/DMCCheck";
	
	      var queryStart = "?";
	      var queryConcat = "&";
	      var queryAction = "action=" + action;
	      var queryDeviceId = "deviceId=" + deviceId;
	      var queryVerified = "verified=" + actionSuccessful;
	      var queryRenewalCanceled = "renewCanceled=" + actionSuccessful;
	      var queryString = queryStart + queryAction + queryConcat + queryDeviceId + queryConcat;
	
	      if (action == 'renewal') queryString += queryRenewalCanceled;else queryString += queryVerified;
	
	      var newURL = window.location.protocol + "//" + window.location.host + command + queryString;
	      window.location.replace(newURL);
	    },
	    /**
	     * Update modal with succcess text
	     */
	    showSuccessStep: function showSuccessStep() {
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      digitalDataEvents.push({ uimsg: "My Account | Membership | Verify Membership | Success" });
	      COSTCO.dialog.updateModal({
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: COSTCO.util.tmpl('tmpl_membership_verify_success', {}),
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        primary_event: function primary_event() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', true);
	          } else {
	            COSTCO.dialog.close();
	            location.reload();
	          }
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', true);
	          } else {
	            COSTCO.dialog.close();
	            location.reload();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      });
	    },
	    /**
	     * Update modal with error text from prepared template.
	     * @param  {string} errorTemplate   Template id
	     * @param  {Object} data            Data used to populate in template
	     */
	    displayErrorInModal: function displayErrorInModal(errorTemplate, data) {
	      COSTCO.dialog.updateModal({
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: COSTCO.util.tmpl(errorTemplate, data),
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	          location.reload();
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            location.reload();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      });
	    }
	
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.MemberVerification = MemberVerification;
	  return MemberVerification;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 20 */,
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var CreditCard = {
			initComplete: false,
			init: function init(state) {
				if (!COSTCO.CreditCard.initComplete) {
					COSTCO.CreditCard.initComplete = true;
					COSTCO.CreditCard.validationRules();
					COSTCO.CreditCard.forms.creditCardForm().validate({
						rules: {
							account: { required: true, isAmex: true, customcc: true, costcoCC: true },
							cc_cvc_validator: { required: true, cvv: true },
							cc_nameoncard: { required: true, checkSpecialchar: true },
							cc_expiry_date: { required: true, checkExpiryDate: true }
						},
						messages: {
							account: { required: messages.ERR_CCNUM_REQ, isAmex: messages._ERR_INVALID_AMEX_SELECTEDCARDTYPE, customcc: messages.ERR_INVALID_CREDITCARD_SHORT, costcoCC: messages.COSTCO_CC_DISABLED },
							cc_cvc_validator: { required: messages.ERR_CHECKOUT_PAYMENT_EMPTY_CARDNUMBE_PIN, cvv: messages.ERR_INVALID_CVV },
							cc_nameoncard: { required: messages.ERR_NAME_REQ, checkSpecialchar: messages.ERR_INVALID_CC_NAME },
							cc_expiry_date: { required: messages.ERR_EXPIRYDATE_REQ, checkExpiryDate: messages.ERR_INVALID_DATE }
						},
						errorPlacement: function errorPlacement(error, element) {
							if (element.attr('id') === 'account_validator') {
								$('#account').addClass('error-credit-card');
								$('#account_validator_err_msg').html(error.html());
								$('#account_validator_err_msg').removeClass('hide');
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
									if (error.html() != "" & error.html() != null) {
										$('iframe').filter('.gw-proxy-number').addClass('error-credit-card');
										$('#isAutoRenew').prop("checked", false);
									} else {
										$('iframe').filter('.gw-proxy-number').removeClass('error-credit-card');
									}
								}
								$('iframe').filter('.gw-proxy-number').focus();
							} else if (element.attr('id') === 'cc_cvc_validator') {
								COSTCO.CreditCard.isCybersourceEnabled() ? $('#cc_cvc').addClass('error') : $('#cc_cvc').addClass('error-credit-card');
								$('#cc_cvc_err_msg').html(error.html());
								$('#cc_cvc_err_msg').removeClass('hide');
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
									if (error.html() != "" & error.html() != null) {
										$('iframe').filter('.gw-proxy-securityCode').addClass('error-credit-card');
									} else {
										$('iframe').filter('.gw-proxy-securityCode').removeClass('error-credit-card');
									}
								}
								if (typeof TokenGateway !== "undefined" && TokenGateway.focusField != "cardNumber") {
									$('iframe').filter('.gw-proxy-securityCode').focus();
								}
							} else {
								error.insertAfter(element);
							}
						},
						success: function success(label, element) {
							var $element = $(element);
							if ($element.attr('id') === 'account_validator') {
								label.parent().removeClass('error');
								$('#account').removeClass('error-credit-card');
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
									$('iframe').filter('.gw-proxy-number').removeClass('error-credit-card');
								}
								label.html('');
							} else if ($element.attr('id') === 'cc_cvc_validator') {
								label.parent().removeClass('error');
								$('#cc_cvc').removeClass('error-credit-card');
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
									$('iframe').filter('.gw-proxy-securityCode').removeClass('error-credit-card');
								}
								label.html('');
							} else {
								label.parent().removeClass('error');
								label.remove();
							}
						}
					});
	
					$('#account').unbind('input').on('input', COSTCO.CreditCard.accountNumberChangeEvent);
	
					var cardType = COSTCO.CreditCard.forms.creditCardForm().find('input[name=payMethodId]').val();
	
					if (state == 'payment') {
						// do something if needed
					}
	
					$(".a11y-tooltip").popover();
	
					// Only need to run this onload
					var expiryDate = $('#cc_expiry_date').val();
					if (expiryDate != null && expiryDate.trim().length == 6) {
						expiryDate = '0' + expiryDate;
						$('#cc_expiry_date').val(expiryDate);
					}
	
					COSTCO.CreditCard.maskInput();
					if ($('#isBDAppVar').val() == 'BD') {
						if ($('#ach-block-form').length > 0) {
							$('#ach-block-form').validate();
						}
	
						if ($('#ar-block-form').length > 0) {
							$('#ar-block-form').validate();
						}
	
						if ($('#ordPayInsVal').length > 0) {
							var paymentType = $('#ordPayInsVal').val();
							var submitedPaymentType = $('#submitedPayMethodId').val();
							if (submitedPaymentType.length > 0) {
								paymentType = paymentType != submitedPaymentType ? submitedPaymentType : paymentType;
							}
							if (paymentType == 'Check') {
								if (!COSTCO.util.isExternalCarrierShipmode()) {
									COSTCO.wallet.showCheckOnDeliverySection();
								}
							} else if (paymentType == 'ACH') {
	
								if ($('#isBDAppVar').val() == 'BD' && COSTCO.util.isNdEnabled()) {
	
									COSTCO.wallet.showACHSection();
	
									if ($('input[name=payMethodId]').val() == 'ACH' && !COSTCO.CreditCard.isPaymentEditAreaVisible()) {
										$('#radio-ach').prop('checked', true);
										$('#save_as_default2').prop('checked', true);
									};
								} else {
									if (!COSTCO.util.isExternalCarrierShipmode()) {
										COSTCO.wallet.showACHSection();
	
										if ($('input[name=payMethodId]').val() == 'ACH' && !COSTCO.CreditCard.isPaymentEditAreaVisible()) {
											$('#radio-ach').prop('checked', true);
											$('#save_as_default2').prop('checked', true);
										};
									}
								}
							} else if (paymentType == 'LineOfCredit') {
								if (!COSTCO.util.isExternalCarrierShipmode()) {
									COSTCO.wallet.showAcctReceivableSection();
								}
							} else {
								COSTCO.wallet.showCCSection();
							}
						}
					}
				}
			},
			forms: {
				creditCardForm: function creditCardForm() {
					return $('#CheckoutPaymentForm');
				},
				achForm: function achForm() {
					return $('#ach-block-form');
				},
				arForm: function arForm() {
					return $('#ar-block-form');
				}
			},
			cardTypes: {
				VISA: 'VISA',
				AMEX: 'AMEX',
				MASTER_CARD: 'Master Card',
				DISCOVER: 'Discover',
				JCB: 'JCB',
				DINERS_CLUB: 'Discover Diners',
				CUP: 'Union Pay',
				COSTCO_CREDIT_CARD: 'Costco Credit Card',
				DEFAULT_PAYMENT: 'DefaultPayment'
			},
	
			accountNumberChangeEvent: function accountNumberChangeEvent() {
	
				var ccNumber = $(this).val();
			},
	
			updatePaymentType: function updatePaymentType(cardNumber, $cardTypeInput) {
	
				var cardType = COSTCO.CreditCard.getCardType(cardNumber);
				if (cardType != '?') {
					$cardTypeInput.val(cardType);
				}
			},
	
			isVisaCard: function isVisaCard(cardNumber) {
				return (/^(4)/.test(cardNumber)
				);
			},
			isMasterCard: function isMasterCard(cardNumber) {
				return (/^(2[2-7]|5[1-5])/.test(cardNumber)
				);
			},
			isCostcoCard: function isCostcoCard(cardNumber) {
				return (/^(7111|7003)/.test(cardNumber)
				);
			},
			isDiscoverCard: function isDiscoverCard(cardNumber) {
				return (/^(6011|65|6499|6555|6556)/.test(cardNumber)
				);
			},
			getCardType: function getCardType(a) {
	
				a = a.replace(/\s+/g, "");
	
				if (/^(34|37)/.test(a) && 15 == a.length) return COSTCO.CreditCard.cardTypes.AMEX;
				if (/^(2[2-7]|5[1-5])/.test(a) && 16 == a.length) return COSTCO.CreditCard.cardTypes.MASTER_CARD;
				if (/^(30[0-5]|3095|36[0-9]|3[8-9])/.test(a) && (14 == a.length || 16 == a.length)) return COSTCO.CreditCard.cardTypes.DINERS_CLUB;
				if (/^(3528|35[3-8]|333[7-9]|334)/.test(a) && (15 == a.length || 16 == a.length)) return COSTCO.CreditCard.cardTypes.JCB;
				if (!/^(4)/.test(a) || 13 != a.length && 16 != a.length) {
					if (/^(6011|65|6499|6555|6556|62)/.test(a) && 16 == a.length) return COSTCO.CreditCard.cardTypes.DISCOVER;
					if (/^(7111|7003)/.test(a) && 16 == a.length) return COSTCO.CreditCard.cardTypes.COSTCO_CREDIT_CARD;
					if (/^(\*)/.test(a)) return COSTCO.CreditCard.cardTypes.DEFAULT_PAYMENT;
				} else return COSTCO.CreditCard.cardTypes.VISA;
				return "?";
			},
			validationRules: function validationRules() {
	
				$.validator.setDefaults({ ignore: ".ignore,.ignoreHide" });
				$.validator.addMethod('costcoCC', function (value, element) {
					value = value.replace(/\s+/g, '');
					//check to see if value is costco cc and is disabled, otherwise return true and do normal customcc check.
					if (COSTCO.CreditCard.isCostcoCard(value)) {
						var costcoCCDisabled = $('#costcoCCDisabled').val() == 'true';
						return !costcoCCDisabled;
					}
					return true;
				});
				$.validator.addMethod("isAmex", function (value, element) {
					value = value.replace(/\s+/g, "");
					var cardTypeTmp = COSTCO.CreditCard.getCardType(value);
					if (COSTCO.CreditCard.cardTypes.AMEX == cardTypeTmp) {
						//Amex not allowed - trigger specific error message
						return false;
					} else {
						return true;
					}
				});
	
				/* Replicated $.validator.methods.creditcard() from jquery-1.10.2 for jquery-3.6.3
	   * since this is no longer defined in 3.6.3
	   * ALM 47238
	      	*/
				$.validator.addMethod('creditCard', function (value, element) {
					if (this.optional(element)) {
						return "dependency-mismatch";
					}
					if (/[^0-9 \-]+/.test(value)) {
						return false;
					}
					var n = 0,
					    i = 0,
					    r = false,
					    s,
					    o;
					value = value.replace(/\D/g, "");
					if (value.length < 13 || value.length > 19) {
						return false;
					}
					for (s = value.length - 1; s >= 0; s--) {
						o = value.charAt(s);
						i = parseInt(o, 10);
						if (r) {
							if ((i *= 2) > 9) {
								i -= 9;
							}
						}
						n += i;
						r = !r;
					}
					return n % 10 === 0;
				});
				$.validator.addMethod("customcc", function (value, element) {
	
					value = value.replace(/\s+/g, "");
					var cardTypeTmp = COSTCO.CreditCard.getCardType(value);
					if (!costcoStoreFeatures.DISCOVER_DINERSCLUB_JCB_CUP_ENABLED) {
						if (COSTCO.util.getLocale() == 'en-US' && $('#isBDAppVar').val() == 'BC' && (cardTypeTmp == COSTCO.CreditCard.cardTypes.DISCOVER || cardTypeTmp == COSTCO.CreditCard.cardTypes.DINERS_CLUB || cardTypeTmp == COSTCO.CreditCard.cardTypes.JCB || cardTypeTmp == COSTCO.CreditCard.cardTypes.CUP)) {
							return false;
						}
					}
					if ((COSTCO.util.getLocale() == 'en-CA' || COSTCO.util.getLocale() == 'fr-CA' || $('#isBDAppVar').val() == 'BD') && (cardTypeTmp == COSTCO.CreditCard.cardTypes.DISCOVER || cardTypeTmp == COSTCO.CreditCard.cardTypes.DINERS_CLUB || cardTypeTmp == COSTCO.CreditCard.cardTypes.JCB)) {
						return false;
					}
					if (value.indexOf("*") > 0 && value.length >= 14 && value.length <= 16) {
						return true;
					}
					return this.optional(element) || /^7\d{15}$/.test(value) || /^\*{11}\s?\d{4}$/.test(value) || /^\*{12}\s?\d{4}$/.test(value) || $.validator.methods.creditCard.call($.data(element.form, 'validator'), value, element);
				});
	
				$.validator.addMethod("ccTypeCheck", function (value, element) {
	
					var cc = (value + '').replace(/\s/g, ''); //remove space
					// remove spaces 
					var cardType;
					if ($('input[name=payMethodId]').val() != null) {
						cardType = $('input[name=payMethodId]').val().split(' ').join('');
					}
	
					var returnVal = false;
	
					if (this.optional(element)) {
						return this.optional(element);
					}
	
					var cardTypeTmp = COSTCO.CreditCard.getCardType(cc);
					if (cardType == cardTypeTmp || '?' != cardTypeTmp) {
						returnVal = true;
					} else if (cc.indexOf('*') != -1) {
						//This is just a safety net to catch a * in the payment type to indicate there is 
						//a default payment.  If it is falsely entered the payment gateway will catch and throw an error.
						returnVal = true;
					} else {
						returnVal = false;
					}
	
					return returnVal;
				});
	
				$.validator.addMethod("cvv", function (value, element) {
					return value.trim().length == 3;
				});
	
				$.validator.addMethod("checkSpecialchar", function (value, element) {
					// CC name shouldn't have any non-alphanumeric characters and needs at least 1 letter				
					return this.optional(element) || !COSTCO.util.CC_NAME_FIELD_REGEX.test(value) && COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
				});
	
				$.validator.addMethod("checkExpiryDate", function (value, element) {
					var success = this.optional(element) || /^(0[1-9]|1[012])\/([123]\d)$/.test(value);
					if (!success) {
						COSTCO.util.announceSRMessage(messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE);
					}
					return success;
				});
	
				$.validator.addMethod("checkIsDateInPast", function (value, element) {
					var enteredMonth = parseInt(value.split('/')[0]);
					var enteredYear = parseInt(value.split('/')[1]);
					var now = new Date();
					var currentMonth = parseInt((now.getMonth() + 1).toString());
					var currentYear = parseInt(now.getFullYear().toString().substr(-2));
					if (enteredYear < currentYear || enteredYear == currentYear && enteredMonth < currentMonth) {
						return false;
					} else {
						return true;
					}
				});
			},
			validate: {
				creditCardForm: function creditCardForm(isCvvCodeValidationIgnored) {
	
					if ($('#outstandingPrincipal').length > 0 && $('#outstandingPrincipal').val() == 0 && !COSTCO.OrderSummary.isMembershipPurchaseOptinSelected()) {
						return true;
					}
	
					var form = COSTCO.CreditCard.forms.creditCardForm();
					if ($('input[name=payMethodId]').val() == 'Costco Credit Card') {
						$('#cc_cvc_validator').val("123");
						$('#cc_expiry_date').addClass('ignore').val("");
					} else {
						$('#cc_expiry_date').removeClass('ignore');
					}
	
					//since cvv validation is only required if user clicks on change link,
					//we need to add ignore class to skip validation of blank cvv field if
					//the user does not click change.
					if ($('#cc_cvv_div').is(':hidden') || isCvvCodeValidationIgnored) {
						$('#cc_cvc_validator').addClass('ignore');
					} else {
						$('#cc_cvc_validator').removeClass('ignore');
					}
	
					if (form.length != 0) {
						return form.valid();
					}
				}
			},
			submit: {
				creditCardForm: function creditCardForm() {
					$('.order-ajax').addClass('ajax-busy');
					var form = COSTCO.CreditCard.forms.creditCardForm();
					var expDate = $(form).find('input[name=cc_expiry_date]').val().split('/');
					$('#creditCardTokenSessionId').val(modularTokenSessionId);
	
					$(form).find('input[name=expire_month]').val(expDate[0]);
					if (typeof expDate[1] != 'undefined' && expDate[1].length == 2) {
	
						$(form).find('input[name=expire_year]').val('20' + expDate[1]);
					}
					if ($('#checkoutPage').length > 0 && $('#checkoutPage').val() == 'review') {
						if ($('[name=walletCheckout]').attr('value') == 'false') {
							$(form).find('input[name=ccLastFour]').val($(form).find('input[name=account]').val().slice(-4));
						}
					}
					if (costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED !== 'undefined' && costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED && ($('input[name="isQuickPurchase"]') !== undefined && $('input[name="isQuickPurchase"]').val() === 'true' || $('input[name="isQuickPurchaseFlow"]') !== undefined && $('input[name="isQuickPurchaseFlow"]').val() === 'true')) {
	
						if ($("input[name='radio-auto-renew']:checked").val() !== undefined && $("input[name='radio-auto-renew']:checked").val() == 'optin') {
							digitalDataEvents.push({ ui: "Checkout Flow | Check | Enroll For Membership Auto Renewal" });
						} else {
							digitalDataEvents.push({ ui: "Checkout Flow | Check | Don't Enroll For Membership Auto Renewal" });
						}
					}
	
					// [0] skips jquery validation - validation must be handled in a different method
					form[0].submit();
				},
				achForm: function achForm() {
					$('.order-ajax').addClass('ajax-busy');
					var form = COSTCO.CreditCard.forms.achForm();
					form[0].submit();
				},
				arForm: function arForm() {
					$('.order-ajax').addClass('ajax-busy');
					var form = COSTCO.CreditCard.forms.arForm();
					form[0].submit();
				}
			},
			/**
	   * Uses the Jquery Mask plugin to format input fields. Use cleanVal() instead of val() to get unformatted value
	   */
			maskInput: function maskInput() {
				$('#cc_expiry_date').mask('00/00', {
					placeholder: 'MM/YY'
				});
				$('#account').mask('ZZZZ ZZZZ ZZZZ 0000', { selectOnFocus: true, translation: { 'Z': { pattern: '[\\*0-9]' } } });
				$('#cc_cvc').mask('0009');
			},
			/**
	   * Checks the state of the credit card radio button selection
	   * @return 1 if user has selected credit card radio button, otherwise returns 0
	   */
			isCreditCardOptionSelected: function isCreditCardOptionSelected() {
				return $('input[id=radio-credit-card]:checked').length || COSTCO.Checkout.displayAllPayments() && $('input[id=radio-credit-card-review]:checked').length;
			},
			showErrorBox: function showErrorBox() {
				$('#credit-card-block').addClass('error-box');
				if ($('#isBDAppVar').val() == 'BD') {
					if ($("#check-del-block") && $("#check-del-block").length > 0) {
						$('#check-del-block').addClass('error-box');
					}
					if ($("#ach-block") && $("#ach-block").length > 0) {
						$('#ach-block').addClass('error-box');
					}
					if ($("#acc-receiv-block") && $("#acc-receiv-block").length > 0) {
						$('#acc-receiv-block').addClass('error-box');
					}
				}
			},
			hideErrorBox: function hideErrorBox() {
				$('#credit-card-block').removeClass('error-box');
				if ($('#isBDAppVar').val() == 'BD') {
					if ($("#check-del-block") && $("#check-del-block").length > 0) {
						$('#check-del-block').removeClass('error-box');
					}
					if ($("#ach-block") && $("#ach-block").length > 0) {
						$('#ach-block').removeClass('error-box');
					}
					if ($("#acc-receiv-block") && $("#acc-receiv-block").length > 0) {
						$('#acc-receiv-block').removeClass('error-box');
					}
				}
			},
			isSelected: function isSelected() {
				var selected = $('#credit-card-block input[name=\'payment-radio\']:checked').val();
				return selected;
			},
			isUsed: function isUsed() {
				return $('#credit-card-info-container').length > 0 && !$('#credit-card-info-container').hasClass('hide');
			},
			isApplied: function isApplied() {
				return $('input[id=ordPayInsVal]').length > 0 && $('input[id=ordPayInsVal]').val() == 'CreditCard';
			},
			isPaymentEditAreaVisible: function isPaymentEditAreaVisible() {
				var paymentEditAreaVisible = $('#credit-card-block').length > 0 && $('#credit-card-block').attr('class') != 'hide';
				return paymentEditAreaVisible;
			},
			isCCEditAreaVisible: function isCCEditAreaVisible() {
				var creditCardEditAreaVisible = $('#credit-card-block').length > 0 && !$('#credit-card-block').hasClass('hide') && this.isCreditCardOptionSelected() > 0;
				return creditCardEditAreaVisible;
			},
			isCCEditAreaHidden: function isCCEditAreaHidden() {
				var creditCardEditAreaHidden = $('#credit-card-block').length > 0 && $('#credit-card-block').hasClass('hide') && this.isCreditCardOptionSelected() > 0;
				return creditCardEditAreaHidden;
			},
			isCybersourceEnabled: function isCybersourceEnabled() {
				return $("#cybersourceEnabled").val() === 'true';
			},
			is3DSPaymentAuthEnabled: function is3DSPaymentAuthEnabled() {
				return $("#threeDSPaymentEnabled").val() === 'true';
			},
			is3DSMemberCheckoutEnabled: function is3DSMemberCheckoutEnabled() {
				return $("#is3DSMemberCheckoutEnabled").val() === 'true';
			}
		};
	
		if (typeof window.COSTCO === 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.CreditCard = CreditCard;
	
		return CreditCard;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title payment-methods.js: Sub-module for Account pages
	 * @description This module is used to handle tasks on Account -> Payment Methods page
	 * @dependency checkout_helper, creditcard
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(24), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (checkoutHelper, creditCard) {
	  var PaymentMethods = {
	    sessionId: '',
	    isACHMember: $('#achMemberValue').val() == 'true',
	
	    getForm: function getForm() {
	      return $('#PaymentMethodForm');
	    },
	
	    url: {
	      AJAX_PAYMENT_METHOD_UPDATE: '/AjaxPaymentMethodUpdateCmd'
	    },
	    /**
	     * Initialization of the module.
	     */
	    init: function init() {
	      this.cybersourceEnabled = $("#cybersourceEnabled").val() == 'true';
	      this.addValidationMethods();
	      this.initValidation();
	      this.maskInput();
	      COSTCO.MemberVerification.validationRules();
	      if ((isBDApplication !== 'BD' || isBDApplication === 'BD' && !PaymentMethods.isACHMember) && this.getForm().length > 0) {
	        this.showCCSection();
	      }
	      console.log('Payment Methods module initialized.');
	    },
	
	    /**
	     * Adds validation methods for form validation
	     */
	    addValidationMethods: function addValidationMethods() {
	      $.validator.setDefaults({
	        ignore: '.ignore'
	      });
	
	      $.validator.addMethod('costcoCC', function (value, element) {
	        value = value.replace(/\s+/g, '');
	        var costcoCCSaved = $('#costcoCCSaved').val() == 'true';
	        //check to see if value is costco cc and is disabled, otherwise return true and do normal customcc check.
	        if (/^\*/.test(value) && costcoCCSaved || /^7\d{5}\*{6}\d{4}$/.test(value)) {
	          var costcoCCDisabled = $('#costcoCCDisabled').val() == 'true';
	          return !costcoCCDisabled;
	        }
	        return true;
	      });
	
	      /**
	         	* Replicated $.validator.methods.creditcard() from jquery-1.10.2 for jquery-3.6.3
	      * since this is no longer defined in 3.6.3
	      * ALM 47081
	         	*/
	      $.validator.addMethod('rxCreditCard', function (value, element) {
	        if (this.optional(element)) {
	          return "dependency-mismatch";
	        }
	        if (/[^0-9 \-]+/.test(value)) {
	          return false;
	        }
	        var n = 0,
	            i = 0,
	            r = false,
	            s,
	            o;
	        value = value.replace(/\D/g, "");
	        if (value.length < 13 || value.length > 19) {
	          return false;
	        }
	        for (s = value.length - 1; s >= 0; s--) {
	          o = value.charAt(s);
	          i = parseInt(o, 10);
	          if (r) {
	            if ((i *= 2) > 9) {
	              i -= 9;
	            }
	          }
	          n += i;
	          r = !r;
	        }
	        return n % 10 === 0;
	      });
	
	      $.validator.addMethod('customcc', function (value, element) {
	        value = value.replace(/\s+/g, '');
	        if (!costcoStoreFeatures.DISCOVER_DINERSCLUB_JCB_CUP_ENABLED && isBDApplication == 'BC' && COSTCO.util.getLocale() == 'en-US') {
	          if (/^6011\d{2}\*{6}\d{4}$/.test(value) || /^65\d{4}\*{6}\d{4}$/.test(value) || /^6499\d{2}\*{6}\d{4}$/.test(value) || /^6555\d{2}\*{6}\d{4}$/.test(value) || /^6556\d{2}\*{6}\d{4}$/.test(value) || /^(30[0-5]|3095|36[0-9]|3[8-9])/.test(value) || /^(3528|35[3-8]|333[7-9]|334)/.test(value)) {
	            return false;
	          }
	        }
	        if (COSTCO.util.getLocale() == 'en-CA' || COSTCO.util.getLocale() == 'fr-CA' || isBDApplication == 'BD') {
	          if (/^6011\d{2}\*{6}\d{4}$/.test(value) || /^65\d{4}\*{6}\d{4}$/.test(value) || /^6499\d{2}\*{6}\d{4}$/.test(value) || /^6555\d{2}\*{6}\d{4}$/.test(value) || /^6556\d{2}\*{6}\d{4}$/.test(value) || /^(30[0-5]|3095|36[0-9]|3[8-9])/.test(value) || /^(3528|35[3-8]|333[7-9]|334)/.test(value)) {
	            return false;
	          }
	        }
	
	        if (value.indexOf('*') > 0 && value.length >= 14 && value.length <= 16) {
	          return true;
	        }
	        return this.optional(element) || /^7\d{5}\*{6}\d{4}$/.test(value) || /^\S{6}(\*{3}|\*{5})\s?\d{4}$/.test(value) || /^\S{6}\*{6}\s?\d{4}$/.test(value) || $.validator.methods.rxCreditCard.call($.data(element.form, 'validator'), value, element);
	      });
	
	      $.validator.addMethod('checkSpecialchar', function (value, element) {
	        // CC name shouldn't have any non-alphanumeric characters and needs at least 1 letter				
	        return this.optional(element) || !COSTCO.util.CC_NAME_FIELD_REGEX.test(value) && COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
	      });
	
	      $.validator.addMethod('checkExpiryDate', function (value, element) {
	        return this.optional(element) || /^(0[1-9]|1[012])\/([123]\d)$/.test(value);
	      });
	
	      $.validator.addMethod("checkIsDateInPast", function (value, element) {
	        var enteredMonth = parseInt(value.split('/')[0]);
	        var enteredYear = parseInt(value.split('/')[1]);
	        var now = new Date();
	        var currentMonth = parseInt((now.getMonth() + 1).toString());
	        var currentYear = parseInt(now.getFullYear().toString().substr(-2));
	        if (enteredYear < currentYear || enteredYear == currentYear && enteredMonth < currentMonth) {
	          return false;
	        } else {
	          return true;
	        }
	      });
	
	      $.validator.addMethod("achtype", function (value, element, param) {
	        return this.optional(element) || value !== param;
	      }, "Value must not equal arg.");
	
	      $.validator.addMethod("achNoSpChar", function (value, element, param) {
	        value = value.replace(/\s+/g, "");
	        return this.optional(element) || /^\w+$/i.test(value);
	      }, messages.ERR_INVALID_ACH_SPECIAL_CHARACTERS);
	
	      $.validator.addMethod("achAccountNumber", function (value, element, param) {
	        return this.optional(element) || /^(\d{1,13}|\*{1,13}|\x{1,13})\d{4}$/.test(value);
	      }, messages.ERR_INVALID_ACCOUNTNUM);
	
	      $.validator.addMethod("achRoutingNumber", function (value, element, param) {
	        return this.optional(element) || /^\d{9}$/.test(value);
	      }, messages.ERR_INVALID_ROUTINGNUM);
	
	      $.validator.addMethod("achNameLen", function (value, element, param) {
	        return this.optional(element) || value.length == 0 || value.length < 29;
	      }, messages.ERR_INVALID_ACH_NAME);
	    },
	    validationRules: function validationRules() {
	      $.validator.setDefaults({
	        ignore: '.ignore'
	      });
	
	      $.validator.addMethod('costcoCC', function (value, element) {
	        value = value.replace(/\s+/g, '');
	        var costcoCCSaved = $('#costcoCCSaved').val() == 'true';
	        //check to see if value is costco cc and is disabled, otherwise return true and do normal customcc check.
	        if (/^\*/.test(value) && costcoCCSaved || /^7\d{5}\*{6}\d{4}$/.test(value)) {
	          var costcoCCDisabled = $('#costcoCCDisabled').val() == 'true';
	          return !costcoCCDisabled;
	        }
	        return true;
	      });
	
	      $.validator.addMethod('customcc', function (value, element) {
	        value = value.replace(/\s+/g, '');
	
	        if (value.indexOf('*') > 0 && value.length == 16) {
	          return true;
	        }
	
	        return this.optional(element) || /^7\d{5}\*{6}\d{4}$/.test(value) || /^\S{6}(\*{3}|\*{5})\s?\d{4}$/.test(value) || /^\S{6}\*{6}\s?\d{4}$/.test(value) || $.validator.methods.creditcard.call($.data(element.form, 'validator'), value, element);
	      });
	
	      $.validator.addMethod('checkSpecialchar', function (value, element) {
	        return this.optional(element) || !/[<>\'\"]/.test(value); // CC name shouldn't have any html tag
	      });
	
	      $.validator.addMethod('checkExpiryDate', function (value, element) {
	        return this.optional(element) || /^(0[1-9]|1[012])\/([123]\d)$/.test(value);
	      });
	
	      $.validator.addMethod("checkIsDateInPast", function (value, element) {
	        var enteredMonth = parseInt(value.split('/')[0]);
	        var enteredYear = parseInt(value.split('/')[1]);
	        var now = new Date();
	        var currentMonth = parseInt((now.getMonth() + 1).toString());
	        var currentYear = parseInt(now.getFullYear().toString().substr(-2));
	        if (enteredYear < currentYear || enteredYear == currentYear && enteredMonth < currentMonth) {
	          return false;
	        } else {
	          return true;
	        }
	      });
	    },
	    /**
	     * Initializes jQuery validation plugin on PaymentMethod form
	     */
	    initValidation: function initValidation() {
	      PaymentMethods.getForm().validate({
	        errorPlacement: function errorPlacement(error, element) {
	          if ($(element).is('#card_number_validator')) {
	            $('.gw-proxy-number').css('border', '');
	            $('.gw-proxy-number').addClass('tokenization-error');
	            error.insertAfter(element);
	          } else if (element.attr("name") == "ach_checkbox") {
	            element.closest(".row").find("[ach-checkbox-error]").append(error);
	          } else if ($(element).is('#ach_account_holder_validator')) {
	            $('.gw-proxy-bankAccountHolder').css('border', '');
	            $('.gw-proxy-bankAccountHolder').addClass('tokenization-error');
	            error.insertAfter(element);
	          } else if ($(element).is('#ach_routing_number_validator')) {
	            $('.gw-proxy-routingNumber').css('border', '');
	            $('.gw-proxy-routingNumber').addClass('tokenization-error');
	            error.insertAfter(element);
	          } else if ($(element).is('#ach_account_number_validator')) {
	            $('.gw-proxy-bankAccountNumber').css('border', '');
	            $('.gw-proxy-bankAccountNumber').addClass('tokenization-error');
	            error.insertAfter(element);
	          } else {
	            error.insertAfter(element);
	          }
	        },
	        success: function success(label, element) {
	          if ($(element).is('#card_number_validator')) {
	            $('.gw-proxy-number').css('border', '1px solid #ccc');
	            $('.gw-proxy-number').removeClass('tokenization-error');
	          } else if ($(element).is('#ach_account_holder_validator')) {
	            $('.gw-proxy-bankAccountHolder').css('border', '1px solid #ccc');
	            $('.gw-proxy-bankAccountHolder').removeClass('tokenization-error');
	          } else if ($(element).is('#ach_routing_number_validator')) {
	            $('.gw-proxy-routingNumber').css('border', '1px solid #ccc');
	            $('.gw-proxy-routingNumber').removeClass('tokenization-error');
	          } else if ($(element).is('#ach_account_number_validator')) {
	            $('.gw-proxy-bankAccountNumber').css('border', '1px solid #ccc');
	            $('.gw-proxy-bankAccountNumber').removeClass('tokenization-error');
	          }
	        }
	      });
	    },
	    /**
	     * Removes red borders from input fields
	     */
	    removeBorderErrors: function removeBorderErrors() {
	      PaymentMethods.getForm().find('iframe.tokenization-error, input.error').each(function (index, element) {
	        $(element).css('border', '1px solid #ccc');
	        $(element).removeClass('tokenization-error, error');
	      });
	    },
	    /**
	     * Disables/enables input fields according to selected payment method
	     * @param paymentMethodType payment method type (CreditCard | ACH)
	     * @return void
	     */
	    setupSelectedFormSection: function setupSelectedFormSection(paymentMethodType) {
	      var achInputFields = PaymentMethods.getForm().find('input[ach-input-field]');
	      var ccInputFields = PaymentMethods.getForm().find('input[cc-input-field]');
	
	      if (paymentMethodType === 'CreditCard') {
	        achInputFields.each(function () {
	          $(this).attr('disabled', 'disabled');
	        });
	        ccInputFields.each(function () {
	          $(this).removeAttr('disabled');
	        });
	      } else if (paymentMethodType === 'ACH') {
	        achInputFields.each(function () {
	          $(this).removeAttr('disabled');
	        });
	        ccInputFields.each(function () {
	          $(this).attr('disabled', 'disabled');
	        });
	      } else {
	        console.log('Unknown payment method passed to setupSelectedFormSection() function.');
	      }
	      PaymentMethods.getForm().validate().resetForm();
	    },
	    /**
	     * Validates the Payment Methods add/edit fields
	     */
	    validatePaymentMethodForm: function validatePaymentMethodForm() {
	      var form = PaymentMethods.getForm();
	
	      if (form.length != 0) {
	        return form.valid();
	      }
	    },
	    /**
	     * Validation rules for credit card input fields
	     */
	    creditCardValidationRules: {
	      number: {
	        required: true,
	        customcc: true,
	        costcoCC: true,
	        messages: {
	          required: messages.ERR_CCNUM_REQ,
	          customcc: messages.ERR_INVALID_CREDITCARD_SHORT,
	          costcoCC: messages.COSTCO_CC_DISABLED
	        }
	      },
	      nameOnCard: {
	        required: true,
	        checkSpecialchar: true,
	        messages: {
	          required: messages.ERR_NAME_REQ,
	          checkSpecialchar: messages.ERR_INVALID_CC_NAME
	        }
	      },
	      cc_expiry_date: {
	        required: true,
	        checkExpiryDate: true,
	        checkIsDateInPast: true,
	        messages: {
	          required: messages.ERR_EXPIRYDATE_REQ,
	          checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	          checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	        }
	      }
	    },
	    pharmacyCreditCardValidationRules: {
	      number: {
	        required: true,
	        customcc: true,
	        costcoCC: true,
	        messages: {
	          required: messages.ERR_PH_CCNUM_REQ,
	          customcc: messages.ERR_INVALID_PH_CREDITCARD_SHORT,
	          costcoCC: messages.COSTCO_CC_DISABLED
	        }
	      },
	      nameOnCard: {
	        required: true,
	        checkSpecialchar: true,
	        messages: {
	          required: messages.ERR_PH_NAME_REQ,
	          checkSpecialchar: messages.ERR_INVALID_CC_NAME
	        }
	      },
	      cc_expiry_date: {
	        required: true,
	        checkExpiryDate: true,
	        checkIsDateInPast: true,
	        messages: {
	          required: messages.ERR_PH_EXPIRYDATE_REQ,
	          checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	          checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	        }
	      }
	    },
	    /**
	     * Validation rules for ACH input fields
	     */
	    achValidationRules: {
	      ach_account_holder: {
	        required: true,
	        achNameLen: true,
	        messages: {
	          required: messages.ERR_ACH_NAME_REQ,
	          achNameLen: messages.ERR_INVALID_ACH_NAME
	        }
	      },
	      accountType: {
	        required: true,
	        achtype: "-1",
	        messages: {
	          required: messages.ERR_ACH_CARDTYPE_REQ,
	          achtype: messages.ERR_ACH_CARDTYPE_REQ
	        }
	      },
	      ach_routing_number: {
	        required: true,
	        achNoSpChar: true,
	        achRoutingNumber: true,
	        messages: {
	          required: messages.ERR_ROUTINGNUM_REQ,
	          achNoSpChar: messages.ERR_INVALID_ROUTINGNUM
	        }
	      },
	      ach_account_number: {
	        required: true,
	        achAccountNumber: true,
	        messages: {
	          required: messages.ERR_ACH_CCNUM_REQ,
	          achNoSpChar: messages.ERR_INVALID_ACCOUNTNUM,
	          achAccountNumber: messages.ERR_INVALID_ACCOUNTNUM
	        }
	      },
	      ach_checkbox: {
	        required: true,
	        messages: {
	          required: messages.ACH_AGREE_PROMPT
	        }
	      }
	    },
	    /**
	     * Validation rules for ACH input fields
	     */
	    achCybsValidationRules: {
	      ach_account_holder: {
	        required: true,
	        achNameLen: true,
	        messages: {
	          required: messages.ERR_ACH_NAME_REQ,
	          achNameLen: messages.ERR_INVALID_ACH_NAME
	        }
	      },
	      accountType: {
	        required: true,
	        achtype: "-1",
	        messages: {
	          required: messages.ERR_ACH_CARDTYPE_REQ,
	          achtype: messages.ERR_ACH_CARDTYPE_REQ
	        }
	      },
	      ach_checkbox: {
	        required: true,
	        messages: {
	          required: messages.ACH_AGREE_PROMPT
	        }
	      }
	    },
	    /**
	     * Helper function to remove rules from form input fields
	     */
	    removeRules: function removeRules(rulesObj) {
	      for (var item in rulesObj) {
	        if (item == 'accountType') {
	          if ($('select[name=' + item + ']').length > 0) {
	            $('select[name=' + item + ']').rules('remove');
	          }
	        } else {
	          if ($('input[name=' + item + ']').length > 0) {
	            $('input[name=' + item + ']').rules('remove');
	          }
	        }
	      }
	    },
	    /**
	     * Helper function to add rules to form input fields
	     */
	    addRules: function addRules(rulesObj) {
	      for (var item in rulesObj) {
	        if (item == 'accountType') {
	          $('select[name=' + item + ']').rules('add', rulesObj[item]);
	        } else {
	          $('input[name=' + item + ']').rules('add', rulesObj[item]);
	        }
	      }
	    },
	    /**
	     * Submits the Payment Methods add/edit form
	     */
	    submit: function submit(redirectURL) {
	      var form = PaymentMethods.getForm();
	      var expDate = $(form).find('input[name=cc_expiry_date]').val().split('/');
	      $(form).find('input[name=expMonth]').val(expDate[0]);
	      $(form).find('input[name=expYear]').val('20' + expDate[1]);
	      if (PaymentMethods.cybersourceEnabled) {
	        $(form).find('input[name=ach_account_holder]').val($("#ach_account_holder").val());
	        $("#ach_account_holder_validator").val($("#ach_account_holder").val());
	      }
	      checkoutHelper.ajax_update_state({
	        method: 'POST',
	        url: PaymentMethods.url.AJAX_PAYMENT_METHOD_UPDATE,
	        data: form.serializeArray(),
	        dataType: 'json',
	
	        done: function done(data, textStatus, jqXHR, options) {
	          checkoutHelper.ajax_update_default_done(data, textStatus, jqXHR, options);
	
	          if (data.error.application.length > 0) {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application], true);
	          } else if (data.payload.data.status === 'success') {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [data.payload.data.message], true);
	            if (redirectURL) {
	              setTimeout(function () {
	                location.href = COSTCO.util.makeUrl('/' + redirectURL, { langId: wcs.langId, storeId: wcs.storeId, catalogId: wcs.catalogId, toPrescription: true });
	              }, 2000);
	            }
	          }
	        },
	        always: function always() {
	          $('.order-ajax').removeClass('ajax-busy');
	          TokenGateway.refreshGateway();
	        }
	      });
	    },
	    /**
	     * Mask expiry date and credit card number
	     */
	    maskInput: function maskInput() {
	      $('#cc_expiry_date').mask('00/00');
	      $('#card_number').mask('ZZZZ ZZZZ ZZZZ 0000', {
	        selectOnFocus: true,
	        translation: {
	          'Z': {
	            pattern: '[\\*0-9]'
	          }
	        }
	      });
	    },
	
	    formSubmitter: function formSubmitter(redirectURL, paymentMethodType) {
	      COSTCO.PaymentMethods.validatePaymentMethodForm();
	      var form = PaymentMethods.getForm();
	      if (form.valid()) {
	        PaymentMethods.submit(redirectURL);
	      }
	    },
	
	    /**
	     * Removes the payment method from respective payment methods list
	     * @param  {String} bodyMessage   	message to be displayed in body of dialog modal
	     * @param  {String} form 			form to be submitted thru ajax
	     * @param  {String} redirectURL 	URL to redirect the user to
	     * @param  {String} type 			payment type (currently: 'CreditCard'|'ACH')
	     * @return void
	     */
	    removePaymentMethod: function removePaymentMethod(bodyMessage, form, redirectURL, type) {
	      COSTCO.dialog.createExtDialogBox({
	        title: type === 'CreditCard' ? messages.ACCOUNT_PAYMENT_METHODS_Remove_Card_Button_Text : messages.COSTCO_REMOVE,
	        body: bodyMessage,
	        primary: type === 'CreditCard' ? messages.ACCOUNT_PAYMENT_METHODS_Remove_Card_Button_Text : messages.COSTCO_REMOVE,
	        secondary: messages.JS_DIALOG_CANCEL,
	        dialogclasses: 'remove-card-modal',
	        primary_event: function primary_event() {
	          checkoutHelper.ajax_update_state({
	            method: 'POST',
	            url: PaymentMethods.url.AJAX_PAYMENT_METHOD_UPDATE,
	            data: $(form).serializeArray(),
	            dataType: 'json',
	            ajax_update_post_done: function ajax_update_post_done(data) {
	
	              // TODO: Check if we need this
	              if (PaymentMethods.cybersourceEnabled) {
	                createTokenSessionId();
	              } else {
	                TokenGateway.refreshGateway();
	              }
	
	              PaymentMethods.addValidationMethods();
	              PaymentMethods.initValidation();
	              PaymentMethods.maskInput();
	
	              if (isBDApplication !== 'BD' || isBDApplication === 'BD' && !PaymentMethods.isACHMember) {
	                PaymentMethods.showCCSection();
	              }
	
	              COSTCO.dialog.close();
	
	              if (data.payload.data.status === 'success') {
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [data.payload.data.message], true);
	                if (redirectURL) {
	                  setTimeout(function () {
	                    location.href = COSTCO.util.makeUrl('/' + redirectURL, { langId: wcs.langId, storeId: wcs.storeId, catalogId: wcs.catalogId });
	                  }, 2000);
	                }
	              } else {
	                // error
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.payload.data.message], true);
	              }
	            }
	          });
	        }
	      });
	    },
	    showRecaptchaDetails: function showRecaptchaDetails() {
	      $('#cc-recaptcha-learn-more-link').addClass('hide');
	      $('#recaptcha-message-top').focus();
	    },
	
	    /** Method to call validation method of recaptcha */
	    validateReCaptcha: function validateReCaptcha(grecaptcha) {
	      grecaptcha.execute();
	    },
	    /**
	     * Saves payment method for a user
	     * @param {redirectURL} URL to redirect the user to
	     * @param {paymentMethodType} 'CreditCard'|'ACH'
	     * @return void
	     */
	    savePaymentMethod: function savePaymentMethod(redirectURL, paymentMethodType) {
	
	      //reset ach dropdown value
	      if ($('#ach_account_type').val() == null || $('#ach_account_type').val() == '') {
	        $('#ach_account_type').val('-1');
	      }
	
	      if (paymentMethodType === 'CreditCard') {
	        TokenGateway.updateSessionFromForm('card', function () {
	          COSTCO.PaymentMethods.formSubmitter(redirectURL, paymentMethodType);
	        }, 'PaymentMethodForm');
	      } else if (paymentMethodType === 'ACH') {
	
	        if ($('#ach_account_type').val() == '-1') {
	          $('#ach_account_type').val('');
	        }
	        TokenGateway.updateSessionFromForm('ach', function () {
	          COSTCO.PaymentMethods.formSubmitter(redirectURL, paymentMethodType);
	        }, 'PaymentMethodForm');
	      }
	
	      //Add new payment methods here
	      return false;
	    },
	    setlabelActive: function setlabelActive(data, type) {
	
	      if ($('#cc-payment-block').find('[id=card_number_validator]').val() != '') {
	        $('label[for="card_number_validator"]').addClass("active");
	      }
	      if ($('#cc-payment-block').find('[id=cc_expiry_date]').val() != '') {
	        $('label[for="cc_expiry_date"]').addClass("active");
	      }
	      if ($('#cc-payment-block').find('[id=nameOnCard]').val() != '') {
	        $('label[for="nameOnCard"]').addClass("active");
	      }
	    },
	    /**
	     * Displays credit card / ach payment form when widget in Display mode
	     * @param  {JSON Object} data	data to populate template
	     * @return {void}
	     */
	    showPharmacyPaymentForm: function showPharmacyPaymentForm(data, type) {
	      COSTCO.util.notification.clearNotification();
	
	      if (!this.cybersourceEnabled) {
	        createTokenSessionId(false, false);
	      }
	      var formHtmlBlock = '#payment-method-edit';
	      var formTemplate = 'tmpl_payment_methods_form';
	      var inputFieldsSection = '';
	      $('#payment-method-display').hide();
	
	      var htmlForm = COSTCO.util.tmpl(formTemplate, {});
	      $(formHtmlBlock).html(htmlForm);
	
	      inputFieldsSection = COSTCO.util.tmpl('tmpl_pharmacy_payment_methods_full', data);
	      $('#payment-method-container').append(inputFieldsSection);
	
	      if (!this.cybersourceEnabled) {
	        TokenGateway.refreshGateway();
	      }
	
	      PaymentMethods.addValidationMethods();
	      PaymentMethods.initValidation();
	      PaymentMethods.maskInput();
	      PaymentMethods.setlabelActive();
	
	      if (type === 'CreditCard') {
	        PaymentMethods.showCCSection();
	      } else if (type === 'ACH') {
	        PaymentMethods.showACHSection();
	      }
	
	      if (this.cybersourceEnabled) {
	        this.setInputFieldsEvents();
	      }
	    },
	    /**
	     * Displays credit card / ach payment form when widget in Display mode
	     * @param  {JSON Object} data	data to populate template
	     * @return {void}
	     */
	    showPaymentForm: function showPaymentForm(data, type) {
	
	      COSTCO.util.notification.clearNotification();
	      if (!this.cybersourceEnabled) {
	        createTokenSessionId(false, false);
	      }
	      var formHtmlBlock = '#payment-method-edit';
	      var formTemplate = 'tmpl_payment_methods_form';
	      var inputFieldsSection = '';
	      $('#payment-method-display').hide();
	
	      var htmlForm = COSTCO.util.tmpl(formTemplate, {});
	      $(formHtmlBlock).html(htmlForm);
	
	      inputFieldsSection = COSTCO.util.tmpl('tmpl_payment_methods_full', data);
	      $('#payment-method-container').append(inputFieldsSection);
	
	      if (!this.cybersourceEnabled) {
	        TokenGateway.refreshGateway();
	      }
	
	      PaymentMethods.addValidationMethods();
	      PaymentMethods.initValidation();
	      PaymentMethods.maskInput();
	
	      if (type === 'CreditCard') {
	        PaymentMethods.showCCSection();
	        if (this.cybersourceEnabled) {
	          this.setInputFieldsEvents();
	        }
	      } else if (type === 'ACH') {
	        PaymentMethods.showACHSection();
	        if (this.cybersourceEnabled) {
	          this.setACHInputFieldsEvents();
	        }
	      }
	    },
	
	    setInputFieldsEvents: function setInputFieldsEvents() {
	      $("#card_number").keypress(function () {
	        TokenGateway.resetCardNumber(this);
	      }).keyup(function (event) {
	        if (event.keyCode === 8 || event.keyCode === 46) {
	          TokenGateway.resetCardNumber(this);
	        }
	      });
	      $("#card_number").click(function () {
	        TokenGateway.resetCardNumber(this);
	      });
	    },
	
	    setACHInputFieldsEvents: function setACHInputFieldsEvents() {
	      $("#ach_account_number").keypress(function () {
	        TokenGateway.resetACHFields(this, $("#ach_routing_number"), "ach_account_number");
	      }).keyup(function (event) {
	        if (event.keyCode === 8 || event.keyCode === 46) {
	          TokenGateway.resetACHFields(this, $("#ach_routing_number"), "ach_account_number");
	        }
	      });
	      $("#ach_account_number").click(function () {
	        TokenGateway.resetACHFields(this, $("#ach_routing_number"), "ach_account_number");
	      });
	
	      $("#ach_routing_number").keypress(function () {
	        TokenGateway.resetACHFields($("#ach_account_number"), this, "ach_routing_number");
	      }).keyup(function (event) {
	        if (event.keyCode === 8 || event.keyCode === 46) {
	          TokenGateway.resetACHFields($("#ach_account_number"), this, "ach_routing_number");
	        }
	      });
	      $("#ach_routing_number").click(function () {
	        TokenGateway.resetACHFields($("#ach_account_number"), this, "ach_routing_number");
	      });
	      $("#ach_account_holder").keypress(function () {
	        PaymentMethods.resetAccountHolderField();
	      }).keyup(function (event) {
	        if (event.keyCode === 8 || event.keyCode === 46) {
	          PaymentMethods.resetAccountHolderField();
	        }
	      });
	      $("#ach_account_holder").click(function () {
	        PaymentMethods.resetAccountHolderField();
	      });
	    },
	
	    resetAccountHolderField: function resetAccountHolderField() {
	      var labelSelector = 'label[for="ach_account_holder_validator"]';
	      $(labelSelector).removeClass('error');
	      $(labelSelector).addClass('hide');
	      if ($("#ach_account_holder").prop("readonly")) {
	        $(labelSelector).html("");
	        $("#ach_account_holder").removeAttr("disabled");
	        $("#ach_account_holder").removeAttr("readonly");
	        TokenGateway.resetACHFields($("#ach_account_number"), $("#ach_routing_number"), "ach_account_holder");
	      }
	      $("#ach_account_holder").focus();
	    },
	
	    /**
	     * Shows Credit Card section on user radio selection
	     */
	    showCCSection: function showCCSection() {
	      $('#radio-credit-card').prop('checked', true);
	      $('#PaymentMethodForm #payment_type').val('CreditCard');
	      $('#ach-payment-block').addClass('hide');
	      $('#cc-payment-block').removeClass('hide');
	      PaymentMethods.removeBorderErrors();
	      PaymentMethods.setupSelectedFormSection('CreditCard');
	      if (this.cybersourceEnabled) {
	        PaymentMethods.removeRules(PaymentMethods.achCybsValidationRules);
	      } else {
	        PaymentMethods.removeRules(PaymentMethods.achValidationRules);
	      }
	
	      var isPharmacy = $('input[name="isPharmacy"]').val();
	      if (isPharmacy) {
	        if (this.cybersourceEnabled) {
	          PaymentMethods.addCybersourceRules(PaymentMethods.pharmacyCreditCardCybsValidationRules);
	        } else {
	          PaymentMethods.addRules(PaymentMethods.pharmacyCreditCardValidationRules);
	        }
	      } else {
	        if (this.cybersourceEnabled) {
	          PaymentMethods.addCybersourceRules(PaymentMethods.creditCardCybsValidationRules);
	        } else {
	          PaymentMethods.addRules(PaymentMethods.creditCardValidationRules);
	        }
	      }
	    },
	    selectACHPayment: function selectACHPayment() {
	      if (this.cybersourceEnabled) {
	        createTokenSessionId(false, false);
	      }
	      PaymentMethods.showACHSection();
	      if (this.cybersourceEnabled) {
	        this.setACHInputFieldsEvents();
	      }
	    },
	    /**
	     * Shows ACH section on user radio selection (BD only)
	     */
	    showACHSection: function showACHSection() {
	      $('#radio-ach').prop('checked', true);
	      $('#PaymentMethodForm #payment_type').val('ACH');
	      $('#ach-payment-block').removeClass('hide');
	      $('#cc-payment-block').addClass('hide');
	      PaymentMethods.removeBorderErrors();
	      PaymentMethods.setupSelectedFormSection('ACH');
	      if (this.cybersourceEnabled) {
	        PaymentMethods.removeRules(PaymentMethods.creditCardCybsValidationRules);
	        PaymentMethods.addRules(PaymentMethods.achCybsValidationRules);
	      } else {
	        PaymentMethods.removeRules(PaymentMethods.creditCardValidationRules);
	        PaymentMethods.addRules(PaymentMethods.achValidationRules);
	      }
	    },
	
	    /** Changes for Cybersource Integration starts here **/
	
	    addCybersourceRules: function addCybersourceRules(rulesObj) {
	      for (var item in rulesObj) {
	        if (item == 'accountType') {
	          $('select[name=' + item + ']').rules('add', rulesObj[item]);
	        } else {
	          $('input[name=' + item + ']').rules('add', rulesObj[item]);
	        }
	      }
	    },
	
	    creditCardCybsValidationRules: {
	      nameOnCard: {
	        required: true,
	        checkSpecialchar: true,
	        messages: {
	          required: messages.ERR_NAME_REQ,
	          checkSpecialchar: messages.ERR_INVALID_CC_NAME
	        }
	      },
	      cc_expiry_date: {
	        required: true,
	        checkExpiryDate: true,
	        checkIsDateInPast: true,
	        messages: {
	          required: messages.ERR_EXPIRYDATE_REQ,
	          checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	          checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	        }
	      }
	    },
	    pharmacyCreditCardCybsValidationRules: {
	      nameOnCard: {
	        required: true,
	        checkSpecialchar: true,
	        messages: {
	          required: messages.ERR_PH_NAME_REQ,
	          checkSpecialchar: messages.ERR_INVALID_CC_NAME
	        }
	      },
	      cc_expiry_date: {
	        required: true,
	        checkExpiryDate: true,
	        checkIsDateInPast: true,
	        messages: {
	          required: messages.ERR_PH_EXPIRYDATE_REQ,
	          checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	          checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	        }
	      }
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.PaymentMethods = PaymentMethods;
	
	  return PaymentMethods;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	* @title checkout_helper.js: Feature level module
	* @description Utility module associated with checkout
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var Checkout = {
			/**
	  * Default implementation of the done promise used by ajax_update_state.
	  * The data structure this function uses is defined in JSONLayout.jsp.
	  * Update the state of each html segment. This assumes that the
	  * property key maps to the id of the html segment to replace. Also,
	  * if there any errors defined on the response_obj.error,
	  * display them.
	  * @param  {String} data       The JSON returned as a string. Contains
	  *                             the encoded html that must be decoded
	  *                             and then is injected into the DOM.
	  * @param  {String} textStatus [description]
	  * @param  {String} jqXHR      [description]
	  * @param  {Object} options    The options object originally passed to
	  *                             ajax_update_state
	  * @return {void}
	  *
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_update_default_done
	  */
			ajax_update_default_done: function ajax_update_default_done(data, textStatus, jqXHR, options) {
				try {
					var response_obj = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : JSON.parse(data);
					var defaultOptions = {
						ajax_replace_content: COSTCO.Checkout.ajax_replace_content,
						ajax_handle_errors: COSTCO.Checkout.ajax_handle_errors,
						ajax_update_post_done: function ajax_update_post_done() {},
						error_container: '',
						scrollToError: true
					};
					$('body').trigger('costco.ajax.content.update.start', response_obj);
					var mergedOptions = $.extend(true, {}, defaultOptions, options);
					// Inject New Html
					mergedOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
					// Post Html Injection
					mergedOptions.ajax_update_post_done(response_obj, mergedOptions, defaultOptions);
					// Handle any Errors and perform cleanup
					mergedOptions.ajax_handle_errors(response_obj, mergedOptions, defaultOptions);
					$('body').trigger('costco.ajax.content.update.end', response_obj);
				} catch (e) {
					console.error(e);
				}
				console.log('ajax_update_default_done');
			},
	
			/**
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_replace_content
	  */
			ajax_replace_content: function ajax_replace_content(response_obj, mergedOptions, defaultOptions) {
				Object.keys(response_obj.payload.html).forEach(function (key) {
					var encoded_html = response_obj.payload.html[key];
					if (mergedOptions.replaceKey) {
						if (mergedOptions.replaceKey.original == key) {
							key = mergedOptions.replaceKey.replace;
						}
					}
					$('#' + key).html(COSTCO.util.get_decoded_html(encoded_html));
					console.log('ajax_replace_content' + key);
				});
			},
	
			/**
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_handle_errors
	  */
			ajax_handle_errors: function ajax_handle_errors(response_obj, mergedOptions, defaultOptions) {
				if ($('#isBDAppVar').val() == 'BD') {
					if (COSTCO.CreditCard.isCybersourceEnabled()) {
						$('.error:not(.error-qty-increment, #cc_cvc, #cc_cvc_err_msg)').empty();
					} else {
						$('.error:not(.error-qty-increment)').empty(); // clear any errors that may be on the page
					}
				} else {
					if (COSTCO.CreditCard.isCybersourceEnabled()) {
						$('.error:not(select, #cc_cvc, #cc_cvc_err_msg)').empty();
						$('.error:not(select)').removeClass('critical-notification');
					} else {
						$('.error:not(select)').empty().removeClass('critical-notification'); // clear any errors that may be on the page
					}
	
					if (!$('.order-error').find('p').text().length) {
						$('.order-error').removeClass('critical-notification');
					}
				}
				var error_container = mergedOptions.error_container;
				if (Checkout.isReviewPage() || Checkout.isPaymentPage()) {
					if (typeof TokenGateway !== 'undefined') {
						TokenGateway.refreshGateway();
					}
					if (response_obj.metadata && response_obj.metadata.quantityUpdatedForCashCardPaymentErr) {
						error_container = '#errquantity_application_';
						$('#errquantity_application_').addClass('critical-notification');
						$('#errquantity_application_').removeClass('error');
						$("#CheckoutPaymentForm input[name=doBillingPaymentCmd]").val('true');
	
						if ($('#errquantity_application_').html().trim() == '') {
							$('#errquantity_application_').html(response_obj.metadata.quantityUpdatedForCashCardPaymentErr);
						}
					} else {
						if (typeof COSTCO.CreditCard !== 'undefined') {
							COSTCO.CreditCard.init();
						}
						if (typeof COSTCO.wallet !== 'undefined') {
							//wallet module is not used in USBD - all other allow
							if (wcs.storeId != '11301') {
								COSTCO.wallet.init();
							}
						}
						if (typeof COSTCO.CC !== 'undefined') {
							COSTCO.CC.init();
						}
					}
				}
				var input_container = mergedOptions.input_container;
				var application = response_obj.error.application || [];
				var exception = response_obj.error.exception || [];
				var error_html = '';
				if (exception.length > 0) {
					if (wcs.langId !== -25) {
						error_html += '<p>Sorry, we are experiencing technical issues. Please try again later.</p>';
					} else {
						error_html += '<p>Désolé, nous éprouvons des difficultés techniques. Veuillez réessayer plus tard.</p>';
					}
				}
				application.forEach(function (error_message) {
					error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
				});
				// if there is a redirect, store the error in sessionStorage and redirect user,
				// otherwise error will show in error container
				if (response_obj.error.redirect) {
					if (typeof sessionStorage != 'undefined') {
						sessionStorage.setItem('errorMessage', error_html); // store error_html in sessionStorage to show on redirected page
					}
					document.location.href = '/' + response_obj.error.redirect;
					return;
				}
				if (typeof error_container === 'string') {
					error_container = $(error_container);
				}
				if (input_container) {
					if (application.length + exception.length > 0) {
						$(input_container).addClass('error');
						$(input_container).attr('aria-invalid', 'true');
					} else {
						$(input_container).removeClass('error');
						$(input_container).attr('aria-invalid', 'false');
					}
				}
				if (error_container == '' || error_container.length == 0) {
					$('body').trigger('costco.ajax.content.update.sucess', response_obj);
					return;
				}
				error_container.children().remove();
				if (response_obj.metadata.quantityUpdatedForCashCardPaymentErr && error_html.length > 0) {
					$(error_container).html('');
					COSTCO.Checkout.showPaymentEditOption($('input[name=payMethodId]').val());
				}
				if (error_html.trim() != '') {
					error_container.append("<p class=\"sr-only\">" + messages.ERROR + "</p>");
					error_container.append(error_html);
					error_container.addClass('critical-notification');
					if (mergedOptions.not_critical_notification !== undefined && mergedOptions.not_critical_notification) {
						error_container.removeClass('critical-notification');
					}
	
					// add quantity limit error at the item level for BD
					if ($('#isBDAppVar').val() == 'BD') {
						$('.order-item').each(function () {
							if ($(this).find('.itemPartNumberPurchased').html() == response_obj.error.itemNumber) {
								$(this).find('.critical-notification').append(error_html).removeClass('hide');
							}
						});
					}
	
					COSTCO.util.announceSRMessage(messages.ERROR + "&nbsp" + error_html);
				}
				// Add/remove class critical-notification for page-top error in Cart page
				if (error_container.attr('id') == 'errquantity_' && checkoutPage && checkoutPage == 'cart') {
					if (error_container.html().trim() != '') {
						error_container.addClass('critical-notification');
					} else {
						error_container.removeClass('critical-notification');
					}
				}
				if ($('#errquantity_application_').length > 0 && $('#errquantity_application_').html().trim() != '') {
					if (!COSTCO.OrderSummary.isAllPaidByCashCard()) {
						COSTCO.Checkout.showPaymentEditSection($('input[name=payMethodId]').val());
					} else {
						$('#errquantity_application_').html('');
						$('#errquantity_application_').removeClass('critical-notification');
						$('#errquantity_application_').addClass('error');
					}
					COSTCO.CC.init();
				} else if ($('#errquantity_application_').length > 0) {
					$('#errquantity_application_').removeClass('critical-notification');
					$('#errquantity_application_').addClass('error');
					//This will do the real work - I have no idea what the above code does.
					//This will place error messages in-line
				} else if ($('#isBDAppVar').val() == 'BD') {
					COSTCO.OrderItems.placeGlobalCartErrorsInLine(response_obj);
					if ($("#contractErrContainer").length > 0) {
						error_container.addClass('hide');
						if (!$("#contractErrContainer").is(':visible')) $("#contractErrContainer").removeClass('hide');
					} else {
						error_container.removeClass('hide');
					}
				}
				if (mergedOptions.scrollToError && COSTCO.util.has_errors(response_obj)) {
					$('body').trigger('costco.ajax.content.update.error', response_obj);
					$('body, html').animate({
						scrollTop: $(error_container).offset().top - 30
					}, 800);
				}
			},
	
			/**
	  * A generic function to make ajax requests. The only difference being
	  * that this function sets a default done promise that injects html
	  * into the DOM with the response data. Pass done, fail, and always
	  * functions to the options object to be called in each respective promise.
	  * @param  {Object} options Object containing options to pass to $.ajax
	  *                          and functions to call within $.ajax promises.
	  * @return {void}
	  *
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_update_state
	  */
			ajax_update_state: function ajax_update_state(options, page) {
				// Prevent code breaking if checkoutPage is undefined.
				//let checkoutPage = typeof window.checkoutPage == 'undefined' ? false : window.checkoutPage;
				$('.order-ajax').addClass('ajax-busy');
				var checkoutPageName = typeof checkoutPage === 'undefined' ? false : checkoutPage;
				if (options.page || checkoutPageName) {
					options.url = COSTCO.util.makeUrl(options.url, {
						'checkoutPage': options.page || checkoutPageName
					});
				}
				if (!options.done) {
					options.done = COSTCO.Checkout.ajax_update_default_done;
				}
				if (!options.always) {
					options.always = COSTCO.Checkout.ajax_update_default_always(options.inputContainer);
				}
				COSTCO.util.ajax(options);
			},
	
			/**
	  * Extracting default function out so we can perfom this and something else
	  *
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_update_default_always
	  */
			ajax_update_default_always: function ajax_update_default_always(inputContainer) {
				$('.order-ajax').removeClass('ajax-busy');
				COSTCO.Checkout.validator = undefined;
				// ALM 54928 Possible patch fix for issue that exists in prod, NOT PERMANENT!
				if ($('#isBDAppVar').val() == 'BD') {
					if (!$('.order-error').find('p').text().length) {
						$('.order-error').removeClass('critical-notification');
					}
				}
				// Create a function to focus back to the original input after
				// the ajax call is done
				// This will only be done only if there input is defined in the option payload
				// ALM 54928: Possible patch fix for issue that exists in prod, NOT PERMANENT!
				if ($('#isBDAppVar').val() == 'BD') {
					if (!$('.order-error').find('p').text().length) {
						$('.order-error').removeClass('critical-notification');
					}
				}
				if (inputContainer) {
					var focusInput = $(inputContainer);
					if (focusInput.length > 0) {
						// If we have the id then lets use it
						if (focusInput[0].id) {
							console.log(focusInput[0].id);
							$('#' + focusInput[0].id).focus();
						} else {
							console.log('Working for it');
							// Ok no id so now we have to do work
							if (focusInput[0].nodeName == 'INPUT') {
								if (focusInput.attr('type') == 'radio' && focusInput.attr('name')) {
									$('input:checked[name="' + focusInput.attr('name') + '"]').focus();
								}
							}
						}
					}
				}
			},
	
			/**
	  * Displays the error message stored in sessionStorage from the previous page
	  * where error was sent to client, but a redirect needed to happen
	  */
			display_error_after_redirect: function display_error_after_redirect() {
				if (typeof sessionStorage != 'undefined' && sessionStorage.getItem('errorMessage')) {
					var $container = $('#progress-meter-row').children().last();
					$container.addClass('error');
					$container.append(sessionStorage.getItem('errorMessage'));
					sessionStorage.removeItem('errorMessage');
				}
			},
	
			/**
	  * Util to give an interactive character count down
	  * @param  {ojbect} label    pass the jquery obj where you want the
	  *                           countdown to reflect
	  * @param  {object} textarea pass a 'text' input
	  *                           (input[type='text'],textarea) to count
	  * @return {void}
	  */
			character_count: function character_count(label, textarea) {
				if ($(label).length > 0 && $(textarea).length > 0) {
					var updateLabelCount = function updateLabelCount(textarea, label) {
						var count = $(textarea).val().length;
						$(label).text(max - count);
					};
	
					var max = parseInt($(textarea).attr('maxlength'));
					$(label).text(max - $(textarea).val().length);
					$(textarea).unbind('keyup').on('keyup', function () {
						updateLabelCount(this, label);
					});
					$(textarea).unbind('change').on('change', function () {
						updateLabelCount(this, label);
					});
				}
			},
	
			getAuthToken: function getAuthToken() {
				return $('[name=authToken]').first().val();
			},
	
			show_busy_indicator: function show_busy_indicator() {
				$('.order-ajax').addClass('ajax-busy');
			},
	
			remove_busy_indicator: function remove_busy_indicator() {
				$('.order-ajax').removeClass('ajax-busy');
			},
	
			/**
	  * If PAD is the only choice in div.delivery-option-radios, PAD is required.
	  * Else it ain't.
	  * @param  {object}  delivery_radios The jQuery object that maps to
	  *                                   div.delivery-option-radios
	  * @return {Boolean} Is PAD required as a shipping method for this item.
	  */
			is_pad_required: function is_pad_required(delivery_radios) {
				var $radio_containers = $(delivery_radios).children();
				return $radio_containers.length === 1 && $radio_containers.first().hasClass('pad');
			},
	
			/**
	  * Is a PAD delivery option radio selected?
	  * @param  {object}  delivery_radios The jQuery object that maps to
	  *                                   div.delivery-option-radios
	  * @return {Boolean}                 Is the PAD radio selected?
	  */
			is_pad_selected: function is_pad_selected(delivery_radios) {
				var isSelected = false;
				var $pad_input = $(delivery_radios).find('.pad input[type=radio]');
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
					var $padWithoutNextDay = $(delivery_radios).find('.individualShipBlock, .individualPharmacyShipModes');
					if ($(delivery_radios).find(".grocery-header-text").length === 0 && $(delivery_radios).find(".frozen-header-text").length === 0) {
						if ($padWithoutNextDay.length === 0) {
							$(delivery_radios).find(".selection-box-v2.pad").attr("checked");
							isSelected = true;
						} else {
							isSelected = $pad_input.length > 0 && $pad_input.prop('checked');
						}
					}
				} else {
					isSelected = $pad_input.length > 0 && $pad_input.prop('checked');
				}
				return isSelected;
			},
	
			/**
	  * Clean inputs with quantity value unit
	  */
			clear_form: function clear_form() {
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
					var inputs = $('input[name^=quantity]');
					if (inputs) {
						inputs.each(function () {
							var parent = $(this).parent('div');
							parent.removeClass('error');
						});
					}
				}
			},
			/**
	  * Generic validator instance
	  * @type $.validator
	  */
			validator: undefined,
	
			/**
	  * This function is used for dynamic form validation. Its meant to be
	  * wrapped in a decorator and configured appropriately. (See how
	  * orderitems.js uses it). Everything keys off of options_obj.rule. If
	  * a rule is supplied, we're matching that rule with a single dynamic input.
	  * Otherwise, we want to validate multiple, dynamic inputs. We pass a
	  * options_obj.validate_inputs function(See orderitem.js example) that
	  * applies the rules we want. Finally, if we're valid, execute the supplied
	  * callback
	  * @param  {object} options_obj The object with the following properties:
	  *                              {
	  	*                                form: <The form we're validating>,
	  	*                                input: <optional: input to validate>,
	  	*                                validate_inputs: <The fn to add N number
	  	*                                  of rules>,
	  	*                                rule: <optional: the object that represents
	  	*                                  the rule to validate with provided input>,
	  	*                                rules_config_obj: <All of the rules to
	  	*                                  potentially pass to $.fn.validator>,
	  	*                                callback: <The function to pass on
	  	*                                  successful validation>
	  	*                              }
	  * @return {void}
	  */
			_dynamic_validate: function _dynamic_validate(options_obj) {
				var self = COSTCO.Checkout;
				var $form = options_obj.form;
				var $input = options_obj.input;
				var validate_inputs = options_obj.validate_inputs;
				var rule = options_obj.rule;
				var rules_config_obj = options_obj.rules_config_obj;
				var callback = options_obj.callback;
				//callbackParams is used in case callback function has parameters
				var callbackParams = options_obj.callbackParams;
				var options = {
					focusInvalid: false,
					errorElement: 'span'
				};
				var errorPlacement = options_obj.errorPlacement;
				if (self.validator && rule != 'quantity') {
					$form.destroyValidator(self.validator);
					COSTCO.Checkout.clear_form();
				}
				// If we're not validating a single input, we want to call the invalid
				// handler so when we throw an error we scroll to where that error is.
				if (!rule) {
					options.invalidHandler = COSTCO.util.invalid_handler;
				}
				self.validator = $form.validate(options);
				if (rule) {
					// We want a specific rule bound on the input.
					// If we're being called as an inline event handler on an input, we good, otherwise
					// use the data-id attribute of the calling DOM element to get the input.
					var $input = $input.prop('tagName') === 'INPUT' || $input.prop('tagName') === 'SELECT' ? $input : $('#' + $input.data('id'));
					$input.rules('add', rules_config_obj[rule]);
					if (!(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE)) {
						if ($('#isBDAppVar').val() == 'BD' && rule == 'quantity') {
							self.validator.settings.errorClass = self.validator.settings.errorClass + ' error-qty-increment';
						}
					}
				} else {
					// Case where we have mulitple dynamic inputs to validate
					if (validate_inputs) validate_inputs(rules_config_obj);
				}
				if (errorPlacement) {
					self.validator.settings.errorPlacement = errorPlacement;
				}
				// $.validator.form triggers form validation programmatically
				// If we're a valid form, execute the callback.
				if (self.validator.form()) {
					if (callback) {
						if (callbackParams !== undefined && callbackParams.length > 0) {
							callback(callbackParams);
						} else {
							callback();
						}
					}
				}
			},
	
			editMyAccount: function editMyAccount(view) {
				var path = "/AccountInformationView?langId=" + wcs.langId + "&storeId=" + wcs.storeId + "&catalogId=" + wcs.catalogId + "&crmSpecificView=" + view;
				window.location.href = path;
			},
	
			/**
	  * This is the inline event handler for membership application item.
	  * It needs to redirect back to the application page.
	  * @param  {[type]} partNumber  [description]
	  * @param  {[type]} orderItemId [description]
	  * @param  {[type]} orderId     [description]
	  * @return {void}
	  */
			editApplication: function editApplication(partNumber, orderItemId, orderId) {
				var path = '';
				try {
					$.cookie('APPLICATION_TRACKING_COOKIE', null, {
						path: '/'
					});
				} catch (e) {}
				if ($('#isBDAppVar').val() === 'BD' && $.cookie('cartCountCookie') > 1) {
					path = '/MembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
				} else {
					path = '/QuickMembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
				}
				$.cookie('APPLICATION_TRACKING_COOKIE', orderItemId);
				var currentPage = window.location.pathname.substr(1);
				if (currentPage.includes('CheckoutReviewView')) {
					path += '&orderId=' + orderId;
				}
				window.location.href = path;
			},
	
			/**
	  * Opens 'Remove Memebrship/Renewal Warning Modal' dialog modal.
	  * @return {void}
	  */
			openRemoveWarningModal: function openRemoveWarningModal(isRenew, orderItemId) {
				COSTCO.dialog.createExtDialogBox({
					title: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Label : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Label,
					body: isRenew ? memberOnlyFeatureEnabled ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Body_Text : memberOnlyFeatureEnabled ? messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Body_Text,
					primary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Keep_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Keep_Membership_Button_Text,
					secondary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Remove_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Remove_Membership_Button_Text,
					dialogclasses: 'leave-page-modal',
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					},
					secondary_event: function secondary_event() {
						COSTCO.OrderItems.remove_item(orderItemId);
					}
				});
			},
	
			openRemoveWarningModal_v2: function openRemoveWarningModal_v2(isRenew, orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart) {
				COSTCO.dialog.createExtDialogBox({
					title: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Label : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Label,
					body: isRenew ? memberOnlyFeatureEnabled ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Body_Text : memberOnlyFeatureEnabled ? messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Body_Text,
					primary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Keep_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Keep_Membership_Button_Text,
					secondary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Remove_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Remove_Membership_Button_Text,
					dialogclasses: 'leave-page-modal',
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					},
					secondary_event: function secondary_event() {
						COSTCO.OrderItems.remove_item_v2(orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
					}
				});
			},
	
			deletePaymentInstructionsForOrder: function deletePaymentInstructionsForOrder() {
				return new Promise(function (resolve, reject) {
					if (Checkout.isCheckoutPage()) {
						// if we're on the checkout page
						var currentOrderId = $('INPUT[name="orderId"]').val();
						COSTCO.util.ajax({
							url: '/AjaxDeletePaymentInstructionsForOrder',
							method: 'POST',
							dataType: 'json',
							data: {
								orderId: currentOrderId
							},
							success: function success(result) {
								// if no xcreditcard id, clear everything in the form. Else, clear the piId and populate the xCreditCardId in the form
								if (result.xcreditCardId.length === 0) {
									if ($('#piIdCashCard').length > 0) {
										$('#piIdCashCard').val('');
									}
									if ($('#account').length > 0) {
										$('#account').val('');
									}
									if ($('#cc_expiry_date').length > 0) {
										$('#cc_expiry_date').val('');
									}
									if ($('#cc_nameoncard').length > 0) {
										$('#cc_nameoncard').val('');
									}
								} else {
									if ($('#piIdCashCard').length > 0) {
										$('#piIdCashCard').val('');
									}
									if ($('[name="xCreditCardId"]').length > 0) {
										$('[name="xCreditCardId"]').val(result.xcreditCardId);
									}
								}
	
								console.log('Deleted payment instructions for order ' + currentOrderId);
								resolve();
							},
							fail: function fail(error) {
								console.error('Error deleting payment instructions for order ' + currentOrderId);
								resolve();
							}
						});
					} else {
						// if we're not on the checkout page, do nothing
						resolve();
					}
				});
			},
	
			showPaymentEditOption: function showPaymentEditOption(payType, skipCreateToken) {
				if (payType == 'ACH' && hasCashCard) {
					COSTCO.CC.removeCashCard($('#remove-cash-card-link'));
				}
				if (/^(Check|LineOfCredit)$/i.test(payType)) {
					Checkout.showPaymentEditSection(payType);
				} else {
					Checkout.deletePaymentInstructionsForOrder().then(function () {
						COSTCO.Checkout.moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay();
						if (undefined == skipCreateToken) {
							createTokenSessionId().then(function () {
								Checkout.showPaymentEditSection(payType);
							});
						}
					});
				}
			},
	
			showPaymentEditSection: function showPaymentEditSection(payType) {
				$('#payment-method-radio-buttons').removeClass('hide');
				$('#cod-ach-acr-payment').removeClass('hide');
				$('#cc-payment-block-title').removeClass('hide');
				$('#cc-payment-block').removeClass('hide');
				$('#credit-card-address-block').removeClass('hide');
				$('#cc-payment-address-block').removeClass('hide');
				$('#credit-card-block').removeClass('hide');
				$('#wallet-block').removeClass('hide');
				$('#credit-card-info-container').addClass('hide');
				$('#creditcard-block-form').removeClass('display');
				$('#single-page-checkout #cc-payment-block').attr('do-not-show', 'false');
				$('.payment-method-change').addClass('hide');
				$('#applepay-payment-block').addClass('hide');
				$('#applepay-block-form').removeClass('display');
				$('#applepay-info-container').addClass('hide');
				$('#placeOrderTerms').removeClass('hide');
				$('#placeOrderTermsApplePay').addClass('hide');
				$('#placeOrderTermsMob').removeClass('hide');
				$('#placeOrderTermsApplePayMob').addClass('hide');
				$('#place-order-button-regular').removeAttr('do-not-show');
				$('#place-order-button-applepay').attr('do-not-show', 'true');
				$('#place-order-button-regular').removeClass('hide');
				$('#place-order-button-applepay').addClass('hide');
				if (COSTCO.Checkout.displayAllPayments()) {
					$('#credit-card-block-review').addClass('hide');
					$('input[id=usedPayMethod]').val('');
				}
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
					$('#wallet-payment-address-form').addClass('hide');
					$('#payment-address-form').removeClass('hide');
					$('#payment-address-form .address-change-link-B').removeClass('hide');
					$('input[id=appliedPayMethod]').val('');
					$('input[id=isApplePaySheetSubmitted]').val('');
					$('input[id=unifiedPaymentType]').val('');
				}
				if ($('#isBDAppVar').val() == 'BD') {
	
					if (COSTCO.util.isNdEnabled()) {
						$('#ach-block').removeClass('hide');
					} else if (!COSTCO.util.isExternalCarrierShipmode()) {
						$('#check-del-block').removeClass('hide');
						$('#ach-block').removeClass('hide');
						$('#acc-receiv-block').removeClass('hide');
					}
	
					var paymentType = $('#ordPayInsVal').length > 0 ? $('#ordPayInsVal').val() : payType;
					if (paymentType == 'Check') {
						COSTCO.wallet.showCheckOnDeliverySection();
					} else if (paymentType == 'ACH') {
						COSTCO.wallet.showACHSection();
					} else if (paymentType == 'LineOfCredit') {
						COSTCO.wallet.showAcctReceivableSection();
					} else if ($('#wallet-info-div').length && !$('#wallet-info-div').hasClass('hide')) {
						$('#wallet-info-div').addClass('hide');
						$('#wallet-change-link').addClass('hide');
						if (wcs.locale == 'en_CA' || wcs.locale == 'fr_CA') {
							COSTCO.wallet.showMasterpassSection();
						} else {
							COSTCO.wallet.disableUseExistingWallet();
							COSTCO.wallet.showVisaSection();
						}
					} else {
						COSTCO.wallet.showCCSection();
						Checkout.reValidateCVV();
					}
				} else if ($('#wallet-info-div').length && !$('#wallet-info-div').hasClass('hide')) {
					$('#wallet-info-div').addClass('hide');
					$('#wallet-change-link').addClass('hide');
					if (wcs.locale == 'en_CA' || wcs.locale == 'fr_CA') {
						COSTCO.wallet.showMasterpassSection();
					} else {
						COSTCO.wallet.disableUseExistingWallet();
						COSTCO.wallet.showVisaSection();
					}
					COSTCO.QuickRenewAddressHelper.configureAddressesSectionBasedOnPaymentType('wallet');
				} else {
					COSTCO.wallet.showCCSection();
					Checkout.reValidateCVV();
					COSTCO.QuickRenewAddressHelper.configureAddressesSectionBasedOnPaymentType('credit card');
				}
				$('#auto-renew-div').appendTo($('#save_CC').parent().parent());
				$('#auto-renew-div').removeClass('mt-16');
				$('#auto-renew-div').addClass('mt-5');
				$('#auto-renew-div').addClass('mb-16');
				$('#autorenew-invalid-saved-card-div').addClass('hide');
				return false;
			},
	
			hidePaymentEditSection: function hidePaymentEditSection() {
				$('#payment-method-radio-buttons').addClass('hide');
				$('#cod-ach-acr-payment').addClass('hide');
				$('#cc-payment-block').addClass('hide');
				$('#credit-card-block').addClass('hide');
				$('#credit-card-address-block').addClass('hide');
				$('#cc-payment-address-block').addClass('hide');
				$('#wallet-block').addClass('hide');
				if ($('#isBDAppVar').val() == 'BD') {
					$('#check-del-block').addClass('hide');
					$('#ach-block').addClass('hide');
					$('#acc-receiv-block').addClass('hide');
				}
			},
	
			clickToPayWasTriggered: function clickToPayWasTriggered() {
				var value = sessionStorage.getItem('CLICK_TO_PAY_TRIGGERED');
				return value ? true : false;
			},
	
			removeClickToPayTriggered: function removeClickToPayTriggered() {
				sessionStorage.removeItem('CLICK_TO_PAY_TRIGGERED');
			},
	
			setClickToPayTriggered: function setClickToPayTriggered() {
				sessionStorage.setItem('CLICK_TO_PAY_TRIGGERED', true);
			},
	
			moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay: function moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay() {
				if (COSTCO.Checkout.clickToPayWasTriggered()) {
					var btn = $('#orderSummaryCheckoutButton');
					if (btn.length) {
						var currentStepNumber = parseInt(btn.attr('current-step-number')),
						    finalStepNumber = CHECKOUTSTEPS.length;
						// if we're on the last checkout step
						if (currentStepNumber > 1 && currentStepNumber == finalStepNumber) {
							var previousStepIndex = currentStepNumber - 2,
							    previousStepNumber = currentStepNumber - 1;
							btn.val(CHECKOUTSTEPS[previousStepIndex].text).attr('onclick', 'COSTCO.OrderSummary.checkoutSteps.submitCheckoutStep(' + previousStepNumber + ')');
						}
					}
				}
				COSTCO.Checkout.removeClickToPayTriggered();
			},
	
			updateCheckoutForm: function updateCheckoutForm() {
				var val = this.checked ? 'on' : 'off';
				$('#isSavedPaymentAutoRenew').prop('value', val);
			},
	
			isCheckoutPage: function isCheckoutPage() {
				return $('#CheckoutPaymentForm').length ? true : false;
			},
	
			isCartPage: function isCartPage() {
				return $('#cart').length > 0;
			},
	
			isReviewPage: function isReviewPage() {
				var isReviewPage = false;
				var currentPage = window.location.pathname.substr(1);
				if (currentPage.includes('CheckoutReviewView')) {
					isReviewPage = true;
				}
				return isReviewPage;
			},
	
			isPaymentPage: function isPaymentPage() {
				var isPaymentPage = false;
				var currentPage = window.location.pathname.substr(1);
				if (currentPage.includes('CheckoutPaymentView')) {
					isPaymentPage = true;
				}
				return isPaymentPage;
			},
	
			reValidateCVV: function reValidateCVV() {
				if ($('#cc_expiry_date').val() != '') {
					COSTCO.CreditCard.validate.creditCardForm();
					$("label[for='cc_cvc_validator']").text(messages.CVV_REENTER);
				} else {
					$('#save_CC').prop('checked', false);
				}
			},
			toggleCartAccordion: function toggleCartAccordion(orderItemId) {
				if ($('#cart-accordion-header-1-' + orderItemId).hasClass('collapsed')) {
					$('#cart-accordion-header-1-' + orderItemId).text(messages.HIDE_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-' + orderItemId).hide();
					$('#arrow-' + orderItemId).remove();
					$('#cart-accordion-header-1-' + orderItemId).after("&nbsp;<i class='co-arrow-left rotate90' id='arrow-" + orderItemId + "'></i>");
				} else {
					$('#cart-accordion-header-1-' + orderItemId).text(messages.SHOW_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-' + orderItemId).show();
					$('#arrow-' + orderItemId).remove();
					$('#cart-accordion-header-1-' + orderItemId).after("&nbsp;<i class='co-arrow-right rotate90' id='arrow-" + orderItemId + "'></i>");
				}
			},
	
			membershipAutoRenewOptionOptedIn: function membershipAutoRenewOptionOptedIn() {
				window.digitalDataEvents = window.digitalDataEvents || [];
				if ($("input[name='radio-auto-renew']:checked").val() !== undefined && !$('#membership-renew-error-container').hasClass('hide')) {
					$('#membership-renew-selection-error').addClass('hide');
				}
				$('input[name="isPurchaseMembershipAutoRenew"]').val('true');
				$('#wallet-block').addClass('hide');
				$('#creditcard-block-form').removeClass('display');
				if ($('#credit-card-info-container').length == 0) {
					$('#wallet-info-div').addClass('hide');
					$('#credit-card-block').removeClass('hide');
				}
				document.getElementById('credit-card-block').scrollIntoView({ behavior: 'smooth', block: 'center' });
			},
	
			membershipAutoRenewOptionOptedOut: function membershipAutoRenewOptionOptedOut() {
				window.digitalDataEvents = window.digitalDataEvents || [];
				if ($("input[name='radio-auto-renew']:checked").val() !== undefined && !$('#membership-renew-error-container').hasClass('hide')) {
					$('#membership-renew-selection-error').addClass('hide');
				}
				$('input[name="isPurchaseMembershipAutoRenew"]').val('false');
				if (!$('#wallet-info-div').length > 0) {
					$('#wallet-block').removeClass('hide');
				}
				$('#CheckoutPaymentForm').validate().resetForm();
				$('#account').removeClass('error-credit-card');
				$('#cc_cvc').removeClass('error-credit-card');
				$('#account_validator_err_msg').html('');
				$('#cc_cvc_err_msg').html('');
				$('#cc_membership_renew_error').removeClass('critical-notification');
				$('#cc_membership_renew_error').addClass('alert-notification');
			},
	
			pageRefreshForToken: function pageRefreshForToken() {
				window.digitalDataEvents = window.digitalDataEvents || [];
				digitalDataEvents.push({ nav: "Checkout Flow | refresh your page" });
			},
	
			toggleCartAccordionMobile: function toggleCartAccordionMobile(orderItemId) {
				if ($('#cart-accordion-header-2-' + orderItemId).hasClass('collapsed')) {
					$('#cart-accordion-header-2-' + orderItemId).text(messages.HIDE_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-2-' + orderItemId).hide();
					$('#arrow-m-' + orderItemId).remove();
					$('#cart-accordion-header-2-' + orderItemId).after("&nbsp;<i class='co-arrow-left rotate90' id='arrow-m-" + orderItemId + "'></i>");
				} else {
					$('#cart-accordion-header-2-' + orderItemId).text(messages.SHOW_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-2-' + orderItemId).show();
					$('#arrow-m-' + orderItemId).remove();
					$('#cart-accordion-header-2-' + orderItemId).after("&nbsp;<i class='co-arrow-right rotate90' id='arrow-m-" + orderItemId + "'></i>");
				}
			},
	
			/**
	  * Helper function to recompile & reload all checkout sections. Performed by ajax-modular
	  * call to '/order-prepare' without additional request parameters.
	  * @return {object} Deferred
	  */
			ajaxRefreshAllCheckoutSections: function ajaxRefreshAllCheckoutSections() {
				var deferred = $.Deferred();
				COSTCO.CreditCard.initComplete = false;
				COSTCO.AjaxModular.ajax_update_state({
					url: '/order-prepare',
					always: function always(data, textStatus, jqXHR, options) {
						deferred.resolve();
					}
				});
				return deferred.promise();
			},
	
			addScreenReaderAnnouncement: function addScreenReaderAnnouncement(adaMessage) {
				var adaMessageDiv = $('#screen-reader-announcement');
				if (adaMessageDiv.length > 0) {
					setTimeout(function () {
						adaMessageDiv.html(adaMessage);
					}, 1000);
				}
			},
			displayAllPayments: function displayAllPayments() {
				return costcoStoreFeatures.DISPLAY_ALL_PAYMENTS;
			},
			usedPayment: function usedPayment() {
				return $('input[id=usedPayMethod]').length > 0 ? $('input[id=usedPayMethod]').val() : "";
			},
			resetCheckoutPaymentFields: function resetCheckoutPaymentFields(payType) {
				$('#account').val("");
				$('#cc_cvc').val("");
				$('#cc_expiry_date').val("");
				$('#cc_nameoncard').val("");
				TokenGateway.focusField = "card.number";
				$('#cc_cvc_err_msg').addClass('hide');
				$.cookie('tkSession', 'false', { path: '/' });
				createTokenSessionId().then(function () {
					Checkout.showPaymentEditSection(payType);
				});
			}
		};
	
		if (typeof window.COSTCO === 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.Checkout = Checkout;
		return Checkout;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @title timeoutModal.js: Feature level module
	 * @description The module used for displaying and handling the timeout modal
	 * 
	 */
	var WorkerInterval = function () {
		function WorkerInterval(callback, interval) {
			_classCallCheck(this, WorkerInterval);
	
			var blob = new Blob(['setInterval(() => postMessage(0), ' + interval + ');']);
			var workerScript = URL.createObjectURL(blob);
			this.worker = new Worker(workerScript);
			this.worker.onmessage = callback;
		}
	
		_createClass(WorkerInterval, [{
			key: 'stop',
			value: function stop() {
				this.worker.terminate();
			}
		}]);
	
		return WorkerInterval;
	}();
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (util) {
	
		var timeoutModal = {
			/*
	   * timerCountdown is set to 5min and 5seconds
	   * the 15 second bufferTimer is needed to account 
	   * for page load + ajax delivery time
	   */
			state: null,
			timer: wcs.isPharmacy === 'true' ? 900000 : wcs.loginTimeOut,
			timerCountdown: 300000,
			bufferTimer: 15000,
			backgroundModalSettings: null,
			lastActiveElement: null,
			timerInterval: null,
			timerSetTimeout: null,
			data: null,
			START_TIME: '05',
			/*
	   * constants defined for state only
	   */
			INITIALIZED: 'Initialized',
			DISPLAYED: 'Displayed',
			TIMEDOUT: 'Timed Out',
			CLEARING: 'Clearing',
	
			/*
	   * ALM 32035
	   * Create list hydrator
	   */
			createListInputValue: null,
	
			/*
	   * On init we check if user is signed in, 
	   * if not we do not init
	   */
			init: function init() {
				var timeUntilInit = timeoutModal.timer - timeoutModal.timerCountdown - timeoutModal.bufferTimer;
				timeoutModal.state = timeoutModal.INITIALIZED;
				if (COSTCO.util.isUserLoggedIn() && (wcs.isPharmacy === 'true' || !COSTCO.Header.isKmsiSession())) {
					//start timeout modal timing
					timeoutModal.timerSetTimeout = setTimeout(function () {
						console.log('loading timeout modal wcs.loginTimeout = ' + wcs.loginTimeOut);
						timeoutModal.displayTimeoutModal();
					}, timeUntilInit);
				}
				return;
			},
	
			/*
	   * Finds any modal in the background and copies its settings,
	   * displays the timeout modal and scrolls to the appropriate section
	   */
			displayTimeoutModal: function displayTimeoutModal() {
				if (COSTCO.dialog.isVisible()) {
					timeoutModal.backgroundModalSettings = COSTCO.dialog.getSettings();
				}
				COSTCO.dialog.initializeReturnFocusListener();
				timeoutModal.lastActiveElement = document.activeElement;
				timeoutModal.checkForCreateNewList();
				COSTCO.dialog.showAndHideModal(timeoutModal.loadTimeoutModalSettings());
				window.scrollTo(0, 0);
			},
	
			/*
	   * Creates a 5min countdown timer 
	   * Modifies body text based on timeLeft 
	   * seconds and minutes are formatted to have 2 digits
	   * this function is killed in resetTimeoutModal()
	   */
			countdown: function countdown() {
				timeoutModal.state = timeoutModal.DISPLAYED;
				var timeLeft = new Date(timeoutModal.timerCountdown);
				var textBody = messages.TIMEOUT_MODAL_BODY;
				$('#timeout-modal-countdown-text').html(textBody.replace('{0}', timeoutModal.START_TIME).replace('{1}', '00'));
				timeoutModal.timerInterval = new WorkerInterval(function () {
					if (timeLeft.getSeconds() === 0 && timeLeft.getMinutes() === 0) {
						timeoutModal.state = timeoutModal.TIMEDOUT;
						timeoutModal.resetTimeoutModal();
						COSTCO.dialog.close();
						var isAddressBookDisplayView = document.location.pathname === '/AddressBookDisplayView';
						if (isAddressBookDisplayView) {
							document.location.href = 'Logoff?URL=ReLogonFormView';
						} else if (wcs.isPharmacy === 'true') {
							document.location.href = 'Logoff?usrClk=true';
						}
						return;
					}
					var seconds = timeLeft.getSeconds() < 10 ? '0' + timeLeft.getSeconds() : timeLeft.getSeconds();
					var minutes = timeLeft.getMinutes() < 10 ? '0' + timeLeft.getMinutes() : timeLeft.getMinutes();
					var textBodyCopy = textBody.replace('{0}', minutes).replace('{1}', seconds);
					$('#timeout-modal-countdown-text').html(textBodyCopy);
					timeLeft = new Date(timeLeft - 1000);
				}, 1000);
			},
	
			/*
	   * Makes an ajax call to /AjaxRefreshUserSession
	   * on success it resets and re-inits the modal sequence
	   * on failure it resets and closes the modal
	   */
			ajaxRefreshUserSession: function ajaxRefreshUserSession() {
				$.ajax({
					url: wcs.isPharmacy === 'true' ? '/AjaxRefreshUserSession?isPharmacy=true' : '/AjaxRefreshUserSession',
					success: function success(data) {
						timeoutModal.data = JSON.parse(data);
						if (timeoutModal.data.status === '1') {
							console.log("success refreeshing session");
							timeoutModal.timerInterval.stop();
						} else {
							console.log('error refreshing session');
						}
					},
					error: function error(data) {
						console.log('error making ajax call');
						COSTCO.dialog.close();
					}
				});
			},
	
			/*
	   * set of modal options - see costcodialog.js for root 
	   * 2nd onclick event listener is for the close button 
	   * necessary to setTimeout and call the function as is 
	   * because order of execution loses the other function call
	   */
			loadTimeoutModalSettings: function loadTimeoutModalSettings() {
				var modalOptions = {
					title: messages.TIMEOUT_MODAL_HEADER,
					body: COSTCO.util.tmpl('tmpl_timeout_modal'),
					hideFooter: true,
					preventClose: true,
					onshown: function onshown(e) {
						timeoutModal.countdown();
						e.preventDefault();
						$('#timeout-submit').focus();
						$('#timeout-submit').on('click', function (e) {
							e.preventDefault();
							timeoutModal.modalOnclick();
						});
						$('#timeout-cancel').on('click', function (e) {
							e.preventDefault();
							COSTCO.dialog.close();
						});
						$('#timeout-modal').parent().prev().find('.co-close').on('click', function (e) {
							COSTCO.dialog.close();
							e.preventDefault();
							$(this).unbind();
						});
					},
					close: function close() {
						COSTCO.dialog.close();
					}
				};
				return modalOptions;
			},
	
			/*
	   * general handler for closing/refreshing the timeout modal
	   * this is called on click/spacebar for any button of the timeout modal
	   */
			modalOnclick: function modalOnclick() {
				timeoutModal.ajaxRefreshUserSession();
				if (COSTCO.dialog.isVisible()) {
					timeoutModal.backgroundModalSettings === null ? COSTCO.dialog.close() : COSTCO.dialog.showAndHideModal(timeoutModal.backgroundModalSettings);
					$(timeoutModal.lastActiveElement).focus();
				}
				timeoutModal.resetTimeoutModal();
				if (timeoutModal.state !== timeoutModal.TIMEDOUT) {
					new COSTCO.timeoutModal.init();
				}
			},
	
			/*
	   * resets all values and clears state 
	   * clears intervals and timeouts 
	   */
			resetTimeoutModal: function resetTimeoutModal() {
				if (timeoutModal.state !== timeoutModal.TIMEDOUT) {
					timeoutModal.state = timeoutModal.CLEARING;
				}
				timeoutModal.backgroundModalSettings = null;
				clearInterval(timeoutModal.timerInterval);
				clearTimeout(timeoutModal.timerSetTimeout);
				if (timeoutModal.state === timeoutModal.TIMEDOUT) {
					console.log("Session timed out");
				} else {
					console.log("TIMEOUT MODAL DONE CLEARING");
				}
			},
	
			checkForCreateNewList: function checkForCreateNewList() {
				if (timeoutModal.backgroundModalSettings !== null && timeoutModal.backgroundModalSettings.primary === messages.MA_CREATELIST) {
					timeoutModal.backgroundModalSettings.onshown = function () {
						$('#listidname').val(COSTCO.timeoutModal.createListInputValue);
						$('#listidname').focus();
					};
					var listIdNameVal = $('#listidname').val();
					timeoutModal.createListInputValue = listIdNameVal;
				}
			}
		};
	
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
		/*
	  * exposing the file to global
	  * use COSTCO.timeoutModal.xxx to check
	  * any constants defined at the top
	  */
		window.COSTCO.timeoutModal = timeoutModal;
		return timeoutModal;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title mathtable.js: Sub-module
	 * @description Associated with MathTableAndProductOptions.jsp
	 * This JS file calculates prices of products, shows/hides the 
	 * math table on the Product Details Page
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (phelper) {
		var retryCount = 0;
		var retryLimit = 3;
		var isRegionalPdtAvlble = false;
		var initSwatch = false;
		var isRegionalPdt = false;
		var backordered = false;
		var bundlePriceMap = new Map();
		var blockContractAjax = false;
		var previousContractAjaxItem = '';
		var selectedObj = null;
		var selectedVar = null;
		var initalizeAjaxCall = false;
		var hideBreakdownvariants = false;
		var isCostcoMembers = false;
		var isUserSignedIn = false;
		var CMath = {
			isBackOrderFlag: false,
			invAvailableAjax: false,
			invokebatchCall: false,
			pdpPageloadComplete: false,
			kbPageloadComplete: false,
			siteControllOOS: false,
			isWarehouseEnabled: false,
			isWioEnabled: false,
			isBopiwEnabled: false,
			isErrorlocationControlleditem: false,
			invokeAjaxCall: false,
			selectedswatches: [],
			onloadSelectOption: [],
			variantJSON: [],
			varItemJSON: [],
			iskitsbundle: false,
			/* Math Table Controller */
			// Initializes the controller. Checks what kind of product the user landed on executes accordingly.
			init: function init() {
				if (isPDPVariantGreyOutEnabled == 'true') {
					localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
				}
				var bundleItem = $('#bundleItem').val();
				var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
				var isWarehouseOnlyAttr = $('#isWarehouseOnlyAttr').val() == "true" ? true : false;
				var pricingtextdisplay = $('#pricingtextdisplay').val() == 'true' ? true : false;
	
				if (isWarehouseOnlyAttr && pricingtextdisplay && $('#applicationType').val() == 'BC') {
					$('#warehouseonly_pricing_info').removeClass('hide');
				}
	
				COSTCO.CMath.iskitsbundle = $('#iskitsbundle').val() == "true" ? true : false;
				if ($('#isBDAppVar').val() != 'BD' && isPDPVariantGreyOutEnabled == 'true' && !(typeof product != 'undefined' && Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) && !scheduledDeliverable) {
					$('head').append('<style type="text/css">.loading {animation: pulse 1.5s ease-in-out 0.5s 50;}@keyframes pulse {0% {opacity: 1;}50% {opacity: 0.4;}100% {opacity: 1;}}</style>');
				}
				if ($('#isBDAppVar').val() != 'BD' && bundleItem && product.length == 0) {
					$('.crumbs').show();
					$('#product-page').addClass('hide');
					$('#not_found_error_pdp').removeClass('hide');
				}
				if (phelper.isSingleItem(products)) {
					$('.starting-price').hide();
					var catentry = $('.online-price').data('catentry');
					var quickView = $('#quick_view').val() == "true" ? true : false;
					phelper.item_type = 'single';
					if ($('#isBDAppVar').val() != 'BD' && !quickView) {
						window.reactObj.fulfillments.buyInStoreOnly.wcsVariant = false;
						window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi = false;
					}
					if (catentry) {
	
						if ($('#isBDAppVar').val() == 'BD' || quickView) {
							CMath.pricingInfo(catentry);
							CMath.showBreakdown(!hideBreakdownvariants);
							CMath.showBackorderMessage();
						}
					} else {
						$('.your-price').addClass('hide');
					}
					var catID = products[0][0].catentry;
					COSTCO.Product.active_catentry = catID;
					COSTCO.CMath.invokeBuildABundle(catID);
					var defaultItemNumber = COSTCO.Product.getPartnumber();
					window.eventBus.subscribe('reactReady', function (data) {
						window.eventBus.publish('bfImageViewerPartnumber', defaultItemNumber);
					});
				} else if (phelper.isSingleVariant(products)) {
					phelper.item_type = 'single_variant';
	
					if (COSTCO.CMath.iskitsbundle) {
						COSTCO.CMath.buildTooltip();
						CMath.selectCurrentSelectedItem();
					}
					COSTCO.Product.sort_variant_options();
					CMath.bindVariantProducts();
					var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
					if (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag || scheduledDeliverable) {
						$('#PDPSwatchSkeletone-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
						$('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').show();
						$('.dropdown-skeleton-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
						$('[name=productOption0' + parseInt(optionsSelected.length - 1) + ']').show();
					}
				} else if (phelper.isMultiVariant(products)) {
					phelper.item_type = 'multi_variant';
	
					if (COSTCO.CMath.iskitsbundle) {
						COSTCO.CMath.buildTooltip();
						CMath.selectCurrentSelectedItem();
					}
					COSTCO.Product.sort_variant_options();
					CMath.bindVariantProducts();
					if ($('#isBDAppVar').val() != 'BD' && isPDPVariantGreyOutEnabled == 'true') {
						var _optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
						for (var i = 0; i <= _optionsSelected.length - 2; i++) {
							$('#PDPSwatchSkeletone-productOption0' + parseInt(i) + '').hide();
							$('#swatchesID-productOption0' + parseInt(i) + '').show();
							$('.dropdown-skeleton-productOption0' + parseInt(i) + '').hide();
							$('[name=productOption0' + parseInt(i) + ']').show();
						}
						if (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag || scheduledDeliverable) {
							$('#PDPSwatchSkeletone-productOption0' + parseInt(_optionsSelected.length - 1) + '').hide();
							$('#swatchesID-productOption0' + parseInt(_optionsSelected.length - 1) + '').show();
							$('.dropdown-skeleton-productOption0' + parseInt(_optionsSelected.length - 1) + '').hide();
							$('[name=productOption0' + parseInt(_optionsSelected.length - 1) + ']').show();
						}
					}
				} else if (COSTCO.CMath.iskitsbundle) {
	
					phelper.item_type = 'single_variant';
					COSTCO.Product.sort_variant_options();
					CMath.bindVariantProducts();
				} else if (phelper.isBundle(products)) {
					phelper.item_type = 'bundle';
					if ($('#isBDAppVar').val() != 'BD') {
						for (var i = 0; i < product.length; i++) {
							var productId = product[i].catentry;
							var count = 0,
							    size = product.length;
							count = i;
							for (var j = 0; j < products[i].length; j++) {
								var itemId = products[i][j].catentry;
								//CMath.showBundleSpecificData(productId,itemId,count,size);
								CMath.callAjaxBundleInventory(productId, itemId, count, size);
							}
						}
					}
					CMath.addToCartSwitch(false);
					CMath.bindQuantitiesForBundle();
					CMath.bindVariantProducts('bundle');
	
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
						CMath.updateItemNumberDisplay();
					}
				}
				CMath.regionSelector();
				CMath.mathTableDisplayRules();
				CMath.showRightToRepair();
				if ($('#isBDAppVar').val() == 'BD') {
					CMath.showPriceVariants();
				}
				var userInfo = COSTCO.util.getMemberCookie(),
				    signedIn = userInfo.signedIn,
				    costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
				    isCostcoMembers = costcoMember,
				    memberOnly = $('#memberItem').val() == "true" ? true : false;
	
				if (COSTCO.CMath.iskitsbundle && !isUserSignedIn && memberOnly) {
					$('#bundle-button-container').addClass('hide');
				}
				if (COSTCO.CMath.iskitsbundle && isUserSignedIn && isCostcoMembers) {
					$('#bundle-button-container').removeClass('hide');
				}
				if (COSTCO.CMath.iskitsbundle && !isUserSignedIn && !memberOnly && mapItem) {
					$('#bundle-button-container').addClass('hide');
				}
	
				//Grocery US change - Depot Catalog Online - Call Ajax for contract specific details 
				if (CMath.isContractSpecificAjaxRequired()) {
					if (!COSTCO.CMath.iskitsbundle) {
						CMath.handleContractSpecificRules();
					}
				}
				if ($('#delivery-zip').val() != undefined) {
					$('#delivery-zip').val($.cookie('invCheckPostalCode'));
				}
	
				// Single Product EDD setup
				if (Array.isArray(products) && products.length > 0) {
	
					var defaultShipcode = "";
	
					if ($('#defaultShipcode').length != 0) {
						defaultShipcode = $('#defaultShipCode').val();
					}
	
					$('#showLiveEDD').val(products[0][0].eddVendorName);
					$('#vendorName').val(products[0][0].eddVendorName);
	
					if (!COSTCO.util.isEDDEnabled() || !CMath.isValidShipMode(defaultShipcode)) {
						$('#showLiveEDD').val("");
						$('#vendorName').val("");
					}
				}
				if (!COSTCO.CMath.iskitsbundle) {
					CMath.handleEDDForms();
				}
				if (phelper.isSingleItem(products) && $('#vendorName').length > 0) {
					if (COSTCO.Header.hasInvPostalCodeCookie() && COSTCO.Header.isInvStateCookieMissing()) {
						var zipcode = $.cookie('invCheckPostalCode');
						var updateZipCodeStateCookies = function updateZipCodeStateCookies(data, textstatus, XMLHttpRequest) {
	
							var locationData = COSTCO.Header.extractLocationData(data);
							var invalidZip = locationData.InvalidZip;
							var province = locationData.Province;
							var country = locationData.Country;
	
							if (!invalidZip) {
								COSTCO.Header.setDeliveryCookies(zipcode, province, country);
	
								if ((typeof $.cookie('invCheckPostalCode') === 'undefined' || $.cookie('invCheckPostalCode') == null) && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
									COSTCO.Product.showEddForm();
								} else if ($.cookie('invCheckPostalCode') != null && $('#liveEDD') && $('#liveEDD').val() === "true" && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
									COSTCO.Product.displayEDDForm = false;
									COSTCO.Product.retrieveEDD();
								} else if ($('#liveEDD') && $('#liveEDD').val() === "true" && $('#vendorName').val().toLowerCase().includes('narvar') && $('.edd-container').length > 0) {
									COSTCO.Header.itemPartNumberSelcted = products[0][0].partNumber;
									COSTCO.Header.showEDDWidget();
								} else if (typeof product !== 'undefined' && typeof product[0] !== 'undefined' && product[0].isScheduledDeliverable === "true") {
									var url = "AjaxDeliveryReservationCalendarCmd?storeId=" + wcs.storeId + "&deliveryVendorSku=" + $('#deliveryVendorSku').val() + "&zipCode=" + $.cookie('invCheckPostalCode') + "&productSku=" + $('#productPartnumberVal').val();
									COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
										sku: $('#deliveryVendorSku').val(),
										url: url,
										productSku: $('#productPartnumberVal').val(),
										zipCode: $.cookie('invCheckPostalCode')
									});
								}
							}
						};
						if ($('#isGeocodeService').val() != "true") {
							COSTCO.util.callBing(zipcode, updateZipCodeStateCookies, updateZipCodeStateCookies);
						} else {
							COSTCO.util.callGeocodeAPI(zipcode, updateZipCodeStateCookies, updateZipCodeStateCookies);
						}
					} else {
						if ((typeof $.cookie('invCheckPostalCode') === 'undefined' || $.cookie('invCheckPostalCode') == null) && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
							COSTCO.Product.showEddForm();
						} else if ($.cookie('invCheckPostalCode') != null && $('#liveEDD') && $('#liveEDD').val() === "true" && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
							COSTCO.Product.displayEDDForm = false;
							COSTCO.Product.retrieveEDD();
						} else if ($('#liveEDD') && $('#liveEDD').val() === "true" && $('#vendorName').val().toLowerCase().includes('narvar') && $('.edd-container').length > 0) {
							COSTCO.Header.itemPartNumberSelcted = products[0][0].partNumber;
							COSTCO.Header.showEDDWidget();
						} else if (typeof product !== 'undefined' && typeof product[0] !== 'undefined' && product[0].isScheduledDeliverable === "true") {
							var url = "AjaxDeliveryReservationCalendarCmd?storeId=" + wcs.storeId + "&deliveryVendorSku=" + $('#deliveryVendorSku').val() + "&zipCode=" + $.cookie('invCheckPostalCode') + "&productSku=" + $('#productPartnumberVal').val();
							COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
								sku: $('#deliveryVendorSku').val(),
								url: url,
								productSku: $('#productPartnumberVal').val(),
								zipCode: $.cookie('invCheckPostalCode')
							});
						}
					}
					// onclick of pills bfImageViewerPartnumber will be published
					window.eventBus.publish('bfImageViewerPartnumber', COSTCO.Header.itemPartNumberSelcted);
					window.reactObj.defaultItemNumber = COSTCO.Header.itemPartNumberSelcted;
				}
	
				try {
					COSTCO.util.checkAndDisableSignInButton();
				} catch (ignore) {}
			},
	
			swatchTileSelected: false,
			swatchInitialTileSelected: false,
			allVariantsSelected: false,
			swatchActiveColor: '',
			changeVariantTriggered: false,
			preSelectedAttributesPassed: false,
			preSelectedAttributesChanged: false,
	
			// A sequence of functions that shows the online price, fees/discounts, calculates and shows (if not bundle) "Your Price"
			pricingInfo: function pricingInfo(catentryid, priceOnline) {
				CMath.showOnlinePrice(catentryid);
				CMath.processEcoFee(catentryid, priceOnline);
				//Commented out the below lines as part of Canada Compliance changes
				//CMath.showFeesAndDiscounts(catentryid);
				//CMath.calculateYourPrice(catentryid);
				CMath.showTaxableFoodAttribute(catentryid);
			},
			//Implemented as part of Canada Compliance changes
			showDiscountsBreakdown: function showDiscountsBreakdown(catentryid) {
				var $disc = $('.disc[data-catentry=' + catentryid + ']');
				var $discValue = $disc.find('.disc-value');
	
				CMath.hideElements($('.disc'), $('.disc .disc-value'));
				CMath.showLocalizedValues($disc, $discValue, $disc.data('disc'));
	
				var discText = $discValue.text().trim();
				var isDiscEmpty = discText === '' || discText === '--';
				var hasHideClass = $disc.hasClass('hide');
	
				if (isDiscEmpty) {
					$disc.toggleClass('active hide');
				} else if (!isDiscEmpty && hasHideClass) {
					$disc.toggleClass('hide active');
				}
			},
			//Implemented as part of Canada Compliance changes
			showFeeBreakdown: function showFeeBreakdown(catentryId, feeArray) {
				CMath.hideElements($('.fees'), $('.fees .fee-value'));
	
				var loc = $.cookie('C_LOC');
				if (!loc || loc.length <= 2 || !Array.isArray(feeArray)) return;
				document.querySelectorAll('.fees.' + loc + '[data-catentry="' + catentryId + '"]').forEach(function (feeElement) {
					var feeType = feeElement.getAttribute('data-feeType');
					if (feeArray.includes(feeType)) {
						var $feeElement = $(feeElement);
						CMath.showLocalizedValues($feeElement, $feeElement.find('.fee-value'), $feeElement.data('feeamt'));
					}
				});
			},
			//Implemented as part of Canada Compliance changes
			processEcoFee: function processEcoFee(catentryId, priceOnline) {
				var currentRegion = COSTCO.util.getRegion();
				var ecoFeesConfigurations = typeof feesConfigurations !== 'undefined' ? feesConfigurations : null;
				var discount = $('.disc[data-catentry=' + catentryId + ']').data('disc');
				discount = discount ? parseFloat(COSTCO.util.decode(discount).replace(/,/g, '')) : 0;
	
				if (discount) {
					$('.disc[data-catentry=' + catentryId + ']').toggleClass('active hide');
					CMath.showBreakdown(true, catentryId);
					CMath.showDiscountsBreakdown(catentryId);
				} else {
					CMath.hideElements($('.disc'), $('.disc .disc-value'));
				}
				if (priceOnline) {
					$('.online-price[data-catentry=' + catentryId + '] .op-value').text(phelper.formatMoney(phelper.processPrice(priceOnline)));
					$('.online-price[data-catentry=' + catentryId + ']').data('opvalue', COSTCO.util.encode(String(priceOnline)));
				}
	
				var opPrice = COSTCO.util.decode($('.online-price[data-catentry=' + catentryId + ']').data('opvalue')) || 0;
				opPrice = parseFloat(opPrice.toString().replace(/,/g, '')) || 0;
	
				var regionECOConfig = CMath.getRegionFeeConfig(ecoFeesConfigurations, currentRegion, "EcoFee");
				var regionDepositConfig = CMath.getRegionFeeConfig(ecoFeesConfigurations, currentRegion, "Deposit");
				var regionOtherConfig = CMath.getRegionFeeConfig(ecoFeesConfigurations, currentRegion, "OtherFee");
				var categoryConfigMap = {
					EcoFee: regionECOConfig,
					Deposit: regionDepositConfig,
					OtherFee: regionOtherConfig
				};
				var feeIdMap = {
					EcoFee: [],
					Deposit: [],
					OtherFee: []
				};
				var loc = $.cookie('C_LOC');
				if (!loc || loc.length <= 2) {
					CMath.showFeeBreakdown(catentryId, null);
					CMath.calculateYouPriceV2(catentryId, false, opPrice, discount);
					return;
				}
				var feeElements = $('.fees.' + loc + '[data-catentry=' + catentryId + ']');
				document.getElementById("linkfee-container").innerHTML = "";
				var regionfees = []; // feeIds eligible for the provience
				feeElements.each(function () {
					var feeType = this.getAttribute('data-feeType');
					var feeCategory = this.getAttribute('data-feeCategory');
					if (feeCategory && feeType && feeType.trim() !== "") {
						var config = categoryConfigMap[feeCategory];
						if (config) {
							feeIdMap[feeCategory].push(feeType);
						}
					}
				});
				if (!feeElements || feeElements.length === 0) {
					CMath.showFeeBreakdown(catentryId, null);
					CMath.calculateYouPriceV2(catentryId, false, opPrice, discount);
					return;
				}
				if (!regionECOConfig) {
					console.warn("Region configuration not found");
					CMath.showFeeBreakdown(catentryId, null);
					if (regionECOConfig || regionDepositConfig || regionOtherConfig) {
						CMath.ecoFeeBreakdownDisplay(feeIdMap, null, catentryId, null, opPrice);
					}
					CMath.calculateYouPriceV2(catentryId, false, opPrice, discount);
					if ($('#isBDAppVar').val() == 'BD' && COSTCO.util.isUSBDStore()) {
						CMath.showFeesAndDiscounts(catentryId);
						if ($('#breakdown').hasClass('hide') && $('.active.online-price .op-value').text() != "--") {
							$('#breakdown').toggleClass('hide active');
						}
						CMath.calculateYourPrice(catentryId);
					}
					return;
				}
				if (regionECOConfig.feeType !== "ALL") {
					regionfees = regionECOConfig.feeType.split(',');
				}
	
				var displayLogic = {
					INTERNALIZED: function INTERNALIZED() {
						var ecofeetotal = CMath.ecoFeeBreakdownDisplay(feeIdMap, regionfees, catentryId, categoryConfigMap, opPrice);
						var combinedPrice = (opPrice + ecofeetotal).toFixed(2);
						if (ecofeetotal > 0) {
							var clonedContent = document.getElementById('priceBreakdown').cloneNode(true);
							clonedContent.removeAttribute('id');
							clonedContent.className = 'ecofee-details';
							var parentDiv = null;
							if (discount > 0) {
								parentDiv = document.querySelector('.online-price[data-catentry="' + catentryId + '"]');
							} else {
								parentDiv = document.querySelector('.your-price');
							}
							parentDiv.parentNode.insertBefore(clonedContent, parentDiv.nextSibling);
							var locale = COSTCO.util.getLocale();
							if (locale == 'fr-CA' && discount > 0) {
								document.querySelector('.ecofee-details').style.paddingLeft = '150px';
							}
							document.getElementById('priceBreakdown').innerHTML = "";
						}
						CMath.showFeeBreakdown(catentryId, null);
						CMath.calculateYouPriceV2(catentryId, false, combinedPrice, discount);
						if (combinedPrice) {
							$('.online-price[data-catentry=' + catentryId + '] .op-value').text(phelper.formatMoney(combinedPrice));
							$('.online-price[data-catentry=' + catentryId + ']').data('opvalue', combinedPrice);
						}
					},
					HIDDEN: function HIDDEN() {
						CMath.showFeeBreakdown(catentryId, null);
						var ecofeetotal = CMath.ecoFeeBreakdownDisplay(feeIdMap, regionfees, catentryId, categoryConfigMap, opPrice);
						var combinedPrice = (opPrice + ecofeetotal).toFixed(2);
						CMath.calculateYouPriceV2(catentryId, false, combinedPrice, discount);
						if (ecofeetotal) {
							$('.online-price[data-catentry=' + catentryId + '] .op-value').text(phelper.formatMoney(combinedPrice));
							$('.online-price[data-catentry=' + catentryId + ']').data('opvalue', combinedPrice);
						}
					},
					MATHTABLE: function MATHTABLE() {
						CMath.showBreakdown(true, catentryId);
						CMath.showFeeBreakdown(catentryId, feeIdMap["EcoFee"]);
	
						var ecofeetotal = CMath.ecoFeeBreakdownDisplay(feeIdMap, regionfees, catentryId, categoryConfigMap, opPrice);
						var totalSplit = opPrice + ecofeetotal;
						CMath.calculateYouPriceV2(catentryId, false, totalSplit, discount);
					},
					STANDARD: function STANDARD() {
						CMath.showFeeBreakdown(catentryId, null);
						CMath.ecoFeeBreakdownDisplay(feeIdMap, null, catentryId, categoryConfigMap, opPrice);
						CMath.calculateYouPriceV2(catentryId, false, opPrice, discount);
					}
				};
	
				(displayLogic[regionECOConfig.display.PDP] || displayLogic.STANDARD)();
	
				$('.co-help.eco-fee').popover();
			},
	
			ecoFeeBreakdownDisplay: function ecoFeeBreakdownDisplay(feeIdMap, regionfees, catentryId, displayConfig, opValue) {
				if (!displayConfig || (!feeIdMap["EcoFee"] || feeIdMap["EcoFee"].length === 0) && (!feeIdMap["Deposit"] || feeIdMap["Deposit"].length === 0) && (!feeIdMap["OtherFee"] || feeIdMap["OtherFee"].length === 0)) {
					return 0;
				}
				var ecoFeeTotal = 0;
				var ecoFeeTotalHidden = 0;
				var noEcoFeeInRegion = Array.isArray(regionfees) && regionfees.length > 0 && Array.isArray(feeIdMap.EcoFee) && feeIdMap.EcoFee.length > 0 && feeIdMap.EcoFee.some(function (id) {
					return !regionfees.includes(id);
				});
				document.getElementById("linkfee-container").innerHTML = "";
				var container = document.getElementById("linkfee-container");
				var location = $.cookie('C_LOC');
				var elements = document.querySelectorAll('.fee-parent .fees.' + location + '[data-catentry="' + catentryId + '"]');
				var tooltip = null;
				var ecoFeeHiddenTextAdded = false;
				var ecoFeeDisplay = null;
				elements.forEach(function (feeElement) {
					var feeType = feeElement.getAttribute('data-feeType');
					if (!feeType) return;
					var feeCategory = null;
					for (var category in feeIdMap) {
						if (feeIdMap[category].includes(feeType)) {
							feeCategory = category;
							break;
						}
					}
					var decodedAmount = parseFloat(atob(feeElement.getAttribute('data-feeamt')));
					var labelElement = feeElement.querySelector(".fee-label");
					var label = labelElement ? COSTCO.util.sentenceToPascalCase(labelElement.innerText.trim()) : "";
					var ecoFeeElement = feeElement.querySelector(".co-help.eco-fee");
					var linkFeeElement = feeElement.querySelector(".eco-fee");
					var tooltipClone = ecoFeeElement ? ecoFeeElement.cloneNode(true) : linkFeeElement ? linkFeeElement.cloneNode(true) : "";
					var isRegionFee = regionfees != null && regionfees.length > 0 ? regionfees.includes(feeType) : true;
					var isEcoFee = feeCategory == 'EcoFee' && isRegionFee;
					var config = displayConfig[feeCategory];
					var pdpDisplay = config && config.display ? config.display.PDP : null;
					if (isEcoFee && (pdpDisplay === 'INTERNALIZED' || pdpDisplay === 'MATHTABLE')) {
						ecoFeeTotal += decodedAmount;
						tooltip = tooltipClone;
						ecoFeeDisplay = pdpDisplay;
					} else if (isEcoFee && pdpDisplay === 'HIDDEN' && isRegionFee) {
						if (!noEcoFeeInRegion) {
							ecoFeeTotalHidden += decodedAmount;
							if (!ecoFeeHiddenTextAdded) {
								ecoFeeHiddenTextAdded = true;
								container.appendChild(CMath.createFeeRow(label, messages.ECO_FEE_INCLUDED, tooltipClone));
							}
						}
						ecoFeeTotal += decodedAmount;
					} else {
						var ecofeeamount = phelper.formatMoney(phelper.processPrice(decodedAmount.toFixed(2)), true);
						container.appendChild(CMath.createFeeRow(label, '+' + ecofeeamount, tooltipClone));
					}
				});
	
				if (ecoFeeTotal > 0 && ecoFeeDisplay === 'INTERNALIZED') {
					var breakdownDiv = document.getElementById('priceBreakdown');
					var itemprice = phelper.formatMoney(phelper.processPrice(opValue.toFixed(2)), true);
					var totalEcofeeAmount = phelper.formatMoney(phelper.processPrice(ecoFeeTotal.toFixed(2)), true);
					breakdownDiv.innerHTML = '(' + itemprice + ' + ' + totalEcofeeAmount + ' ' + messages.PDETAIL_ECOFEE_TEXT + '<span class="eco-fee-tool"></span>)';
					if (tooltip) breakdownDiv.querySelector(".eco-fee-tool").appendChild(tooltip);
				}
				if (ecoFeeTotalHidden > 0) {
					var _discount = $('.disc[data-catentry=' + catentryId + ']').data('disc');
					_discount = _discount ? parseFloat(COSTCO.util.decode(_discount).replace(/,/g, '')) : 0;
					if (_discount > 0) {
						opValue -= _discount;
					}
					var combinedPrice = (opValue + ecoFeeTotalHidden).toFixed(2);
					var addedprice = phelper.formatMoney(phelper.processPrice(combinedPrice), true);
					document.getElementById("ecoFeeHiddenLayout_" + catentryId).value = addedprice;
				}
	
				return ecoFeeTotal;
			},
			createFeeRow: function createFeeRow(label, valueHtml, tooltipElement) {
				var div = document.createElement("div");
				div.className = "fee-row linkfee_";
				div.innerHTML = '\n\t            <div class="fee-name linkfee_">' + label + '</div>\n\t            <div class="fee-info-icon linkfee_"></div>\n\t            <div class="fee-value pull-right">' + valueHtml + '</div>\n\t        ';
				if (tooltipElement) div.querySelector(".fee-info-icon").appendChild(tooltipElement);
				return div;
			},
			getRegionFeeConfig: function getRegionFeeConfig(feeDisplayConfig, currentRegion, feeCategory) {
				if (!feeDisplayConfig) return null;
				var regionFees = feeDisplayConfig[currentRegion] || feeDisplayConfig["ALL"] || [];
				return regionFees.find(function (fee) {
					return fee.feeCategory === feeCategory;
				}) || null;
			},
			// A utility function that first hides the "Online Price" for each product on the page and then shows the particular "Online Price" (div) associated with the passed catentryId 
			showOnlinePrice: function showOnlinePrice(catentryid) {
				CMath.hideElements($('.online-price'), $('.online-price .op-value'));
				CMath.useRegionFeeIncludedOpValue($('.online-price[data-catentry=' + catentryid + ']'), catentryid);
			},
			// A utility function that first hides the "Fees / Discounts" for each product on the page and then shows the particular "Fees / Discounts" (divs) associated with the passed catentryId
			showFeesAndDiscounts: function showFeesAndDiscounts(catentryid) {
				CMath.hideElements($('.disc'), $('.disc .disc-value'));CMath.hideElements($('.fees'), $('.fees .fee-value'));
				CMath.showLocalizedValues($('.disc[data-catentry=' + catentryid + ']'), $('.disc[data-catentry=' + catentryid + '] .disc-value'), $('.disc[data-catentry=' + catentryid + ']').data('disc'));
				if ($('.disc[data-catentry=' + catentryid + '] .disc-value').text() == '' || $('.disc[data-catentry=' + catentryid + '] .disc-value').text() == '--') {
					$('.disc[data-catentry=' + catentryid + ']').toggleClass('active hide');
				} else if (($('.disc[data-catentry=' + catentryid + '] .disc-value').text() != '' || $('.disc[data-catentry=' + catentryid + '] .disc-value').text() != '--') && $('.disc[data-catentry=' + catentryid + ']').hasClass('hide')) {
					$('.disc[data-catentry=' + catentryid + ']').toggleClass('hide active');
				}
				if ($.cookie('C_LOC') != null) {
					if ($.cookie('C_LOC').length > 2) {
						if ($('.fees.' + $.cookie('C_LOC') + '[data-catentry=' + catentryid + ']').length > 0) {
							// fees exist for this region
							$('.fees.' + $.cookie('C_LOC') + '[data-catentry=' + catentryid + ']').each(function () {
								var isFeeCombined = false;
								if (typeof feesCombineWithPrice !== 'undefined') {
									for (var i = 0; i < feesCombineWithPrice.length; i++) {
										var config = feesCombineWithPrice[i];
										if (config.region == $.cookie('C_LOC') && config.feeId == $(this).data('feeid')) {
											isFeeCombined = true;
											break;
										}
									}
								}
								if (isFeeCombined == false) {
									CMath.showLocalizedValues($(this), $(this).find('.fee-value'), $(this).data('feeamt'));
								}
							});
						}
					}
				}
			},
			//Method to display the taxable food item label in the PDP page
			showTaxableFoodAttribute: function showTaxableFoodAttribute() {
				if (typeof taxableCatalogsAttributes !== 'undefined' && taxableCatalogsAttributes != null) {
					for (var i = 0; i < taxableCatalogsAttributes.length; i++) {
						var taxableAttr = taxableCatalogsAttributes[i];
						var regionCode = $.cookie('C_LOC');
						if (regionCode !== 'undefined' && regionCode != null && taxableAttr.value === regionCode.slice(-2)) {
							$("#taxable-item").removeClass('hide');
							break;
						} else {
							$("#taxable-item").addClass('hide');
						}
					}
				}
			},
			// Display Right to Repair content based on the region
			showRightToRepair: function showRightToRepair() {
				if (typeof righToRepairConfig !== 'undefined' && righToRepairConfig != null) {
					var rtrRegions = righToRepairConfig.split(",");
					for (var i = 0; i < rtrRegions.length; i++) {
						var rtrRegion = rtrRegions[i];
						var regionCode = $.cookie('C_LOC');
						if (regionCode !== 'undefined' && regionCode != null && rtrRegion === regionCode.slice(-2)) {
							$("#right-to-repair").removeClass('hide');
							break;
						} else {
							$("#right-to-repair").addClass('hide');
						}
					}
				}
			},
	
			// Main workhorse. Calculates the "Your Price" after adding any fees and then subtracting any discount associated with the catentryid. Always returns a double
			calculateYouPriceV2: function calculateYouPriceV2(catentryid, isBundle, finalprices, discount) {
				CMath.showLocalizedValues($('.online-price[data-catentry=' + catentryid + ']'), $('.online-price[data-catentry=' + catentryid + '] .op-value'), $('.online-price[data-catentry=' + catentryid + ']').data('opvalue'));
				var finalPrice = finalprices - discount;
				if (!isBundle) {
					if ($('#isBDAppVar').val() == 'BD') {
						$('.your-price .value').text(phelper.formatMoney(phelper.processPrice(finalPrice)));
						if ($('.unitcurrency').text() == null || $('.unitcurrency').text() == '$-.- -' || $('.unitcurrency').text().trim() == '' || COSTCO.util.getLocale() == 'fr-CA') {
							$('#price-per-unit-container').addClass('hide');
						} else {
							$('#price-per-unit-container').show();
							$('#price-per-unit-container').removeClass('hide');
						}
					} else {
						if (finalPrice != 0.00) {
							$('.your-price .value').text(phelper.formatMoney(phelper.processPrice(finalPrice)));
						}
					}
					if ($('#isBDAppVar').val() != 'BD') {
						$('#price-per-unit-container').show();
					}
				}
				return finalPrice;
			},
	
			calculateYourPrice: function calculateYourPrice(catentryid, isBundle) {
				var opPrice;
				if (catentryid) {
					opPrice = COSTCO.util.decode($('.online-price[data-catentry=' + catentryid + ']').data('opvalue'));
				}
				if ($.type(opPrice) === 'string') {
					opPrice = opPrice.split(',').join('');
				}
				var opValue = parseFloat(opPrice) || 0.00;
				var discount = $('.disc[data-catentry=' + catentryid + ']').data('disc') ? COSTCO.util.decode($('.disc[data-catentry=' + catentryid + ']').data('disc')) : 0.00;
				discount = $.type(discount) === 'string' ? parseFloat(discount.split(',').join('')) : discount;
				var fees = function () {
					var totalFees = 0.00;
					if ($.cookie('C_LOC') != null) {
						if ($.cookie('C_LOC').length > 2) {
							$('.fees.' + $.cookie('C_LOC') + '[data-catentry=' + catentryid + ']').each(function () {
								var isFeeCombined = false;
								if (typeof feesCombineWithPrice !== 'undefined') {
									for (var i = 0; i < feesCombineWithPrice.length; i++) {
										var config = feesCombineWithPrice[i];
										if (config.region == $.cookie('C_LOC') && config.feeId == $(this).data('feeid')) {
											isFeeCombined = true;
											opValue += parseFloat(COSTCO.util.decode($(this).data('feeamt')));
											break;
										}
									}
								}
								if (!isFeeCombined) {
									totalFees += parseFloat(COSTCO.util.decode($(this).data('feeamt')));
								}
							});
						}
					}
					return totalFees;
				}();
	
				$('.online-price[data-catentry=' + catentryid + '] .op-value').text(phelper.formatMoney(phelper.processPrice(opValue)));
				$('.online-price[data-catentry=' + catentryid + ']').attr('data-opvalue', COSTCO.util.encode(opValue + ''));
	
				var finalPrice = opValue + fees - discount;
				if (!isBundle) {
					if ($('#isBDAppVar').val() == 'BD') {
						$('.your-price .value').text(phelper.formatMoney(phelper.processPrice(finalPrice)));
						if ($('.unitcurrency').text() == null || $('.unitcurrency').text() == '$-.- -' || $('.unitcurrency').text().trim() == '' || COSTCO.util.getLocale() == 'fr-CA') {
							$('#price-per-unit-container').addClass('hide');
						} else {
							$('#price-per-unit-container').show();
							$('#price-per-unit-container').removeClass('hide');
						}
					} else {
						if (finalPrice != 0.00) {
							$('.your-price .value').text(phelper.formatMoney(phelper.processPrice(finalPrice)));
						}
					}
					if ($('#isBDAppVar').val() != 'BD') {
						$('#price-per-unit-container').show();
					}
				}
				return finalPrice;
			},
			// Generic utility function for hiding the passed element. Additionally, this function encodes the hidden values to base64
			hideElements: function hideElements(element, valueHolder) {
				$(element).each(function () {
					if (!$(this).hasClass('hide')) {
						$(this).addClass('hide');
					}
					if ($(this).hasClass('active')) {
						$(this).removeClass('active');
					}
				});
				$(valueHolder).each(function () {
					if (!COSTCO.util.base64test.test($(this).text())) {
						$(this).text(COSTCO.util.encode($(this).text()));
					}
				});
			},
			// Hides price per unit container
			hidePricerPerUnit: function hidePricerPerUnit() {
				if (products[0].length > 1) {
					$('#price-per-unit-container').hide();
				}
			},
			// Generic utility function for showing the localized values of valueHolder.
			showLocalizedValues: function showLocalizedValues(parent, valueHolder, value) {
				$(parent).toggleClass('hide');$(parent).toggleClass('active');
				if ($('#isBDAppVar').val() == 'BD') {
					$(valueHolder).text(phelper.formatMoney(phelper.processPrice(value)));
				} else {
					if (phelper.processPrice(value) != 0.00) {
						$(valueHolder).text(phelper.formatMoney(phelper.processPrice(value)));
					} else {
						$(valueHolder).text('--');
					}
				}
			},
			// Show the math table breakdown (true/false). True is show, false is hide.
			showBreakdown: function showBreakdown(flag, catentryId) {
				if (flag) {
					var sameVals = $('.active.online-price .op-value').text() == $('.your-price .value').text();
					if ($('#breakdown').hasClass('hide') && !sameVals && $('.active.online-price .op-value').text() != "--") {
						$('#breakdown').toggleClass('hide active');
					} else if ($('#breakdown').hasClass('active') && sameVals) {
						$('#breakdown').toggleClass('active hide');
					}
				} else {
					if ($('#breakdown').hasClass('active')) {
						$('#breakdown').toggleClass('active hide');
						if ($('#isBDAppVar').val() != 'BD') {
							$('.your-price .value').text('--');
							CMath.hidePricerPerUnit();
						}
					}
				}
			},
			/**
	   * Uses feesCombineWithPrice config set from xappconfig to determine if
	   * eco-fee should be hidden and included in the online-price
	   */
			useRegionFeeIncludedOpValue: function useRegionFeeIncludedOpValue(parent, catentryid) {
				function getRegionPrice(regionPrices, region) {
					for (var i = 0; i < regionPrices.length; i++) {
						if (regionPrices[i].region == region) {
							return regionPrices[i].price;
						}
					}
					return null;
				}
				function getFeeId(feeOptions, region) {
					for (var i = 0; i < feeOptions.length; i++) {
						if (feeOptions[i].region == region) {
							return feeOptions[i].feeId;
						}
					}
					return null;
				}
	
				function getFeeIds(feeOptions, region) {
					var feeIds = [];
					for (var i = 0; i < feeOptions.length; i++) {
						if (feeOptions[i].region == region) {
							feeIds.push(feeOptions[i].feeId);
						}
					}
					return feeIds;
				}
				var region = COSTCO.util.getRegion();
				if (region && region != '""' && $('.fees.' + region).length > 0 && typeof feesCombineWithPrice != 'undefined') {
					var productData = phelper.findItem(products[0], catentryid) || [];
					var feeIds = getFeeIds(productData.feeOptions, region);
					var isAllFeesCombined = false;
					if (feeIds && feeIds.length > 0) {
						feeIds.forEach(function (feeId) {
							var isFeeCombined = false;
							for (var i = 0; i < feesCombineWithPrice.length; i++) {
								var config = feesCombineWithPrice[i];
								if (config.region == region && config.feeId == feeId) {
									isFeeCombined = true;
									break;
								}
							}
							isAllFeesCombined = isAllFeesCombined && isFeeCombined;
						});
						if (isAllFeesCombined == true) {
							hideBreakdownvariants = true;
						}
					}
				}
			},
			/* Product Options (variants) controller */
			bindQuantitiesForBundle: function bindQuantitiesForBundle() {
				var $qtys = $('input[name^=quantity-]'),
				    has_math_table = $('.math-table').length > 0;
				$qtys.unbind('change.bundleQty').on('change.bundleQty', function () {
					var total = 0.00,
					    allQtyVals = $.map($qtys, function (e) {
						var qtyVal = parseInt($(e).val());return isNaN(qtyVal) ? 0 : qtyVal;
					});
					if (has_math_table) {
						$qtys.each(function (i) {
							var qtyVal = parseInt($(this).val()),
							    quantity = isNaN(qtyVal) || qtyVal < 0 ? 0 : qtyVal,
							    //if product is not a number or negative treat as 0
							catentryid = CMath.getCatEntryId($(this).data('product'));
							typeof catentryid !== 'undefined' ? total += CMath.calculateYourPrice(catentryid, true) * quantity : allQtyVals[i] = 0;
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
								var itemTotal = CMath.calculateYourPrice(catentryid, true) * quantity;
								var itemProcesPrice = phelper.processPrice(itemTotal);
								var itemFormatMoney = COSTCO.util.formatMoney(itemProcesPrice, true);
								$('#bundle-' + this.id).closest('.bundle-item').find('.bundle-item-total').text(itemFormatMoney);
							}
						});
					}
					//treat quantity value that is negative as 0
					if (COSTCO.util.all(allQtyVals, function (x) {
						return x == 0 || x < 0;
					})) {
						CMath.addToCartSwitch(false);
						$('.your-price .value').text('--');
						CMath.hidePricerPerUnit();
					} else {
						CMath.addToCartSwitch(true);
						if (has_math_table) {
							$('.your-price .value').text(COSTCO.util.formatMoney(phelper.processPrice(total)), true);
						}
					}
				});
			},
			/**
	      * Updates item number section for Bundle without variance.
	      * @return void
	      */
			updateItemNumberDisplay: function updateItemNumberDisplay() {
				$('#product-body-item-number').html(messages.PDETAIL_NUMBER + products[0][0].partNumber);
				$('#product-body-item-number').removeClass('hide');
			},
			// Each variant select associated with a product gets a change event that controls if to calculate a price (i.e. if there are any unselected values as part of a multi-variant product). Handles bundles
			bindVariantProducts: function bindVariantProducts(type, inOption) {
	
				if (typeof inOption !== 'undefined') {
					$('.varis').find('option[value=' + inOption + ']').prop('selected', true);
				}
				$('.varis').each(function (variIndex) {
					if (variIndex + 1 == $('.varis').length && (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions || costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE)) {
						console.log("Binding the Variants Selected ");
						COSTCO.CMath.allVariantsSelected = true;
					}
					$(this).parent().find('select[data-product=' + $(this).data('product') + ']').unbind('change.vari').on('change.vari', function () {
						var num = $(this).data('product');
						var variantProductIndex = $(this).index('.varis[data-product=' + num + ']');
						var optionsSelected = phelper.get_selected_array($('.varis[data-product=' + num + ']').find('option:selected'));
						if (isPDPVariantGreyOutEnabled == 'true') {
							//Analytics for variants
							for (var i = 0; i < optionsSelected.length; i++) {
	
								var $selectedOption = $('.varis option[value=' + optionsSelected[i] + ']');
								var productOptionId = $selectedOption.parent().attr('id');
								var $selectedOptionLabel = $('label[for=' + productOptionId + ']');
								var $selectedOptionKey = $selectedOptionLabel.find('.selectedOptionKey');
								var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
								var selectedlabelText = $selectedOptionKey.text().split(':')[0].trim();
								window.digitalDataEvents = window.digitalDataEvents || [];
								var swatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 1) + '').length > 0;
								var dropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').length > 0;
								if (swatch) {
									var swatchvalue = $('span[automation-id=selectionItem_' + optionsSelected[i] + ']').text().trim();
									digitalDataEvents.push({ uimsg: "Product Detail | " + selectedlabelText + " | " + swatchvalue + "" });
								} else if (dropDown) {
									var dropdownvalue = $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[i] + ']').text().trim();
									if (!dropdownvalue.includes(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
										digitalDataEvents.push({ uimsg: "Product Detail | " + selectedlabelText + " | " + dropdownvalue + "" });
									}
								}
							}
						}
						if (optionsSelected.length == 3 && !COSTCO.CMath.iskitsbundle) {
							// inorder to handle multivariant 3 level on page load this iteration is required for enabling lower level
							for (var i = 0; i < optionsSelected.length - 1; i++) {
								CMath.next_variant_attributes(i, num, optionsSelected[i]);
							}
						} else {
							if (!COSTCO.CMath.iskitsbundle || COSTCO.CMath.iskitsbundle && !dropDown) {
								CMath.next_variant_attributes(variantProductIndex, num, $(this).find('option:selected').val());
							}
						}
	
						optionsSelected = phelper.get_selected_array($('.varis[data-product=' + num + ']').find('option:selected'));
						var any_unselected = optionsSelected.indexOf("unselected") > -1;
						var any_selected = COSTCO.util.any(optionsSelected, function (x) {
							return x != "unselected";
						});
						var selectedCatentryid = CMath.getCatEntryId(num, optionsSelected);
						var selectedProgramType = CMath.getItemProgramType(num, optionsSelected);
						var isShipToWarehouseItem = CMath.isShipToWarehouseItem(num, optionsSelected);
						var applType = $('#applicationType').val();
						CMath.disableSelectsAfterUnselected($('.varis[data-product=' + num + ']').parent(), optionsSelected, type);
						if (applType == 'BC') {
							var varaintParameters = { "productId": selectedCatentryid, "programType": selectedProgramType, "storeId": wcs.storeId };
							if (selectedCatentryid != undefined && selectedProgramType != undefined) {
								if ((typeof selectedObj === 'undefined' ? 'undefined' : _typeof(selectedObj)) === undefined || JSON.stringify(selectedObj) !== JSON.stringify(varaintParameters)) {
									selectedObj = varaintParameters;
									window.reactObj.global.shipToWarehouse = isShipToWarehouseItem;
									window.reactObj.fulfillments.buyInStoreOnly.productId = selectedCatentryid;
									window.reactObj.fulfillments.buyInStoreOnly.programType = selectedProgramType;
									if (phelper.item_type == 'single_variant' || phelper.item_type == 'multi_variant') {
										window.reactObj.fulfillments.buyInStoreOnly.wcsVariant = true;
										window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi = false;
										var readInvFromBatchApiXapp = $('#readInvFromBatchApiEnabled').val();
										if (readInvFromBatchApiXapp === 'true') {
											window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi = true;
										}
									}
									try {
										if (_typeof(window.reactObj.fulfillments.buyInStoreOnly) != undefined) {
											if (_typeof(window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi) != undefined && window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi) {
												window.wioEventBus.publish('notifyVaraintsChange', varaintParameters);
											} else {
												var itemStockStatusExist = false;
												var selectedPartNum = '';
												$.each(products, function (index, jsonObject) {
													$.each(jsonObject, function (key, value) {
														if (value['catentry'] === selectedCatentryid) {
															selectedPartNum = value['partNumber'];
														}
													});
												});
												$.each(COSTCO.CMath.varItemJSON, function (index, jsonObject) {
													$.each(jsonObject, function (key, value) {
														$.each(value, function (objKey, objValue) {
															if (objKey === 'itemNumber' && objValue === selectedPartNum) {
																itemStockStatusExist = true; // verify if selected item stock exists
															}
														});
													});
												});
												if (itemStockStatusExist) {
													window.wioEventBus.publish('notifyVaraintsChange', varaintParameters);
												}
											}
										}
									} catch (e) {
										console.log(e);
									}
								}
							}
						}
	
						var preselectAttrsStr = COSTCO.util.getParameterByName('preselect');
						if (typeof preselectAttrsStr !== 'undefined' && preselectAttrsStr != null && preselectAttrsStr != 'null' && CMath.preSelectedAttributesChanged == false) {
							var preselectAttrArr = preselectAttrsStr.split('||');
							CMath.preSelectedAttributesPassed = true;
							if (preselectAttrArr.length == 1) {
								preselectAttrKeyVal = preselectAttrArr[0];
								var replaceSelected = '';
								var replaceNextVariant = '';
								var preselectAttrKeyValArr = preselectAttrKeyVal.split(':');
								optionsSelected.forEach(function (selectedOption, selectedIndex) {
									options[0].forEach(function (optionsArr) {
										if (optionsArr['n'].toLowerCase() == preselectAttrKeyValArr[0]) {
											if (optionsArr['v'].hasOwnProperty(selectedOption) == true) {
												Object.keys(optionsArr['v']).forEach(function (attrVal) {
													if (optionsArr['v'][attrVal].toLowerCase() == preselectAttrKeyValArr[1] && attrVal.toLowerCase() == selectedOption) {
														console.log(preselectAttrKeyValArr[1] + " value is preselected ");
													} else if (optionsArr['v'][attrVal].toLowerCase() == preselectAttrKeyValArr[1]) {
														replaceSelected = attrVal;
														console.log(preselectAttrKeyValArr[1] + " new value is preselected " + attrVal);
													}
												});
												if (replaceSelected !== '') {
													optionsSelected.splice(optionsSelected.indexOf(selectedOption), 1, replaceSelected);
													$('.varis').find('option[value=' + replaceSelected + ']').prop('selected', true);
	
													var nextSelectedIndex = selectedIndex == 0 ? 1 : 0;
													products[0].forEach(function (product, index) {
														if (product.options.includes(replaceSelected) == true) {
	
															if (product.options.includes(optionsSelected[nextSelectedIndex]) == true) {
																console.log("The Variant Exists .. ");
																replaceNextVariant = optionsSelected[nextSelectedIndex];
															} else {
																if (replaceNextVariant == '') {
																	replaceNextVariant = product.options[0] == replaceSelected ? product.options[1] : product.options[0];
																}
															}
														}
													});
													if (typeof replaceNextVariant != 'undefined' && replaceNextVariant != '') {
														optionsSelected.splice(nextSelectedIndex, 1, replaceNextVariant);
														$('.varis').find('option[value=' + replaceNextVariant + ']').prop('selected', true);
													}
													CMath.next_variant_attributes(variantProductIndex, num, replaceSelected);
													replaceSelected = '';
													replaceNextVariant = '';
												}
											}
										}
									});
								});
							} else {
								preselectAttrArr.forEach(function (preselectAttrKeyVal, index) {
									var replaceSelected = '';
									var preselectAttrKeyValArr = preselectAttrKeyVal.split(':');
									optionsSelected.forEach(function (selectedOption, selectedIndex) {
										options[0].forEach(function (optionsArr) {
											if (optionsArr['n'].toLowerCase() == preselectAttrKeyValArr[0]) {
												if (optionsArr['v'].hasOwnProperty(selectedOption) == true) {
													Object.keys(optionsArr['v']).forEach(function (attrVal) {
														if (optionsArr['v'][attrVal].toLowerCase() == preselectAttrKeyValArr[1] && attrVal.toLowerCase() == selectedOption) {
															console.log(preselectAttrKeyValArr[1] + " value is preselected ");
														} else if (optionsArr['v'][attrVal].toLowerCase() == preselectAttrKeyValArr[1]) {
															replaceSelected = attrVal;
															console.log(preselectAttrKeyValArr[1] + " new value is preselected " + attrVal);
														}
													});
													if (replaceSelected !== '') {
														optionsSelected.splice(optionsSelected.indexOf(selectedOption), 1, replaceSelected);
														$('.varis').find('option[value=' + replaceSelected + ']').prop('selected', true);
														replaceSelected = '';
													}
												}
											}
										});
									});
								});
							}
							CMath.preSelectedAttributesChanged = true;
							$('body').trigger("costco.variant.changed");
						}
	
						if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && !$(optionsSelected).parents('.vari').is('.swatchDropdown[data-swatch-mode=2]')) {
	
							optionsSelected.forEach(function (value) {
								CMath.update_selected_option_label(value);
							});
							CMath.disableSelectsAfterUnselected($('.varis-v2[data-product=' + num + ']').parent(), optionsSelected, type);
							try {
	
								for (var i = $('.varis[data-product=0]').length - 1; i > 0; i--) {
									$("#productOption0" + i + " option[style*='display: none']").each(function () {
										$("#swatches-productOption0" + i + " input[value*='" + $(this).val() + "']").parent().hide();
										$(this).attr('disabled', 'disabled').hide();
									});
	
									$("#productOption0" + i + " option[style*='display: block'], #productOption0" + i + " option[style*='display: inline']").each(function () {
										if ($("#swatches-productOption0" + i + " input:checked:enabled").length < 1) {
											$("#swatches-productOption0" + i + " input[value*='" + $(this).val() + "']").click();
											$(this).removeAttr('disabled').show();
											return false;
										}
									});
								}
							} catch (e) {
								console.log(e);
							}
						}
	
						if (type === 'bundle') {
							// If we're a bundle and at least one variant is selected and its associated qty
							// is 0, set it to one to help user.
							if (any_selected) {
								var $input = $(this).parents('.variantContainer').find('.bundleQty input'),
								    input_val = $input.val();
								if (!isNaN(parseInt(input_val)) && parseInt(input_val) == 0) {
									$input.val(1);
								}
							}
							$('input[name^=quantity-]').trigger('change.bundleQty');
						}
						if (type !== 'bundle' && any_unselected) {
							CMath.showLowestPriceVariant();
							//if the catentryid is undefined it means there is no option selected
							//in that case show default variant backorder message 
							if (typeof catentryid === "undefined") {
								$('#backorder-message').text(variantBackorderMessageDefault);
								$('#backorder-message').show();
							}
						} else {
							$('.starting-price').hide();
						}
	
						var catentryid = CMath.getCatEntryId(num, optionsSelected);
						if (product[0].isScheduledDeliverable === "true" && catentryid) {
							//invoke if item is scheduledDeliverable and a variant has been selected
							window.COSTCO.ScheduledDeliverable.setDeliverableInputsFromSelectedProduct();
						}
						var variantIndex = 0;
						var deliveryVendorSku = '';
						COSTCO.Product.active_catentry = catentryid;
						//populate the catalogEntryID property in the add to cart form with the 
						//catentry ID for the resolved item.
						if (typeof catentryid !== "undefined") {
							COSTCO.CMath.allVariantsSelected = true;
							if (type === 'bundle') {
								$('input[name=catalogEntryId_' + (num + 1) + ']').val(catentryid);
							} else {
								//exclude the contract specific flow as price will be populated by ajax in that flow
								$('input[name=catEntryId]').val(catentryid);
								if ($('#isBDAppVar').val() == 'BD') {
									CMath.pricingInfo(catentryid);
									$('.unitcurrency').text('$' + phelper.formatMoney(phelper.processPrice(phelper.findItem(products[num], optionsSelected).pricePerUnit)));
									if ($('.unitcurrency').text() == null || $('.unitcurrency').text() == '$-.- -' || $('.unitcurrency').text().trim() == '' || COSTCO.util.getLocale() == 'fr-CA') {
										$('#price-per-unit-container').addClass('hide');
									} else {
										$('#price-per-unit-container').show();
										$('#price-per-unit-container').removeClass('hide');
									}
									CMath.showBreakdown(true);
								}
								//Exclude LocationControlled Inv items
								if (!COSTCO.util.islocationControlledInventoryFlow() && $('#isBDAppVar').val() == 'BD') {
									//show backorder message only on variants that are backorder and hide for the rest
									var variantInventory = phelper.findItem(products[num], optionsSelected).inventory;
									var vaiantType = phelper.findItem(products[num], optionsSelected).type;
									if (variantInventory && variantInventory === COSTCO.util.productConstants.inv_backorderd || vaiantType > 2) {
										$('#backorder-message').text(phelper.findItem(products[num], optionsSelected).backorderMessage);
										$('#backorder-message').show();
										$('.edd-container').hide();
									} else {
										$('#backorder-message').hide();
										$('.edd-container').show();
									}
								}
	
								for (var i = 0; i < products[0].length; i++) {
									if (products[0][i].catentry === catentryid) {
										variantIndex = i;
										break;
									}
								}
							}
						} else {
							//Only 1 attribute is selected from multi-variant
							COSTCO.CMath.allVariantsSelected = false;
							for (var i = 0; i < products[0].length; i++) {
								if (products[0][i].options[0] === optionsSelected[0] || products[0][i].options[1] === optionsSelected[0]) {
									variantIndex = i;
									break;
								}
							}
						}
						for (var i = 0; i < products[0].length; i++) {
							if (products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock) {
								deliveryVendorSku = deliveryVendorSku + products[0][i].manufacturerPartNumber + ",";
							}
						}
						if (deliveryVendorSku.length > 0) {
							deliveryVendorSku = deliveryVendorSku.slice(0, deliveryVendorSku.length - 1);
						}
	
						if (any_selected) {
							if ($(window).width() < 769) {
								$('.item-model-number').removeClass('col-xs-12');
								//STR0167115 - ALM26087
								//and STRY0167115...
								if (products[0] !== undefined && products[0][variantIndex] !== undefined && products[0][variantIndex].vendorModelNumber !== undefined && products[0][variantIndex].vendorModelNumber !== "") {
									if (messages !== undefined && messages.PDETAIL_MODEL !== undefined) {
										$('#model-no').html(messages.PDETAIL_MODEL + products[0][variantIndex].vendorModelNumber);
									} else {
										$('#model-no').html(products[0][variantIndex].vendorModelNumber);
									}
								}
							} else {
	
								//STRY0167115...
								if (products[0] !== undefined && products[0][variantIndex] !== undefined && products[0][variantIndex].partNumber !== undefined && products[0][variantIndex].partNumber !== "") {
									if (messages !== undefined && messages.PDETAIL_NUMBER !== undefined) {
										$('#product-body-item-number').html(messages.PDETAIL_NUMBER + products[0][variantIndex].partNumber);
									} else {
										$('#product-body-item-number').html(products[0][variantIndex].partNumber);
									}
								}
								$('#product-body-item-number').removeClass('hide');
								if (COSTCO.CMath.iskitsbundle) {
									if (products[0] !== undefined && products[0][variantIndex] !== undefined && products[0][variantIndex].productName !== undefined && products[0][variantIndex].productName !== "") {
										$('[automation-id="productName"]').text(products[0][variantIndex].productName);
									}
								}
								//STR0167115 - ALM26087
								//and STRY0167115...
								if (products[0] !== undefined && products[0][variantIndex] !== undefined && products[0][variantIndex].vendorModelNumber !== undefined && products[0][variantIndex].vendorModelNumber !== "") {
									if (messages !== undefined && messages.PDETAIL_MODEL !== undefined) {
										$('#product-body-model-number').html(messages.PDETAIL_MODEL + products[0][variantIndex].vendorModelNumber);
									} else {
										$('#product-body-model-number').html(products[0][variantIndex].vendorModelNumber);
									}
								}
							}
	
							$('#showLiveEDD').val(products[0][variantIndex].eddVendorName);
							$('#vendorName').val(products[0][variantIndex].eddVendorName);
	
							var defaultShipcode = "";
	
							if ($('#defaultShipcode').length != 0) {
								defaultShipcode = $('#defaultShipCode').val();
							}
	
							if (!COSTCO.util.isEDDEnabled() || !CMath.isValidShipMode(defaultShipcode)) {
								$('#showLiveEDD').val("");
								$('#vendorName').val("");
							}
							if ((isRegionalPdtAvlble || !COSTCO.util.issiteControlledInventoryFlow()) && initalizeAjaxCall || $('#isBDAppVar').val() == 'BD' || (phelper.item_type == 'single_variant' || phelper.item_type == 'multi_variant') && !initalizeAjaxCall && !COSTCO.CMath.iskitsbundle) {
								CMath.handleEDDForms();
							}
	
							if (messages !== undefined && messages.PDETAIL_NUMBER !== undefined) {
								$('#item-no').html(messages.PDETAIL_NUMBER + products[0][variantIndex].partNumber);
							} else {
								$('#item-no').html(products[0][variantIndex].partNumber);
							}
	
							COSTCO.Header.itemPartNumberSelcted = products[0][variantIndex].partNumber;
	
							// update sku/itemNumber for analytics
	
							window.digitalDataEvents = window.digitalDataEvents || [];
							if (typeof window.digitalData !== "undefined" && typeof window.digitalData.product !== "undefined" && typeof window.digitalData.product[0] !== "undefined") {
								window.digitalData.product[0].sku = products[0][variantIndex].partNumber;
								window.digitalData.product[0].itemNumber = products[0][variantIndex].partNumber;
							}
						}
						if (product[0].isScheduledDeliverable === "true") {
							//invoke if item is scheduledDeliverable and a variant has been selected
	
							$('#deliveryVendorSku').val(products[0][variantIndex].manufacturerPartNumber);
							$('#deliveryVendorSkuArr').val(deliveryVendorSku);
	
							//attach event to select options button
							window.COSTCO.ScheduledDeliverable.attachEventSelectOptions({
								sku: $('#deliveryVendorSku').val(),
								categoryCode: $('#categoryCode').val(),
								zipCode: $('#delivery-zip').val()
	
							});
							var swatchMode = $('.swatchDropdown').data('swatch-mode');
	
							if ($('#catEntryId').val() == COSTCO.Product.active_catentry && previousContractAjaxItem != COSTCO.Header.itemPartNumberSelcted && (swatchMode == 2 && (brandfolderEnabled || COSTCO.CMath.swatchTileSelected && COSTCO.CMath.swatchInitialTileSelected) || (swatchMode == 1 || swatchMode == 0) && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions || (swatchMode == 1 || swatchMode == 0) && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions_V2)) {
								previousContractAjaxItem = COSTCO.Header.itemPartNumberSelcted;
								if (products[0][variantIndex].zipcodeAvailabilityMessage === '0' || typeof products[0][variantIndex].zipcodeAvailabilityMessage === "undefined") {
									window.COSTCO.ScheduledDeliverable.resetDeliverableForm();
									var url = "AjaxDeliveryReservationCalendarCmd?storeId=" + wcs.storeId + "&deliveryVendorSku=" + $('#deliveryVendorSku').val() + "&zipCode=" + $.cookie('invCheckPostalCode') + "&productSku=" + $('#productPartnumberVal').val();
									COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
										sku: $('#deliveryVendorSku').val(),
										url: url,
										productSku: $('#productPartnumberVal').val(),
										zipCode: $.cookie('invCheckPostalCode')
									});
								} else if (typeof products[0][variantIndex].zipcodeAvailabilityResponseCode !== "undefined" && products[0][variantIndex].zipcodeAvailabilityResponseCode === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
									if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
										$('#deliveryFailMessage').removeClass("hide");
										$('#prod-page-delivery').removeClass('hide');
										$('#zip-group').addClass('hide');
										if (products[0][variantIndex].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd) {
											$('#deliveryFailMessage').addClass("warning").removeClass("critical-notification");
											$('[name=select-options]').prop("disabled", false);
										} else {
											$('#deliveryFailMessage').removeClass("warning").addClass("critical-notification");
											$('[name=select-options]').prop("disabled", true);
										}
										$('#geDeliveryFailMessageSpan').text(products[0][variantIndex].zipcodeAvailabilityMessage);
										$('#deliveryDateMessage').removeClass('success').addClass('hide');
										$('#deliveryLocationText').addClass('hide');
										$('#deliveryInfoText').addClass("hide");
									} else {
										$('#deliveryFailMessage').removeClass("hide");
										$('#prod-page-delivery').addClass('hide');
										$('#zip-group').addClass('hide');
										$('#geDeliveryFailMessageSpan').text(products[0][variantIndex].zipcodeAvailabilityMessage);
										$('#deliveryDateMessage').removeClass('success').addClass('hide');
										$('#deliveryLocationText').addClass('hide');
										$('#deliveryInfoText').addClass("hide");
										if (products[0][variantIndex].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd) {
											$('[name=select-options]').prop("disabled", false);
										} else {
											$('[name=select-options]').prop("disabled", true);
										}
									}
								} else {
									if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
										var deliveryDate = products[0][variantIndex].zipcodeAvailabilityMessage;
										var date = deliveryDate ? new Date(deliveryDate).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }) : "";
										$('#deliveryDateMessageTxt').text(date);
									} else {
										$('#deliveryDateMessageTxt').text(products[0][variantIndex].zipcodeAvailabilityMessage);
									}
									$('#zip-group').removeClass('hide');
									$('#deliveryFailMessage').addClass("hide");
									$('#prod-page-delivery').addClass('hide');
									$('#deliveryDateMessage').removeClass('hide').addClass('success');
									$('#deliveryLocationText').removeClass('hide');
									$('#deliveryInfoText').removeClass("hide");
								}
							}
						}
						if ($(this).parents('.vari').is('.swatchDropdown[data-swatch-mode=1]')) {
							var swatchable = $(this).find('option:selected[data-swatch]');
							if (swatchable.length > 0) {
								CMath.triggerSwatchDropDownSelection($(swatchable).data('swatch'));
							}
						}
	
						if (any_selected && (typeof catentryid !== "undefined" || !catentryid) && COSTCO.CMath.allVariantsSelected) {
							$('body').trigger("costco.variant.changed");
							var _swatchMode = $('.swatchDropdown').data('swatch-mode');
							if ($('#catEntryId').val() == COSTCO.Product.active_catentry && (_swatchMode == 2 && (brandfolderEnabled || COSTCO.CMath.swatchTileSelected && COSTCO.CMath.swatchInitialTileSelected) || (_swatchMode == 1 || _swatchMode == 0) && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions || (_swatchMode == 1 || _swatchMode == 0) && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions_V2)) {
								if ($.cookie('invCheckPostalCode') != null && $('#liveEDD') && $('#liveEDD').val() === "true" && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
									if ((typeof selectedVar === 'undefined' ? 'undefined' : _typeof(selectedVar)) === undefined || selectedVar != $('#catEntryId').val()) {
										selectedVar = $('#catEntryId').val();
										COSTCO.Product.displayEDDForm = false;
										COSTCO.Product.retrieveEDD();
										COSTCO.Product.isEddItem = true;
									}
								} else if ($('#productPage').val() && $('#liveEDD') && $('#liveEDD').val() === "true" && $('#vendorName').val().toLowerCase().includes('narvar') && $('.edd-container').length > 0) {
									COSTCO.CMath.callEDDFunctions();
								}
							}
						}
	
						if ((!(any_selected && (typeof catentryid !== "undefined" || !catentryid)) || typeof $.cookie('invCheckPostalCode') === 'undefined' || $.cookie('invCheckPostalCode') == null) && $('#edd-form-block').length > 0 && !$('#vendorName').val().toLowerCase().includes('narvar')) {
							COSTCO.Product.showEddForm();
						}
						//block ajax calls which are repeated and in case of variation only trigger ajax after its first call from init 
						if ($('.swatchDropdown').data('swatch-mode') == 2 && (!COSTCO.CMath.swatchTileSelected || COSTCO.CMath.swatchTileSelected && previousContractAjaxItem === '')) {
							brandfolderEnabled ? blockContractAjax = false : blockContractAjax = true;
						} else {
							blockContractAjax = false;
						}
						var userInfo = COSTCO.util.getMemberCookie(),
						    signedIn = userInfo.signedIn,
						    costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
						    memberOnly = $('#memberItem').val() == "true" ? true : false;
						var itemPartNumber = COSTCO.Product.getPartnumber();
	
						varaintParameters = { "productId": selectedCatentryid, "programType": selectedProgramType, "partNumber": itemPartNumber, "storeId": wcs.storeId };
						if (isShipToWarehouseItem) {
							window.wioEventBus.publish('notifyVaraintsChangeForSTW', varaintParameters);
						}
	
						var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
						//Invoke contract specific ajax on each selection		
						if (!COSTCO.CMath.iskitsbundle) {
							if (CMath.changeVariantTriggered && CMath.isContractSpecificAjaxRequired() && selectedCatentryid != undefined) {
								retryCount = 0;
								if (!memberOnly || signedIn && memberOnly) {
									CMath.handleContractSpecificRules();
								} else {
									if (isPDPVariantGreyOutEnabled == 'true' && !(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) && !scheduledDeliverable) {
										COSTCO.CMath.invokeBatchCallForUpperLevel(itemPartNumber);
										COSTCO.CMath.handlePillsForGuest();
										COSTCO.CMath.invokeAjaxCall = false;
									}
								}
							} else {
								if (isPDPVariantGreyOutEnabled == 'true' && !(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) && !scheduledDeliverable) {
									COSTCO.CMath.invokeBatchCallForUpperLevel(itemPartNumber);
									COSTCO.CMath.handlePillsForGuest();
									COSTCO.CMath.invokeAjaxCall = false;
								}
							}
						}
						var itemPartNumber = COSTCO.Product.getPartnumber();
						window.reactObj.fulfillments.buyInStoreOnly.partNumber = itemPartNumber;
						window.eventBus.publish('bfImageViewerPartnumber', itemPartNumber);
						window.eventBus.publish('pdpSwatchUpdate', itemPartNumber);
						window.eventBus.subscribe('reactReady', function () {
							window.eventBus.publish('bfImageViewerPartnumber', itemPartNumber);
						});
						window.eventBus.subscribe('swatchReady', function () {
							window.eventBus.publish('pdpSwatchUpdate', itemPartNumber);
						});
						window.reactObj.defaultItemNumber = itemPartNumber;
						if (COSTCO.CMath.iskitsbundle) {
							COSTCO.CMath.invokeBuildABundle(catentryid);
						}
					});
	
					if (!CMath.changeVariantTriggered) {
						$(this).trigger('change.vari');
						CMath.changeVariantTriggered = true;
					}
				});
			},
			//FOr GuestUser, To handle pills selection based on oos response
			handlePillsForGuest: function handlePillsForGuest() {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				var len = optionsSelected.length;
				$('#swatches-productOption0' + parseInt(len - 1) + ' .selection-box-v2').find('span.selection-item').each(function () {
					$(this).removeClass("select-span1-OOS");
				});
				var variable;
				var lowerSwatch = $('#swatches-productOption0' + parseInt(len - 1) + '').length > 0;
				if (lowerSwatch) {
					// pills
					if (COSTCO.Product.item_type === 'multi_variant') {
	
						variable = $('input[value=' + optionsSelected[len - 1] + ']').next().attr("automation-id");
					} else if (COSTCO.Product.item_type === 'single_variant') {
						// $('.selection-item').removeClass("select-span1-OOS");
						variable = $('input[value=' + optionsSelected[0] + ']').next().attr("automation-id");
					}
					if ($('span[automation-id=' + variable + ']').hasClass('span1-outofstock')) {
						$('span[automation-id=' + variable + ']').addClass("select-span1-OOS");
					}
				}
				CMath.update_selected_option_label(optionsSelected[len - 1]);
			},
			callEDDFunctions: function callEDDFunctions() {
				if (COSTCO.Header.narvarDCFetchedSku == '' || COSTCO.Header.narvarDCFetchedSku != COSTCO.Header.itemPartNumberSelcted) {
					if (COSTCO.Header.hasInvPostalCodeCookie() && COSTCO.Header.isInvStateCookieMissing()) {
						var zipcode = $.cookie('invCheckPostalCode');
						var updateZipCodeStateCookies = function updateZipCodeStateCookies(data, textstatus, XMLHttpRequest) {
	
							var locationData = COSTCO.Header.extractLocationData(data);
							var invalidZip = locationData.InvalidZip;
							var province = locationData.Province;
							var country = locationData.Country;
	
							if (!invalidZip) {
								COSTCO.Header.setDeliveryCookies(zipcode, province, country);
								if (COSTCO.Header.narvarDCFetchedSku == '' || COSTCO.Header.narvarDCFetchedSku != COSTCO.Header.itemPartNumberSelcted) {
									COSTCO.Header.startEDDMutationObserver();
									COSTCO.Header.showEDDWidget();
								}
							}
						};
						if ($('#isGeocodeService').val() != "true") {
							COSTCO.util.callBing(zipcode, updateZipCodeStateCookies, updateZipCodeStateCookies);
						} else {
							COSTCO.util.callGeocodeAPI(zipcode, updateZipCodeStateCookies, updateZipCodeStateCookies);
						}
					} else {
						COSTCO.Header.startEDDMutationObserver();
						COSTCO.Header.showEDDWidget();
					}
				}
			},
	
			// A utility function that disables successive selects of variant products if their previous is unselected. Supports n multivariants
			disableSelectsAfterUnselected: function disableSelectsAfterUnselected(styleSelects, optionsArray, type) {
	
				$(styleSelects).removeClass('disabled');
				$(styleSelects).find('select').removeAttr('disabled');
				var unselectedPos = optionsArray.indexOf("unselected");
				if (type !== 'bundle') {
					if (unselectedPos > -1) {
						CMath.addToCartSwitch(false);
					} else {
						CMath.addToCartSwitch(true);
					}
				}
				for (var i = unselectedPos == -1 ? optionsArray.length - 1 : unselectedPos, len = optionsArray.length; i < len; i++) {
					$($(styleSelects)[i + 1]).addClass('disabled');
					$($(styleSelects)[i + 1]).find('select').attr("disabled", "disabled");
					$($(styleSelects)[i + 1]).find('option[value=unselected]').prop('selected', true);
				}
			},
	
			/**
	   * Utility function that determines what combination of variants is valid
	   * @param  {[type]}
	   * @param  {[type]}
	   * @param  {[type]}
	   * @return {[type]}
	   */
			next_variant_attributes: function next_variant_attributes(current_index, product_num, prev_variant_value) {
				var $next_variant = $($('.varis[data-product=' + product_num + ']')[current_index + 1]);
				var optionsSelected = phelper.get_selected_array($('.varis[data-product=' + product_num + ']').find('option:selected'));
				var upperVariant = optionsSelected.length > 2 ? optionsSelected[0] : '';
				if ($next_variant.length > 0) {
	
					var $next_variant_options = $next_variant.find('option:not(.defaultOpt)');
	
					var _$variant_option_input = void 0;
					var $variant_option_label = void 0;
					var $variant_option_dropbox = void 0;
	
					$('.varis-v2').attr('disabled', 'disabled');
					$next_variant_options.attr('disabled', 'disabled').hide().each(function (index, opt) {
	
						if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	
							if (numberOfOptionsToDisplayAsTiles && $next_variant_options.length < numberOfOptionsToDisplayAsTiles) {
	
								_$variant_option_input = $('input[value=' + opt.value + ']');
								$variant_option_label = _$variant_option_input.closest('label');
								_$variant_option_input.attr('disabled', 'disabled');
								_$variant_option_input.prop('checked', false);
							} else {
	
								$variant_option_dropbox = $('.varis-v2').find('option[value=' + opt.value + ']');
								$variant_option_dropbox.attr('disabled', 'disabled').hide();
							}
						}
	
						products[product_num].forEach(function (product_obj) {
							var upperlevelCheck = upperVariant != '' ? COSTCO.util.hasElem(upperVariant, product_obj.options) : true;
							if (COSTCO.util.hasElem(prev_variant_value, product_obj.options) && COSTCO.util.hasElem(opt.value, product_obj.options) && upperlevelCheck) {
	
								$(opt).removeAttr('disabled').attr("style", "display: block;");
								$(opt)[0].disabled = false;
	
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	
									if (numberOfOptionsToDisplayAsTiles && $next_variant_options.length < numberOfOptionsToDisplayAsTiles) {
	
										$variant_option_label.removeClass('disabled');
										$variant_option_label.show();
										$variant_option_label.css('display', '');
										_$variant_option_input.removeAttr('disabled');
										if (_$variant_option_input.siblings()[0]) {
											CMath.update_variant_option(_$variant_option_input.siblings(), product_obj, $next_variant_options.length);
										}
									} else {
	
										$variant_option_dropbox.removeAttr('disabled').show();
										if ($variant_option_dropbox[0]) {
											CMath.update_variant_option($variant_option_dropbox[0], product_obj, $next_variant_options.length);
										}
									}
								}
							}
							if (typeof prev_variant_value === "undefined" || prev_variant_value == null || product_obj.options.includes(prev_variant_value)) {
								CMath.update_variant_option(opt, product_obj, $next_variant_options.length);
							}
						});
					});
					$next_variant.find('option[value=unselected]').prop('selected', true);
					if ($next_variant.find('option:enabled').length > 0 && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
						$($next_variant.find('option:enabled')[0]).prop('selected', true);
					}
					if ($variant_option_dropbox) {
						var dropdownIndex = current_index + 1;
						newoptval = $($('.varis-v2[name=productOption0' + dropdownIndex + ']').find('option:enabled')[0]).val();
						$($('.varis-v2[name=productOption0' + dropdownIndex + ']').find('option:enabled')[0]).prop('selected', true);
						$($($next_variant.find('option[value=' + newoptval + ']'))[0]).prop('selected', true);
					}
				} else if (typeof prev_variant_value === "undefined" || prev_variant_value == null) {
					var $variant_options = $('.varis[data-product=' + product_num + ']').find('option:not(.defaultOpt)');
					$variant_options.each(function (index, opt) {
						products[product_num].forEach(function (product_obj) {
							CMath.update_variant_option(opt, product_obj, $variant_options.length);
						});
					});
				}
			},
	
			/**
	   * Function that updates variant option label for selected options
	   */
			update_selected_option_label: function update_selected_option_label(value) {
	
				if (value != 'unselected') {
	
					var $selectedOption = $('.varis option[value=' + value + ']');
					var productOptionId = $selectedOption.parent().attr('id');
					var $selectedOptionLabel = $('label[for=' + productOptionId + ']');
					var $selectedOptionKey = $selectedOptionLabel.find('.selectedOptionKey');
					var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	
					$selectedOptionKey.html($selectedOptionKey.text()[$selectedOptionKey.text().length - 1] == ':' ? $selectedOptionKey.text() : $selectedOptionKey.text() + ':');
					$selectedOptionValue.html(' ' + $selectedOption.text());
					if ($('#isBDAppVar').val() != 'BD' && isPDPVariantGreyOutEnabled == 'true') {
						if ($('span[automation-id=selectionItem_' + value + ']').hasClass("select-span1-OOS")) {
							if (!$selectedOptionValue.text().includes(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
								$selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
							}
						} else if ($('.varis-v2 option[automation-id=varisOption_' + value + ']').hasClass("out-of-stock")) {
							if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
								var textToReplace = $selectedOptionValue.text();
								var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
								$selectedOptionValue.text(newText);
								$selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
							}
						}
					}
					$selectedOptionValue.show();
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
						$variant_option_input = $('input[value=' + value + ']');
						$variant_option_input.prop('checked', true);
					}
				} else {
	
					var $defaultOptions = $('option[value=' + value + ']');
					$defaultOptions.each(function (index, element) {
	
						if ($(element).prop('selected')) {
	
							var productOptionId = $(element).parent().attr('id');
							var $defaultOptiontLabel = $('label[for=' + productOptionId + ']');
							var $defaultOptionKey = $defaultOptiontLabel.find('.selectedOptionKey');
							$defaultOptionKey.html($defaultOptionKey.text()[$defaultOptionKey.text().length - 1] == ':' ? $defaultOptionKey.text().substring(0, $defaultOptionKey.text().length - 1) : $defaultOptionKey.text());
							$defaultOptiontLabel.find('.selectedOptionValue').hide();
						}
					});
				}
			},
	
			/**
	   * Function that disables/enables variant option and updates option text
	   */
			update_variant_option: function update_variant_option(opt, product_obj, nextVariantLength) {
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
					$(opt).siblings().each(function (index, option) {
						if (typeof option.innerHTML != 'undefined' && !option.innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							$(option).removeAttr('disabled');
						}
					});
					$(opt).closest('label').removeClass('disabled');
				}
				//Update backorder / not available text for multivariant products
				if (typeof opt.value !== "undefined" && product_obj.options.includes(opt.value)) {
					if (product_obj.inventory === COSTCO.util.productConstants.inv_backorderd || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd && product_obj.zipcodeAvailabilityResponseCode === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	
						if ($(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
							$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
						}
						if (!$(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)) {
							$(opt)[0].innerHTML += ' - ' + messages.BACKORDER_TEXT;
						}
					} else if (product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
	
						if ($(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)) {
							var sliceStr = ' - ' + messages.BACKORDER_TEXT;
							$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
						}
						if (!$(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							$(opt)[0].innerHTML += ' - ' + messages.OUT_OF_STOCK_TEXT;
						}
						if (product_obj.zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_outOfStock) {
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
								$(opt).siblings().attr('disabled', 'disabled');
								$(opt).closest('span').addClass('disabled');
							}
							$(opt).attr('disabled', 'disabled');
						}
					} else {
						if ($(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT) || $(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							if ($(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)) {
								var sliceStr = ' - ' + messages.BACKORDER_TEXT;
								$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
							}
							if ($(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
								var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
								$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
							}
							$(opt)[0].disabled = false;
						}
					}
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
						if (typeof opt.value !== "undefined") {
							$variant_option_input = $('input[value=' + opt.value + ']');
							if (typeof $variant_option_input.siblings('.selection-item')[0] !== "undefined") {
								$variant_option_input.siblings('.selection-item')[0].innerHTML = $(opt)[0].innerHTML;
							}
							$variant_option_span = $variant_option_input.closest('span');
							if ($variant_option_span.length > 0) {
								if (product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
									$variant_option_span.addClass('disabledSwatch');
								} else {
									$variant_option_span.removeClass('disabledSwatch');
								}
							}
						}
					}
				}
			},
	
			// A utility function to retrieve that catentry of a product by passing the product number and an array of the options selected associated with that product number.
			getCatEntryId: function getCatEntryId(productNum, optionsSelected) {
				var catentryid;
				if (phelper.item_type == 'single') {
					return products[0][0].catentry;
				} else {
					var productArray = products ? products[productNum] : [];
					var optionsSelected = optionsSelected || phelper.get_selected_array($('.varis[data-product=' + productNum + ']').find('option:selected'));
					var product_selected = phelper.findItem(productArray, optionsSelected);
					return product_selected && product_selected.catentry ? product_selected.catentry : undefined;
				}
			},
			getItemProgramType: function getItemProgramType(productNum, optionsSelected) {
				var programType;
				if (phelper.item_type == 'single') {
					return products[0][0].programType;
				} else {
					var productArray = products ? products[productNum] : [];
					var optionsSelected = optionsSelected || phelper.get_selected_array($('.varis[data-product=' + productNum + ']').find('option:selected'));
					var product_selected = phelper.findItem(productArray, optionsSelected);
					return product_selected && product_selected.programType ? product_selected.programType : undefined;
				}
			},
	
			isShipToWarehouseItem: function isShipToWarehouseItem(productNum, optionsSelected) {
				var shipToWarehouse;
				if (phelper.item_type == 'single') {
					return products[0][0].shipToWarehouse;
				} else {
					var productArray = products ? products[productNum] : [];
					var optionsSelected = optionsSelected || phelper.get_selected_array($('.varis[data-product=' + productNum + ']').find('option:selected'));
					var product_selected = phelper.findItem(productArray, optionsSelected);
					return product_selected && product_selected.shipToWarehouse ? product_selected.shipToWarehouse : false;
				}
			},
	
			// A function that enables/disables the add-to-cart button; true = enable, false = disable.
			addToCartSwitch: function addToCartSwitch(test) {
				if (test) {
					//add-to-car button
					$('#add-to-cart input[name=add-to-cart]').removeAttr('disabled');
					$(".add-to-list-button").show();
					//add-to-wishlist button
					//ALM22204 Show the Add to List option once the variant is selected
					$("#add-to-wishlist").show();
					$("#addListbtn").show();
					$("#add-to-wishlist").removeClass("add-to-wishlist-desactive");
					$("#addListbtn").removeClass("add-to-wishlist-desactive");
					if ($('#add-to-cart input[name=add-to-cart]').val() == 'Out of Stock') {
						$('#add-to-cart input[name=add-to-cart]').attr('disabled', 'disabled');
					}
				} else {
					//Add to Cart Button need not be disabled if the Contract Ajax had been invoked
					if (!isRegionalPdt) {
						//add-to-car button
						$('#add-to-cart input[name=add-to-cart]').attr('disabled', 'disabled');
					}
					$("#add-to-list").hide();
					//Ensure 'Add to Registry' div spans the whole row on mobile when 'Add to List' button is hidden
					$("#mr-registry-container").removeClass("col-xs-6").addClass("col-xs-12");
	
					//add-to-wishlist button
					//ALM22204 Hide the Add to List option until the variant is selected
					$("#add-to-wishlist").hide();
					$("#addListbtn").hide();
					$("#add-to-wishlist").addClass("add-to-wishlist-desactive");
					$("#addListbtn").addClass("add-to-wishlist-desactive");
				}
			},
			// Change event on region selector to associate fees with their respective region.
			regionSelector: function regionSelector() {
				$('#regionDropdown').unbind('change.regionFees').on('change.regionFees', function (e) {
					CMath.pricingInfo($('.active.online-price').data('catentry'));
					CMath.showBreakdown(true);
				});
			},
			//Grocery US change - Depot Catalog Online - Retrieve the contract specific details of an item
			handleContractSpecificRules: function handleContractSpecificRules() {
				retryCount++;
				if ((COSTCO.util.islocationControlledInventoryFlow() || COSTCO.util.issiteControlledInventoryFlow() && phelper.item_type != 'bundle') && retryCount <= retryLimit) {
					CMath.hideElementsBeforeAjax();
					previousContractAjaxItem = COSTCO.Header.itemPartNumberSelcted;
					var productId = $("input[name='productBeanId']").val();
					if (productId == undefined) {
						productId = product[0].catentry;
					}
					if (productId) {
						//Invoke ajax call
						//CMath.showContractSpecificData(productId);
						CMath.callAjaxInventory(productId);
					}
				}
			},
			//Grocery US change - Depot Catalog Online - Invoke ajax call
			/**
	   * Invokes the AjaxGetContractPriceCmd controller command to fetch default contract and contract based
	   * price  and handle it's response, setting the jsp view accordingly.
	   */
			showContractSpecificData: function showContractSpecificData(data) {
				var productOnlinePrice = parseFloat(0.00).toFixed(2);
				var catentryid = $('#catEntryId').val();
				var pricePerUnit = "";
				var dispOnZeroInv = true;
				var isFrozenItem = $('#isFrozenItem').val();
				var isBundleItem = $('#bundleItem').val();
				var signedIn = false;
				signedIn = COSTCO.util.getMemberCookie().signedIn;
				isRegionalPdt = COSTCO.util.islocationControlledInventoryFlow();
				isRegionalPdtAvlble = false;
				blockContractAjax = false;
				$('#product-page').addClass('ajax-busy');
				//Call AJAX to get the contract prices of the given item
				COSTCO.util.ajax({
					url: '/AjaxGetContractPrice',
					method: 'GET',
					dataType: 'json',
					data: {
						itemId: encodeURIComponent(data.itemId),
						catalogId: wcs.catalogId,
						productId: data.productId[0],
						isFrozenItem: isFrozenItem,
						isRegionalPdt: isRegionalPdt,
						isBundleItem: isBundleItem
	
					},
					done: function done(data, textStatus, jqXHR, options) {
						$('#product-page').removeClass('ajax-busy');
						CMath.showBreakdown(false);
						if (data.errorMessageKey) {
							//setUp2DayErrorPage with zip code overlay
							if (data.errorMessageKey == 'ERR_2DAY_PRICE_INVALID') {
								CMath.handleContractPriceAjaxFailure(data);
							} else {
								CMath.setUp2DayErrorPage();
								if (!signedIn) {
									$('.view-zip-signin').removeClass('hide');
								}
								$('.grocery-zip-form').removeClass('hide');
								$('.your-price .value').text('- -.- -');
								$('.unitcurrency').text('$-.- -');
								$('.math-table').show();
								$('#price-per-unit-container').show();
								//Paint the error message on the zip code overlay
								if (data.errorMessageKey != 'ERR_ZIP_NOTVALID') {
									$('.alert-notification').empty();
									$('.critical-notification').empty();
									var error = COSTCO.util.get_decoded_html(data.errorMessage);
	
									if (data.errorMessageKey != 'ERR_2DAY_NOT_AVAILABLE' && data.errorMessageKey != 'ERR_2DAY_ITEM_UNAVAILABLE' && data.errorMessageKey != 'ERR_LOCATIONCONTROLLED_ITEM_UNAVAILABLE') {
										error = error.replace(/[0-9]*\./, $.cookie('invCheckPostalCode') + '.');
									}
									CMath.addBorderToShipItMolecule('default');
									$('.alert-notification').append(error);
									$('.alert-notification').removeClass('hide');
									$('.critical-notification').addClass('hide');
								}
							}
							$('.online-price[data-catentry=' + catentryid + ']').data('inv', COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail);
							$('.edd-container').hide();
							$('#edd-message-block').hide();
							$('#backorder-message').hide();
	
							COSTCO.Product.toggleDeliveryMoleculeOnComingSoon();
						} else {
							productOnlinePrice = data.finalOnlinePrice;
							pricePerUnit = data.pricePerUnit;
							discount = data.discount;
							catentryid = data.itemId;
							//if there exists value for price
							if (typeof productOnlinePrice !== 'undefined' && !isNaN(productOnlinePrice)) {
								//if there exists value for discount, show discount node
								if (typeof discount !== 'undefined' && !isNaN(discount) && discount != 0.0) {
									$('.disc[data-catentry=' + catentryid + ']').toggleClass('hide active');
									$('.disc[data-catentry=' + catentryid + '] .disc-value').text(phelper.formatMoney(phelper.processPrice(discount)));
									$('.disc[data-catentry=' + catentryid + ']').data('disc', COSTCO.util.encode(discount + ''));
									CMath.showBreakdown(true);
								} else {
									//remove the discount node if there is no discount
									if ($('.disc').length > 0) {
										$('.disc[data-catentry=' + catentryid + ']').toggleClass('active hide');
									}
								}
								//Paint the contract price on PDP and encode the final item price to PDP page
								$('.online-price[data-catentry=' + catentryid + '] .op-value').text(phelper.formatMoney(phelper.processPrice(productOnlinePrice)));
								$('.online-price[data-catentry=' + catentryid + ']').data('opvalue', COSTCO.util.encode(productOnlinePrice + ''));
								if (!$('.online-price').length && !$('.your-price').length) {
									if ($('.marketing-container .merchandisingText').text() == '') {
										$('.marketing-container .merchandisingText').text("Starting at $" + phelper.formatMoney(phelper.processPrice(productOnlinePrice)));
									}
								}
								if (pricePerUnit.length > 0) {
									//populate the price per unit based on contract price
									$('.unitcurrency').text('$' + phelper.formatMoney(phelper.processPrice(pricePerUnit)));
								}
	
								if ($('.unitcurrency').text() == null || $('.unitcurrency').text() == '$-.- -' || $('.unitcurrency').text().trim() == '' || COSTCO.util.getLocale() == 'fr-CA') {
									$('#price-per-unit-container').addClass('hide');
								} else {
									$('#price-per-unit-container').show();
									$('#price-per-unit-container').removeClass('hide');
								}
								//Handle other render events - 
								//Rules to hide/show UI elements , based on bussines requirement -
								//This will only be executed after Successfull price update.
	
								CMath.pricingInfo($('.online-price[data-catentry=' + catentryid + ']').data('catentry'), productOnlinePrice);
							}
						}
					}, fail: function fail(data) {
						CMath.handleContractPriceAjaxFailure(data);
					}
				});
			},
			callAjaxInventory: function callAjaxInventory(productId) {
	
				var catentryid = $('#catEntryId').val();
				if (catentryid == undefined) {
					catentryid = products[0][0].catentry;
				}
				var dispOnZeroInv = true;
				var isFrozenItem = $('#isFrozenItem').val();
				var isBundleItem = $('#bundleItem').val();
				var whParam = COSTCO.LWSearch.getRegionalLocations();
				var warehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
				var signedIn = false;
				backordered = false;
				COSTCO.CMath.isBackOrderFlag = false;
				initalizeAjaxCall = true;
				var backorderMessage = '';
				signedIn = COSTCO.util.getMemberCookie().signedIn;
				isRegionalPdt = COSTCO.util.islocationControlledInventoryFlow();
				isRegionalPdtAvlble = false;
				COSTCO.CMath.invAvailableAjax = false;
				COSTCO.CMath.isWarehouseEnabled = false;
				blockContractAjax = false;
				$('#product-page').addClass('ajax-busy');
				COSTCO.util.ajax({
					url: '/AjaxGetInventoryDetail',
					method: 'GET',
					dataType: 'json',
					data: {
						itemId: encodeURIComponent(catentryid),
						catalogId: wcs.catalogId,
						productId: productId,
						WH: whParam,
						warehouse: warehouse,
						isFrozenItem: isFrozenItem,
						isRegionalPdt: isRegionalPdt,
						isBundleItem: isBundleItem
					},
					done: function done(data, textStatus, jqXHR, options) {
						$('#product-page').removeClass('ajax-busy');
						var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
						//Display out of stock overlay over product image
						if (data.errorMessageKey) {
							CMath.setUp2DayErrorPage();
							if (!signedIn) {
								$('.view-zip-signin').removeClass('hide');
							}
							$('.grocery-zip-form').removeClass('hide');
							//Read variable from jsp to see whether price call happened already
							var isPriceCallInvokedForPickup = $('#isPriceCallInvokedForPickup').val();
							if (isPriceCallInvokedForPickup == 'false') {
								$('.your-price .value').text('- -.- -');
							}
							$('.unitcurrency').text('$-.- -');
							$('.math-table').show();
							$('#price-per-unit-container').show();
							if ($('#price-per-unit-container').hasClass('hide') && isPriceCallInvokedForPickup == 'false') {
								$('#price-per-unit-container').removeClass('hide');
							}
							//Paint the error message on the zip code overlay
							if (data.errorMessageKey != 'ERR_ZIP_NOTVALID') {
								$('.alert-notification').empty();
								$('.critical-notification').empty();
								var error = COSTCO.util.get_decoded_html(data.errorMessage);
	
								if (data.errorMessageKey != 'ERR_2DAY_NOT_AVAILABLE' && data.errorMessageKey != 'ERR_2DAY_ITEM_UNAVAILABLE' && data.errorMessageKey != 'ERR_LOCATIONCONTROLLED_ITEM_UNAVAILABLE') {
									error = error.replace(/[0-9]*\./, $.cookie('invCheckPostalCode') + '.');
								}
								CMath.addBorderToShipItMolecule('default');
								$('.alert-notification').append(error);
								$('.alert-notification').removeClass('hide');
								$('.critical-notification').addClass('hide');
							}
	
							$('.online-price[data-catentry=' + catentryid + ']').data('inv', COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail);
							$('.edd-container').hide();
							$('#edd-message-block').hide();
							$('#backorder-message').hide();
							if (isPDPVariantGreyOutEnabled == 'true' && (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant')) {
								var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
								var len = optionsSelected.length;
								var itemPartNumber = COSTCO.Product.getPartnumber();
								var lowerSwatch = $('#swatches-productOption0' + parseInt(len - 1) + '').length > 0;
								var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0;
								$('#swatches-productOption0' + parseInt(len - 1) + ' .selection-box-v2').find('span.selection-item').each(function () {
									$(this).removeClass("select-span1-OOS");
								});
								var status = '0';
								COSTCO.CMath.updateAjaxStockStatus(status, itemPartNumber, lowerSwatch, lowerDropDown);
								COSTCO.CMath.isErrorlocationControlleditem = true;
								//Following code for invoke batch API if we are switching upper level swatch/dropdown 
								if ($('div.buyinstoreonly.MuiBox-root').length > 0) {
									COSTCO.CMath.isWarehouseEnabled = true;
								} else {
									COSTCO.CMath.isWarehouseEnabled = false;
								}
								COSTCO.CMath.invokeBatchCallForUpperLevel(itemPartNumber);
							}
							//Check for coming soon flag
							COSTCO.Product.toggleDeliveryMoleculeOnComingSoon();
						} else {
							var _optionsSelected2 = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
							var len = _optionsSelected2.length;
							var lowerSwatch = $('#swatches-productOption0' + parseInt(len - 1) + '').length > 0;
							var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0;
							var itemPartNumber = COSTCO.Product.getPartnumber();
							COSTCO.CMath.isErrorlocationControlleditem = false;
							isRegionalPdtAvlble = data.invAvailable;
							COSTCO.CMath.invAvailableAjax = data.invAvailable;
							COSTCO.CMath.isWarehouseEnabled = data.isWarehouseEnabled;
							dispOnZeroInv = data.dispOnZeroInvtry;
							backordered = data.isBackOrdered;
							COSTCO.CMath.isBackOrderFlag = data.isBackOrdered;
							backorderMessage = data.backOrderMessage;
							COSTCO.CMath.invokeAjaxCall = true;
							COSTCO.CMath.isWioEnabled = data.isWioEnabled;
							COSTCO.CMath.isBopiwEnabled = data.isBopiwEnabled;
	
							//If the product coming soon and feature flags are false, do this
							if (!(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag)) {
								if (isPDPVariantGreyOutEnabled == 'true' && !scheduledDeliverable) {
									$('#swatches-productOption0' + parseInt(len - 1) + ' .selection-box-v2').find('span.selection-item').each(function () {
										$(this).removeClass("select-span1-OOS");
									});
									//Following code for invoke batch API if we are switching upper level swatch/dropdown 
									COSTCO.CMath.invokeBatchCallForUpperLevel(itemPartNumber);
								}
								if (isPDPVariantGreyOutEnabled == 'false') {
									if (!isRegionalPdtAvlble && dispOnZeroInv && !backordered) {
										var oosImgTag = COSTCO.util.tmpl('tmpl_oos_overlay_img');
										$('#productImageOverlay').prepend(oosImgTag);
										$('.primary-clause').hide();
									} else {
										if (!$('#vendorName').val()) {
											$('.primary-clause').show();
										}
									}
								}
								if (!isRegionalPdtAvlble && !backordered && isPDPVariantGreyOutEnabled == 'true' && !scheduledDeliverable) {
									var status = '0';
									COSTCO.CMath.updateAjaxStockStatus(status, itemPartNumber, lowerSwatch, lowerDropDown);
	
									//$('.primary-clause').show();
								} else {
									if (isPDPVariantGreyOutEnabled == 'true' && !scheduledDeliverable) {
										var status = '1';
										COSTCO.CMath.updateAjaxStockStatus(status, itemPartNumber, lowerSwatch, lowerDropDown);
	
										//Following code for remove css of previous selected swatches
										if (lowerSwatch) {
											// pills
											if (COSTCO.Product.item_type === 'multi_variant') {
												var len = _optionsSelected2.length;
												variable = $('input[value=' + _optionsSelected2[len - 1] + ']').next().attr("automation-id");
											} else if (COSTCO.Product.item_type === 'single_variant') {
												$('.selection-item').removeClass("select-span1-OOS");
												variable = $('input[value=' + _optionsSelected2[0] + ']').next().attr("automation-id");
											}
											$('span[automation-id=' + variable + ']').removeClass("select-span1-OOS");
											$('span[automation-id=' + variable + ']').removeClass("span1-outofstock");
											$('span[automation-id=' + variable + ']').children("p").remove(); // for removing P tag
										} else if (lowerDropDown) {
											// lower level drop-down
											$('.varis-v2 option[automation-id=varisOption_' + _optionsSelected2[len - 1] + ']').removeClass("out-of-stock");
											$('.varis-v2 option[automation-id=varisOption_' + _optionsSelected2[len - 1] + ']').children("span").remove();
											COSTCO.CMath.update_selected_option_label(_optionsSelected2[len - 1]);
										}
										if ($('#swatches-productOption0' + parseInt(_optionsSelected2.length - 2) + '').length > 0) {
											COSTCO.Product.strikeUpperLevelVariant(_optionsSelected2);
										} else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(_optionsSelected2.length - 2) + ']').length > 0) {
											COSTCO.Product.grayOutUpperLevelDropDown(_optionsSelected2);
										}
									}
								}
								var isEDDItem = $('#liveEDD').length > 0 && $('#liveEDD').val() === 'true';
								//For LocationControlledInventory Items 
								if (backordered && backorderMessage !== '') {
									$('#backorder-message').text(backorderMessage);
									$('#backorder-message').append('<span id="backordered"></span>');
									$('#backorder-message').show();
									$('.edd-container').hide();
									$('#edd-message-block').hide();
									$('.online-price[data-catentry=' + catentryid + ']').data('inv', COSTCO.util.productConstants.inv_backorderd);
									if (isRegionalPdt) {
										$('.primary-clause').hide(); //Added this for Depozipin hide this message in delivery molecule
									}
								} else {
									$('#backorder-message').hide();
									$('.edd-container').show();
									$('.online-price[data-catentry=' + catentryid + ']').data('inv', 'IN_STOCK');
									if (isRegionalPdtAvlble && !isEDDItem) {
										$('.primary-clause').show();
									}
								}
								//if inventory not available and display on zero inventory flag off show product not found view
	
								if (!isRegionalPdtAvlble && !dispOnZeroInv && phelper.item_type == 'single' && !isEDDItem) {
									COSTCO.Product.invokeInventoryBatchAPIcallforSingleitem(itemPartNumber);
								}
								//depozip in small pack edd msg hide
								if (!isRegionalPdtAvlble && isRegionalPdt && COSTCO.Product.isLocCtrlSmallPck) {
									$('.edd-container').hide();
									$('#edd-message-block').hide();
									$('.primary-clause').hide();
								}
								//Added this for Depozipin hide this message in delivery molecule
								if (!isRegionalPdtAvlble && isRegionalPdt && !isEDDItem) {
									$('.primary-clause').hide();
								}
								//depozip in small pack edd msg hide
								if (!isRegionalPdtAvlble && isRegionalPdt && COSTCO.Product.isLocCtrlSmallPck) {
									$('.edd-container').hide();
									$('#edd-message-block').hide();
									$('.primary-clause').hide();
								}
								//Added this for Depozipin hide this message in delivery molecule
								if (!isRegionalPdtAvlble && isRegionalPdt && !isEDDItem) {
									$('.primary-clause').hide();
								}
								//depozip in small pack edd msg hide
								if (!isRegionalPdtAvlble && isRegionalPdt && COSTCO.Product.isLocCtrlSmallPck) {
									$('.edd-container').hide();
									$('#edd-message-block').hide();
									$('.primary-clause').hide();
								}
								//Added this for Depozipin hide this message in delivery molecule
								if (!isRegionalPdtAvlble && isRegionalPdt && !isEDDItem) {
									$('.primary-clause').hide();
								}
								if (!isRegionalPdtAvlble && !isRegionalPdt) {
									$('.edd-container').hide();
									$('#edd-message-block').hide();
									$('.primary-clause').hide();
									COSTCO.CMath.siteControllOOS = true;
								} else {
									if (isEDDItem && !backordered) {
										$('.edd-container').show();
										$('#edd-message-block').show();
										if (!$('#vendorName').val()) {
											$('.primary-clause').show();
										}
									}
								}
								if (isPDPVariantGreyOutEnabled == 'true' && !scheduledDeliverable) {
									if (lowerSwatch) {
										var lowerLevelCount = $('#swatchesID-productOption0' + parseInt(_optionsSelected2.length - 1) + '').find('.selection-box-v2:visible').length;
										var lowerLevelOOSCount = $('#swatchesID-productOption0' + parseInt(_optionsSelected2.length - 1) + '').find('.span1-outofstock').length;
										if (lowerLevelCount === lowerLevelOOSCount) {
											COSTCO.Product.strikeUpperLevelVariant(_optionsSelected2);
										} else {
											var $selectedUpperLabel = $('label[for=productOption0' + parseInt(_optionsSelected2.length - 2) + ']');
											var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
											$selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS);
	
											var $selectedOOSOption = $('input[value=' + _optionsSelected2[_optionsSelected2.length - 2] + ']').next().attr("automation-id");
											$('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
											$('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
											$('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
											if (_optionsSelected2.length == 3) {
												var $selectedUpperLabel = $('label[for=productOption0' + parseInt(_optionsSelected2.length - 3) + ']');
												var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
												$selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS);
	
												var $selectedOOSOption = $('input[value=' + _optionsSelected2[_optionsSelected2.length - 3] + ']').next().attr("automation-id");
												$('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
												$('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
												$('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
											}
										}
									} else if (lowerDropDown) {
										var lowerLevelDropDownCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(_optionsSelected2.length - 1) + ']').find('option.opt:not(:disabled)').length;
										var lowerLevelDropDownOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(_optionsSelected2.length - 1) + ']').find('option.out-of-stock:not(:disabled)').length;
										if (lowerLevelDropDownCount === lowerLevelDropDownOOSCount) {
	
											if (!$('.varis-v2 option[automation-id=varisOption_' + _optionsSelected2[_optionsSelected2.length - 2] + ']').hasClass('out-of-stock')) {
												$('.varis-v2 option[automation-id=varisOption_' + _optionsSelected2[_optionsSelected2.length - 2] + ']').append('<span class="out-of-stock-text"></span>');
												$('.varis-v2 option[automation-id=varisOption_' + _optionsSelected2[_optionsSelected2.length - 2] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
												$('.varis-v2 option[automation-id=varisOption_' + _optionsSelected2[_optionsSelected2.length - 2] + ']').addClass("out-of-stock");
												var $selectedOptionLabel = $('label[for=productOption0' + parseInt(len - 2) + ']');
												var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
												if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
													//$selectedOptionValue.prepend('Out of Stock - ' );
													var textToReplace = $selectedOptionValue.text();
													var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
													$selectedOptionValue.text(newText);
													$selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
												}
												$selectedOptionValue.show();
											}
										} else {
											var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(_optionsSelected2.length - 2) + ']');
											var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
											$dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);
											var $dropDownOOSOption = $('.varis-v2 option[value=' + _optionsSelected2[_optionsSelected2.length - 2] + ']').attr("automation-id");
											$('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
											$('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
											if (_optionsSelected2.length == 3) {
												var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(_optionsSelected2.length - 3) + ']');
												var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
												$dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);
												var $dropDownOOSOption = $('.varis-v2 option[value=' + _optionsSelected2[_optionsSelected2.length - 3] + ']').attr("automation-id");
												$('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
												$('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
											}
										}
									}
									//For 3 level varaints in order to retain  top level strike when swaping between other top levels
									COSTCO.CMath.strikealllevelvariants();
								}
							}
							CMath.mathTableDisplayRules();
							CMath.showContractSpecificData(data);
						}
					}, fail: function fail(data) {
						//CMath.handleContractPriceAjaxFailure(data);
						console.log('ajax fail - will retry - count=' + retryCount);
						CMath.handleContractSpecificRules();
					}
				});
			},
			updateAjaxStockStatus: function updateAjaxStockStatus(status, itemPartNumber, lowerSwatch, lowerDropDown) {
				if (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant') {
					var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
					var len = optionsSelected.length;
					var uptitemarrayStatus = {};
					var uptvariantitemArray = {};
					if (COSTCO.CMath.variantJSON.length > 0) {
						for (var i in COSTCO.CMath.variantJSON) {
							var val = COSTCO.CMath.variantJSON[i];
							for (var j in val) {
								var sub_key = j;
								var sub_val = val[j];
								if (sub_key == itemPartNumber) {
									uptitemarrayStatus["OL"] = status;
									uptitemarrayStatus["WH"] = sub_val.WH;
									uptvariantitemArray[itemPartNumber] = uptitemarrayStatus;
									COSTCO.CMath.variantJSON[i] = uptvariantitemArray;
									localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
								}
							}
						}
						for (var i in COSTCO.CMath.variantJSON) {
							var val = COSTCO.CMath.variantJSON[i];
							for (var j in val) {
								var sub_key = j;
								var sub_val = val[j];
								if (sub_key == itemPartNumber) {
									if (status == '0' && sub_val.WH == '0') {
										if (COSTCO.Product.item_type === 'multi_variant') {
											if (lowerSwatch) {
												COSTCO.CMath.ajaxStrikeSwatches();
											} else if (lowerDropDown) {
												COSTCO.CMath.ajaxGrayOutDropDown();
											}
										} else if (COSTCO.Product.item_type === 'single_variant') {
											if ($('#swatches-productOption00').length > 0) {
												COSTCO.CMath.ajaxStrikeSwatches();
											} else if ($('.varis-v2[data-product=0]').length > 0) {
												COSTCO.CMath.ajaxGrayOutDropDown();
											}
										}
									} else {
										//Following code for remove css of previous selected swatches
	
										if (lowerSwatch) {
											// pills
											if (COSTCO.Product.item_type === 'multi_variant') {
	
												variable = $('input[value=' + optionsSelected[len - 1] + ']').next().attr("automation-id");
											} else if (COSTCO.Product.item_type === 'single_variant') {
												$('.selection-item').removeClass("select-span1-OOS");
												variable = $('input[value=' + optionsSelected[0] + ']').next().attr("automation-id");
											}
											$('span[automation-id=' + variable + ']').removeClass("select-span1-OOS");
											$('span[automation-id=' + variable + ']').removeClass("span1-outofstock");
											$('span[automation-id=' + variable + ']').children("p").remove(); // for removing P tag
										} else if (lowerDropDown) {
											// lower level drop-down
											$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').removeClass("out-of-stock");
											$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').children("span").remove();
										}
										COSTCO.CMath.update_selected_option_label(optionsSelected[len - 1]);
									}
									if ($('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0) {
										COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
									} else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0) {
										COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
									}
								}
							}
						}
					}
				}
			},
			invokeBatchCallForUpperLevel: function invokeBatchCallForUpperLevel(itemPartNumber) {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				var len = optionsSelected.length;
				if (COSTCO.CMath.pdpPageloadComplete) {
					var invokeBatchAPICall = true;
					for (var i in COSTCO.CMath.variantJSON) {
	
						var val = COSTCO.CMath.variantJSON[i];
						for (var j in val) {
							var sub_key = j;
							if (sub_key == itemPartNumber) {
								invokeBatchAPICall = false;
							}
						}
					}
	
					for (var i = 0; i < optionsSelected.length; i++) {
						if (optionsSelected[i] != COSTCO.CMath.selectedswatches[i] && i != optionsSelected.length - 1) {
							COSTCO.CMath.invokebatchCall = true;
							break;
						}
					}
					var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
					if (COSTCO.CMath.invokebatchCall && !scheduledDeliverable && (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant')) {
						$('#PDPSwatchSkeletone-productOption0' + parseInt(optionsSelected.length - 1) + '').show();
						$('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
						$('[name=productOption0' + parseInt(optionsSelected.length - 1) + ']').hide();
						$('.dropdown-skeleton-productOption0' + parseInt(optionsSelected.length - 1) + '').show();
						$('#swatches-productOption0' + parseInt(len - 2) + ' .selection-box-v2').find('span.selection-item').each(function () {
							$(this).removeClass("select-span1-OOS");
						});
						$('#swatches-productOption00 .selection-box-v2').find('span.selection-item').each(function () {
							$(this).removeClass("select-span1-OOS");
						});
						$('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').find('option.opt:not(:disabled)').each(function () {
							$(this).removeClass("out-of-stock");
							$(this).children("span").remove();
							CMath.update_selected_option_label(optionsSelected[len - 1]);
						});
						$('#swatches-productOption0' + parseInt(len - 1) + ' .selection-box-v2').find('span.selection-item').each(function () {
							$(this).removeClass("span1-outofstock");
							$(this).children("p").remove(); // for removing P
							// tag;
							CMath.update_selected_option_label(optionsSelected[len - 1]);
						});
	
						COSTCO.Product.findOOSitem(invokeBatchAPICall);
					}
				}
			},
			ajaxStrikeSwatches: function ajaxStrikeSwatches() {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				var len = optionsSelected.length;
	
				// $('.selection-item').removeClass("select-span1-OOS");
	
				variable = $('input[value=' + optionsSelected[len - 1] + ']').next().attr("automation-id");
				if ($("input[automation-id='variationOptions_" + optionsSelected[len - 1] + "']:checked").length) {
					//if($('span[automation-id='+variable+']').attr('aria-checked') === 'true'){
					$('span[automation-id=' + variable + ']').addClass("select-span1-OOS");
					//folowing  code for appending OOS label in lower level
					COSTCO.Product.appendLabelSwatches(len - 1);
				} else {
	
					$('span[automation-id=' + variable + ']').removeClass("select-span1-OOS");
				}
				if (!$('span[automation-id=' + variable + ']').hasClass('span1-outofstock')) {
					$('span[automation-id=' + variable + ']').addClass("span1-outofstock");
				} else {
					if (!$('span[automation-id=' + variable + ']').children('p').length) {
						$('span[automation-id=' + variable + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
						$('span[automation-id=' + variable + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
					}
				}
			},
			ajaxGrayOutDropDown: function ajaxGrayOutDropDown() {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				var len = optionsSelected.length;
	
				if (!$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').hasClass('out-of-stock')) {
					$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').append('<span class="out-of-stock-text"></span>');
					$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
					$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').addClass("out-of-stock");
					var $selectedOptionLabel = $('label[for=productOption0' + parseInt(len - 1) + ']');
					var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
					if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
						var textToReplace = $selectedOptionValue.text();
						var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
						$selectedOptionValue.text(newText);
						$selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
					}
					$selectedOptionValue.show();
				}
			},
			callAjaxBundleInventory: function callAjaxBundleInventory(productId, itemId, count, size) {
	
				var catentryid = itemId;
				var dispOnZeroInv = true;
				var isFrozenItem = $('#isFrozenItem').val();
				var isBundleItem = $('#bundleItem').val();
				var whParam = COSTCO.LWSearch.getRegionalLocations();
				var warehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
				var signedIn = false;
				backordered = false;
				initalizeAjaxCall = true;
				var backorderMessage = '';
				signedIn = COSTCO.util.getMemberCookie().signedIn;
				isRegionalPdt = COSTCO.util.islocationControlledInventoryFlow();
				isRegionalPdtAvlble = false;
				blockContractAjax = false;
				$('#product-page').addClass('ajax-busy');
				COSTCO.util.ajax({
					url: '/AjaxGetInventoryDetail',
					method: 'GET',
					async: false,
					dataType: 'json',
					data: {
						itemId: encodeURIComponent(itemId),
						catalogId: wcs.catalogId,
						productId: productId,
						WH: whParam,
						warehouse: warehouse,
						isFrozenItem: isFrozenItem,
						isRegionalPdt: isRegionalPdt,
						isBundleItem: isBundleItem
					},
					done: function done(data, textStatus, jqXHR, options) {
						$('#product-page').removeClass('ajax-busy');
						if (data.errorMessageKey) {
							$('.online-price[data-catentry=' + catentryid + ']').data('inv', COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail);
							$('.edd-container').hide();
							$('#edd-message-block').hide();
							$('#backorder-message').hide();
						} else {
							isRegionalPdtAvlble = data.invAvailable;
							dispOnZeroInv = data.dispOnZeroInvtry;
							backordered = data.isBackOrdered;
							backorderMessage = data.backOrderMessage;
							if (isPDPVariantGreyOutEnabled == 'false') {
								if (!isRegionalPdtAvlble && dispOnZeroInv && !backordered) {
									var oosImgTag = COSTCO.util.tmpl('tmpl_oos_overlay_img');
									$('#productImageOverlay').prepend(oosImgTag);
									$('.primary-clause').hide();
								} else {
									if (!$('#vendorName').val()) {
										$('.primary-clause').show();
									}
								}
							} else {
	
								if (!$('#vendorName').val()) {
									$('.primary-clause').show();
								}
							}
							var isEDDItem = $('#liveEDD').length > 0 && $('#liveEDD').val() === 'true';
							//For LocationControlledInventory Items 
							if (backordered && backorderMessage !== '') {
								$('#backorder-message').text(backorderMessage);
								$('#backorder-message').append('<span id="backordered"></span>');
								$('#backorder-message').show();
								$('.edd-container').hide();
								$('#edd-message-block').hide();
								$('.online-price[data-catentry=' + catentryid + ']').data('inv', COSTCO.util.productConstants.inv_backorderd);
							} else {
								$('#backorder-message').hide();
								$('.edd-container').show();
								$('.online-price[data-catentry=' + catentryid + ']').data('inv', 'IN_STOCK');
								if (isRegionalPdtAvlble && !isEDDItem) {
									$('.primary-clause').show();
								}
							}
							CMath.mathTableDisplayRules();
							CMath.showBundleSpecificData(data, count, size);
						}
					}, fail: function fail(data) {
						CMath.handleContractPriceAjaxFailure(data);
					}
				});
			},
			/**Iterate bundle items in order to invoke ajaxgetcontract price **/
			showBundleSpecificData: function showBundleSpecificData(data, count, size) {
				var productOnlinePrice = parseFloat(0.00).toFixed(2);
				var catentryid = data.itemId;
				var pricePerUnit = "";
				var dispOnZeroInv = true;
				var isFrozenItem = $('#isFrozenItem').val();
				var isBundleItem = $('#bundleItem').val();
				var signedIn = false;
				signedIn = COSTCO.util.getMemberCookie().signedIn;
				isRegionalPdt = COSTCO.util.islocationControlledInventoryFlow();
				isRegionalPdtAvlble = false;
				blockContractAjax = false;
				$('#product-page').addClass('ajax-busy');
				//Call AJAX to get the contract prices of the given item
				COSTCO.util.ajax({
					url: '/AjaxGetContractPrice',
					method: 'GET',
					dataType: 'json',
					data: {
						itemId: encodeURIComponent(data.itemId),
						catalogId: wcs.catalogId,
						productId: data.productId[0],
						isFrozenItem: isFrozenItem,
						isRegionalPdt: isRegionalPdt,
						isBundleItem: isBundleItem
	
					},
					done: function done(data, textStatus, jqXHR, options) {
						$('#product-page').removeClass('ajax-busy');
	
						CMath.showBreakdown(false);
						if (data.errorMessageKey) {
							//setUp2DayErrorPage with zip code overlay
							if (data.errorMessageKey == 'ERR_2DAY_PRICE_INVALID') {
								CMath.handleContractPriceAjaxFailure(data);
							} else {
								CMath.setUp2DayErrorPage();
								if (!signedIn) {
									$('.view-zip-signin').removeClass('hide');
								}
								$('.grocery-zip-form').removeClass('hide');
								$('.your-price .value').text('- -.- -');
								$('.unitcurrency').text('$-.- -');
								$('.math-table').show();
								$('#price-per-unit-container').show();
								//Paint the error message on the zip code overlay
								if (data.errorMessageKey != 'ERR_ZIP_NOTVALID') {
									$('.alert-notification').empty();
									$('.critical-notification').empty();
									var error = COSTCO.util.get_decoded_html(data.errorMessage);
	
									if (data.errorMessageKey != 'ERR_2DAY_NOT_AVAILABLE' && data.errorMessageKey != 'ERR_2DAY_ITEM_UNAVAILABLE' && data.errorMessageKey != 'ERR_LOCATIONCONTROLLED_ITEM_UNAVAILABLE') {
										error = error.replace(/[0-9]*\./, $.cookie('invCheckPostalCode') + '.');
									}
									CMath.addBorderToShipItMolecule('default');
									$('.alert-notification').append(error);
									$('.alert-notification').removeClass('hide');
									$('.critical-notification').addClass('hide');
								}
							}
							$('.online-price[data-catentry=' + catentryid + ']').data('inv', COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail);
							$('.edd-container').hide();
							$('#edd-message-block').hide();
							$('#backorder-message').hide();
						} else {
							//Added logic to retrive minimumItemPrice for bundle
							bundlePriceMap.set(data.itemId, data.finalOnlinePrice);
							if (count + 1 == size) {
								var minItemPrice = data.finalOnlinePrice;
								bundlePriceMap.forEach(function (values, keys) {
									var currentPrice = values;
									if (currentPrice < minItemPrice) minItemPrice = currentPrice.toString();
								});
								$('#starting-bundle-price').text('$' + phelper.formatMoney(phelper.processPrice(minItemPrice)));
							}
							productOnlinePrice = data.finalOnlinePrice;
							pricePerUnit = data.pricePerUnit;
							$('#bundle-info-container[data-product=' + count + '] .price span').text('$' + phelper.formatMoney(phelper.processPrice(productOnlinePrice)));
							discount = data.discount;
							catentryid = data.itemId;
							//if there exists value for price
							if (typeof productOnlinePrice !== 'undefined' && !isNaN(productOnlinePrice)) {
								//if there exists value for discount, show discount node
								//Paint the contract price on PDP and encode the final item price to PDP page
								$('.online-price[data-catentry=' + catentryid + '] .op-value').text(phelper.formatMoney(phelper.processPrice(productOnlinePrice)));
								$('.online-price[data-catentry=' + catentryid + ']').data('opvalue', COSTCO.util.encode(productOnlinePrice + ''));
								$('#price-per-unit-container').addClass('hide');
								//Handle other render events - 
								//Rules to hide/show UI elements , based on bussines requirement -
								//This will only be executed after Successfull price update.
								//CMath.pricingInfo($('.online-price[data-catentry='+catentryid+']').data('catentry'));		        			
							}
						}
					}, fail: function fail(data) {
						CMath.handleContractPriceAjaxFailure(data);
					}
				});
			},
	
			/**
	   * Handles Ajax failure scenario, painting the refresh button and 
	   * critical error message.
	   */
			handleContractPriceAjaxFailure: function handleContractPriceAjaxFailure(data) {
				CMath.setUp2DayErrorPage();
				//Hide prices and show Refresh Item Details button with error message
				$('#price-per-unit-container').addClass('hide');
				$('#product-page').removeClass('ajax-busy');
				$priceSection = $('#productPriceSection');
				$priceSection.hide();
				$('.product-interaction').hide();
				$('#refreshSection').removeClass('hide');
				$("#RefreshBtn").attr("disabled", false);
				if (retryCount == retryLimit) {
					$('div#criticalMsg1').removeClass('hide');
					$('button#RefreshBtn').addClass('hide');
				}
			},
			/**
	   * Performs string manipulations to extract warehouse number from warehouse cookie
	   * based on catalog type.
	   */
			fetchWarehouseCookieVal: function fetchWarehouseCookieVal(catalogType) {
				var result = $('#defWHCookieVal').val();
				var warehouseCookie = $.cookie('WAREHOUSEDELIVERY_WHS');
				if (warehouseCookie != null && warehouseCookie != '') {
					var cookieArray = warehouseCookie.split(',');
					for (index in cookieArray) {
						var cookieVal = cookieArray[index];
						if (cookieVal.toLowerCase().includes(catalogType.toLowerCase())) {
							result = cookieVal.split('=').length == 2 ? cookieVal.split('=')[1] : $('#defWHCookieVal').val();
						}
					}
				}
				return result;
			},
			//Grocery US change - Depot Catalog Online - Should not show espots, discount, fee in case of errors
			setUp2DayErrorPage: function setUp2DayErrorPage() {
				$functionalElements = $('.grocery-espot-class,.marketing-container,.delivery-fee');
				$functionalElements.remove();
			},
			//Rule to invoke Ajax call for contract specific data
			isContractSpecificAjaxRequired: function isContractSpecificAjaxRequired() {
				return COSTCO.util.isDepotCatalogEnabled() && (COSTCO.util.islocationControlledInventoryFlow() || COSTCO.util.issiteControlledInventoryFlow()) && !blockContractAjax;
			},
			//Hide functional elements before ajax
			hideElementsBeforeAjax: function hideElementsBeforeAjax() {
				$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#variants,#add-to-cart,#qty,#price-per-unit-container');
				$functionalElements.hide();
				$('.grocery-zip-form').addClass('hide');
			},
			//Show Availability for regional items
			showLocationControlledInventoryItemsAvailability: function showLocationControlledInventoryItemsAvailability() {
				var targetedCartBehaviour = $('#targetedCartBehaviour').val() === "Membership" ? true : false;
				var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
				if (scheduledDeliverable) {
					$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#qty');
				} else {
					$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#add-to-cart,#qty');
				}
				if (!targetedCartBehaviour && !scheduledDeliverable) {
					if (retryCount <= retryLimit && isRegionalPdtAvlble) {
						//Basically , changes to show the PDP as OOS INSTOCK , based on AJAX response ie , based on contract is done here .
						//Here changes are made to handle the pdt image and add to cart section , when the product is made INSTOCK for the customer selected
						//zipcode (ffm center based on zip code)
						var atcMsg = messages.ADDTOCART;
						$('img.oos-overlay').addClass("hide");
						$("input[type='button'][name='add-to-cart']").attr("disabled", false).val(atcMsg).attr("disabled", false).removeClass("out-of-stock");
						$('li#add-to-cart,li#add-to-cart-map').val(atcMsg).removeClass("out-of-stock");
						$functionalElements.show();
					} else if (retryCount <= retryLimit && !isRegionalPdtAvlble) {
						//Basically , changes to show the PDP as OOS(Out of Stock) , based on AJAX response ie , based on contract is done here .
						//Here changes are made to handle the pdt image and add to cart section , when the product is made OOS for the customer selected
						//zipcode (ffm center based on zip code)
						if (backordered) {
							var atcMsg = messages.ADDTOCART;
							$('img.oos-overlay').addClass("hide");
							$("input[type='button'][name='add-to-cart']").attr("disabled", false).val(atcMsg).attr("disabled", false).removeClass("out-of-stock");
							$('li#add-to-cart,li#add-to-cart-map').val(atcMsg).removeClass("out-of-stock");
							$functionalElements.show();
						} else {
							var oosMsg = messages.ADDTOCART_OUTOFSTOCK;
							$functionalElements.show();
							$('#qty-decrement,#qty-input,#qty-increment,#qty').hide();
							if (isPDPVariantGreyOutEnabled == 'false') {
								$('img.oos-overlay').removeClass("hide");
							}
							$("input[type='button'][name='add-to-cart']").attr("disabled", true).val(oosMsg).attr("disabled", true).addClass("out-of-stock");
							$('li#add-to-cart,li#add-to-cart-map').val(oosMsg).addClass("out-of-stock");
						}
					}
				} else {
					$functionalElements.show();
				}
				this.showSelectedOptions();
			},
	
	
			strikealllevelvariants: function strikealllevelvariants() {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				var len = optionsSelected.length;
				var itemCount = 0,
				    oosCount = 0;
				if (COSTCO.Product.item_type === 'multi_variant' && optionsSelected.length == 3) {
					for (var i = 0; i < product.length; i++) {
						for (var j = 0; j < products[i].length; j++) {
							var itemId = products[i][j].partNumber;
							if (products[i][j].options.includes(optionsSelected[0])) {
								itemCount++;
								for (var k in COSTCO.CMath.variantJSON) {
									var val = COSTCO.CMath.variantJSON[k];
									for (var l in val) {
										var sub_key = l;
										var sub_val = val[l];
										if (sub_key == itemId && sub_val.OL == '0' && sub_val.WH == '0') {
											oosCount++;
										}
									}
								}
							}
						}
						if (oosCount == itemCount) {
							$('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.selection-box-v2:visible').each(function () {
								if (!$(this).find('span.selection-item').hasClass('span1-outofstock')) {
									$(this).find('span.selection-item').addClass("span1-outofstock");
									if (!$(this).find('span.selection-item').children('p').length) {
										$(this).find('span.selection-item').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
										$(this).find('span.selection-item').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
									}
								}
							});
							variable = $('input[value=' + optionsSelected[0] + ']').next().attr("automation-id");
							if (!$('span[automation-id=' + variable + ']').hasClass('span1-outofstock')) {
								$('span[automation-id=' + variable + ']').addClass("span1-outofstock");
								if (!$('span[automation-id=' + variable + ']').children('p').length) {
									$('span[automation-id=' + variable + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
									$('span[automation-id=' + variable + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
								}
							}
							COSTCO.Product.appendLabelSwatches(len - 3);
							$('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.opt:not(:disabled)').each(function () {
								if (!$(this).hasClass('out-of-stock')) {
									$(this).append('<span class="out-of-stock-text"></span>');
									$(this).find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
									$(this).addClass("out-of-stock");
								}
							});
							if (!$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 3] + ']').hasClass('out-of-stock')) {
								$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 3] + ']').append('<span class="out-of-stock-text"></span>');
								$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 3] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
								$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 3] + ']').addClass("out-of-stock");
								var $selectedOptionLabel = $('label[for=productOption0' + parseInt(len - 3) + ']');
								var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
								if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
									var textToReplace = $selectedOptionValue.text();
									var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
									$selectedOptionValue.text(newText);
									$selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
								}
								$selectedOptionValue.show();
							}
						}
					}
				}
			},
	
			// Rules to hide/show the math-table / price-breakdown based on business requirements. 
			mathTableDisplayRules: function mathTableDisplayRules() {
				var status = COSTCO.TOBACCO.userMemberInfo(),
				    hasLicense = status.hasLicense != 'undefined' ? status.hasLicense : false;
				var userInfo = COSTCO.util.getMemberCookie(),
				    signedIn = userInfo.signedIn,
				    costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
				    isCostcoMembers = costcoMember;
				isUserSignedIn = signedIn;
				memberOnly = $('#memberItem').val() == "true" ? true : false, mapItem = $('#mapItem').val() == "true" ? true : false, tobaccoProduct = $('#tobaccoProduct').val() == "true" ? true : false, inStock = $('#outOfStock').val() == "true" ? true : false, $functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#add-to-cart,#qty,#price-per-unit-container');
				$functionalElementsTob = $('#qty-decrement,#qty-input,#qty-increment,#variants,#add-to-cart,#qty');
	
				var $signInToBuy = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? $('.sign-in-to-buy') : $('#sign-in-to-buy');
	
				var validated = userInfo.validated;
				var verified = userInfo.verified;
				var memberActive = userInfo.active;
				blockContractAjax = false;
	
				$('#link-membership').hide();
				$('#link-membership-v2').hide();
				$('#purchase-membership').hide();
				$('#renew-membership').hide();
				$('.mem-button').hide();
				var zipcode = $.cookie('WC_BD_ZIP');
				var appType = $('#applicationType').val();
				if (zipcode != '' && zipcode != null || appType == 'BC') {
					$('.social-share-link').show();
				} else {
					$('.social-share-link').hide();
				}
				if (isRegionalPdt) {
					COSTCO.CMath.showLocationControlledInventoryItemsAvailability();
				} else if (mapItem && !memberOnly) {
					// map item
					if (signedIn && costcoMember) {
						$functionalElements.show();
						$('#sign-in-for-details').hide();
						$signInToBuy.hide();
						$('#sign-in-to-buy-v2').hide();
						this.showSelectedOptions();
					} else if (!signedIn && !costcoMember) {
						$functionalElements.hide();
						blockContractAjax = true;
					} else if (signedIn && !costcoMember) {
						$functionalElements.hide();
						$('#sign-in-for-details').hide();
						$signInToBuy.hide();
						$('#sign-in-to-buy-v2').hide();
						$('#add-to-cart-map').show();
						this.showSelectedOptions();
						blockContractAjax = true;
					} else if (!signedIn && costcoMember) {
						$('#sign-in-for-details').hide();
						$signInToBuy.hide();
						$('#sign-in-to-buy-v2').hide();
						blockContractAjax = true;
					}
				} else if (tobaccoProduct) {
					// tobacco product 
					if (signedIn) {
						$('#sign-in-for-details').hide();
						$('#yellow-alert').show();
						if (inStock) {
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
								document.getElementById('add-to-cart-btn').disabled = false;
							} else {
								if (hasLicense) {
									document.getElementById('add-to-cart-btn').disabled = false;
								} else {
									document.getElementById('add-to-cart-btn').disabled = true;
								}
							}
						}
					} else {
						var zipcode = $.cookie('WC_BD_ZIP');
						if (zipcode != '' || zipcode != null) {
							$functionalElementsTob.hide();
							$('#sign-in-for-details').show();
						}
					}
				} else if (memberOnly) {
					// member only item
					$('#prod-page-delivery').removeClass('hide');
					if (!signedIn) {
						var rememberedShowMemberItem = $.cookie('rememberedShowMemberItem');
						if (typeof rememberedShowMemberItem !== 'undefined' && rememberedShowMemberItem !== null) {
							$('#sign-in-to-buy, .mem-button').hide();
							$('#price-per-unit-container').removeClass('hide');
							this.showSelectedOptions();
							$('#sign-in-to-buy-v2, .sign-in-to-buy').hide();
							$('.sign-in-to-buy').removeClass('interaction-element');
						} else {
							$functionalElements.hide();
							$('.mem-button').hide();
							$signInToBuy.show();
							if (COSTCO.CMath.iskitsbundle) {
								$('#bundle-button-container').hide();
							}
							$('#sign-in-to-buy-v2').show();
							if ($('#scheduledDeliverable').val() === 'true') {
								$('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
							}
							if ($('#edd-form-block').length > 0 && !$('#edd-form-block').hasClass('hidden') && !COSTCO.CMath.iskitsbundle) {
								$('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
							}
							if ($('#edd-form-block').length > 0 && !$('#edd-form-block').hasClass('hidden') && COSTCO.CMath.iskitsbundle && !inStock) {
								$('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
							}
							blockContractAjax = true;
						}
					} else {
						if (costcoMember) {
							if (validated || verified) {
								$signInToBuy.hide();
								$('.mem-button').hide();
								$('#sign-in-to-buy-v2').hide();
								$('#price-per-unit-container').removeClass("hide");
								if (memberActive) {
									this.showSelectedOptions();
									var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
									if ($('#isBDAppVar').val() != 'BD' && !scheduledDeliverable) {
										var atcMsg = messages.ADDTOCART;
										$('img.oos-overlay').addClass("hide");
										$("input[type='button'][name='add-to-cart']").attr("disabled", false).val(atcMsg).attr("disabled", false).removeClass("out-of-stock");
										$('li#add-to-cart,li#add-to-cart-map').val(atcMsg).removeClass("out-of-stock");
										$functionalElements.show();
										if (initalizeAjaxCall && !isRegionalPdtAvlble && !backordered) {
											var oosMsg = messages.ADDTOCART_OUTOFSTOCK;
											$('#qty-decrement,#qty-input,#qty-increment,#qty').hide();
											if (isPDPVariantGreyOutEnabled == 'false') {
												$('img.oos-overlay').removeClass("hide");
											}
											$("input[type='button'][name='add-to-cart']").attr("disabled", true).val(oosMsg).attr("disabled", true).addClass("out-of-stock");
											$('li#add-to-cart,li#add-to-cart-map').val(oosMsg).addClass("out-of-stock");
										}
									} else if ($('#isBDAppVar').val() != 'BD' && scheduledDeliverable) {
										$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#qty,#price-per-unit-container');
										$functionalElements.show();
									}
								} else {
									$functionalElements.hide();
									if (COSTCO.CMath.iskitsbundle) {
										$('#bundle-button-container').hide();
									}
									$('#renew-membership').show();
									blockContractAjax = true;
								}
							} else {
								$functionalElements.hide();
								$('.mem-button').hide();
								$signInToBuy.hide();
								$('#sign-in-to-buy-v2').hide();
								$('#link-membership').show();
								$('#link-membership-v2').show();
								$('#purchase-membership').show();
								if (COSTCO.CMath.iskitsbundle) {
									$('#bundle-button-container').hide();
								}
								blockContractAjax = true;
							}
						} else {
							$functionalElements.hide();
							$signInToBuy.hide();
							$('#sign-in-to-buy-v2').hide();
							$('#link-membership').show();
							$('#link-membership-v2').show();
							$('#purchase-membership').show();
							if ($('#scheduledDeliverable').val() === 'true') {
								$('#link-membership-for-price').removeClass('primary-button-v2').addClass('secondary-button-v2');
							}
							if (COSTCO.CMath.iskitsbundle) {
								$('#bundle-button-container').hide();
							}
							blockContractAjax = true;
						}
					}
				} else if ($('#isBDAppVar').val() != 'BD' && !isRegionalPdt && initalizeAjaxCall) {
					COSTCO.CMath.showLocationControlledInventoryItemsAvailability();
				} else {
					if (($('#isBDAppVar').val() == 'BD' || !initalizeAjaxCall) && !isRegionalPdt) {
						$functionalElements.show();
					}
					this.showSelectedOptions();
				}
				if ($('#isBDAppVar').val() == 'BD' && $('#edd-form-block').length > 0 && !isRegionalPdt) {
					$('#add-to-cart-btn').attr("disabled", true);
				}
				if ($('.oos-notify-me-v2').length == 0) {
					$('#ctas').removeClass('hide');
				}
				//Call this method to change border color of ShipIt molecule in BC flow
				CMath.addBorderToShipItMolecule();
			},
			/**This function is called only in BC flow to change the 
	   * border color of ShipIt Molecule to green when item available and border is deemphasized when item out of stock   
	   */
			addBorderToShipItMolecule: function addBorderToShipItMolecule(border) {
				if ('BC' === $('#applicationType').val()) {
					if (typeof border === 'undefined' && $('#add-to-cart').is(':visible')) {
						var atc = document.getElementById('add-to-cart-btn');
						if (null != atc) border = document.getElementById('add-to-cart-btn').disabled ? 'outOfStock' : 'available';
					}
					switch (border) {
						case 'available':
							$('.product-interaction').addClass('delivery-mol-border-green');
							break;
						case 'outOfStock':
							$('.product-interaction').removeClass('delivery-mol-border-green');
							$('.product-interaction').addClass('delivery-border');
							break;
						default:
							$('.product-interaction').removeClass('delivery-mol-border-green');
							$('.product-interaction').removeClass('delivery-border');
					}
				}
			},
			/**
	  * This function is called when a swatch color tile is clicked and
	  * the Rich FX event is triggered for switching colors.
	  * During the event, Rich FX calls RMActiveColor, which contains this function.
	  * We need to select the corresponding value in our Select element
	  * and mimick a normal varis selection.
	  */
			triggerSwatchTilesSelection: function triggerSwatchTilesSelection(activeColor, activeElement) {
	
				var preselectAttrsStr = COSTCO.util.getParameterByName('preselect');
				var swatchMode = $('.swatchDropdown').data('swatch-mode');
				if (!initSwatch && typeof preselectAttrsStr !== 'undefined' && preselectAttrsStr != null && preselectAttrsStr != 'null' && preselectAttrsStr.length > 0 && typeof swatchMode !== 'undefined' && swatchMode == 2) {
					initSwatch = true;
					var preselectattr = preselectAttrsStr.split(':').length > 1 ? preselectAttrsStr.split(':')[1] : activeColor;
					$('#productOption00 option.opt').each(function () {
						if ($(this).text().toLowerCase() == preselectattr || $(this).data('swatch') == preselectattr) {
							$(this)[0].selected = true;
							activeColor = preselectattr;
							console.log('Selecting preselect of ' + preselectattr);
							CMath.updateSwatchToPreselect(preselectattr.split(' ').join(''));
						}
					});
				}
	
				activeColor = DOMPurify.sanitize(activeColor);
				var $swatchElement = $('[data-swatch=' + activeColor + ']');
				$swatchElement.prop('selected', true);
				if (COSTCO.CMath.swatchInitialTileSelected && activeColor != COSTCO.CMath.swatchActiveColor) {
					COSTCO.CMath.swatchActiveColor = activeColor;
					COSTCO.CMath.swatchTileSelected = true;
				} else if (!COSTCO.CMath.swatchInitialTileSelected && activeColor == COSTCO.CMath.swatchActiveColor) {
					COSTCO.CMath.swatchTileSelected = false;
				}
				if (COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete) {
					CMath.redirectPDP();
				} else {
					$swatchElement.trigger('change.vari');
				}
	
				var colorsNames = $.map($('[data-swatch]', '.swatchDropdown'), function (option) {
					if ($(option).text().includes(messages.BACKORDER_TEXT)) {
						var sliceStr = ' - ' + messages.BACKORDER_TEXT;
						return $(option).text().slice(0, $(option).text().indexOf(sliceStr)) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					} else if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
						var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
						return $(option).text().slice(0, $(option).text().indexOf(sliceStr)) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					} else if ($(option).text().includes(' -')) {
						return $(option).text().slice(0, $(option).text().indexOf(' -')) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					} else {
						return $(option).text() + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					}
				});
				var colorNameTitle = $.map(colorsNames, function (value) {
					if (value.includes(' -' + activeColor + '-')) {
						return value.slice(0, value.indexOf(' -' + activeColor + '-'));
					}
				});
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
					var colorNameSpan = document.createElement("SPAN");
					$(colorNameSpan).text(messages.COLOR + ': ' + colorNameTitle);
					$(colorNameSpan).addClass('bold');
	
					$('label[for="theSwatches"]').html(colorNameSpan);
					$('label[for="pdpSwatches"]').html(colorNameSpan);
				} else {
					$('label', '#variants .variantContainer').first().text(messages.COLOR + ': ' + colorNameTitle);
				}
	
				$('img', '#theSwatches').each(function () {
					var swatchElement = $(this).siblings('span.RICHFXColorChangeSwatchName')[0];
					if (typeof swatchElement !== 'undefined' && swatchElement !== null) {
						var itemDescriptionArray = $(this).siblings('span.RICHFXColorChangeSwatchName')[0].innerHTML.split(" ");
						if (itemDescriptionArray.length == 2) {
							if (typeof $(this).parent().find('#selectedOffScreenSwatch') !== 'undefined') {
								$(this).parent().find('#selectedOffScreenSwatch').each(function () {
									$(this).remove();
								});
							}
							if (itemDescriptionArray[1].toLowerCase() === activeColor) {
								$(this).parent().prepend('<span id="selectedOffScreenSwatch" class="offscreen">Selected</span>');
							}
						}
					}
				});
			},
	
			updateSwatchToPreselect: function updateSwatchToPreselect(color) {
				$('.RICHFXColorChangeLink span').each(function () {
					var swatchIdx = $(this).html().indexOf(' ' + color);
					if (swatchIdx >= 0 && $(this).html().substr(swatchIdx + 1) == color) {
						$(this).next().click();
					}
				});
			},
	
			runRMAActiveColor: function runRMAActiveColor(event, color) {
				if (event.keyCode == 13) {
					event.preventDefault();
					console.log("Pressed enter key with color : " + color);
					// The space at the beginning is added so blue won't match against lightblue.
					CMath.updateSwatchToPreselect(color);
				}
			},
	
			/**
	   * This function is called to  the stock availability using the response from the GE webservice. 
	   * Adding the 'X' on the swatch and making it disabled. Also reseting it when we re call the service. 
	   * We're using '-' as delimiter for the swatch code and swatch description and inventory status and if price added than that too..
	   *  
	   */
			updateGEStockAvailability: function updateGEStockAvailability() {
				var colorsNames = $.map($('[data-attr-name="Color"]', '.swatchDropdown'), function (option) {
					if ($(option).text().includes(messages.BACKORDER_TEXT)) {
						var sliceStr = ' - ' + messages.BACKORDER_TEXT;
						return $(option).text().slice(0, $(option).text().indexOf(sliceStr)) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					} else if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
						var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
						return $(option).text().slice(0, $(option).text().indexOf(sliceStr)) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					} else if ($(option).text().includes(' -')) {
						return $(option).text().slice(0, $(option).text().indexOf(' -')) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					} else {
						return $(option).text() + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					}
				});
				//span.RICHFXColorChangeSwatchName has the name in format '1 colorname' to we split it on space and on index 1 we get colorname.
				//and for french also , the colorname from RICHFX is also same. 
	
				$('[data-attr-name="Color"]', '.swatchDropdown').each(function () {
					var swatchElement = $(this)[0];
					if (typeof swatchElement !== 'undefined' && swatchElement !== null) {
						var color = $(swatchElement).data('swatch').trim().toLowerCase();
						var colorNameTitle = $.map(colorsNames, function (value) {
							if (value.includes(' -' + color + '-')) {
								return value.slice(0, value.indexOf(' -' + color + '-'));
							}
						});
	
						var colorsOutStock = $.map($('[data-attr-name="Color"]', '.swatchDropdown'), function (option) {
							if ($(option).data('swatch') === color) {
								for (var i = 0; i < products[0].length; i++) {
									if (products[0][i].options.length === 1 && $(option).val() === products[0][i].options[0] || products[0][i].options.length === 2 && ($(option).val() === products[0][i].options[0] || $(option).val() === products[0][i].options[1])) {
										if (products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd) {
											if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
												var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
												var optionText = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
												$(option).text(optionText);
											}
											if (!$(option).text().includes(messages.BACKORDER_TEXT)) {
												var message = $(option).text() + ' - ' + messages.BACKORDER_TEXT;
												$(option).text(message);
											}
										}
										if (products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_outOfStock || products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
	
											if ($(option).text().includes(messages.BACKORDER_TEXT)) {
												var sliceStr = ' - ' + messages.BACKORDER_TEXT;
												var optionText = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
												$(option).text(optionText);
											}
											if (!$(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
												var message = $(option).text() + ' - ' + messages.OUT_OF_STOCK_TEXT;
												$(option).text(message);
											}
											$(option).attr("disabled", "disabled");
											return $(option).data('swatch').trim().toLowerCase();
										}
									}
								}
							}
						});
						var colorsInStock = $.map($('[data-attr-name="Color"]', '.swatchDropdown'), function (option) {
							if ($(option).data('swatch') === color) {
								for (var i = 0; i < products[0].length; i++) {
									if (products[0][i].options.length === 1 && $(option).val() === products[0][i].options[0] || products[0][i].options.length === 2 && ($(option).val() === products[0][i].options[0] || $(option).val() === products[0][i].options[1])) {
										if (products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock && products[0][i].zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_outOfStock && products[0][i].zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_invalidSku && $(option).attr("disabled") === "disabled") {
											$(option).removeAttr("disabled");
											if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
												var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
												var message = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
												$(option).text(message);
											} else if ($(option).text().includes(messages.BACKORDER_TEXT)) {
												var sliceStr = ' - ' + messages.BACKORDER_TEXT;
												var message = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
												$(option).text(message);
											}
											return $(option).data('swatch').trim().toLowerCase();
										}
									}
								}
							}
						});
	
						$('img', '#theSwatches').each(function () {
							var swatchElement = $(this).siblings('span.RICHFXColorChangeSwatchName')[0];
							if (typeof swatchElement !== 'undefined' && swatchElement !== null) {
								var itemDescriptionArray = $(swatchElement)[0].innerHTML.split(" ");
								if (itemDescriptionArray.length == 2 && itemDescriptionArray[1].toLowerCase() === color) {
									if (colorsOutStock[0] === color && !$(this).parent().hasClass('disabledSwatch')) {
										$(this).parent().addClass('disabledSwatch');
										if (color == 'white') {
											$(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-grey.png" class="disableOverlaySwatch" />');
										} else {
											$(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-white.png" class="disableOverlaySwatch" />');
										}
										$(this).parent().get(0).setAttribute("tabindex", "-1");
										$(this).parent().wrap('<span class="swatch-help" data-placement="bottom" data-trigger="focus hover" tabindex="0" data-toggle="popover" data-html="true" data-content="' + colorNameTitle + ' ' + messages.OUT_OF_STOCK_TOOLTIP + '" />');
										$(this).parent().prepend('<span class="offscreen">' + colorNameTitle + ' ' + messages.OUT_OF_STOCK_TOOLTIP + '</span>');
	
										$(this).parent().get(0).removeAttribute("data-sort");
										$(this).parent().get(0).removeAttribute("data-content");
										$(this).parent().get(0).removeAttribute("data-placement");
										$(this).parent().get(0).removeAttribute("data-trigger");
										$(this).parent().get(0).removeAttribute("data-toggle");
	
										$(this).parent().get(0).removeAttribute("aria-expanded");
										$(this).parent().get(0).removeAttribute("aria-haspopup");
										$(this).parent().get(0).removeAttribute("data-original-title");
										$(this).parent().get(0).removeAttribute("role");
										$(this).parent().get(0).removeAttribute("title");
	
										$(this).parent().get(0).removeAttribute("data-html");
										$(this).parent().get(0).classList.remove("swatch-help");
									}
									if (colorsInStock[0] === color && $(this).parent().hasClass('disabledSwatch')) {
	
										$(this).parent().removeClass('disabledSwatch');
	
										$(this).siblings('img.disableOverlaySwatch').remove();
										$(this).siblings('span.offscreen').remove();
	
										$(this).parent().get(0).setAttribute("data-sort", colorsInStock.indexOf(color));
										$(this).parent().get(0).removeAttribute("tabindex");
										$(this).parent().get(0).setAttribute("data-content", colorNameTitle);
										$(this).parent().get(0).setAttribute("data-placement", "bottom");
										$(this).parent().get(0).setAttribute("data-trigger", "focus hover");
										$(this).parent().get(0).setAttribute("data-toggle", "popover");
										$(this).parent().get(0).setAttribute("data-html", "true");
										$(this).parent().get(0).classList.add("swatch-help");
										$(this).parent().unwrap();
									}
									COSTCO.util.swatch_accesible_popover('.swatch-help');
								}
							}
						});
					}
				});
	
				//NEED FOR BF?
				if ($('#theSwatches').children().length == 0) {
					var itemOutStock = $.map($('[data-swatch]', '.swatchDropdown'), function (option) {
						if ($(option).data('swatch') === 'pedestal option') {
							for (var i = 0; i < products[0].length; i++) {
								if (products[0][i].options.length === 1 && $(option).val() === products[0][i].options[0] || products[0][i].options.length === 2 && ($(option).val() === products[0][i].options[0] || $(option).val() === products[0][i].options[1])) {
									if (products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd) {
										if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
											var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
											var optionText = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
											$(option).text(optionText);
										}
										if (!$(option).text().includes(messages.BACKORDER_TEXT)) {
											var message = $(option).text() + ' - ' + messages.BACKORDER_TEXT;
											$(option).text(message);
										}
									}
									if (products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_outOfStock || products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
	
										if ($(option).text().includes(messages.BACKORDER_TEXT)) {
											var sliceStr = ' - ' + messages.BACKORDER_TEXT;
											var optionText = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
											$(option).text(optionText);
										}
										if (!$(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
											var message = $(option).text() + ' - ' + messages.OUT_OF_STOCK_TEXT;
											$(option).text(message);
										}
										$(option).attr("disabled", "disabled");
										return $(option).data('swatch').trim().toLowerCase();
									}
								}
							}
						}
					});
	
					var itemsInStock = $.map($('[data-swatch]', '.swatchDropdown'), function (option) {
						if ($(option).data('swatch') === 'pedestal option') {
							for (var i = 0; i < products[0].length; i++) {
								if (products[0][i].options.length === 1 && $(option).val() === products[0][i].options[0] || products[0][i].options.length === 2 && ($(option).val() === products[0][i].options[0] || $(option).val() === products[0][i].options[1])) {
									if (products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock && products[0][i].zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_outOfStock && products[0][i].zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_invalidSku && $(option).attr("disabled") === "disabled") {
										$(option).removeAttr("disabled");
										if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
											var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
											var message = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
											$(option).text(message);
										} else if ($(option).text().includes(messages.BACKORDER_TEXT)) {
											var sliceStr = ' - ' + messages.BACKORDER_TEXT;
											var message = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
											$(option).text(message);
										}
										return $(option).data('swatch').trim().toLowerCase();
									}
								}
							}
						}
					});
				}
	
				var $variant_options = $('.varis[data-product=0]').find('option:not(.defaultOpt)');
				var optionsSelected = phelper.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				$variant_options.each(function (index, opt) {
					if (optionsSelected.includes(opt.value)) {
						products[0].forEach(function (product_obj) {
							CMath.update_variant_option_GE(opt, product_obj, $variant_options.length, optionsSelected);
						});
					}
				});
			},
	
			/**
	   * Function that disables/enables variant option and updates option text after GE Availability Call
	   */
			update_variant_option_GE: function update_variant_option_GE(opt, product_obj, nextVariantLength) {
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
					$(opt).siblings().each(function (index, option) {
						if (typeof option.innerHTML != 'undefined' && !option.innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							$(option).removeAttr('disabled');
						}
						if (option.innerHTML.includes(messages.BACKORDER_TEXT) || option.innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							if (option.innerHTML.includes(messages.BACKORDER_TEXT)) {
								var sliceStr = ' - ' + messages.BACKORDER_TEXT;
								option.innerHTML = option.innerHTML.slice(0, option.innerHTML.indexOf(sliceStr));
							}
							if (option.innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
								var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
								option.innerHTML = option.innerHTML.slice(0, option.innerHTML.indexOf(sliceStr));
							}
							$(option).disabled = false;
						}
						$variant_option_input = $('input[value=' + option.value + ']');
						if (typeof $variant_option_input.siblings('.selection-item')[0] !== "undefined") {
							$variant_option_input.siblings('.selection-item')[0].innerHTML = option.innerHTML;
						}
						$variant_option_span = $variant_option_input.closest('span');
						if ($variant_option_span.length > 0) {
							if (product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
								$variant_option_span.addClass('disabledSwatch');
							} else {
								$variant_option_span.removeClass('disabledSwatch');
							}
						}
					});
					$(opt).closest('label').removeClass('disabled');
				}
				if (typeof opt.value !== "undefined" && product_obj.options.includes(opt.value)) {
	
					if (product_obj.inventory === COSTCO.util.productConstants.inv_backorderd || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd && product_obj.zipcodeAvailabilityResponseCode === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	
						if ($(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
							$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
						}
						if (!$(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)) {
							$(opt)[0].innerHTML += ' - ' + messages.BACKORDER_TEXT;
						}
					} else if (product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
	
						if ($(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)) {
							var sliceStr = ' - ' + messages.BACKORDER_TEXT;
							$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
						}
						if (!$(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							$(opt)[0].innerHTML += ' - ' + messages.OUT_OF_STOCK_TEXT;
						}
						if (product_obj.zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_outOfStock) {
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
								$(opt).siblings().attr('disabled', 'disabled');
								$(opt).closest('span').addClass('disabled');
							}
							$(opt).attr('disabled', 'disabled');
						}
					}
	
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
						if (typeof opt.value !== "undefined") {
							$variant_option_input = $('input[value=' + opt.value + ']');
							if (typeof $variant_option_input.siblings('.selection-item')[0] !== "undefined") {
								$variant_option_input.siblings('.selection-item')[0].innerHTML = $(opt)[0].innerHTML;
							}
							$variant_option_span = $variant_option_input.closest('span');
							if ($variant_option_span.length > 0) {
								if (product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
									$variant_option_span.addClass('disabledSwatch');
								} else {
									$variant_option_span.removeClass('disabledSwatch');
								}
							}
						}
					}
				}
			},
			/**
	   * This function is called when a color is selected in our swatch dropdown.
	   * We need to trigger a click event on Rich FX's swatch color tiles in order
	   * for the zoomviewer to correctly update to the chosen color. The swatch color
	   * tiles should be hidden when our swatch color dropdown is showing.
	   */
			triggerSwatchDropDownSelection: function triggerSwatchDropDownSelection(swatchColor) {
	
				if (typeof swatchColor == 'undefined' || swatchColor == '') {
					return;
				}
	
				// The space at the beginning is added so blue won't match against lightblue.
				$('.RICHFXColorChangeLink span.RICHFXColorChangeSwatchName').each(function () {
					var swatchIdx = $(this).html().indexOf(' ' + swatchColor);
					if (swatchIdx >= 0 && $(this).html().substr(swatchIdx + 1) == swatchColor) {
						var $theViews = $('#theViews');
						if ($theViews) {
							$theViews.find('img').each(function () {
								$(this).off("click");
							});
						}
						$(this).next().click();
						if ($theViews) {
							$theViews.find('img').each(function () {
								$(this).on('click', function (event) {
									$(this).on("click");
								});
							});
						}
					}
				});
			},
			// displays the lowest price of all variants when no variants are selected
			showLowestPriceVariant: function showLowestPriceVariant() {
				if (phelper.isSingleVariant(products) || phelper.isMultiVariant(products)) {
					var catentry = products[0][0].catentry;
					var minPrice = this.calculateYourPrice(catentry, true);
					var maxPrice = this.calculateYourPrice(catentry, true);
					for (var i = 0, len = products[0].length; i < len; i++) {
						if (minPrice > this.calculateYourPrice(products[0][i].catentry, true)) {
							minPrice = this.calculateYourPrice(products[0][i].catentry, true);
							catentry = products[0][i].catentry;
						} else if (maxPrice < this.calculateYourPrice(products[0][i].catentry, true)) {
							maxPrice = this.calculateYourPrice(products[0][i].catentry, true);
						}
					}
					if (minPrice === maxPrice) {
						$('.starting-price').hide();
					} else {
						$('.starting-price').show();
					}
					this.pricingInfo(catentry);
					this.showBreakdown(true);
				}
			},
			// determines price to show for same price variants
			showPriceVariants: function showPriceVariants() {
				if (phelper.isSingleVariant(products) || phelper.isMultiVariant(products)) {
					// Get the price of the first product from the products array to compare
					var catentry = products[0][0].catentry,
					    price = this.calculateYourPrice(catentry, true);
					// Check to see if every other variant has the same price
					for (var i = 0, len = products[0].length; i < len; i++) {
						var item_price = this.calculateYourPrice(products[0][i].catentry, true);
						if (price != item_price) {
							break;
						}
						if (i == len - 1) {
							this.pricingInfo(catentry);
							this.showBreakdown(true);
						}
					}
				}
			},
			optionsInStockMAP: function optionsInStockMAP() {
				var inStockMap = {};
	
				for (var j = 0; j < options.length; j++) {
					// options Sku level count
					for (var k = 0; k < options[j].length; k++) {
						// options Sku attribute level count
						var skuAttr = options[j][k];
						if (skuAttr && skuAttr.s && skuAttr.s > 0) {
							//Key - optiondesc, value = Swatch type and value
							var mapValue = { 'swatchable_mode': skuAttr.s, 'vimage': skuAttr.vimage };
							inStockMap[skuAttr.i] = mapValue;
						}
					}
				}
				return inStockMap;
			},
			showBackorderMessage: function showBackorderMessage() {
				if (typeof backorderMessage !== "undefined") {
					$('#backorder-message').removeClass('hide');
					$('#backorder-message').html(backorderMessage);
				}
			},
			showSelectedOptions: function showSelectedOptions() {
				// GE scheduled deliverable
				var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
				$schDeliveryElements = $('#select-options');
	
				if (scheduledDeliverable) {
					$schDeliveryElements.show();
					$('#prod-page-delivery').removeClass('hide');
					$('#add-to-cart').hide();
					$('#add-to-cart-map').hide();
				}
			},
			handleEDDForms: function handleEDDForms() {
	
				eddInstallationServicesJSON = {};
				if (!$('#vendorName').val() || phelper.item_type == 'bundle') {
					$('#liveEDD').val("false");
					$('#edd-message-block').hide();
					$('.edd-container').hide();
					$('.primary-clause').show();
	
					if (COSTCO.util.checkElementById('#outOfStock', 'true')) {
						COSTCO.Product.enableAddtoCart();
					}
				} else {
					$('#liveEDD').val("true");
					$('.primary-clause').hide();
					$('#edd-message-block').show();
				}
			},
			formatMaxShipDate: function formatMaxShipDate(startDate) {
				var d = new Date(startDate),
				    month = '' + (d.getMonth() + 1),
				    day = '' + d.getDate(),
				    year = d.getFullYear();
	
				if (month.length < 2) month = '0' + month;
				if (day.length < 2) day = '0' + day;
	
				var langId = COSTCO.util.getLangId();
				if (langId === '-25') {
					return [day, month, year].join('/');
				} else {
					return [month, day, year].join('/');
				}
			},
	
			isValidShipMode: function isValidShipMode(defaultShipcode) {
				if (defaultShipcode && (defaultShipcode.toLowerCase() == messages.SHIPCODE_NO_SHIPPING || defaultShipcode.toLowerCase() == messages.SHIPCODE_MAIL)) {
					return false;
				} else {
					return true;
				}
			},
			invokeBuildABundle: function invokeBuildABundle(catentryid) {
				if (COSTCO.CMath.iskitsbundle) {
					var itemPartNumber = COSTCO.Product.getPartnumber();
					var ItemType = 'single';
					if (ItemType != phelper.item_type) {
						ItemType = 'variant';
					}
					var varaintParameters = { "partNumber": itemPartNumber, "catentryId": catentryid, "ItemType": ItemType };
					window.reactObj.bundle.partNumber = itemPartNumber;
					window.reactObj.bundle.catentryId = catentryid;
					window.reactObj.bundle.ItemType = ItemType;
					try {
						if ((typeof varaintParameters === 'undefined' ? 'undefined' : _typeof(varaintParameters)) != undefined) {
							window.wioEventBus.publish('bundleDataRequest', varaintParameters);
						}
					} catch (e) {
						console.log(e);
					}
				}
			},
			invokeBundleSetForPDP: function invokeBundleSetForPDP(virtualBundleID) {
				try {
					if ((typeof virtualBundleID === 'undefined' ? 'undefined' : _typeof(virtualBundleID)) != undefined) {
						var itemType = 'single';
						if (itemType != phelper.item_type) {
							itemType = 'variant';
						}
						var inputJson = { partNumber: COSTCO.Product.getPartnumber(), ItemType: itemType, virtualBundleID: virtualBundleID };
						window.wioEventBus.publish('displayBundlePackage', inputJson);
					}
				} catch (e) {
					console.log(e);
				}
			}, selectNextSwatch: function selectNextSwatch(id, count) {
				var activeColor = id.split('_')[1];
				var imageId = count + "_" + activeColor;
				if (activeColor != COSTCO.CMath.swatchActiveColor) {
					$('.selectedSwatch').removeClass('selectedSwatch');
					$("#" + id).addClass("selectedSwatch");
					$('img').removeClass('kBSwatchSelected');
					$("#" + imageId).removeClass("kBSwatchUnSelected");
					$("#" + imageId).addClass("kBSwatchSelected");
					COSTCO.CMath.setKbLabel();
					var $swatchElement = $('[data-swatch=' + activeColor + ']');
					$swatchElement.prop('selected', true);
					if (COSTCO.CMath.swatchInitialTileSelected && activeColor != COSTCO.CMath.swatchActiveColor) {
						COSTCO.CMath.swatchActiveColor = activeColor;
						COSTCO.CMath.swatchTileSelected = true;
					}
					if (COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete) {
						CMath.redirectPDP();
					}
				}
			},
			setKbLabel: function setKbLabel() {
				var labelColor = $(".selectedSwatch").attr("data-content");
				$('label[for="theKBSwatches"]').html('<span class="bold">Color: </span>' + labelColor);
			},
			buildTooltip: function buildTooltip() {
				$('body').append('<div id="KBTooltipId" class="popover fade bottom in" style=" display: block;position:absolute;visiblity:hidden;">' + '<div class="arrow" style="left: 50%;"></div><div class="popover-content"></div></div>');
			},
			showKBTooltip: function showKBTooltip(data) {
				var index = data.id.split('_')[0];
				var labelColor = $('#' + data.id).attr("data-content");
				var target = $('#' + data.id);
				$('#KBTooltipId').removeClass('hide');
				$('#KBTooltipId .popover-content').html(target.attr('data-content'));
				// update text
				target.attr('title', '');
				var tt = $('#RICHFXTooltip').offset();
				var absoluteOffset = target.offset();
				// following code for setting top postion
				var topPosition = "38";
				var actLeftPosition = parseFloat(absoluteOffset.left);
				var actTopPosition = parseFloat(absoluteOffset.top) + parseFloat(topPosition);
				$('#KBTooltipId').css('top', parseFloat(actTopPosition) + 'px');
				// following code for setting left postion
				var element = document.getElementById("KBTooltipId");
				var rect = element.getBoundingClientRect();
				var widthfalf = rect.width / 2;
				actLeftPosition = actLeftPosition - widthfalf + 20;
				$('#KBTooltipId').css('left', parseFloat(actLeftPosition) + 'px');
				$('#KBTooltipId').css('visibility', 'visible');
			}, hideKBTooltip: function hideKBTooltip(data) {
				var index = data.id.split('_')[0];
				$('#KBTooltipId').css('visibility', 'hidden');
			},
	
			redirectPDP: function redirectPDP() {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				var equalOption = optionsSelected.length === COSTCO.CMath.onloadSelectOption.length && optionsSelected.every(function (value, index) {
					return value === COSTCO.CMath.onloadSelectOption[index];
				});
				if (!equalOption) {
					var isPreviousSwatchAvailable;
					var reloadProductUrl;
					var i;
					var i;
					var swatch;
					var dropDown;
	
					(function () {
						isPreviousSwatchAvailable = false;
	
						var arr1 = optionsSelected.concat().sort();
						for (i = 0; i < product.length; i++) {
							if (products[i] != undefined) {
								products[i].forEach(function (list) {
									var arr2 = list.options.concat().sort();
									var equalValues = arr2.length === arr1.length && arr2.every(function (value, index) {
										return value === arr1[index];
									});
									if (equalValues) {
										isPreviousSwatchAvailable = true;
										reloadProductUrl = list.productUrl;
										return;
									}
								});
							}
						}
						if (!isPreviousSwatchAvailable) {
							CMath.redirectwithFirstItem(optionsSelected);
						}
						if (isPreviousSwatchAvailable) {
							// disable swatch
							$(".RICHFXColorChangeLink").addClass('disabledSwatch'); //disable image
							if (undefined != optionsSelected) {
								for (i = 0; i < optionsSelected.length; i++) {
									swatch = $('#swatches-productOption0' + i + '').length > 0;
									dropDown = $('.varis-v2[automation-id=varisSwatch_0' + i + ']').length > 0;
	
									if (swatch) {
										$("#swatchesID-productOption0" + i + "").attr('disabled', 'disabled'); //disable tile swatches
									} else if (dropDown) {
										$('.varis-v2[automation-id=varisSwatch_0' + i + ']').attr('disabled', 'disabled'); //disable dropdown
									}
								}
							}
	
							document.location.href = reloadProductUrl + "?isSwatchReload";
						}
					})();
				}
			}, reloadOnRadio: function reloadOnRadio(radioId, inputLevel) {
	
				var level = inputLevel.replace('productOption0', '');
				var tileId = radioId.split('_')[1];
				$('.radio-padding[automation-id=selectionItem_' + tileId + ']').addClass("select-radio-remove-boarder");
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				if ($('#swatches-productOption0' + level + ' .selection-box-v2 input').length > 0) {
					var firstSelectedVariant = $('#swatches-productOption0' + level + ' input[value=' + tileId + ']');
					$('#productOption0' + level).val($(firstSelectedVariant).val());
					$variant_option_input = $('input[value=' + tileId + ']');
					$variant_option_input.prop('checked', true);
					CMath.redirectPDP();
				}
			}, redirectwithFirstItem: function redirectwithFirstItem(optionsSelected) {
				var reloadPage = false;
				for (var i = 0; i < product.length; i++) {
					if (products[i] != undefined) {
						products[i].forEach(function (list) {
							list.options.forEach(function (option) {
								if (optionsSelected[0] == option) {
									reloadPage = true;
									reloadProductUrl = list.productUrl;
									return;
								}
							});
						});
					}
				}
				if (reloadPage) {
					document.location.href = reloadProductUrl + "?isSwatchReload";
				}
			}, selectCurrentSelectedItem: function selectCurrentSelectedItem() {
				$('.variantContainer select.varis option').each(function (index, inputVar) {
					$(inputVar).removeAttr('checked');
					$(inputVar).attr('aria-checked', 'false');
					$(inputVar).attr('selected', false);
				});
				var selectedAttribute = $('#selectedSwatchAttr').val();
				if (null != selectedAttribute && undefined != selectedAttribute && selectedAttribute != "") {
					selectedAttribute = selectedAttribute.replace('[', '').replace(']', '');
					var arrayselect = [];
					arrayselect = selectedAttribute.split(',');
					arrayselect.forEach(function (option) {
						//Swatch selection
	
						if ($("#activeswatch_" + option.split('#')[1] + "").length > 0) {
							$("#activeswatch_" + option.split('#')[1] + "").addClass('selectedSwatch');
							$("#activeswatch_" + option.split('#')[1] + "").attr('aria-pressed', 'true');
							$("#activeswatch_" + option.split('#')[1] + " img").removeClass('kBSwatchUnSelected');
							$("#activeswatch_" + option.split('#')[1] + " img").addClass('kBSwatchSelected');
						}
						//Tiles selection
						$('.variantContainer select.varis option').each(function (index, inputVar) {
							if ($(inputVar).val() == option.split('#')[0].trim()) {
								$(inputVar).prop('checked', true);
								$(inputVar).attr('aria-checked', 'true');
								$(inputVar).attr('selected', true);
								$(inputVar).addClass('selection-item');
							}
						});
						//Dropdown selection
						var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
						// const arr1 = optionsSelected.concat().sort();
						var noOflevels = optionsSelected.length;
						var dropDown = $('.varis[automation-id=varisSwatch_0' + parseInt(noOflevels - 1) + ']').length > 0;
						var options = [];
						if (noOflevels > 1 && dropDown) {
							for (var i = 0; i < product.length; i++) {
								if (products[i] != undefined) {
									products[i].forEach(function (list) {
										if (list.options.includes(optionsSelected[0])) {
											list.options.forEach(function (opt) {
												if (opt != optionsSelected[0]) {
													options.push(opt);
												}
											});
										}
									});
								}
							}
							if (options.length > 0) {
								$('.varis[automation-id=varisSwatch_0' + parseInt(noOflevels - 1) + ']').find('option.opt:not(:disabled)').each(function () {
									if (!options.includes($(this).attr("value"))) {
										var opt = $(this).attr("value");
										$variant_option_input = $('.varis [automation-id=varisOption_' + opt + ']');
										if ($variant_option_input.length > 0) {
											$variant_option_input.attr('disabled', 'disabled').hide();
											$variant_option_input.prop('checked', false);
										}
									}
								});
							}
						}
					});
				}
			}, hideKBSkeletone: function hideKBSkeletone() {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				$('#PDPSwatchSkeletone-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
				$('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').show();
				$('.dropdown-skeleton-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
				$('[name=productOption0' + parseInt(optionsSelected.length - 1) + ']').show();
			}
	
		};
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.CMath = CMath;
	
		return CMath;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(24), __webpack_require__(62), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (checkout_helper, addtocart, preauthchargesmodal) {
	  var OrderItems = {
	    /**
	     * Fires the OrderItemsLoaded event.
	     */
	    loaded: function loaded() {
	      COSTCO.Global.notify('OrderItemsLoaded');
	    },
	
	    /**
	     * this variable will prevent
	     * multiple calls to sms update command
	     */
	    smsPhoneUpdateStarted: false,
	    /**
	      * this variable will prevent
	      * multiple calls to AjaxRefreshFreightSavingsCmdImpl
	      */
	    initalloadCompleted: false,
	    notSoldUrl: undefined,
	    globalCalendarMap: undefined,
	    apiAlreadyCalled: undefined,
	    /**
	     * This function should be called from the including module.
	     * @return {void}
	     */
	    init: function init() {
	      this.ltlMessages();
	      this.tooltips();
	      this.popovers();
	      this.validationRules();
	      COSTCO.EDDService.callEddService();
	      COSTCO.OrderItems.updateShipModeToPickUp(false);
	      if (!COSTCO.util.isBusinessDelivery()) {
	        this.autoSelectDeliveryOption();
	      }
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_OPTIONS_FEATURE_ENABLED === true) {
	        $('body').unbind('change').on('change', '#ShopCartForm select[id="cart-options"]', function (event) {
	          COSTCO.OrderItems.cartOptionsHandler(event);
	        });
	      }
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
	        if (checkoutPage === 'review') {
	          $('.resale_option').unbind('click').on('click', function () {
	            COSTCO.OrderItems.resaleOptionHandler(this, true);
	          });
	        }
	      }
	      if ($('#isBDAppVar').val() == 'BD') {
	        if ($('#delivery-zip-shipping') && $('#delivery-zip-shipping').length == 1) {
	          $('#delivery-zip-shipping').append(COSTCO.util.tmpl('template_shipping'));
	        }
	        if ($('#delivery-zip-review') && $('#delivery-zip-review').length == 1) {
	          $('#delivery-zip-review').append(COSTCO.util.tmpl('template_review'));
	        }
	        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_OPTIONS_FEATURE_ENABLED === false) {
	          $("#ShopCartForm select[id='cart-options']").unbind('change').change(function (event) {
	            COSTCO.OrderItems.cartOptionsHandler(event);
	          });
	        }
	        //Resale radio and text view switch based on page
	        COSTCO.OrderItems.setResaleOptionView();
	
	        if (checkoutPage && costcoStoreFeatures.RESALE_FEATURE_ENABLED === true) {
	          COSTCO.OrderItems.nonTaxableAllChecked();
	        }
	
	        COSTCO.OrderItems.setDeliveryDateView();
	
	        COSTCO.OrderItems.updateShipmodeDetails();
	
	        $('#delivery-date-block-change').unbind('click').on('click', COSTCO.OrderItems.showDatePickerFocus);
	
	        if (checkoutPage === 'confirmation') {
	          COSTCO.OrderItems.formatDateForOCP();
	        }
	
	        if (checkoutPage === 'cart') {
	          console.log('cart');
	          $('.resale_option').unbind('click').on('click', function () {
	            COSTCO.OrderItems.resaleOptionHandler(this, true);
	          });
	        }
	      }
	
	      // binding events to quantity input which call update when input is changed (on blur and when ENTER is pressed)
	      this.addQuantityEventHandlers();
	
	      COSTCO.util.resetScreenReaderAnnouncement();
	      COSTCO.util.announceSRGlobalErrorMessage();
	
	      // binding events to quantity input which call update when input is changed (on blur and when ENTER is pressed)
	      COSTCO.util.resetScreenReaderAnnouncement();
	      COSTCO.util.announceSRGlobalErrorMessage();
	      // Start mutation observer for Narvar EDD, except on payment and confirmation (orderitems - init)
	      if (checkoutPage !== 'payment') {
	        if (checkoutPage !== 'confirmation') {
	          COSTCO.Header.startEDDMutationObserver();
	        }
	      }
	
	      this.maskInputs();
	      this.maskTiresSmsInputField();
	
	      //Anounce SR message that cart is empty
	      if ($('#empty-cart-id').length > 0) {
	        COSTCO.util.announceSRMessage(messages.CART_EMPTY_SHORT);
	        if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true') {
	          if (typeof adobeProductData != 'undefined' && typeof adobeAnalyticsCommonData != 'undefined' && typeof contextVariables != 'undefined') {
	            contextVariables.priceTotal = 0;
	            COSTCO.AdobeEvents.init('commerce.productListViews', adobeProductData, adobeAnalyticsCommonData, contextVariables);
	          }
	        }
	      }
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	        COSTCO.OrderItems.removeRedudantMinibannerImport();
	        COSTCO.OrderItems.checkSelectedRadioButton();
	        $('[name="delivery-options-radio"]').each(function () {
	          $(this).find('input[type=radio]').unbind('change').change(function () {
	            COSTCO.OrderItems.checkSelectedRadioButton();
	          });
	        });
	      }
	
	      //Check for invalid ship mode for all the products in cart and display error message.
	      //STRY0182081 changes starts
	      if (checkoutPage === 'cart' && $('#isBDAppVar').val() == 'BC') {
	        COSTCO.OrderItems.validateShipMode(true);
	        if (COSTCO.util.isRunningOnMobileApp()) {
	          $('#cart-back-to-top').addClass('sticky');
	        }
	      }
	
	      //STRY0182081 changes ends
	
	      if (checkoutPage === 'multi-shipping') {
	        COSTCO.OrderItems.bindHeaderFooterLinksForLeavePageModal();
	      }
	
	      //SFSTRY0026170 SR announce order confirmation
	      if ($('#h1-thank-you-for-your-order').length > 0) {
	        $('#h1-thank-you-for-your-order').focus();
	      }
	    },
	
	    /**
	     * SFSTRY0038308: If an item has delivery option(s) and none is selected, auto-select the first available one.
	     */
	    autoSelectDeliveryOption: function autoSelectDeliveryOption() {
	      var deliveryRadioSelector = 'div.selection-box-v3 input[type="radio"][id^="ship-mode-radio"]';
	      $('.delivery-options.form-group[role="radiogroup"]').each(function () {
	        var $radios = $(this).find(deliveryRadioSelector);
	        if ($radios.filter(':checked').length === 0) {
	          var $firstNonDisabledRadio = $radios.filter(':not(:disabled)').first();
	          if ($firstNonDisabledRadio.length) {
	            var onclickScript = $firstNonDisabledRadio.attr('onclick');
	            if (onclickScript) {
	              try {
	                // Execute via eval() and not by triggering click event in order not to disrupt page CSS
	                eval(onclickScript); // Safe as onclick script comes from JSP
	              } catch (err) {
	                console.error(err);
	              }
	            }
	          }
	        }
	      });
	    },
	
	    /**
	     * Display LTL messages only if there is more than one LTL item in cart/order.
	     * LTL messages are by default hidden on page load.
	     * (Cart: CartOrderItem_UI.jspf; Order Review: ReviewItemLine.jsp)
	     */
	    ltlMessages: function ltlMessages() {
	      if ($('.ltl-container').length > 1) {
	        $('.ltl-container').removeClass('hide');
	      }
	    },
	
	    /** Display global pickup error for Bopiw and STW items on page load 
	     * and ship mode change */
	    displayGlobalPickUpAlerts: function displayGlobalPickUpAlerts(hasPickUpServiceError, isShipmodeSwitch) {
	
	      COSTCO.Header.popovers();
	      var hasErrSet = false;
	      var isShipmodeSwitch = isShipmodeSwitch ? isShipmodeSwitch : false;
	      if ($('[id^=error_pickup_wio_disabled_]').length > 0) {
	        COSTCO.OrderItems.showErrors(messages.ERR_PICKUP_WIO_DISABLED_CART_HEADER, '#bopiwWIOError');
	        hasErrSet = true;
	      }
	
	      if ($('[id^=error_pickup_unavailable_]').length > 0) {
	        var hasError = false;
	        $('[id^=error_pickup_unavailable_]').each(function () {
	          if (!hasError && !$(this).hasClass('hidden')) {
	            hasError = true;
	          }
	        });
	        if (hasError) {
	          COSTCO.OrderItems.showErrors(messages.ERR_PICKUP_UNAVAILABLE_CART_HEADER, '#bopiwUnavailableError');
	          if (checkoutPage === 'cart') {
	            digitalDataEvents.push({ uimsg: "ShoppingCart | Full | Pick-up is unavailable | Check Nearby Warehouses" });
	          } else if (checkoutPage === 'review') {
	            digitalDataEvents.push({ uimsg: "Checkout Flow | Pick-up is unavailable - check nearby warehouses" });
	          }
	          hasErrSet = true;
	        }
	      }
	
	      if ($('[id^=mdo_error_pickup_unavailable_]').length > 0) {
	        var hasMdoError = false;
	        $('[id^=mdo_error_pickup_unavailable_]').each(function () {
	          if (!hasMdoError && !$(this).hasClass('hidden')) {
	            hasMdoError = true;
	          }
	        });
	        if (hasMdoError) {
	          COSTCO.OrderItems.showErrors(messages.ERR_MDO_PICKUP_UNAVAILABLE_CART_HEADER, '#mdoUnavailableError');
	          //Analytics to be added for mdo 
	          if (checkoutPage === 'cart') {
	            digitalDataEvents.push({ uimsg: "Cart | Pick-Up | Pick-Up is Unavailable" });
	          } else if (checkoutPage === 'review') {
	            digitalDataEvents.push({ uimsg: "Checkout Flow | Pick-Up | Pick-Up is Unavailable" });
	          }
	          hasErrSet = true;
	        }
	      }
	
	      if (!hasErrSet && hasPickUpServiceError) {
	        COSTCO.OrderItems.showErrors(messages.ERR_PICKUP_SERVICE, '#bopiwServiceError');
	        hasErrSet = true;
	      }
	
	      if (!hasErrSet) {
	        $('#bopiwWIOError').empty();
	        $('#bopiwWIOError').removeClass('critical-notification order-error');
	        $('#bopiwServiceError').empty();
	        $('#bopiwServiceError').removeClass('critical-notification order-error');
	        $('#bopiwUnavailableError').empty();
	        $('#bopiwUnavailableError').removeClass('critical-notification order-error');
	      }
	
	      var hasWarningSet = false;
	      if (!isShipmodeSwitch) {
	        if ($('[id^=newSTWItem_]').length > 0) {
	          COSTCO.OrderItems.showWarnings(messages.PICKUP_WARNING_MESSAGE_NEW_STW_ITEM, '#bopiwNewStwItemAlert');
	          hasWarningSet = true;
	        }
	        if ($('[id^=warehouseChanged_]').length > 0) {
	          COSTCO.util.announceSRMessage(messages.PICKUP_WARNING_MESSAGE_WAREHOUSE_CHANGED);
	        }
	
	        if ($('[id^=orderDateChanged_]').length > 0 && !isShipmodeSwitch) {
	          var orderDateChanged = false;
	          $('[id^=orderDateChanged_]').each(function () {
	            if (!orderDateChanged && !$(this).hasClass('hidden')) {
	              orderDateChanged = true;
	            }
	          });
	
	          if (orderDateChanged) {
	            COSTCO.OrderItems.showWarnings(messages.PICKUP_WARNING_MESSAGE_EDD_CHANGED_HEADER, '#bopiwEddChangeAlert');
	            if (checkoutPage === 'cart') {
	              digitalDataEvents.push({ uimsg: "ShoppingCart | Full | Estimated Pick-up Date has Changed" });
	            } else if (checkoutPage === 'review') {
	              digitalDataEvents.push({ uimsg: "Checkout Flow | Estimated Pick-up Date has Changed" });
	            }
	            hasWarningSet = true;
	          }
	        }
	      }
	      if (!hasWarningSet) {
	        $('#bopiwNewStwItemAlert').empty();
	        $('#bopiwEddChangeAlert').empty();
	      }
	    },
	
	    showWarnings: function showWarnings(warning, warningLoc) {
	      if (warning != '' && warning != undefined && $(warningLoc).children('p').length < 1) {
	        $(warningLoc).append('<p>' + warning + '</p>').show();
	        $('html, body').animate({ scrollTop: $('.warning').offset().top }, 'slow');
	        COSTCO.util.announceSRMessage(warning);
	      }
	    },
	
	    showErrors: function showErrors(error, errLoc) {
	      if (error != '' && error != undefined && $(errLoc).children('p').length < 1) {
	        $(errLoc).addClass('critical-notification order-error');
	        $(errLoc).append('<p class="sr-only">' + messages.ERROR + '</p>').show();
	        $(errLoc).append('<p>' + error + '</p>').show();
	        $('html, body').animate({ scrollTop: $('.error').offset().top }, 'slow');
	        $('#hasPickUpError').val(true);
	        COSTCO.util.announceSRMessage(error);
	      }
	    },
	
	    invokeWarehouseCartCheckoutSideBarBOPIW: function invokeWarehouseCartCheckoutSideBarBOPIW(pageName, partNumber, useWarehouseInventory, isShiptoWarehouseItem, orderItemId, warehouseNumber, zipCode) {
	      var map = { 'pageName': pageName, 'itemNumber': partNumber, 'useWarehouseInventory': useWarehouseInventory, 'isShiptoWarehouseItem': isShiptoWarehouseItem, 'orderItemId': orderItemId, 'warehouseNumber': warehouseNumber, 'zipCode': zipCode };
	      window.wioEventBus.publish('changeMyWarehouseSideBar', map);
	    },
	    /**
	     * onclick handler for the "Get Directions" link. Opens a new tab and redirects
	     * to maps.google.com using Current Location as starting addr and warehouse
	     * address as the destination address.
	     * @param  {addressLine1, city, state, country} used to get the warehouse address
	     * @return {void}
	     */
	    mdoCartDirectionLink: function mdoCartDirectionLink(addressLine1, city, state, country) {
	      addressLine1 = addressLine1;
	      city = city;
	      state = state;
	      country = country;
	      var warehouseAddress = encodeURIComponent(['Costco'].concat(addressLine1.split(' ')).concat(city.split(' ')).concat(state.split(' ')).concat(country.split(' ')).join(' '));
	      var win = window.open(window.location.protocol + '//maps.google.com?saddr=Current+Location&daddr=' + warehouseAddress);
	      win.focus();
	    },
	
	    /**
	     * method that determines if order should be sent to multiple or single address
	     * based on users selected addresses
	     */
	    shipToMultiOrSingleAddress: function shipToMultiOrSingleAddress(redirectURL) {
	      if (COSTCO.OrderItems.allItemsHaveSameAddress()) {
	        if (redirectURL != undefined && redirectURL != '') {
	          $('<input>').attr({
	            type: 'hidden',
	            name: 'redirect_url',
	            value: redirectURL
	          }).appendTo('#ShipAsCompleteForm');
	        }
	        COSTCO.OrderItems.submitSingleShippingForm();
	      } else {
	        if (redirectURL != undefined && redirectURL != '') {
	          $('<input>').attr({
	            type: 'hidden',
	            name: 'redirect_url',
	            value: redirectURL
	          }).appendTo('#continue-multi-address-form');
	        }
	        document.getElementById('continue-multi-address-form').submit();
	      }
	    },
	
	    /**
	     * Canceling actions on Multiple Shipping address page. 
	     * Reverts the address modifications to previously selected address
	     */
	    cancelMultiShipToddress: function cancelMultiShipToddress(redirectURL) {
	      $('[name^="addressId_"]').each(function (index, element) {
	        $(element).val($(element).attr('data-orderitem-addressid'));
	      });
	      COSTCO.OrderItems.shipToMultiOrSingleAddress(redirectURL);
	    },
	
	    /**
	     * Binding header and footer links for initiating leave page modal
	     * 
	     */
	    bindHeaderFooterLinksForLeavePageModal: function bindHeaderFooterLinksForLeavePageModal() {
	
	      var headerAndFooterLinks = $('#header-checkout-widget, #footer-bottom').find("a");
	      headerAndFooterLinks.click(function () {
	        var addressValue = $(this).attr("href");
	        if (addressValue != '#') COSTCO.OrderItems.initiateLeavePageModal(addressValue);
	        return false;
	      });
	    },
	
	    /**
	     * Showing leave page modal if user chooses to cancel shopping
	     * @param {string} secondaryButtonHref	To set where primary button should redirect
	     */
	    initiateLeavePageModal: function initiateLeavePageModal(secondaryButtonHref) {
	
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.LEAVE_PAGE_MODAL_TITLE,
	        body: messages.LEAVE_PAGE_MODAL_BODY,
	        primary: messages.LEAVE_PAGE_MODAL_LEAVE_PAGE_BUTTON,
	        secondary: messages.LEAVE_PAGE_MODAL_STAY_ON_PAGE_BUTTON,
	        dialogclasses: 'modalv2',
	        secondary_button_style: 'tertiary',
	        primary_event: function primary_event() {
	          COSTCO.OrderItems.cancelMultiShipToddress(secondaryButtonHref);
	        },
	        secondary_event: function secondary_event() {
	          COSTCO.dialog.close();
	        }
	      });
	    },
	
	    /**
	     * check if all order items have the same selected address
	     */
	    allItemsHaveSameAddress: function allItemsHaveSameAddress() {
	      var addressIds = $('[name^="addressId_"]').map(function () {
	        return this.value;
	      }).get();
	
	      return $('.warehouse-pickup-address').length === 0 && $('#tire-item-address-container').length === 0 && addressIds.every(function (val, i, arr) {
	        return val === arr[0];
	      });
	    },
	
	    /**
	     * method for submitting single address form on multi-shipping page 
	     */
	    submitSingleShippingForm: function submitSingleShippingForm() {
	      $('<input>').attr({
	        type: 'hidden',
	        name: 'shipAddressId',
	        value: $('[name^="addressId_"]').val()
	      }).appendTo('#ShipAsCompleteForm');
	      document.getElementById('ShipAsCompleteForm').submit();
	    },
	
	    /**
	     *  Removing redudant minibanner from page which have display:none class
	     * 
	     */
	    removeRedudantMinibannerImport: function removeRedudantMinibannerImport() {
	      $(".top-bar:hidden").remove();
	    },
	
	    /**
	     * this method will be initiated when some of the addresses change
	     * it will call command for updating sms on order items that have associated address
	     * with which this method was called
	     */
	    updateSmsPhoneForOrderItems: function updateSmsPhoneForOrderItems(address) {
	
	      if (!OrderItems.smsPhoneUpdateStarted) {
	        OrderItems.smsPhoneUpdateStarted = true;
	        COSTCO.AjaxModular.ajax_update_state({
	          url: 'CostcoMultipleOrderItemsUpdateSmsPhoneCmd',
	          method: 'POST',
	          dataType: 'json',
	          data: address,
	          scrollToError: false,
	          done: function done(data, textStatus, jqXHR, options) {
	            COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
	            COSTCO.OrderItems.tooltips();
	          },
	          always: function always() {
	            OrderItems.smsPhoneUpdateStarted = false;
	          }
	        });
	      }
	    },
	
	    addQuantityEventHandlers: function addQuantityEventHandlers() {
	      if ($('.quantity-selector-v2 input[name^=quantity_]').length > 0) {
	        // saves old value of quantity to compare with newly entered value
	        $('.quantity-selector-v2 input[name^=quantity_]').off('focusin').on('focusin', function () {
	          $(this).data('val', $(this).val());
	        });
	
	        $('.quantity-selector-v2 input[name^=quantity_]').off('keydown change').on('keydown change', function (e) {
	          if (e.which == 13 || e.type == 'change') {
	            e.preventDefault();
	            if ($(this).val() !== $(this).data('val')) {
	              COSTCO.OrderItems.changeQuantityValue(this);
	            } else {
	              $(this).next().focus();
	            }
	          }
	        });
	      }
	    },
	    getStringOfZerosByLength: function getStringOfZerosByLength(length) {
	      var output = '';
	      while (length > 0) {
	        output = output + '0';
	        length--;
	      }
	      return output;
	    },
	    maskInputs: function maskInputs() {
	      $('input[name^=smsPhone]').unmask().mask('000-000-0000');
	      if (COSTCO.util.isBusinessDelivery()) {
	        $("input[id*='quantity_']").unmask().mask('0000');
	      } else {
	        if ($('#cartTotalLimitBC').length) {
	          var qntyMaskBC = this.getStringOfZerosByLength($('#cartTotalLimitBC').val().length);
	          $("input[id*='quantity_']").unmask().mask(qntyMaskBC);
	        }
	      }
	      $('#edit-contact-information-phone input[id^=smsPhoneId_]').unmask().mask('000-000-0000');
	      $('.scheduled-delivery-widget-v2 input[id^=contactPhone_]').unmask().mask('000-000-0000');
	      $('[id^=edit-contact-information-phone] input[id^=smsPhoneId_]').unmask().mask('000-000-0000');
	    },
	    maskTiresSmsInputField: function maskTiresSmsInputField() {
	      $('#edit-tires-contact-information-phone input[id^=tiresSmsPhoneId_]').unmask().mask('000-000-0000');
	    },
	    setResaleOptionView: function setResaleOptionView() {
	      var page = $('.resalesection').attr('page');
	      if (page == 'CART') {
	        $('.resale_radio').removeClass('hide');
	      } else {
	        $('.resale_text').removeClass('hide');
	      }
	    },
	    cartOptionsHandler: function cartOptionsHandler(event) {
	      var option = $('#ShopCartForm').find('select[id=cart-options]').val();
	      if (option == "AddAllToList") {
	        COSTCO.Shoppinglistshelper.redirect(event, COSTCO.Shoppinglistshelper.openCartListsModal(event));
	        window.digitalDataEvents = window.digitalDataEvents || [];
	        digitalDataEvents.push({ wishLoc: "Shopping Cart | Full" });
	      } else if (option == "RemoveAllFromCart") {
	        COSTCO.dialog.createExtDialogBox({
	          title: messages.REMOVE_ITEMS_POPUP,
	          body: COSTCO.util.tmpl('tmpl_cart_remove_item_popups'),
	          primary: messages.CART_POPUP_REMOVE,
	          secondary: messages.CART_POPUP_CANCEL,
	          primary_event: function primary_event() {
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            var orderItemProducts = [];
	            var orderItems = $("#order-items .order-item");
	            $(orderItems).each(function (index, element) {
	              orderItemProducts.push({ pid: $("input[name=catalogEntryId_" + (index + 1) + "]").val(), sku: $(element).find(".itemPartNumberPurchased").text() });
	            });
	            digitalDataEvents.push({
	              cartRemove: "Shopping Cart | Full",
	              products: orderItemProducts,
	              element: event.target
	            });
	            location.href = $("#MultiItemsRemoveUrl").val();
	            $.cookie('deliveryDateCookie', '');
	          },
	          secondary_event: function secondary_event() {
	            COSTCO.dialog.close();
	            $("select[id=cart-options]").each(function () {
	              this.selectedIndex = 0;
	            });
	          },
	          onclose: function onclose(e) {
	            $("select[id=cart-options]").each(function () {
	              this.selectedIndex = 0;
	            });
	            $("label[for='cart-options']").removeClass("active");
	          }
	        });
	      } else if (option == "UseAllForResale") {
	        var radio = $("#ShopCartForm input[name^='resaleChecked_']");
	        for (var i = 0; i < radio.length; i++) {
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	            var value = radio[i].checked;
	            if (!value) {
	              $("#ShopCartForm input:checkbox[name^='resaleChecked_']")[i].checked = true;
	              COSTCO.OrderItems.resaleOptionHandler(radio[i], false);
	            }
	          } else {
	            var _value = $(radio[i]).val();
	            if (_value == "yes") {
	              $("#ShopCartForm input:checkbox[name^='resaleChecked_']")[i].checked = true;
	              COSTCO.OrderItems.resaleOptionHandler(radio[i], false);
	            }
	          }
	        }
	        OrderItems.resale_update(radio);
	        COSTCO.util.announceSRMessage(messages.ITEMS_SELECTED_RESALE);
	      } else if (option == "UseNoneForResale") {
	        var _radio = $("#ShopCartForm input[name^='resaleChecked_']");
	        for (var i = 0; i < _radio.length; i++) {
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	            var _value2 = _radio[i].checked;
	            var isTobaccoProduct = _radio[i].dataset.istobaccoproduct;
	            if (_value2 && isTobaccoProduct !== "1") {
	              $("#ShopCartForm input:checkbox[name^='resaleChecked_']")[i].checked = false;
	              COSTCO.OrderItems.resaleOptionHandler(_radio[i], false);
	            }
	          } else {
	            var _value3 = $(_radio[i]).val();
	            var id = _radio[i].name;
	            var orderItem = id.split('_')[1];
	            var isTobacco = $("#tobaccoProduct_" + orderItem).val();
	            if (isTobacco != 1 && _value3 == "no" || isTobacco == 1 && _value3 == "yes") {
	              $("#ShopCartForm input:radio[name^='resaleChecked_']")[i].checked = true;
	              COSTCO.OrderItems.resaleOptionHandler(_radio[i], false);
	            }
	          }
	        }
	        OrderItems.resale_update(_radio);
	        COSTCO.util.announceSRMessage(messages.ITEMS_DESELECTED_RESALE);
	      }
	      $('#cart-options').focus();
	    },
	    resaleLicenseModal: function resaleLicenseModal() {
	      var needResaleLicenseModal = $('#resaleLicenseModalNeeded').val();
	      if (needResaleLicenseModal) {
	
	        COSTCO.dialog.createExtDialogBox({
	          title: messages.RESALE_LICENSE_MODAL_TITLE,
	          body: COSTCO.util.tmpl('tmpl_resale_license_modal', {
	            resaleLicenseModalBody: messages.RESALE_LICENSE_MODAL_BODY
	          }),
	          primary: messages.RESALE_OPTION_YES,
	          secondary: messages.RESALE_OPTION_NO,
	          primary_event: function primary_event() {
	            COSTCO.CAddress.closeModal();
	            window.location.href = $('#return-to-cart').attr('href');
	          }
	
	        });
	      }
	    },
	    formatDateForOCP: function formatDateForOCP() {
	      var orderPlacedTime = new Date($("#orderPlacedTime").val());
	      var schedDeliveryDate = new Date($("#schedDeliveryDate").val());
	      $("#orderPlacedOn").html(OrderItems.formatDate(orderPlacedTime.getDay(), orderPlacedTime.getDate(), orderPlacedTime.getMonth(), orderPlacedTime.getFullYear(), wcs.langId));
	      $("#deliveryDate").html(OrderItems.formatDate(schedDeliveryDate.getDay(), schedDeliveryDate.getDate(), schedDeliveryDate.getMonth(), schedDeliveryDate.getFullYear(), wcs.langId));
	    },
	    setDeliveryDateView: function setDeliveryDateView() {
	      if (checkoutPage == 'shipping') {
	        if (COSTCO.util.isNdEnabled()) {
	          $("#deldatepicker").prop('disabled', false);
	        }
	        COSTCO.OrderItems.showDatePicker();
	      } else if (checkoutPage == 'review') {
	        var userChoice = false;
	        if (COSTCO.util.isNdEnabled()) {
	          $("#deldatepicker").prop('disabled', false);
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE ? $('input[name="deliveryMethod"]').val().length > 1 : $('input[name="deliveryMethod"]').length > 1) {
	            userChoice = true;
	          }
	        }
	
	        if ($('#isBDAppVar').val() == 'BD') {
	          COSTCO.OrderItems.validateDeliveryDate();
	        }
	
	        if ($('#isBDAppVar').val() == 'BD' && wcs.langId === '-1') {
	          COSTCO.OrderItems.validateVendorHoliday();
	        }
	
	        COSTCO.OrderItems.delDatePicker();
	        var cookieDate = COSTCO.OrderItems.getCookie("deliveryDateCookie");
	        if (cookieDate && cookieDate != "" && cookieDate != null && !userChoice && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
	          $('#deldatepicker-div').addClass('hide');
	          $('#delivery-date-block').removeClass('hide');
	          var date_str = COSTCO.OrderItems.getDisplayDateFormatForReview(cookieDate);
	          $("#delivery-date-block").find(".body-copy").html(date_str);
	        } else {
	          COSTCO.OrderItems.showDatePicker();
	        }
	      } else if (checkoutPage == 'cart' && (COSTCO.util.isNdEnabled() || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE)) {
	        COSTCO.OrderItems.delDatePicker();
	        $("#deldatepicker").prop('disabled', false);
	        COSTCO.OrderItems.showDatePicker();
	      }
	    },
	    showDatePicker: function showDatePicker() {
	      $('#deldatepicker-div').removeClass('hide');
	      $('#delivery-date-block').addClass('hide');
	    },
	    showDatePickerFocus: function showDatePickerFocus() {
	      COSTCO.OrderItems.showDatePicker();
	      $('#deldatepicker').focus();
	    },
	    validateDeliveryDate: function validateDeliveryDate() {
	      var shipmodeId = 10101;
	      var isCaShipModeId = false;
	      if ($('input[name="deliveryMethod"]').length > 0) {
	        var caShipModeId = $('input[name="deliveryMethod"]:checked').val();
	        isCaShipModeId = caShipModeId == '11608' || caShipModeId == '11608_SP';
	      }
	      if ((COSTCO.util.isNdEnabled() || isCaShipModeId) && $('input[name="deliveryMethod"]').length > 0) {
	        shipmodeId = $('input[name="deliveryMethod"]:checked').val();
	      }
	      var datesEnabled = [];
	      var isSelectedDateAvailable = false;
	      var isSelectedDateEmpty = true;
	      var selectedDeliveryDate = $('input[name=selDeliveryDate]').val();
	      var preferredDates = $('#preferredDates').val();
	      if (preferredDates != undefined && preferredDates != '') {
	        datesEnabled = preferredDates.split('|').filter(function (item) {
	          return item !== '';
	        });
	      }
	      var getFormattedDate = function getFormattedDate(encodedDate) {
	        var date = new Date(COSTCO.OrderItems.decode_utf8(encodedDate));
	        var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	        var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
	        return month + '/' + day + '/' + date.getFullYear();
	      };
	      if (selectedDeliveryDate && selectedDeliveryDate != '') {
	        var deliveryDate = getFormattedDate(selectedDeliveryDate);
	        isSelectedDateAvailable = datesEnabled.includes(deliveryDate);
	        isSelectedDateEmpty = false;
	      } else {
	        var inputDate = $('input#deldatepicker').val() || $('input#deldatepicker').attr('value');
	        isSelectedDateAvailable = datesEnabled.includes(inputDate);
	      }
	      if (!isSelectedDateAvailable && (shipmodeId == '10101' || shipmodeId == '10101_SP' || shipmodeId == '11608' || shipmodeId == '11608_SP')) {
	        $.cookie('deliveryDateCookie', '');
	
	        if (COSTCO.util.isNdEnabled() && isSelectedDateEmpty) {
	          $('#delivery-date-notification').removeClass('hide');
	          $('#delivery-date-notification').addClass('critical-notification');
	          $('#delivery-date-notification').text(messages.ERR_CHECKOUT_EMPTY_DELIVERY_DATE);
	        } else {
	          var foundin = $("*:contains('" + messages.ERR_CHECKOUT_DELIVERY_DATE + "')").length > 0;
	          if (!foundin) {
	            $('#delivery-date-notification').removeClass('hide');
	            $('#delivery-date-notification').addClass('critical-notification');
	            $('#delivery-date-notification').text(messages.ERR_CHECKOUT_DELIVERY_DATE);
	          }
	        }
	        if (COSTCO.util.isNdEnabled()) {
	          COSTCO.OrderSummary.chooseDeliveryMethod(true);
	        } else {
	          COSTCO.OrderSummary.chooseDeliveryMethodNdOff();
	        }
	        $('#deldatepicker').val('');
	      } else {
	        // Remove delivery date error notification for Residential address flow
	        $('#delivery-date-notification').empty();
	        $('#delivery-date-notification').removeClass('critical-notification');
	        $('#delivery-date-notification').addClass('hide');
	      }
	    },
	    validateVendorHoliday: function validateVendorHoliday() {
	      var $vendorHolidayInput = $('input#forceExpandCalendar');
	      if ($vendorHolidayInput.val()) {
	        COSTCO.OrderSummary.chooseDeliveryMethodNdOff();
	      }
	    },
	    getDisplayDateFormatForReview: function getDisplayDateFormatForReview(cookieDate) {
	      var formatedDate = '';
	      if (checkoutPage && checkoutPage == 'review' && cookieDate && cookieDate != '' && cookieDate != null) {
	        var date = new Date(COSTCO.OrderItems.decode_utf8(cookieDate));
	        formatedDate = COSTCO.OrderItems.formatDate(date.getDay(), date.getDate(), date.getMonth(), date.getFullYear(), wcs.langId);
	      }
	      return formatedDate;
	    },
	    encode_utf8: function encode_utf8(s) {
	      return encodeURIComponent(s);
	    },
	    decode_utf8: function decode_utf8(s) {
	      return decodeURIComponent(s);
	    },
	
	    validateSelectedDeliveryDate: function validateSelectedDeliveryDate(selectedDate) {
	
	      var datesEnabled = [];
	      var isSelectedDateAvailable = false;
	      var selectedDeliveryDate = $('input[name=selDeliveryDate]').val();
	      if (selectedDate != null && selectedDate != '') {
	        selectedDeliveryDate = selectedDate;
	      }
	      var preferredDates = $('#preferredDates').val();
	      if (preferredDates != undefined && preferredDates != '') {
	        datesEnabled = preferredDates.split('|').filter(function (item) {
	          return item !== '';
	        });
	      }
	      var getFormattedDate = function getFormattedDate(encodedDate) {
	        var date = new Date(COSTCO.OrderItems.decode_utf8(encodedDate));
	        var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	        var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
	        return month + '/' + day + '/' + date.getFullYear();
	      };
	      if (selectedDeliveryDate && selectedDeliveryDate != '') {
	        var deliveryDate = getFormattedDate(selectedDeliveryDate);
	        isSelectedDateAvailable = datesEnabled.includes(deliveryDate);
	      }
	      return isSelectedDateAvailable;
	    },
	
	    /**
	     * Calls the datepicker plugin (js/Widgets/ada-datepicker) on input#deldatepicker.
	     * @return {void}
	     */
	    delDatePicker: function delDatePicker() {
	      var datepickerElem = $('#deldatepicker');
	      var preferredDatesElem = $('#preferredDates').val();
	      if (preferredDatesElem != undefined && preferredDatesElem != '') {
	        var datesEnabled = preferredDatesElem.split('|').filter(function (item) {
	          return item !== '';
	        });
	        datepickerElem.datepicker({
	          format: wcs.langId === '-25' ? 'D. d M yyyy' : 'D, M dd, yyyy',
	          autoclose: true,
	          showOnFocus: false,
	          orientation: 'auto right',
	          todayHighlight: true,
	          datesEnabled: datesEnabled,
	          language: wcs.langId === '-25' ? 'fr' : 'en'
	        }).on('changeDate', function (e) {
	          $('#deliveryDatePageError').hide();
	          // Remove error message regarding wrong delivery date
	          $('#delivery-date-notification').text('');
	          $('#delivery-date-notification').removeClass('critical-notification');
	          $('#delivery-date-notification').addClass('hide');
	
	          // The change event needs the date string to pass to the server.
	          var date_str = '',
	              selected_date = e.date;
	          if (selected_date !== undefined) {
	            for (var k = 0; k < this.allowed_objs.length; k++) {
	              var date_obj = new Date(this.allowed_objs[k]);
	              var dateVal = selected_date.getDate();
	              var month = selected_date.getMonth();
	              var year = selected_date.getFullYear();
	              var day = selected_date.getDay();
	              if (dateVal == date_obj.getDate() && month == date_obj.getMonth() && year == date_obj.getFullYear()) {
	                date_str = COSTCO.OrderItems.formatDate(day, dateVal, month, year);
	                break;
	              }
	            }
	            var encodedDate = COSTCO.OrderItems.encode_utf8(date_str);
	            if (COSTCO.OrderItems.validateSelectedDeliveryDate(encodedDate) && $('.order-error').find('p').text().trim() === messages.ERR_CHECKOUT_DELIVERY_DATE) {
	              $('.order-error').removeClass('critical-notification');
	              $('.order-error').addClass('hide');
	            }
	            $.cookie('deliveryDateCookie', date_str);
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	              datepickerElem.val(date_str);
	              $("label[for='deldatepicker']").addClass('active').removeClass('error');
	            }
	            $('[name="selDeliveryDate"]').val(encodedDate);
	          }
	        }.bind({
	          allowed_objs: datesEnabled
	        }));
	
	        setTimeout(function () {
	          //let cookieDate = COSTCO.OrderItems.getCookie('deliveryDateCookie');
	          var savedShipmode = 10101;
	          var isCaShipModeId = false;
	          if ($('#savedShipmodeID').val() != undefined) {
	            var caShipModeId = $('#savedShipmodeID').val();
	            isCaShipModeId = caShipModeId == 11608;
	          }
	          if ($('#savedShipmodeID').val() != undefined && (COSTCO.util.isNdEnabled() || isCaShipModeId)) {
	            savedShipmode = $('#savedShipmodeID').val();
	          }
	          if ((datepickerElem.val() === undefined || datepickerElem.val() === '') && (savedShipmode == 10101 || savedShipmode == 11608)) {
	            datepickerElem.val(COSTCO.OrderItems.getCookie('deliveryDateCookie'));
	          }
	          var cookieDate = datepickerElem.val();
	          if (cookieDate && cookieDate != '' && cookieDate != null) {
	            var date_string = COSTCO.OrderItems.decode_utf8(cookieDate);
	            datepickerElem.datepicker('setDate', new Date(date_string));
	          }
	        });
	      }
	    },
	    bindPoNotes: function bindPoNotes() {
	      $('form#po-notes-facade-form #po-notes-facade').unbind().bind('change', function () {
	        //$('form#NewAddressSingleShippingForm input[name=poNotes]').val($(this).val());
	        $('input[name=poNotes]').val($(this).val());
	        globalPoNote = $(this).val();
	      });
	    },
	    bindDeliveryMethod: function bindDeliveryMethod() {
	      $('input[name="deliveryMethod"]').unbind().bind('change', function () {
	        var shipmodeId = $("input[name='deliveryMethod']:checked").val();
	        $('form#CheckoutReviewForm input[name="orderShipmodeId"]').val(shipmodeId);
	      });
	    },
	    copyPoNotes: function copyPoNotes(tmpvalue) {
	      $('form#po-notes-facade-form #po-notes-facade').val(tmpvalue);
	      $('input[name=poNotes]').val($('form#po-notes-facade-form #po-notes-facade').val());
	      $('#ponote-block span').html(tmpvalue);
	    },
	    globalizePoNotes: function globalizePoNotes() {
	      if ($('input[name=poNotes]') != null) {
	        globalPoNote = $('input[name=poNotes]').val();
	      }
	    },
	    /**
	     * Formats date in 'EEE, MMM dd, yyy' format for English &
	     * 'EEE. dd MMMM yyy' for French.
	     * @param {string} langId - (optional) if omitted use English
	     */
	    formatDate: function formatDate(day, date, month, year, langId) {
	      var monthNames = langId === '-25' ? ["janv.", "févr.", "mars", "avril", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."] : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	      var days = langId === '-25' ? ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"] : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
	
	      var formatedDate = langId === '-25' ? days[day] + '. ' + date + ' ' + monthNames[month] + ' ' + year : days[day] + ', ' + monthNames[month] + ' ' + date + ', ' + year;
	
	      return formatedDate;
	    },
	    getCookie: function getCookie(name) {
	      var re = new RegExp(name + "=([^;]+)");
	      var value = re.exec(document.cookie);
	      return value != null ? unescape(value[1]) : null;
	    },
	    /**
	     * [validationRules description]
	     * @return {[type]} [description]
	     */
	    validationRules: function validationRules() {
	      /**
	       * Validate a date format. Could be dd/mm/yyyy or mm/dd/yyyy
	       */
	      $.validator.addMethod("dateFormat", function (value, element) {
	        var dateArr = value.split('/');
	        return this.optional(element) || dateArr.length === 3 ? !isNaN(parseInt(dateArr[0])) && !isNaN(parseInt(dateArr[1])) && !isNaN(parseInt(dateArr[2])) ? true : false : false;
	      }, messages.ERR_INVALID_STATE);
	
	      // Used by the Shopping Cart page
	      $.validator.addMethod("quantityIncrement", function (value, element) {
	        var $quantityIncrement = $(element).data("quantity-increment");
	
	        var quantityIncrement = 1; //default quantityIncrement is always 1 (a whole number)
	        if ((typeof $quantityIncrement === 'undefined' ? 'undefined' : _typeof($quantityIncrement)) == undefined || !$quantityIncrement) {
	          return true;
	        }
	        var qty = parseInt($quantityIncrement);
	        if (qty) {
	          quantityIncrement = qty;
	        }
	        if (value % quantityIncrement != 0) {
	          return false;
	        }
	        return true;
	      });
	
	      COSTCO.ScheduledDeliverable.validationRules.phone();
	
	      $.validator.addMethod("emptyGiftMessage", function (value, element) {
	        $('label[for=giftMessageRequired]').removeClass('hide');
	        $('.gift-message-required-text').closest('.edit').children('button[id^=addGiftMessageButton_]').addClass('gift-message-required-text-error');
	        setTimeout(function () {
	          $('.gift-message-required-text').closest('.edit').children('button[id^=addGiftMessageButton_]').focus();
	        }, 200);
	        $('label[for=giftMessageRequired]').attr("role", "alert");
	        $('span[id=giftMessageRequired-error]').css("padding-left", "11px");
	        $('span[id=giftMessageRequired-error]').attr("role", "alert");
	        return false;
	      }, messages.CHECKOUT_DELIVERY_GiftMsg_Empty_Error);
	      $.validator.addMethod("giftMessageRequired", function (value, element) {
	        if (!value.includes("unsupported") && !value.includes("optional") && value.includes("_empty")) {
	          $('div.gift-message-data > div.edit > span.gift-message-required-text').html('<div class="error">' + messages.CHECKOUT_DELIVERY_GiftMsg_Empty_Error + '</div>');
	          return false;
	        } else {
	          return true;
	        }
	      }, "");
	      $.validator.addMethod("alphaNum", function (value, element) {
	        return this.optional(element) || /^[a-zA-Z0-9\u00C0-\u017F.,!?''"()\r\n\s]+$/i.test(value);
	      }, messages.CHECKOUT_DELIVERY_GiftMessageValidation);
	    },
	
	    /**
	     * messageParamSubstitute expects a variable number of parameters that will replace (right to left) the {#} portions of the message.
	     * First parameter to the function is the message with the substitute sections
	     * followed by corresponding number of arguments to do replacement on 
	     */
	    messageParamSubstitute: function messageParamSubstitute(msg) {
	      if (arguments.length <= 1) {
	        return msg;
	      }
	      var regEx = /({[0-9]+})/;
	      var argsArray = Array.prototype.slice.call(arguments);
	      var cntr;
	      for (cntr = 1; cntr < argsArray.length; cntr++) {
	        msg = msg.replace(regEx, argsArray[cntr]);
	      }
	      return msg;
	    },
	    /**
	     * This is a decorator function that is used inline for order item
	     * validation. This allows you to validate a single input in the case
	     * where you'd like to just validate one input, or ALL validate-able inputs
	     * using validate_inputs.
	     * @param  {Function} callback The function to be called after successful
	     *                             validation.
	     * @param  {string}   rule     OPTIONAL: The specific rule to validate
	     *                             if we're dealing with just one input
	     * @param  {array}    callbackParams Args passed to callback                           
	     * @return {void}
	     */
	    validate: function validate(callback, rule, callbackParams, errorPlacement) {
	      // No getting around this. You need input wrapped in form.
	      var $form = $('#ShopCartForm');
	      // This would correlate with where we called this method from. If we're
	      // calling this inline ".call(this)", "this" would represent the input
	      var $input = $(this);
	      // The function we use to add rules to dynamic inputs
	      var validate_inputs = COSTCO.OrderItems.validate_inputs;
	      // The set of rules used that get passed to $.fn.validate
	      var rules_config_obj = COSTCO.OrderItems.rules_config_obj($input);
	      checkout_helper._dynamic_validate({
	        form: $form,
	        input: $input,
	        validate_inputs: validate_inputs,
	        rule: rule,
	        rules_config_obj: rules_config_obj,
	        callback: callback,
	        errorPlacement: function errorPlacement(error, element) {
	          if (element.attr("name").startsWith("date_")) {
	            error.appendTo(element.parent());
	          } else if (typeof element.attr("data-itemtype") !== 'undefined' && element.attr("data-itemtype") !== false && element.attr("data-itemtype").startsWith("variableQuantity")) {
	            error.insertAfter(element.parent().parent());
	          } else {
	            error.insertAfter(element.parent());
	          }
	        },
	        callbackParams: callbackParams
	      });
	
	      //go to the first visible and non-empty error on the page if there is one
	      if ($('#isBDAppVar').val() == 'BD') {
	        if ($('.datepickererror').not(':empty').length > 0 && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	          $('html, body').animate({ scrollTop: $('[name=' + $('.datepickererror').not(':empty').attr('for') + ']').offset().top - 50 }, 500);
	          $('#deldatepicker').focus();
	        }
	      } else {
	        var statusCode = $('#statusCode').val();
	        if ($('#hasPickUpError').val() == "true" || $('label.error').not(':empty').length > 0 && $('[name=' + $('label.error').not(':empty').attr('for') + ']').length > 0) {
	          //$('html, body').animate({ scrollTop: $('[name=' + $('label.error').not(':empty').attr('for') + ']').offset().top - 50 }, 500)
	          $('html, body').animate({ scrollTop: $('.error').offset().top }, 'slow'); //recreating scroll-top
	          if (statusCode != null && statusCode != undefined && statusCode != "" && statusCode != 200) {
	            COSTCO.util.announceSRMessage(messages.ERR_PICKUP_SERVICE);
	          } else if ($('#hasPickUpError').val() == "true") {
	            if ($('[id^=mdo-pickUp-unAvailable]').length > 0) {
	              COSTCO.util.announceSRMessage(messages.ERR_MDO_PICKUP_UNAVAILABLE_CART_HEADER);
	            } else {
	              COSTCO.util.announceSRMessage(messages.ERR_PICKUP_UNAVAILABLE_CART_HEADER);
	            }
	          }
	        } else if ($('[id^=error_pickup_wio_disabled_]').length > 0) {
	          $('html, body').animate({ scrollTop: $('.error').offset().top }, 'slow'); //recreating scroll-top
	          COSTCO.util.announceSRMessage(messages.ERR_PICKUP_WIO_DISABLED_CART_HEADER);
	        }
	      }
	    },
	    nonTaxableOptionHandler: function nonTaxableOptionHandler(event) {
	      var id = event.name;
	      var nonTaxableOption = event.type === 'checkbox' ? event.checked : event.value === "yes";
	      if (nonTaxableOption) {
	        var radio = $("#ShopCartForm input[name^='resaleChecked_']");
	        for (var i = 0; i < radio.length; i++) {
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	            var value = radio[i].checked;
	            if (!value) {
	              $("#ShopCartForm input:checkbox[name^='resaleChecked_']")[i].checked = true;
	              COSTCO.OrderItems.resaleOptionHandler(radio[i], false);
	            }
	          } else {
	            var _value4 = $(radio[i]).val();
	            if (_value4 == "yes") {
	              $("#ShopCartForm input:radio[name^='resaleChecked_']")[i].checked = true;
	              COSTCO.OrderItems.resaleOptionHandler(radio[i], false);
	            }
	          }
	        }
	        $('#' + event.id).removeAttr("data-bi-tc");
	        if (checkoutPage && checkoutPage == 'review') {
	          $('#' + event.id).attr("data-bi-tc", "ui:Checkout | Select All Items as Non-Taxable");
	        } else {
	          $('#' + event.id).attr("data-bi-tc", "ui:Cart | Select All Items as Non-Taxable");
	        }
	        OrderItems.resale_update(radio);
	        COSTCO.util.announceSRMessage(messages.ITEMS_SELECTED_RESALE);
	      } else {
	        var _radio2 = $("#ShopCartForm input[name^='resaleChecked_']");
	        for (var i = 0; i < _radio2.length; i++) {
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	            var _value5 = _radio2[i].checked;
	            var isTobaccoProduct = _radio2[i].dataset.istobaccoproduct;
	            if (_value5 && isTobaccoProduct !== "1") {
	              $("#ShopCartForm input:checkbox[name^='resaleChecked_']")[i].checked = false;
	              COSTCO.OrderItems.resaleOptionHandler(_radio2[i], false);
	            }
	          } else {
	            var _value6 = $(_radio2[i]).val();
	            var _id = _radio2[i].name;
	            var orderItem = _id.split('_')[1];
	            var isTobacco = $("#tobaccoProduct_" + orderItem).val();
	            if (isTobacco != 1 && _value6 == "no" || isTobacco == 1 && _value6 == "yes") {
	              $("#ShopCartForm input:radio[name^='resaleChecked_']")[i].checked = true;
	              COSTCO.OrderItems.resaleOptionHandler(_radio2[i], false);
	            }
	          }
	        }
	
	        $('#' + event.id).removeAttr("data-bi-tc");
	        if (checkoutPage && checkoutPage == 'review') {
	          $('#' + event.id).attr("data-bi-tc", "ui:Checkout | De-Select All Items as Non-Taxable");
	        } else {
	          $('#' + event.id).attr("data-bi-tc", "ui:Cart | De-Select All Items as Non-Taxable");
	        }
	        OrderItems.resale_update(_radio2);
	        COSTCO.util.announceSRMessage(messages.ITEMS_DESELECTED_RESALE);
	      }
	    },
	    resaleOptionHandler: function resaleOptionHandler(e, updateEach) {
	      var id = e.name;
	      var resaleOption = e.type === 'checkbox' ? e.checked : e.value === "yes";
	      var resaleInput = 'resaleFlag_' + id.split('_')[1];
	      var flagValue = void 0;
	      var attributeAnalytics = void 0;
	      if (resaleOption) {
	        flagValue = id.split('_')[1] + "_1";
	        if (checkoutPage && checkoutPage == 'review') {
	          attributeAnalytics = "ui:Checkout | Non-Taxable | Select Product";
	        } else {
	          attributeAnalytics = "ui:Cart | Non-Taxable | Select Product";
	        }
	      } else {
	        flagValue = id.split('_')[1] + "_0";
	        if (checkoutPage && checkoutPage == 'review') {
	          attributeAnalytics = "ui:Checkout | Non-Taxable | De-Select Product";
	        } else {
	          attributeAnalytics = "ui:Cart | Non-Taxable | De-Select Product";
	        }
	      }
	      $('#ShopCartForm').find('#' + resaleInput).val(flagValue);
	      $('#ShopCartForm').find('#' + id).removeAttr("data-bi-tc");
	      $('#ShopCartForm').find('#' + id).attr("data-bi-tc", attributeAnalytics);
	      if (updateEach) {
	        OrderItems.resale_update(e);
	      }
	    },
	    nonTaxableAllChecked: function nonTaxableAllChecked() {
	      var counter = 0;
	      var resaleItems = $('#ShopCartForm').find('input[name="resaleCheckedIds"]') || [];
	      if (resaleItems.length > 0) {
	        for (var _i = 0; _i < resaleItems.length; _i++) {
	          var isChecked = resaleItems[_i].value.split('_')[1];
	          if (isChecked == 0) {
	            counter++;
	          }
	        }
	        if ($('#resaleAllChecked').length > 0) {
	          if (counter > 0) {
	            $('#resaleAllChecked').prop('checked', false);
	          } else {
	            $('#resaleAllChecked').prop('checked', true);
	          }
	        }
	      } else {
	        $('#nonTaxableAllCheckbox').addClass('hide');
	      }
	    },
	    resale_update: function resale_update(input) {
	      // Input injector intially sets ajaxFlag to true in the ShopCartForm,
	      // but subsequent calls need to ensure it is set
	      // true because ajax_update_post_done sets it false.
	      $('#ShopCartForm input[name=ajaxFlag]').val(true);
	      checkout_helper.ajax_update_state({
	        url: '/AjaxResaleUpdate',
	        method: "POST",
	        data: $('#ShopCartForm').serialize(),
	        ajax_replace_content: function ajax_replace_content(response_obj, mergedOptions, defaultOptions) {
	          defaultOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
	        },
	        ajax_update_post_done: function ajax_update_post_done(response_obj, mergedOptions, defaultOptions) {
	          COSTCO.Header.miniShopCartRefresh();
	          $('#ShopCartForm input[name=ajaxFlag]').val(false);
	          COSTCO.OrderItems.init();
	          $('#' + input.id).focus();
	        },
	        inputContainer: input
	      });
	    },
	    /**
	     * All of the potentail rules to pass to $.fn.validator. These are
	     * "order item" specific.
	     * @param input input quantity value element reference
	     * @return {object}     The object with all of the rules attached as
	     *                      properties.
	     */
	    rules_config_obj: function rules_config_obj(input) {
	      var rules = {};
	      var unitOfMeasure = COSTCO.Product.getUnitOfMeasure(input);
	      var increment = COSTCO.Product.getQuantityStep(input, unitOfMeasure);
	      if ($('#isBDAppVar').val() == 'BD') {
	        rules.quantity = {
	          required: true,
	          min: 0,
	          digits: true,
	          quantityIncrement: true,
	          messages: {
	            required: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY,
	            min: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_INVALID_QTY.replace("{0}", increment),
	            maxlength: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_HIGHER_QTY_2.replace("{0}", COSTCO.Product.maxQuantity()),
	            digits: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY,
	            quantityIncrement: function quantityIncrement(params, element) {
	              var message = "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_CART_MSG_QTY_INC_BD;
	              return OrderItems.messageParamSubstitute(message, increment);
	            }
	          }
	        };
	      } else {
	        rules.quantity = {
	          required: true,
	          min: 0,
	          max: Number($('#cartTotalLimitBC').val()),
	          digits: true,
	          messages: {
	            required: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY,
	            min: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_INVALID_QTY.replace("{0}", COSTCO.Product.getQuantityStep(input)),
	            max: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_HIGHER_QTY_2.replace("{0}", COSTCO.Product.maxQuantity()),
	            maxlength: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_HIGHER_QTY_2.replace("{0}", COSTCO.Product.maxQuantity()),
	            digits: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY
	          }
	        };
	      }
	      rules.pad = {
	        required: true,
	        messages: {
	          required: messages.SHIP_SELECT_PRE_DEL_DATE
	        }
	      };
	
	      rules.protectionPlanQuantity = {
	        required: true,
	        digits: true,
	        max: function max(element) {
	          var parentOrderItemQty = $(element).closest('.order-item').find('input[id^="quantity_"]').val();
	          return parseInt(parentOrderItemQty);
	        },
	        messages: {
	          required: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY,
	          digits: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY,
	          max: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY
	        }
	      };
	
	      if (COSTCO.util.getLangId() == -25) {
	        rules.pad.dateFormat = true;
	        rules.pad.messages.date = messages.SHIP_SELECT_PRE_DEL_DATE;
	      } else {
	        rules.pad.date = true;
	        rules.pad.messages.date = messages.SHIP_SELECT_PRE_DEL_DATE;
	      }
	
	      // Parts and services
	      rules.scheduledDelivery = {};
	      rules.scheduledDelivery.contactPhone = {
	        required: true, contactPhone: true,
	        messages: {
	          contactPhone: messages.ERR_INVALID_PHONE1
	        }
	      };
	      rules.scheduledDelivery.deliveryDate = {
	        required: true
	      };
	      rules.giftMessageRequired = {
	        emptyGiftMessage: true
	      };
	      return rules;
	    },
	
	    cartKitsBundleRemove: function cartKitsBundleRemove(removeOrderitemsId, quantityId, isPharmacy, prescriptionId, oldQtyval) {
	      var remove_html = '';
	      var item_names = [];
	      var callerElement = event.target;
	      removeOrderitemsId.forEach(function (removeOrderitemsId) {
	        var item_name = $('#product-name_' + removeOrderitemsId).text();
	        item_names.push(item_name);
	      });
	      var item_name_kits = "";
	      for (var i = 0; i < item_names.length; i++) {
	        item_name_kits += "<li>" + item_names[i] + "</li><br>";
	      }
	      COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	      remove_html += COSTCO.util.tmpl('tmpl_cart_remove_all_associated_items_popup', { item_name_kits: item_name_kits });
	      var modalSettings = {
	        modalLabel: messages.REMOVE_ITEM_MODAL_ALERT,
	        title: messages.REMOVE_ITEM_POPUP,
	        body: remove_html,
	        primary: messages.CART_POPUP_REMOVE_ITEMS,
	        secondary: messages.CART_POPUP_CANCEL,
	        primary_event: function primary_event() {
	          $('#' + quantityId).val(0);
	          COSTCO.OrderItems.quantity_update(quantityId, isPharmacy, prescriptionId);
	        }, onshown: function onshown() {
	          $('button[automation-id=closeModalButton]').focus();
	        }, secondary_event: function secondary_event() {
	          COSTCO.dialog.close();
	          COSTCO.OrderItems.notSoldUrl = "";
	          if (typeof oldQtyval !== 'undefined') {
	            $('#' + quantityId).val(oldQtyval);
	          }
	        }, onclose: function onclose(e) {
	          COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	          COSTCO.OrderItems.notSoldUrl = "";
	          if (typeof oldQtyval !== 'undefined') {
	            $('#' + quantityId).val(oldQtyval);
	          }
	        }
	
	      };
	      COSTCO.dialog.showModal(modalSettings);
	    },
	    /**
	     * If I intend to validate all of the inputs associated with order items,
	     * I pass my rules config obj and use each rule associatd with the input.
	     * I want to use the rules_config_obj.quantity rule with input.quantity.
	     * @param  {object} rules_config_obj The rules object
	     * @return {void}
	     */
	    validate_inputs: function validate_inputs(rules_config_obj) {
	      $('input[type=tel].quantity').each(function (i, input) {
	        $(input).rules("add", rules_config_obj.quantity);
	      });
	      // Add all PAD required items and check if at least one shipping option
	      // was selected.
	      $('.delivery-option-radios').each(function (i, delivery_radios) {
	        if (checkout_helper.is_pad_required(delivery_radios) || checkout_helper.is_pad_selected(delivery_radios)) {
	          var $input = $(delivery_radios).parents('.delivery-options').find('input.date-input');
	          $input.rules("add", rules_config_obj.pad);
	        }
	      });
	
	      $('input[id^="contactPhone"]').each(function (i, input) {
	        $(input).rules("add", rules_config_obj.scheduledDelivery.contactPhone);
	      });
	
	      $('input[id^="deliveryDate"]').each(function (i, input) {
	        $(input).rules("add", rules_config_obj.scheduledDelivery.deliveryDate);
	      });
	
	      //if there are any inputs with giftMessageRequired = true, then add rule
	      $('input[name=giftMessageRequired]').each(function (i, input) {
	
	        $(input).rules('add', rules_config_obj.giftMessageRequired);
	      });
	    },
	    /**
	     * Holds the available ship dates for order items that have selected
	     * PAD as their delivery option.
	     * @type {Object}
	     */
	    ship_dates: {},
	    /**
	     * The .co-info element represents a tooltip. Eco-fees,
	     * plain packaging, etc.
	     * @return {void}
	     */
	    tooltips: function tooltips() {
	      COSTCO.util.accesible_popover($('.co-info, .co-help'));
	      $('.a11y-tooltip').popover();
	    },
	    popovers: function popovers() {
	      $('.help-icon').popover({
	        trigger: 'focus',
	        placement: 'bottom'
	      });
	      $('.help-icon').popover();
	    },
	    /**
	     * Simply submit the shop cart form. Used as a callback function for
	     * COSTCO.OrderItems.validate. Inlined in CartBody.jsp
	     */
	    submit_cart: function submit_cart() {
	      var products = [];
	      var noOfItems = $('#order-items').find('.order-item').length;
	      //STRY0182081 changes starts
	      //Holds the flag to check whether the page holds valid ship mode id or not.
	      var hasValidShipmodeId = true;
	      for (var i = 1; i <= noOfItems; i++) {
	        var orderItemId = $('#orderItem_' + i).val();
	        var shipmodeId = $('#orderitem_shipmodedetails_' + orderItemId) != null ? $('#orderitem_shipmodedetails_' + orderItemId).val() : null;
	        var isOrderItemShipModeListEmpty = $('#isOrderItemShipModeListEmpty_' + orderItemId) != null ? $('#isOrderItemShipModeListEmpty_' + orderItemId).val() : false;
	        //Check if the shipmodeId is undefined or shimodelist is empty, then set to false and show the error message.
	        if ((shipmodeId == null || typeof shipmodeId === 'undefined' || shipmodeId == "" || isOrderItemShipModeListEmpty) && $('#isBDAppVar').val() == 'BC') {
	          hasValidShipmodeId = false;
	        }
	        $('#shipMode_' + orderItemId).val(shipmodeId);
	        var quantity = $('#quantity_' + i).val();
	        var partNumber = $('.order-item')[i - 1].dataset.orderitemnumber;
	        products.push({
	          qty: quantity,
	          partNumber: partNumber
	        });
	      }
	      $('body').trigger("costco.item.qty.updated", [products]);
	      if (hasValidShipmodeId && COSTCO.OrderItems.validateScheduledDeliveryDate() && COSTCO.OrderItems.validateScheduledDeliveryDateEmpty() && $('#hasPickUpError').val() != 'true') {
	        document.ShopCartForm.submit();
	        if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true') {
	          if (typeof adobeProductData != 'undefined' && typeof adobeAnalyticsCommonData != 'undefined' && typeof contextVariables != 'undefined') {
	            COSTCO.AdobeEvents.initEventIfLoggedIn('commerce.productListViews', adobeProductData, adobeAnalyticsCommonData, contextVariables);
	          }
	        }
	      } else if (!hasValidShipmodeId) {
	        //Check if the ship mode id is false
	        //Show the error message at the page level, stating there is an invalid shippment assigned to a product.
	        var errLoc = "#errquantity_";
	        $(errLoc).addClass('critical-notification');
	        $(errLoc).html('<p class="sr-only">' + messages.ERROR + '</p>').show();
	        $(errLoc).html('<p>' + messages.ERR_INVALID_SHIPPING_METHOD_CART + '</p>').show();
	      }
	      //STRY0182081 changes ends
	    },
	
	    /**
	     * This function will validate whether all the order items have valid shipping method associated to it or not.
	     * Created for : STRY0182081
	     */
	    validateShipMode: function validateShipMode(showItemErrMsg) {
	      //Fetch the no of items in the cart.
	      var noOfItems = $('#order-items').find('.order-item').length;
	      //Iterate through each item and check for the ship mode id is present or not.
	      for (var i = 1; i <= noOfItems; i++) {
	        var orderItemId = $('#orderItem_' + i).val();
	        var shipmodeId = $('#orderitem_shipmodedetails_' + orderItemId) != null ? $('#orderitem_shipmodedetails_' + orderItemId).val() : null;
	        var isOrderItemShipModeListEmpty = $('#isOrderItemShipModeListEmpty_' + orderItemId) != null ? $('#isOrderItemShipModeListEmpty_' + orderItemId).val() : null;
	
	        //Check if the shipmodeId is undefined or shipmodeList is empty, then set to false and show the error message.
	        if ((shipmodeId == null || typeof shipmodeId === 'undefined' || shipmodeId == "" || isOrderItemShipModeListEmpty) && $('#isBDAppVar').val() == 'BC') {
	          if (typeof showItemErrMsg != 'undefined' && showItemErrMsg) {
	            //Show the error message for each item which has invalid shipping method.
	            //Populate the shipMode_cart_error_{orderItemId} section in the cart page with the content from shipMode_error_section_${orderItemId}
	            var shipModeErrSec = $('#shipMode_error_section_' + orderItemId).html();
	            $('#shipMode_cart_error_' + orderItemId).html(shipModeErrSec);
	          } else {
	            //Skip the check for the rest of the items and return the flag status.
	            return false;
	          }
	        }
	      }
	      return true;
	    },
	    /**
	     * Method to check if the Calendar date is a valid one
	     */
	    validateScheduledDeliveryDate: function validateScheduledDeliveryDate() {
	      var valid = true;
	      var isInValidDeliveryCalendar = $('#scheduledDeliveryDateInvalid').val();
	      if (isInValidDeliveryCalendar === 'undefined') {
	        valid = true;
	      } else if (isInValidDeliveryCalendar == "true") {
	        $(".date-input-field.error").focus();
	        valid = false;
	      }
	      return valid;
	    },
	    /**
	     * Method to check if the Calendar field has a value
	     */
	    validateScheduledDeliveryDateEmpty: function validateScheduledDeliveryDateEmpty() {
	      var valid = true;
	      var isDateEmpty = $('#noDeliveryDate').val();
	      if (isDateEmpty === 'undefined') {
	        valid = true;
	      } else if (isDateEmpty == "true") {
	        $('.date-input-field').addClass("error");
	        $('.select-delivery-date').removeClass("hidden");
	        $(".date-input-field.error").focus();
	        valid = false;
	      }
	      return valid;
	    },
	    /**
	     * Method to check if the Calendar field has a value
	     */
	    validateAddressAvailable: function validateAddressAvailable() {
	      var valid = true;
	      var isAddressEmpty = $('#noValidAddress').val();
	      if (isAddressEmpty === 'undefined') {
	        valid = true;
	      } else if (isAddressEmpty == "true") {
	        $('.edd-address-error-text').removeClass('hidden');
	        $('.edd-address-button').addClass('edd-global-zip-error');
	        $(".edd-address-button")[0].scrollIntoView();
	        valid = false;
	      }
	      return valid;
	    },
	
	    /**
	     * check_quantity: client side check for cart quantities. function: test if
	     * all the quantity field in shopping cart is correct, else stop form
	     * submission.
	     * @param {function} ajax_callback An optional callback function that tells
	     *                                 check_quantity to use this instead of
	     *                                 using a form submit after it validates.
	     */
	    check_quantity: function check_quantity(ajax_callback) {
	      var noOfItems = $('.order-item').length;
	      var flag = false;
	      var check = {};
	      for (var i = 1; i <= noOfItems; i++) {
	        if ($("#quantity_" + i).length != 0) {
	          check = jQuery.trim($("#quantity_" + i).val());
	        }
	        if (check.length != 0 && !/^[0-9]+(\.[0]{1,2})?$/.test(check)) {
	          flag = true;
	          $("span.server-error").hide();
	          $("div.check").hide();
	          var errLoc = "#errquantity_";
	          $(errLoc).html('<p class="sr-only">' + messages.ERROR + '</p>').show();
	          $(errLoc).html('<p>' + messages.ERR_ADD_TO_CART_INVALID_QTY + '</p>').show();
	          $('html, body').animate({
	            scrollTop: $(errLoc).offset().top
	          }, 'fast');
	          break;
	        }
	      }
	      if (!flag && !ajax_callback) {
	        $(errLoc).html("").hide();
	        document.ShopCartForm.submit();
	      } else if (!flag && typeof ajax_callback == "function") {
	        ajax_callback();
	      }
	    },
	    /**
	     * The inline event handler for the edit links associated with
	     * the quantities of each order item in the order items table.
	     * @param  {object} event The type of event mapped to the inline event handler
	     * @return {void}
	     */
	    edit_quantity: function edit_quantity(event) {
	      var id = $(this).data('id');
	      $(this).addClass('hide');
	      $('span[data-id=' + id + ']').addClass('hide');
	      $('input[id =' + id + ']').removeClass('hide');
	      $('input[id =' + id + ']').focus();
	      $('.update[data-id=' + id + ']').removeClass('hide');
	    },
	    reset_delivery_options: function reset_delivery_options() {
	
	      COSTCO.OrderItems.validate.call();
	
	      $('.delivery-options.grey-box').not('.exclude').addClass('hide');
	      $('.delivery-options-selected.grey-box').not('.exclude').removeClass('hide');
	
	      if ($('label.error').not(':empty').length > 0 && $('[name=' + $('label.error').not(':empty').attr('for') + ']').length > 0) {
	        alert();
	        var lineItem = $("label.error");
	        for (m = 0; m < lineItem.length; m++) {
	          var itemId = lineItem[m].htmlFor.includes('date_') ? lineItem[m].htmlFor.replace('date_', '') : "";
	          $('.delivery-options-selected[data-orderitem=' + itemId + ']').addClass('hide');
	          $('.delivery-options[data-orderitem=' + itemId + ']').removeClass('hide');
	        }
	      }
	    },
	    /**
	     * Inline event handler for the deliver options edit link. Hides the
	     * "Selected" block and shows radio options available for selection.
	     * @return {void}
	     */
	    edit_delivery_options: function edit_delivery_options() {
	      if ($(this).hasClass('edit')) {
	        // Hide the "selected" block and show the list of radio options
	
	        COSTCO.OrderItems.reset_delivery_options();
	
	        var selected = $(this).parents('.delivery-options-selected'),
	            orderitem_id = selected.data('orderitem');
	        selected.addClass('hide');
	        $('.delivery-options[data-orderitem=' + orderitem_id + ']').removeClass('hide');
	        $('.delivery-options[data-orderitem=' + orderitem_id + ']').find(':checked').focus();
	      }
	    },
	
	    /**
	     * Pops a modal for the delivery option details
	     * @param  {string} title_id   ID of the title of the product to be used
	     *                             as the title of the modal.
	     * @param  {string} clauses_id ID of the list of clauses to display in the
	     *                             body of the modal
	     * @return {void}
	     */
	    delivery_details: function delivery_details(title_id, clauses_id) {
	
	      var callerElement = event.target;
	
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.DELIVERY_DETAILS,
	        body: $('#' + clauses_id).html(),
	        primary: messages.JS_DIALOG_OK
	      });
	      COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	    },
	    /**
	     * Pops a modal for the pickup option details
	     * @param  {string} title_id   ID of the title of the product to be used
	     *                             as the title of the modal.
	     * @param  {string} clauses_id ID of the list of clauses to display in the
	     *                             body of the modal
	     * 
	     * @param  {string} pick_clauses_id ID of the list of clauses to display in the
	     *                             body of the modal
	     * @return {void}
	     */
	    pickup_and_delivery_details: function pickup_and_delivery_details(title_id, clauses_id, pick_clauses_id) {
	      var callerElement = event.target;
	      var addHeading = messages.DELIVERY_DETAILS_HEADING + $('#' + clauses_id).html();
	      var concatenateText = addHeading + $('#' + pick_clauses_id).html();
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.DELIVERY_PICKUP_DETAILS,
	        body: concatenateText,
	        primary: messages.JS_DIALOG_OK
	      });
	      COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	    },
	    /**
	     * This function checks if the item to be removed is a membership card and
	     * if a user does not have a memebrship already and then
	     * it calls COSTCO.Checkout.openRemoveWarningModal if both conditions are true
	     */
	    delegate_remove_action: function delegate_remove_action(isMembershipItem, isRenew, orderItemId, countMembershipItemInCart) {
	      var isMember = COSTCO.util.getMemberCookie()['costcoMember'] != 'undefined' && COSTCO.util.getMemberCookie()['costcoMember'] != null ? COSTCO.util.getMemberCookie()['costcoMember'] : false;
	
	      if (isMembershipItem && countMembershipItemInCart === 1 && (isRenew || !isMember)) {
	        COSTCO.Checkout.openRemoveWarningModal(isRenew, orderItemId);
	      } else {
	        COSTCO.OrderItems.remove_item(orderItemId);
	      }
	    },
	
	    delegate_remove_action_v2: function delegate_remove_action_v2(isMembershipItem, isRenew, orderItemId, orderId, catEntryId, countMembershipItemInCart, isPharmacy, prescriptionId, lastItemInCart) {
	
	      var itemwithSameBundleId = [];
	      var notSoldeItem = [];
	      var removeOrderitemsId = [];
	      var delegateRemoveItemsParam = {};
	      COSTCO.OrderItems.notSoldUrl = "";
	      var isNotSoldItem = $("#notSoldSeperatelyItem_" + orderItemId).val() == "true" ? true : false;
	      if (undefined != $("#notSoldSeperatelyBundleId_" + orderItemId).val() && !isNotSoldItem) {
	        var bundleId = $("#notSoldSeperatelyBundleId_" + orderItemId).val();
	        $('.notSoldBundil').each(function () {
	          var test = this;
	          if (bundleId == $(this).val()) {
	            var OtherbundleitemIdArray = $(this).attr('id').split("_");
	            if (undefined != OtherbundleitemIdArray[1] && null != OtherbundleitemIdArray[1]) {
	              itemwithSameBundleId.push(OtherbundleitemIdArray[1]);
	              var isNotSoledSeperatlyItem = $("#notSoldSeperatelyItem_" + OtherbundleitemIdArray[1]).val() == "true" ? true : false;
	              if (isNotSoledSeperatlyItem) {
	                notSoldeItem.push(OtherbundleitemIdArray[1]);
	              }
	            }
	          }
	        });
	        if (itemwithSameBundleId.length != 0 && notSoldeItem.length != 0) {
	          var normalItemLength = itemwithSameBundleId.length - notSoldeItem.length;
	          if (normalItemLength == 1) {
	            for (var i = 0; i < notSoldeItem.length; i++) {
	              removeOrderitemsId.push(notSoldeItem[i]);
	              var count = i + 2;
	              var delegateRemoveitem = 'orderItem_' + count;
	              delegateRemoveItemsParam[delegateRemoveitem] = notSoldeItem[i];
	              var catentryId = $("#notSoldSeperateCatenId_" + notSoldeItem[i]).val();
	              var catentry = 'catalogEntryId_' + count;
	              delegateRemoveItemsParam[catentry] = catentryId;
	              var qty = 'quantity_' + count;
	              delegateRemoveItemsParam[qty] = 0;
	              COSTCO.OrderItems.notSoldUrl = COSTCO.OrderItems.notSoldUrl + "&orderItem_" + count + "=" + notSoldeItem[i] + "&quantity_" + count + "=0&catalogEntryId_" + count + "=" + catentryId;
	            }
	          }
	        }
	      }
	
	      var isMember = COSTCO.util.getMemberCookie()['costcoMember'] != 'undefined' && COSTCO.util.getMemberCookie()['costcoMember'] != null ? COSTCO.util.getMemberCookie()['costcoMember'] : false;
	      //Invalidating prestored EDD response for OrderItemID
	      var calendarResponse = $('#calendarServiceResponse').val();
	      if (calendarResponse != undefined) {
	        document.getElementById("calendarServiceResponse").value = "";
	        apiAlreadyCalled = undefined;
	      }
	      if (isMembershipItem && countMembershipItemInCart === 1 && (isRenew || !isMember)) {
	        COSTCO.Checkout.openRemoveWarningModal_v2(isRenew, orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
	      } else {
	        if (undefined != COSTCO.OrderItems.notSoldUrl && COSTCO.OrderItems.notSoldUrl != "") {
	          COSTCO.OrderItems.cartKitsBundleDelegateRemove(delegateRemoveItemsParam, removeOrderitemsId, orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
	        }
	        if (undefined == COSTCO.OrderItems.notSoldUrl || COSTCO.OrderItems.notSoldUrl == "") {
	          COSTCO.OrderItems.remove_item_v2(orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
	        }
	      }
	    },
	    /**
	     * 
	     */
	
	    cartKitsBundleDelegateRemove: function cartKitsBundleDelegateRemove(delegateRemoveItemsParam, removeOrderitemsId, orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart) {
	      var remove_html = '';
	      var item_names = [];
	      var callerElement = event.target;
	      removeOrderitemsId.forEach(function (removeOrderitemsId) {
	        var item_name = $('#product-name_' + removeOrderitemsId).text();
	        item_names.push(item_name);
	      });
	      var item_name_kits = "";
	      for (var i = 0; i < item_names.length; i++) {
	        item_name_kits += "<li>" + item_names[i] + "</li><br>";
	      }
	      remove_html += COSTCO.util.tmpl('tmpl_cart_remove_all_associated_items_popup', { item_name_kits: item_name_kits });
	      COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	      var modalSettings = {
	        modalLabel: messages.REMOVE_ITEM_MODAL_ALERT,
	        title: messages.REMOVE_ITEM_POPUP,
	        body: remove_html,
	        primary: messages.CART_POPUP_REMOVE_ITEMS,
	        secondary: messages.CART_POPUP_CANCEL,
	        primary_event: function primary_event() {
	          COSTCO.OrderItems.remove_delegate_item_v2(delegateRemoveItemsParam, orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
	        }, onshown: function onshown() {
	          $('button[automation-id=closeModalButton]').focus();
	        }, secondary_event: function secondary_event() {
	          COSTCO.dialog.close();
	          COSTCO.OrderItems.notSoldUrl = "";
	        }, onclose: function onclose(e) {
	          COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	          COSTCO.OrderItems.notSoldUrl = "";
	        }
	      };
	      COSTCO.dialog.showModal(modalSettings);
	    },
	    remove_item: function remove_item(orderItemId) {
	      COSTCO.OrderItems.setCookie("cartTotalCookie", "0.00");
	      var removeURL = $('input[name=removeURL_' + orderItemId + ']').val();
	      $form = $('<form></form>');
	      $form.append("<input type='hidden' name='authToken' value='" + COSTCO.Checkout.getAuthToken() + "' />");
	      $form.attr('action', removeURL);
	      $form.attr('method', 'post');
	      $form.appendTo('body').submit();
	    },
	
	    remove_item_v2: function remove_item_v2(orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart) {
	      COSTCO.OrderItems.setCookie("cartTotalCookie", "0.00");
	      var calledEDDAfterRemoval = false;
	      var params = {
	        ajaxFlag: true,
	        isRestrictedPostalCode: false,
	        actionType: 'delete',
	        orderId: orderId,
	        orderItemId: orderItemId,
	        catEntryId: catEntryId,
	        isPharmacy: isPharmacy,
	        prescriptionId: prescriptionId,
	        lastItemInCart: lastItemInCart
	
	      };
	      COSTCO.AjaxModular.ajax_update_state({
	        method: 'POST',
	        url: '/AjaxModularManageShoppingCartCmd',
	        data: params,
	        dataType: 'json',
	        done: function done(data, textStatus, jqXHR, options) {
	          COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
	          if (data.error !== undefined && (data.error.application.length > 0 || data.error.exception.length > 0)) {
	            OrderItems.displayOrderErrors(data);
	          } else {
	            COSTCO.Header.miniShopCartRefresh();
	            COSTCO.OrderItems.addQuantityEventHandlers();
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	              COSTCO.Global.datePickerEventHanler();
	            }
	          }
	          if (data.payload.data.successMessage !== undefined) {
	            // announce success message to screen reader
	            checkout_helper.addScreenReaderAnnouncement(data.payload.data.successMessage);
	          }
	          if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true' && checkoutPage == 'cart') {
	            if (typeof contextVariables != 'undefined') {
	              $('body').find('script[id="' + $('[data-orderitemid="' + orderItemId + '"]').first().attr('data-orderitemnumber') + '"]').remove();
	            }
	          }
	          //this payload will come from checkout page on removing last item
	          //on shipping options
	          if (data.payload.data.viewTaskName === 'AjaxModularDefaultView') {
	            window.location.href = '/CheckoutCartView';
	          }
	          COSTCO.OrderItems.init();
	          //EDD service is called on init
	          calledEDDAfterRemoval = true;
	        },
	        always: function always() {
	          if ($('#deldatepicker').length > 0) {
	            COSTCO.OrderItems.delDatePicker();
	            COSTCO.OrderItems.updateShipmodeDetails();
	          }
	          $('.co-help').popover();
	          if (!calledEDDAfterRemoval) {
	            COSTCO.EDDService.callEddService();
	          }
	        }
	      });
	    },
	
	    remove_delegate_item_v2: function remove_delegate_item_v2(delegateRemoveItemsParam, orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart) {
	      COSTCO.OrderItems.setCookie("cartTotalCookie", "0.00");
	
	      var params = {
	        ajaxFlag: true,
	        isRestrictedPostalCode: false,
	        actionType: 'delete',
	        orderId: orderId,
	        orderItemId: orderItemId,
	        orderItem_1: orderItemId,
	        catEntryId: catEntryId,
	        catalogEntryId_1: catEntryId,
	        quantity_1: 0,
	        isPharmacy: isPharmacy,
	        prescriptionId: prescriptionId,
	        lastItemInCart: lastItemInCart
	
	      };
	
	      var delegateRemoveCombinedParams = Object.assign(params, delegateRemoveItemsParam);
	
	      COSTCO.AjaxModular.ajax_update_state({
	        method: 'POST',
	        url: '/AjaxModularManageShoppingCartCmd',
	        data: delegateRemoveCombinedParams,
	        dataType: 'json',
	        done: function done(data, textStatus, jqXHR, options) {
	          COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
	          if (data.error !== undefined && (data.error.application.length > 0 || data.error.exception.length > 0)) {
	            OrderItems.displayOrderErrors(data);
	          } else {
	            COSTCO.Header.miniShopCartRefresh();
	            COSTCO.OrderItems.addQuantityEventHandlers();
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	              COSTCO.Global.datePickerEventHanler();
	            }
	          }
	          if (data.payload.data.successMessage !== undefined) {
	            // announce success message to screen reader
	            checkout_helper.addScreenReaderAnnouncement(data.payload.data.successMessage);
	          }
	          //this payload will come from checkout page on removing last item
	          //on shipping options
	          if (data.payload.data.viewTaskName === 'AjaxModularDefaultView') {
	            window.location.href = '/CheckoutCartView';
	          }
	          COSTCO.OrderItems.init();
	        },
	        always: function always() {
	          if ($('#deldatepicker').length > 0) {
	            COSTCO.OrderItems.delDatePicker();
	            COSTCO.OrderItems.updateShipmodeDetails();
	          }
	          $('.co-help').popover();
	          COSTCO.EDDService.callEddService();
	        }
	      });
	      COSTCO.dialog.close();
	      COSTCO.OrderItems.notSoldUrl = "";
	    },
	    /**
	     * Adds the protection plan to the current order
	     * @param  {int} catEntryId   		catEntryId of the item to add to cart
	     * @param  {int} parentOrderItemId	orderItemId of the parent item
	     * @return {void}
	     */
	    addProtectionPlan: function addProtectionPlan(element, catEntryId, parentOrderItemId, orderId, addressId) {
	      // After the AJAX update, focus is returned to this element
	      var focusId = element && element.id;
	
	      var params = {
	        ajaxFlag: true,
	        isRestrictedPostalCode: false,
	        actionType: 'add',
	        catEntryId: catEntryId,
	        quantity: $('[name=protectionPlanQuantity_' + catEntryId + '_' + parentOrderItemId + ']').val(),
	        catalogEntryId_1: catEntryId,
	        quantity_1: $('[name=protectionPlanQuantity_' + catEntryId + '_' + parentOrderItemId + ']').val(),
	        parentOrderItemId: parentOrderItemId,
	        orderId: orderId,
	        isProtectionPlan: true,
	        addressId: addressId
	      };
	
	      COSTCO.AjaxModular.ajax_update_state({
	        method: 'POST',
	        url: '/AjaxModularManageShoppingCartCmd',
	        data: params,
	        dataType: 'json',
	        done: function done(data, textStatus, jqXHR, options) {
	          COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
	          if (data.error !== undefined && (data.error.application.length > 0 || data.error.exception.length > 0)) {
	            var _parentOrderItemId = data.payload.data.parentOrderItemId;
	            var itemErrorContainer = $('div[data-parentorderitemid=' + _parentOrderItemId + ']');
	            OrderItems.displayOrderErrors(data, itemErrorContainer);
	          } else {
	            COSTCO.Header.miniShopCartRefresh();
	            $(element).prop('checked', true);
	          }
	          COSTCO.OrderItems.updateShipModeToPickUp(false);
	          COSTCO.EDDService.callEddService();
	        },
	        complete: function complete() {
	          if (focusId) {
	            setTimeout(function () {
	              var $el = $('#' + focusId);
	              if ($el.length) {
	                $el.focus();
	              }
	            }, 0);
	          }
	        }
	      });
	    },
	    /**
	     * Removes the protection plan from the current order
	     * @param  {int} orderId   			orderId of the order to remove the protection plan from
	     * @param  {int} orderItemId   		orderItemId of the protection plan to remove
	     * @param  {int} parentOrderItemId	orderItemId of the parent item
	     * @return {void}
	     */
	    removeProtectionPlan: function removeProtectionPlan(element, orderId, orderItemId, parentOrderItemId) {
	      // After the AJAX update, focus is returned to this element
	      var focusId = element && element.id;
	      var params = {
	        ajaxFlag: true,
	        isRestrictedPostalCode: false,
	        actionType: 'delete',
	        orderId: orderId,
	        orderItemId: orderItemId
	
	      };
	      COSTCO.AjaxModular.ajax_update_state({
	        method: 'POST',
	        url: '/AjaxModularManageShoppingCartCmd',
	        data: params,
	        dataType: 'json',
	        done: function done(data, textStatus, jqXHR, options) {
	          COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
	          if (data.error !== undefined && (data.error.application.length > 0 || data.error.exception.length > 0)) {
	            var _parentOrderItemId2 = data.payload.data.parentOrderItemId;
	            var itemErrorContainer = $('div[data-parentorderitemid=' + _parentOrderItemId2 + ']');
	            OrderItems.displayOrderErrors(data, itemErrorContainer);
	          } else {
	            COSTCO.Header.miniShopCartRefresh();
	            $(element).prop('checked', false);
	          }
	        },
	        complete: function complete() {
	          if (focusId) {
	            setTimeout(function () {
	              var $el = $('#' + focusId);
	              if ($el.length) {
	                $el.focus();
	              }
	            }, 0);
	          }
	        }
	      });
	    },
	    /**
	     * Replaces an existing protection plan in the current order.
	     * The function performs a two-step operation:
	     * 1) Removes the currently selected protection plan via AJAX.
	     * 2) On successful removal, adds the new protection plan using COSTCO.OrderItems.addProtectionPlan.
	     * @param {HTMLElement} element
	     * @param {string} orderId
	     * @param {string} orderItemId
	     * @param {string} catEntryId
	     * @param {string} parentOrderItemId
	     * @param {string} addressId
	     */
	    replaceProtectionPlan: function replaceProtectionPlan(element, orderId, orderItemId, catEntryId, parentOrderItemId, addressId) {
	      // Remove existing protection plan
	      COSTCO.AjaxModular.ajax_update_state({
	        method: 'POST',
	        url: '/AjaxModularManageShoppingCartCmd',
	        data: {
	          ajaxFlag: true,
	          isRestrictedPostalCode: false,
	          actionType: 'delete',
	          orderId: orderId,
	          orderItemId: orderItemId
	        },
	        dataType: 'json',
	        done: function done(data, textStatus, jqXHR, options) {
	          if (data.error !== undefined && (data.error.application.length > 0 || data.error.exception.length > 0)) {
	            COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
	            var _parentOrderItemId3 = data.payload.data.parentOrderItemId;
	            var itemErrorContainer = $('div[data-parentorderitemid=' + _parentOrderItemId3 + ']');
	            OrderItems.displayOrderErrors(data, itemErrorContainer);
	          } else {
	            // Add new protection plan and keep the page busy
	            options.keepBusy = true;
	            COSTCO.OrderItems.addProtectionPlan(element, catEntryId, parentOrderItemId, orderId, addressId);
	          }
	        }
	      });
	    },
	    displayOrderErrors: function displayOrderErrors(data, itemErrorContainer) {
	
	      if (typeof itemErrorContainer !== "undefined" && itemErrorContainer.length > 0) {
	
	        itemErrorContainer.empty();
	
	        if (data.error.application !== undefined) {
	          $.each(data.error.application, function (index, errorMessage) {
	            itemErrorContainer.append(errorMessage);
	          });
	        }
	        if (data.error.exception !== undefined) {
	          $.each(data.error.exception, function (index, errorMessage) {
	            itemErrorContainer.append(errorMessage);
	          });
	        }
	        itemErrorContainer.removeClass('hide');
	      }
	
	      COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application], true, '#notification-message');
	    },
	    setCookie: function setCookie(cookieName, cvalue) {
	      console.log("COOKIE REMOVED");
	      document.cookie = cookieName + "=" + cvalue + ";";
	    },
	    order_prepare: function order_prepare() {
	      var error_container = $('.error.check').length > 0 ? '.error.check' : '.order-error';
	      console.log("Invoke Order Prepare");
	      checkout_helper.ajax_update_state({
	        url: '/order-prepare',
	        method: "POST",
	        data: $('#ShopCartForm').serialize(),
	        error_container: error_container,
	        ajax_replace_content: function ajax_replace_content(response_obj, mergedOptions, defaultOptions) {
	          defaultOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
	        },
	        ajax_update_post_done: function ajax_update_post_done(response_obj, mergedOptions, defaultOptions) {
	          // Refresh the cart icon's number to reflect the adjusted quantity.
	          COSTCO.Header.miniShopCartRefresh();
	          COSTCO.OrderItems.init();
	          COSTCO.dialog.close();
	        }
	      });
	    },
	    /**
	     * Makes a request to /order-quantity-update which wraps
	     * ManageShoppingCartCmdImpl. This will update the quantity of the items
	     * requested and then return a json response with html to inject
	     * representing the new order items and order total.
	     * @return {void}
	     */
	    quantity_update: function quantity_update(input, isPharmacy, prescriptionId) {
	      var error_container = $('.error.check').length > 0 ? '.error.check' : '#errquantity_';
	      var orderItemIndex = 0;
	      if (Array.isArray(input)) {
	        orderItemIndex = input[0].replace("quantity", "");
	      } else {
	        orderItemIndex = input.replace("quantity", "");
	      }
	      var orderItemIndexRegExp = new RegExp(orderItemIndex, 'g');
	      var activeElement = document.activeElement.getAttribute("id");
	      var inputContainer = undefined;
	      if (checkoutPage == 'cart' || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
	        inputContainer = input;
	      } else {
	        var inputId = input.id;
	        var inputContainerArr = $('.edit').filter('[data-id=' + inputId + ']');
	        for (i = 0; i < inputContainerArr.length; i++) {
	          if ($(inputContainerArr[i]).attr('data-max-screen') && COSTCO.util.isMaxScreen($(inputContainerArr[i]).data('max-screen'))) {
	            inputContainer = inputContainerArr[i];
	            break;
	          } else if ($(inputContainerArr[i]).attr('data-min-screen') && COSTCO.util.isMinimumScreen($(inputContainerArr[i]).data('min-screen'))) {
	            inputContainer = inputContainerArr[i];
	            break;
	          }
	        }
	      }
	
	      //On review page, since there are two quantity inputs for each item (desktop and mobile/tablet),
	      //we need to disable the input not being used so it won't be included in formdata
	
	      if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
	        if (checkoutPage == 'review') {
	          if (COSTCO.util.getScreenType() == 'DESKTOP' || COSTCO.util.getScreenType() == 'TABLET-LANDSCAPE') {
	            $('input[id^=quantity_]').not('[id$=DESKTOP]').attr('disabled', 'disabled');
	          } else {
	            $('input[id^=quantity_][id$=DESKTOP]').attr('disabled', 'disabled');
	          }
	        }
	      }
	
	      COSTCO.util.input_injector('#ShopCartForm', {
	        actionType: 'update',
	        ajaxFlag: 'true',
	        requesttype: 'ajax',
	        isPharmacy: typeof isPharmacy === "undefined" ? false : isPharmacy,
	        prescriptionId: typeof prescriptionId === "undefined" ? "" : prescriptionId
	      });
	      // Input injector intially sets ajaxFlag to true in the ShopCartForm,
	      // but subsequent calls to quantity_update need to ensure it is set
	      // true because ajax_update_post_done sets it false.
	      $('#ShopCartForm input[name=ajaxFlag]').val(true);
	      var reqData = $('#ShopCartForm [name]').not("#order-items :input").serialize() + '&' + $("#order-item" + orderItemIndex + " :input").serialize();
	      reqData = reqData.replaceAll(orderItemIndex, "_1");
	      if (undefined != COSTCO.OrderItems.notSoldUrl && COSTCO.OrderItems.notSoldUrl != "") {
	        reqData = reqData + "" + COSTCO.OrderItems.notSoldUrl;
	      }
	      checkout_helper.ajax_update_state({
	        url: '/order-quantity-update',
	        method: "POST",
	        //data: $('#ShopCartForm').serialize(),
	        data: reqData,
	        page: typeof checkoutPage === "undefined" ? "" : checkoutPage,
	        error_container: error_container,
	        done: function done(data, textStatus, jqXHR, options) {
	          try {
	            var response_obj = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : JSON.parse(data);
	
	            if (response_obj.error && response_obj.error.application.indexOf(messages.EMPTY_CART) == 0) {
	              document.location.href = "/CheckoutCartView";
	            } else {
	              COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	            }
	          } catch (e) {
	            console.error(e);
	          }
	        },
	        ajax_replace_content: function ajax_replace_content(response_obj, mergedOptions, defaultOptions) {
	          if (response_obj.metadata && response_obj.metadata.quantityUpdatedForCashCardPaymentErr) {
	            response_obj.error.application.push(response_obj.metadata.quantityUpdatedForCashCardPaymentErr);
	          }
	          defaultOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
	        },
	        ajax_update_post_done: function ajax_update_post_done(response_obj, mergedOptions, defaultOptions) {
	          // Refresh the cart icon's number to reflect the adjusted quantity.
	          COSTCO.Header.miniShopCartRefresh();
	          $('#ShopCartForm input[name=ajaxFlag]').val(false);
	          COSTCO.OrderItems.init();
	          if (typeof COSTCO.CreditCard !== 'undefined') {
	            COSTCO.CreditCard.initComplete = false;
	            COSTCO.CreditCard.init();
	          }
	
	          // add ada message, after the quantity is updated
	          var estimatedTotalLabel = void 0;
	
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	            estimatedTotalLabel = $('.estimated-total-label');
	            if (!COSTCO.util.isBusinessDelivery()) {
	              COSTCO.OrderItems.setDeliveryDateView();
	            }
	          } else {
	            estimatedTotalLabel = $('#estimated-total-label');
	          }
	
	          var estimatedTotalValue = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && checkoutPage === 'review' ? $('.surchargeOrderTotal') : $('#order-estimated-total');
	          if (estimatedTotalLabel.length > 0 && estimatedTotalValue.length > 0) {
	            checkout_helper.addScreenReaderAnnouncement(estimatedTotalLabel.html() + ' ' + estimatedTotalValue.html());
	          }
	        },
	        always: function always() {
	          COSTCO.Checkout.ajax_update_default_always(inputContainer);
	          //remove disabled attr on any hidden inputs that got disabled
	          $('input[id^=quantity_]').removeAttr('disabled');
	          if (typeof TokenGateway != 'undefined') {
	            TokenGateway.refreshGateway();
	          }
	          COSTCO.OrderItems.popovers();
	          COSTCO.preauthchargesmodal.init();
	          COSTCO.OrderSummaryCart.measurementGuideCheckboxesOnOff();
	
	          // Sync attr 'value' and field value in quantities on Cart page, in case of back-end rejection of change
	          if (checkoutPage == 'cart' || checkoutPage == 'review') {
	            $('[id^=quantity_]').each(function (index, element) {
	              if ($(element).val() != $(element).attr('value')) {
	                $(element).val($(element).attr('value'));
	              }
	            });
	            $('#' + activeElement).focus();
	          }
	
	          if (checkoutPage == 'review') {
	            if (inputContainer[0] != undefined && inputContainer.value != 0) {
	              $('#' + activeElement).focus();
	            }
	          }
	          COSTCO.OrderItems.displayGlobalPickUpAlerts(false, true);
	        },
	        complete: function complete() {
	          // Set focus to COSTCO.AjaxModular.pendingFocusId element, if it is set
	          var focusId = COSTCO.AjaxModular.pendingFocusId;
	          COSTCO.AjaxModular.pendingFocusId = null;
	          if (focusId) {
	            setTimeout(function () {
	              var $el = $('#' + focusId);
	              if ($el.length) {
	                $el.focus();
	              }
	            }, 0);
	          }
	        },
	        inputContainer: inputContainer
	      });
	      COSTCO.dialog.close();
	      COSTCO.OrderItems.notSoldUrl = "";
	    },
	    //Method to update all the quntity fields on update of one quantity
	    onchange_update: function onchange_update(obj, qtyup, quant) {
	      var qty = obj.value;
	      $('input[id=' + obj.id + ']').val(qty);
	      COSTCO.OrderItems.validate.call(obj, qtyup, quant);
	    },
	    /**
	     * Take global errors and place them in-line
	     * @return {void}
	     */
	    placeGlobalCartErrorsInLine: function placeGlobalCartErrorsInLine(response_obj) {
	
	      //function will place error message in-line and deal with CSS
	      function placeErrorInLine(itemNumber, errorMsg) {
	        var lineItem = $("div[data-orderitemnumber]");
	        //For each order item number
	        for (c = 0; c < lineItem.length; c++) {
	          var itemNumberTmp = $(lineItem[c]).data("orderitemnumber");
	          //Order item container
	          if (itemNumberTmp == itemNumber) {
	            //Place error message in all containers
	            //$(lineItem[c]).find('.critical-notification').html(errorMsg.replace(/''/g, '\'') )
	            $(lineItem[c]).find('.critical-notification').each(function (index, element) {
	              if (undefined !== element.id && element.id.indexOf('notSoldSepLineItemError') != -1) {
	                $(element).addClass("hide");
	              } else {
	                $(element).html(errorMsg.replace(/''/g, '\''));
	              }
	            });
	            //Deal with containers
	            var errorContainer = $(lineItem[c]).find('.critical-notification');
	            //Do this for Cart View Only
	            if (window.location.href.indexOf('CheckoutCartView') > -1 || window.location.href.indexOf('CheckoutCartDisplayView') > -1 && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	              $(errorContainer[0]).addClass('hidden-xs hidden-sm hidden-md');
	              $(errorContainer[1]).addClass('hidden-lg hidden-xl');
	            }
	            //Do this for Review Page only
	            if (window.location.href.indexOf('CheckoutReviewView') > -1) {
	              $('#errquantity_').removeClass('error');
	              $('#errquantity_').addClass('critical-notification');
	            }
	            //Show time ready!
	            $(lineItem[c]).find('.critical-notification').each(function (index, element) {
	              if (undefined !== element.id && element.id.indexOf('notSoldSepLineItemError') != -1) {
	                $(element).addClass("hide");
	              } else {
	                $(element).removeClass('hide');
	              }
	            });
	            //$(lineItem[c]).find('.critical-notification').removeClass('hide')
	            $('#errquantity_').removeClass('hide');
	          }
	        }
	      }
	
	      //Places errors in-line that show on the page before any ajax call
	      if (typeof response_obj == "undefined") {
	        //get all global error messages
	        var errorTop = $('.errorTop');
	        for (i = 0; i < errorTop.length; i++) {
	          //for each error message parse the partnumber - this is where it gets weird
	          var lineItem = $("div[data-orderitemnumber]");
	          for (m = 0; m < lineItem.length; m++) {
	            var item = $(lineItem[m]).data("orderitemnumber");
	            var errorMessage = $(errorTop[i]).html();
	            item = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE ? " " + item : item;
	            var found = errorMessage.search(item);
	            if (found != -1) {
	              placeErrorInLine(item, errorMessage);
	            }
	          }
	        }
	        $('#errquantity_').hide();
	      } else {
	        //Places errors in-line after ajax call
	        for (i = 0; i < response_obj.error.application.length; i++) {
	          var lineItem = $("div[data-orderitemnumber]");
	          for (m = 0; m < lineItem.length; m++) {
	            var item = $(lineItem[m]).data("orderitemnumber");
	            var errorMessage = response_obj.error.application[i];
	            var found = errorMessage.search(item);
	            if (found != -1) {
	              placeErrorInLine(item, errorMessage);
	            }
	          }
	        }
	        $('#errquantity_').show();
	      }
	    },
	
	    /**
	     * Save for later operations
	     */
	    saveForLater: {
	      save: function save(catentryId, orderItemId) {
	        OrderItems.saveForLater.ajaxCallSFL(catentryId, 'save', orderItemId);
	        OrderItems.saveForLater.announceSrMessageForSflAction(messages.SFL_ITEM_SAVED_FOR_LATER);
	      },
	      remove: function remove(catentryId) {
	        OrderItems.saveForLater.ajaxCallSFL(catentryId, 'remove');
	        OrderItems.saveForLater.announceSrMessageForSflAction(messages.SFL_REMOVED_FROM_THE_CART);
	      },
	      moveToCart: function moveToCart(catentryId) {
	        COSTCO.util.notification.clearNotification('#errquantity_');
	        OrderItems.saveForLater.ajaxCallSFL(catentryId, 'move_to_cart');
	        OrderItems.saveForLater.announceSrMessageForSflAction(messages.SFL_MOVED_TO_THE_CART);
	      },
	      ajaxOpenPage: function ajaxOpenPage(pageNumberToGo) {
	        checkout_helper.ajax_update_state({
	          url: '/AjaxGetSFLItemsCmd',
	          method: "POST",
	          data: {
	            pageNumber: pageNumberToGo
	          },
	          ajax_update_post_done: function ajax_update_post_done(response_obj, mergedOptions, defaultOptions) {
	            $('html, body').scrollToElem($('#order-items-sfl'), 100);
	            OrderItems.tooltips();
	          }
	        });
	      },
	      ajaxCallSFL: function ajaxCallSFL(catentryId, action) {
	        var orderItemId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	        if (typeof $('#calendarServiceResponse').val() !== 'undefined') {
	          document.getElementById("calendarServiceResponse").value = "";
	        }
	        apiAlreadyCalled = undefined;
	        var error_container = '#errquantity_';
	        checkout_helper.ajax_update_state({
	          error_container: error_container,
	          url: '/AjaxSaveForLaterCmd',
	          method: "POST",
	          data: {
	            catentryId: catentryId,
	            action: action,
	            orderItemId: orderItemId
	          },
	          ajax_replace_content: function ajax_replace_content(response_obj, mergedOptions, defaultOptions) {
	            defaultOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
	            COSTCO.Header.miniShopCartRefresh();
	            COSTCO.OrderItems.init();
	          },
	          ajax_update_post_done: function ajax_update_post_done(response_obj, mergedOptions, defaultOptions) {
	            $('.co-help').popover('destroy');
	            COSTCO.OrderItems.tooltips();
	          },
	          ajax_handle_errors: function ajax_handle_errors(response_obj, mergedOptions, defaultOptions) {
	            var exception = response_obj.error.exception || [];
	            var error_html = '';
	            if (exception.length > 0) {
	              error_html += '<p>' + exception[0].errorMessage + '</p>';
	            }
	            var error = $(error_container);
	            if (error_html.trim() != '') {
	              error.append("<p class=\"sr-only\">" + messages.ERROR + "</p>");
	              error.append(error_html);
	              error.addClass('critical-notification');
	              if (mergedOptions.not_critical_notification !== undefined && mergedOptions.not_critical_notification) {
	                error.removeClass('critical-notification');
	              }
	              COSTCO.util.announceSRMessage(messages.ERROR + "&nbsp" + error_html);
	            }
	          }
	        });
	      },
	      /**
	       * Announces to SR user when SFL action happened.
	       * Finds nearest product title and use it as parameter
	       * for announceSRMessage function
	       */
	      announceSrMessageForSflAction: function announceSrMessageForSflAction(srMessage) {
	        var productDescription = $(event.currentTarget).closest('.order-item').find('.sfl-item-desc a').text();
	        if (productDescription) {
	          var srMessageForAnnouncing = srMessage.replace("{0}", productDescription);
	          COSTCO.util.announceSRMessage(srMessageForAnnouncing);
	        }
	      }
	    },
	
	    /**
	     * Plain packaging for items. Save or delete operations. Use with
	     * PlainPackaging.jsp
	     * @return {void}
	     */
	    plain_packaging: function plain_packaging() {
	      var data = $(this).parents('.plain-packaging-data'),
	          op = data.find('input[name=op]');
	      $(this).prop('checked') ? op.val('save') : op.val('delete');
	      $(this).prop('disabled', true); // probably need to disable place order too?
	      COSTCO.util.ajax({
	        url: '/ManagePlainPackaging',
	        method: 'POST',
	        dataType: 'json',
	        input: this,
	        data: data.find('input').serializeArray(),
	        always: function always(data, textStatus, jqXHR, options) {
	          $(options.input).prop('disabled', false);
	        }
	      });
	    },
	    /**
	     * This is THE gift message functionality. It is to be used with
	     * ItemGiftMessage.jsp which includes some necessary inputs (in addition
	     * to the inputs within the modal html) used to POST to /ManageGiftMessage.
	     * @return {void}
	     */
	    gift_message: function gift_message() {
	      var action = $(this).data('action'),
	          title = action == 'edit' ? messages.CHECKOUT_DELIVERY_EditGiftMessage : messages.Shipping_Gift_Message,
	          gift_container = $(this).parents('.gift-message-container'),
	          orderItemId = gift_container.data('orderitem'),
	          address_id = gift_container.data('addressid'),
	          is_self_address = gift_container.data('selfaddress'),
	          recipient_name = action == 'edit' ? gift_container.find('.recipient-name').text() : '',
	          your_name = action == 'edit' ? gift_container.find('.your-name').text() : '',
	          gift_message = action == 'edit' ? gift_container.find('.gift-message').text() : '';
	      var gift_form_title;
	      if ($('input[name="giftMessageCondition_' + orderItemId + '"]').val() == "required_empty") {
	        gift_form_title = messages.RWD_GIFT_MSG_REQUIRED_SUBTITLE;
	      } else {
	        gift_form_title = messages.RWD_GIFT_SUBTITLE;
	      }
	      COSTCO.dialog.createExtDialogBox({
	        title: title,
	        body: COSTCO.util.tmpl('tmpl_gift_form', {
	          orderItemId: orderItemId,
	          gift_form_title: gift_form_title,
	          address: gift_container.find('.address').html(),
	          recipient_name: recipient_name,
	          your_name: your_name,
	          is_self_address: is_self_address,
	          gift_message: gift_message,
	          // Remove link is hidden if we're a new gift message
	          hide: action == 'edit' ? '' : 'hide',
	          // Used to set gift_operation on remove gift message link
	          delete_op_name: '\'delete\'',
	          // Get the order items that share the same address id
	          // to display in the modal.
	          order_items: function () {
	            var html = "";
	            $('.gift-message-container[data-addressid=' + address_id + ']').each(function (i, elem) {
	              var order_item = $(elem).parents('.order-item'),
	                  src = order_item.find('.item-thumbnail img').attr('src'),
	                  title = order_item.find('.product-title a').text();
	              html += COSTCO.util.tmpl('tmpl_gift_order_item', {
	                src: src,
	                title: title
	              });
	            });
	            return html;
	          }()
	        }),
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.PRIMARYMEMBER_MEMBERSHIP__Save_ButtonText,
	        // Save Gift Message
	        primary_event: function () {
	          if ($('#gift-message').valid()) {
	            // If gift message form is valid, perform a save operation
	            COSTCO.OrderItems.gift_operation.call(this, 'save');
	          }
	        }.bind(orderItemId)
	      });
	      // Templating (pre)appends whitespace in the textarea. Lets get rid of it.
	      $('#giftMessage').text($('#giftMessage').text().trim());
	      // Start the interactive character counting for he gift message.
	      checkout_helper.character_count($('#gift-count'), $('#giftMessage'));
	      //Validate the inputs before doing anything
	
	      $('#gift-message').validate({
	        focusInvalid: false,
	        rules: {
	          recipientName: {
	            required: true,
	            alphaNum: true
	          },
	          fromName: {
	            required: true,
	            alphaNum: true
	          },
	          giftMessage: {
	            required: true,
	            alphaNum: true
	          }
	        },
	        messages: {
	          recipientName: {
	            required: messages.CHECKOUT_DELIVERY_RecipientFirstNameRequired,
	            alphaNum: messages.CHECKOUT_DELIVERY_GiftMessageValidation
	          },
	          fromName: {
	            required: messages.CHECKOUT_DELIVERY_YourNameRequired,
	            alphaNum: messages.CHECKOUT_DELIVERY_GiftMessageValidation
	          },
	          giftMessage: {
	            required: messages.CHECKOUT_DELIVERY_GiftMessageRequired,
	            alphaNum: messages.CHECKOUT_DELIVERY_GiftMessageValidation
	          }
	        },
	        invalidHandler: COSTCO.util.invalid_handler
	      });
	    },
	    /**
	     * This is the version 2 of method for handling gift messages
	     * It is responsible for opening gift message modal and presenting
	     * all neccesary information regarding gift message,
	     * for example,
	     * for which item(s) if linked particular gift message,
	     * on which address are those(that) item(s) sent,
	     * etc.
	     * @see #gift_message
	     * @return {void}
	     */
	    gift_message_v2: function gift_message_v2() {
	      var callerElement = event.target;
	      var action = $(this).data('action'),
	          title = action == 'edit' ? messages.CHECKOUT_DELIVERY_EditGiftMessage : messages.Shipping_Gift_Message,
	          gift_container = $(this).parents('.gift-message-container'),
	          orderItemId = gift_container.data('orderitem'),
	          address_id = gift_container.data('addressid'),
	          is_self_address = gift_container.data('selfaddress'),
	          to_recipient = action == 'edit' ? gift_container.find('.to-recipient').text() : '',
	          your_name = action == 'edit' ? gift_container.find('.your-name').text() : '',
	          gift_message = action == 'edit' ? gift_container.find('.gift-message').text() : '';
	      var gift_form_title;
	      if ($('input[name="giftMessageCondition_' + orderItemId + '"]').val() == "required_empty") {
	        gift_form_title = messages.RWD_GIFT_MSG_REQUIRED_SUBTITLE;
	      } else {
	        gift_form_title = messages.RWD_GIFT_ADD_MESSAGE_MODAL_INFO;
	      }
	      COSTCO.dialog.createExtDialogBox({
	        title: title,
	        body: COSTCO.util.tmpl('tmpl_gift_form_v2', {
	          orderItemId: orderItemId,
	          gift_form_title: gift_form_title,
	          recipient_first_title: messages.GFORM_RCP_FIRST_NAME,
	          address: gift_container.find('.address').html(),
	          to_recipient: to_recipient,
	          your_name: your_name,
	          is_self_address: is_self_address,
	          gift_message: gift_message,
	          // Remove link is hidden if we're a new gift message
	          hide: action == 'edit' ? '' : 'hide',
	          // Used to set gift_operation on remove gift message link
	          delete_op_name: '\'delete\'',
	          // Get the order items that share the same address id
	          // to display in the modal.
	          order_items: function () {
	            var html = "";
	            $('.gift-message-container[data-addressid=' + address_id + ']').each(function (i, elem) {
	              var order_item = $(elem).parents('.order-item'),
	                  src = order_item.find('.item-thumbnail img').attr('src'),
	                  title = order_item.find('.product-title a').text();
	              alt = order_item.find('.product-title').text().trim();
	              html += COSTCO.util.tmpl('tmpl_gift_order_item', {
	                src: src,
	                title: title,
	                alt: alt
	              });
	            });
	            return html;
	          }()
	        }),
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.PRIMARYMEMBER_MEMBERSHIP__Save_ButtonText,
	        // Save Gift Message
	        primary_event: function () {
	          if ($('#gift-message').valid()) {
	            // If gift message form is valid, perform a save operation
	            COSTCO.OrderItems.gift_operation.call(this, 'save');
	          }
	        }.bind(orderItemId)
	      });
	      // Templating (pre)appends whitespace in the textarea. Lets get rid of it.
	      $('#giftMessage').text($('#giftMessage').text().trim());
	      // Start the interactive character counting for he gift message.
	      checkout_helper.character_count($('#gift-count-v2'), $('#giftMessage'));
	      // Validate the inputs before doing anything
	      $('#gift-message').validate({
	        focusInvalid: false,
	        rules: {
	          toRecipient: {
	            required: true,
	            alphaNum: true
	          },
	          fromName: {
	            required: true,
	            alphaNum: true
	          },
	          giftMessage: {
	            required: true,
	            alphaNum: true
	          }
	        },
	        messages: {
	          toRecipient: {
	            required: messages.CHECKOUT_DELIVERY_RecipientNameRequired,
	            alphaNum: messages.CHECKOUT_DELIVERY_GiftMessageValidation
	          },
	          fromName: {
	            required: messages.CHECKOUT_DELIVERY_YourNameRequired,
	            alphaNum: messages.CHECKOUT_DELIVERY_GiftMessageValidation
	          },
	          giftMessage: {
	            required: messages.CHECKOUT_DELIVERY_GiftMessageRequired,
	            alphaNum: messages.CHECKOUT_DELIVERY_GiftMessageValidation
	          }
	        },
	        invalidHandler: COSTCO.util.invalid_handler
	      });
	      $('#gift-message').find('.input-outline').each(function () {
	        if ($(this).val().length !== 0) {
	          $('#gift-message').find('label[for=' + $(this).attr('id') + ']').addClass('active');
	        }
	      });
	      $('#costcoModalBtn2').removeClass('btn-primary');
	      $('#costcoModalBtn2').addClass('primary-button-v2');
	      $('.costcoModalBtn1').removeClass('btn-tertiary');
	      $('.costcoModalBtn1').addClass('secondary-button-v2');
	      COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	    },
	    /**
	     * [gift_operation description]
	     * @param  {[type]} operation [description]
	     * @return {[type]}           [description]
	     */
	    gift_operation: function gift_operation(operation, orderItemId) {
	      var orderItemId = typeof orderItemId === 'number' ? orderItemId : this,
	          gift_container = $('.gift-message-container[data-orderitem=' + orderItemId + ']'),
	          error_container = gift_container.find('.error-container');
	      // Close modal
	      $('.costcoModalBtn1').first().click();
	      // Set the operation
	      gift_container.find('input[name=op]').val(operation);
	      // Get the serialized data necessary for the POST
	      var data = gift_container.find('input').add('#gift-message input, #gift-message textarea');
	      // Send it over the wire
	      checkout_helper.ajax_update_state({
	        error_container: error_container,
	        method: 'POST',
	        url: '/ManageGiftMessage',
	        data: data.serializeArray(),
	        dataType: 'json',
	        always: function always() {
	          COSTCO.EDDService.callEddService();
	          if (checkoutPage === 'cart' || checkoutPage === 'review') {
	            var pickUpAPIResp = $('#pickUpAPIResponses').val();
	            if (pickUpAPIResp != undefined && pickUpAPIResp != null && pickUpAPIResp != '') {
	              COSTCO.OrderItems.repaintPickUpMolecule(JSON.parse(pickUpAPIResp), true, true);
	            }
	            COSTCO.OrderItems.displayGlobalPickUpAlerts(false, true);
	          }
	        }
	      });
	    },
	    shippingSelector: '.shipping-cost[data-orderitemid="{0}"][data-shipmodeid="{1}"]',
	    shipMethodSelector: '.individualShipBlock[data-orderitem="{0}"][data-shipmodeid="{1}"]',
	    reset_shipping_cost_display: function reset_shipping_cost_display() {
	      $(".shipping-cost").html("");
	    },
	    display_shipping_cost: function display_shipping_cost(orderItemId, shippingMethod) {
	      var shippingAmount = 0;
	      if (shippingMethod && !shippingMethod.isGroceryItem) {
	        var id = shippingMethod.id;
	        var amount = shippingMethod.amount;
	        var error = shippingMethod.error;
	        var selector = COSTCO.util.messageFormat(COSTCO.OrderItems.shippingSelector, orderItemId, id);
	        var shippingContainerColl = $(selector);
	
	        if (shippingMethod.autoUpgradeShipModeDesc) {
	          var shippingDescContainer = $('#shipMode-desc-' + orderItemId + '-' + shippingMethod.id);
	          if (shippingDescContainer.length) shippingDescContainer.text(shippingMethod.autoUpgradeShipModeDesc);
	        }
	
	        if (shippingContainerColl.length > 0) {
	          if (error != null && error > 0) {
	            COSTCO.OrderItems.display_error(orderItemId, costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE ? shippingMethod.detailedErrorMessage : shippingMethod.errorMessage);
	          } else {
	            var formattedQuery = COSTCO.util.messageFormat(COSTCO.OrderItems.error_query, orderItemId);
	            var elem = void 0;
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	              elem = $(formattedQuery).parents().closest("ul").find(".critical-notification");
	            } else {
	              elem = $(formattedQuery);
	            }
	            var html = elem.html();
	            if (typeof html !== "undefined" && html.trim().length === 0) {
	              elem.addClass('hide');
	            }
	
	            var processedAmount = amount;
	            //For loop needed as warehouse pickup shipping will have the same orderItemId and shipModeId
	            //as the default ship mode [first ship mode]
	            for (x = 0; x < shippingContainerColl.length; x++) {
	              var shippingContainer = $(shippingContainerColl[x]);
	              //If warehouse pickup item shipping charge is waived then override amount to 0
	              if (amount == 0 || shippingContainer.data('warehousepickup') == 1) {
	                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE && shippingContainer.hasClass('calendar-arrival')) {
	                  shippingContainer.html(messages.RWD_INCLUDED);
	                  $(shippingContainer).attr('id', 'calendar-arrival_' + orderItemId);
	                } else {
	                  shippingContainer.html(": " + messages.RWD_SHIPPING_AND_HANDLING_INCLUDED);
	                }
	                processedAmount = 0;
	              } else {
	                shippingContainer.html(": " + COSTCO.util.formatMoney(amount, true));
	              }
	              if (shippingContainer.data('shipchecked') == true) {
	                shippingAmount = processedAmount;
	              }
	            }
	          }
	        }
	      } else if (shippingMethod && shippingMethod.isGroceryItem) {
	        shippingAmount = shippingMethod.amount;
	      }
	      return shippingAmount;
	    },
	    error_query: costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE ? '.delivery-options[data-orderitem={0}]' : '.order-item[data-orderitemid={0}] .critical-notification',
	    display_error: function display_error(orderItemId, message) {
	      var formattedQuery = COSTCO.util.messageFormat(COSTCO.OrderItems.error_query, orderItemId);
	      var elem = void 0;
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	        elem = $(formattedQuery).parents().closest("ul").find(".critical-notification");
	      } else {
	        elem = $(formattedQuery);
	      }
	      if (elem.length == 0) {
	        return;
	      }
	      var html = elem.html().trim();
	      if (html) {
	        try {
	          html = html.replace(new RegExp(message, 'g'), "");
	          if (html) {
	            html = html + "<br>" + message;
	          } else {
	            html = message;
	          }
	        } catch (e) {
	          console.log(e);
	        }
	      } else {
	        html = message;
	      }
	
	      var decodedHTML = COSTCO.util.get_decoded_html(html);
	
	      elem.html(decodedHTML).removeClass('hide');
	    },
	    /**
	     * [update_shipmode description]
	     * Call the ajax update state to re-initialize any tooltips we may have
	     * @param  {[type]} shipModeId  [description]
	     * @param  {[type]} orderItemId [description]
	     * @param  {[type]} padDate     [description]
	     * @param  {boolean} singleShipModeUpdate [this param tells ShippingCalculationCodeCalculateCmd that only this orderitem need be send to OMS for ship charge calculation]
	     * @return {[type]}             [description]
	     */
	    update_shipmode: function update_shipmode(shipModeId, orderItemId, padDate, skipCallEddService) {
	      var is_selected = $(this).data('checked');
	      /*Check whether warehouse pickup is selected*/
	      var divId = $(this).attr('id');
	      var error_container = $('.error.check').length > 0 ? '.error.check' : '#errquantity_';
	      if (!is_selected) {
	        // Update the shipmode.
	        var inputContainer = undefined;
	        if (checkoutPage == 'review') {
	          $('#markShipChargeChange').val('true');
	        }
	        if (checkoutPage == 'cart' || checkoutPage == 'review' && costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
	          inputContainer = padDate ? $('input[value=' + shipModeId + ']') : $(this);
	        } else {
	          inputContainer = $('.delivery-options-selected[data-orderitem=' + orderItemId + ']').find('.edit')[0];
	        }
	        $('#pick_up_text_' + orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
	        var delivery_options = $(this).parents('.delivery-options');
	
	        var estimatedDeliveryDate = '';
	
	        var deliveryCharge = $('.shipping-cost[data-shipmodeid=' + shipModeId + '][data-orderitemid=' + orderItemId + ']').html();
	        if (deliveryCharge != null) deliveryCharge = deliveryCharge.replace("$", "").replace(":", "").trim();
	
	        // if we have estimated delivery dates on the page, place them in a variable and 
	        // pass them to the CostcoItemUpdateShipModeCmd so they can be written to the database
	        if (typeof $(delivery_options).find('.edd-non-formatted-date_' + shipModeId + '_' + orderItemId + '')[0] !== 'undefined') {
	          estimatedDeliveryDate = $(delivery_options).find('.edd-non-formatted-date_' + shipModeId + '_' + orderItemId + '')[0].value;
	        }
	
	        var page = typeof checkoutPage !== "undefined" ? checkoutPage : 'cart';
	        var hasOrderLineError = false;
	        var ifAnyPickupError = false;
	        var freeGiftShipMode = document.getElementsByName('freeGiftShipMode');
	        var freeGiftShipModeArray = [];
	        if (freeGiftShipMode !== undefined) {
	          for (var i = 0; i < freeGiftShipMode.length; i++) {
	            freeGiftShipModeArray.push(freeGiftShipMode[i].value);
	          }
	        }
	        var pickUpAPIResp = '';
	        var mdmAPIResp = '';
	        var switchToPickUp = false;
	        if (divId == 'ship-mode-radio-warehouse-pickup_' + orderItemId || divId == 'ship-mode-radio-ltl-pickup_' + orderItemId) {
	          pickUpAPIResp = $('#pickUpAPIResponses').val();
	          switchToPickUp = true;
	        }
	        if (divId == 'ship-mode-radio-ltl-pickup_' + orderItemId) {
	          mdmAPIResp = $('#mdmApiResponses').val();
	        }
	        checkout_helper.ajax_update_state({
	          error_container: error_container,
	          page: page,
	          url: '/CostcoOrderItemUpdateShipModeCmd',
	          method: 'POST',
	          data: [{
	            name: "shipModeId",
	            value: shipModeId || ""
	          }, {
	            name: "orderItemId",
	            value: orderItemId || ""
	          }, {
	            name: "singleShipModeUpdate",
	            // ALM28937 setting singleShipModeUpdate as false
	            value: false || ""
	          }, {
	            name: "padDate",
	            value: padDate || ""
	          }, {
	            name: "estimatedDeliveryDate",
	            value: estimatedDeliveryDate || ""
	          }, {
	            name: "deliveryCharge",
	            value: deliveryCharge || ""
	          }, {
	            name: "freeGiftShipMode",
	            value: JSON.stringify(freeGiftShipModeArray) || ""
	          }, {
	            name: "pickUpAPIResponses",
	            value: pickUpAPIResp
	          }, {
	            name: "mdmApiResponses",
	            value: mdmAPIResp
	          }],
	          always: function always() {
	            COSTCO.Checkout.ajax_update_default_always(inputContainer);
	            COSTCO.OrderItems.tooltips();
	            COSTCO.preauthchargesmodal.init();
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	              COSTCO.OrderItems.addQuantityEventHandlers();
	              COSTCO.Global.datePickerEventHanler();
	            }
	            // Returns a focus to checked radio button
	            $('#' + inputContainer.attr('id')).parent().focus();
	            if (!skipCallEddService) {
	              COSTCO.EDDService.callEddService();
	            }
	            var pickUpAPIResp = $('#pickUpAPIResponses').val();
	            var isSwitchToDelivery = !switchToPickUp;
	            if (pickUpAPIResp != undefined && pickUpAPIResp != null && pickUpAPIResp != '') {
	              COSTCO.OrderItems.repaintPickUpMolecule(JSON.parse(pickUpAPIResp), true, true, isSwitchToDelivery, orderItemId);
	            }
	            COSTCO.OrderItems.displayGlobalPickUpAlerts(false, true);
	            /** if mdo pickup is selected */
	            if (divId == 'ship-mode-radio-ltl-pickup_' + orderItemId) {
	              COSTCO.OrderItems.handleErrorDisplayForMdo();
	            }
	          },
	          ajax_update_post_done: function ajax_update_post_done(response_obj, mergedOptions, defaultOptions) {
	            // Narvar check EDD when user changes ship mode (orderitems.js)
	            COSTCO.Header.startEDDMutationObserver();
	          },
	          inputContainer: inputContainer
	        });
	      }
	    },
	
	    /** To not to display errors On Load of cart page for mdo items ALM54165*/
	    handleErrorDisplayForMdo: function handleErrorDisplayForMdo() {
	      if ($("#contractErrContainer").length > 0 && $("#contractErrContainer").is(':visible')) {
	        $("#contractErrContainer").addClass('hide');
	      }
	      if ($("#lineItemError").length > 0 && $("#lineItemError").is(':visible')) {
	        $("#lineItemError").addClass('hide');
	      }
	    },
	
	    /* To display Freight Savings On Load of cart page*/
	    refreshFreightSavings: function refreshFreightSavings() {
	      var orderId = $('[name=orderId]').val();
	      return COSTCO.util.ajax({
	        method: 'POST',
	        url: '/AjaxRefreshFreightSavingsCmd',
	        dataType: 'json',
	        data: [{
	          name: "orderId",
	          value: orderId || ""
	        }]
	      }).done(COSTCO.util.safe(function (data, textStatus, jqXHR) {
	        OrderItems.initalloadCompleted = true;
	        if (data.totalFreightSavingsAjax === 'undefined' || data.totalFreightSavingsAjax === null || data.totalFreightSavingsAjax === '' || data.totalFreightSavingsAjax >= 0) {
	          $("#totalFreightSavingsOutput").addClass('hide');
	          $("#freightsavingHeading").addClass('hide');
	          if (checkoutPage === 'cart') {
	            var numPrice = $("#order-estimated-total").text().replace('$', '').replace(',', '');
	            total = COSTCO.Product.formatMoney(parseFloat(numPrice) - parseFloat(orderStatic.totalFreightSavings));
	            $("#order-estimated-total").text("$" + total);
	            $("#order-estimated-total-mobile").text("$" + total);
	          } else if (checkoutPage === 'review') {
	            var numPrice = $("#outstandingPrincipal").val().replace('$', '').replace(',', '');
	            total = COSTCO.Product.formatMoney(parseFloat(numPrice) - parseFloat(orderStatic.totalFreightSavings));
	            $("#orderTotalOutput").html("$" + total);
	            $("#outstandingPrincipal").val(total.replace(',', ''));
	            $("#currentOrderTotal").val(total.replace(',', ''));
	            $("#order-estimated-total-checkout-mobile").text("$" + total);
	          }
	          orderStatic.totalFreightSavings = data.totalFreightSavingsAjax;
	        } else if (data.totalFreightSavingsAjax != orderStatic.totalFreightSavings && checkoutPage === 'cart') {
	          var numPrice = $("#order-estimated-total").text().replace('$', '').replace(',', '');
	          var freightDiff = parseFloat(data.totalFreightSavingsAjax) - parseFloat(orderStatic.totalFreightSavings);
	          total = COSTCO.Product.formatMoney(parseFloat(numPrice) + parseFloat(freightDiff));
	          $("#order-estimated-total").text("$" + total);
	          $("#order-estimated-total-mobile").text("$" + total);
	          var freightvalue = "-$" + COSTCO.Product.formatMoney(-data.totalFreightSavingsAjax);
	          $("#totalFreightSavingsOutput").html(freightvalue);
	          $("#totalFreightSavingsOutput").removeClass('hide');
	          $("#freightsavingHeading").removeClass('hide');
	          orderStatic.totalFreightSavings = data.totalFreightSavingsAjax;
	        } else if (checkoutPage === 'review' && data.totalFreightSavingsAjax != orderStatic.totalFreightSavings) {
	          var freightDiff = parseFloat(data.totalFreightSavingsAjax) - parseFloat(orderStatic.totalFreightSavings);
	          var numPrice = $("#outstandingPrincipal").val().replace('$', '').replace(',', '');
	          total = COSTCO.Product.formatMoney(parseFloat(numPrice) + parseFloat(freightDiff));
	          $("#orderTotalOutput").html("$" + total);
	          $("#outstandingPrincipal").val(total.replace(',', ''));
	          $("#currentOrderTotal").val(total.replace(',', ''));
	          $("#order-estimated-total-checkout-mobile").text("$" + total);
	          var freightvalue = "-$" + COSTCO.Product.formatMoney(-data.totalFreightSavingsAjax);
	          $("#totalFreightSavingsOutput").html(freightvalue);
	          $("#totalFreightSavingsOutput").removeClass('hide');
	          $("#freightsavingHeading").removeClass('hide');
	          orderStatic.totalFreightSavings = data.totalFreightSavingsAjax;
	        }
	      }), 'COSTCO.OrderItems.refreshFreightSavings')
	      // unexpected error flow
	      .fail();
	    },
	    /**
	     * Function use to set orderitem as warehousepickup order
	     * Upon success of setting the command redirect to warehouse selection
	     */
	    set_warehouse_pickup: function set_warehouse_pickup(orderItemId, shipModeId, fromPage) {
	      console.log('Set order item id to ' + orderItemId);
	      console.log('Set ship mode id to ' + shipModeId);
	      console.log(wcs.langId);
	
	      var redirectUrl = '/WarehousePickupLocatorView';
	      redirectUrl += '?storeId=' + wcs.storeId;
	      redirectUrl += '&catalogId=' + wcs.catalogId;
	      redirectUrl += '&langId=' + wcs.langId;
	      redirectUrl += '&orderitemId=' + orderItemId;
	      redirectUrl += '&shipModeId=' + shipModeId;
	      redirectUrl += '&fromPage=' + fromPage;
	      redirectUrl += '&checkoutPage=' + checkoutPage;
	
	      window.location.href = redirectUrl;
	    },
	    /**
	     * [date_picker_radio description]
	     * @return {[type]} [description]
	     */
	    date_picker_radio: function date_picker_radio() {
	      var orderItemId = $(this).parents('.delivery-option-radios').data('orderitem');
	      $('input.date-input[data-orderitem=' + orderItemId + ']').trigger('click');
	    },
	    prescriptionDetailPopUp: function prescriptionDetailPopUp(prescriptionId, patientId) {
	      var prescriptionId1 = $("input[name=" + prescriptionId + "]").val();
	      $.ajax({
	        url: prescriptionDetailUrl,
	        dataType: 'json',
	        data: {
	          shopperId: patientId,
	          prescriptionId: prescriptionId1
	        },
	        cache: false,
	        success: COSTCO.OrderItems.prescriptionDetailPopUpSuccess,
	        error: function error(xhr, ajaxOptions, thrownError) {
	          console.log(xhr + " " + ajaxOptions + " " + thrownError);
	        }
	      });
	    },
	    prescriptionDetailPopUpSuccess: function prescriptionDetailPopUpSuccess(data) {
	      var prescriptionDetail = $.parseJSON(DOMPurify.sanitize(data.prescriptionDetail));
	      var centralFill = $.parseJSON(DOMPurify.sanitize(data.centralFill));
	      var disableAutoRefill = DOMPurify.sanitize(data.disableAutoRefill);
	      COSTCO.OrderItems.buildPrescriptionDetail(prescriptionDetail, centralFill, disableAutoRefill);
	      return false;
	    },
	    buildPrescriptionDetail: function buildPrescriptionDetail(details, centralFill, disableAutoRefill) {
	      var DELIVERY_PREFERENCE = 'Self Checkout';
	      var template = COSTCO.util.tmpl('tmpl_rx_popup_v2', {});
	      $template = $(template);
	      var fullName = COSTCO.util.replaceSpecialChars(details.firstName) + " " + COSTCO.util.replaceSpecialChars(details.lastName);
	      $template.find("#detail-patient").html(fullName);
	      $template.find("#detail-prescriptionId").html(details.rx);
	      if (details.orderNumber == 0) {
	        details.orderNumber = '';
	      }
	      $template.find("#detail-costcoOrder").html(details.orderNumber);
	      $template.find("#detail-status").html(details.status);
	      $template.find("#detail-medication").html(details.prescriptionName);
	      $template.find("#detail-quantity").html(details.quantity);
	      $template.find("#detail-refillsLeft").html(details.refillsLeft);
	      var autoRefill = "NO";
	      if (details.autoRefill == 1) {
	        autoRefill = "YES";
	      } else if (details.autoRefill == 3) {
	        autoRefill = "<a href='javascript:noRefillPopup(false);'>N/A</a>";
	      }
	      if (disableAutoRefill == true) autoRefill = "<a href='javascript:noRefillPopup(true);'>N/A</a>";
	      $template.find("#detail-autoRefill").html(autoRefill);
	      $template.find("#detail-deliveryPreference").html(details.deliveryPreference);
	      if (details.deliveryPreference == DELIVERY_PREFERENCE) {
	        details.shipMethod = '';
	      }
	      $template.find("#detail-shippingOption").html(details.shipMethod);
	      var physicianDetail = "";
	      if (details.physicianName != "" || details.physicianCity != "" || details.physicianState != "" || details.physicianPhone != "") {
	        physicianDetail = details.physicianName + ", " + details.physicianCity + ", " + details.physicianState + ", " + details.physicianPhone;
	      }
	      $template.find("#detail-physician").html(physicianDetail);
	      var price = "";
	      if (details.price != "") {
	        price = "$" + details.price;
	      }
	      $template.find("#detail-price").html(price);
	      $template.find("#detail-centralFillName").html(centralFill.name);
	      $template.find("#detail-centralFillStreet").html(centralFill.street);
	      var cityStZip = centralFill.city + ", " + centralFill.state + " " + centralFill.zip;
	      $template.find("#detail-centralFillCityStZip").html(cityStZip);
	      $template.find("#detail-centralFillPhone").html("Phone: " + centralFill.phone);
	      $template.find("#detail-centralFillFax").html("Fax: " + centralFill.fax);
	      options = {
	        body: $template,
	        title: "Prescription Details",
	        primary: "OK"
	      };
	      COSTCO.dialog.showAndHideModal(options);
	    },
	    /**
	     * [date_picker description]
	     * @return {[type]} [description]
	     */
	    date_picker: function date_picker() {
	      var o = COSTCO.OrderItems,
	          orderItemId = $(this).data('orderitem'),
	          shipModeId = $('.pad input[data-orderitem=' + orderItemId + ']').val(),
	          langId = COSTCO.util.getLangId();
	      // Select the PAD radio associated with the input
	      $('.delivery-option-radios[data-orderitem=' + orderItemId + '] .pad input').prop('checked', true);
	
	      // Added the below line to fix STRY0154849 Costco.com/.ca PAD date_picker inoperable after initialization
	      if ($(this).hasClass('datepicker-initialized')) $(this).removeClass('datepicker-initialized');
	
	      if (typeof o.ship_dates[orderItemId] == "undefined" || !$(this).hasClass('datepicker-initialized')) {
	        COSTCO.util.ajax({
	          url: '/CostcoMultiShippingCmd',
	          method: 'GET',
	          dataType: 'json',
	          input: this,
	          data: {
	            listPreferredDates: true,
	            shipOrderItemNum: orderItemId,
	            shipModeId: shipModeId,
	            shipAddressId: $(this).data('addressid')
	          },
	          done: function done(data, textStatus, jqXHR, options) {
	            if (data && data.shipDates) {
	              var orderItemId = $(options.input).data('orderitem');
	              o.ship_dates[orderItemId] = data.shipDates.map(function (date_str) {
	                return {
	                  date_obj: new Date(date_str),
	                  date_str: date_str
	                };
	              });
	              //Fixing datepicker for ADA users to pick only available shipping dates
	              var enabledDates = function enabledDates() {
	                var availableDates = [];
	                o.ship_dates[orderItemId].forEach(function (allowed_obj) {
	                  if (allowed_obj.date_str) {
	                    var formatedDate = allowed_obj.date_obj.toJSON().split("T")[0];
	                    var availableFormatedDate = formatedDate.split('-')[1] + '/' + formatedDate.split('-')[2] + '/' + formatedDate.split('-')[0];
	                    availableDates.push(availableFormatedDate);
	                  }
	                });
	                return availableDates;
	              };
	              $(options.input).datepicker({
	                todayHighlight: true,
	                autoclose: true,
	                orientation: "auto right",
	                format: langId == -1 || langId == -24 ? "mm/dd/yyyy" : "dd/mm/yyyy",
	                language: langId == -1 || langId == -24 ? "en" : "fr",
	                showOnFocus: false,
	                datesEnabled: enabledDates()
	              }).on('changeDate', function (e) {
	                // The change event needs the date string to pass to the server.
	                var date_str = "",
	                    selected_date = e.date;
	                this.allowed_objs.forEach(function (allowed_obj) {
	                  var date_obj = allowed_obj.date_obj;
	                  if (selected_date.getDate() == date_obj.getDate() && selected_date.getMonth() == date_obj.getMonth() && selected_date.getFullYear() == date_obj.getFullYear()) {
	                    date_str = allowed_obj.date_str;
	                    return;
	                  }
	                });
	                COSTCO.OrderItems.update_shipmode(shipModeId, orderItemId, date_str);
	              }.bind({ // Bind an object to the function's "this" context so we can reference this fields for "changeDate"
	                allowed_objs: o.ship_dates[orderItemId],
	                orderItemId: orderItemId,
	                shipModeId: shipModeId
	              }));
	              $(options.input).datepicker('show');
	              $(options.input).addClass('datepicker-initialized');
	            }
	          }
	        });
	      }
	    },
	
	    cachedAddressData: {},
	
	    updateSmsPhoneForItem: function updateSmsPhoneForItem(elem, orderItemId) {
	      var smsPhone = "";
	
	      $('#smsPhoneId_' + orderItemId).bind("click", function () {
	        $('#smsPhoneLabel_' + orderItemId).addClass('hidden');
	        $('#smsPhoneId_' + orderItemId).removeClass('error');
	      });
	
	      if ($('#receiveSMS_' + orderItemId).is(':checked') || $('#receiveTireNotification_' + orderItemId).is(':checked')) {
	        smsPhone = $('#smsPhoneId_' + orderItemId).cleanVal();
	        if (smsPhone.length < 10 || parseInt(smsPhone) == 0) {
	          $('#smsPhoneLabel_' + orderItemId).addClass('error');
	          $('#smsPhoneLabel_' + orderItemId).removeClass('hidden');
	          $('#smsPhoneId_' + orderItemId).addClass('error');
	          $('#smsPhoneId_' + orderItemId).focus();
	          return;
	        }
	        $('.smsPhoneBlock').removeClass('hidden');
	      } else {
	        $('.smsPhoneBlock').addClass('hidden');
	      }
	
	      var data = [{
	        name: "smsPhone",
	        value: smsPhone || ""
	      }, {
	        name: "orderItemId",
	        value: orderItemId || ""
	      }];
	      var focusedItemId = $(elem).attr('id');
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
	        this.ajaxSmsPhoneUpdateV2(data);
	      } else {
	        this.ajaxSmsPhoneUpdate(data, focusedItemId);
	      }
	    },
	
	    updateSmsPhoneForOrder: function updateSmsPhoneForOrder(elem, orderId, preserveAddressData) {
	      var smsPhone = "";
	      if ($('#receiveSMS_' + orderId).is(':checked')) {
	        $('.smsPhoneBlock').removeClass('hidden');
	        smsPhone = $('#smsPhoneId_' + orderId).cleanVal();
	        if (smsPhone.length < 10 || parseInt(smsPhone) == 0) {
	          $('#smsPhoneLabel_' + orderId).addClass('error');
	          $('#smsPhoneLabel_' + orderId).removeClass('hidden');
	          $('#smsPhoneId_' + orderId).addClass('error');
	          $('#smsPhoneId_' + orderId).focus();
	          return;
	        }
	      } else {
	        $('.smsPhoneBlock').addClass('hidden');
	        $('#smsPhoneId_' + orderId).val("");
	      }
	
	      var data = [{
	        name: "smsPhone",
	        value: smsPhone || ""
	      }, {
	        name: "orderId",
	        value: orderId || ""
	      }];
	      var focusedItemId = $(elem).attr('id');
	      if (typeof preserveAddressData !== 'undefined' && preserveAddressData) {
	        COSTCO.OrderItems.cachedAddressData.first = $('#firstId').val();
	        COSTCO.OrderItems.cachedAddressData.last = $('#lastId').val();
	        COSTCO.OrderItems.cachedAddressData.company = $('#companyId').val();
	        COSTCO.OrderItems.cachedAddressData.line1 = $('#address1Id').val();
	        COSTCO.OrderItems.cachedAddressData.line2 = $('#address2Id').val();
	        COSTCO.OrderItems.cachedAddressData.zip = $('#postalId').val();
	        COSTCO.OrderItems.cachedAddressData.city = $('#cityId').val();
	        COSTCO.OrderItems.cachedAddressData.state = $('#stateId').val();
	        COSTCO.OrderItems.cachedAddressData.country = $('#countryId').val();
	        COSTCO.OrderItems.cachedAddressData.phone = $('#phoneId').val();
	        COSTCO.OrderItems.cachedAddressData.email = $('#emailId').val();
	        COSTCO.OrderItems.cachedAddressData.addressType = $('#save-address-inline').is(':checked') ? '' : 'T';
	        COSTCO.OrderItems.cachedAddressData.isPrimary = $('#set-default-inline').is(':checked') ? '1' : '0';
	      }
	      this.ajaxSmsPhoneUpdateV2(data, focusedItemId);
	    },
	
	    /**
	     * Updates Contact Information phone number for Tires
	     * @param {String}	orderId The OrderId
	     * @return void
	     */
	    updateSmsPhoneForTiresOrder: function updateSmsPhoneForTiresOrder(orderId, form, smsOptedIn) {
	
	      var smsPhone = "";
	      var isTireOptedIn = true;
	
	      if (form != null) {
	        if (typeof form.id !== 'undefined' && form.id !== '' && form.id.includes('tires-mobile-phone-input')) {
	          form = $("[id^='tires-mobile-phone-input']");
	          if (smsOptedIn != undefined && smsOptedIn == "true") {
	            var placeholder = "input[id=tireSmsCheckPhoneId_" + orderId + "]";
	            if ($(placeholder) != undefined && $(placeholder).prop('checked')) {
	              smsPhone = $('#tiresSmsPhoneId_' + orderId).val();
	            } else {
	              isTireOptedIn = false;
	            }
	          }
	        } else if (typeof form.id !== 'undefined' && form.id !== '' && form.id === 'ShopCartForm') {
	          form = $("[id=ShopCartForm]");
	          smsPhone = $('#tiresSmsPhoneId_' + orderId).val();
	        }
	
	        if (!COSTCO.OrderSummary.smsValidator.isValid(form, "[id^=edit-tires-contact-information-phone] input[id^=tiresSmsPhoneId_]")) {
	          return;
	        }
	      }
	
	      var data = [{
	        name: "smsPhone",
	        value: smsPhone || ""
	      }, {
	        name: "orderId",
	        value: orderId || ""
	      }, {
	        name: "checkoutPage",
	        value: checkoutPage
	      }, {
	        name: "isTire",
	        value: true
	      }, {
	        name: "isTireOptedIn",
	        value: isTireOptedIn
	      }];
	      this.ajaxSmsPhoneUpdateV2(data);
	    },
	
	    clearFieldForOrder: function clearFieldForOrder(orderItemId, typeOfOrder) {
	
	      var placeholder1 = "";
	      var placeholder2 = "";
	      var placeholder3 = "";
	      var placeholder4 = "";
	
	      switch (typeOfOrder) {
	        case 'RegularOrder':
	          placeholder1 = "#contact-information-phone";
	          placeholder2 = "#edit-contact-information-phone";
	          placeholder3 = "input[id=smsPhoneId_" + orderItemId + "]";
	          placeholder4 = "#sms-agreement-info";
	          break;
	        case 'TiresOrder':
	          placeholder1 = "#tires-contact-information-phone";
	          placeholder2 = "#tireSmsOptInNotification";
	          placeholder3 = "input[id=tiresSmsPhoneId_" + orderItemId + "]";
	          placeholder4 = "#tire-sms-agreement-info";
	          break;
	        default:
	          console.log("COSTCO - Irregular order type");
	      }
	
	      $(placeholder3).focus();
	
	      $(placeholder3).val("");
	      var form = null;
	
	      if ($("[id=mobile-phone-input_" + orderItemId + "]").length > 0) {
	        form = $("[id=mobile-phone-input_" + orderItemId + "]");
	      }
	    },
	
	    /**
	     * this method will update sms phone on every order item from order
	     * that is sms enabled
	     */
	    updateSmsPhoneForOrder_v2: function updateSmsPhoneForOrder_v2(orderId, smsOptedIn) {
	
	      var smsPhone = "";
	      var form = null;
	      var isOptedIn = true;
	
	      if ($("[id=mobile-phone-input_" + orderId + "]").length > 0) {
	        form = $("[id=mobile-phone-input_" + orderId + "]");
	      }
	
	      if (smsOptedIn != undefined && smsOptedIn == "true") {
	        if (!COSTCO.OrderSummary.smsValidator.isValid(form, "#smsPhoneId_" + orderId)) {
	          return;
	        }
	        var placeholder = "input[id=smsCheckPhoneId_" + orderId + "]";
	        if ($(placeholder) != undefined && $(placeholder).prop('checked')) {
	          smsPhone = $('#smsPhoneId_' + orderId).val();
	        } else {
	          isOptedIn = false;
	        }
	      } else {
	        isOptedIn = false;
	      }
	      var data = [{
	        name: "smsPhone",
	        value: smsPhone || ""
	      }, {
	        name: "orderId",
	        value: orderId || ""
	      }, {
	        name: "checkoutPage",
	        value: checkoutPage
	      }, {
	        name: "isTire",
	        value: false
	      }, {
	        name: "isOptedIn",
	        value: isOptedIn
	      }];
	      this.ajaxSmsPhoneUpdateV2(data);
	    },
	    /**
	     * This function is used to add/update sms Phone for smsEnabled items 
	     */
	    updateSmsPhoneForItem_v2: function updateSmsPhoneForItem_v2(orderItemId, orderItemIds, orderId) {
	
	      var smsPhone = $('#smsPhoneId_' + orderItemId).val();
	      var form = null;
	
	      if ($("[id=ShopCartForm]").length > 0) {
	        form = $("[id=ShopCartForm]");
	      }
	
	      if (!COSTCO.OrderSummary.smsValidator.isValid(form, "#smsPhoneId_" + orderItemId)) {
	        return;
	      }
	
	      var data = [{
	        name: "smsPhone",
	        value: smsPhone || ""
	      }, {
	        name: "orderItemId",
	        value: orderItemId || ""
	      }, {
	        name: "checkoutPage",
	        value: 'review'
	      }, {
	        name: "orderItemIds",
	        value: orderItemIds
	      }, {
	        name: "isOptedIn",
	        value: true
	      }, {
	        name: "orderId",
	        value: orderId || ""
	      }];
	      this.ajaxSmsPhoneUpdateV2(data);
	    },
	
	    ajaxSmsPhoneUpdateV2: function ajaxSmsPhoneUpdateV2(data) {
	      COSTCO.AjaxModular.ajax_update_state({
	        url: 'CostcoOrderItemUpdateSmsPhoneCmd',
	        method: 'POST',
	        dataType: 'json',
	        data: data,
	        scrollToError: false,
	        done: function done(data, textStatus, jqXHR, options) {
	          COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
	          COSTCO.OrderItems.tooltips();
	        },
	        always: function always() {
	          if ($(".multi-address-box").length > 0) {
	            COSTCO.EDDService.callEddService();
	            COSTCO.ShippingCosts.displayTotals();
	          }
	        }
	      });
	    },
	    /**
	     * Method to call the AjaxLTLSelectedDeliveryDateUpdateCmd to save the selected date to DB
	     */
	    ajaxCalendarDataUpdate: function ajaxCalendarDataUpdate(data) {
	      if (data.mode == 'SELECTED') {
	        var timeSlot = null;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = globalCalendarMap.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	
	            if (item.trim() === data.currentId) {
	              timeSlot = globalCalendarMap.get(item).get(data.dateFormatted);
	              if (null !== timeSlot && !Array.isArray(timeSlot)) {
	                timeSlot = timeSlot.split();
	                data.selectedTimeSlot = timeSlot[0];
	              }
	              break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        if (undefined !== timeSlot && null !== timeSlot) {
	          COSTCO.OrderItems.displayCalendarTimeSlots(timeSlot, data.orderItemId, data.dateFormatted, data.selectedTimeSlot, data.currentId);
	        }
	      } else {
	        COSTCO.EDDService.stringifyJsonData(data);
	      }
	      data.orderId = $('[name=orderId]').val();
	      COSTCO.AjaxModular.ajax_update_state({
	        url: '/AjaxLTLSelectedDeliveryDateUpdateCmd',
	        method: 'POST',
	        data: data,
	        scrollToError: false,
	        done: function done(textStatus, jqXHR, options) {
	          if (data.mode == 'SELECTED') {
	            if (null !== data.listOfFulfilledOrderIds) {
	              var listOdIds = data.listOfFulfilledOrderIds.split(",");
	              for (i = 0; i < listOdIds.length; i++) {
	                COSTCO.EDDService.createCalendarInput(data, listOdIds[i].trim());
	              }
	            }
	          }
	          /* following block introduced as part of kits and bundle.
	           *to display freight saving on initial load after edd sync
	           *  */
	          if (costcoStoreFeatures.FEIGHTSAVINGS_FEATURE_ENABLE === true && (checkoutPage === 'cart' || checkoutPage === 'review')) {
	            COSTCO.OrderItems.refreshFreightSavings();
	          }
	        }
	      });
	    },
	    ajaxSmsPhoneUpdate: function ajaxSmsPhoneUpdate(data, focusItemId) {
	      $.ajax({
	        url: '/CostcoOrderItemUpdateSmsPhoneCmd',
	        method: 'POST',
	        data: data,
	        timeout: 15000
	      }).done(function (smsPhoneUpdateObj) {
	        console.log('SMS phone Updated Successfully ');
	      }).fail(function (smsPhoneUpdateObj) {
	        // Error Calling SMS update Service
	        console.log('Error Updating the phone for SMS ');
	      });
	    },
	
	    updateSetDefaultShippingAddress: function updateSetDefaultShippingAddress(addressId) {
	
	      if ($('#setDefault_' + addressId).is(':checked')) {
	        $('#setDefault_' + addressId).prop('checked', false);
	        COSTCO.dialog.createExtDialogBox({
	          title: messages.JS_CHANGE_DEFAULT_ADDRESS_TITLE,
	          body: $('#tmpl_default_address_info_dialog').html(),
	          primary: messages.JS_DIALOG_ACCEPT,
	          primary_event: function primary_event() {
	            $('#setDefault_' + addressId).prop('checked', true);
	            $('#costcoModal').modal('hide');
	            $("input[name='setAsDefaultShippingAddress']").map(function () {
	              $(this).val($('#setDefault_' + addressId).is(':checked'));
	            });
	            COSTCO.CAddressBook.setDefault(addressId, function () {
	              $('#setDefault_' + addressId).closest('div').addClass('hide');
	            });
	          },
	          secondary: messages.JS_DIALOG_CANCEL
	        });
	      } else {
	        $("input[name='setAsDefaultShippingAddress']").map(function () {
	          $(this).val($('#setDefault_' + addressId).is(':checked'));
	        });
	      }
	    },
	
	    updateSetDefaultBillingAddress: function updateSetDefaultBillingAddress(addressId) {
	      if ($('#CheckoutPaymentForm').length) {
	        $("#CheckoutPaymentForm input[name='setAsDefaultBillingAddress']").val($('#setDefault_' + addressId).is(':checked'));
	      }
	      if ($('#CheckoutReviewForm').length) {
	        $("#CheckoutReviewForm input[name='setAsDefaultBillingAddress']").val($('#setDefault_' + addressId).is(':checked'));
	      }
	      if ($('#setDefault_' + addressId).is(':checked')) {
	        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
	          $('#address-block-billing').find('#setDefault_' + addressId).attr('checked', true);
	        }
	        COSTCO.CAddressBook.setDefault(addressId, function () {
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	            $('#address-block-billing').find('#setDefault_' + addressId).closest('div').addClass('hide');
	          } else {
	            $('#setDefault_' + addressId).closest('div').removeClass('hide');
	          }
	        });
	      }
	    },
	
	    initSetDefaultAddressstate: function initSetDefaultAddressstate(state) {
	      if ($('input[name^=setDefault_]').length > 0) {
	
	        $('input[name^=setDefault_]').each(function () {
	          $(this).prop('checked', state);
	        });
	      }
	      if ($("input[name='setAsDefaultShippingAddress]'").length > 0) {
	        $("input[name='setAsDefaultShippingAddress']").map(function () {
	          $(this).val(state);
	        });
	        //    		$('#setAsDefaultShippingAddress').val(state)
	      }
	    },
	
	    changeAddress: function changeAddress(addressId, addressType) {
	
	      var callerElement = event.target;
	      addressLabels.edit.primaryButton = messages.EDIT_ADDRESS_SAVE_BUTTON;
	      COSTCO.CAddressSelectionDialog.showAddressSelectionDialog(addressId, addressType, undefined, undefined, undefined, 'change');
	      COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	    },
	
	    /**
	     * Sends an analytics event when unavailable free gift items
	     * are removed due to service area restrictions.
	     */
	    sendAnalyticsDataRemoveUnavailableFreeGiftItems: function sendAnalyticsDataRemoveUnavailableFreeGiftItems() {
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      if (checkoutPage === 'cart') {
	        digitalDataEvents.push({ ui: 'Shopping Cart | Item/s unavailable for service area | Remove unavailable items' });
	      } else if (checkoutPage === 'review') {
	        digitalDataEvents.push({ ui: 'Checkout Flow | Item/s unavailable for service area | Remove unavailable items' });
	      }
	    },
	
	    removeUnavailableItems: function removeUnavailableItems(isInvalidShipModeItems) {
	      var formArray = $('#ShopCartForm').serializeArray();
	      var formData = {};
	      var tempData = {};
	      for (var i = 0; i < formArray.length; i++) {
	        var mapKey = formArray[i]['name'];
	        if (mapKey.indexOf('orderItem') < 0 && mapKey.indexOf('catalogEntryId') < 0 && mapKey.indexOf('quantity') < 0 && mapKey.indexOf('orderItemId') < 0) {
	          formData[mapKey] = formArray[i]['value'];
	        } else {
	          tempData[mapKey] = formArray[i]['value'];
	        }
	      }
	      formData['actionType'] = 'delete';
	      formData['ajaxFlag'] = true;
	
	      //STRY0182081 changes starts
	      /*
	       *  isInvalidShipModeItems is the flag for checking to delete only invalid shipping mode items.
	       *  This will be set only when remove unavailable link is selected from the invalid shipping mode error message.
	       */
	      if (typeof isInvalidShipModeItems != 'undefined' && isInvalidShipModeItems && $('#isBDAppVar').val() == 'BC') {
	        var noOfItems = $('#order-items').find('.order-item').length;
	        var paramCount = 1;
	        for (var i = 1; i <= noOfItems; i++) {
	          var orderItemId = $('#orderItem_' + i).val();
	          var shipmodeId = $('#orderitem_shipmodedetails_' + orderItemId) != null ? $('#orderitem_shipmodedetails_' + orderItemId).val() : null;
	          var isOrderItemShipModeListEmpty = $('#isOrderItemShipModeListEmpty_' + orderItemId) != null ? $('#isOrderItemShipModeListEmpty_' + orderItemId).val() : false;
	          //Check if the shipmodeId is undefined, then set to false and show the error message.
	          if (shipmodeId == null || typeof shipmodeId === 'undefined' || shipmodeId == "" || isOrderItemShipModeListEmpty) {
	            formData['orderItem_' + paramCount] = orderItemId;
	            formData['catalogEntryId_' + paramCount] = $('input[name=catalogEntryId_' + i + ']').val();
	            formData['quantity_' + paramCount] = 0;
	            paramCount++;
	          }
	        }
	      } else {
	        var errorOrderItemsCount = formData['errorOrderItemsCount'];
	        if (errorOrderItemsCount != undefined) {
	          for (var i = 1; i <= errorOrderItemsCount; i++) {
	            formData['orderItem_' + i] = formData['errorOrderItemId_' + i];
	            formData['catalogEntryId_' + i] = tempData['catalogEntryId_' + i];
	            formData['quantity_' + i] = 0;
	          }
	        }
	      }
	      //STRY0182081 changes ends
	
	      checkout_helper.ajax_update_state({
	        url: '/order-quantity-update',
	        method: "POST",
	        data: formData,
	        error_container: $('#contractErrContainer'),
	        ajax_replace_content: function ajax_replace_content(response_obj, mergedOptions, defaultOptions) {
	          if (response_obj.error && response_obj.error.application.indexOf('Empty Cart') == 0) {
	            document.location.href = "/CheckoutCartView";
	            throw new Error('No order items. Redirecting to cart.');
	          }
	          defaultOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
	        },
	        ajax_update_post_done: function ajax_update_post_done(response_obj, mergedOptions, defaultOptions) {
	          // Refresh the cart icon's number to reflect the adjusted quantity.
	          COSTCO.Header.miniShopCartRefresh();
	          COSTCO.OrderItems.init();
	          if (typeof COSTCO.CreditCard !== 'undefined') {
	            COSTCO.CreditCard.initComplete = false;
	            COSTCO.CreditCard.init();
	          }
	        },
	        always: function always() {
	          if ($('#contractErrContainer .errorTop').length == 0) {
	            $('#contractErrContainer').addClass('hidden');
	          }
	          if (typeof TokenGateway != 'undefined') {
	            TokenGateway.refreshGateway();
	          }
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
	            $('#notification-message .order-error').removeClass('critical-notification');
	          }
	          COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	        }
	      });
	    },
	    /**
	     * updateShipmodeDetails - used to handle the shipmode logic in the cart page
	     */
	    updateShipmodeDetails: function updateShipmodeDetails() {
	      var dualContract = COSTCO.util.isCABDStore() && undefined != $('#isStorePickupSelected').val() && null != $('#isStorePickupSelected').val() && ($('#isStorePickupSelected').val() === 'true' || $('#isLocalBuisnessDelSelected').val() === 'true');
	      if ((COSTCO.util.isNdEnabled() || dualContract) && checkoutPage === 'cart' && $('input[name="deliveryMethod"]').length > 0) {
	
	        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	
	          var shipmodeId = "";
	          try {
	            var target = $(event.target);
	            shipmodeId = target.val().length > 0 ? target.val() : $(target.children().first()).val();
	          } catch (err) {
	            shipmodeId = $("input[name='deliveryMethod']:checked").val();
	          }
	
	          shipmodeId = shipmodeId.length > 0 ? shipmodeId : $("input[name='deliveryMethod']:checked").val();
	        } else {
	          var shipmodeId = $("input[name='deliveryMethod']:checked").val();
	        }
	        var shipModeDescription = $('#shipmodeDescription').val() ? $('#shipmodeDescription').val().toUpperCase() : "";
	        if (shipmodeId == 10101 || shipmodeId == 11608) {
	          $("#deldatepicker").prop('disabled', false);
	          $('#deldatepicker').addClass('enableDate');
	          $('.co-calendar').addClass('enableDate');
	          var surchargeAmount = parseInt($('#freeDeliveryOrderAmount').val());
	          var shippingCharge = parseInt($('#toolTipDeliverySurcharge').val());
	          var currentWhsZipCode = $.cookie('WC_BD_WHS');
	          if (shipModeDescription === "PICK-UP" || currentWhsZipCode === '729') {
	            $('#delivery-fee .a11y-tooltip').attr("data-content", messages.MINIMUM_ORDER_AMOUNT_TOOLTIP.replace('{0}', surchargeAmount).replace('{1}', shippingCharge));
	          } else {
	            $('#delivery-fee .a11y-tooltip').attr("data-content", messages.HEADER_BANNER_TOOLTIP.replace('{0}', surchargeAmount).replace('{1}', shippingCharge));
	          }
	
	          var cookieDate = COSTCO.OrderItems.getCookie("deliveryDateCookie");
	          if (cookieDate && cookieDate != "" && cookieDate != null) {
	            $("#deldatepicker").datepicker('setDate', new Date(cookieDate));
	          }
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE && !COSTCO.util.isNdEnabled()) {
	            $("#deldatepicker").focus();
	          }
	        } else {
	          $("#deldatepicker").prop('disabled', true);
	          $('#deldatepicker').removeClass('enableDate');
	          $('.co-calendar').removeClass('enableDate');
	          $("#delivery-fee .a11y-tooltip").attr("data-content", messages.HEADER_BANNER_TOOLTIP_GND);
	          if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	            $('label[for="deldatepicker"]').css("display", "none");
	            $("#deldatepicker").val('');
	          } else {
	            $("#deldatepicker").val('');
	            $('label[for="deldatepicker"]').removeClass("active");
	            $('#deldatepicker, label[for="deldatepicker"]').removeClass("error");
	            $('#deliveryDatePageError').html("");
	            $('#deliveryDatePageError').css("display", "none");
	          }
	          $('#ShopCartForm').find('#selDeliveryDate').val('');
	        }
	
	        if (shipModeDescription === messages.ACTION_ORDER_PICKUP) {
	          var minimumOrderAmount = parseInt($('#minimumOrderAmount').val());
	          $("#delivery-fee .a11y-tooltip").attr("data-content", messages.MINIMUM_ORDER_AMOUNT_TOOLTIP.replace('{0}', minimumOrderAmount));
	        }
	
	        $('#ShopCartForm').find('#shipmodeIdBD').val(shipmodeId);
	        COSTCO.Header.miniShopCartRefresh();
	        COSTCO.OrderItems.hideExpressCheckout();
	      }
	    },
	    /**
	     * Function to hide express checkout button in cart page when saved payment is ACH
	     * @return {void}
	     */
	    hideExpressCheckout: function hideExpressCheckout() {
	      var paymentType = $('#savedPaymentType').val();
	      if ($('#isBDAppVar').val() == 'BD' && COSTCO.util.isNdEnabled()) {
	        if (paymentType == 'ACH') {
	          $('.express-checkout').removeClass('hide');
	          $('.toggle-checkout').removeClass('big-green');
	          $('.cont-shopping').removeClass('col-md-offset-4');
	        }
	      } else {
	        if (paymentType == 'ACH' && COSTCO.util.isExternalCarrierShipmode()) {
	          $('.express-checkout').addClass('hide');
	          $('.cont-shopping').addClass('col-md-offset-4');
	          $('.toggle-checkout').addClass('big-green');
	        } else if (paymentType == 'ACH' && !COSTCO.util.isExternalCarrierShipmode()) {
	          $('.express-checkout').removeClass('hide');
	          $('.toggle-checkout').removeClass('big-green');
	          $('.cont-shopping').removeClass('col-md-offset-4');
	        }
	      }
	    },
	    /**
	     * dateSelected - bind the selected date 
	     */
	    dateSelected: function dateSelected(input) {
	      var deliveryDateBD = input.value;
	      $('#ShopCartForm').find('#selDeliveryDate').val(deliveryDateBD);
	    },
	    createAutoRenewModal: function createAutoRenewModal() {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.RENEW_UPGRADE__AutoRenewHeader,
	        body: COSTCO.util.tmpl('tmpl_auto_renew_membership_modal', {}),
	        primary: messages.CLOSE
	      });
	    },
	
	    /**
	     * This function is used to open edit block for Contact Information Phone Number for Tire product 
	     * Single shipping and Multi shipping.
	     */
	    editContactInformationPhone: function editContactInformationPhone(orderItemId, typeOfOrder, smsOptedIn) {
	
	      var placeholder1 = "";
	      var placeholder2 = "";
	      var placeholder3 = "";
	      var placeholder4 = "";
	      var placeholder5 = "";
	      var placeholder6 = "";
	      var form = null;
	
	      switch (typeOfOrder) {
	        case 'RegularOrder':
	          placeholder1 = "#contact-information-phone";
	          placeholder2 = "#edit-contact-information-phone";
	          placeholder3 = "input[id=smsPhoneId_" + orderItemId + "]";
	          placeholder4 = "#sms-agreement-info";
	          placeholder5 = "input[id=smsCheckPhoneId_" + orderItemId + "]";
	          placeholder6 = "#smsOptInNotification";
	          break;
	        case 'OrderItem':
	          placeholder1 = "#contact-information-phone-" + orderItemId;
	          placeholder2 = "#edit-contact-information-phone-" + orderItemId;
	          placeholder3 = "input[id=smsPhoneId_" + orderItemId + "]";
	          placeholder4 = "#sms-agreement-info-" + orderItemId;
	          $('#edit-contact-information-phone-' + orderItemId + ' input[id^=smsPhoneId_]').unmask().mask('000-000-0000');
	          break;
	        case 'TiresOrder':
	          placeholder1 = "#tires-contact-information-phone";
	          placeholder2 = "#edit-tires-contact-information-phone";
	          placeholder3 = "input[id=tiresSmsPhoneId_" + orderItemId + "]";
	          placeholder4 = "#tire-sms-agreement-info";
	          placeholder5 = "input[id=tireSmsCheckPhoneId_" + orderItemId + "]";
	          placeholder6 = "#tireSmsOptInNotification";
	          break;
	        default:
	          console.log("COSTCO - Irregular order type");
	      }
	
	      if (smsOptedIn != undefined && smsOptedIn === "true") {
	        if ($(placeholder5).prop('checked')) {
	          $(placeholder6).removeClass('hide');
	          $(placeholder4).removeClass('hide');
	          if ($(placeholder3).val() === '') {
	            $(placeholder2 + " " + placeholder3).focus();
	          }
	          if (typeOfOrder === "RegularOrder" && $(placeholder3).val() !== '') {
	            this.updateSmsPhoneForOrder_v2(orderItemId, "true");
	          } else if (typeOfOrder == "TiresOrder" && $(placeholder3).val() !== '') {
	            this.updateSmsPhoneForTiresOrder(orderItemId, form, "true");
	          }
	        } else {
	          $(placeholder6).addClass('hide');
	          $(placeholder4).addClass('hide');
	          if (typeOfOrder === "RegularOrder") {
	            this.updateSmsPhoneForOrder_v2(orderItemId, "false");
	          } else if (typeOfOrder == "TiresOrder") {
	            this.updateSmsPhoneForTiresOrder(orderItemId, form, "false");
	          }
	        }
	      } else {
	
	        $(placeholder1).addClass('hide');
	        $(placeholder2).removeClass('hide');
	
	        $(placeholder2 + " " + placeholder3).focus();
	        $(placeholder2 + " " + placeholder3).select();
	        $(placeholder4).addClass('col-lg-6');
	      }
	    },
	
	    changeQuantityValue: function changeQuantityValue(quantity, isIncrement) {
	      var quantityId = $(quantity);
	      var val = quantityId.val().length > 0 ? parseInt(quantityId.val()) : '';
	      var oldQtyval = quantityId.attr('value');
	      var quantityStep = COSTCO.Product.getQuantityStep(quantityId);
	
	      if (isIncrement === true) {
	        val += quantityStep;
	        var residual = val % quantityStep;
	        val = val - residual;
	      }
	      if (isIncrement === false) {
	        var _residual = val % quantityStep;
	        if (_residual == 0) {
	          val -= quantityStep;
	        } else {
	          val -= _residual;
	        }
	      }
	      if (val < 0) {
	        quantityId.val(0);
	      } else {
	        quantityId.val(val);
	      }
	
	      var callbackParams = [];
	      callbackParams.push(quantityId.attr('id'));
	      var QtyIndex = quantityId.attr('id');
	      var qty = $("#" + QtyIndex).val();
	      orderItemIndex = QtyIndex.replace("quantity", "");
	      var orderItem_id = $("#orderItem" + orderItemIndex).val();
	      if (qty == 0 && $("#notSoldSeperatelyBundleId_" + orderItem_id).val() != undefined) {
	        COSTCO.OrderItems.removeItemUsingUpdateQty(QtyIndex, orderItem_id, false, 0, oldQtyval);
	      } else {
	        COSTCO.OrderItems.validate.call(quantity, COSTCO.OrderItems.quantity_update, 'quantity', callbackParams);
	      }
	
	      COSTCO.Product.expendErrorOnQtyUnit(quantityId, 'span');
	      //COSTCO.Product.discardInvalidQtyValues(val, quantityId,isIncrement);
	      if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true' && typeof adobeProductData != 'undefined') {
	        adobeProductData = [];
	      }
	      if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true' && checkoutPage == 'cart') {
	        if (typeof contextVariables != 'undefined') {
	          var partNumber = $('[data-orderitemid="' + orderItem_id + '"]').first().attr('data-orderitemnumber');
	          var _adobeProductData = eval('adobeProductData' + partNumber);
	          _adobeProductData.quantity = qty;
	        }
	      }
	    },
	
	    /**
	     * Checking if input fields are selected
	     * and set attribute aria-checked with value true/false to label
	     */
	    checkSelectedRadioButton: function checkSelectedRadioButton() {
	      $('[name="delivery-options-radio"]').each(function () {
	        if ($(this).find('input[type=radio]').is(':checked')) {
	          this.setAttribute("aria-checked", "true");
	        } else {
	          this.setAttribute("aria-checked", "false");
	        }
	      });
	    },
	
	    /**
	     * removing item using quantity update
	     * update quantity happens with 0 qty, item will be removed from order
	     * @param
	     */
	    removeItemUsingUpdateQty: function removeItemUsingUpdateQty(quantityId, orderItemId, isPharmacy, prescriptionId, oldQtyval) {
	      // For protection plan items, store the related "No Plan" radio ID
	      // to restore focus after the AJAX update
	      $noPlan = $('input[id^="noPlan_"][data-dependent-order-item-id="' + orderItemId + '"]');
	      if ($noPlan.length) {
	        COSTCO.AjaxModular.pendingFocusId = $noPlan.attr('id');
	      }
	      var itemwithSameBundleId = [];
	      var notSoldeItem = [];
	      var removeOrderitemsId = [];
	      COSTCO.OrderItems.notSoldUrl = "";
	      var isNotSoldItem = $("#notSoldSeperatelyItem_" + orderItemId).val() == "true" ? true : false;
	      if (undefined != $("#notSoldSeperatelyBundleId_" + orderItemId).val() && !isNotSoldItem) {
	        var bundleId = $("#notSoldSeperatelyBundleId_" + orderItemId).val();
	        $('.notSoldBundil').each(function () {
	          var test = this;
	          if (bundleId == $(this).val()) {
	            var OtherbundleitemIdArray = $(this).attr('id').split("_");
	            if (undefined != OtherbundleitemIdArray[1] && null != OtherbundleitemIdArray[1]) {
	              itemwithSameBundleId.push(OtherbundleitemIdArray[1]);
	              var isNotSoledSeperatlyItem = $("#notSoldSeperatelyItem_" + OtherbundleitemIdArray[1]).val() == "true" ? true : false;
	              if (isNotSoledSeperatlyItem) {
	                notSoldeItem.push(OtherbundleitemIdArray[1]);
	              }
	            }
	          }
	        });
	        if (itemwithSameBundleId.length != 0 && notSoldeItem.length != 0) {
	          var normalItemLength = itemwithSameBundleId.length - notSoldeItem.length;
	          if (normalItemLength == 1) {
	            for (var i = 0; i < notSoldeItem.length; i++) {
	              removeOrderitemsId.push(notSoldeItem[i]);
	              var count = i + 2;
	              var catentryId = $("#notSoldSeperateCatenId_" + notSoldeItem[i]).val();
	              COSTCO.OrderItems.notSoldUrl = COSTCO.OrderItems.notSoldUrl + "&orderItem_" + count + "=" + notSoldeItem[i] + "&quantity_" + count + "=0&catalogEntryId_" + count + "=" + catentryId;
	            }
	          }
	        }
	      }
	      var removedOrderItemDescription = $('#product-name_' + orderItemId).find('.title-medium');
	      if (removedOrderItemDescription !== undefined && removedOrderItemDescription.html() !== undefined) {
	        COSTCO.util.announceSRMessage(messages.SFL_REMOVED_FROM_THE_CART.replace('{0}', removedOrderItemDescription.html().trim()));
	      }
	      if (undefined == COSTCO.OrderItems.notSoldUrl || COSTCO.OrderItems.notSoldUrl == "") {
	        $('#' + quantityId).val(0);
	        $('input[name=' + quantityId + ']').val(0);
	      }
	      var calendarResponse = $('#calendarServiceResponse').val();
	      if (calendarResponse != undefined) {
	        document.getElementById("calendarServiceResponse").value = "";
	        apiAlreadyCalled = undefined;
	      }
	      if (undefined != COSTCO.OrderItems.notSoldUrl && COSTCO.OrderItems.notSoldUrl != "") {
	        COSTCO.OrderItems.cartKitsBundleRemove(removeOrderitemsId, quantityId, isPharmacy, prescriptionId, oldQtyval);
	      }
	      if (undefined == COSTCO.OrderItems.notSoldUrl || COSTCO.OrderItems.notSoldUrl == "") {
	        COSTCO.OrderItems.quantity_update(quantityId, isPharmacy, prescriptionId);
	      }
	      if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true' && typeof adobeProductData != 'undefined') {
	        adobeProductData = [];
	      }
	    },
	
	    removeBaliBlindsItemsUsingUpdateQty: function removeBaliBlindsItemsUsingUpdateQty(orderItemId) {
	      var removedBaliBlindsItemDescription = $('#product-name_' + orderItemId).find('.title-medium');
	      if (removedBaliBlindsItemDescription !== undefined && removedBaliBlindsItemDescription.html() !== undefined) {
	        COSTCO.util.announceSRMessage(messages.SFL_REMOVED_FROM_THE_CART.replace('{0}', removedBaliBlindsItemDescription.html().trim()));
	      }
	      var formArray = $('#ShopCartForm').serializeArray();
	      var formData = {};
	      var tempData = {};
	      for (var _i2 = 0; _i2 < formArray.length; _i2++) {
	        var mapKey = formArray[_i2]['name'];
	        if (mapKey.indexOf('orderItem') < 0 && mapKey.indexOf('catalogEntryId') < 0 && mapKey.indexOf('quantity') < 0 && mapKey.indexOf('orderItemId') < 0 && mapKey.indexOf('isBaliBlinds') < 0) {
	          formData[mapKey] = formArray[_i2]['value'];
	        } else {
	          tempData[mapKey] = formArray[_i2]['value'];
	        }
	      }
	      formData['actionType'] = 'delete';
	      formData['ajaxFlag'] = true;
	
	      var noOfItems = $('#order-items').find('.order-item').length;
	      var paramCount = 1;
	      for (var i = 1; i <= noOfItems; i++) {
	        if (tempData['isBaliBlinds_' + i]) {
	          formData['orderItem_' + paramCount] = tempData['orderItem_' + i];
	          formData['catalogEntryId_' + paramCount] = tempData['catalogEntryId_' + i];
	          formData['quantity_' + paramCount] = 0;
	          paramCount++;
	        }
	      }
	
	      checkout_helper.ajax_update_state({
	        url: '/order-quantity-update',
	        method: "POST",
	        data: formData,
	        page: typeof checkoutPage === "undefined" ? "" : checkoutPage,
	        error_container: $('#contractErrContainer'),
	        done: function done(data, textStatus, jqXHR, options) {
	          try {
	            var response_obj = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : JSON.parse(data);
	            if (response_obj.error && response_obj.error.application.indexOf(messages.EMPTY_CART) == 0) {
	              document.location.href = "/CheckoutCartView";
	            } else {
	              COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	            }
	          } catch (e) {
	            console.error(e);
	          }
	        },
	        ajax_replace_content: function ajax_replace_content(response_obj, mergedOptions, defaultOptions) {
	          if (response_obj.metadata && response_obj.metadata.quantityUpdatedForCashCardPaymentErr) {
	            response_obj.error.application.push(response_obj.metadata.quantityUpdatedForCashCardPaymentErr);
	            $('#single-page-checkout #cc-payment-block').attr('do-not-show', false);
	          }
	          defaultOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
	        },
	        ajax_update_post_done: function ajax_update_post_done(response_obj, mergedOptions, defaultOptions) {
	          // Refresh the cart icon's number to reflect the adjusted quantity.
	          COSTCO.Header.miniShopCartRefresh();
	          $('#ShopCartForm input[name=ajaxFlag]').val(false);
	          COSTCO.OrderItems.init();
	          if (typeof COSTCO.CreditCard !== 'undefined') {
	            COSTCO.CreditCard.initComplete = false;
	            COSTCO.CreditCard.init();
	          }
	
	          // add ada message, after the quantity is updated
	          var estimatedTotalLabel = void 0;
	
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	            estimatedTotalLabel = $('.estimated-total-label');
	            if (!COSTCO.util.isBusinessDelivery()) {
	              COSTCO.OrderItems.setDeliveryDateView();
	            }
	          } else {
	            estimatedTotalLabel = $('#estimated-total-label');
	          }
	
	          var estimatedTotalValue = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && checkoutPage === 'review' ? $('.surchargeOrderTotal') : $('#order-estimated-total');
	          if (estimatedTotalLabel.length > 0 && estimatedTotalValue.length > 0) {
	            checkout_helper.addScreenReaderAnnouncement(estimatedTotalLabel.html() + ' ' + estimatedTotalValue.html());
	          }
	        },
	        always: function always() {
	          COSTCO.Checkout.ajax_update_default_always();
	          if (typeof TokenGateway != 'undefined') {
	            TokenGateway.refreshGateway();
	          }
	          COSTCO.OrderItems.popovers();
	        }
	      });
	    },
	
	    changeProtectionPlanQuantityValue: function changeProtectionPlanQuantityValue(quantityId, isIncrement) {
	
	      var value = $(quantityId).val();
	      if (isIncrement === true) {
	        value++;
	      } else {
	        value--;
	      }
	
	      COSTCO.OrderItems.validateProtectionPlanQuantity(quantityId, value);
	    },
	
	    validateProtectionPlanQuantity: function validateProtectionPlanQuantity(quantityId, value) {
	
	      var errorPlacement = function errorPlacement(error, element) {
	        error.insertAfter($(element).parent());
	      };
	
	      COSTCO.OrderItems.validate.call($(quantityId), COSTCO.OrderItems.updateProtectionPlanQuantity(quantityId, value), 'protectionPlanQuantity', errorPlacement);
	    },
	
	    updateProtectionPlanQuantity: function updateProtectionPlanQuantity(quantityId, value) {
	
	      var parentOrderItemQty = $(quantityId).closest('.order-item').find('input[id^="quantity_"]').val();
	      var parentOrderItemQtyNumber = parseInt(parentOrderItemQty);
	
	      if (value <= parentOrderItemQtyNumber && value > 0) {
	        $(quantityId).val(value);
	      } else {
	        $(quantityId).val(1);
	      }
	    },
	
	    toggleAgeRestrictionDeliveryTermsCheckbox: function toggleAgeRestrictionDeliveryTermsCheckbox(nameOfRestriction) {
	      var orderId = $('[name=orderId]').val();
	      var checkmarkObject = nameOfRestriction === 'ALCOHOL_RESTRICTION' ? $('#alcoholTerms') : $('#tobaccoTerms');
	      var checkmark = checkmarkObject.is(':checked');
	      var name = nameOfRestriction;
	
	      var data = [{
	        name: "orderId",
	        value: orderId || ""
	      }, {
	        name: "checkmark",
	        value: checkmark
	      }, {
	        name: "name",
	        value: name
	      }];
	
	      $.ajax({
	        url: '/AjaxAgeRestrictionDeliveryTermsCheckCmd',
	        method: 'POST',
	        data: data,
	        timeout: 150000
	      }).done(function () {
	        console.log('Age Restriction Checkbox Updated Successfully ');
	      }).fail(function () {
	        console.log('Error Updating Age Restriction Checkbox ');
	      });
	    },
	
	    /**
	     * [date_picker_scheduler description]
	     * @return {[type]} [description]
	     */
	    date_picker_scheduler: function date_picker_scheduler(shipModeId) {
	      var orderItems = COSTCO.OrderItems,
	          langId = COSTCO.util.getLangId();
	      var shipCode = $(this).data('shipcode');
	      $('.delivery-option-radios[data-orderitem=' + orderItemId + '] .pad input').prop('checked', true);
	
	      if ($(this).hasClass('datepicker-initialized')) $(this).removeClass('datepicker-initialized');
	
	      if (typeof orderItems.ship_dates[orderItemId] == "undefined" || !$(this).hasClass('datepicker-initialized')) {
	        var dateList = $(this).data('datelist').replace(/^\[(.+)\]$/, '$1').split(',');
	        var shipDates = [];
	        for (i = 0; i < dateList.length; i++) {
	          shipDates[i] = COSTCO.util.convertDateToTimestamp(dateList[i]);
	        }
	        var commonDate = $(this).data('commondate').split('-');
	        var orderItemId = $(this).data('orderitem');
	        var currentId = "scheduler_picker_" + orderItemId + "_" + shipModeId + "_" + shipCode;
	        orderItems.ship_dates[orderItemId] = shipDates.map(function (date_str) {
	          return {
	            date_obj: new Date(date_str),
	            date_str: date_str
	          };
	        });
	
	        //Fixing datepicker for ADA users to pick only available  dates
	        var enabledDates = function enabledDates() {
	          var availableDates = [];
	          orderItems.ship_dates[orderItemId].forEach(function (allowed_obj) {
	            if (allowed_obj.date_str) {
	              var date = new Date(allowed_obj.date_obj);
	              var timeZoneCorrectDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
	              // East of GMT
	              if (date.getTimezoneOffset() < 0) {
	                timeZoneCorrectDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
	              }
	              var formattedDate = timeZoneCorrectDate.toJSON().split("T")[0];
	              var availableFormattedDate = formattedDate.split('-')[1] + '/' + formattedDate.split('-')[2] + '/' + formattedDate.split('-')[0];
	              availableDates.push(availableFormattedDate);
	            }
	          });
	          return availableDates;
	        };
	
	        if (COSTCO.util.isCAStore() && langId === "-25" && null !== document.getElementById('for-Canada_' + currentId)) {
	          var selectedDate = $(this).data('selecteddate');
	          var dateInDisplay = $(this).data('datetodisplay');
	          if (undefined !== selectedDate && selectedDate !== "") {
	            commonDate = selectedDate.split('-');
	          }
	          document.getElementById(currentId).setAttribute("value", "");
	          var labelElement = document.getElementById('for-Canada_' + currentId);
	          labelElement.innerHTML = dateInDisplay;
	          $('#for-Canada_' + currentId).removeClass('hidden');
	        }
	        $("#scheduler_picker_" + orderItemId + "_" + shipModeId + "_" + shipCode).datepicker({
	          autoclose: true,
	          defaultViewDate: { year: commonDate[0], month: commonDate[1] - 1, day: commonDate[2] },
	          orientation: "auto right",
	          format: wcs.langId === '-25' ? 'DD. d MM, yyyy' : 'DD, MM d, yyyy',
	          language: wcs.langId === '-25' ? 'fr' : 'en',
	          showOnFocus: false,
	          datesEnabled: enabledDates()
	        }).on('changeDate', function (e) {
	          var full_date = e.date;
	          var dateVal = full_date.getDate();
	          var month = full_date.getMonth() + 1;
	          var year = full_date.getFullYear();
	          var day = full_date.getDay();
	          var formatMonth = month < 10 ? '0' + month : month;
	          var formatDay = dateVal < 10 ? '0' + dateVal : dateVal;
	          var dateFormatted = year + '-' + formatMonth + '-' + formatDay;
	          var shipCode = $(this).data('shipcode');
	          var orderItemId = $(this).data('orderitem');
	          var dateList = $(this).data('datelist').replace(/^\[(.+)\]$/, '$1').split(',');
	          var item = 'scheduler_picker_' + orderItemId + "_" + shipModeId + "_" + shipCode;
	          if (!dateList.includes(dateFormatted)) {
	            $('#' + item.trim() + '_dateError').removeClass('hidden');
	            $('#' + item.trim()).addClass('error');
	            $('#' + item.trim() + '_labelAlign').addClass('cart-calendar-label');
	            $('#scheduledDeliveryDateInvalid').val(true);
	            $('.calendar-label-active-field').addClass('hidden');
	          } else {
	            $('.calendar-label-active-field').addClass('hidden');
	            $('.cart-calender-label-align').removeClass('hidden');
	            $('.date-input-field').removeClass("error");
	            $('.select-delivery-date').addClass("hidden");
	            $('#noDeliveryDate').val(false);
	            $('.error-date-availability').addClass('hidden');
	            $('.cart-calender-label-align').removeClass('cart-calendar-label');
	            $('#scheduledDeliveryDateInvalid').val(false);
	            if ($(this).data('timeslot') !== "") {
	              $('#' + currentId + '_timeslot').removeClass('hidden');
	            }
	            // The change event needs the date string to pass to the server.
	
	            var date_str = "",
	                selected_date = e.currentTarget.value;
	            var requiredKeys = $('#orderitemAndShipModeList').val();
	            if (COSTCO.util.isCAStore() && langId === "-25") {
	              document.getElementById(currentId).setAttribute('data-selecteddate', dateFormatted);
	              document.getElementById(currentId).setAttribute('data-datetodisplay', COSTCO.EDDService.getDateFormattedToDisplay(dateFormatted));
	            }
	            var data = {
	              selectedMonth: month,
	              selectedDay: day,
	              selectedYear: year,
	              selectedTimeSlot: $(this).data('timeslot'),
	              selectedDate: dateVal,
	              selectedDeliveryDate: selected_date,
	              orderItemId: orderItemId,
	              listOfEddorderItems: $('#listOfEddItems').val(),
	              currentPage: checkoutPage,
	              requiredKeys: requiredKeys,
	              currentId: currentId,
	              dateFormatted: dateFormatted,
	              listOfFulfilledOrderIds: $(this).data('fulfilledorders'),
	              mode: 'SELECTED'
	            };
	
	            //Ajax call to update the user selected date against all items and repaint the content to cart/review page
	            COSTCO.OrderItems.ajaxCalendarDataUpdate(data);
	          }
	        });
	        $("#scheduler_picker_" + orderItemId + "_" + shipModeId + "_" + shipCode).datepicker('show');
	        $("#scheduler_picker_" + orderItemId + "_" + shipModeId + "_" + shipCode).addClass('datepicker-initialized');
	      }
	    },
	    /**
	     * Method to get the selected date and timeslot and call the ajax to save this to DB
	     */
	    saveSelectedDate: function saveSelectedDate() {
	
	      $('.calendar-time-slot-error').addClass('hidden');
	      $('#scheduledDeliveryDateInvalid').val(false);
	      $('.time-slot-span').removeClass('time-slot-span-border');
	      var date;
	      if (undefined !== $(this).data('selecteddate')) {
	        date = $(this).data('selecteddate').split('-');
	      }
	      var selectedYear = date[0];
	      var selectedDate = date[2];
	      var selectedMonth = date[1];
	      var data = {
	        selectedMonth: selectedMonth,
	        selectedYear: selectedYear,
	        selectedTimeSlot: $('input[name="userTimeSlot"]:checked').val(),
	        selectedDate: selectedDate,
	        selectedDeliveryDate: $(this).data('selecteddate'),
	        orderItemId: $(this).data('orderitem'),
	        listOfEddorderItems: $('#listOfEddItems').val(),
	        listOfFulfilledOrderIds: $(this).data('fulfilledorders'),
	        currentPage: checkoutPage
	      };
	      COSTCO.OrderItems.ajaxCalendarDataUpdate(data);
	    },
	
	    populateMeasurementGuidesCheckboxes: function populateMeasurementGuidesCheckboxes() {
	      var array = [];
	      array = JSON.parse(sessionStorage.getItem('measurementCheckboxes'));
	
	      $(array).each(function (i, obj) {
	        $('.' + obj.id).prop('checked', obj.checked);
	      });
	    },
	
	    saveMeasurementGuidesCheckboxesStates: function saveMeasurementGuidesCheckboxesStates() {
	      var measurmentCheckboxs = [];
	      $('input[id^="measuring-guides-checkbox-"]').each(function (i, value) {
	
	        var measurmentCheckbox = new Object();
	        measurmentCheckbox.id = value.id;
	        measurmentCheckbox.checked = value.checked;
	        measurmentCheckboxs.push(measurmentCheckbox);
	      });
	      if (measurmentCheckboxs.length != 0) {
	        sessionStorage.setItem('measurementCheckboxes', JSON.stringify(measurmentCheckboxs));
	      }
	    },
	
	    /**
	     * Measurement Guidelines
	     */
	    validateMeasurementGuidesEligibility: function validateMeasurementGuidesEligibility() {
	      var isValid = true;
	      $("#ShopCartForm .measuring-guides-checkbox").each(function () {
	        var isValidEachInput = $(this).is(":checked");
	        if (isValidEachInput) {
	          OrderItems.unhighlightMeasuringError(this);
	        } else {
	          isValid = false;
	          OrderItems.highlightMeasuringError(this);
	        }
	      });
	
	      return isValid;
	    },
	
	    highlightMeasuringError: function highlightMeasuringError(element) {
	      $(element).closest('.measuring-guides-warning').removeClass('warning').addClass('critical-notification').css('margin-bottom', '5px');
	      $(element).attr('aria-invalid', 'true');
	      $(element).trigger("focus");
	      $(element).closest('.measuring-guides-container').find('#' + element.id + '-error').remove();
	      $(element).closest('.measuring-guides-container').append('<div id="' + element.id + '-error" class="error" role="alert">' + messages.MEASUREMENT_GUIDES_CHECK_ERROR + '</label>');
	      $('#' + element.id + '-error').css({ 'font-size': '14px', 'font-weight': '700' });
	      $(element)[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
	    },
	
	    unhighlightMeasuringError: function unhighlightMeasuringError(element) {
	      $(element).attr('aria-invalid', 'false');
	      $(element).closest('.measuring-guides-warning').removeClass('critical-notification').addClass('warning').css('margin-bottom', '5px');
	      $(element).closest('.measuring-guides-container').find('#' + element.id + '-error').remove();
	    },
	
	    disableShipMethodCode: function disableShipMethodCode(element) {
	      $(element).hide();
	    },
	
	    selectCorrectShipMode: function selectCorrectShipMode(orderItemId, element) {
	      var selectShipMode = COSTCO.util.messageFormat(COSTCO.OrderItems.shipMethodSelector, orderItemId, element.shipModeId);
	      var checkboxSelection = $(selectShipMode).find("INPUT.shipModeId")[0];
	      var shipModeToSelect = $(selectShipMode);
	      $(checkboxSelection).prop("checked", true);
	      var elemOrderItem = $(shipModeToSelect).attr("data-orderitem");
	      COSTCO.OrderItems.update_shipmode.call($(shipModeToSelect), $(shipModeToSelect).attr("data-shipmodeid"), elemOrderItem, undefined, true);
	    },
	
	    //refresh header with new delivery method eligible items
	    refreshHeader: function refreshHeader(userSelectionDeliveryMethod) {
	
	      userSelectionDeliveryMethod = userSelectionDeliveryMethod.charAt(0).toUpperCase() + userSelectionDeliveryMethod.slice(1);
	
	      var makeAjaxCall = true;
	      var currentDeliveryMethod = $('#bdaddrtype').text();
	      if (currentDeliveryMethod.includes(userSelectionDeliveryMethod)) {
	        makeAjaxCall = false;
	      }
	      if (makeAjaxCall) {
	        var postData = [{
	          name: "storeId",
	          value: wcs.storeId || ""
	        }, {
	          name: "catalogId",
	          value: wcs.catalogId || ""
	        }, {
	          name: "langId",
	          value: wcs.langId || ""
	        }, {
	          name: "zipCodeFormDeliveryZipCode",
	          value: $.cookie('WC_BD_ZIP') || ""
	        }, {
	          name: "currentZipCode",
	          value: $.cookie('WC_BD_ZIP') || ""
	        }, {
	          name: "userSelectionDeliveryMethod",
	          value: userSelectionDeliveryMethod || ""
	        }, {
	          name: "checkoutPage",
	          value: "cart"
	        }, {
	          name: "isInitiatedFromChangeAddressType",
	          value: "true"
	        }];
	        $.ajax({
	          url: '/AjaxBusinessDeliveryBrowse',
	          type: 'POST',
	          data: postData,
	          dataType: 'json',
	          success: function success(data, textStatus, xhr) {
	            if (data.errorCode) {
	              if (data.errorCode == 2510) {
	                // session timeout
	                document.location.href = 'Logoff?URL=ReLogonFormView&storeId=' + wcs.storeId;
	                return;
	              }
	            } else {
	              // BD only: Update WC_BD_LOC cookie if ZIP is set/changed
	              if (COSTCO.util.isBusinessDelivery() && data.zipCodeBDCookieSet) {
	                if ($('#isGeocodeService').val() != "true") {
	                  COSTCO.util.callBingAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
	                } else {
	                  COSTCO.util.callGeocodeApiAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
	                }
	                window.location.href = "/CheckoutCartView";
	              }
	            }
	          },
	          error: function error(xhr, textStatus, errorThrown) {
	            COSTCO.zipCodeModal.ajaxCallErrorLog(xhr, textStatus, errorThrown, true);
	          }
	        });
	      }
	    },
	    /**
	     * This method is called from JSP when shipmode swiches to pickup. Fetches OMS inventory, calls wcs to update the latest data into DB. 
	     * @param - ordItemId
	     * @param - isSwitchToPickUp
	     */
	    updateShipModeToPickUp: function updateShipModeToPickUp(isSwitchToPickUp) {
	      try {
	        if (checkoutPage === 'cart' || checkoutPage === 'review') {
	          var requestJson = $('#pickUpRequestJson').val();
	          if (requestJson !== undefined && null !== requestJson && requestJson.length > 0) {
	            var costcoEnv = $('#costcoEnvironmentForEDD').val();
	            if (costcoEnv == "") {
	              costcoEnv = 'ECOM';
	            } else if (costcoEnv == "DEV") {
	              costcoEnv = 'QA3';
	            }
	            var clientIdentifier = $('#apigeeClientIdentifierHeader').val();
	            var costcoService = "restInventory";
	
	            var apiHeader = {
	              "costco.env": costcoEnv,
	              "client-identifier": clientIdentifier,
	              "costco.service": costcoService
	            };
	            var requestJsonList = JSON.parse(decodeURIComponent(requestJson));
	            var hasPickUpServiceError = false;
	            var pickUpApi = $('#pickUpAPIURL').val();
	            var respJson;
	            var requestObj = {};
	            for (var i = 0; i < requestJsonList.length; i++) {
	              var reqparams = requestJsonList[i];
	              if (reqparams != undefined && reqparams != null && reqparams != '' && (reqparams.itemAddedForPickUp || isSwitchToPickUp) || reqparams.ltlFeatureFlag && (reqparams.ltlpickupfrompdp || reqparams.ltlPickUpOnlyItem || reqparams.ltlPickUpItem && !reqparams.whsEnabled)) {
	                if (!reqparams.siteControlledOnlyItem || reqparams.eddItem) {
	                  /** Call PickUp API If Item is UseWarehouseInevntory or ShipToWarehouse tagged LocationControlled or Edd Enabled */
	                  var pickUpUrl = pickUpApi + "/" + reqparams.partNumber + "?quantity=" + reqparams.quantity + "&selectedWarehouse=" + reqparams.selectedWarehouse + "&shippingCodes=" + reqparams.shipCode + "&action=" + reqparams.action;
	                  respJson = COSTCO.OrderItems.invokePickUpAPI(pickUpUrl, apiHeader);
	                  if (respJson != undefined && respJson != null && respJson != '') {
	                    respJson.siteInventory = reqparams.siteInventory;
	                    respJson.siteControlledOnlyItem = reqparams.siteControlledOnlyItem;
	                    respJson.locationControlledItem = reqparams.locationControlledItem;
	                    respJson.shipToWarehouseItem = reqparams.shipToWarehouseItem;
	                    respJson.quantity = reqparams.quantity;
	                    respJson.ltlpickupfrompdp = reqparams.ltlpickupfrompdp;
	                    requestObj['orderItemId_' + reqparams.orderItemId] = respJson;
	                  } else if (!hasPickUpServiceError) {
	                    /** Display PickUp Unavailable API Service error when API response is blank */
	                    hasPickUpServiceError = true;
	                    $('#pickUp-unAvailable-' + reqparams.orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW_UNAVAILABLE);
	                    $('#pickUp-tooltip-' + reqparams.orderItemId).html('');
	                    $('#pickUp-memberOnly-' + reqparams.orderItemId).html('');
	                    $('#mdo-pickUp-memberOnly-' + reqparams.orderItemId).html('');
	                    $('#mdo-pickUp-memberOnly-' + reqparams.orderItemId).html('');
	                    $('#ship-mode-radio-warehouse-pickup_' + reqparams.orderItemId).parent().find('input[type=radio]').attr('disabled', true);
	                    $('#ship-mode-radio-warehouse-pickup_' + reqparams.orderItemId).parent().find('input[type=radio]').removeAttr('checked');
	                    $('#ship-mode-radio-ltl-pickup_' + reqparams.orderItemId).parent().find('input[type=radio]').removeAttr('checked');
	                    $('#ship-mode-radio-ltl-pickup_' + reqparams.orderItemId).parent().find('input[type=radio]').attr('disabled', true);
	                  }
	                } else {
	                  /** Setting required data to render PickUp molecule for Site controlled only item with out EDD */
	                  respJson = {
	                    "itemNumber": reqparams.partNumber,
	                    "quantity": reqparams.quantity,
	                    "eddItem": reqparams.eddItem,
	                    "siteControlledOnlyItem": reqparams.siteControlledOnlyItem,
	                    "locationControlledItem": reqparams.locationControlledItem,
	                    "siteInventory": reqparams.siteInventory,
	                    "shipToWarehouseItem": reqparams.shipToWarehouseItem
	                  };
	                  requestObj['siteControlled_' + reqparams.orderItemId] = respJson;
	                }
	              }
	            }
	
	            if (requestObj != undefined && requestObj != null) {
	              /** Set PickUp API response and other WCS attributes to hidden for using it during shipmode switch. */
	              $('#pickUpAPIResponses').val(JSON.stringify(requestObj));
	              if (!isSwitchToPickUp) {
	                /** Calling functions to display pickUp molecule and call AjaxPickUpWarehouseUpdateCmd */
	                COSTCO.OrderItems.repaintPickUpMolecule(requestObj, isSwitchToPickUp, false);
	                COSTCO.OrderItems.callWarehousePickUpCmd(requestObj, hasPickUpServiceError);
	              }
	            }
	            if (!isSwitchToPickUp) {
	              /** Display global alerts and errors */
	              COSTCO.OrderItems.displayGlobalPickUpAlerts(hasPickUpServiceError, isSwitchToPickUp);
	            }
	          }
	        }
	      } catch (err) {
	        console.log('Apigee Responses Exception Occured Due to ' + err);
	      }
	    },
	
	    /**
	     * Invokes Pickup API
	     */
	    invokePickUpAPI: function invokePickUpAPI(pickUpUrl, apiHeader) {
	      var responseJson;
	      try {
	        $.ajax({
	          url: pickUpUrl,
	          type: 'GET',
	          headers: apiHeader,
	          dataType: 'json',
	          async: false,
	          success: function success(data) {
	            responseJson = data;
	          },
	          error: function error(data) {
	            responseJson = data;
	          }
	        });
	      } catch (e) {
	        console.error(e);
	      }
	      return responseJson;
	    },
	
	    /**
	     * Invokes MDM API
	     */
	    invokeMdmAPI: function invokeMdmAPI(clientIdentifier, ltlPickupLocValue) {
	      var mdmApiURL = $('#mdoMdmApiFrontend').val();
	      var apiHeader = {
	        "client-identifier": clientIdentifier
	      };
	      var constructURL = mdmApiURL + "/" + ltlPickupLocValue + ".json";
	      var responseJson;
	      try {
	        $.ajax({
	          url: constructURL,
	          type: 'GET',
	          headers: apiHeader,
	          dataType: 'json',
	          async: false,
	          success: function success(data) {
	            responseJson = data;
	            if (data && $.isEmptyObject(data)) {
	              responseJson = false;
	            }
	          },
	          error: function error(data) {
	            responseJson = false;
	          }
	        });
	      } catch (e) {
	        console.error(e);
	      }
	
	      return responseJson;
	    },
	
	    /**
	     * Parse Hours and Holidays MDM API Response 
	     */
	    parseMdmApiHoursAndHolidays: function parseMdmApiHoursAndHolidays(responseJson, orderItemId, isltlPickupItemSelected) {
	      var doNotshowPickupHours = false;
	      var pickupMdmHoursMixedCart;
	      if (checkoutPage === 'review') {
	        if ($(".mdo-mixed-cart").is(':visible')) {
	          pickupMdmHoursMixedCart = $("#show-mdoApi-pickUp-hours-" + orderItemId + "mixedCart");
	          pickupMdmHoursMixedCart.empty();
	          doNotshowPickupHours = true;
	        }
	      }
	      // Check if mdoLocation is present
	      if (responseJson.mdoLocation) {
	        // Check if name is present
	        if (responseJson.mdoLocation.name) {
	          COSTCO.OrderItems.formatAddress(responseJson);
	        }
	        // Check if hours are present
	        var pickupMdmHours = $("#show-mdoApi-pickUp-hours-" + orderItemId);
	        if (responseJson.mdoLocation.hours != null && responseJson.mdoLocation.hours != undefined && responseJson.mdoLocation.hours.length > 0) {
	          pickupMdmHours.empty();
	          responseJson.mdoLocation.hours.forEach(function (entry) {
	            var title = entry.title[0].value;
	            var openTime = entry.open ? COSTCO.OrderItems.formatTime(entry.open) : "Closed";
	            var closeTime = entry.close ? COSTCO.OrderItems.formatTime(entry.close) : "";
	            var showPickupMdmHours;
	            if (entry.hoursType.code === "open" && openTime && closeTime) {
	              showPickupMdmHours = title + " " + openTime + " to " + closeTime;
	            } else if (entry.hoursType.code === "closed") {
	              showPickupMdmHours = title + " Closed";
	            } else if (entry.hoursType.code === "close" && openTime && closeTime) {
	              showPickupMdmHours = title + " Closed";
	            }
	            // Append a new <span> with the text content to the container
	            if (showPickupMdmHours) {
	              // Create a new <span> element
	              var createWorkDaysSpan = $("<span style = 'color: #5F5F5F; font-size: 12px;font-style: normal;font-weight: 400;line-height: 20px;'></span>").text(showPickupMdmHours);
	              if (doNotshowPickupHours == true && doNotshowPickupHours != undefined) {
	                if (pickupMdmHoursMixedCart !== undefined) {
	                  pickupMdmHoursMixedCart.append(createWorkDaysSpan);
	                  if (isltlPickupItemSelected) {
	                    $("#show-mdoApi-pickUp-hours-label-" + orderItemId).empty();
	                  }
	                }
	                if (!isltlPickupItemSelected) {
	                  pickupMdmHours.append(createWorkDaysSpan.clone());
	                }
	              } else {
	                pickupMdmHours.append(createWorkDaysSpan);
	              }
	            }
	          });
	        }
	        /** Show Fallback When MDM API is down  */
	        else if (responseJson.mdoLocation.hours == null || responseJson.mdoLocation.hours == undefined || responseJson.mdoLocation.hours.length == 0) {
	            $('#mdmFailHoursText-' + orderItemId).removeClass('hidden');
	            $('#mdm-edd-fails-' + orderItemId).removeClass('hidden');
	          }
	
	        // Check if holidays are present
	        if (responseJson.mdoLocation.holidays) {
	          responseJson.mdoLocation.holidays.forEach(function (holiday) {
	            var holidayName = holiday.name[0].value;
	            var holidayHoursType = holiday.holidayHoursType.code;
	            var holidayopenTime = holiday.hour && holiday.hour.open ? COSTCO.OrderItems.formatTime(holiday.hour.open) : "";
	            var holidaycloseTime = holiday.hour && holiday.hour.close ? COSTCO.OrderItems.formatTime(holiday.hour.close) : "";
	            var showPickupMdmHours = void 0;
	            if (holidayHoursType === "closed") {
	              showHolidayPickupMdmHours = holidayName + " Closed";
	            } else if (holidayopenTime != "" && holidaycloseTime != "") {
	              showHolidayPickupMdmHours = holidayName + " " + " " + holidayopenTime + " to " + holidaycloseTime;
	            } else if (holidayHoursType === "open") {
	              showHolidayPickupMdmHours = holidayName + " Open";
	            }
	            // Append a new <span>
	            var createHolidayDaysSpan = $("<span style = 'color: #5F5F5F; font-size: 12px;font-style: normal;font-weight: 400;line-height: 20px;'></span>").text(showHolidayPickupMdmHours);
	            if (doNotshowPickupHours == true && doNotshowPickupHours != undefined) {
	              if (pickupMdmHoursMixedCart !== undefined) {
	                pickupMdmHoursMixedCart.append(createHolidayDaysSpan);
	                $("#show-mdoApi-pickUp-hours-label-" + orderItemId).empty();
	              }
	              if (!isltlPickupItemSelected) {
	                pickupMdmHours.append(createHolidayDaysSpan.clone());
	                $("#show-mdoApi-pickUp-hours-label-" + orderItemId).html(messages.ORD_MARKET_DISTRIBUTION_MDO_HOURS);
	              }
	            } else {
	              pickupMdmHours.append(createHolidayDaysSpan);
	            }
	          });
	        }
	      } else {
	        console.log("mdoLocation is not present in the response.");
	      }
	    },
	    /**
	     * Format time from MDM API into 12 hours clock
	     */
	    formatTime: function formatTime(mdmapitime) {
	      var _mdmapitime$split = mdmapitime.split(":"),
	          _mdmapitime$split2 = _slicedToArray(_mdmapitime$split, 2),
	          hours = _mdmapitime$split2[0],
	          minutes = _mdmapitime$split2[1];
	
	      var hoursInt = parseInt(hours);
	      var period = hoursInt >= 12 ? "PM" : "AM";
	      hoursInt = hoursInt % 12 || 12;
	      var formatedTime = hoursInt + ':' + minutes + period;
	      return formatedTime;
	    },
	    /**
	     * Format Adress from MDM API
	     */
	    formatAddress: function formatAddress(responseJson) {
	      if (responseJson.mdoLocation && responseJson.mdoLocation.address != null && responseJson.mdoLocation.address != undefined) {
	        var pickupMdmLoc = $(".mdoPickupLocClass");
	        pickupMdmLoc.empty();
	        var locationName = responseJson.mdoLocation.name[0].value.split(" ")[0];
	        var locationNameWithText = locationName + " Costco Distribution Center";
	        var address = responseJson.mdoLocation.address;
	        var line1 = address.line1;
	        var city = address.city.charAt(0) + address.city.slice(1).toLowerCase();
	        var state = address.territory;
	        var postalCode = address.postalCode;
	        var showaddress = void 0;
	        showaddress = locationNameWithText + "<br>" + line1 + "<br>" + city + ", " + state + " " + postalCode;
	        var createaddressDiv = $("<div style='color: #333333; font-size: 14px; font-style: normal; font-weight: 400; line-height: 20px !important;'></div>").html(showaddress);
	        pickupMdmLoc.append(createaddressDiv);
	      }
	    },
	
	    /**
	     * Method to call WCS command to update shipmode and inventory details.
	     * @param  {string} respObj
	     * @param  {string} isSwitchToPickUp
	     */
	    callWarehousePickUpCmd: function callWarehousePickUpCmd(respObj, hasPickUpServiceError) {
	      var mdmAPIResp = '';
	      try {
	        mdmAPIResp = $('#mdmApiResponses').val();
	        COSTCO.AjaxModular.ajax_update_state({
	          method: 'POST',
	          url: '/AjaxPickUpWarehouseUpdateCmd',
	          data: [{
	            name: "pickUpAPIResponses",
	            value: JSON.stringify(respObj)
	          }, {
	            name: "mdmApiResponses",
	            value: mdmAPIResp
	          }],
	          done: function done(data, textStatus, jqXHR, options) {
	            console.log("Pickup API details updated to Backend");
	          }
	        });
	      } catch (e) {
	        console.error(e);
	      }
	    },
	
	    /**
	     * Method to display PickUp molecule details
	     */
	    repaintPickUpMolecule: function repaintPickUpMolecule(respObj, isSwitchToPickUp, shipModeSwitch, isSwitchToDelivery, updatedOrderItemId) {
	      if (respObj != undefined && respObj != null) {
	        var keys = Object.keys(respObj);
	        var mdmApiResponJson;
	        var triggerMdmApiOnce = 1;
	        var clientIdentifier = $('#wh_DetailParam_ClientId').val();
	        for (var i = 0; i < keys.length; i++) {
	          var key = keys[i];
	          var request = {};
	          var respJson = respObj[key];
	          if (key.indexOf('orderItemId_') !== -1) {
	            var orderItemId = key.split('orderItemId_')[1];
	            var isBopiwItem = false;
	            var isStwItem = false;
	            var isMdoItem = false;
	            var isSiteControlledOnly = respJson.siteControlledOnlyItem != undefined && respJson.siteControlledOnlyItem != null && respJson.siteControlledOnlyItem;
	            var stw = respJson.shipToWarehouse;
	            var isSiteControlledAndMdoitem = false;
	            var ltlPickUpNode = respJson.warehouseAvailability.ltlPickUp;
	            var wioError = $('[id^=error_pickup_wio_disabled_' + orderItemId + ']');
	            var quantity = COSTCO.OrderItems.getOrderItemQuantity(orderItemId, respJson.quantity, isSwitchToPickUp);
	            var _isltlPickupItemSelected = $('#ship-mode-radio-ltl-pickup_' + orderItemId).parent().find('input[type=radio]').attr('checked');
	            if (respJson.warehouseAvailability != undefined && respJson.warehouseAvailability != null && !isSiteControlledOnly) {
	              /** Parse PickUp API Response and see if Items is BOPIW eligible then render PickUP molecule for BOPIW. */
	              var bopiw = respJson.warehouseAvailability.useWarehouseInventory;
	              var mdoAddedFromPdp = respJson.ltlpickupfrompdp;
	              if (isSwitchToDelivery && orderItemId == updatedOrderItemId) {
	                $('#pick_up_text_' + orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
	              } else {
	                $('#pick_up_text_' + orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_STW);
	              }
	              if (bopiw != undefined && bopiw != null && bopiw.buyable != undefined && bopiw.buyable != null && bopiw.buyable && quantity <= bopiw.maxUnitsAvailable && wioError != undefined && wioError.length < 1) {
	                /** Display PBOPIW PickUp molecule when Buyable True and Max units available >= requested quantity */
	                isBopiwItem = true;
	                $('#pickUpLabel-' + orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
	                $('#pick_up_text_' + orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
	                var pickupDate = COSTCO.OrderItems.checkEDT(bopiw.orderPickup);
	                $('#pickUp-edd-' + orderItemId).html(pickupDate);
	                if (pickupDate == messages.ORD_WAREHOUSE_EDT_TODAY_BOPIW) {
	                  $('#pickUp-edd-hours-' + orderItemId).html(messages.ORD_WAREHOUSE_EDT_TODAY_BOPIW_HOURS);
	                }
	                $('#pickUp-edd-espot-' + orderItemId).addClass("hidden");
	                var oldEdd = $('#edtPickUp_' + orderItemId).val();
	                oldEdd = oldEdd != undefined && oldEdd != null && oldEdd != '' ? oldEdd : null;
	                var newEdd = bopiw.orderPickup != undefined && bopiw.orderPickup != null && bopiw.orderPickup != '' ? bopiw.orderPickup : null;
	                if (!isSwitchToPickUp && oldEdd != newEdd) {
	                  $('#orderDateChanged_' + orderItemId).removeClass("hidden");
	                }
	              } else if (!respJson.locationControlledItem && respJson.shipToWarehouseItem) {
	                var siteInventory = respJson.siteInventory;
	                if (siteInventory != undefined && siteInventory != null && siteInventory != '' && siteInventory) {
	                  /** When Items is BOPIW buyable false But its STW + SiteControlled and Site Inventory is available */
	                  isBopiwItem = true;
	                  COSTCO.OrderItems.showSTWPickUpEDD(orderItemId, stw, isSwitchToPickUp);
	                } else {
	                  /** Show PickUp unavailable error when BOPIW buyable false, and SiteInventory is unavailable  */
	                  COSTCO.OrderItems.showPickUpUnAvailable(orderItemId, shipModeSwitch);
	                }
	              }
	              if (ltlPickUpNode != undefined && ltlPickUpNode != null && ltlPickUpNode.buyable != undefined && ltlPickUpNode.buyable != null) {
	                //invoke mdm pickupapi to get open hours for the pickup location
	                var ltlPickupLoc = ltlPickUpNode.fulfillmentCenter;
	                var mdmApiResponJsonString = $('#mdmApiResponses').val();
	                if (mdmApiResponJsonString != "") {
	                  var jsonObject = JSON.parse(mdmApiResponJsonString);
	                  mdmApiResponJson = jsonObject;
	                }
	                /** Trigger MDM API when counter is 1 Once triggered make it increment  */
	                if (ltlPickupLoc != undefined && ltlPickupLoc.includes("-3pl") && triggerMdmApiOnce == 1) {
	                  var ltlPickupLocValue = ltlPickupLoc.split("-")[0];
	                  if (mdmApiResponJson == undefined || mdmApiResponJson.mdoLocation.mdoId != ltlPickupLocValue) {
	                    mdmApiResponJson = COSTCO.OrderItems.invokeMdmAPI(clientIdentifier, ltlPickupLocValue);
	                    triggerMdmApiOnce++;
	                  }
	                }
	                if (mdmApiResponJson != null && mdmApiResponJson != undefined && mdmApiResponJson != false) {
	                  $('#mdmApiResponses').val(JSON.stringify(mdmApiResponJson));
	                  COSTCO.OrderItems.parseMdmApiHoursAndHolidays(mdmApiResponJson, orderItemId, _isltlPickupItemSelected);
	                } else {
	                  /** Show Fallback When MDM API is down  */
	                  $('#mdmFailHoursText-' + orderItemId).removeClass('hidden');
	                  $('#mdm-edd-fails-' + orderItemId).removeClass('hidden');
	                  if (checkoutPage === 'review') {
	                    if ($(".mdo-mixed-cart").is(':visible')) {
	                      $("#show-mdoApi-pickUp-hours-label-" + orderItemId).empty();
	                    }
	                  }
	                }
	                if (ltlPickUpNode.buyable && quantity <= ltlPickUpNode.maxUnitsAvailable && wioError != undefined && wioError.length < 1) {
	                  isMdoItem = true;
	                  $('#mdoLabel-' + orderItemId).html(messages.ORD_MARKET_DELIVERY_LABEL_MDO);
	                  var pickupDate = COSTCO.OrderItems.checkEDT(ltlPickUpNode.orderPickup, true);
	                  if (mdmApiResponJson != null && mdmApiResponJson != undefined && mdmApiResponJson != false) {
	                    $('#mdo-pickUp-edd-' + orderItemId).html(messages.ORD_MARKET_DELIVERY_ESTIMATED_LABEL_MDO + " " + pickupDate);
	                  }
	                  $('#mdo-text-' + orderItemId).html(messages.ORD_MARKET_DISTRIBUTION_LABEL_MDO);
	                  var oldEdd = $('#mdoEdtPickUp_' + orderItemId).val();
	                  oldEdd = oldEdd != undefined && oldEdd != null && oldEdd != '' ? oldEdd : null;
	                  var newEdd = ltlPickUpNode.orderPickup != undefined && ltlPickUpNode.orderPickup != null && ltlPickUpNode.orderPickup != '' ? ltlPickUpNode.orderPickup : null;
	                  if (!isSwitchToPickUp && oldEdd != newEdd && $('[id^=ship-mode-radio-ltl-pickup_' + orderItemId + ']').length > 0) {
	                    $('#orderDateChanged_' + orderItemId).removeClass("hidden");
	                  }
	                } else {
	                  if (_isltlPickupItemSelected) {
	                    /** Show PickUp unavailable error when BOPIM buyable false */
	                    COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);
	                  }
	                }
	              } else if (ltlPickUpNode == undefined || ltlPickUpNode == null || ltlPickUpNode.buyable == undefined || ltlPickUpNode.buyable == null) {
	                /** isStwItem and isBopiwItem are default to false **/
	                if (isStwItem && isBopiwItem && _isltlPickupItemSelected) {
	                  /** Show PickUp unavailable error when BOPIM added from pdp and if ltlpickup json is null in response*/
	                  COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);
	                }
	              }
	            }
	            if (!isBopiwItem && !_isltlPickupItemSelected && respJson.shipToWarehouseItem && stw != undefined && stw != null && respJson.locationControlledItem) {
	              if (stw.availability != undefined && stw.availability != null && (stw.availability == 'INSTOCK' || stw.availability == 'LOWSTOCK')) {
	                /** Display pickup molecule when item is not eligible for BOPIW, But Shiptowarehouse available and its InStock or LowStock */
	                isStwItem = true;
	                COSTCO.OrderItems.showSTWPickUpEDD(orderItemId, stw, isSwitchToPickUp);
	              } else {
	                if (_isltlPickupItemSelected && !isMdoItem) {
	                  /** Show PickUp unavailable error when BOPIM buyable false, and ShipToWarehouse OOS  */
	                  COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);
	                } else {
	                  /** Show PickUp unavailable error when BOPIW buyable false, and ShipToWarehouse OOS  */
	                  $('#pick_up_text_' + orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
	                  COSTCO.OrderItems.showPickUpUnAvailable(orderItemId, shipModeSwitch);
	                }
	              }
	            }
	            /** to check if the item is site controlled with ltlpickup and mdopickup selected */
	            if (isSiteControlledOnly && ltlPickUpNode != undefined && ltlPickUpNode != null && ltlPickUpNode.buyable != undefined && ltlPickUpNode.buyable != null && isSiteControlledOnly) {
	              var ltlPickupLoc = ltlPickUpNode.fulfillmentCenter;
	              var mdmApiResponJsonString = $('#mdmApiResponses').val();
	              if (mdmApiResponJsonString != "") {
	                var jsonObject = JSON.parse(mdmApiResponJsonString);
	                mdmApiResponJson = jsonObject;
	              }
	              /** Trigger MDM API when counter is 1 Once triggered make it increment  */
	              if (ltlPickupLoc != undefined && ltlPickupLoc.includes("-3pl") && triggerMdmApiOnce == 1) {
	                var ltlPickupLocValue = ltlPickupLoc.split("-")[0];
	                if (mdmApiResponJson == undefined || mdmApiResponJson.mdoLocation.mdoId != ltlPickupLocValue) {
	                  mdmApiResponJson = COSTCO.OrderItems.invokeMdmAPI(clientIdentifier, ltlPickupLocValue);
	                  triggerMdmApiOnce++;
	                }
	              }
	              if (mdmApiResponJson != null && mdmApiResponJson != undefined && mdmApiResponJson != false) {
	                $('#mdmApiResponses').val(JSON.stringify(mdmApiResponJson));
	                COSTCO.OrderItems.parseMdmApiHoursAndHolidays(mdmApiResponJson, orderItemId, _isltlPickupItemSelected);
	              } else {
	                /** Show Fallback When MDM API is down  */
	                $('#mdmFailHoursText-' + orderItemId).removeClass('hidden');
	                $('#mdm-edd-fails-' + orderItemId).removeClass('hidden');
	                if (checkoutPage === 'review') {
	                  if ($(".mdo-mixed-cart").is(':visible')) {
	                    $("#show-mdoApi-pickUp-hours-label-" + orderItemId).empty();
	                  }
	                }
	              }
	              if (ltlPickUpNode.buyable && quantity <= ltlPickUpNode.maxUnitsAvailable && wioError != undefined && wioError.length < 1) {
	                isMdoItem = true;
	                $('#mdoLabel-' + orderItemId).html(messages.ORD_MARKET_DELIVERY_LABEL_MDO);
	                var pickupDate = COSTCO.OrderItems.checkEDT(ltlPickUpNode.orderPickup, true);
	                if (mdmApiResponJson != null && mdmApiResponJson != undefined && mdmApiResponJson != false) {
	                  $('#mdo-pickUp-edd-' + orderItemId).html(messages.ORD_MARKET_DELIVERY_ESTIMATED_LABEL_MDO + " " + pickupDate);
	                }
	                $('#mdo-text-' + orderItemId).html(messages.ORD_MARKET_DISTRIBUTION_LABEL_MDO);
	                var oldEdd = $('#mdoEdtPickUp_' + orderItemId).val();
	                oldEdd = oldEdd != undefined && oldEdd != null && oldEdd != '' ? oldEdd : null;
	                var newEdd = ltlPickUpNode.orderPickup != undefined && ltlPickUpNode.orderPickup != null && ltlPickUpNode.orderPickup != '' ? ltlPickUpNode.orderPickup : null;
	                if (!isSwitchToPickUp && oldEdd != newEdd && $('[id^=ship-mode-radio-ltl-pickup_' + orderItemId + ']').length > 0) {
	                  $('#orderDateChanged_' + orderItemId).removeClass("hidden");
	                }
	                if (isSiteControlledOnly && _isltlPickupItemSelected) {
	                  isSiteControlledAndMdoitem = true;
	                }
	              } else {
	                if (_isltlPickupItemSelected) {
	                  /** Show PickUp unavailable error when BOPIM buyable false */
	                  COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);
	                }
	              }
	            } else if (!_isltlPickupItemSelected && ltlPickUpNode != undefined && ltlPickUpNode.buyable != undefined && ltlPickUpNode.buyable) {
	              if ($('[id^=ship-mode-radio-ltl-pickup_' + orderItemId + ']').length > 0) {
	                var pickupDate = COSTCO.OrderItems.checkEDT(ltlPickUpNode.orderPickup, true);
	                if (mdmApiResponJson != null && mdmApiResponJson != undefined && mdmApiResponJson != false) {
	                  $('#mdo-pickUp-edd-' + orderItemId).html(messages.ORD_MARKET_DELIVERY_ESTIMATED_LABEL_MDO + " " + pickupDate);
	                }
	              }
	            } else if ((ltlPickUpNode == undefined || ltlPickUpNode == null || ltlPickUpNode.buyable == undefined || ltlPickUpNode.buyable == null) && _isltlPickupItemSelected) {
	              COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);
	            } else if (isSiteControlledOnly && !isSiteControlledAndMdoitem) {
	              var siteInventory = respJson.siteInventory;
	              if (siteInventory != undefined && siteInventory != null && siteInventory != '' && siteInventory) {
	                isStwItem = true;
	                /** Display pick up molecule as available when STW + SiteControlled Item when Site Inventory is available */
	                COSTCO.OrderItems.showSTWPickUpEDD(orderItemId, stw, isSwitchToPickUp);
	              } else {
	                /** Show PickUp unavailable error when BOPIW buyable false, and ShipToWarehouse OOS  */
	                COSTCO.OrderItems.showPickUpUnAvailable(orderItemId, shipModeSwitch);
	              }
	            }
	
	            if (!isMdoItem) {
	              if (_isltlPickupItemSelected && !isMdoItem) {
	                /** Show PickUp unavailable error when item is not satsfied for BOPIM PickUp Availability  */
	                COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);
	              }
	            }
	            if (!isBopiwItem && !isStwItem) {
	              /** Show PickUp unavailable error when item is not satsfied for BOPIW or STW PickUp Availability  */
	              if (!respJson.shipToWarehouseItem) {
	                $('#pick_up_text_' + orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
	              }
	              COSTCO.OrderItems.showPickUpUnAvailable(orderItemId, shipModeSwitch);
	            } else {
	              var whsActive = $('#warehouseActive_' + orderItemId).val();
	              if (whsActive === "true") {
	                $('#error_pickup_unavailable_' + orderItemId).addClass('hidden');
	              } else {
	                COSTCO.OrderItems.showPickUpUnAvailable(orderItemId, shipModeSwitch);
	              }
	            }
	          } else if (key.indexOf('siteControlled_') !== -1) {
	            /** This block executes when Item is STW + SiteControlled and no EDD */
	            var siteInventory = respJson.siteInventory;
	            var orderItemId = key.split('siteControlled_')[1];
	            if (shipModeSwitch) {
	              if (isSwitchToDelivery && orderItemId == updatedOrderItemId) {
	                $('#pick_up_text_' + orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
	              } else if (!isSwitchToDelivery && orderItemId == updatedOrderItemId) {
	                $('#pick_up_text_' + orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_STW);
	              }
	            } else {
	              $('#pick_up_text_' + orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_STW);
	            }
	
	            if (siteInventory != undefined && siteInventory != null && siteInventory != '' && siteInventory) {
	              /** Display PickUp molecule as available when site inventory is InStock */
	              COSTCO.OrderItems.showPickUpEDD(orderItemId, null, messages.EDD_ESTIMATED_PICKUP);
	              $('#ship-mode-radio-warehouse-pickup_' + orderItemId).parent().find('input[type=radio]').removeAttr('disabled');
	            } else {
	              if (isltlPickupItemSelected && !isMdoItem) {
	                /** Show Mdo PickUp available error when SiteInevntory is OOS */
	                COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);
	              } else {
	                /** Show PickUp unavalable error when SiteInevntory is OOS */
	                COSTCO.OrderItems.showPickUpUnAvailable(orderItemId, shipModeSwitch);
	              }
	            }
	          }
	        }
	      }
	      COSTCO.Header.popovers();
	    },
	
	    /**
	        * Method to format Date
	        */
	    checkEDT: function checkEDT(dateValue, showEddDate) {
	      var date = new Date(dateValue);
	      var splitDate = dateValue.split('-');
	      var year = splitDate[0];
	      var month = splitDate[1] - 1;
	      var day = splitDate[2];
	      var langId = COSTCO.util.getLangId();
	      var daysOfWeek = void 0;
	      var monthName = void 0;
	      var dateFormat = void 0;
	      var today = new Date();
	      var tomorrow = new Date();
	      var edt = "";
	      tomorrow.setDate(tomorrow.getDate() + 1);
	      showEddDate = showEddDate ? showEddDate : false;
	      if (!showEddDate) {
	        if (date.toDateString() === today.toDateString()) {
	          edt = messages.ORD_WAREHOUSE_EDT_TODAY_BOPIW;
	        } else if (date.toDateString() === tomorrow.toDateString()) {
	          edt = messages.ORD_WAREHOUSE_EDT_TOMORROW_BOPIW;
	        } else {
	          if (langId === '-25') {
	            edt = new Date(dateValue).toLocaleDateString('fr-CA', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
	          } else {
	            edt = new Date(dateValue).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
	          }
	        }
	      } else {
	        if (langId === '-25') {
	          edt = new Date(dateValue).toLocaleDateString('fr-CA', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
	        } else {
	          edt = new Date(dateValue).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
	        }
	      }
	      return edt;
	    },
	
	    /**
	     * Method to display PickUp EDD values in the PickUp molecule for STW items.
	     */
	    showSTWPickUpEDD: function showSTWPickUpEDD(orderItemId, stw, isSwitchToPickUp) {
	      var eddValue = null;
	      var oldEdd = $('#edtPickUp_' + orderItemId).val();
	      oldEdd = oldEdd != undefined && oldEdd != null && oldEdd != '' ? oldEdd : null;
	      var newEdd = stw != undefined && stw != null && stw.estimatedDeliveryDate != undefined && stw.estimatedDeliveryDate != null && stw.estimatedDeliveryDate != '' ? stw.estimatedDeliveryDate : null;
	      if (!isSwitchToPickUp && oldEdd != newEdd) {
	        $('#orderDateChanged_' + orderItemId).removeClass("hidden");
	      }
	      if (newEdd != null) {
	        eddValue = COSTCO.OrderItems.checkEDT(newEdd, true);
	      }
	      COSTCO.OrderItems.showPickUpEDD(orderItemId, eddValue, messages.EDD_ESTIMATED_PICKUP);
	    },
	
	    /**
	     * Method to display PickUp EDD values in the PickUp molecule.
	     */
	    showPickUpEDD: function showPickUpEDD(orderItemId, edd, pickUpLabel) {
	      if (edd != undefined && edd != null && edd != '') {
	        $('#pickUp-edd-' + orderItemId).html(edd);
	        $('#pickUp-edd-espot-' + orderItemId).addClass("hidden");
	      } else {
	        $('#pickUp-edd-' + orderItemId).addClass('hidden');
	        $('#pickUp-edd-espot-' + orderItemId).removeClass('hidden');
	      }
	      $('#pickUpLabel-' + orderItemId).html(pickUpLabel);
	      $('#carrier-details-' + orderItemId).removeClass('hidden');
	    },
	
	    /**
	     * Method to display pickup un-available error. 
	     */
	    showPickUpUnAvailable: function showPickUpUnAvailable(orderItemId, shipModeSwitch) {
	      var pickUpRadio = $('#ship-mode-radio-warehouse-pickup_' + orderItemId).parent().find('input[type=radio]');
	      if (!shipModeSwitch || pickUpRadio != undefined && pickUpRadio != null && pickUpRadio.is(':checked') && shipModeSwitch) {
	        $('#error_pickup_unavailable_' + orderItemId).removeClass("hidden");
	        $('#pickUp-unAvailable-' + orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW_UNAVAILABLE);
	        $('#pickUp-tooltip-' + orderItemId).html('');
	        $('#pickUp-memberOnly-' + orderItemId).html('');
	        $(pickUpRadio).attr('disabled', true);
	        $(pickUpRadio).removeAttr('checked');
	      }
	    },
	
	    /**
	     * Method to display mdo pickup unavailable
	     */
	    showMdoPickUpUnAvailable: function showMdoPickUpUnAvailable(orderItemId, shipModeSwitch) {
	      var pickUpRadio = $('#ship-mode-radio-ltl-pickup_' + orderItemId).parent().find('input[type=radio]');
	      if (!shipModeSwitch || pickUpRadio != undefined && pickUpRadio != null && pickUpRadio.is(':checked') && shipModeSwitch) {
	        $('#mdo_error_pickup_unavailable_' + orderItemId).removeClass("hidden");
	        var getProductlink = $('#mdo_product_link_' + orderItemId).val();
	        var getStoreText = $('#mdo_error_pickup_unavailable_' + orderItemId).html();
	        var storetextWithProductLink = getStoreText.replace('{0}', getProductlink);
	        $('#mdo_error_pickup_unavailable_' + orderItemId).html(storetextWithProductLink);
	        $('#mdo-pickUp-unAvailable-' + orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW_UNAVAILABLE);
	        $('#mdo-pickUp-tooltip-' + orderItemId).html('');
	        $('#mdo-pickUp-memberOnly-' + orderItemId).html('');
	        $('#mdoLabel-' + orderItemId).html('');
	        $('#mdo-pickUp-hours-' + orderItemId).html('');
	        $('#mdo-text-' + orderItemId).addClass("hidden");
	        $('#carrier-details-' + orderItemId).addClass("hidden");
	        $(pickUpRadio).attr('disabled', true);
	        $(pickUpRadio).removeAttr('checked');
	      }
	    },
	
	    /**
	     * Method to get orderitem level quantity 
	     */
	    getOrderItemQuantity: function getOrderItemQuantity(orderItemId, quantity, isSwitchToPickUp) {
	      var itemQuantity;
	      if (!isSwitchToPickUp) {
	        itemQuantity = quantity;
	      }
	
	      if (isSwitchToPickUp || itemQuantity == undefined || itemQuantity == null) {
	        var noOfItems = $('#order-items').find('.order-item').length;
	        var ordItemQuantity = {};
	        for (var i = 1; i <= noOfItems; i++) {
	          var ordItemId = $('#orderItem_' + i).val();
	          if (orderItemId == ordItemId) {
	            itemQuantity = $('#quantity_' + i).val();
	            break;
	          }
	        }
	      }
	      return itemQuantity;
	    }
	
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = new Object();
	  }
	
	  typeof window.COSTCO.Global == 'undefined' ? document.addEventListener('OrderItemsLoaded', OrderItems.loaded, false) : OrderItems.loaded();
	
	  window.COSTCO.OrderItems = OrderItems;
	
	  return OrderItems;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title addtocart.js: Sub-module
	 * @description Associated with ProductForm.jsp
	 * This JS file binds add to cart event listeners.
	 * Checks if a selection is back ordered to invoke a
	 * backordered modal.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5), __webpack_require__(54)], __WEBPACK_AMD_DEFINE_RESULT__ = function (phelper, mathtable) {
	    var AddToCart = {
	        init: function init() {
	            this.validate();
	            if ($('#ProductForm').length && $("span#backordered").length) {
	                phelper.bindSubmitToBackOrderModal(); // Here because span#backordered was included on the page
	            } else {
	                // Nothing backordered, add-to-cart button submit normally.
	                $("#ProductForm input[name='add-to-cart']").unbind('click').click(function (event) {
	                    if (event != undefined && event.target != undefined) {
	                        var callerElement = event.target;
	                        COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	                    } else {
	                        COSTCO.dialog.returnFocusOnCallerElement(document.activeElement);
	                    }
	                    $('#ProductForm').submit();
	                });
	            }
	        },
	
	        validate: function validate() {
	
	            $.validator.addMethod("quantityincrement", function (value, element) {
	                var $quantityIncrement = $(element).data("quantity-increment");
	                var errorMesg = $(element).data("error-message");
	
	                var quantityIncrement = 1; //default quantityIncrement is always 1 (a whole number)
	                if ((typeof $quantityIncrement === 'undefined' ? 'undefined' : _typeof($quantityIncrement)) == undefined || !$quantityIncrement) {
	                    return true;
	                }
	                var qty = parseInt($quantityIncrement);
	                if (qty) {
	                    quantityIncrement = qty;
	                }
	                if (value % quantityIncrement != 0) {
	                    return false;
	                }
	                return true;
	            }, function (params, element) {
	
	                return $(element).data("error-message") + " " + $(element).data("quantity-increment");
	            });
	
	            var _rules = {
	                submitHandler: function (form) {
	                    var item_type = phelper.item_type,
	                        $product_error = $('body').find('.product-error'),
	                        $add_success = $(form).find('.add-success'),
	                        quantity_obj = phelper.is_valid_quantity(item_type, $('input[name=quantity]')),
	                        valid = true;
	                    // Clear any previous error/success state and disable add to cart
	                    $product_error.html('');
	                    tobaccoProduct = $('#tobaccoProduct').val() == "true" ? true : false;
	                    if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && tobaccoProduct) {
	                        $('#add-to-cart').addClass('interaction-element');
	                        $('#error-notification-placeholder').empty();
	                        $('#error-notification-placeholder').addClass('hide');
	                    }
	                    $add_success.html('');
	                    // Disable quantity and add to cart to avoid spam
	                    $('#add-to-cart input').attr('disabled', 'disabled');
	                    $('input[name=quantity]').attr('disabled', 'disabled');
	
	                    // Check if we have a valid quantity
	                    if (!quantity_obj.valid) {
	                        $product_error.html(quantity_obj.message);
	                        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                            $('#minQtyText ').addClass('error');
	                        }
	                        valid = false;
	                    }
	                    // Check if we have a valid sku resolved
	                    if (valid && !phelper.is_sku_resolved(item_type, quantity_obj)) {
	                        $product_error.html("<span class='sr-only'>" + messages.ERROR + "</span>" + messages.ERR_ADD_TO_CART_SELECT_ONE);
	                        valid = false;
	                    }
	                    // If valid, Add to cart
	                    if (valid && typeof $('#vendorName').val() !== 'undefined' && ($('#vendorName').val().toLowerCase().includes('narvar') || COSTCO.Product.eddFormDisplayed != true || $('#ProductForm').length && $("span#backordered").length)) {
	                        this.ajaxAddToCart('#ProductForm', this.product_form_done, this.product_form_fail, this.product_form_always);
	                        $('#add-to-cart-btn').not('[offscreen]').focus();
	                    } else {
	                        // enable quantity and add to cart
	                        if (COSTCO.Product.eddFormDisplayed === '' || $('#edd-date-msg.hide').length == 0) {
	                            $('#add-to-cart input').removeAttr('disabled');
	                        }
	                        $('input[name=quantity]').removeAttr('disabled');
	                        $('#minQtyText').focus();
	                    }
	                }.bind(this)
	            };
	            var appType = $('#applicationType').val();
	            if (appType == 'BD') {
	                _rules.rules = {
	                    quantity: { quantityincrement: true }
	                };
	
	                _rules.messages = {
	                    quantity: {
	                        quantityincrement: function quantityincrement(params, element) {
	                            var unitOfMeasure = COSTCO.Product.getUnitOfMeasure($(element));
	                            var increment = COSTCO.Product.getQuantityStep($(element), unitOfMeasure);
	                            return "<p class='sr-only'>" + messages.ERROR + "</p>" + $(element).data("error-message") + " " + increment;
	                        }
	                    }
	                };
	
	                _rules.errorPlacement = function (error, element) {
	                    $product_error = element.closest('#ProductForm').find('.product-error');
	                    $product_error.html(error.css({ "margin": 0 }));
	                    COSTCO.Product.expendErrorOnQtyUnit(element, 'span');
	                };
	            }
	
	            if ($('#ProductForm')) {
	                var validate = $('#ProductForm').validate(_rules);
	                if (validate != undefined) {
	                    validate.form();
	                }
	            }
	        },
	
	        add_related: function add_related(form, done, fail, always) {
	            $(form).find('.related-success').empty();
	            $(form).find('.product-error').empty();
	            $(form).find('button.add-to-cart').attr('disabled', 'disabled');
	            this.ajaxAddToCart(form, done, fail, always);
	        },
	
	        ajaxAddToCart: function ajaxAddToCart(form, done, fail, always) {
	            var isRestrictedPostalCode = COSTCO.Header.checkIsRestricted();
	            var singleVariant = "single_variant";
	            var multiVariant = "multi-variant";
	            var targetedAttribute = $('#targetedCartBehaviour').val();
	            var targetedCart = "";
	            if (targetedAttribute !== undefined && targetedAttribute === 'Membership') {
	                //Any new behaviour, like Tickets, can be added to this condition to ensure that item is added to targeted cart
	                targetedCart = targetedAttribute;
	            }
	            //Fetch the contract specific flag for the Depot catalog flow
	            var programType = $('#programType').val();
	            var contractIdentifier = "";
	            if (typeof programType === "undefined") {
	                programType = "";
	            }
	            if (programType == "2DayDelivery") {
	                contractIdentifier = "Regional";
	            }
	
	            var isRelatedForm = form.indexOf('#RelatedProductForm') >= 0 ? true : false;
	            var $form = $(form),
	                locale = COSTCO.util.getLocale(),
	                productErrorDiv = $form.find('.product-error').empty(),
	                relatedProductErrorDiv = $form.find('.related-product-error').empty(),
	                quantity_text = messages.RWD_QUANTITY + ' ',
	                quantity,
	                final_price = (locale == 'en-US' || locale == 'en-CA' ? ' $' : '') + (isRelatedForm ? $form.find('.price').text().replace('$', '') : costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? $('#pull-right-price .value').text() : $('.your-price .value').text()) + (locale == 'fr-CA' ? ' $' : ''),
	                formData = $form.serializeArray(),
	                cleanData = { 'ajaxFlag': true, 'checkOmsInventory': true, 'isPdpPage': true, 'isRestrictedPostalCode': isRestrictedPostalCode, 'targetedCartBehaviour': targetedCart, 'contractIdentifier': contractIdentifier },
	                selected_products = [];
	            $.each(formData, function (index, value) {
	                var dataName = formData[index].name;
	                var dataValue = formData[index].value;
	                if (dataName == 'relatedQty') {
	                    dataName = 'quantity';
	                }
	                if (!/_\d$/.test(dataName) && dataValue !== '' && dataValue !== '0') {
	                    cleanData[dataName] = dataValue;
	                }
	            });
	            var productIndex = 1;
	            cleanData['catalogEntryId_' + productIndex] = cleanData['catEntryId'];
	            if (cleanData['quantity'] == undefined) {
	                cleanData['quantity'] = $('#minQtyText').val();
	                if (cleanData['quantity'] == undefined) {
	                    cleanData['quantity'] = 1;
	                }
	            }
	            var isShipRestrictionStore = $('#shipRestrictionStore').val();
	            cleanData['isShipRestrictionStore'] = isShipRestrictionStore;
	            cleanData['quantity_' + productIndex] = cleanData['quantity'];
	            $form.find('.variantContainer').each(function (i, p) {
	                var dropdowns = $(p).find('option:selected').map(function () {
	                    return $(this).val();
	                }).get();
	                var swatches = $(p).find('.selected').map(function () {
	                    return $(this).attr('value');
	                }).get();
	                var selectedVariants = dropdowns.concat(swatches);
	                var selected_product = phelper.findItem(products[i], selectedVariants);
	                if (selected_product) {
	                    quantity = phelper.item_type == 'bundle' ? parseInt($(p).find('[id^=qty-input] input').val()) : parseInt($('input[name=quantity]').val());
	                    selected_product.quantity = quantity_text + quantity;
	                    var itemText = $('span.item-number-bundles').text().trim();
	                    selected_product.isFsaChdItem = $('input[name=isFsaChdItem]', $(form)).val();
	                    var bundle_item_number = phelper.item_type == 'bundle' ? itemText + '  ' + (selected_product.partNumber || "") : "";
	                    selected_product.item_number = bundle_item_number == "" ? $('span.item-number').text() || '#' + selected_product.partNumber || "" : bundle_item_number;
	                    selected_product.final_price = phelper.item_type != 'bundle' ? final_price : $('.online-price[data-catentry=' + selected_product.catentry + ']').data('opvalue') ? phelper.formatMoney(mathtable.calculateYourPrice(selected_product.catentry, true), true) : '';
	                }
	                if (selected_product && quantity > 0) {
	                    selected_products = selected_products.concat(selected_product);
	                    cleanData['catalogEntryId_' + productIndex] = selected_product.catentry;
	                    cleanData['quantity_' + productIndex] = quantity;
	                    productIndex++;
	                }
	            });
	            if (phelper.item_type == 'single') {
	                var selected_product = phelper.findItem(products[0], []);
	                selected_product.quantity = quantity_text + $('input[name=quantity]').val();
	                selected_product.item_number = $('span.item-number').text();
	                selected_product.final_price = final_price;
	                selected_product.isFsaChdItem = $('input[name=isFsaChdItem]', $(form)).val();
	                selected_products = selected_products.concat(selected_product);
	            }
	
	            if (typeof eddInstallationServicesJSON !== 'undefined') {
	                cleanData['eddInstallationServicesJSON'] = JSON.stringify(eddInstallationServicesJSON);
	            }
	
	            var eddPrimaryClause = $('#eddPrimaryClause').val();
	            if (typeof eddPrimaryClause !== 'undefined') {
	                cleanData['eddPrimaryClause'] = eddPrimaryClause;
	            }
	
	            $.ajax({
	                url: "/AjaxManageShoppingCartCmd",
	                type: 'POST',
	                data: cleanData,
	                dataType: 'json'
	            }).done(function (data, textStatus, xhr) {
	
	                data.selected_products = selected_products;
	                data.form_id = form;
	                $('#isPickUpItem').val(data.pickUp);
	                $('#isSTWtem').val(data.isSTWPickUp);
	                $('#isMDOItem').val(data.mdoPickUp);
	                if (done) done(data, textStatus, xhr);
	                if (COSTCO.util.isNdEnabled()) {
	                    var surcharge = data.surchargeAmount;
	                    var thresholdAmount = data.thresholdAmount;
	                    var shipmethodId = data.shipmethodId;
	                    var toolTipDeliverySurcharge = data.toolTipDeliverySurcharge;
	                    $('#freeDeliveryOrderAmount').val(parseFloat(thresholdAmount));
	                    $('#deliverySurcharge').val(parseFloat(surcharge));
	                    $('#toolTipDeliverySurcharge').val(parseFloat(toolTipDeliverySurcharge));
	                    COSTCO.Header.displayTooltip(shipmethodId);
	                }
	                if (data.multipleRestricted) {
	                    $form.find('.product-notification').html('<span>' + data.multipleRestricted + '<span>').show();
	                }
	                $('input[name="associatedParentIds"]').val(data.associatedParentIds);
	                COSTCO.Header.refreshGroceryBanner();
	            }).fail(function (xhr, textStatus, errorThrown) {
	                if (fail) fail(xhr, textStatus, errorThrown);
	            }).always(function (data, textStatus, errorThrown) {
	                if (always) always(data, textStatus, errorThrown);
	            });
	        },
	
	        has_error: function has_error(data) {
	            var productErrorDiv = void 0;
	            var bundleProduct = $('#bundle-items-container').length !== 0 ? true : false;
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                if (bundleProduct) {
	                    productErrorDiv = $('#bundle-items-container').find('.product-error');
	                } else {
	                    productErrorDiv = $(data.form_id + ' .product-error').length ? $(data.form_id + ' .product-error') : $('#pdp-sticky-container').find('.product-error');
	                }
	            }
	            var relatedProductErrorDiv = $(data.form_id + ' .related-product-error');
	            var errorCount = 0;
	            if (data.errorCode) {
	                errorCount++;
	                if (data.errorCode == 2510) {
	                    // session timeout
	                    document.location.href = 'Logoff?URL=ReLogonFormView';
	                    return;
	                } else {
	                    if (data.errorCode && data.errorMessage) {
	                        productErrorDiv.append("<span class='sr-only'>" + messages.ERROR + "</label>" + "<p class=\"span\">" + data.errorCode + data.errorMessage + "</p>");
	                        COSTCO.util.logToClickTale(data, location.href, 151);
	                        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                            $('#minQtyText ').addClass('error');
	                        }
	                    } else {
	                        productErrorDiv.append("<span class='sr-only'>" + messages.ERROR + "</label>" + "<p class=\"span\" System Error adding to cart, please retry at a later time </p>");
	                        COSTCO.util.logToClickTale(data, location.href, 152);
	                    }
	                }
	            } else {
	                if (data.orderErrMsgObj) {
	                    var errors = data.orderErrMsgObj;
	                    var errorLoc = data.orderErrMsgLocObj;
	                    for (var errorKey in errors) {
	                        if (errors.hasOwnProperty(errorKey)) {
	                            errorCount++;
	                            var isErrorPopup = false;
	                            if (errorLoc.hasOwnProperty(errorKey)) {
	                                if (errorLoc[errorKey] === 'popup') isErrorPopup = true;
	                            }
	                            var errorMsg = errors[errorKey].replace('~', ',').replaceAll("''", "'");
	                            if (isErrorPopup) {
	                                var msgContent = errorMsg;
	                                if (COSTCO.util.isCAStore() && COSTCO.Header.checkIsRestricted()) {
	                                    msgContent = messages.GROCERY_ITEM_UNAVAILABLE_TEXT;
	                                }
	                                var modalOptions = {
	                                    title: messages.GROCERY_ITEM_UNAVAILABLE_TITLE,
	                                    body: '<p>' + msgContent + '</p>',
	                                    primary: messages.GROCERY_ITEM_UNAVAILABLE_PRIMARY,
	                                    primary_event: function primary_event() {
	                                        COSTCO.dialog.close();
	                                    }
	                                };
	                                COSTCO.dialog.showAndHideModal(modalOptions);
	                            } else if (errorKey === messages.SHIP_RESTRICTION_ERROR_KEY || errorKey === messages.SHIP_RESTRICTION_ERROR_KEY_CA || errorKey === messages.ERR_OMS_INVENTORY_API_FAILURE_ERROR) {
	                                productErrorDiv.append('<p class="alert-notification">' + errorMsg + '</p>');
	                                $('.product-error').removeClass('error');
	                                $('#prod-page-restriction').removeClass('hide');
	                            } else {
	                                if (errorKey === messages.RELATED_ITEM_ADD_ERROR_KEY) {
	                                    relatedProductErrorDiv.append('<p class="error">' + errorMsg + "</p>");
	                                } else {
	                                    if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                                        errorMsg = errorMsg.replace(/&lt;/g, '<');
	                                        errorMsg = errorMsg.replace(/&gt;/g, '>');
	                                        productErrorDiv.append('<span><p class="sr-only">Error</p>' + errorMsg + '</span>');
	                                        productErrorDiv.removeClass('hide');
	                                        productErrorDiv.focus();
	                                        if (Object.keys(oosFreeGiftAnalyticsMessages).includes(errorKey)) {
	                                            window.digitalDataEvents = window.digitalDataEvents || [];
	                                            digitalDataEvents.push({ uimsg: 'ProductDetail | Buy One Get One Free | Error | ' + oosFreeGiftAnalyticsMessages[errorKey] });
	                                        }
	                                    } else {
	                                        productErrorDiv.append("<span class='sr-only'>" + messages.ERROR + "</span>" + '<p class="error">' + errorMsg + '</p>');
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            return errorCount;
	        },
	
	        product_form_done: function product_form_done(data, textStatus, xhr) {
	            if (COSTCO.AddToCart.has_error(data) == 0) {
	                var paramData = data;
	                if (data.redirecturl != null) {
	                    urlWithoutQueryString = data.redirecturl.split('?')[0];
	                    var appType = $('#applicationType').val();
	                    if (urlWithoutQueryString.indexOf('CatalogSearch') != -1 || urlWithoutQueryString.indexOf('CategoryDisplay') != -1 || urlWithoutQueryString.indexOf('.html') != -1 && urlWithoutQueryString.indexOf('.product.') == -1 || appType !== undefined && appType === 'BC' && urlWithoutQueryString.indexOf('QuickMembershipApplicationView') !== -1 || urlWithoutQueryString.indexOf('MembershipApplicationView') !== -1) {
	                        var url = data.redirecturl;
	                        delete data.redirecturl;
	                        delete data.selected_products;
	                        var params = $.param(data);
	                        var decodedUrl = $("<div/>").html(url).text();
	                        var finalUrl;
	                        if (decodedUrl.indexOf('?') != -1) {
	                            if (decodedUrl.substr(decodedUrl.length - 1) == '&') {
	                                finalUrl = decodedUrl + params;
	                            } else {
	                                finalUrl = decodedUrl + '&' + params;
	                            }
	                        } else {
	                            finalUrl = decodedUrl + '?' + params;
	                        }
	                        document.location.href = finalUrl;
	                        return;
	                    }
	                }
	                // Invoke add to cart modal
	                phelper.added_modal(data.selected_products, data.orderItemId, data.itemMessage, data.originalQuantity);
	                var quantity = '1';
	                var langId = parseInt(COSTCO.util.getLangId());
	                if (langId == -1 || langId == -24) {
	                    quantity = data.selected_products[0].quantity.replace("Quantity ", "");
	                } else {
	                    quantity = data.selected_products[0].quantity.replace("Quantité ", "");
	                }
	
	                var price = data.selected_products[0].final_price.replace(" $", "");
	                var partNumber = parseInt(data.selected_products[0].partNumber);
	                var orderItemId = data.orderItemId;
	                var qtyBought = data.itemMessage;
	                var itemInventory = data.selected_products[0].inventory === "IN_STOCK" ? "In stock" : "Out of stock";
	                var orderId = data.orderId;
	                var data = {
	                    partNumber: partNumber,
	                    price: price,
	                    quantity: quantity,
	                    orderItemId: orderItemId,
	                    qtyBought: qtyBought
	                };
	
	                $('body').trigger("costco.cart.item.added", [data]);
	
	                var windsorProductData = {
	                    partNumber: partNumber,
	                    price: price,
	                    quantity: qtyBought,
	                    inventory: itemInventory
	                };
	                try {
	                    if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true') {
	                        if (typeof contextVariables != 'undefined' && typeof adobeProductData != 'undefined' && typeof adobeProductData[0] != 'undefined') {
	                            contextVariables.orderId = orderId;
	                            adobeProductData[0].quantity = parseInt(quantity);
	                            if (!($('#mymdGenericItemNumber').length > 0 && $('#mymdGenericItemNumber').val() == adobeProductData[0].SKU)) {
	                                COSTCO.AdobeEvents.initEventIfLoggedIn('commerce.productListAdds', adobeProductData, adobeAnalyticsCommonData, contextVariables);
	                            }
	                        }
	                    }
	                } catch (err) {
	                    console.log('Problem with sending product data to Adobe');
	                }
	
	                $('body').trigger("windsor.product.cart.item.added", [windsorProductData]);
	                $('#related-products-container').find('.sign-in').on("click", function () {
	                    sessionStorage.setItem('AddedToCartModalData', JSON.stringify(paramData));
	                    window.digitalDataEvents = window.digitalDataEvents || [];
	                    digitalDataEvents.push({
	                        event: "interface interaction",
	                        interfaceInteractionName: "sign in for price"
	                    });
	                });
	            }
	            if ($('#isPickUpItem').val() != 'true') {
	                $('#add-to-cart input').removeAttr('disabled');
	                $('input[name=quantity]').removeAttr('disabled');
	            }
	        },
	
	        product_form_fail: function product_form_fail() {
	            $('#add-to-cart input').removeAttr('disabled');
	            $('input[name=quantity]').removeAttr('disabled');
	        },
	
	        product_form_always: function product_form_always() {
	            $('#add-to-cart input').removeAttr('disabled');
	            $('input[name=quantity]').removeAttr('disabled');
	            COSTCO.Header.miniShopCartRefresh();
	        },
	
	        related_done: function related_done(data, textStatus, xhr) {
	            if (COSTCO.AddToCart.has_error(data) == 0) {
	                var addedToCartMessage = data.itemMessage == 1 ? messages.PDETAIL_ITEMS_ADDED_TO_CART : messages.PDETAIL_ITEMS_ADDED_TO_CART2;
	
	                $(data.form_id).find('.form_and_button').addClass('hide');
	                $(data.form_id).find('.ctas').addClass('hide');
	                $(data.form_id).find('.related-success').append('<p><i class="co-checkmark"></i> ' + addedToCartMessage + '</p>');
	
	                //if called on replacement products modal on checkout pages, disable Cancel button to force user to go to View Cart
	                if (typeof checkoutPage !== 'undefined') {
	                    $('.related-products.replacements .add-buttons .btn-tertiary').prop('disabled', true);
	                }
	            } else {
	                $(data.form_id).find('button.add-to-cart').removeAttr('disabled');
	            }
	        },
	
	        related_fail: function related_fail(data, textStatus, errorThrown) {
	            $(data.form_id).find('.product-error').append(errorThrown);
	            $(data.form_id).find('button.add-to-cart').removeAttr('disabled');
	        },
	
	        related_always: function related_always(data, textStatus, errorThrown) {
	            COSTCO.Header.miniShopCartRefresh();
	        },
	
	        getUrlParameter: function getUrlParameter(sParam) {
	            var sPageURL = decodeURIComponent(window.location.search.substring(1));
	            var sURLVariables = sPageURL.split('&');
	
	            for (var i = 0; i < sURLVariables.length; i++) {
	                var sParameterName = sURLVariables[i].split('=');
	
	                if (sParameterName[0] === sParam) {
	                    return sParameterName[1] === undefined ? true : sParameterName[1];
	                }
	            }
	        },
	
	        removeItemFromCart: function removeItemFromCart(orderId, orderItemsId, redirectUrl) {
	            var urlParam = { 'actionType': 'delete',
	                'backURL': redirectUrl,
	                'orderId': orderId,
	                'orderItemId': orderItemsId
	            };
	            var removeItemfromCartUrl = 'ManageShoppingCartCmd?' + jQuery.param(urlParam);
	            console.log(removeItemfromCartUrl);
	            window.location.href = removeItemfromCartUrl;
	        },
	
	        removeMembersipItemFromCart: function removeMembersipItemFromCart() {
	            var orderId = COSTCO.AddToCart.getUrlParameter('orderId');
	            var orderItemId = void 0;
	            if (orderId == undefined) {
	                orderId = $('#membershipOrderId').val();
	                orderItemId = $('#membershipOrderItemId').val();
	            } else {
	                orderItemId = COSTCO.AddToCart.getUrlParameter('orderItemId');
	            }
	
	            COSTCO.AddToCart.removeItemFromCart(orderId, orderItemId, "/");
	        },
	        acceptTermsAndConditions: function acceptTermsAndConditions() {
	
	            var command = '/UpdateTermsAndConditions';
	            var urlForRedirection = COSTCO.AddToCart.getUrlParameter('urlForRedirection');
	            var quickMembership = COSTCO.AddToCart.getUrlParameter('quickMembership');
	            var fromCheckout = COSTCO.AddToCart.getUrlParameter('fromCheckout');
	            var membershipOrderItemId = COSTCO.AddToCart.getUrlParameter('orderItemId');
	
	            var urlParam = { 'fromCheckout': fromCheckout,
	                'quickMembership': quickMembership,
	                'urlForRedirection': urlForRedirection,
	                'membershipOrderItemId': membershipOrderItemId };
	
	            var updateTermsAndConditions = command + '?' + jQuery.param(urlParam);
	            window.location.href = updateTermsAndConditions;
	        }
	
	    };
	    if (typeof window.COSTCO == 'undefined') {
	        window.COSTCO = new Object();
	    }
	    window.COSTCO.AddToCart = AddToCart;
	
	    return AddToCart;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title addressSelectionDialog.js: Feature level module
	 * @description Address utility module
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14), __webpack_require__(18)], __WEBPACK_AMD_DEFINE_RESULT__ = function (address, addressDisplay) {
	  var CAddressSelectionDialog = {
	    createAddressSelectionContent: function createAddressSelectionContent(currentAddressId, type, addressTemplates, templateOptions) {
	      var address_block_html = "",
	          labels = address.getHeaderLabels(type, 'choose'),
	          addressJson = address.getAddressJson(type, currentAddressId);
	      var template = "";
	      addressJson.forEach(function (address, i) {
	        if (address.isPrimary == "1") {
	          // Default address
	          template = "tmpl_choose_default_address_block";
	        } else {
	          // Non-default address
	          template = addressTemplates.addressBlock;
	        }
	        address_block_html += COSTCO.util.tmpl(template, {
	          currentAddressId: currentAddressId === undefined ? "''" : currentAddressId,
	          type: type,
	          id: address.id,
	          editButton: labels.editButton,
	          address: addressDisplay.createAddressDisplay(address, type),
	          orderItemId: templateOptions.orderItemId === undefined ? "''" : templateOptions.orderItemId,
	          multiShip: templateOptions.multiShip === undefined ? "''" : templateOptions.multiShip
	        });
	      });
	      var needsSearchVal = false;
	      var needsSortVal = false;
	      var needsNotificationVal = false;
	      var recentSortVal = $('#recentSort').val();
	      var firstNameZToASortVal = $('#firstNameZToASort').val();
	      var firstNameAToZSortVal = $('#firstNameAToZSort').val();
	      var lastNameAToZSortVal = $('#lastNameAToZSort').val();
	      var lastNameZToASortVal = $('#lastNameZToASort').val();
	      var companyNameAToZSortVal = $('#companyNameAToZSort').val();
	      var companyNameZToASortVal = $('#companyNameZToASort').val();
	      var sortSelectVal = $('#sortSelect').val();
	      if ($('#isBDAppVar').val() == 'BD') {
	        needsSearchVal = false;
	        needsSortVal = addressJson.length >= 20;
	      } else {
	        needsSearchVal = addressJson.length >= 20;
	        needsSortVal = false;
	      }
	      if (typeof templateOptions.needsNotification != 'undefined') {
	        needsNotificationVal = templateOptions.needsNotification;
	      }
	
	      // This is the container for the address blocks. Represents the content
	      // of the modal.
	      return COSTCO.util.tmpl(addressTemplates.wrapper, {
	        type: type,
	        orderItemId: templateOptions.orderItemId,
	        shipTo: labels.shipTo,
	        headerText: labels.headerText,
	        addNewAddress: labels.addNewAddress,
	        addressChooseBlocks: address_block_html,
	        needsSearch: needsSearchVal,
	        needsSort: needsSortVal,
	        needsNotification: needsNotificationVal,
	        recentSort: recentSortVal,
	        firstNameZToASort: firstNameZToASortVal,
	        firstNameAToZSort: firstNameAToZSortVal,
	        lastNameAToZSort: lastNameAToZSortVal,
	        lastNameZToASort: lastNameZToASortVal,
	        companyNameAToZSort: companyNameAToZSortVal,
	        companyNameZToASort: companyNameZToASortVal,
	        currentAddressId: typeof currentAddressId === 'undefined' ? "''" : currentAddressId,
	        sortSelect: sortSelectVal
	      });
	    },
	    showAddressSelectionDialog: function showAddressSelectionDialog(addressId, type, orderItemId, multiShip, templateOptions, mode) {
	      COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function (data) {
	        var addressTemplates = {};
	        addressTemplates.addressBlock = 'tmpl_choose_address_block';
	        addressTemplates.wrapper = 'tmpl_choose_address_wrapper';
	        addressTemplates.footerText = undefined;
	
	        if ((typeof templateOptions === 'undefined' ? 'undefined' : _typeof(templateOptions)) != 'object') {
	          templateOptions = {};
	        }
	        templateOptions.orderItemId = orderItemId;
	        templateOptions.multiShip = multiShip;
	        templateOptions.mode = mode;
	        COSTCO.CAddressSelectionDialog.createModal(addressId, type, addressTemplates, templateOptions);
	        if (event !== undefined) {
	          var callerElement = event.target;
	          COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	        }
	      });
	    },
	    createModal: function createModal(addressId, type, addressTemplates, templateOptions) {
	
	      var body = COSTCO.CAddressSelectionDialog.createAddressSelectionContent(addressId, type, addressTemplates, templateOptions);
	      var headerText = '';
	      if (addressTemplates.headerText) {
	
	        var displayText = '';
	        if (type == 'S') {
	          displayText = addressLabels.choose.shipping.headerText;
	        } else if (type == 'B') {
	          displayText = addressLabels.choose.billing.headerText;
	        }
	
	        headerText = COSTCO.util.tmpl(addressTemplates.headerText, { headerText: displayText });
	      }
	      var mode = typeof templateOptions.mode !== 'undefined' ? templateOptions.mode : 'choose';
	      address.baseModal(type, mode, {
	        body: body,
	        secondary_event: function secondary_event() {
	          COSTCO.CAddressSelectionDialog.handleClose(addressId, templateOptions.orderItemId);
	        },
	        close: function close() {
	          COSTCO.CAddressSelectionDialog.handleClose(addressId, templateOptions.orderItemId);
	        }
	      });
	    },
	
	    handleClose: function handleClose(addressId, orderItemId) {
	      $('#costcoModal').modal('hide');
	      $('#address_change_' + addressId + '_' + orderItemId).focus();
	    },
	
	    handleRadioButtonClick: function handleRadioButtonClick(element) {
	      $('#costcoModalBtn2').removeClass('btn-disabled');
	    },
	    /**
	     * This function is called when the select button is clicked in the address choose modal
	     */
	    handleAddressSelection: function handleAddressSelection(addressId, newAddressId, orderItemId) {
	
	      if (typeof $('#calendarServiceResponse').val() !== 'undefined') {
	        document.getElementById("calendarServiceResponse").value = "";
	      }
	      if (typeof sessionStorage !== "undefined") {
	        sessionStorage.setItem('shipping-costs-orderItemId', orderItemId);
	        sessionStorage.setItem('shipping-costs-addressId', newAddressId);
	      }
	      address.chooseAddress(addressId, newAddressId, orderItemId);
	      if (!(COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof checkoutPage != 'undefined')) {
	        $('#costcoModal').modal('hide');
	      }
	    },
	    /**
	     * These are the address blocks that are used in the "Choose
	     * a X Address" modal.
	     * @param  {array} addresses Array of address objects
	     * @param  {String} type     The type of address we're making 'S' or
	     *                           'B'
	     * @param  {array} currentAddressId Array of currentAddressId(String) of length 1
	     * @param  {array} orderItemId Array of orderItemId(String) of length 1                          
	     * @return {void}
	     */
	    buildAddressBlocks: function buildAddressBlocks(addresses, type, currentAddressId, orderItemId) {
	      var util = COSTCO.util;
	      var address_block_html = "";
	      if (addresses.length > 0) {
	        var labels = address.getHeaderLabels(type, 'choose');
	        $('#address-blocks').children().remove();
	
	        addresses.forEach(function (addr, i) {
	          // Normalizing property values of each address object
	          util.renameArray(addr, util.addressNamingMap);
	          addr.addressType = addr.addressType.trim();
	          address_block_html += util.tmpl('tmpl_choose_address_block', {
	            checked: i === 0 ? "checked" : "",
	            type: type,
	            id: addr.id,
	            editButton: labels.editButton,
	            address: addressDisplay.createAddressDisplay(addr, type),
	            orderItemId: typeof orderItemId === 'undefined' || orderItemId.length == 0 || typeof orderItemId[0] == 'undefined' || orderItemId[0] == '' ? "''" : orderItemId[0],
	            currentAddressId: typeof currentAddressId === 'undefined' || currentAddressId.length == 0 || typeof currentAddressId[0] == 'undefined' || currentAddressId[0] == '' ? "''" : currentAddressId[0],
	            multiShip: "''"
	          });
	        });
	        util.concatNonDuplicates(addresses);
	        $('#address-blocks').append(address_block_html);
	      }
	    },
	    sortAddressList: function sortAddressList() {
	      var $sortOption = $('.checkout-address-book-select').find('option:selected').val();
	      var util = COSTCO.util;
	      var type = $('#address-sort-form').find('input[name=addressType]').val();
	      if ($sortOption == '2') {
	        $('#address-sort-form').find('input[name=filterName]').val('firstname');
	        $('#address-sort-form').find('input[name=filterOrder]').val('ASC');
	      } else if ($sortOption == '3') {
	        $('#address-sort-form').find('input[name=filterName]').val('firstname');
	        $('#address-sort-form').find('input[name=filterOrder]').val('DESC');
	      } else if ($sortOption == '5') {
	        $('#address-sort-form').find('input[name=filterName]').val('lastname');
	        $('#address-sort-form').find('input[name=filterOrder]').val('ASC');
	      } else if ($sortOption == '6') {
	        $('#address-sort-form').find('input[name=filterName]').val('lastname');
	        $('#address-sort-form').find('input[name=filterOrder]').val('DESC');
	      } else if ($sortOption == '7') {
	        $('#address-sort-form').find('input[name=filterName]').val('companyname');
	        $('#address-sort-form').find('input[name=filterOrder]').val('ASC');
	      } else if ($sortOption == '8') {
	        $('#address-sort-form').find('input[name=filterName]').val('companyname');
	        $('#address-sort-form').find('input[name=filterOrder]').val('DESC');
	      }
	      util.ajax({
	        url: '/AjaxCostcoGetAddressCmd',
	        method: 'GET',
	        dataType: 'json',
	        data: $('#address-sort-form').serializeArray(),
	        done: function done(data, textStatus, jqXHR, options) {
	          try {
	            var addresses = JSON.parse(data.addresses);
	            if (!data.addresses || addresses.length == 0) {
	              throw new Error("No addresses");
	            }
	            CAddressSelectionDialog.buildAddressBlocks(addresses, type, data.currentAddressId, data.orderItemId);
	          } catch (e) {
	            $('.address-search .error').removeClass('hide');
	            console.error(e);
	          }
	        },
	        fail: function fail(jqXHR, textStatus, errorThrown) {
	          console.error(errorThrown);
	        }
	      });
	    },
	    /**
	     * Used in the "Choose a X Address" modal (Checkout Shipping) to allow
	     * the user to search for addresses in their address book by first and
	     * last name. Made specifically for users that have tons of addresses.
	     * This function is used on the form located in CheckoutTemplates.jspf.
	     * @return {void}
	     */
	    addressSearch: function addressSearch() {
	      var $firstName = $(this).find('input[name=firstName]');
	      var $lastName = $(this).find('input[name=lastName]');
	      $firstName.val($firstName.val().trim());
	      $lastName.val($lastName.val().trim());
	      var type = $(this).find('input[name=addressType]').val();
	      var util = COSTCO.util;
	      $('.address-search .error').addClass('hide');
	      if (!$firstName.val() && !$lastName.val()) {
	        // Empty, don't make server call. Just use addresses we have.
	        $('.address-search .error').removeClass('hide');
	        CAddressSelectionDialog.buildAddressBlocks(util.addresses, type);
	        return;
	      }
	      util.ajax({
	        url: '/AjaxCostcoGetAddressCmd',
	        method: 'GET',
	        dataType: 'json',
	        data: $(this).serializeArray(),
	        done: function done(data, textStatus, jqXHR, options) {
	          try {
	            var addresses = JSON.parse(data.addresses);
	            if (!data.addresses || addresses.length == 0) {
	              throw new Error("No addresses");
	            }
	            CAddressSelectionDialog.buildAddressBlocks(addresses, type, data.currentAddressId, data.orderItemId);
	          } catch (e) {
	            $('.address-search .error').removeClass('hide');
	            console.error(e);
	          }
	        },
	        fail: function fail(jqXHR, textStatus, errorThrown) {
	          console.error(errorThrown);
	        }
	      });
	    }
	  };
	  if (typeof window.COSTCO === "undefined") {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.CAddressSelectionDialog = CAddressSelectionDialog;
	  return CAddressSelectionDialog;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title rxdrugdetails.js: Sub-module for Rx pages
	 * @description This module is used to handle various drug search tasks
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var rxDrugDetails = {
	
			init: function init(options) {
				this.bindEvents();
			},
			/**
	   * bind events
	   *  
	   */
			bindEvents: function bindEvents() {
				if ($('#navigation-tabs .active').find('a').attr("href")) {
					if ('drug-detail-info' != $('#navigation-tabs .active').find('a').attr("href").substr(1)) {
						$('#print-link').addClass('hidden');
					}
				} else {
					console.warn('Navigation tabs empty.');
				}
	
				$('#navigation-tabs a').click(function () {
					$('a[href*=drug-detail-price]').removeAttr('aria-expanded');
					$('a[href*=drug-detail-info]').removeAttr('aria-expanded');
					if ('drug-detail-info' == $('#navigation-tabs .active').find('a').attr("href").substr(1)) {
						$('#print-link').removeClass('hidden');
					} else if ('drug-detail-price' == $('#navigation-tabs .active').find('a').attr("href").substr(1)) {
						$('#print-link').addClass('hidden');
					}
				});
			},
			/**
	   * show drug info and change clicked link color
	   * 
	   * @param index link index
	   */
			showDrugInfo: function showDrugInfo(index) {
				$('[id^=drug-link-]').each(function () {
					$(this).removeClass('clicked_link');
					$(this).addClass('body-copy-link');
				});
				$('#drug-link-' + index).removeClass('body-copy-link');
				$('#drug-link-' + index).addClass('body-copy-medium clicked_link');
	
				$('[id^=details-info-]').each(function () {
					$(this).addClass('hidden');
				});
				$('#details-info-' + index).removeClass('hidden');
				$('html, body').animate({
					scrollTop: $('#drug-info-name-' + index).offset().top
				}, 1000);
			},
			/**
	   * submit cancel form
	   * 
	   */
			submitCancelForm: function submitCancelForm() {
				$("#PharmacyCancelDrugSelection").submit();
			},
			/**
	   * go back
	   * 
	   */
			goBack: function goBack() {
				window.history.back();
			},
			/**
	   * select drug
	   * 
	   * @param drugDescription drug description
	   * @param ndc number
	   */
			selectDrug: function selectDrug(drugDescription, ndcNumber) {
				var newPrescriptionForm = document.forms['PharmacyAddDrugForm'];
				newPrescriptionForm.drugDescription.value = drugDescription;
				newPrescriptionForm.ndcNumber.value = ndcNumber;
				newPrescriptionForm.submit();
			},
	
			//Sets Drug detail aria expanded value to true when Drug detail displays only
			rxDrugDetailAriaExpandSwitch: function rxDrugDetailAriaExpandSwitch() {
				if ($('a[target="drug-detail-info"]').parent().hasClass('active')) {
					$('a[target="drug-detail-price"]').attr('aria-selected', 'false');
					$('a[target="drug-detail-info"]').attr('aria-selected', 'true');
				} else {
					$('a[target="drug-detail-price"]').attr('aria-selected', 'true');
					$('a[target="drug-detail-info"]').attr('aria-selected', 'false');
				};
			}
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.rxDrugDetails = rxDrugDetails;
	
		return rxDrugDetails;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title rxprescription.js: Sub-module for Rx pages
	 * @description This module is used to handle various prescription-related tasks
	 * @dependency checkout_helper.js, address.js, addressSelectionDialog.js, addressForm.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(114)], __WEBPACK_AMD_DEFINE_RESULT__ = function (rxAddressHelper) {
	
		var rxRefillPrescription = {
	
			init: function init(options) {
				rxRefillPrescription.sortPrescriptionsJSON();
				rxRefillPrescription.bindEvents();
				rxRefillPrescription.showHideShippingAndBillingSection();
	
				if (options != undefined) {
					rxAddressHelper.init(options);
				}
			},
	
			currentAddressId: '',
			currentAddressType: '',
	
			showHideShippingAndBillingSection: function showHideShippingAndBillingSection() {
	
				$('#ship-when-ready').click(function () {
					$('#billing-and-shiping').show();
					if ($('#complete-prescription-request-button').attr('data-is-disabled-by-default') == 'true') {
						$('#complete-prescription-request-button').prop('disabled', true);
					}
				});
	
				$('#notify-when-ready').click(function () {
					$('#billing-and-shiping').hide();
					if ($('#complete-prescription-request-button').attr('data-is-disabled-by-default') == 'true') {
						$('#complete-prescription-request-button').prop('disabled', false);
					}
				});
			},
	
			/**
	   * Binding events
	   */
			bindEvents: function bindEvents() {
				if (rxRefillPrescription.refillPrescriptionInfoForm.getForm().length) {
					rxRefillPrescription.refillPrescriptionInfoForm.getForm().find('input[name=submit-for-review]').unbind('click').on('click', rxRefillPrescription.submitForReview);
					rxRefillPrescription.setUpSortEventListeners();
				}
			},
			refillPrescriptionInfoForm: {
				/**
	    * Gets refill prescription info form
	    * @return {form} Refill prescription info jquery form
	    */
				getForm: function getForm() {
					return $('#RefillPrescriptionInfoForm');
				},
				/**
	    * Checks if refill prescription form is valid to be submitted
	    * @return {Boolean} True if form is valid
	    */
				isValid: function isValid() {
					return rxRefillPrescription.getSelectedPrescriptionIds().length;
				}
			},
			refillPrescriptionSubmitForm: {
				/**
	    * Gets refill prescription submit form
	    * @return {form} Refill prescription submit jquery form
	    */
				getForm: function getForm() {
					return $('#refill-prescription-order-verification');
				}
			},
			url: {
				REMOVE_DRUG: '/AjaxPharmacyRemoveDrugFromSessionCmd',
				CHANGE_PRESCRIPTION_STATUS: '/AjaxPharmacyPrescriptionActiveStatusChangeCmd',
				CHANGE_PRESCRIPTION_AUTOREFILL: '/AjaxPharmacyPrescriptionAutoRefillCmd'
			},
			/**
	   * Sorts active and inactive prescription lists for webpage display
	   * @param (string) listType		Type of the list to order(Active, Inactive)
	   * @param (string) sortType 	Selected sorting type  
	   */
			sortPrescriptionsJSON: function sortPrescriptionsJSON(listType, sortType) {
	
				//On initial page load, sort by order date
				if (listType == "undefined" && sortType == "undefined" || listType == undefined && sortType == undefined || listType == null && sortType == null) {
					//Set all selects to initial value Sort by order date
					if (typeof activePrescriptions != "undefined" && activePrescriptions.length > 0) {
						activePrescriptions.sort(rxRefillPrescription['prescriptionSortByLastOrderedDesc']);
						$('#activeRefills-sort').closest('.row').show();
					} else {
						$('#activeRefills-sort').closest('.row').hide();
					}
					if (typeof inactivePrescriptions != "undefined" && inactivePrescriptions.length > 0) {
						inactivePrescriptions.sort(rxRefillPrescription['prescriptionSortByLastOrderedDesc']);
						$('#inactiveRefills-sort').closest('.row').show();
					} else {
						$('#inactiveRefills-sort').closest('.row').hide();
					}
					if (typeof onFilePrescriptions != "undefined" && onFilePrescriptions.length > 0) {
						onFilePrescriptions.sort(rxRefillPrescription['prescriptionSortByLastOrderedDesc']);
						$('#onFileRefills-sort').closest('.row').show();
					} else {
						$('#onFileRefills-sort').closest('.row').hide();
					}
				} else if (listType == "activePrescriptions" && typeof activePrescriptions != "undefined") {
					activePrescriptions.sort(rxRefillPrescription[sortType]);
				} else if (listType == "inactivePrescriptions" && typeof inactivePrescriptions != "undefined") {
					inactivePrescriptions.sort(rxRefillPrescription[sortType]);
				} else if (listType == "onFilePrescriptions" && typeof onFilePrescriptions != "undefined") {
					onFilePrescriptions.sort(rxRefillPrescription[sortType]);
				}
			},
			/**
	   * Sets up event listeners for sorting refill prescriptions lists 
	   */
			setUpSortEventListeners: function setUpSortEventListeners() {
				$('#activeRefills-sort').off('change').on('change', function () {
					COSTCO.rxRefillPrescription.sortPrescriptionsJSON("activePrescriptions", this.value);
					active_loadPrescriptionLists();
				});
				$('#inactiveRefills-sort').off('change').on('change', function () {
					COSTCO.rxRefillPrescription.sortPrescriptionsJSON("inactivePrescriptions", this.value);
					inactive_loadPrescriptionLists();
				});
				$('#onFileRefills-sort').off('change').on('change', function () {
					COSTCO.rxRefillPrescription.sortPrescriptionsJSON("onFilePrescriptions", this.value);
					onFile_loadPrescriptionLists();
				});
			},
	
			/**
	   * Orders prescription list by order date
	   */
			prescriptionSortByLastOrderedDesc: function prescriptionSortByLastOrderedDesc(prescriptionA, prescriptionB) {
				var prescriptionALastOrderedDate = prescriptionA.lastOrdered ? prescriptionA.lastOrdered : prescriptionA.lastOrderedDate ? prescriptionA.lastOrderedDate : '';
				var prescriptionBLastOrderedDate = prescriptionB.lastOrdered ? prescriptionB.lastOrdered : prescriptionB.lastOrderedDate ? prescriptionB.lastOrderedDate : '';
				return new Date(prescriptionBLastOrderedDate).getTime() - new Date(prescriptionALastOrderedDate).getTime();
			},
	
			/**
	   * Orders prescription list by drug name
	   */
			prescriptionSortByDrugName: function prescriptionSortByDrugName(prescriptionA, prescriptionB) {
				var prescriptionADrugName = prescriptionA.drugDescription ? prescriptionA.drugDescription : '';
				var prescriptionBDrugName = prescriptionB.drugDescription ? prescriptionB.drugDescription : '';
				return prescriptionADrugName.toLowerCase() < prescriptionBDrugName.toLowerCase() ? -1 : prescriptionADrugName.toLowerCase() > prescriptionBDrugName.toLowerCase() ? 1 : 0;
			},
	
			/**
	   * Orders prescription list by refills left Treat N/A as 999(infinite refills left) so they show in end of sorted list
	   */
			prescriptionSortByRefillsLeft: function prescriptionSortByRefillsLeft(prescriptionA, prescriptionB) {
				var prescriptionARefillsLeft = prescriptionA.refillsLeft ? !isNaN(prescriptionA.refillsLeft) ? prescriptionA.refillsLeft : 999 : 999;
				var prescriptionBRefillsLeft = prescriptionB.refillsLeft ? !isNaN(prescriptionB.refillsLeft) ? prescriptionB.refillsLeft : 999 : 999;
				return prescriptionARefillsLeft - prescriptionBRefillsLeft;
			},
	
			/**
	   * Orders prescription list by auto refill, possible values 0-2 N/A, if the value is N/A or empty replace it with number 4
	   */
			prescriptionSortByAutoRefill: function prescriptionSortByAutoRefill(prescriptionA, prescriptionB) {
				var prescriptionAAutoRefill = prescriptionA.autoRefill ? !isNaN(prescriptionA.autoRefill) ? prescriptionA.autoRefill : 4 : 4;
				var prescriptionBAutoRefill = prescriptionB.autoRefill ? !isNaN(prescriptionB.autoRefill) ? prescriptionB.autoRefill : 4 : 4;
				return prescriptionAAutoRefill - prescriptionBAutoRefill;
			},
	
			noRefillPopup: function noRefillPopup(isMedicare) {
				var popupDiv = '#no-refill-popup';
				if (isMedicare) {
					popupDiv = '#no-refill-popup-medicare';
				}
	
				COSTCO.dialog.createExtDialogBox({
					title: messages.REFILL_PRESCRIPTION_TITLE_NOREFILL,
					body: $(popupDiv).html(),
					primary: messages.JS_DIALOG_OK,
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					}
	
				});
			},
	
			/**
	   * Creates active/inactive prescriptions table with pagination, based on template
	   * @param  {string} status               Prescription status (active / inactive)
	   * @param  {string} prescriptionsBlockId HTML block ID to be populated with prescription rows
	   * @param  {number} pageNum              Page number to show
	   * @param  {number} rowsNum              Prescription rows per page
	   * @param  {number} numOfPages           Total number of pages
	   */
			createPrescriptionsSection: function createPrescriptionsSection(status, prescriptionsBlockId, pageNum, rowsNum, numOfPages, totalRecordsNum, pagingRequest) {
	
				$('#' + prescriptionsBlockId).html('');
	
				var prescriptions = this.getPrescriptionsJSON(status, pageNum, rowsNum);
	
				$.each(prescriptions, function (index, value) {
	
					value.groupIndex = index + 1;
	
					var template = COSTCO.util.tmpl(status + '_refill_prescription_row', value);
	
					template = $(template);
	
					if (value.checked == true) {
						template.find('#prescriptionNumber_' + value.prescriptionId).prop('checked', true);
					}
	
					template.find('#autoRefillEnabled_' + value.prescriptionId).prop('checked', value.autoRefill == '1' ? true : false);
					template.find('#autoRefillDisabled_' + value.prescriptionId).prop('checked', value.autoRefill == '0' ? true : false);
					var autoRefill = "<a href='javascript:COSTCO.rxRefillPrescription.noRefillPopup(false);'>N/A</a>";
					if (template.find('#autoRefillDisabled_' + value.prescriptionId) && value.autoRefill == 3 && value.onFile == "false") {
						setTimeout(function () {
							var clearView = '';
	
							$('#autoRefillDiv_' + value.prescriptionId).html(clearView);
							$('#autoRefillDiv_' + value.prescriptionId).html(autoRefill);
						}, 100);
					}
	
					if (value.onFile == "true" && value.active == "false") {
						template.find('#autoRefillDiv_' + value.prescriptionId).html(autoRefill);
						template.find('#lastOrderedDiv_' + value.prescriptionId).html("New");
					}
	
					$('#' + prescriptionsBlockId).append(template);
				});
	
				// Add class 'active-page' to current page
				$('[page-number^="' + status + '-"]').removeClass('active-page');
				$('[page-number="' + status + '-' + pageNum + '"]').addClass('active-page');
	
				// Bind events to arrows for Previous and Next page
				$('#' + status + '-previous-page').unbind().on('click', function () {
					var previousPage = pageNum - 1 > 0 ? pageNum - 1 : pageNum;
					COSTCO.rxRefillPrescription.createPrescriptionsSection(status, prescriptionsBlockId, previousPage, rowsNum, numOfPages, totalRecordsNum);
				});
	
				$('#' + status + '-next-page').unbind().on('click', function () {
					var nextPage = pageNum + 1 <= numOfPages ? pageNum + 1 : pageNum;
					COSTCO.rxRefillPrescription.createPrescriptionsSection(status, prescriptionsBlockId, nextPage, rowsNum, numOfPages, totalRecordsNum);
				});
	
				// Hide Show logic for previous and next arrows
				if (pageNum == 1) {
					$('#' + status + '-previous-page').hide();
				} else if (pageNum > 1 && numOfPages > 1) {
					$('#' + status + '-previous-page').show();
				}
	
				if (pageNum == numOfPages) {
					$('#' + status + '-next-page').hide();
				} else if (pageNum < numOfPages) {
					$('#' + status + '-next-page').show();
				}
	
				// Show paging navigation
				var firstRecordIndex = (pageNum - 1) * rowsNum + 1;
				var lastRecordIndex = pageNum * rowsNum < totalRecordsNum ? pageNum * rowsNum : totalRecordsNum;
				$('#' + status + '-paging-navigation').html(COSTCO.util.tmpl('prescription_upper_paging_navigation', {
					firstRecordIndex: firstRecordIndex,
					lastRecordIndex: lastRecordIndex,
					totalRecordsNum: totalRecordsNum
				}));
	
				if (pagingRequest) {
					$(window).scrollTop($('#' + prescriptionsBlockId).offset().top - 200);
				}
			},
	
			/**
	   * Gets JSON array of active or inactive prescriptions to be displayed on page
	   * @param {string} status 	Status of prescriptions to display ('active' | 'inactive')
	   * @param {number} pageNum 	Page number; Default set to 1
	   * @param {number} rowsNum 	Number of records to be displayed; Default set to 10
	   * @return Prescriptions JSON Array to be displayed on page, based on pageNum, rowsNum count and prescription status
	   */
			getPrescriptionsJSON: function getPrescriptionsJSON(status, pageNum, rowsNum) {
	
				var resultArray = [];
	
				if (pageNum == undefined) {
					pageNum = 1;
				}
	
				if (rowsNum == undefined) {
					rowsNum = 10;
				}
	
				var beginIndex = pageNum * rowsNum - rowsNum;
				var endIndex = pageNum * rowsNum - 1;
	
				var prescriptionsJson = [];
				if (status == 'active') {
					prescriptionsJson = activePrescriptions;
				} else if (status == 'inactive') {
					prescriptionsJson = inactivePrescriptions;
				} else if (status == 'onFile') {
					prescriptionsJson = onFilePrescriptions;
				}
	
				$.each(prescriptionsJson, function (index, value) {
					if (beginIndex <= index && index <= endIndex) {
						resultArray.push(value);
					}
				});
	
				return resultArray;
			},
			/**
	   * Returns prescriptions selected by user based on prescription status. If no status is provided, get selected prescriptions from both active and inactive lists
	   * @param {string} status Prescription status (active|inactive). Could be ommited if want to ceheck both active and inactive lists
	   * @return {Array} Selected prescriptions which have property checked=true
	   */
			getSelectedPrescriptionIds: function getSelectedPrescriptionIds(status) {
	
				var selectedPrescriptions = [];
				var tmpPrescriptionsArray = [];
	
				if (status == undefined) {
					$.merge(tmpPrescriptionsArray, activePrescriptions);
					$.merge(tmpPrescriptionsArray, inactivePrescriptions);
					$.merge(tmpPrescriptionsArray, onFilePrescriptions);
				} else if (status == 'active') {
					tmpPrescriptionsArray = activePrescriptions;
				} else if (status == 'inactive') {
					tmpPrescriptionsArray = inactivePrescriptions;
				} else if (status == 'onFile') {
					tmpPrescriptionsArray = onFilePrescriptions;
				}
				$.each(tmpPrescriptionsArray, function (index, value) {
					if (value.checked == true) {
						selectedPrescriptions.push(value.prescriptionId);
					}
				});
	
				return selectedPrescriptions;
			},
			/**
	   * Removes the drug from order prescription list on Verification Page
	   * @param {int} rxNumber 	rxNumber of prescription to be removed
	   */
			removeDrug: function removeDrug(rxNumber) {
	
				var key = [rxNumber];
	
				if (key.length !== 0) {
	
					COSTCO.Checkout.ajax_update_state({
						error_container: '#notification-message',
						method: 'POST',
						url: rxRefillPrescription.url.REMOVE_DRUG,
						data: { drugMapKey: key, fromPage: rxCheckoutPageName },
						dataType: 'json'
					});
				} else {
					console.log('rxNumber empty!');
				}
			},
			/**
	   * Toggles show / hide display of prescription list on webpage
	   * @param {String} section 	specifies which prescription list section to toggle
	   */
			showHideToggle: function showHideToggle(event) {
	
				var showHideButton = $(event.currentTarget);
				var divWrapper = $(showHideButton).closest('.prescription-info-list-wrapper');
				var prescriptionWrapper = $(divWrapper).find('.prescription-info-list');
				var icon = $(showHideButton).find('i');
				var span = $(showHideButton).find('span');
				var activeToggle = $(divWrapper).find('#active-prescriptions-toggle');
				var inactiveToggle = $(divWrapper).find('#inactive-prescriptions-toggle');
				var onFileToggle = $(divWrapper).find('#onFile-prescriptions-toggle');
	
				if ($(showHideButton).hasClass('show-list')) {
					$(showHideButton).removeClass('show-list');
					$(icon).removeClass('rotate270');
					$(showHideButton).addClass('hide-list');
					$(icon).addClass('rotate90');
					$(span).text(messages.RWD_COMPARE_SHOW);
					$(showHideButton).find('.paging-navigation .text-right').hide();
					$(prescriptionWrapper).hide();
				} else {
					$(showHideButton).removeClass('hide-list');
					$(icon).removeClass('rotate90');
					$(showHideButton).addClass('show-list');
					$(icon).addClass('rotate270');
					$(span).text(messages.RWD_COMPARE_HIDE);
					$(showHideButton).find('.paging-navigation .text-right').show();
					$(prescriptionWrapper).show();
				};
	
				if ($(activeToggle).hasClass('show-list')) {
					$(activeToggle).attr('aria-label', messages.REFILL_PRESCRIPTION_HIDE_ACTIVE_TOGGLE);
				} else if ($(activeToggle).hasClass('hide-list')) {
					$(activeToggle).attr('aria-label', messages.REFILL_PRESCRIPTION_SHOW_ACTIVE_TOGGLE);
				} else if ($(inactiveToggle).hasClass('show-list')) {
					$(inactiveToggle).attr('aria-label', messages.REFILL_PRESCRIPTION_HIDE_INACTIVE_TOGGLE);
				} else if ($(inactiveToggle).hasClass('hide-list')) {
					$(inactiveToggle).attr('aria-label', messages.REFILL_PRESCRIPTION_SHOW_INACTIVE_TOGGLE);
				} else if ($(onFileToggle).hasClass('show-list')) {
					$(onFileToggle).attr('aria-label', messages.REFILL_PRESCRIPTION_HIDE_ONFILE_TOGGLE);
				} else if ($(onFileToggle).hasClass('hide-list')) {
					$(onFileToggle).attr('aria-label', messages.REFILL_PRESCRIPTION_SHOW_ONFILE_TOGGLE);
				} else {
					$(onFileToggle).attr('aria-label', " ");
				};
			},
	
			/**
	   * Opens AutoRefill Reminder dialog.
	   */
			openEnableAutoRefillReminderDialog: function openEnableAutoRefillReminderDialog() {
	
				COSTCO.dialog.createExtDialogBox({
					title: messages.ENABLE_AUTOREFILL_REMINDER_DIALOG_TITLE,
					body: messages.ENABLE_AUTOREFILL_REMINDER_DIALOG_CONTENT,
					primary: messages.JS_DIALOG_OK
				});
			},
			/**
	   * Opens information dialog when user clicks make inactive / active button.
	   */
			openChangePrescriptionStatusInfoDialog: function openChangePrescriptionStatusInfoDialog() {
	
				COSTCO.dialog.createExtDialogBox({
					title: messages.PRESCRIPTION_PHARMACY__Info_DialogTitle,
					body: messages.HDREFILL_PRESCRIPTION_PHARMACY__SelectAPrescriptionActiveStatusChange_DialogText,
					primary: messages.JS_DIALOG_OK
				});
			},
			/**
	   * Handles on click auto refill radio button
	   * @param {number} autoRefill       Radio button user clicked (0 - off | 1 - on)
	   * @param {number} prescriptionId 	Prescription id
	   * @param {string} status        	 	Prescription status (active | inactive)
	   */
			managePrescriptionAutoRefill: function managePrescriptionAutoRefill(autoRefill, prescriptionId, status) {
				COSTCO.Checkout.ajax_update_state({
					error_container: '#notification-message',
					method: 'POST',
					url: rxRefillPrescription.url.CHANGE_PRESCRIPTION_AUTOREFILL,
					data: { prescriptionId: prescriptionId, autoRefill: autoRefill, status: status },
					dataType: 'json',
					done: function done(data, textStatus, jqXHR, options) {
						if (data.payload.data.numberOfPrescriptionsUpdated != 1) {
							rxRefillPrescription.revertAutoRefillUserSelection(prescriptionId);
						} else {
							if (data.payload.data.patientAutoRefillReminder == "false" && autoRefill == 1) {
								rxRefillPrescription.openEnableAutoRefillReminderDialog();
							}
							var prescriptionListToUpdate = activePrescriptions;
							if (options.data.status == 'inactive') {
								COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
								prescriptionListToUpdate = inactivePrescriptions;
							}
							prescriptionListToUpdate.find(function (result, index) {
								if (result.prescriptionId == prescriptionId) {
									prescriptionListToUpdate[index].autoRefill = autoRefill;
								}
							});
						}
					},
					ajax_update_post_done: function ajax_update_post_done() {
						rxRefillPrescription.bindEvents();
					}
				});
			},
			/**
	   * Reverts auto refill user selection to initial state from prescription JSON 
	   * @param  {number} prescriptionId 	Id of prescription to revert
	   */
			revertAutoRefillUserSelection: function revertAutoRefillUserSelection(prescriptionId) {
	
				var presc = rxRefillPrescription.getPrescriptionJSONById(activePrescriptions, prescriptionId);
				if (presc == undefined) {
					presc = rxRefillPrescription.getPrescriptionJSONById(inactivePrescriptions, prescriptionId);
				}
	
				if (presc != undefined) {
	
					if (presc.autoRefill == 0) {
						$('#autoRefillDisabled_' + prescriptionId).prop('checked', true);
					} else if (presc.autoRefill == 1) {
						$('#autoRefillEnabled_' + prescriptionId).prop('checked', true);
					}
				}
			},
	
			/**
	   * Iteraters through provided JSON array and updates 'checked' property to match user selection
	   * @param {JSON Array} prescriptionJSON 				Prescription JSON array to update
	   * @param {number} 		 prescriptionId   				User selected prescription
	   * @param {String}     ajaxResponseAutoRefill		Ajax response with autorefill option set by command
	   */
			updatePrescriptionAutoRefillInJSON: function updatePrescriptionAutoRefillInJSON(prescriptionJSON, prescriptionId, ajaxResponseAutoRefill) {
				$.each(prescriptionJSON, function (index, value) {
					if (value.prescriptionId == prescriptionId) {
						value.autoRefill = ajaxResponseAutoRefill;
					}
				});
			},
			/**
	   * Gets prescription JSON from input JSON array by ID
	   * @param  {JSON Array} 	prescriptionJSON 	Prescription JSON array
	   * @param  {number} 			prescriptionId   	Id of prescription to find in JSON array
	   * @return {JSON Object}  Found prescription
	   */
			getPrescriptionJSONById: function getPrescriptionJSONById(prescriptionJSON, prescriptionId) {
	
				var json = void 0;
				$.each(prescriptionJSON, function (index, value) {
					if (value.prescriptionId == prescriptionId) {
						json = value;
						return false;
					}
				});
	
				return json;
			},
	
			/**
	   * Handles on click prescription selection
	   * @param {number} prescriptionId 	Prescription id
	   * @param {string} status        	 	Prescription status (active | inactive)
	   * @param {string} element       	 	HTML element user clicked on
	   */
			managePrescriptionSelection: function managePrescriptionSelection(prescriptionId, status, element) {
	
				COSTCO.util.notification.clearNotification();
	
				if (status == 'active') {
					rxRefillPrescription.setPrescriptionSelectionInJSON(activePrescriptions, prescriptionId, element);
				} else if (status == 'inactive') {
					rxRefillPrescription.setPrescriptionSelectionInJSON(inactivePrescriptions, prescriptionId, element);
				} else if (status == 'onFile') {
					rxRefillPrescription.setPrescriptionSelectionInJSON(onFilePrescriptions, prescriptionId, element);
				}
			},
			/**
	   * Iterates through provided JSON array and sets 'checked' property to match user selection
	   * @param {JSON Array} prescriptionJSON 	Prescription JSON array to update
	   * @param {number} prescriptionId   			User selected prescription
	   * @param {Object} element          			Selected prescription input html element
	   */
			setPrescriptionSelectionInJSON: function setPrescriptionSelectionInJSON(prescriptionJSON, prescriptionId, element) {
				$.each(prescriptionJSON, function (index, value) {
					if (value.prescriptionId == prescriptionId) {
						value.checked = $(element).prop('checked');
					}
				});
			},
			/**
	   * Submits refill prescription for review
	   */
			submitForReview: function submitForReview() {
	
				if (rxRefillPrescription.refillPrescriptionInfoForm.isValid()) {
					var form = rxRefillPrescription.refillPrescriptionInfoForm.getForm();
					form.find('input[id="rxPrescriptionNumber"]').val(rxRefillPrescription.getSelectedPrescriptionIds().toString());
					form.submit();
				} else {
					COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [messages.ERR_NO_REFILL_PRESCRIPTION_SELECTED], true, undefined);
				}
			},
			/**
	   * Changes selected prescriptions status from active / inactive to opposite
	   * @param {String} status		Prescription status (active | inactive)
	   */
			changePrescriptionStatus: function changePrescriptionStatus(status) {
				var selectedPrescriptionIds = rxRefillPrescription.getSelectedPrescriptionIds(status);
				if (selectedPrescriptionIds.length) {
	
					COSTCO.Checkout.ajax_update_state({
						error_container: '#notification-message',
						method: 'POST',
						url: rxRefillPrescription.url.CHANGE_PRESCRIPTION_STATUS,
						data: {
							selectedPrescriptionIds: selectedPrescriptionIds.toString(),
							isActive: status == 'active' || status == 'onFile' ? true : false
						},
						dataType: 'json',
						ajax_update_post_done: function ajax_update_post_done() {
							COSTCO.rxRefillPrescription.sortPrescriptionsJSON();
							rxRefillPrescription.bindEvents();
							if (typeof onFilePrescriptions != "undefined" && onFilePrescriptions.length > 0) onFile_loadPrescriptionLists();
							if (typeof inactivePrescriptions != "undefined" && inactivePrescriptions.length > 0) inactive_loadPrescriptionLists();
							if (typeof activePrescriptions != "undefined" && activePrescriptions.length > 0) active_loadPrescriptionLists();
						},
						error: function error() {
							console.log("There was an error processing prescription status change.");
						}
					});
				} else {
					rxRefillPrescription.openChangePrescriptionStatusInfoDialog();
				}
			}
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.rxRefillPrescription = rxRefillPrescription;
	
		return rxRefillPrescription;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title rxaddresshelper.js: Sub-module for Rx pages
	 * @description This module is used to handle address operations
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var rxAddressHelper = {
	
			init: function init(options) {
				rxAddressHelper.url.MANAGE_ADDRESS_UPDATE = options.updateURL;
				rxAddressHelper.url.MANAGE_ADDRESS_ADD = options.addURL;
				rxAddressHelper.url.MANAGE_ADDRESS_SET_DEFAULT = options.setDefaultURL;
			},
	
			currentAddressId: '',
			currentAddressType: '',
	
			/**
	   * URL JSON object should be populated via init(options) funtion
	   * @type {Object}
	   */
			url: {
				MANAGE_ADDRESS_UPDATE: '',
				MANAGE_ADDRESS_ADD: '',
				MANAGE_ADDRESS_SET_DEFAULT: ''
			},
	
			/**
	   * Shows address selection dialog when user tries to change it
	   * @param {String} addressId Address Id of displayed address 
	   * @param {String} addressType Address type of displayed address ('S' - shipping, 'B' - billing)
	   */
			showPrescriptionAddressSelectionDialog: function showPrescriptionAddressSelectionDialog(addressId, addressType) {
	
				COSTCO.util.getAddressBatchPage(addressType, 'FIRSTNAME', 'ASC', '96', function (data) {
	
					rxAddressHelper.currentAddressId = addressId;
					rxAddressHelper.currentAddressType = addressType;
	
					var addressTemplates = {};
					addressTemplates.addressBlock = 'tmpl_choose_address_block';
					addressTemplates.wrapper = 'tmpl_rx_choose_address_wrapper';
					COSTCO.CAddressSelectionDialog.createModal(addressId, addressType, addressTemplates, {});
				});
			},
	
			/**
	   * Sets address to be default 
	   * @param {String} addressId Address id to be set as default
	   */
			setDefault: function setDefault(addressId) {
	
				COSTCO.Checkout.ajax_update_state({
					url: rxAddressHelper.url.MANAGE_ADDRESS_SET_DEFAULT,
					method: "POST",
					dataType: 'json',
					data: {
						authToken: COSTCO.Checkout.getAuthToken(),
						formdata: encodeURIComponent(JSON.stringify({ 'id': addressId }))
					}
				});
	
				$('#costcoModal').modal('hide');
			},
	
			/**
	   * Prepares data for add address modal display
	   * @param {String} addressType Type of address to create ('S' - shipping, 'B' - billing)
	   */
			createNewAddress: function createNewAddress(addressType, addressOptions) {
	
				if (addressOptions == undefined) {
					var addressOptions = {};
				}
	
				addressOptions.url = rxAddressHelper.url.MANAGE_ADDRESS_ADD;
				addressOptions.tmplFooterText = 'tmpl_rx_add_edit_address_footer';
	
				rxAddressHelper.openAddressAddModal(addressType, undefined, 'add', addressOptions);
			},
	
			/**
	   * Prepares data for edit address modal display
	   * @param {String} addressType Type of address to edit ('S' - shipping, 'B' - billing)
	   * @param {Object} obj Address object to be edited
	   */
			editAddress: function editAddress(addressType, obj) {
	
				var data;
	
				if (typeof obj === 'number') {
					var addressJson = COSTCO.CAddress.getAddressJson(obj)[0];
					data = addressJson;
				} else {
					data = obj;
				}
	
				if (data == null) {
					data = window['ajaxAddressObject_' + obj];
				}
	
				if (addressOptions == undefined) {
					var addressOptions = {};
				}
	
				if ($('#address-blocks input:radio:checked').val() == data['id']) {
					data['isPrimary'] = '1';
				}
	
				addressOptions.url = rxAddressHelper.url.MANAGE_ADDRESS_UPDATE;
				addressOptions.tmplFooterText = 'tmpl_rx_add_edit_address_footer';
	
				rxAddressHelper.openAddressAddModal(addressType, data, 'edit', addressOptions);
			},
	
			/**
	   * Opens add/edit address modal
	   * @param {String} addressType Type of address to create ('S' - shipping, 'B' - billing)
	   * @param {Object} addressObj If mode 'edit', address object to prepopulate input fields in modal
	   * @param {String} mode Mode of address modal ('add' - add new address, 'edit' - edit existing address)
	   * @param {String} addressOptions Various options for address add/edit
	   */
			openAddressAddModal: function openAddressAddModal(addressType, addressObj, mode, addressOptions) {
	
				if (addressOptions.tmplFooterText) {
					var footerText = COSTCO.util.tmpl(addressOptions.tmplFooterText, {});
				}
	
				var openAddress = function openAddress(error) {
					var htmlBody = COSTCO.CAddressForm.createHtml(type, addressObj, mode, undefined, undefined, undefined, error);
					// if it is edit mode, trigger jQuery validation immediately
					if (mode == "edit") {
						COSTCO.CAddressForm.validate(addressType, htmlBody);
					}
					COSTCO.CAddress.baseModal(addressType, mode, {
						body: htmlBody,
						footerText: footerText,
						primary_event: function primary_event() {
							if (COSTCO.CAddressForm.validate(addressType)) {
								COSTCO.CAddressForm.submit(addressType, false, addressOptions);
							}
						}
					});
				};
	
				openAddress(undefined);
	
				$('body').unbind("costco.address.error").bind("costco.address.error", function (event, error) {
					openAddress(error);
				});
			},
	
			/**
	   * Opens info dialog on click "Why?" link in choose address modal
	   */
			showDefaultPharmacyAddressInfoDialog: function showDefaultPharmacyAddressInfoDialog() {
	
				COSTCO.dialog.createExtDialogBox({
					title: messages.PRESCRIPTION_PHARMACY__DefaultAddress_DialogText,
					body: COSTCO.util.tmpl('tmpl_rx_default_pharmacy_address_info_dialog', {}),
					close: function close() {
						rxAddressHelper.showPrescriptionAddressSelectionDialog(rxAddressHelper.currentAddressId, rxAddressHelper.currentAddressType);
					}
				});
			}
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.rxAddressHelper = rxAddressHelper;
	
		return rxAddressHelper;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	* @title rxnewprescription.js: Sub-module for new prescription page
	* @description This module is used to handle various new prescription related tasks
	* @dependences 
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(114)], __WEBPACK_AMD_DEFINE_RESULT__ = function (rxAddressHelper) {
	
		var rxNewPrescription = {
	
			init: function init(options) {
				if ($('#new-prescription-info').length == 1) {
					rxNewPrescription.populateStateSelectBox();
					rxNewPrescription.bindEvents();
					rxNewPrescription.maskInput();
				}
				rxNewPrescription.showHideShippingAndBillingSection();
	
				if (options != undefined) {
					rxAddressHelper.init(options);
				}
			},
			/**
	   * show and hide billing and shipping section
	   */
			showHideShippingAndBillingSection: function showHideShippingAndBillingSection() {
	
				$('#ship-when-ready').click(function () {
					$('#billing-and-shiping').show();
					if ($('#complete-prescription-request-button').attr('data-is-disabled-by-default') == 'true') {
						$('#complete-prescription-request-button').prop('disabled', true);
					}
				});
	
				$('#notify-when-ready').click(function () {
					$('#billing-and-shiping').hide();
					if ($('#complete-prescription-request-button').attr('data-is-disabled-by-default') == 'true') {
						$('#complete-prescription-request-button').prop('disabled', false);
					}
				});
			},
			/**
	   * Gets new prescription info form
	   * @return {form} New prescription info jquery form
	   */
			getForm: function getForm() {
				return $('#NewPrescriptionForm');
			},
	
			/**
	   * Binding events
	   */
			bindEvents: function bindEvents() {
				$('#new_prescription_next_button').click(function () {
					rxNewPrescription.proceedToNextPage();
				});
				$('#add-more-prescriptions-button').click(function () {
					COSTCO.rxPrescriptionHelper.drugSection.addMorePrescriptions('drug-info-block', 'single_drug_row');
				});
	
				$('body').on('hidden.bs.popover', function (e) {
					$(e.target).data('bs.popover').inState.click = false;
				});
			},
	
			/**
	   * Validates data on form and submits it.
	   */
			proceedToNextPage: function proceedToNextPage() {
				if (rxNewPrescription.validate()) {
					var form = rxNewPrescription.getForm();
					COSTCO.rxPrescriptionHelper.drugSection.setFilledPresciptionsCount();
					rxNewPrescription.getForm().submit();
				}
			},
	
			/**
	   * Populates state select field
	   */
			populateStateSelectBox: function populateStateSelectBox() {
				var form = rxNewPrescription.getForm();
				if (form.find('.state-select').length) {
					var stateProvList = this.getStateProvJson();
					var stateOptions = this.getStateOptions(stateProvList);
					form.find('.state-select').append(stateOptions);
				}
				var state_default = $('input[name=state_old]').val();
				if (state_default != "") {
					form.find('.state-select').val(state_default);
				}
			},
	
			/**
	      * [description]
	      * @param  {[type]} stateProvList [description]
	      * @return {[type]}               [description]
	      */
			getStateOptions: function getStateOptions(stateProvList) {
				return COSTCO.CAddressForm.getStateOptions(stateProvList);
			},
			/**
	   * [description]
	   * @return {[type]} [description]
	   */
			getStateProvJson: function getStateProvJson() {
				return COSTCO.CAddress.getStateProvJson();
			},
			/**
	   * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val()
	   * to get unformatted value
	   * @param  {[type]} template [description]
	   * @return {void}          [description]
	   */
			maskInput: function maskInput() {
				$('#NewPrescriptionForm').find('[name=physicianPhone]').unmask().mask('(000) 000-0000');
			},
	
			validationRulesApplied: false,
	
			/**
	   * Set of rules used for new prescription form validation
	   */
			validationRules: function validationRules() {
	
				if (!rxNewPrescription.validationRulesApplied) {
					$.validator.addMethod("notEqual", function (value, element, param) {
						return this.optional(element) || value != param;
					}, messages.ERR_INVALID_STATE);
					$.validator.addMethod("physicianPhone", function (value, element) {
						return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
					}, messages.ERR_INVALID_PHONE1);
					/*Custom Validator to make sure at least one drug name (or Rx number por transfer) is entered*/
					$.validator.addMethod("require_from_group", COSTCO.rxPrescriptionHelper.drugSection.drugNameValidationMethod, messages.ERR_REQUIRED_DRUG_NAME);
	
					rxNewPrescription.validationRulesApplied = true;
				}
			},
	
			/**
	   * Form validation
	   */
			validate: function validate() {
				rxNewPrescription.validationRules();
				var form = rxNewPrescription.getForm();
				if (form.length != 0) {
					form.validate({
						focusInvalid: false,
						invalidHandler: COSTCO.util.invalid_handler,
						groups: {
							drugNames: COSTCO.rxPrescriptionHelper.drugSection.drugNames
						},
						rules: {
							physicianName: { required: true },
							physicianCity: { required: true },
							physicianState: { required: true, notEqual: "NO_STATE_TYPE_SELECTED" },
							physicianPhone: { required: true, physicianPhone: true },
							willMailPrescription: { required: true },
							drugName_0: { require_from_group: [1, '.drug-name'] }
						},
						messages: {
							physicianName: messages.ERR_REQUIRED_PHYSICIAN_NAME,
							physicianPhone: { required: messages.ERR_REQUIRED_PHYSICIAN_PHONE, physicianPhone: messages.ERR_INVALID_PHONE_NUMBER },
							physicianCity: messages.ERR_REQUIRED_PHYSICIAN_CITY,
							physicianState: messages.ERR_INVALID_STATE,
							willMailPrescription: messages.ERR_REQUIRED_ORIGINAL_PRESCRIPTION,
							drugName_0: messages.ERR_REQUIRED_DRUG_NAME
						},
						errorPlacement: function errorPlacement(error, element) {
	
							if (element.hasClass('state-select')) {
								error.appendTo(element);
								error.insertAfter($('[name=physicianState]').parent());
							} else if (element.hasClass('drug-name')) {
								if (element.attr('name') === 'drugName_0') {
									error.appendTo(element.parent());
								}
							}
							//set error placement for radio button in newPrescription page
							else if (element.attr('type') === 'radio') {
									error.insertBefore($('#options-group'));
								} else {
									error.appendTo(element.parent());
								}
						}
					});
	
					var selectsValid = true;
					form.find('.style-select > select').each(function () {
						$(this).unbind('change').change(function () {
							if ($(this).val() === "NO_STATE_TYPE_SELECTED") {
								selectsValid = false;
								$(this).parent().addClass('error');
							} else {
								$(this).parent().removeClass('error');
							}
						});
					});
	
					form.find('.style-select > select').change();
					return form.valid() && selectsValid;
				}
			}
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.rxNewPrescription = rxNewPrescription;
	
		return rxNewPrescription;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title rxtransferprescription.js: Sub-module for Rx Transfer Prescription pages
	 * @description This module is used to handle various tasks related to transfer prescriptions
	 * @dependency rxaddresshelper
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(114)], __WEBPACK_AMD_DEFINE_RESULT__ = function (rxAddressHelper) {
	
		var rxTransferPrescription = {
	
			/**
	   * Initializes Transfer Prescription module.
	   */
			init: function init(options) {
				if (options != undefined) {
					rxAddressHelper.init(options);
				}
				rxTransferPrescription.populateStateSelectBox();
				rxTransferPrescription.bindEvents();
				rxTransferPrescription.addCustomValidators();
				rxTransferPrescription.maskInput();
				console.log('Transfer Prescription module initialized.');
			},
			/**
	   * Populates state select field
	   */
			populateStateSelectBox: function populateStateSelectBox() {
				var form = rxTransferPrescription.getForm();
				if (form.find('.state-select').length) {
					var stateProvList = this.getStateProvJson();
					var stateOptions = this.getStateOptions(stateProvList);
					form.find('.state-select').append(stateOptions);
				}
				var state_default = $('input[name=pharmacyState]').val();
				if (state_default != "") {
					form.find('.state-select').val(state_default);
				} else {
					form.find('.state-select').val("NO_STATE_TYPE_SELECTED");
				}
			},
			getForm: function getForm() {
				return $('#transfer-prescription-form');
			},
			/**
	       * [description]
	       * @param  {[type]} stateProvList [description]
	       * @return {[type]}               [description]
	       */
			getStateOptions: function getStateOptions(stateProvList) {
				return COSTCO.CAddressForm.getStateOptions(stateProvList);
			},
			/**
	   * [description]
	   * @return {[type]} [description]
	   */
			getStateProvJson: function getStateProvJson() {
				//return COSTCO.CAddress.getStateProvJson();
				return transferPrescriptionCountry;
			},
			/**
	   * Binds events on page.
	   */
			bindEvents: function bindEvents() {
				// Prevent submit form when pressing Enter in Warehouse Location input field, and execute findWarehouse(keyword)
				$('#warehouse-search-keyword').keypress(function (event) {
					if (event.keyCode == 13) {
						event.preventDefault();
						rxTransferPrescription.findWarehouse($('#warehouse-search-keyword').val());
					}
				});
	
				$('#find-warehouse-onclick-submit').click(function () {
					rxTransferPrescription.findWarehouse($('#warehouse-search-keyword').val());
				});
	
				$('#add-more-prescriptions-button').click(function () {
					COSTCO.rxPrescriptionHelper.drugSection.addMorePrescriptions('drug-info-block', 'transfer_single_drug_row');
				});
	
				$('#transfer-prescription-next-button').click(function (event) {
					rxTransferPrescription.validateAndSubmit(event);
				});
	
				$('#default-shipping-tooltip').popover({
					trigger: 'hover focus',
					placement: 'top'
				});
	
				$('#default-shipping-tooltip').on('keydown', function (event) {
					if (event.which == 27) $(this).popover('hide');
				});
	
				$('#prescription-information-tooltip').popover({
					trigger: 'hover focus',
					placement: 'top'
				});
	
				$('#prescription-information-tooltip').on('keydown', function (event) {
					if (event.which == 27) $(this).popover('hide');
				});
	
				$('#ship-when-ready').click(function () {
					$('#billing-and-shiping').show();
					if ($('#complete-prescription-request-button').attr('data-is-disabled-by-default') == 'true') {
						$('#complete-prescription-request-button').prop('disabled', true);
					}
				});
	
				$('#notify-when-ready').click(function () {
					$('#billing-and-shiping').hide();
					if ($('#complete-prescription-request-button').attr('data-is-disabled-by-default') == 'true') {
						$('#complete-prescription-request-button').prop('disabled', false);
					}
				});
			},
	
			/**
	   * Form ID.
	   */
			FORM_ID: 'transfer-prescription-form',
	
			/**
	   * Initial value.
	   */
			validationRulesApplied: false,
	
			/**
	   * Validation rules for Transfer prescription
	   */
			validationRules: function validationRules() {
	
				if (!rxTransferPrescription.validationRulesApplied) {
					$.validator.addMethod("notEqual", function (value, element, param) {
						return this.optional(element) || value != param;
					}, messages.ERR_INVALID_STATE);
					$.validator.addMethod("pharmacyPhone", function (value, element) {
						return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
					}, messages.ERR_INVALID_PHONE1);
					$.validator.addMethod("prescriptionNumber_invalid", function (value, element) {
						return this.optional(element) || /(^[0-9a-zA-Z\s\-]+$)/.test(value);
					}, messages.ERR_INVALID_RX_NUMBER);
					$.validator.addMethod("drugName_0", function (value, element) {
						return !this.optional(element) && /(^[0-9a-zA-Z\s\-\%\*\,\.\/\&\(\)]+$)/.test(value);
					}, messages.ERR_INVALID_PRESCRIPTION_DRUG_NAME);
					$.validator.addMethod("drugName_others", function (value, element) {
						return this.optional(element) || /(^[0-9a-zA-Z\s\-\%\*\,\.\/\&\(\)]+$)/.test(value);
					}, messages.ERR_INVALID_PRESCRIPTION_DRUG_NAME);
					$.validator.addMethod("drugName_w_rxNum", function (value, element) {
						var id = element.id.split("_");
						var prescriptionNumberId = "#prescriptionNumber_" + id[1];
						var prescriptionNumberValue = $(prescriptionNumberId).val();
						return prescriptionNumberValue !== "" && this.optional(element) ? false : true;
					}, messages.ERR_REQUIRED_DRUG_NAME);
					$.validator.addMethod("pharmacyName", function (value, element) {
						return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
					}, messages.ERR_REQUIRED_PHARMACY_NAME);
	
					rxTransferPrescription.validationRulesApplied = true;
				}
			},
	
			/**
	   * Add custom rules to the form validation
	   */
			addCustomValidators: function addCustomValidators() {
	
				//Ensures given element is not visible on the page in order to continue
				$.validator.addMethod("isNotVisible", function (value, element, param) {
					return !$(element).is(":visible");
				}, messages.ERR2_REQUIRED_WAREHOUSE_NUMBER);
			},
			maskInput: function maskInput() {
				$('#transfer-prescription-form').find('[name=pharmacyPhone]').unmask().mask('(000) 000-0000');
			},
			/**
	      * Form validation.
	      */
			validate: function validate() {
				$("#red-box-error").addClass("hidden");
				rxTransferPrescription.validationRules();
				var form = $('#' + rxTransferPrescription.FORM_ID);
				if (form.length > 0) {
					form.validate({
						focusInvalid: false,
						ignore: '',
						invalidHandler: COSTCO.util.invalid_handler,
	
						rules: {
							warehouseSearchKeyword: { isNotVisible: true },
							drugName_0: { required: true, drugName_0: true },
							pharmacyName: { required: true, pharmacyName: true },
							pharmacyPhone: { required: true },
							pharmacyCity: { required: true },
							pharmacyState: { required: true, notEqual: "NO_STATE_TYPE_SELECTED" }
						},
						messages: {
							warehouseSearchKeyword: {
								digits: messages.ERR_INVALID_WAREHOUSE_NUMBER
							},
							drugName_0: { required: messages.ERR_REQUIRED_DRUG_NAME },
							pharmacyName: { required: messages.ERR_REQUIRED_PHARMACY_NAME },
							pharmacyPhone: { required: messages.ERR_INVALID_PHONE1 },
							pharmacyCity: { required: messages.ERR_REQUIRED_PHYSICIAN_CITY },
							pharmacyState: { required: messages.ERR_INVALID_STATE }
						},
						errorPlacement: function errorPlacement(error, element) {
							if (element.hasClass('drug-name') || element.hasClass('prescription-number')) {
								error.insertAfter(element);
							} else if (element.attr('id') == 'warehouse-search-keyword') {
								error.insertAfter(element.closest('.input-group'));
							}
	
							if (element.hasClass('input-outline')) {
								error.insertAfter(element);
							}
						}
					});
					$.validator.addClassRules("prescription-number", {
						prescriptionNumber_invalid: true
					});
					$.validator.addClassRules("drug-name", {
						drugName_others: true, drugName_w_rxNum: true
					});
				}
				return form.valid();
			},
	
			/**
	   * Redirects to Warehouse Location page, passing the search keyword as parameter.
	   * @param {string} searchKeyword Search term.
	   */
			findWarehouse: function findWarehouse(searchKeyword) {
				if (searchKeyword == null || searchKeyword == undefined) {
					searchKeyword = '';
				}
				var prescriptionForm = document.forms[rxTransferPrescription.FORM_ID];
				prescriptionForm.location.value = searchKeyword.trim();
				prescriptionForm.action = '/transfer-warehouse-location?storeId=' + wcs.storeId + '&langId=' + wcs.langId + '&catalogId=' + wcs.catalogId + '&isPharmacy=true&location=' + searchKeyword.trim();
				COSTCO.rxPrescriptionHelper.drugSection.setFilledPresciptionsCount();
				prescriptionForm.submit();
			},
	
			/**
	   * Validates data and submits the form.
	   */
			validateAndSubmit: function validateAndSubmit(event) {
				if (rxTransferPrescription.validate()) {
					COSTCO.rxPrescriptionHelper.drugSection.setFilledPresciptionsCount();
					$('#' + rxTransferPrescription.FORM_ID).submit();
				} else {
					event.preventDefault();
				}
			}
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.rxTransferPrescription = rxTransferPrescription;
	
		return rxTransferPrescription;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title rxpatientprofile.js: Sub-module for Global pages
	 * @description This module is used for patient profile
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(23), __webpack_require__(6), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (helper, PaymentMethods, addressBook, memberVerification) {
		var regexes = {
			POLICY_HOLDER_NAME: /^[a-zA-Z0-9-\s]*$/,
			DOB_FORMAT: /^(0[1-9]|1[012])[\/](0[1-9]|[12][0-9]|3[01])[\/](19|20)\d\d$/,
			RX_NUMBER: /\(?([0-9]{3})\)\s([0-9]{3})\2?([-]?)([0-9]{4})/,
			BIN_NUMBER: /^(?=.*(.)(?!$|.*\1))(?=.*(?!\1))[0-9]{6}$/,
			PCN_NUMBER: /^[a-zA-Z0-9]{0,15}$/,
			IS_ZEROS: /^0+$/
		};
		var rxPatientProfile = {
	
			dynamicFormElement: {},
			newTab: undefined,
	
			init: function init() {
				PaymentMethods.init();
				addressBook.init();
				memberVerification.init();
				helper.dobPopulate(this.getForm(), 100);
				this.addValidationMethods();
				this.setSelectedValuesForDate();
				this.bindEvents();
				this.maskInput(this.getForm());
				this.displayAutoRefillDisabled();
				this.displayNotificationMessage();
				this.bindHeaderAndFooterLinksForLeavePageModal();
			},
	
			bindHeaderAndFooterLinksForLeavePageModal: function bindHeaderAndFooterLinksForLeavePageModal() {
				var headerAndFooterLinks = $('#header-widget, #leftnav, #crumbs_ul, #footer-widget, #footer-bottom, #header-pharmacy-user-box, .menu').find("a").not('#customer-service-header');
				headerAndFooterLinks.click(function () {
					var addressValue = $(this).attr("href");
					if (addressValue != '#' && addressValue != 'javascript:void(0);') {
						var existingProfile = $('#existingProfile').val();
						if (existingProfile === 'false') {
							COSTCO.rxPatientProfile.openLeavePageModal(addressValue);
						} else {
							window.location.href = DOMPurify.sanitize(secondaryButtonHref); //Sanitize data.
						}
					}
	
					return false;
				});
			},
	
			/**
	   * Bind the back url on patient profile page load
	   *
	   */
			detectBackButton: function detectBackButton() {
				if (typeof history.pushState === "function") {
					history.pushState("back", null, null);
					window.onpopstate = function () {
						history.pushState('back', null, null);
						var address = document.referrer;
						COSTCO.rxPatientProfile.openLeavePageModal(address);
					};
				}
			},
	
			openLeavePageModal: function openLeavePageModal(secondaryButtonHref) {
				COSTCO.dialog.modalStack({
					title: messages.PATIENTPROFILE_PHARMACY__LEAVE_PAGE_TITLE,
					body: COSTCO.util.tmpl('patient_profile_leave_page_modal_body_tmpl'),
					primary: messages.PATIENTPROFILE_PHARMACY__MODAL_BUTTON_STAY_ON_PAGE,
					secondary: messages.PATIENTPROFILE_PHARMACY__MODAL_BUTTON_LEAVE_PAGE,
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					},
					secondary_event: function secondary_event() {
						window.location.href = DOMPurify.sanitize(secondaryButtonHref); //Sanitize data.
					}
				});
			},
	
			/**
	   * Bind events on various html elements on the Patient Profile page
	   */
			bindEvents: function bindEvents() {
				$('#medication_list').keypress(function () {
					return this.value.length < 500;
				});
				$('#medication_list').bind('paste', function () {
					return this.value.length + window.clipboardData.getData('Text').length < 500;
				});
	
				$('input[name^=drugAllergy_]').bind('keyup change', function () {
					COSTCO.rxPatientProfile.getForm().validate().element('input[name=allergiesSelected]');
				});
	
				$('input[name^=medicalCondition_]').bind('keyup change', function () {
					COSTCO.rxPatientProfile.getForm().validate().element('input[name=medicalConditionsSelected]');
				});
	
				$('input[name=medicationList]').bind('keyup', function () {
					COSTCO.rxPatientProfile.getForm().validate().element('input[name=medicationsSelected]');
				});
	
				$('#navigation-tabs .table-cell').click(function (event) {
					var clickedTab = $(event.target).find('a').length ? $(event.target).find('a').attr('href').substr(1) : $(event.target).attr('href').substr(1);
					COSTCO.rxPatientProfile.validateCurrentTabBeforeOpenClickedTab(clickedTab, event);
				});
	
				$('#navigation-tabs a').click(function (event) {
					event.preventDefault();
				});
	
				$('#PaymentMethodForm input[id=check-button]').unbind().click(function (event) {
					$('#addCardClicked').val('true');
				});
			},
			/**
	   * Add validation methods for form validation
	   */
			addValidationMethods: function addValidationMethods() {
				// custom validation for date of birth
				$.validator.addMethod('dob', function (value, element, param) {
	
					var form = COSTCO.rxPatientProfile.getForm();
					var valid = true;
					var month = void 0;
					var day = void 0;
					var year = void 0;
					var errField = void 0;
					var idate = void 0;
					var isFuture = false;
					var dateEntered = false;
	
					var isFutureDate = function isFutureDate(idate) {
						var today = new Date().getTime();
						idate = idate.split('/');
						idate = new Date(idate[2], idate[0] - 1, idate[1]).getTime();
						return today - idate < 0 ? true : false;
					};
	
					if (element.name == 'month' || element.name == 'day' || element.name == 'year') {
						month = form.find('select[name=month]').val();
						day = form.find('select[name=day]').val();
						year = form.find('select[name=year]').val();
						dateEntered = month != 'Month' & day != 'Day' & year != 'Year';
						errField = '#dob_error';
					} else if (element.name == 'monthInsurance' || element.name == 'dayInsurance' || element.name == 'yearInsurance') {
						month = form.find('select[name=monthInsurance]').val();
						day = form.find('select[name=dayInsurance]').val();
						year = form.find('select[name=yearInsurance]').val();
						dateEntered = month != 'Month' & day != 'Day' & year != 'Year';
						errField = '#insurance_dob_error';
					}
	
					if (month != 'Month' && day != 'Day' && year != 'Year') {
						idate = month + '/' + day + '/' + year;
						if (isFutureDate(idate)) {
							isFuture = true;
						}
					}
					if (dateEntered && !isFuture) {
						$(errField).hide();
						$('.dateOfBirth').removeClass('error select-error');
						valid = true;
					} else {
						$(element).closest('.dateOfBirth').addClass('error select-error');
						$(errField).show();
						if (isFuture) {
							$(errField)[0].innerHTML = messages.ERR_INCORRECT_DATE_OF_BIRTH;
						} else {
							$(errField)[0].innerHTML = messages.ERR_REQUIRED_DOB;
						}
						valid = false;
					}
					return valid;
				}, '');
	
				$.validator.addMethod('drugAllergies', function (value, element) {
	
					var form = COSTCO.rxPatientProfile.getForm();
	
					if ($("#is_allergies_yes").is(':checked') && $('#drugAllergy_other').val() == "") {
						return $('[name^=drugAllergy_]:checked').length > 0;
					} else {
						return true;
					}
				}, messages.ERR_REQUIRED_DRUG_ALLERGIES_V2);
	
				$.validator.addMethod('medicalConditions', function (value, element) {
	
					var form = COSTCO.rxPatientProfile.getForm();
	
					if ($("#is_medical_conditions_yes").is(':checked') && $('#medicalCondition_other').val() == "") {
						return $('[name^=medicalCondition_]:checked').length > 0;
					} else {
						return true;
					}
				}, messages.ERR_REQUIRED_MEDICAL_CONDITIONS_V2);
	
				$.validator.addMethod('medications', function (value, element) {
					if ($("#is_medication_yes").is(':checked') && $('#medication_list').val() == "") {
						return false;
					} else {
						return true;
					}
				}, messages.ERR_REQUIRED_MEDICATIONS_V2);
	
				$.validator.addMethod('policyHolderRegEx', function (value, element) {
					return regexes.POLICY_HOLDER_NAME.test(value);
				}, messages.ERR_INVALID_POLICYHOLDER);
	
				$.validator.addMethod('phone', function (value, element) {
					return regexes.RX_NUMBER.test(value);
				}, messages.ERR_INVALID_PHONE_NUMBER);
	
				/** STRY0157080 Require at least ONE alphabet in each of the name fields */
				$.validator.addMethod("firstNameValidation", function (value, element) {
					return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
				}, messages.ERR_INVALID_FNAME);
				$.validator.addMethod("lastNameValidation", function (value, element) {
					return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
				}, messages.ERR_INVALID_LNAME);
				$.validator.addMethod("binNumberIsNumeric", function (value, element) {
					return regexes.BIN_NUMBER.test(value);
				}, messages.INVALID_BIN_NUMBER);
				$.validator.addMethod("pcnNumberIsAlphaNumeric", function (value, element) {
					if ($('#pcnNumber').val() == "" || regexes.PCN_NUMBER.test(value)) {
						return true;
					} else {
						return regexes.PCN_NUMBER.test(value);
					}
				}, messages.INVALID_PCN_NUMBER);
			},
			/**
	   * If form is not valid for current tab(fromTab), prevent going on next tab(toTab)
	   * and stay on current tab
	   *  
	       * @param  {[fromTab]} from tab name
	       * @param  {[toTab]} to tab name
	       * @param  {[event]} event
	      * @return {void}
	   */
			setActiveTabAndStopProgress: function setActiveTabAndStopProgress(fromTab, toTab, event) {
				if (fromTab != toTab) {
					$('a[href*=' + fromTab + ']').parent().addClass('active');
					$('a[href*=' + toTab + ']').parent().removeClass('active');
					$('#' + fromTab).addClass('active in');
					$('#' + toTab).removeClass('active in');
					event.stopPropagation();
				}
			},
			/**
	   * If form is not valid for current tab(fromTab), prevent going on next tab(toTab)
	   * and stay on current tab
	   *  
	       * @param  {[currentTab]} current tab name
	       * @param  {[clickedTab]} clicked tab name
	   */
			goToTab: function goToTab(currentTab, clickedTab) {
				$('a[href*=' + clickedTab + ']').removeAttr('tabindex');
				$('a[href*=' + clickedTab + ']').parent().addClass('active');
				$('a[href*=' + currentTab + ']').parent().removeClass('active');
				$('#' + clickedTab).addClass('active in');
				$('#' + currentTab).removeClass('active in');
			},
			/**
	   * Validate current tab before going on clicked tab
	   *  
	   * @param  {[clickedTab]} from tab name
	   * @param  {[event]} event
	   * @return {void}
	   */
			validateCurrentTabBeforeOpenClickedTab: function validateCurrentTabBeforeOpenClickedTab(clickedTab, event) {
	
				var element = $(event.currentTarget.firstElementChild).length > 0 ? event.currentTarget.firstElementChild.hash : event.currentTarget.hash;
				var currentTab = $('#patient-profile .tab-pane.active.in').attr('id');
				this.newTab = clickedTab;
	
				if (currentTab == clickedTab) {
					return;
				}
	
				this.goToTab(currentTab, clickedTab);
	
				switch (clickedTab) {
					case 'insurance':
						if (!COSTCO.rxPatientProfile.validateAccountAndPatientInfo()) {
							COSTCO.rxPatientProfile.setActiveTabAndStopProgress('account-and-patient-info', clickedTab, event);
						}
						break;
	
					case 'payment-method':
						if (!COSTCO.rxPatientProfile.validateAccountAndPatientInfo()) {
							COSTCO.rxPatientProfile.setActiveTabAndStopProgress('account-and-patient-info', clickedTab, event);
						} else if (!COSTCO.rxPatientProfile.validateInsurance()) {
							COSTCO.rxPatientProfile.setActiveTabAndStopProgress('insurance', clickedTab, event);
						}
						break;
	
					case 'address':
						if (!COSTCO.rxPatientProfile.validateAccountAndPatientInfo()) {
							COSTCO.rxPatientProfile.setActiveTabAndStopProgress('account-and-patient-info', clickedTab, event);
						} else if (!COSTCO.rxPatientProfile.validateInsurance()) {
							COSTCO.rxPatientProfile.setActiveTabAndStopProgress('insurance', clickedTab, event);
						}
						addressBook.bindEvents();
						break;
	
					case 'privacy':
						if (!COSTCO.rxPatientProfile.validateAccountAndPatientInfo()) {
							COSTCO.rxPatientProfile.setActiveTabAndStopProgress('account-and-patient-info', clickedTab, event);
						} else if (!COSTCO.rxPatientProfile.validateInsurance()) {
							COSTCO.rxPatientProfile.setActiveTabAndStopProgress('insurance', clickedTab, event);
						} else if (!COSTCO.rxPatientProfile.validateAddress()) {
							COSTCO.rxPatientProfile.setActiveTabAndStopProgress('address', clickedTab, event);
						}
						break;
	
					default:
						this.goToTab(currentTab, clickedTab);
						break;
				}
	
				COSTCO.util.notification.clearNotification();
			},
			/**
	   * get form patient-profile-form
	   */
			getForm: function getForm() {
				return $('#patient-profile-form');
			},
			/**
	   * go on previous tab on click button back
	   */
			back: function back() {
				var activeTab = $('#navigation-tabs').find('a[aria-selected="true"]').parent();
				if (activeTab.length) {
					var prevTab = activeTab.prev();
					var prevTabArticle = $(prevTab).find('a');
					if (!prevTabArticle) {
						return;
					}
					var prevTabArticleHref = prevTabArticle.attr("href");
					if (!prevTabArticleHref || !prevTabArticleHref.length) {
						return;
					}
					this.newTab = prevTabArticleHref.substr(1);
				}
				rxPatientProfile.updateA11yAriaSelected();
				$('#navigation-tabs .active').prev('div').trigger('click');
				$('html, body').animate({ scrollTop: 200 }, 300);
			},
			/**
	   * go on next tab on click button back
	   */
			next: function next() {
	
				var activeTab = $('#navigation-tabs .active').find('a').attr("href").substr(1);
	
				switch (activeTab) {
					case 'account-and-patient-info':
						this.newTab = 'insurance';
						if (COSTCO.rxPatientProfile.validateAccountAndPatientInfo()) {
							COSTCO.rxPatientProfile.goNext();
						}
						break;
					case 'insurance':
						this.newTab = 'payment-method';
						if (COSTCO.rxPatientProfile.validateInsurance()) {
							COSTCO.rxPatientProfile.goNext();
						}
						break;
					case 'payment-method':
						$('#addCardClicked').val('false');
						this.newTab = 'address';
						COSTCO.rxPatientProfile.goNext();
						addressBook.addjustCells('.resizable');
						break;
					case 'address':
						this.newTab = 'privacy';
						if (COSTCO.rxPatientProfile.validateAddress()) {
							COSTCO.util.notification.clearNotification();
							COSTCO.rxPatientProfile.goNext();
						}
						addressBook.bindEvents();
						break;
					default:
						COSTCO.rxPatientProfile.goNext();
						break;
				}
			},
			/**
	   * Uses Jquery Mask plugin to format input.
	   * 
	   * @param  {[type]} template [description]
	   * @return {void}          [description]
	   */
			maskInput: function maskInput(template) {
				if ($(template).find('[name=insurancePhone]')) {
					$(template).find('[name=insurancePhone]').unmask().mask('(000) 000-0000');
				}
			},
			/**
	   * Validate AccountAndPatientInfo
	   * 
	   * @param {void}
	   * @return {boolean}
	   */
			validateAccountAndPatientInfo: function validateAccountAndPatientInfo() {
				var settings = this.getForm().validate().settings;
				settings.rules = {
					patientFirstName: { required: true, firstNameValidation: true },
					patientLastName: { required: true, lastNameValidation: true },
					month: { dob: true },
					day: { dob: true },
					year: { dob: true },
					gender: 'required',
					profileType: 'required',
					allergiesSelected: { required: true, drugAllergies: true },
					medicalConditionsSelected: { required: true, medicalConditions: true },
					medicationsSelected: { required: true, medications: true }
				};
				settings.messages = {
					patientFirstName: { required: messages.ERR_REQUIRED_PT_FIRST_NAME, firstNameValidation: messages.ERR_INVALID_FNAME },
					patientLastName: { required: messages.ERR_REQUIRED_PT_LAST_NAME, lastNameValidation: messages.ERR_INVALID_LNAME },
					gender: messages.ERR_REQUIRED_PT_GENDER,
					profileType: messages.ERR_REQUIRED_PT_PROFILETYPE,
					allergiesSelected: { required: messages.ERR_REQUIRED_YES_NO_ANSWER, drugAllergies: messages.ERR_REQUIRED_DRUG_ALLERGIES_V2 },
					medicalConditionsSelected: { required: messages.ERR_REQUIRED_YES_NO_ANSWER, medicalConditions: messages.ERR_REQUIRED_MEDICAL_CONDITIONS_V2 },
					medicationsSelected: { required: messages.ERR_REQUIRED_YES_NO_ANSWER, medications: messages.ERR_REQUIRED_MEDICATIONS_V2 }
	
				};
				settings.errorPlacement = function (error, element) {
					if (element.is(":radio")) {
						error.appendTo(element.parents('.error-check'));
						error.css({ 'width': '100%' });
					} else {
						error.insertAfter(element);
					}
				};
	
				return this.getForm().valid();
			},
	
			/**
	   * Validate Insurance
	   * 
	   * @param {void}
	   * @return {boolean}
	   */
			validateInsurance: function validateInsurance() {
				var binNumber = $('[name="binNumber"]').val();
				$('[name="binNumber"]').val(this.padZeros(binNumber));
	
				var settings = this.getForm().validate().settings;
				var radioYesSelected = $('#radioYes').is(':checked');
				settings.rules = {
					insuranceSelected: { required: true },
					insuranceMemberId: { required: radioYesSelected },
					groupNumber: { required: radioYesSelected },
					policyholderName: { required: radioYesSelected, policyHolderRegEx: radioYesSelected },
					binNumber: { required: radioYesSelected, binNumberIsNumeric: radioYesSelected },
					pcnNumber: { pcnNumberIsAlphaNumeric: radioYesSelected },
					monthInsurance: { dob: radioYesSelected },
					dayInsurance: { dob: radioYesSelected },
					yearInsurance: { dob: radioYesSelected },
					planName: { required: radioYesSelected },
					insurancePhone: { required: radioYesSelected, phone: radioYesSelected } };
	
				settings.messages = {
					insuranceSelected: messages.ERR_REQUIRED_YES_NO_ANSWER,
					insuranceMemberId: messages.ERR_REQUIRED_MEMBER_ID,
					groupNumber: messages.ERR_REQUIRED_GROUP_NUMBER,
					binNumber: { required: messages.INVALID_BIN_NUMBER, binNumberIsNumeric: messages.INVALID_BIN_NUMBER },
					pcnNumber: { pcnNumberIsAlphaNumeric: messages.INVALID_PCN_NUMBER },
					policyholderName: { required: messages.ERR_REQUIRED_POLICYHOLDER_NAME,
						policyHolderRegEx: messages.ERR_INVALID_POLICYHOLDER },
					planName: messages.ERR_REQUIRED_PLAN_NAME,
					insurancePhone: { required: messages.ERR_REQUIRED_INSURANCE_PHONE,
						phone: messages.ERR_INVALID_PHONE_NUMBER } };
	
				settings.errorPlacement = function (error, element) {
					if (element.is(":radio")) {
						error.appendTo(element.parents('.insuranceBody'));
					} else {
						error.insertAfter(element);
					}
				};
				return this.getForm().valid();
			},
			/**
	   * Validate Payment method
	   */
			validatePaymentMethod: function validatePaymentMethod() {
				if ($('#PaymentMethodForm').length > 0) {
					TokenGateway.updateSessionFromForm('card', function () {
						COSTCO.PaymentMethods.formSubmitter();
					}, 'PaymentMethodForm');
	
					return false;
				} else {
					return true;
				}
			},
	
			/**
	   * Validate address
	   */
			validateAddress: function validateAddress() {
	
				var valid = true;
				var errors = [];
	
				if (addressBook.getDefaultAddress(addressBook.ADDRESS_TYPE_SHIPPING).length == 0) {
					valid = false;
					errors.push(messages.ERR_ADDRESSBOOK_MISSING_SHIPPING_ADDR);
				}
				//see if address length is longer than 30 characters - stry0130872
				else if (addressBook.getDefaultAddress(addressBook.ADDRESS_TYPE_SHIPPING)[0].addressLine0.length > 30) {
						valid = false;
						errors.push(messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE);
					}
	
				if (addressBook.getDefaultAddress(addressBook.ADDRESS_TYPE_BILLING).length == 0) {
					valid = false;
					errors.push(messages.ERR_ADDRESSBOOK_MISSING_BILLING_ADDR);
				}
				//see if address length is longer than 30 characters - stry0130872
				else if (addressBook.getDefaultAddress(addressBook.ADDRESS_TYPE_BILLING)[0].addressLine0.length > 30) {
						valid = false;
						errors.push(messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE);
					}
	
				if (!valid && errors.length > 0) {
					COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, errors, true);
				}
	
				return valid;
			},
	
			/**
	   * Validate Privacy
	   */
			validatePrivacy: function validatePrivacy() {
	
				var settings = this.getForm().validate().settings;
	
				settings.rules = { privacynoticecheck: { required: true } };
	
				settings.messages = { privacynoticecheck: messages.ERR_REQUIRED_PRIVACY_ACKNOWLEDGE };
	
				settings.errorPlacement = function (error, element) {
					if (element.is(":checkbox")) {
						error.appendTo(element.parent("div").parent("div"));
					} else {
						error.insertAfter(element);
					}
				};
				return this.getForm().valid();
			},
			/**
	   * Preselect values for month day and year for date of birth of policy holder
	   * 
	   * @param {void}
	   * @return {boolean}
	   */
			setSelectedValuesForDate: function setSelectedValuesForDate() {
				var policyHolderDateOfBirth = $('[name="policyHolderDOB"]').val();
				if (policyHolderDateOfBirth) {
					var policyHolderDateOfBirthArray = policyHolderDateOfBirth.split('/');
	
					$("#monthInsurance").val(policyHolderDateOfBirthArray[0].replace(/^0+/, ''));
					$("#dayInsurance").val(policyHolderDateOfBirthArray[1].replace(/^0+/, ''));
					$("#yearInsurance").val(policyHolderDateOfBirthArray[2]);
				}
	
				var patientDateOfBirth = $('[name="patientDOB"]').val();
				var isDependentFlag = $('[name="isDependentFlag"]').val();
				if (patientDateOfBirth !== null && isDependentFlag === "false") {
					var patientDateOfBirthArray = patientDateOfBirth.split('/');
	
					$("#month").val(patientDateOfBirthArray[0].replace(/^0+/, ''));
					$("#day").val(patientDateOfBirthArray[1].replace(/^0+/, ''));
					$("#year").val(patientDateOfBirthArray[2]);
				}
			},
			/**
	  * Set plan name, phone insurance, bin and pcn for selected plan name 
	  * 
	  * @param {void}
	  * @return {boolean}
	  */
			setPlanAndPhone: function setPlanAndPhone(plans) {
				var selectedInsurancePlan = $("#insuranceList option:selected");
				$("#planName").val(selectedInsurancePlan.val());
				$("#insurancePhone").val(selectedInsurancePlan.data('insurance-phone'));
				$("#binNumber").val(selectedInsurancePlan.data('binnumber'));
				$("#pcnNumber").val(selectedInsurancePlan.data('pcnnumber'));
				$("#planName").focusout().change();
				$("#insurancePhone").focusout().change();
				$("#pcnNumber").focusout().change();
				$("#binNumber").focusout().change();
			},
	
			/**
	   * SaveProfile
	   * 
	   * @param {void}
	   * @return {void}
	   */
			saveProfile: function saveProfile(event) {
				var activeTab = $('#navigation-tabs .active').find('a').attr("href").substr(1);
				if (!COSTCO.rxPatientProfile.validateAccountAndPatientInfo()) {
					$('#patient-profile-form').find(":input.error:first").focus();
					COSTCO.rxPatientProfile.setActiveTabAndStopProgress('account-and-patient-info', activeTab, event);
					return;
				}
				if (!COSTCO.rxPatientProfile.validateInsurance()) {
					var binNumber = $('[name="binNumber"]').val();
					$('[name="binNumber"]').val(this.padZeros(binNumber));
					$('#patient-profile-form').find(":input.error:first").focus();
					COSTCO.rxPatientProfile.setActiveTabAndStopProgress('insurance', activeTab, event);
					return;
				}
				if (!COSTCO.rxPatientProfile.validateAddress()) {
					COSTCO.rxPatientProfile.setActiveTabAndStopProgress('address', activeTab, event);
					return;
				}
				this.setDateOfBirthHiddenFields();
				this.extractFormData('patient-profile-form');
				this.getForm().submit();
			},
			/**
	   * Complete Profile
	   * 
	   * @param {void}
	   * @return {void}
	   */
			completeProfile: function completeProfile() {
				if (this.validatePrivacy()) {
					this.setDateOfBirthHiddenFields();
					this.extractFormData('patient-profile-form');
					this.getForm().submit();
				}
			},
			/**
	     * Update A11y aria-selected
	     * 
	     * @param {void}
	     * @return {void}
	     */
			updateA11yAriaSelected: function updateA11yAriaSelected() {
				var _this = this;
	
				$('#navigation-tabs').find('a').each(function (index, tab) {
					if (!tab) {
						return;
					}
					if ($(tab).attr("href").substr(1) !== _this.newTab) {
						$(tab).attr('aria-selected', 'false');
					} else {
						$(tab).attr('aria-selected', 'true');
					}
				});
			},
			/**
	   * Go next
	   * 
	   * @param {void}
	   * @return {void}
	   */
			goNext: function goNext() {
				rxPatientProfile.updateA11yAriaSelected();
				$('#navigation-tabs .active').next('div').find('a').attr('aria-disabled', 'false');
				$('#navigation-tabs .active').next('div').removeClass('disabled');
				$('#navigation-tabs .active').next('div').trigger('click');
				$('html, body').animate({ scrollTop: 200 }, 300);
			},
			/** 
	   * Displays prescription details modal
	   */
			displayPrescriptionDetails: function displayPrescriptionDetails() {
				COSTCO.dialog.createExtDialogBox({
					title: messages.PATIENTPROFILE_PHARMACY__PrescriptionDetails_Title,
					body: COSTCO.util.tmpl('patient_profile_prescription_details_modal', {}),
					primary: messages.JS_DIALOG_CLOSE,
					onclose: function onclose() {
						COSTCO.dialog.close();
					}
				});
			},
			/**
	   * Displays Need Help modal
	   */
			displayNeedHelp: function displayNeedHelp() {
				var activeTab = $('#navigation-tabs .active').find('a').attr("href").split('-')[0].substr(1);
				var dialogBody = $('<div/>').html(COSTCO.util.tmpl('patient_profile_need_help_modal', {}));
	
				if (activeTab !== 'privacy') {
	
					dialogBody.find('#accordion-need-help > div').each(function () {
	
						if (!$(this).attr('id').startsWith(activeTab)) {
							$(this).hide();
						}
					});
				}
	
				COSTCO.dialog.createExtDialogBox({
					title: messages.RWD_HELP,
					body: dialogBody.html(),
					primary: messages.JS_DIALOG_CLOSE,
					dialogclasses: 'patientProfileModal',
					onshown: function onshown() {
						$('#accordion-need-help [id^=' + activeTab + ']').each(function () {
							$(this).click();
						});
					},
					afterclose: function afterclose() {
						$('#need-help-link-button').focus();
					}
				});
			},
			/**
	   * Displays Auto Refill Disabled modal
	   */
			displayAutoRefillDisabled: function displayAutoRefillDisabled() {
				if (autoRefillDisenrolled) {
					COSTCO.dialog.createExtDialogBox({
						title: messages.REFILL_PRESCRIPTION_TITLE_NOREFILL,
						body: COSTCO.util.tmpl('no_refill_patient_profile_modal', {}),
						primary: messages.JS_DIALOG_CLOSE
					});
				}
			},
			/**
	   * Displays Auto Refill Reminder Checked dialog when user unchecks auto refill reminder
	   * checkbox on Account and Patient Info page
	   */
			displayAutoRefillReminderChecked: function displayAutoRefillReminderChecked() {
				if ($('#autoRefillReminder').is(':unchecked')) {
					COSTCO.dialog.createExtDialogBox({
						title: messages.DISABLE_AUTOREFILL_REMINDER_DIALOG_TITLE,
						body: messages.DISABLE_AUTOREFILL_REMINDER_DIALOG_CONTENT,
						primary: messages.JS_DIALOG_CLOSE,
						onclose: function onclose() {
							COSTCO.dialog.close();
						}
					});
				} else {
					COSTCO.dialog.createExtDialogBox({
						title: messages.PATIENTPROFILE_PHARMACY__PrescriptionDetails_Title,
						body: COSTCO.util.tmpl('patient_profile_prescription_details_modal', {}),
						primary: messages.JS_DIALOG_CLOSE,
						onclose: function onclose() {
							COSTCO.dialog.close();
						}
					});
				}
			},
	
			/**
	   * Puts the user's focus on the notification for accessibility
	   */
			displayNotificationMessage: function displayNotificationMessage() {
				$('#notification-area').focus();
			},
	
			/**
	   * Persists user data to session object and forwards user to Change Password page
	   */
			updatePassword: function updatePassword() {
				this.dynamicFormElement.updatePatientPassword = {
					'userAction': 'update-password'
				};
				this.persistPatientProfile('updatePatientPassword');
			},
			/**
	   * Persists user data to session object and forwards user to Account Details page
	   */
			updateEmailOrMembershipNumber: function updateEmailOrMembershipNumber() {
				this.dynamicFormElement.updateEmailAndMemberId = {
					'userAction': 'update-email-memberid'
				};
				this.persistPatientProfile('updateEmailAndMemberId');
			},
			/**
	   * Persists user data to session object and forwards user to Edit Payment Method page
	   */
			editPaymentMethod: function editPaymentMethod() {
				this.dynamicFormElement.editPaymentMethod = {
					'userAction': 'editPaymentMethod'
				};
	
				this.persistPatientProfile('editPaymentMethod');
			},
			/**
	   * Persists user data to session object
	   * @param  {String} action	Action to perform
	   */
			persistPatientProfile: function persistPatientProfile(action) {
	
				var self = this;
				self.createDynamicFormElements(action);
				self.extractFormData('PharmacyPersistPatientProfileForm');
				document.forms.PharmacyPersistPatientProfileForm.submit();
	
				/* TODO: Nikola - check if this is ok with Darko and delete/update
	   	var persist = function () {
	   	self.createDynamicFormElements(action);
	   	self.extractFormData('PharmacyPersistPatientProfileForm');
	   	document.forms.PharmacyPersistPatientProfileForm.submit();
	   }
	   
	   if(isConfirmEnabled) {
	   	
	   	ConfirmModal.modal({
	   		content: "#defaultAddressConfirmationDialog",
	   		confirmText : messages.JS_DIALOG_ACCEPT,
	   		dialogOptions : {
	   			title : messages.JS_CHANGE_DEFAULT_ADDRESS_TITLE
	   		},								
	   		onConfirm: persist 
	   	});
	   } else {
	   		persist();
	   }*/
			},
			/**
	   * Adds input elements to Persist Patient Profile form
	   * @param  {String} action	Action to perform
	   */
			createDynamicFormElements: function createDynamicFormElements(action) {
				var param = this.dynamicFormElement[action];
				var length = param.length;
				if ($('#authToken').length > 0) {
					param['authToken'] = $('#authToken').attr('token');
				}
				for (var key in param) {
					$("<input type='hidden'/>").attr({ 'id': 'Patient_Profile_' + key, 'name': key, 'value': param[key] }).appendTo("#PharmacyPersistPatientProfileForm");
				}
			},
			/**
	   * Append data from Address and Payment Method forms to specified form
	   * @param {String} appendTo	Id of form for appending data
	   */
			extractFormData: function extractFormData(appendTo) {
	
				this.setDateOfBirthHiddenFields();
				$("<input type='hidden'/>").attr({ 'id': 'Patient_Profile_userData', 'name': 'userData', 'value': $('#patient-profile-form').serialize() }).appendTo('#' + appendTo);
			},
			/**
	   * set hidden date of birth input fields for form submit
	   * 
	   * @param {void}
	   * @return {void}
	   */
			setDateOfBirthHiddenFields: function setDateOfBirthHiddenFields() {
				var month = $("#month").val();
				var day = $("#day").val();
				var year = $("#year").val();
				month = month && month.length == 1 ? '0' + month : month;
				day = day && day.length == 1 ? '0' + day : day;
	
				$("#patientDOB").val(month + '/' + day + '/' + year);
	
				var radioYesSelected = $('#radioYes').is(':checked');
				if (radioYesSelected) {
					var monthInsurance = $("#monthInsurance").val();
					var dayInsurance = $("#dayInsurance").val();
					var yearInsurance = $("#yearInsurance").val();
	
					monthInsurance = monthInsurance && monthInsurance.length == 1 ? '0' + monthInsurance : monthInsurance;
					dayInsurance = dayInsurance && dayInsurance.length == 1 ? '0' + dayInsurance : dayInsurance;
					$("#policyHolderDOB").val(monthInsurance + '/' + dayInsurance + '/' + yearInsurance);
				}
			},
			/**
	   * Process tokenization response 
	   * 
	   * @param {string} response	response from Accertify web service
	   * @return {void}
	   */
			processTokenizationResponse: function processTokenizationResponse(response) {
	
				if (COSTCO.PaymentMethods.validatePaymentMethodForm()) {
					$('#navigation-tabs .active').next('div').find('a').attr('aria-disabled', 'false');
					$('#navigation-tabs .active').next('div').removeClass('disabled');
					$('a[href*=' + this.newTab + ']').parent().addClass('active');
					$('a[href*=payment-method]').parent().removeClass('active');
					$('#' + this.newTab).addClass('in active');
					$('#payment-method').removeClass('active');
	
					if (this.newTab === 'address') {
						addressBook.addjustCells('.resizable');
					}
				}
			},
	
			/**
	   * Adds new address. 
	   * If there is no addresses of particular type, 
	   * newly created address will be set as default. 
	   * Otherwise, address won't be set as default.
	   */
			addNewAddress: function addNewAddress() {
				var setAsDefault = addressBook.filterAddressesByType(addressBook.getActiveAddressType()).length == 0;
				addressBook.addNewAddress(setAsDefault);
			},
	
			//Main switch for aria-expand/aria-selected attribute value for all rx tabs
			//TODO: this switch should break into two parts one for Parent Tabs and another switch for child tabs
			// this common switch is having issues when dealing with Accessibility issues for child tabs.
			rxAriaExpandSwitch: function rxAriaExpandSwitch() {
				$('.costco-tabs-alternate .table-cell a').unbind('click').on('click', function (e) {
					var $activeCell = $(this).parent();
					$activeCell.parents('.costco-tabs-alternate').find('.table-cell').removeClass('active');
					$activeCell.addClass('active');
	
					//Updates aria-expanded attribute true/false
					if ($activeCell.hasClass('active')) {
						$('.costco-tabs-alternate .table-cell a').attr('aria-selected', 'false');
						//TODO: Need to move into a common method when introducing a brand new child tabs if in-future.
						$(e.currentTarget).attr('aria-selected', 'true');
						if ($('#shippingTab').hasClass('active')) {
							$('#shippingTab').find('a').attr('aria-selected', 'true');
						} else if ($('#billingTab').hasClass('active')) {
							$('#billingTab').find('a').attr('aria-selected', 'true');
						}
					} else {
						$('.costco-tabs-alternate .table-cell a').attr('aria-selected', 'true');
						$(e.currentTarget).attr('aria-selected', 'false');
					};
				});
			},
			padZeros: function padZeros(num) {
				if (num) {
					if (!regexes.IS_ZEROS.test(num)) {
						return num.toString().padStart(6, 0);
					}
				}
			}
	
		};
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.rxPatientProfile = rxPatientProfile;
	
		return rxPatientProfile;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	* @title rxprescriptionhelper.js
	* @description Sub-module which contains various common functionalities for pharmacy section
	* @dependences
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var rxPrescriptionHelper = {
	
			init: function init(options) {
				COSTCO.util.adjustDivHeights('.costco-align-height-shipping-billing-address', 50);
	
				// Whenever address get changed, do div heights adjustment
				$('body').bind('costco.address.added', function (event, address) {
					COSTCO.util.adjustDivHeights('.costco-align-height-shipping-billing-address', 50);
				});
			},
	
			drugSection: {
				drugNames: 'drugName_0 drugName_1 drugName_2 drugName_3 drugName_4 drugName_5 drugName_6 drugName_7 drugName_8 drugName_9 drugName_10 drugName_11 drugName_12 drugName_13 drugName_14',
				prescriptionNumbers: 'prescriptionNumber_0 prescriptionNumber_1 prescriptionNumber_2 prescriptionNumber_3 prescriptionNumber_4 prescriptionNumber_5 prescriptionNumber_6 prescriptionNumber_7 prescriptionNumber_8 prescriptionNumber_9 prescriptionNumber_10 prescriptionNumber_11 prescriptionNumber_12 prescriptionNumber_13 prescriptionNumber_14',
				MAX_PRESCRIPTION_NUMBER: 15,
	
				/**
	    * Function which dynamically creates drug section.
	    * @param {string} blockId ID of block where section will be added.
	    * @param {string} templateId ID of the template to be inserted.
	    */
				createDrugSection: function createDrugSection(blockId, templateId) {
					$('#' + blockId).html('');
					$.each(drugList, function (index, value) {
						rxPrescriptionHelper.drugSection.addSinglePrescriptionRow(blockId, value, templateId);
					});
					if (drugList.length % 3 > 0) {
						var emptyFieldsToAdd = 3 - drugList.length % 3;
						for (i = 0; i < emptyFieldsToAdd; i++) {
							defaultDrugElement.drugIndex = drugList.length + i;
							rxPrescriptionHelper.drugSection.addSinglePrescriptionRow(blockId, defaultDrugElement, templateId);
						}
					}
					// Init rxBoxCount value
					rxPrescriptionHelper.drugSection.setPrescriptionsCount(blockId);
				},
	
				/**
	    * Function which adds new prescriptions on existing section.
	    * Max number of precription sections is limited to 15
	    * @param {string} ID of block where section will be added.
	    * @param {string} templateId ID of the template to be inserted.
	    */
				addMorePrescriptions: function addMorePrescriptions(blockId, templateId) {
					var rxBoxCnt = $('#' + blockId).children().length;
					var freeSpaces = rxPrescriptionHelper.drugSection.MAX_PRESCRIPTION_NUMBER - rxBoxCnt;
					var prescriptions2Add = freeSpaces < 3 ? freeSpaces : 3;
	
					for (i = 0; i < prescriptions2Add; i++) {
						if (i == 1) {
							$('#searchForDrug_' + defaultDrugElement.drugIndex).focus();
						}
						defaultDrugElement.drugIndex = rxBoxCnt + i;
						rxPrescriptionHelper.drugSection.addSinglePrescriptionRow(blockId, defaultDrugElement, templateId);
					}
	
					rxPrescriptionHelper.drugSection.setPrescriptionsCount(blockId);
				},
	
				/**
	    * Function which adds single prescription element on existing section.
	    * Max number of prescription sections is limited to 15
	    * @param {string} blockId ID of block where section will be added.
	    * @param {Object} jsonTemplate
	    * @param {string} templateId ID of the template to be inserted.
	    */
				addSinglePrescriptionRow: function addSinglePrescriptionRow(blockId, jsonTemplate, templateId) {
					if (jsonTemplate.hasOwnProperty("drugIndex")) {
						jsonTemplate.groupIndex = parseInt(jsonTemplate.drugIndex) + 1;
					}
	
					var template = COSTCO.util.tmpl(templateId, jsonTemplate);
					template = $(template);
					if (jsonTemplate.checked == true) {
						template.find('#genericOption_' + jsonTemplate.drugIndex).prop('checked', true);
					}
	
					$('#' + blockId).append(template);
				},
	
				setPrescriptionsCount: function setPrescriptionsCount(blockId) {
					var rxBoxCnt = $('#' + blockId).children().length;
					$('input:hidden[name=rxBoxCount]').val(rxBoxCnt);
					if (rxBoxCnt >= 15) {
						$('#add-more-prescriptions-button').hide();
					}
				},
	
				setFilledPresciptionsCount: function setFilledPresciptionsCount() {
					var rxBoxCount = $('#drug-info-block').children().length;
					var count = 0;
					for (i = 0; i < rxBoxCount; i++) {
						var drugname = $('#drugName_' + i).val();
						if (typeof drugname !== 'undefined' && drugname.trim().length > 0) {
							count++;
						} else {
							$('#drugName_' + i).removeAttr('name');
						}
					}
					$('input:hidden[name = rxBoxCount]').val(count);
				},
	
				/**
	    * Drug section validation function
	    */
				drugNameValidationMethod: function drugNameValidationMethod(value, element, options) {
					var numberRequired = options[0];
					var selector = options[1];
					var fields = $(selector, element.form);
					var filled_fields = fields.filter(function () {
						// it's more clear to compare with empty string
						var drugName = $(this).val();
						return $.trim(drugName) != '';
					});
	
					if (filled_fields.length < numberRequired) {
						return false;
					}
					return true;
				},
	
				/**
	    * Search drug function.
	    * @param {String} index Drug index.
	    * @param {String} formId Form ID.
	    */
				searchForDrug: function searchForDrug(index, formId) {
					var count = $('#drug-info-block').children().length;
					var genericRequested = $('#genericOption_' + index).is(':checked');
					var searchKeyword = $('#drugName_' + index).val();
	
					var prescriptionForm = document.forms[formId];
	
					prescriptionForm.action = 'PharmacyPrescriptionDrugSearch?storeId=' + wcs.storeId + '&langId=' + wcs.langId + '&catalogId=' + wcs.catalogId + '&isPharmacy=true';
	
					prescriptionForm.searchKeyword.value = searchKeyword;
					prescriptionForm.rxBox.value = index;
					prescriptionForm.genericRequested.value = genericRequested;
					prescriptionForm.rxBoxCount.value = count;
	
					prescriptionForm.submit();
				}
			},
	
			/**
	   * Marks the appropriate radio button in Shipping Option section as checked.
	   *
	   * @param {string} shippingMethod Shipping method code (expected '4', '5', or '6')
	   */
			markShippingOptionChecked: function markShippingOptionChecked(shippingMethod) {
				switch (shippingMethod) {
					case '4':
						$('#standard-usps').attr('checked', 'checked');
						break;
					case '5':
						$('#three-day-shipping').attr('checked', 'checked');
						break;
					case '6':
						$('#two-day-shipping').attr('checked', 'checked');
						break;
					default:
						console.error('Invalid shipping method: ' + shippingMethod);
				}
			},
	
			/**
	   * Opens $0 Co-Pay dialog.
	   *
	   * @param {object} $completeRequestForm Complete Prescription Request form.
	   */
			openZeroDollarDialog: function openZeroDollarDialog($completeRequestForm) {
				if ($completeRequestForm.is('form')) {
					COSTCO.dialog.createExtDialogBox({
						title: messages.PRESCRIPTION_PHARMACY__ZeroDollarCopay_DialogText,
						body: $('#zero-dollar-dialog-text').html(),
						primary: messages.PRESCRIPTION_PHARMACY__CompletePrescription_ButtonText,
						primary_event: function primary_event() {
							$completeRequestForm.submit();
						}
					});
				} else {
					console.error('Illegal argument: form is expected.');
				}
			},
			/**
	   * Called when the user clicks Complete Request button.
	   * Validate Address length, according to story stry0130872
	   * @return address validation
	   */
	
			validateAddress: function validateAddress() {
				var valid = true;
				var errors = [];
				$.each($('.address-1-check'), function (index, value) {
					var address1 = $(value).text();
					if (address1 == undefined && valid) {
						valid = false;
						errors.push(messages.ERR_ADDRESSBOOK_MISSING_SHIPPING_ADDR);
					}
					//see if address length is longer than 30 characters - stry0130872
					else if (address1.length > 30 && valid) {
							valid = false;
							errors.push(messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE);
						}
				});
	
				$.each($('.address-2-check'), function (index, value) {
					var address2 = $(value).text();
					if (address2 == undefined && valid) {
						valid = false;
						errors.push(messages.ERR_ADDRESSBOOK_MISSING_SHIPPING_ADDR);
					}
					//see if address length is longer than 30 characters - stry0130872
					else if (address2.length > 30 && valid) {
							valid = false;
							errors.push(messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE);
						}
				});
	
				if (!valid && errors.length > 0) {
					COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, errors, true);
				}
	
				return valid;
			},
			/**
	   * Action to be performed when the user clicks Complete Request button.
	   *
	   * @param {Object} element HTML element.
	   * @param {boolean} hasCreditCard
	   * @param {boolean} enforceZeroDollarDialog
	   */
			completePrescriptionRequestAction: function completePrescriptionRequestAction(element, hasCreditCard, enforceZeroDollarDialog) {
				var completeRequestFormId = $(element).closest('form').attr('id');
				var $completeRequestForm = $('form[id=' + completeRequestFormId + ']');
	
				var isQuickFill = 'true' == $completeRequestForm.find('input[name=isQuickFill]:checked').val();
	
				// Order should always be placed if user selects 'Notify by email' (a.k.a. 'self checkout'),
				// i.e. when isQuickFill equals 'false'.
				if (this.validateAddress()) {
					if (!isQuickFill) {
						$completeRequestForm.submit();
					} else if (enforceZeroDollarDialog) {
						this.openZeroDollarDialog($completeRequestForm);
					} else if (hasCreditCard) {
						$completeRequestForm.submit();
					} else {
						console.error('Illegal arguments.');
					}
				}
			}
		};
	
		if (typeof window.COSTCO === 'undefined') {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.rxPrescriptionHelper = rxPrescriptionHelper;
	
		return rxPrescriptionHelper;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title fsamodal.js: Sub-module for Global pages
	 * @description This module is used to display the fsa modal
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var rxsignin = {
	
			init: function init() {
				this.createFormValidation();
				this.signInOutContainerInit();
				this.dropdownMenuRedirect();
			},
	
			PRESCRIPTION_COUNT_URL: 'PharmacyPrescriptionCountCmd',
	
			signInOutContainerInit: function signInOutContainerInit() {
	
				// TODO: This was loaded from the Header_Data.jspf. Hardocding here, but need to find a better way, to pass this dynamically
				window.COSTCO.rxsignin.prescriptionCountURL = 'PharmacyPrescriptionCountCmd';
	
				// executes when HTML-Document is loaded and DOM is ready, prior to the (window).load()
				var c = $.cookie('hashedUserId');
				if (c && c != '""') {
					var pC = $.cookie("PrescriptionCount");
					rxsignin.ajaxPrescriptionCount();
				} else {
					$('#header-pharmacy-user-box').hide();
				}
			},
	
			setSelectedPatient: function setSelectedPatient() {
				var selectedPatientId = $("#patientList option:selected").attr("id");
				var displayFlag = $("#patientList option:selected").attr("data-displayFlag");
				var patientIndex = $("#patientList option:selected").index();
				var firstName = $("#patientList option:selected").attr("data-firstName");
				var lastName = $("#patientList option:selected").attr("data-lastName");
				var pathName = COSTCO.rxPrescriptionStatus.getPathName(location);
				sessionStorage.setItem("SelectedInfo", selectedPatientId);
				$('#shopperId').val(selectedPatientId);
				$('#isDonotDisplayDetailsFlag').val(displayFlag);
				$('#firstName').val(firstName);
				$('#lastName').val(lastName);
				$('#urlPathName').val(pathName);
				$('#patientSelectorForm').submit();
			},
	
			displaySelectedPatientName: function displaySelectedPatientName() {
				var selshopperId = sessionStorage.getItem("SelectedInfo");
				if (selshopperId != undefined && selshopperId != '') {
					$('#patientList').val(selshopperId);
				}
			},
	
			ajaxPrescriptionCount: function ajaxPrescriptionCount() {
				//Delete the cookie before making Ajax call.
				$.cookie('PrescriptionCount', null, { path: '/' });
				$.ajax({
					type: 'POST',
					url: rxsignin.PRESCRIPTION_COUNT_URL,
					dataType: 'text',
					success: onSuccess,
					error: onError,
					data: { randomValue: Math.random() }
				});
	
				function onSuccess(data) {
					var pC = $.cookie("PrescriptionCount");
					var value = JSON.parse(pC);
					rxsignin.populateData(value);
				}
	
				function onError(data) {
					$('#header-pharmacy-user-box').hide();
				}
			},
			populateData: function populateData(data) {
				//If data is null, undefined or empty, show the promo.
				if (data == null || data == undefined || data == "") {
					$('#header-pharmacy-user-box').hide();
					return;
				}
				//The back end will convert white space characters to '+', do the reverse here. 
				var firstName = data.PatientFirstName.replace(/\+/g, " ");
				var prescriptionProcessed = data.PrescriptionProcessed;
				var prescriptionShipped = data.PrescriptionShipped;
				var truncate = false;
				if (firstName.length > 12) {
					firstName = firstName.substring(0, 12);
					truncate = true;
				}
	
				if (firstName === 'New User') {
					$('#patient-first-name').text('Welcome, ' + firstName);
					$('.info-style').hide();
				} else if ($('#patientList').val() == null) {
					// if no dependent 
					$('#patient-first-name').text('Welcome, ' + firstName);
				} else {
					// if dependent is present
					$('#patient-first-name').text('Welcome, ');
				}
				if (truncate) {
					$('#patient-first-name').html($('#patient-first-name').html() + '&hellip;');
				}
	
				if (prescriptionProcessed == 1) {
					$('#pres-processed-count-text').text("Prescription Processing");
				}
				$('#pres-processed-count').text(prescriptionProcessed);
	
				if (prescriptionShipped == 1) {
					$('#pres-shipped-count-text').text("Prescription Shipping");
				}
				$('#pres-shipped-count').text(prescriptionShipped);
	
				$('#header-pharmacy-user-box').show();
			},
	
			createFormValidation: function createFormValidation() {
	
				//defect CIS100073246. If user clicks Sign In button from the sign in section on the
				//home delivery page without entering any credentials,
				//the placeholder text gets misplaced over the Password field. 
				//solution: id for the form was renamed to HDLogonForm. The new form has been included
				//in this file and invalidHandler was added.
				$('#HDLogonForm').validate({
					rules: {
						logonId: { required: true, email: true },
						logonPassword: { required: true }
					},
					messages: {
						logonId: { email: messages.ERR_INVALID_EMAIL_HD }
					},
					invalidHandler: function invalidHandler(form, validator) {
						//					   TODO: Commented out for rx redesign - CHECK IF THIS IS STILL NEEDED
						////					    // invalidate placeholders to fix layout issues in older browsers
						//						$('input[placeholder], textarea[placeholder]').placeholder();
						////						// clear existing server messages on form resubmit
						//						$('.error_msg, .success, .server-error').remove();
						//						window.COSTCO.rxsignin.correctAlignment();
					}
				});
	
				$('#HDLogonForm').submit(function () {
					if ($('#option1').is(':checked')) {
						$.cookie('rememberedLogonId', $('#logonId').val(), { expires: 14, path: '/' });
					} else {
						$.cookie('rememberedLogonId', $('#logonId').val(), { expires: -1, path: '/' });
					}
				});
	
				if ($('#HDLogonForm #errorlogon').val() == 'True') {
					var n = $('#logonId').val();
					$('#logonId').val(n);
				} else {
					var n = $.cookie('rememberedLogonId');
					$('#logonId').val(n);
					$("#option1").prop('checked', n != null);
				}
			},
			correctAlignment: function correctAlignment() {
				var placeholdersupport = window.COSTCO.rxsignin.isPlaceholderSupported();
				var interval;
				if (placeholdersupport == false) {
					$("input[type='text']").focus(function () {
						interval = setInterval(correctPlaceholder, 100);
					});
					$("input[type='text']").blur(function () {
						clearInterval(interval);
					});
				}
			},
			correctPlaceholder: function correctPlaceholder() {
				var input = $('.PLACEHOLDER-INPUT');
				var label = $('.PLACEHOLDER-LABEL');
				var topPos;
				for (i = 0; i < input.length; i++) {
					topPos = $(input[i]).offset();
					$(label[i]).offset(topPos);
				}
			},
			isPlaceholderSupported: function isPlaceholderSupported() {
				var input = document.createElement("input");
				return 'placeholder' in input;
			},
	
			dropdownMenuRedirect: function dropdownMenuRedirect() {
				$('.dropdown-menu-redirect').unbind('change').change(function () {
					window.location.href = $(this).val();
				});
			}
	
		}; //end fsamodal object
	
		// Expose fsamodal to the global scope.
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.rxsignin = rxsignin;
	
		return rxsignin;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title rxsearch.js: Sub-module for pharmacy search
	 * @description This module is used to perform RX search actions
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var rxsearch = {
	
			init: function init() {
				rxsearch.initAlphabarEvents();
			},
			/**
	   * Initialize Alpha bar on change event, so that drug directory index is shown for selected letter
	   */
			initAlphabarEvents: function initAlphabarEvents() {
				if ($('#browse-drug-select select').length == 1) {
					$('#browse-drug-select select').unbind('change').change(function () {
	
						if ($(this).val() != '') {
							window.location.href = $(this).val();
						}
					});
				}
			},
			/**
	   * Returns total number of search results.
	   * @return {number} Total number of search results.
	   */
			getTotalNumberOfResults: function getTotalNumberOfResults() {
				return rxSearchResults ? rxSearchResults.drugResults.length : 0;
			},
			/**
	   * Creates search results section, for mobile and desktop display.
	   * 
	   * @param {number} currentPage Current page number.
	   * @param {number} itemsPerPage Number of displayed results per page.
	   * @param {string} displayBreak Display width at which two results columns break into four (expected 'lg' or 'xl')
	   * @param {string} resultsBlockId ID of the HTML element where results will be displayed.
	   * @param {string} pageStatsBlockClass HTML class of the element where page stats will be displayed.
	   * @param {string} paginationBlockId ID of the HTML element where page numbers will be displayed.
	   */
			createSearchResultsSection: function createSearchResultsSection(currentPage, itemsPerPage, displayBreak, resultsBlockId, pageStatsBlockClass, paginationBlockId) {
	
				var pageSearchResults = this.getSearchResultsJSONForPage(currentPage, itemsPerPage);
	
				var $mobBlock = $('<div/>').html(COSTCO.util.tmpl('rx_search_results_wrapper_mobile_tmpl', {}));
				var $desktopBlock = $('<div/>').html(COSTCO.util.tmpl('rx_search_results_wrapper_desktop_tmpl', {}));
	
				var total = pageSearchResults.length;
				var mobStep = Math.floor((total + 1) / 2);
				var desktopStep = Math.floor((total + 3) / 4);
	
				var desktopSecondColumnStartIndex = 2 * desktopStep - (total % 4 == 1 ? 1 : 0);
				var desktopThirdColumnStartIndex = 3 * desktopStep - (total % 4 == 1 ? 2 : 0) - (total % 4 == 2 ? 1 : 0);
	
				$.each(pageSearchResults, function (index, value) {
	
					if (value.drugId === "") {
						value.drugId = 0;
					}
	
					var elementBlock = COSTCO.util.tmpl('rx_search_result_element_tmpl', value);
	
					// Handle Mobile
					if (index < mobStep) {
						$mobBlock.find('.rx-search-result-col:nth-of-type(1)').append(elementBlock);
					} else {
						$mobBlock.find('.rx-search-result-col:nth-of-type(2)').append(elementBlock);
					}
	
					// Handle Desktop
					if (index < desktopStep) {
						$desktopBlock.find('.rx-search-result-col:nth-of-type(1)').append(elementBlock);
					} else if (index < desktopSecondColumnStartIndex) {
						$desktopBlock.find('.rx-search-result-col:nth-of-type(2)').append(elementBlock);
					} else if (index < desktopThirdColumnStartIndex) {
						$desktopBlock.find('.rx-search-result-col:nth-of-type(3)').append(elementBlock);
					} else {
						$desktopBlock.find('.rx-search-result-col:nth-of-type(4)').append(elementBlock);
					}
				});
	
				switch (displayBreak) {
					case 'lg':
						$mobBlock.find('#results-wrapper-mobile').addClass('hidden-lg hidden-xl');
						$desktopBlock.find('#results-wrapper-desktop').addClass('hidden-xs hidden-sm hidden-md');
						break;
					case 'xl':
						$mobBlock.find('#results-wrapper-mobile').addClass('hidden-xl');
						$desktopBlock.find('#results-wrapper-desktop').addClass('hidden-xs hidden-sm hidden-md hidden-lg');
						break;
					default:
						$desktopBlock.find('#results-wrapper-desktop').addClass('hide');
						break;
				}
	
				$('#' + resultsBlockId).html($mobBlock.html());
				$('#' + resultsBlockId).append($desktopBlock.html());
	
				if (this.getTotalNumberOfResults() > 0) {
					this.updatePageStats(pageStatsBlockClass, currentPage, itemsPerPage, this.getTotalNumberOfResults());
				}
	
				if ($('#' + paginationBlockId).length) {
					this.createPagination(currentPage, itemsPerPage, displayBreak, resultsBlockId, pageStatsBlockClass, paginationBlockId);
				}
				$("#heading-search-item").focus();
			},
			/**
	   * Creates search results pagination.
	   * 
	   * @param {number} currentPage Current page number.
	   * @param {number} itemsPerPage Number of displayed results per page.
	   * @param {string} displayBreak Display width at which two results columns break into four (expected 'lg' or 'xl')
	   * @param {string} resultsBlockId ID of the HTML element where results will be displayed.
	   * @param {string} pageStatsBlockClass HTML class of the element where page stats will be displayed.
	   * @param {string} paginationBlockId ID of the HTML element where pagination will be displayed.
	   */
			createPagination: function createPagination(currentPage, itemsPerPage, displayBreak, resultsBlockId, pageStatsBlockClass, paginationBlockId) {
	
				var totalPages = parseInt((this.getTotalNumberOfResults() - 1) / itemsPerPage + 1);
	
				if (totalPages > 1 && $('#' + paginationBlockId).length) {
	
					var $pagination = $('<ul/>');
					var templateId = 'rx_search_results_pagination_tmpl';
					var defaultPageJson = {
						'itemsPerPage': itemsPerPage,
						'displayBreak': displayBreak,
						'resultsBlockId': resultsBlockId,
						'pageStatsBlockClass': pageStatsBlockClass,
						'paginationBlockId': paginationBlockId
					};
	
					// Left arrow
					if (currentPage > 1) {
						$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(defaultPageJson, currentPage - 1, '', 'co-arrow-left')));
						$pagination.find('.co-arrow-left').parent('a').attr('aria-label', 'Previous Page');
					}
	
					// Display all page numbers, if number of pages less or equal to 5
					if (totalPages <= 5) {
						for (page = 1; page <= totalPages; page++) {
							$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(defaultPageJson, page)));
						}
	
						// Display page numbers and ellipses, if number of pages is greater than 5
					} else {
	
						// Calculate start and end page number to be displayed, relative to current page
						var startPage = currentPage - 1;
						var endPage = currentPage + 1;
	
						if (startPage < 2) {
							startPage = 2;
							endPage = 4;
						} else if (endPage > totalPages - 2) {
							startPage = totalPages - 3;
							endPage = totalPages - 1;
						}
	
						// Page 1 - Always display
						$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(defaultPageJson, 1)));
	
						// Ellipsis
						if (startPage > 2) {
							$pagination.append(COSTCO.util.tmpl('rx_search_results_hellip_tmpl'));
						}
	
						// Display page numbers startPage-endPage
						for (page = startPage; page <= endPage; page++) {
							$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(defaultPageJson, page)));
						}
	
						// Ellipsis
						if (endPage < totalPages - 1) {
							$pagination.append(COSTCO.util.tmpl('rx_search_results_hellip_tmpl'));
						}
	
						// Last page - always display
						$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(defaultPageJson, totalPages)));
					}
	
					// Right arrow
					if (currentPage < totalPages) {
						$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(defaultPageJson, currentPage + 1, '', 'co-arrow-right')));
						$pagination.find('.co-arrow-right').parent('a').attr('aria-label', 'Next Page');
					}
	
					// Mark current page active
					$pagination.find('#page-' + currentPage).addClass('btn-primary');
	
					$('#' + paginationBlockId).html($pagination);
					$pagination.find('#page-' + currentPage).attr('aria-current', 'page');
				}
			},
			/**
	   * Updates the page stats: the index of first and last record shown, and total number.
	   * 
	   * @param {string} pageStatsBlockClass HTML class of the element where page stats will be displayed.
	   * @param {number} currentPage Current page number.
	   * @param {number} itemsPerPage Number of displayed results per page.
	   * @param {number} total Total number of records.
	   */
			updatePageStats: function updatePageStats(pageStatsBlockClass, currentPage, itemsPerPage, total) {
				if ($('.' + pageStatsBlockClass).length) {
					var startItemIndex = 'undefined';
					var endItemIndex = 'undefined';
					if ((currentPage - 1) * itemsPerPage + 1 <= total) {
						startItemIndex = (currentPage - 1) * itemsPerPage + 1;
						endItemIndex = currentPage * itemsPerPage <= total ? currentPage * itemsPerPage : total;
					}
					$('.' + pageStatsBlockClass + ' .start-item-index').text(startItemIndex.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
					$('.' + pageStatsBlockClass + ' .end-item-index').text(endItemIndex.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
				}
			},
			/**
	   * Helper function used in rxsearch.createPagination().
	   * Creates JSON that represents page HTML element.
	   * 
	   * @param {Object} pageJson Page JSON with predefined fields.
	   * @param {number} page Page number.
	   * @param {string} pageText The text to be displayed, defaults to page.
	   * @param {string} pageClass HTML class of the page element.
	   * @return {Object} JSON that represents page HTML element.
	   */
			createPageJson: function createPageJson(pageJson, page, pageText, pageClass) {
				if (pageJson.constructor === {}.constructor) {
					pageJson.page = page;
					pageJson.pageText = pageText != undefined ? pageText : page;
					pageJson.pageClass = pageClass != undefined ? pageClass : '';
				} else {
					console.error('Expected object as parameter.');
				}
				return pageJson;
			},
			/**
	   * Submit pharmacy-drug-detail-form and show drug details page
	   * 
	   * @param drugId
	   * @param drugName
	   */
			showDrugDetails: function showDrugDetails(drugId, drugName) {
				var farmacyDrugDetailForm = $("#pharmacy-drug-detail-form");
				farmacyDrugDetailForm.find("input[name=drugId]").val(drugId);
				farmacyDrugDetailForm.find("input[name=drugName]").val(drugName);
				farmacyDrugDetailForm.find("input[name=encodedDrugName]").val(encodeURIComponent(drugName));
	
				farmacyDrugDetailForm.submit();
			},
			/**
	   * Get JSON with search results, for given page.
	   * @param {number} pageNumber Page number.
	   * @param {number} itemsPerPage Number of displayed results per page.
	   * @return {array} JSON array with search results to be displayed on the current page.
	   */
			getSearchResultsJSONForPage: function getSearchResultsJSONForPage(pageNumber, itemsPerPage) {
	
				var resultArray = [];
	
				if (this.getTotalNumberOfResults() > 0) {
	
					if (pageNumber == undefined) {
						pageNumber = 1;
					}
	
					if (itemsPerPage == undefined) {
						itemsPerPage = 40;
					}
	
					var beginIndex = pageNumber * itemsPerPage - itemsPerPage;
					var endIndex = pageNumber * itemsPerPage - 1;
	
					$.each(rxSearchResults.drugResults, function (index, value) {
						if (beginIndex <= index && index <= endIndex) {
							resultArray.push(value);
						}
					});
				}
	
				return resultArray;
			}
		}; //end rxsearch object
	
		// Expose rxsearch to the global scope.
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.rxsearch = rxsearch;
	
		return rxsearch;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title fsamodal.js: Sub-module for Global pages
	 * @description This module is used to display the fsa modal
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(61)], __WEBPACK_AMD_DEFINE_RESULT__ = function (orderitems) {
	
		var rxPrescriptionStatus = {
	
			init: function init() {
				this.sortPrescriptionLists();
				this.setUpSortEventListeners();
				$("#inprocess-tertiary").trigger("click");
				$('#inprocess-checkout').hide();
	
				$('#order-refill').click(function () {
					COSTCO.rxPrescriptionStatus.orderRefills();
				});
			},
			//Sanitaize API Data.
			sanitize: function sanitize(unpurifiedData) {
				function replaceChars(ch) {
					switch (ch) {
						case "<":
							return "&lt;";
						case ">":
							return "&gt;";
						case "&":
							return "&amp;";
					}
					return "";
				}
				return unpurifiedData.replace(/[<>&]/g, replaceChars);
			},
			getPathName: function getPathName(locationObj) {
				var pathName = $(locationObj).attr('pathname');
				var purifiedDataStr = COSTCO.rxPrescriptionStatus.sanitize(pathName);
				return purifiedDataStr;
			},
	
			url: {
				CHANGE_PRESCRIPTION_AUTOREFILL: '/AjaxPharmacyPrescriptionAutoRefillCmd'
			},
	
			/**
	   * Sorts inProcess, availableRefills and historyResults lists by order date
	   * @param (string) listType		Type of the list to order(In Process, Available Refills, Prescription History)
	   * @param (string) sortType 	Selected sorting type  
	   */
			sortPrescriptionLists: function sortPrescriptionLists(listType, sortType) {
	
				//On initial page load, sort by order date
				if (listType == "undefined" && sortType == "undefined" || listType == undefined && sortType == undefined || listType == null && sortType == null) {
					//Set all selects to initial value Sort by order date
					if (typeof inProcessResults != "undefined") {
						inProcessResults.sort(rxPrescriptionStatus['prescriptionSortByLastOrderedDesc']);
					}
					if (typeof availableRefillResults != "undefined") {
						availableRefillResults.sort(rxPrescriptionStatus['prescriptionSortByLastOrderedDesc']);
					}
					if (typeof historyResults != "undefined") {
						historyResults.sort(rxPrescriptionStatus['prescriptionSortByLastOrderedDesc']);
					}
					if (typeof onFileResults != "undefined") {
						onFileResults.sort(rxPrescriptionStatus['prescriptionSortByPrescriptionDateDesc']);
					}
				} else if (listType == "inProcessList" && typeof inProcessResults != "undefined") {
					inProcessResults.sort(rxPrescriptionStatus[sortType]);
				} else if (listType == "availableRefillList" && typeof availableRefillResults != "undefined") {
					availableRefillResults.sort(rxPrescriptionStatus[sortType]);
				} else if (listType == "historyList" && typeof historyResults != "undefined") {
					historyResults.sort(rxPrescriptionStatus[sortType]);
				} else if (listType == "onFileList" && typeof onFileResults != "undefined") {
					onFileResults.sort(rxPrescriptionStatus[sortType]);
				}
			},
	
			/**
	   * Sets up event listeners for sorting prescription status list
	   */
			setUpSortEventListeners: function setUpSortEventListeners() {
				$('#inProcess-sort').on('change', function () {
					COSTCO.rxPrescriptionStatus.sortPrescriptionLists("inProcessList", this.value);
					inProcess_loadPrescriptionLists();
				});
				$('#availableRefills-sort').on('change', function () {
					COSTCO.rxPrescriptionStatus.sortPrescriptionLists("availableRefillList", this.value);
					available_refills_loadPrescriptionLists();
				});
				$('#history-sort').on('change', function () {
					COSTCO.rxPrescriptionStatus.sortPrescriptionLists("historyList", this.value);
					history_loadPrescriptionLists();
				});
				$('#onFile-sort').on('change', function () {
					COSTCO.rxPrescriptionStatus.sortPrescriptionLists("onFileList", this.value);
					available_refills_loadPrescriptionOnFileLists();
				});
			},
	
			/**
	   * Orders prescription list by order date
	   */
			prescriptionSortByLastOrderedDesc: function prescriptionSortByLastOrderedDesc(prescriptionA, prescriptionB) {
				var prescriptionALastOrderedDate = prescriptionA.lastOrdered ? prescriptionA.lastOrdered : prescriptionA.lastOrderedDate ? prescriptionA.lastOrderedDate : '';
				var prescriptionBLastOrderedDate = prescriptionB.lastOrdered ? prescriptionB.lastOrdered : prescriptionB.lastOrderedDate ? prescriptionB.lastOrderedDate : '';
				return new Date(prescriptionBLastOrderedDate).getTime() - new Date(prescriptionALastOrderedDate).getTime();
			},
	
			/**
	   * Orders prescription list by prescription date
	   */
			prescriptionSortByPrescriptionDateDesc: function prescriptionSortByPrescriptionDateDesc(prescriptionA, prescriptionB) {
				var prescriptionAPrescriptionDate = prescriptionA.prescriptionDate ? prescriptionA.prescriptionDate : '';
				var prescriptionBPrescriptionDate = prescriptionB.prescriptionDate ? prescriptionB.prescriptionDate : '';
				return new Date(prescriptionBPrescriptionDate).getTime() - new Date(prescriptionAPrescriptionDate).getTime();
			},
	
			/**
	   * Orders prescription list by drug name
	   */
			prescriptionSortByDrugName: function prescriptionSortByDrugName(prescriptionA, prescriptionB) {
				var prescriptionADrugName = prescriptionA.drugDescription ? prescriptionA.drugDescription : '';
				var prescriptionBDrugName = prescriptionB.drugDescription ? prescriptionB.drugDescription : '';
				return prescriptionADrugName.toLowerCase() < prescriptionBDrugName.toLowerCase() ? -1 : prescriptionADrugName.toLowerCase() > prescriptionBDrugName.toLowerCase() ? 1 : 0;
			},
	
			/**
	   * Orders prescription list by type
	   */
			prescriptionSortByType: function prescriptionSortByType(prescriptionA, prescriptionB) {
				var prescriptionAType = prescriptionA.type ? prescriptionA.type : '';
				var prescriptionBType = prescriptionB.type ? prescriptionB.type : '';
				return prescriptionAType.toLowerCase() < prescriptionBType.toLowerCase() ? -1 : prescriptionAType.toLowerCase() > prescriptionBType.toLowerCase() ? 1 : 0;
			},
	
			/**
	   * Orders prescription list by refills left
	   */
			prescriptionSortByRefillsLeft: function prescriptionSortByRefillsLeft(prescriptionA, prescriptionB) {
				var prescriptionARefillsLeft = prescriptionA.refillsLeft ? prescriptionA.refillsLeft : 0;
				var prescriptionBRefillsLeft = prescriptionB.refillsLeft ? prescriptionB.refillsLeft : 0;
				return prescriptionARefillsLeft - prescriptionBRefillsLeft;
			},
	
			/**
	   * Orders prescription list by auto refill, possible values 0-2 N/A, if the value is N/A or empty replace it with number 4
	   */
			prescriptionSortByAutoRefill: function prescriptionSortByAutoRefill(prescriptionA, prescriptionB) {
				var prescriptionAAutoRefill = prescriptionA.autoRefill ? !isNaN(prescriptionA.autoRefill) ? prescriptionA.autoRefill : 4 : 4;
				var prescriptionBAutoRefill = prescriptionB.autoRefill ? !isNaN(prescriptionB.autoRefill) ? prescriptionB.autoRefill : 4 : 4;
				return prescriptionAAutoRefill - prescriptionBAutoRefill;
			},
	
			/**
	   * Orders prescription list by ship date
	   */
			prescriptionSortByShipDate: function prescriptionSortByShipDate(prescriptionA, prescriptionB) {
				var prescriptionAShipDate = prescriptionA.shipDate ? prescriptionA.shipDate : '';
				var prescriptionBShipDate = prescriptionB.shipDate ? prescriptionB.shipDate : '';
				return new Date(prescriptionBShipDate).getTime() - new Date(prescriptionAShipDate).getTime();
			},
	
			/**
	   * Handles click on select checkbox on Available Refills tab
	   * @param {number} prescriptionId 	Prescription id
	   * @param {string} element       	HTML element user clicked on
	   * @param {number} refillsLeft      refills left for element user clicked on
	   */
			managePrescriptionSelection: function managePrescriptionSelection(prescriptionId, element, refillsLeft) {
				rxPrescriptionStatus.setPrescriptionSelectionInJSON(availableRefillResults, prescriptionId, element);
	
				if (combinedResults != undefined && combinedResults.length > 0) rxPrescriptionStatus.setPrescriptionSelectionInJSON(combinedResults, prescriptionId, element);else rxPrescriptionStatus.setPrescriptionSelectionInJSON(availableRefillResults, prescriptionId, element);
	
				/* DFCT0015940: commented out as part of defect resolution */
				//			if(refillsLeft < 1) {
				//				$('#prescriptionNumber_' + prescriptionId).tooltip({'trigger':'focus', 'title': 'Password tooltip'});
				//			} else {
				//				rxPrescriptionStatus.setPrescriptionSelectionInJSON(availableRefillResults, prescriptionId, element);
				//			}
			},
	
			// Handles showing notification when click on Order Refill checkbox on Available Refills tab
			showNotification: function showNotification(prescriptionId) {
				var rxRefillbody = $('#available-refills-prescriptions-body');
				var rxRefillWarning = $('#available-refills-notification-' + prescriptionId);
				var rxRefillWarningContainer = $('#available-refills-prescriptions-warning');
	
				$(rxRefillWarning).toggleClass('hide');
				if (!$(rxRefillWarning).hasClass('hide')) {
					$(rxRefillbody).css('border-bottom', 'none');
					$(rxRefillWarningContainer).css('border-bottom', '1px solid #cccccc');
				} else {
					$(rxRefillbody).css('border-bottom', '1px solid #cccccc');
					$(rxRefillWarningContainer).css('border-bottom', 'none');
				}
			},
	
			/**
	   * Iterates through provided JSON array and sets 'checked' property to match user selection
	   * @param {JSON Array} prescriptionJSON 	Prescription JSON array to update
	   * @param {number} prescriptionId   		User selected prescription
	   * @param {Object} element          		Selected prescription input html element
	   */
			setPrescriptionSelectionInJSON: function setPrescriptionSelectionInJSON(prescriptionJSON, prescriptionId, element) {
				$.each(prescriptionJSON, function (index, value) {
					if (value.prescriptionId == prescriptionId) {
						value.checked = $(element).prop('checked');
					}
				});
			},
	
			selectedResults: [],
			/**
	   * Handles click on select checkbox on In Process tab
	   * @param {number} prescriptionId 	Prescription id
	   */
			inProcessManageSelect: function inProcessManageSelect(prescriptionId) {
	
				var rxArray = COSTCO.rxPrescriptionStatus.selectedResults;
				var rxIndex = COSTCO.rxPrescriptionStatus.selectedResults.indexOf(prescriptionId);
				var messageField = '#multiple-prescriptions';
	
				if (rxIndex < 0) {
					rxArray.push(prescriptionId);
				} else {
					rxArray.splice(rxIndex, 1);
				}
	
				if (rxArray.length > 0) {
					$('#inprocess-checkout').show();
				} else {
					$('#inprocess-checkout').hide();
					$(messageField).hide();
				}
			},
			/**
	   * Method to handle the deselect function 
	   * for if a prescription with a different
	   * patientId is already available
	   */
			deselectPrescription: function deselectPrescription() {
				var messageField = '#multiple-prescriptions';
				var rxArray = COSTCO.rxPrescriptionStatus.selectedResults;
				var patientName = "";
				if ((typeof currentPharmacyOrderDetails === "undefined" ? "undefined" : _typeof(currentPharmacyOrderDetails)) != undefined && currentPharmacyOrderDetails.length > 0) {
					var currentOrderPatientId = currentPharmacyOrderDetails[0].patientId;
					for (var _i = 0; _i < patientListDetails.length; _i++) {
						if (patientListDetails[_i].shopperId === currentOrderPatientId) {
							patientName = patientListDetails[_i].firstName;
						}
					}
				}
				var message = messages.DESELECT_PRESCRIPTION_IN_BASKET.replace("{0}", patientName);
				if (rxArray.length > 0) {
					for (var i = 0; i < rxArray.length; i++) {
						var prescriptionId = rxArray[i];
						$('#prescriptionNumber_' + prescriptionId).attr("checked", false);
						$('#prescriptionNumber_' + prescriptionId).attr("aria-checked", false);
						if (i === rxArray.length - 1) {
							$('#inprocess-checkout').hide();
						}
					}
					$(messageField).removeClass('critical-notification');
					$(messageField).addClass('general-notification');
					$(messageField)[0].innerHTML = message;
					$(messageField).addClass('aria-selected="true"');
					$(messageField)[0].focus();
					$(messageField)[0].scrollIntoView();
					COSTCO.rxPrescriptionStatus.selectedResults.splice(0, rxArray.length);
				}
			},
	
			/**
	   * Method to remove the prescriptions
	   * for a different patientId already available
	   * in cart 
	   */
			removePrescriptionsFromCart: function removePrescriptionsFromCart() {
				var messageField = '#multiple-prescriptions';
				if ((typeof currentPharmacyOrderDetails === "undefined" ? "undefined" : _typeof(currentPharmacyOrderDetails)) != undefined && currentPharmacyOrderDetails.length > 0) {
					var formData = {};
					formData['actionType'] = 'delete';
					formData['ajaxFlag'] = true;
					//setting the orderId from first Object as we need it only once
					formData['orderId'] = currentPharmacyOrderDetails[0].orderId;
					formData['isPharmacy'] = true;
					formData['isRestrictedPostalCode'] = false;
					var paramCount = 1;
					for (var i = 0; i < currentPharmacyOrderDetails.length; i++) {
						formData['orderItem_' + paramCount] = currentPharmacyOrderDetails[i].orderItemId;
						formData['catalogEntryId_' + paramCount] = currentPharmacyOrderDetails[i].catentryId;
						formData['prescriptionId_' + paramCount] = currentPharmacyOrderDetails[i].prescriptionId;
						formData['quantity_' + paramCount] = 0;
						paramCount++;
					}
					COSTCO.AjaxModular.ajax_update_state({
						method: 'POST',
						url: '/AjaxManageShoppingCartCmd',
						data: formData,
						dataType: 'json',
						error_container: messageField,
						done: function done(data, textStatus, jqXHR, options) {
							if (data.error !== undefined && data.error.application.length > 0) {
								$(messageField).addClass('critical-notification');
								$(messageField)[0].innerHTML = error.mesage;
								$(messageField).show();
								$(messageField).addClass('aria-selected="true"');
								$(messageField)[0].focus();
							} else {
								COSTCO.Header.miniShopCartRefresh();
								COSTCO.OrderItems.addQuantityEventHandlers();
								$(messageField).removeClass('critical-notification');
								$(messageField).addClass('success-notification');
								$(messageField)[0].innerHTML = messages.REMOVE_PRESCRIPTIONS_IN_CART;
								$(messageField).show();
								$(messageField).addClass('aria-selected="true"');
								$(messageField)[0].focus();
								$(messageField)[0].scrollIntoView();
								currentPharmacyOrderDetails = {};
							}
						}
					});
				}
			},
	
			/**
	   * Populates hidden input field on In Process tab for form submit
	   * @param {string} formId 	Form Id to append the input field
	   */
			buildSelectedPrescriptionHiddenInput: function buildSelectedPrescriptionHiddenInput(formId) {
				var messageField = '#multiple-prescriptions';
				var currentOrderShopperId = "";
				if ((typeof currentPharmacyOrderDetails === "undefined" ? "undefined" : _typeof(currentPharmacyOrderDetails)) != undefined && currentPharmacyOrderDetails.length > 0) {
					for (var i = 0; i < currentPharmacyOrderDetails.length; i++) {
						currentOrderShopperId = currentPharmacyOrderDetails[0].patientId;
						break;
					}
				}
				if (selectedShopperId === currentOrderShopperId || currentOrderShopperId == "") {
					$('input[id^=prescriptionNumber]').remove();
					// Append a hidden input field to the form that will have the selected prescription ids
					$("<input type='hidden'/>").attr({ 'id': 'rxPrescriptionNumber', 'name': 'rxPrescriptionNumber', 'value': COSTCO.rxPrescriptionStatus.selectedResults.join(',') }).appendTo("#" + formId);
					document.getElementById(formId).submit();
				}
				// display error message if the cart has a prescription with different patient Id
				else {
						$(messageField).addClass('critical-notification');
						$(messageField)[0].innerHTML = messages.ERR_MULTIPLE_PRESCRIPTION_IN_BASKET;
						$(messageField).show();
						$(messageField).addClass('aria-selected="true"');
						$(messageField)[0].focus();
						$(messageField)[0].scrollIntoView();
					}
			},
			/**
	   * Handles on click auto refill radio button
	   * @param {number} autoRefill       Radio button user clicked (0 - off | 1 - on)
	   * @param {number} prescriptionId 	Prescription id
	   */
			managePrescriptionAutoRefill: function managePrescriptionAutoRefill(autoRefill, prescriptionId) {
				COSTCO.Checkout.ajax_update_state({
					error_container: '#error-container',
					method: 'POST',
					url: rxPrescriptionStatus.url.CHANGE_PRESCRIPTION_AUTOREFILL,
					data: { prescriptionId: prescriptionId, autoRefill: autoRefill },
					dataType: 'json',
					done: function done(data, textStatus, jqXHR, options) {
						if (data.payload.data.numberOfPrescriptionsUpdated != 1) {
							rxPrescriptionStatus.revertAutoRefillUserSelection(prescriptionId);
						} else {
							if (data.payload.data.patientAutoRefillReminder == 'false' && autoRefill == 1) {
								rxPrescriptionStatus.openEnableAutoRefillReminderDialog();
							}
							if (options.data.status == 'inactive') {
								COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
							}
							availableRefillResults.find(function (result, index) {
								if (result.prescriptionId == prescriptionId) {
									availableRefillResults[index].autoRefill = autoRefill;
								}
							});
						}
					}
				});
			},
			/**
	   * Displays Need Help modal
	   */
			displayNeedHelp: function displayNeedHelp() {
				var activeTab = $('#navigation-tabs .active').find('a').attr("href").split('-')[0].substr(1);
	
				COSTCO.dialog.createExtDialogBox({
					title: messages.RWD_PRESCRIPTION_STATUS_HELP,
					body: COSTCO.util.tmpl('prescription_status_need_help_modal', {}),
					primary: messages.JS_DIALOG_CLOSE,
	
					onshown: function onshown() {
						$('div[id^=' + activeTab + ']>p a').each(function () {
							$(this).click();
						});
					}
	
				});
			},
			/**
	   * Opens AutoRefill Reminder dialog
	   */
			openEnableAutoRefillReminderDialog: function openEnableAutoRefillReminderDialog() {
				COSTCO.dialog.createExtDialogBox({
					title: messages.ENABLE_AUTOREFILL_REMINDER_DIALOG_TITLE,
					body: messages.ENABLE_AUTOREFILL_REMINDER_DIALOG_CONTENT,
					primary: messages.JS_DIALOG_OK
				});
			},
			/**
	   * Opens info dialog when user clicks Order Refill button without selecting any prescription
	   */
			openChangePrescriptionStatusInfoDialog: function openChangePrescriptionStatusInfoDialog() {
				COSTCO.dialog.createExtDialogBox({
					title: messages.PRESCRIPTION_PHARMACY__Info_DialogTitle,
					body: messages.HDREFILL_PRESCRIPTION_PHARMACY__SelectAPrescriptionOrderRefill,
					primary: messages.JS_DIALOG_OK
				});
			},
			/**
	   * Reverts auto refill user selection to initial state from prescription JSON 
	   * @param  {number} prescriptionId 	Id of prescription to revert
	   */
			revertAutoRefillUserSelection: function revertAutoRefillUserSelection(prescriptionId) {
				var presc = rxPrescriptionStatus.getPrescriptionJSONById(availableRefillResults, prescriptionId);
				if (presc != undefined) {
					if (presc.autoRefill == 0) {
						$('#autoRefillDisabled_' + prescriptionId).prop('checked', true);
					} else if (presc.autoRefill == 1) {
						$('#autoRefillEnabled_' + prescriptionId).prop('checked', true);
					}
				}
			},
			/**
	   * Gets prescription JSON from input JSON array by ID
	   * @param  {JSON Array} 	prescriptionJSON 	Prescription JSON array
	   * @param  {number} 		prescriptionId   	Id of prescription to find in JSON array
	   * @return {JSON Object}	Found prescription
	   */
			getPrescriptionJSONById: function getPrescriptionJSONById(prescriptionJSON, prescriptionId) {
	
				var json = void 0;
				$.each(prescriptionJSON, function (index, value) {
					if (value.prescriptionId == prescriptionId) {
						json = value;
						return false;
					}
				});
	
				return json;
			},
			/**
	   * Handles click on order refills button in Available Refills tab
	   */
			orderRefills: function orderRefills() {
				var selectedPrescriptionIds = rxPrescriptionStatus.getSelectedPrescriptionIds();
				if (selectedPrescriptionIds.length) {
					var refillForm = $('#available-refill-form');
					refillForm.append('<input type="hidden" name="rxPrescriptionNumber" value="' + selectedPrescriptionIds.join(",") + '" />');
					refillForm.submit();
				} else {
					rxPrescriptionStatus.openChangePrescriptionStatusInfoDialog();
				}
			},
			/**
	   * Returns prescriptions selected by user
	   */
			getSelectedPrescriptionIds: function getSelectedPrescriptionIds() {
				var selectedPrescriptions = [];
				var tmpPrescriptionsArray = [];
				tmpPrescriptionsArray = availableRefillResults;
				$.each(tmpPrescriptionsArray, function (index, value) {
					if (value.checked == true) {
						selectedPrescriptions.push(value.prescriptionId);
					}
				});
				tmpPrescriptionsArray = onFileResults;
				$.each(tmpPrescriptionsArray, function (index, value) {
					if (value.checked == true) {
						selectedPrescriptions.push(value.prescriptionId);
					}
				});
				return selectedPrescriptions;
			},
			/**
	   * Gets JSON array of active or inactive prescriptions to be displayed on page
	   * @param {string} status 	Status of prescriptions to display ('active' | 'inactive')
	   * @param {number} pageNum 	Page number; Default set to 1
	   * @param {number} rowsNum 	Number of records to be displayed; Default set to 10
	   * @return Prescriptions JSON Array to be displayed on page, based on pageNum, rowsNum count and prescription status
	   */
			getPrescriptionsJSON: function getPrescriptionsJSON(status, pageNum, rowsNum) {
	
				var resultArray = [];
	
				if (pageNum == undefined) {
					pageNum = 1;
				}
	
				if (rowsNum == undefined) {
					rowsNum = 10;
				}
	
				var beginIndex = pageNum * rowsNum - rowsNum;
				var endIndex = pageNum * rowsNum - 1;
	
				var prescriptionsJson = [];
				if (status == "history") {
					prescriptionsJson = historyResults;
				} else if (status == "available_refills") {
					prescriptionsJson = availableRefillResults;
				} else if (status == "inprocess") {
					prescriptionsJson = inProcessResults;
				} else if (status == "onFile") {
					prescriptionsJson = onFileResults;
				}
	
				$.each(prescriptionsJson, function (index, value) {
					if (beginIndex <= index && index <= endIndex) {
						resultArray.push(value);
					}
				});
	
				return resultArray;
			},
	
			noRefillPopup: function noRefillPopup(isMedicare) {
				var popupDiv = '#no-refill-popup';
				if (isMedicare) {
					popupDiv = '#no-refill-popup-medicare';
				}
	
				COSTCO.dialog.createExtDialogBox({
					title: messages.REFILL_PRESCRIPTION_TITLE_NOREFILL,
					body: $(popupDiv).html(),
					primary: messages.JS_DIALOG_OK,
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					}
	
				});
			},
	
			buildPrescriptionDetail: function buildPrescriptionDetail(details, centralFill, disableAutoRefill) {
				var SELF_CHECKOUT_DELIVERY = messages.PRESCRIPTION_DETAIL__Delivery_Self_Checkout;
				var AUTO_CHECKOUT_DELIVERY = messages.PRESCRIPTION_DETAIL__Delivery_Auto_Checkout;
				var SHIPPED_STATUS = messages.PRESCRIPTION_DETAIL__Delivery_Shipped;
				var AWAITING_PAYMENT = messages.PRESCRIPTION_STATUS_DESC__AwaitingPayment;
				var ORDERED = messages.PRESCRIPTION_STATUS__Ordered;
				var ON_FILE = messages.PRESCRIPTION_STATUS__OnFile;
	
				$("#detail-medication-h4").html(details.prescriptionName);
	
				var fullName = details.firstName + " " + details.lastName;
				$("#detail-patient").html(fullName);
				$("#detail-prescriptionId").html(details.rx);
				$("#detail-status").html(details.status);
	
				if (details.orderNumber == 0) {
					details.orderNumber = '&nbsp;';
				}
	
				$("#detail-costcoOrder").html(details.orderNumber);
				$("#detail-medication").html(details.prescriptionName);
	
				if (details.quantity == 0) {
					details.quantity = '&nbsp;';
				}
	
				$("#detail-quantity").html(details.quantity);
	
				//Display notification if prescription is expired or no refills
				if (details.isExpired) {
					$("#detail-refillsLeft").html(messages.PHARMACY_EXPIRED);
	
					// Shows expired notification on the Prescription Details Page
					$('#prescription-details-expired-notification').removeClass('hide');
				} else if (details.refillsLeft == messages.REFILLS_LEFT_0 && details.autoRefill != messages.AUTOREFILL_VALUE_3) {
					// Shows no refills notification on the Prescription Details Page
					// Don't show if autoRefill value is 3 (NCD restricted)
					$("#prescription-details-no-refills-notification").removeClass('hide');
	
					$("#detail-refillsLeft").html(details.refillsLeft);
				} else {
					$("#detail-refillsLeft").html(details.refillsLeft);
				}
	
				$("#detail-expirationDate").html(details.expirationDate);
	
				var autoRefill = "NO";
				if (details.autoRefill == 1) {
					autoRefill = "YES";
				} else if (details.autoRefill == 3 || details.status == ON_FILE) {
					autoRefill = "<a href='javascript:COSTCO.rxPrescriptionStatus.noRefillPopup(false);'>N/A</a>";
				}
	
				// Do not display notification if prescription is of type new or transfer or null (n/a), and with fill status of new, in process, or cancelled			
				var rxType = details.type.toLowerCase();
				var fillStatus = details.status.toLowerCase();
				if (rxType == messages.PHARMACY_NEW || rxType == messages.PHARMACY_TRANSFER || rxType == messages.PHARMACY_NOT_AVAILABLE) {
					if (fillStatus == messages.PHARMACY_NEW || fillStatus == messages.PHARMACY_INPROCESS || fillStatus == messages.PHARMACY_CANCELLED) {
						// Hides no refills notification on the Prescription Details Page
						$("#prescription-details-no-refills-notification").addClass('hide');
					}
				}
	
				//Do not display notification if prescription has a fill status of 20 (on file)
				if (fillStatus == messages.PHARMACY_ON_FILE) {
					$("#prescription-details-no-refills-notification").addClass('hide');
				}
	
				if (disableAutoRefill == true) autoRefill = "<a href='javascript:COSTCO.rxPrescriptionStatus.noRefillPopup(true);'>N/A</a>";
	
				$("#detail-autoRefill").html(autoRefill);
				$("#detail-deliveryPreference").html(details.deliveryPreference + ':');
	
				/* handling the ship method, tracking # and tracking # URL */
				$("#notify-when-ready").show();
				$("#ship-when-ready").show();
	
				if (details.deliveryPreference == AUTO_CHECKOUT_DELIVERY) {
					$("#notify-when-ready").hide();
				} else if (details.deliveryPreference == SELF_CHECKOUT_DELIVERY) {
					$("#ship-when-ready").hide();
				}
	
				if (details.deliveryPreference == AUTO_CHECKOUT_DELIVERY || details.deliveryPreference == SELF_CHECKOUT_DELIVERY && (details.status == SHIPPED_STATUS || details.status == AWAITING_PAYMENT || details.status == ORDERED)) {
					$("#detail-shippingOption").html(details.shipMethod);
	
					var trackingNumberUrl = details.trackingNumberUrl == '#' || details.trackingNumberUrl == '' ? 'javascript:void(0);' : details.trackingNumberUrl;
	
					var trackingNumberLink = "<a class='external' href='" + trackingNumberUrl + "'>" + details.trackingNumber + "</a>";
	
					$("#detail-trackingNumber").html(trackingNumberLink);
				} else {
					$("#detail-shippingOption").html('');
					$("#detail-trackingNumber").html('');
				}
	
				var physicianDetail = "";
				if (details.physicianName != "" || details.physicianCity != "" || details.physicianState != "" || details.physicianPhone != "") {
					physicianDetail = details.physicianName + ", " + details.physicianCity + ", " + details.physicianState + ", " + details.physicianPhone;
				}
				$("#detail-physician").html(physicianDetail);
	
				var price = "";
				if (details.price != "" || details.rx) {
					price = COSTCO.util.formatMoney(details.price, true);
				}
				$("#detail-price").html(price);
	
				$("#detail-centralFillName").html(centralFill.name);
				$("#detail-centralFillStreet").html(centralFill.street);
				var cityStZip = centralFill.city + ", " + centralFill.state + " " + centralFill.zip;
				$("#detail-centralFillCityStZip").html(cityStZip);
				$("#detail-centralFillPhone").html(centralFill.phone);
				$("#detail-centralFillFax").html(centralFill.fax);
			},
	
			showRxDetail: function showRxDetail(rxNumberContainer, prescriptionId) {
				console.log(prescriptionId);
	
				var tabName = $(rxNumberContainer).attr('sectionid').split('-')[0];
	
				var shipDate = $(rxNumberContainer).attr('shipdate');
				var orderDate = $(rxNumberContainer).attr('orderdate');
	
				$(".back-to-status").show();
				$("#prescription-detail-dialog").fadeIn("fast");
				$("#prescription-status").hide();
	
				if (prescriptionId < 0) {
					prescriptionId *= -1;
				}
				$.ajax({
					type: "POST",
					url: prescriptionDetailUrl,
					dataType: 'json',
					data: { prescriptionId: prescriptionId },
					cache: false,
					success: function success(data) {
						COSTCO.rxPrescriptionStatus.displayPrescriptionDtls(data, shipDate, orderDate, tabName);
					},
					error: function error(xhr, ajaxOptions, thrownError) {
						window.location.href = prescriptionStatusUrl;
						console.log(xhr + " " + ajaxOpstions + " " + thrownError);
					}
				});
			},
			displayPrescriptionDtls: function displayPrescriptionDtls(data, shipDate, orderDate, tabName) {
				console.log(data);
				var prescriptionDetail = $.parseJSON(data.prescriptionDetail);
				var centralFill = $.parseJSON(data.centralFill);
				var disableAutoRefill = $.parseJSON(data.disableAutoRefill);
				$.when(COSTCO.rxPrescriptionStatus.buildPrescriptionDetail(prescriptionDetail, centralFill, disableAutoRefill)).then(function () {
					$(".desktop-title").html(messages.PRESCRIPTION_STATUS__DetailsPageHeader);
					$(".desktop-title-progress-meter .rx-desktop-title h1").html(messages.PRESCRIPTION_STATUS__DetailsPageHeader);
	
					$('#detail-orderDate').html(orderDate);
	
					if (tabName === 'available_refills' || tabName === 'history') {
	
						if (shipDate == '') {
							shipDate = '&nbsp;';
						}
	
						$("#detail-dateShipped").html(shipDate);
						$("#date-shipped-section").show();
						$("#tracking-number-section").show();
					} else {
						$("#date-shipped-section").hide();
						$("#tracking-number-section").hide();
					}
	
					if (window.innerWidth >= 1025) {
						COSTCO.util.adjustDivHeights('.adjust-height-upper-row-xl');
						COSTCO.util.adjustDivHeights('.adjust-height-lower-row-xl');
					}
					return false;
				});
			},
			closeDetail: function closeDetail() {
				$(".back-to-status").hide();
				$("#prescription-status").fadeIn("fast");
				$("#prescription-detail-dialog").hide();
				$(".rx-desktop-title h1").html(messages.PRESCRIPTION_STATUS__PageMainHeader);
				$("#prescription-details-no-refills-notification").addClass('hide');
				$('#prescription-details-expired-notification').addClass('hide');
			},
	
			/**
	   * Normalize values to help in string matching functions
	   */
			normalizeValues: function normalizeValues(data) {
				if (data.status != null) {
	
					var statusNormalized = data.status.toLowerCase().replace(/ /g, '');
					data.statusNormalized = statusNormalized;
					data.needsColumn = $('#inprocess-select-column').length > 0;
				}
				return data;
			},
	
			/**
	   * Creates prescriptions section table with pagination, based on template and status 
	   * @param  {string} status               Prescription status (inprocess|available_refills|history|onFile)
	   * @param  {string} prescriptionsBlockId HTML block ID to be populated with prescription rows
	   * @param  {number} pageNum              Page number to show
	   * @param  {number} rowsNum              Prescription rows per page
	   * @param  {number} numOfPages           Total number of pages
	   */
			createPrescriptionsSection: function createPrescriptionsSection(status, prescriptionsBlockId, pageNum, rowsNum, numOfPages, totalRecordsNum) {
	
				$('#' + prescriptionsBlockId).html('');
	
				var prescriptions = this.getPrescriptionsJSON(status, pageNum, rowsNum);
	
				// If inside 'In Process' tab there is at least one row with 'Add To Cart' checkbox, a modified design will be applied
				var hasAddToCart = false;
				if (status == "inprocess") {
					$.each(prescriptions, function (index, value) {
						value = COSTCO.rxPrescriptionStatus.normalizeValues(value);
						if (value.statusNormalized == 'addtocart') {
							hasAddToCart = true;
						}
					});
					if (hasAddToCart) {
						$('h6#status-header').addClass('align-with-label');
					} else {
						$('h6#status-header').removeClass();
					}
				}
	
				var templateId = 'prescription_status_' + status + (status == "inprocess" && hasAddToCart ? '_hasAddToCart' : '') + '_prescription_row';
	
				$.each(prescriptions, function (index, value) {
	
					value = COSTCO.rxPrescriptionStatus.normalizeValues(value);
	
					//DFCT0015134: Nikola - Dollar Symbol is missing under the Price section
					if (value.price && value.price.indexOf('$') === -1) {
						value.price = COSTCO.util.formatMoney(value.price, true);
					}
					value.groupIndex = index + 1;
	
					var template = COSTCO.util.tmpl(templateId, value);
	
					template = $(template);
	
					if (value.checked == true) {
						template.find('#prescriptionNumber_' + value.prescriptionId).prop('checked', true);
					}
	
					template.find('#autoRefillEnabled_' + value.prescriptionId).prop('checked', value.autoRefill == '1' ? true : false);
					template.find('#autoRefillDisabled_' + value.prescriptionId).prop('checked', value.autoRefill == '0' ? true : false);
					if (template.find('#autoRefillDisabled_' + value.prescriptionId) && value.autoRefill == 3) {
						setTimeout(function () {
							var clearView = '';
							var autoRefill = "<a href='javascript:COSTCO.rxPrescriptionStatus.noRefillPopup(false);'>N/A</a>";
							$('#autoRefillOptions_' + value.prescriptionId).html(clearView);
							$('#autoRefillOptions_' + value.prescriptionId).html(autoRefill);
						}, 100);
					}
					$('#' + prescriptionsBlockId).append(template);
				});
	
				var paginationBlockId = status + '-page-numbers';
				var pageStatsBlockClass = status + '-paging-navigation';
	
				// Show upper paging navigation
				var firstRecordIndex = (pageNum - 1) * rowsNum + 1;
				var lastRecordIndex = pageNum * rowsNum < totalRecordsNum ? pageNum * rowsNum : totalRecordsNum;
				$('#' + status + '-paging-navigation').html(COSTCO.util.tmpl('prescription_upper_paging_navigation', {
					firstRecordIndex: firstRecordIndex,
					lastRecordIndex: lastRecordIndex,
					totalRecordsNum: totalRecordsNum
				}));
	
				if ($('#' + paginationBlockId).length) {
					var optionsPaginationJson = {
						'templateId': 'prescription_status_pagination_tmpl',
						'rowsNum': rowsNum,
						'totalRecordsNum': totalRecordsNum,
						'prescriptionsBlockId': prescriptionsBlockId,
						'pageStatsBlockClass': pageStatsBlockClass,
						'paginationBlockId': paginationBlockId,
						'status': status
					};
					this.createPagination(pageNum, optionsPaginationJson);
				}
			},
			/**
	   * Creates search results pagination.
	   * 
	   * @param {number} 		currentPage 			Current page number
	   * @param {JSON Object} optionsPaginationJson	various options for pagination
	   */
			createPagination: function createPagination(currentPage, optionsPaginationJson) {
	
				var totalPages = parseInt((optionsPaginationJson.totalRecordsNum - 1) / optionsPaginationJson.rowsNum + 1);
				var paginationBlockId = optionsPaginationJson.paginationBlockId;
				var templateId = optionsPaginationJson.templateId;
				var status = optionsPaginationJson.status;
	
				if (totalPages > 1 && $('#' + paginationBlockId).length) {
	
					var $pagination = $('<ul/>');
	
					// Left arrow
					if (currentPage > 1) {
						$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(optionsPaginationJson, currentPage - 1, '', 'co-arrow-left')));
					}
	
					// Display all page numbers, if number of pages less or equal to 5
					if (totalPages <= 5) {
						for (page = 1; page <= totalPages; page++) {
							$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(optionsPaginationJson, page)));
						}
	
						// Display page numbers and ellipses, if number of pages is greater than 5
					} else {
	
						// Calculate start and end page number to be displayed, relative to current page
						var startPage = currentPage - 1;
						var endPage = currentPage + 1;
	
						if (startPage < 2) {
							startPage = 2;
							endPage = 4;
						} else if (endPage > totalPages - 2) {
							startPage = totalPages - 3;
							endPage = totalPages - 1;
						}
	
						// Page 1 - Always display
						$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(optionsPaginationJson, 1)));
	
						// Ellipsis
						if (startPage > 2) {
							$pagination.append(COSTCO.util.tmpl('prescription_status_hellip_tmpl'));
						}
	
						// Display page numbers startPage-endPage
						for (page = startPage; page <= endPage; page++) {
							$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(optionsPaginationJson, page)));
						}
	
						// Ellipsis
						if (endPage < totalPages - 1) {
							$pagination.append(COSTCO.util.tmpl('prescription_status_hellip_tmpl'));
						}
	
						// Last page - always display
						$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(optionsPaginationJson, totalPages)));
					}
	
					// Right arrow
					if (currentPage < totalPages) {
						$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(optionsPaginationJson, currentPage + 1, '', 'co-arrow-right')));
					}
	
					// Mark current page active
					$pagination.find('#page-' + currentPage).addClass('btn-primary');
	
					$('#' + paginationBlockId).html($pagination);
				}
			},
			/**
	   * Helper function used in rxsearch.createPagination().
	   * Creates JSON that represents page HTML element.
	   * 
	   * @param {Object} pageJson Page JSON with predefined fields.
	   * @param {number} page Page number.
	   * @param {string} pageText The text to be displayed, defaults to page.
	   * @param {string} pageClass HTML class of the page element.
	   * @return {Object} JSON that represents page HTML element.
	   */
			createPageJson: function createPageJson(pageJson, page, pageText, pageClass) {
				if (pageJson.constructor === {}.constructor) {
					pageJson.page = page;
					pageJson.pageText = pageText != undefined ? pageText : page;
					pageJson.pageClass = pageClass != undefined ? pageClass : '';
				} else {
					console.error('Expected object as parameter.');
				}
				return pageJson;
			},
			/**
	   * Toggles show / hide display of onFile prescription list on PrescriptionStatus webpage
	   * @param {String} section 	specifies which prescription list section to toggle
	   */
			showHideToggle: function showHideToggle() {
	
				var showHideButton = $('#onFile-prescriptions-toggle');
				var divWrapper = $(showHideButton).closest('#prescription-info-list-block');
				var prescriptionWrapper = $(divWrapper).find('.prescription-info-list');
				var icon = $(showHideButton).find('i');
				var span = $(showHideButton).find('span');
	
				if ($(showHideButton).hasClass('show-list')) {
					$(showHideButton).removeClass('show-list');
					$(icon).removeClass('rotate270');
					$(showHideButton).addClass('hide-list');
					$(icon).addClass('rotate90');
					$(span).text(messages.RWD_COMPARE_SHOW);
					$(showHideButton).find('.paging-navigation .text-right').hide();
					$(prescriptionWrapper).hide();
					$(showHideButton).attr('aria-label', messages.REFILL_PRESCRIPTION_SHOW_ONFILE_TOGGLE);
				} else {
					$(showHideButton).removeClass('hide-list');
					$(icon).removeClass('rotate90');
					$(showHideButton).addClass('show-list');
					$(icon).addClass('rotate270');
					$(span).text(messages.RWD_COMPARE_HIDE);
					$(showHideButton).find('.paging-navigation .text-right').show();
					$(prescriptionWrapper).show();
					$(showHideButton).attr('aria-label', messages.REFILL_PRESCRIPTION_HIDE_ONFILE_TOGGLE);
				};
			}
		}; //end object
	
	
		// Expose to the global scope.
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.rxPrescriptionStatus = rxPrescriptionStatus;
	
		return rxPrescriptionStatus;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var pharmacyRefillPrescription = {
			prescriptionNumberTextBoxCounter: 0,
			eventHandlers: {
				refillPrescriptionSubmit: function refillPrescriptionSubmit(form) {
					form.submit();
				},
				changeRefillOrder: function changeRefillOrder() {
					var form = $('#refillPrescriptionConfirmationForm');
					form.attr('action', 'warehouse-pickup-prescription-refill');
	
					form.submit();
				},
				submitRefillOrder: function submitRefillOrder(url) {
					pharmacyRefillPrescription.urls.ajaxSubmitRefillPrescriptionCmdURL = url || rxStatusUrl;
	
					$.ajax({
						type: 'POST',
						url: pharmacyRefillPrescription.urls.ajaxSubmitRefillPrescriptionCmdURL,
						dataType: 'json',
						data: $('#refillPrescriptionConfirmationForm').serialize(),
						success: pharmacyRefillPrescription.callbacks.onSubmitRefillOrderSucess,
						error: pharmacyRefillPrescription.callbacks.onSubmitRefillOrderError
					});
				}
			},
			callbacks: {
				onSubmitRefillOrderSucess: function onSubmitRefillOrderSucess(data) {
					data = DOMPurify.sanitize(data);
					$('#refill-prescription-loading').hide();
	
					if (data.success == true) {
						// Dynamically create refill status table
						var statusTable = $('#prescription-status-results-table');
						var dataStr = COSTCO.rxPrescriptionStatus.sanitize(data);
						var dataObj = $.parseJSON(dataStr);
						var prescriptionList = $.parseJSON(dataObj.responseVO.prescriptionList);
						$.each(prescriptionList, function (index, value) {
							var statusLineElement = $('#prescription-status-result-tr-template').clone();
							var column1 = $(statusLineElement).find('.column-1 div');
							var column2 = $(statusLineElement).find('.column-2');
							var column3 = $(statusLineElement).find('.column-3');
							var column4 = $(statusLineElement).find('.column-4');
	
							var statusFullMessage = pharmacyRefillPrescription.getRxStatusMessage(value.status);
							var statusLabel = pharmacyRefillPrescription.getRxStatusLabel(value.status);
	
							if (pharmacyRefillPrescription.isCheckStatusFound(value.status)) {
								column1.attr('class', 'icon-check');
								column3.append('<span role="img" aria-hidden="true" class="co-check-circle mid-allign"></span>' + ' ' + '<span class="mid-allign">' + statusLabel + '</span>');
								if ((value.status == pharmacyRefillPrescription.rxStatuses.RXVALID || value.status == pharmacyRefillPrescription.rxStatuses.RXACTIONOK) && value.pickUpDate != null) {
									var pickUpDateStr = DOMPurify.sanitize(value.pickUpDate);
									column4.append(statusFullMessage + ' ' + pickUpDateStr);
								} else {
									column4.append(statusFullMessage);
								}
							} else if (pharmacyRefillPrescription.isWaitStatusFound(value.status)) {
								column1.attr('class', 'icon-wait');
								column3.append('<span class="fi-clock mid-allign"></span>' + ' ' + '<span class="mid-allign">' + statusLabel + '</span>');
								column4.append(statusFullMessage);
							} else if (pharmacyRefillPrescription.isAlertStatusFound(value.status)) {
								column1.attr('class', 'icon-alert');
								column3.append('<span class="co-caution mid-allign"></span>' + ' ' + '<span class="mid-allign">' + statusLabel + '</span>');
								column4.append(statusFullMessage);
							} else {
								column1.attr('class', 'icon-block');
								column3.append('<span class="co-caution mid-allign"></span>' + ' ' + '<span class="mid-allign">' + messages.REFILL_PRESCRIPTION_STATUS_PATIENT_ACTION_REQUIRED + '</span>');
								column4.append(statusFullMessage);
							}
							column2.append(DOMPurify.sanitize(value.number));
							statusLineElement.removeAttr('id');
							statusLineElement.show();
							statusTable.append(statusLineElement);
						});
	
						var confirmationResponseElement = $('#refill-prescription-confirmation-response');
						confirmationResponseElement.removeAttr('style');
	
						var nextStepsElements = $('#next-steps-success');
						nextStepsElements.removeAttr('style');
						nextStepsElements.show();
					} else {
						pharmacyRefillPrescription.handleSubmitError(data);
					}
	
					$('#pharmacyInfo').show();
				},
				onSubmitRefillOrderError: function onSubmitRefillOrderError(data) {
					$('#refill-prescription-loading').hide();
					$('#pharmacyInfo').show();
					pharmacyRefillPrescription.handleSubmitError(data);
				}
			},
			urls: {
				ajaxSubmitRefillPrescriptionCmdURL: null
			},
			handleSubmitError: function handleSubmitError(data) {
				var errorContainer = $('#refill-prescription-confirmation-error');
				$(errorContainer).find('#line-1').text(messages.PRESCRIPTION_MESSAGE_SYSTEM_ISSUE_LINE_1 + ' ' + messages.PRESCRIPTION_MESSAGE_SYSTEM_ISSUE_LINE_2);
				$('#refill-prescription-confirmation-error').show();
				$('#refill-prescription-confirmation-error').removeClass('hide');
	
				var nextStepsElements = $('#next-steps-error');
				nextStepsElements.removeAttr('style');
				nextStepsElements.show();
			},
			rxStatuses: {
				RXVALID: 'RXVALID',
				RXACTIONOK: 'RXACTIONOK',
				RXINQUEUE: 'RXINQUEUE',
				RXREADYFORPICKUP: 'RXREADYFORPICKUP',
				RXEXPIRED: 'RXEXPIRED',
				RXOUTOFREFILLS: 'RXOUTOFREFILLS',
				RXWAITONDOC: 'RXWAITONDOC',
				RXVERIFY: 'RXVERIFY',
				RXTOOSOON: 'RXTOOSOON',
				RXNARCOTIC: 'RXNARCOTIC',
				RXALREADYPICKEDUP: 'RXALREADYPICKEDUP',
				RXALREADYSHIPPED: 'RXALREADYSHIPPED',
				RXGENERICAVAILABLE: 'RXGENERICAVAILABLE',
				RXNOTFOUND: 'RXNOTFOUND'
			},
			getRxCheckStatuses: function getRxCheckStatuses() {
				return [pharmacyRefillPrescription.rxStatuses.RXVALID, pharmacyRefillPrescription.rxStatuses.RXACTIONOK, pharmacyRefillPrescription.rxStatuses.RXINQUEUE, pharmacyRefillPrescription.rxStatuses.RXREADYFORPICKUP, pharmacyRefillPrescription.rxStatuses.RXALREADYSHIPPED, pharmacyRefillPrescription.rxStatuses.RXALREADYPICKEDUP];
			},
			getRxWaitStatuses: function getRxWaitStatuses() {
				return [pharmacyRefillPrescription.rxStatuses.RXEXPIRED, pharmacyRefillPrescription.rxStatuses.RXOUTOFREFILLS, pharmacyRefillPrescription.rxStatuses.RXWAITONDOC];
			},
			getRxAlertStatuses: function getRxAlertStatuses() {
				return [pharmacyRefillPrescription.rxStatuses.RXNOTFOUND, pharmacyRefillPrescription.rxStatuses.RXVERIFY, pharmacyRefillPrescription.rxStatuses.RXTOOSOON, pharmacyRefillPrescription.rxStatuses.RXGENERICAVAILABLE, pharmacyRefillPrescription.rxStatuses.RXNARCOTIC];
			},
			getRxBlockStatuses: function getRxBlockStatuses() {
				return [];
			},
			isCheckStatusFound: function isCheckStatusFound(status) {
				var match = false;
				$.each(pharmacyRefillPrescription.getRxCheckStatuses(), function (index, value) {
					if (status == value) {
						match = true;
					}
				});
				return match;
			},
			isWaitStatusFound: function isWaitStatusFound(status) {
				var match = false;
				$.each(pharmacyRefillPrescription.getRxWaitStatuses(), function (index, value) {
					if (status == value) {
						match = true;
					}
				});
				return match;
			},
			isAlertStatusFound: function isAlertStatusFound(status) {
				var match = false;
				$.each(pharmacyRefillPrescription.getRxAlertStatuses(), function (index, value) {
					if (status == value) {
						match = true;
					}
				});
				return match;
			},
			isBlockStatusFound: function isBlockStatusFound(status) {
				var match = false;
				$.each(pharmacyRefillPrescription.getRxBlockStatuses(), function (index, value) {
					if (status == value) {
						match = true;
					}
				});
				return match;
			},
			getRxStatusMessage: function getRxStatusMessage(status) {
				var rxStatusMessage = void 0;
				switch (status) {
					case pharmacyRefillPrescription.rxStatuses.RXVALID:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXVALID;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXACTIONOK:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXACTIONOK;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXINQUEUE:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXINQUEUE;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXREADYFORPICKUP:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXREADYFORPICKUP;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXEXPIRED:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXEXPIRED;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXOUTOFREFILLS:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXOUTOFREFILLS;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXWAITONDOC:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXWAITONDOC;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXVERIFY:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXVERIFY;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXTOOSOON:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXTOOSOON;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXNARCOTIC:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXNARCOTIC;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXALREADYPICKEDUP:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXALREADYPICKEDUP;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXALREADYSHIPPED:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXALREADYSHIPPED;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXNOTFOUND:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXNOTFOUND;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXGENERICAVAILABLE:
						rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXGENERICAVAILABLE;
						break;
					default:
						rxStatusMessage = messages.PRESCRIPTION_MESSAGE_UNKNOWNS_STATUS;
				}
	
				return rxStatusMessage;
			},
	
			/**
	      * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val() to get unformatted value
	      */
			maskInput: function maskInput() {
				$('#RefillPrescriptionForm').find('#refill_prescription_phoneNumber').unmask().mask('000-000-0000');
			},
	
			init: function init() {
				COSTCO.pharmacyRefillPrescription.eventHandlers.submitRefillOrder();
			},
	
			getRxStatusLabel: function getRxStatusLabel(status) {
				var rxStatusLabel = void 0;
				switch (status) {
					case pharmacyRefillPrescription.rxStatuses.RXVALID:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXVALID;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXACTIONOK:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXACTIONOK;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXINQUEUE:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXINQUEUE;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXREADYFORPICKUP:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXREADYFORPICKUP;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXEXPIRED:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXEXPIRED;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXOUTOFREFILLS:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXOUTOFREFILLS;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXWAITONDOC:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXWAITONDOC;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXVERIFY:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXVERIFY;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXTOOSOON:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXTOOSOON;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXNARCOTIC:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXNARCOTIC;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXALREADYPICKEDUP:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXALREADYPICKEDUP;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXALREADYSHIPPED:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXALREADYSHIPPED;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXNOTFOUND:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXNOTFOUND;
						break;
					case pharmacyRefillPrescription.rxStatuses.RXGENERICAVAILABLE:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXNOTFOUND;
						break;
					default:
						rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_PATIENT_ACTION_REQUIRED;
				}
				return rxStatusLabel;
			}
	
		};
	
		// Expose fsamodal to the global scope.
		if (typeof window.COSTCO === 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.pharmacyRefillPrescription = pharmacyRefillPrescription;
		return pharmacyRefillPrescription;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title fsamodal.js: Sub-module for Global pages
	 * @description This module is used to display the fsa modal
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var rxcontactus = {
	
			init: function init() {
				this.createFormValidation();
			},
	
			createFormValidation: function createFormValidation() {
	
				$('#ContactUsForm').validate({
					rules: {
						contactEmailAddress: { required: true, email: true },
						subjectOfQuestion: 'required',
						candidateQuery: 'required'
					},
					messages: {
						contactEmailAddress: { required: messages.ERR_CONTACT_US_REQUIRED_EMAIL, email: messages.ERR_CONTACT_US_INVALID_EMAIL },
						subjectOfQuestion: messages.ERR_CONTACT_US_REQUIRED_SUBJECT,
						candidateQuery: messages.ERR_CONTACT_US_REQUIRED_BODY
	
					}
				});
			}
	
		}; //end rxcontactus object
	
		// Expose rxcontactus to the global scope.
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.rxcontactus = rxcontactus;
	
		return rxcontactus;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title rxFamilyAccount.js: Sub-module for Global pages
	 * @description This module is used for manage family account
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function (helper) {
	
		var rxFamilyAccount = {
	
			/**
	   * The method displays the modal window to users to provide dependent details. 
	   * Collected details are then passed onto Patient-profile page when the form was submitted based once the values are validated.
	   */
			addNewDependent: function addNewDependent() {
				COSTCO.dialog.createExtDialogBox({
					title: messages.FAMILYACCOUNT_PHARMACY_ADD_BUTTON_LABEL,
					body: COSTCO.util.tmpl('dependent_details_modal', {}),
					primary: messages.FAMILYACCOUNT_PHARMACY_NEXT_BUTTON_LABEL,
					secondary: messages.BUTTON_CANCEL,
					primary_event: function primary_event() {
						if (rxFamilyAccount.addDependentFormHandler()) {
							var month = $('#month').val();
							var day = $('#day').val();
							var year = $('#year').val();
							var errorField = '#crit-error';
							var alertField = '#alert-relationship-error';
							var selectedDependentId = $("#relationship option:selected").val();
							var selectedDependentDesc = $("#relationship option:selected").attr("id");
							var isDepAllowed = true;
							var options = { year: 'numeric', month: 'long', day: 'numeric' };
							var depDob = new Date(year, month - 1, day).toLocaleDateString("en-US", options);
							var profileType = void 0;
							var featureToggleOff = $('#featureToggleOff').val();
							var isAgeAllowed = function isAgeAllowed() {
								var currentDate = new Date();
								var idate = new Date(year, month - 1, day);
								var age = currentDate.getTime() - idate.getTime();
								age = Math.floor(age / (1000 * 60 * 60 * 24 * 365.25));
								return age < 17 ? true : false;
							};
							$('#newDepRelationshipDesc').val(selectedDependentDesc);
							$('#newDepRelationshipId').val(selectedDependentId);
							if (selectedDependentDesc != undefined && selectedDependentDesc != "Pet") {
								if (featureToggleOff === 'featureDisabled' && !isAgeAllowed()) {
									isDepAllowed = false;
									$(errorField)[0].innerHTML = messages.ERR_DEPENDENT_AGE;
									$(errorField).show();
									$(errorField).focus();
									COSTCO.util.announceSRErrorMessage(messages.ERR_DEPENDENT_AGE);
								}
								profileType = "0";
							} else {
								profileType = "1";
							}
							$('#newDepProfileType').val(profileType);
							$('#dependentDob').val(depDob);
							if (isDepAllowed) {
								$(errorField).hide();
								window.digitalDataEvents = window.digitalDataEvents || [];
								digitalDataEvents.push({ uimsg: "Manage Family Account | Add Family Member Modal | Next" });
								$("#dependent-modal").submit();
							}
						} else {
							var firstError = $(".error:visible:first");
							firstError.focus();
							if (firstError.parents(".dobPopulate").length) {
								COSTCO.util.announceSRErrorMessage($("#dob_error")[0].innerText);
							} else if (firstError.is(":radio")) {
								COSTCO.util.announceSRErrorMessage($(".error:visible:last")[0].innerText);
							} else {
								COSTCO.util.announceSRErrorMessage($(".error:visible:first").next()[0].innerText);
							}
						}
					},
					secondary_event: function secondary_event() {
						window.digitalDataEvents = window.digitalDataEvents || [];
						digitalDataEvents.push({ uimsg: "Manage Family Account | Add Family Member Modal | Cancel" });
						COSTCO.dialog.close();
					},
					onshown: function onshown() {
						helper.dobPopulate(rxFamilyAccount.getForm(), 100);
						$('.control--radio input[type="radio"]').on("focusin", function () {
							$(this).next().addClass('ada-outline');
						});
	
						$('.control--radio input[type="radio"]').on("blur", function () {
							$(this).next().removeClass('ada-outline');
						});
					}
				});
			},
			validateEmail: function validateEmail(value) {
				var flag = true;
				flag = flag && /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value.toLowerCase());
				return flag;
			},
	
			checkFirstNameValid: function checkFirstNameValid() {
				var firstName = COSTCO.rxFamilyAccount.getForm().find('input[name=firstName]');
				var firstNameValue = firstName.val();
				if (firstNameValue == "") {
					firstName.attr('aria-invalid', true);
					firstName.addClass('error');
					$('#firstName_error')[0].innerHTML = messages.ERR_INVALID_FIRSTNAME;
					$('#firstName_error').show();
					return false;
				}
				var isValid = COSTCO.util.ATLEAST_ONE_ALPHABET.test(firstNameValue);
				if (!isValid) {
					firstName.attr('aria-invalid', true);
					firstName.addClass('error');
					$('#firstName_error')[0].innerHTML = messages.ERR_INVALID_FIRSTNAME;
					$('#firstName_error').show();
					return false;
				}
				firstName.attr('aria-invalid', false);
				firstName.removeClass('error');
				$('#firstName_error').hide();
				return isValid;
			},
	
			checkLastNameValid: function checkLastNameValid() {
				var lastName = COSTCO.rxFamilyAccount.getForm().find('input[name=lastName]');
				var lastNameValue = lastName.val();
				if (lastNameValue == "") {
					lastName.attr('aria-invalid', true);
					lastName.addClass('error');
					$('#lastName_error')[0].innerHTML = messages.ERR_INVALID_LASTNAME;
					$('#lastName_error').show();
					return false;
				}
				var isValid = COSTCO.util.ATLEAST_ONE_ALPHABET.test(lastNameValue);
				if (!isValid) {
					lastName.attr('aria-invalid', true);
					lastName.addClass('error');
					$('#lastName_error')[0].innerHTML = messages.ERR_INVALID_LASTNAME;
					$('#lastName_error').show();
					return false;
				}
				lastName.attr('aria-invalid', false);
				lastName.removeClass('error');
				$('#lastName_error').hide();
				return isValid;
			},
	
			checkDOBValid: function checkDOBValid() {
				var form = COSTCO.rxFamilyAccount.getForm();
				var month = form.find('select[name=month]').val();
				var day = form.find('select[name=day]').val();
				var year = form.find('select[name=year]').val();
				var errField = $('#dob_error');
				var isFuture = false;
				var dateEntered = false;
				var idate = void 0;
	
				var isFutureDate = function isFutureDate(idate) {
					var today = new Date().getTime();
					idate = idate.split('/');
					idate = new Date(idate[2], idate[0] - 1, idate[1]).getTime();
					return today - idate < 0 ? true : false;
				};
	
				dateEntered = month != 'Month' & day != 'Day' & year != 'Year';
	
				if (month != 'Month' && day != 'Day' && year != 'Year') {
					idate = month + '/' + day + '/' + year;
					if (isFutureDate(idate)) {
						isFuture = true;
					}
				}
	
				if (dateEntered && !isFuture) {
					$('.dateOfBirth').removeClass('error select-error');
					$(errField).hide();
					return true;
				} else {
					$('.dateOfBirth').addClass('error select-error');
					$(errField).show();
					if (isFuture) {
						$(errField)[0].innerHTML = messages.ERR_INCORRECT_DATE_OF_BIRTH;
					} else {
						$(errField)[0].innerHTML = messages.ERR_REQUIRED_DOB;
					}
				}
				return false;
			},
	
			checkDOBMonthValid: function checkDOBMonthValid() {
				var isDOBValid = COSTCO.rxFamilyAccount.checkDOBValid();
				var month = $('#month').val();
				if (month == "Month") {
					$('#month').attr('aria-invalid', true);
					$('#month').addClass('error select-error');
					$('#dob_error')[0].innerHTML = messages.ERR_INVALID_MONTH;
					return false;
				}
				if (!isDOBValid) {
					$('#month').attr('aria-invalid', true);
					$('#month').addClass('error select-error');
					return false;
				}
				$('#month').attr('aria-invalid', false);
				$('#month').removeClass('error select-error');
				return true;
			},
	
			checkDOBDayValid: function checkDOBDayValid() {
				var isDOBValid = COSTCO.rxFamilyAccount.checkDOBValid();
				var day = $('#day').val();
				if (day == "Day") {
					$('#day').attr('aria-invalid', true);
					$('#day').addClass('error select-error');
					$('#dob_error')[0].innerHTML = messages.ERR_INVALID_DAY;
					return false;
				}
				if (!isDOBValid) {
					$('#day').attr('aria-invalid', true);
					$('#day').addClass('error select-error');
					return false;
				}
				$('#day').attr('aria-invalid', false);
				$('#day').removeClass('error select-error');
				return true;
			},
	
			checkDOBYearValid: function checkDOBYearValid() {
				var isDOBValid = COSTCO.rxFamilyAccount.checkDOBValid();
				var year = $('#year').val();
				if (year == "Year") {
					$('#year').attr('aria-invalid', true);
					$('#year').addClass('error select-error');
					$('#dob_error')[0].innerHTML = messages.ERR_INVALID_YEAR;
					return false;
				}
				if (!isDOBValid) {
					$('#year').attr('aria-invalid', true);
					$('#year').addClass('error select-error');
					return false;
				}
				$('#year').attr('aria-invalid', false);
				$('#year').removeClass('error select-error');
				return true;
			},
	
			checkPatientRelationshipValid: function checkPatientRelationshipValid() {
				var selectedDependent = $('#relationship').val();
				if (selectedDependent == 0) {
					$('#relationship').attr('aria-invalid', true);
					$('#relationship').addClass('error');
					$('#relationship_error')[0].innerHTML = messages.ERR_INVALID_RELATIONSHIP;
					$('#relationship_error').show();
					return false;
				}
				$('#relationship').attr('aria-invalid', false);
				$('#relationship').removeClass('error');
				$('#relationship_error').hide();
				return true;
			},
	
			checkGenderValid: function checkGenderValid() {
				var genderCheck = $('[name^=depGender]:checked');
				if (genderCheck.length < 1) {
					$('#depGender_error')[0].innerHTML = messages.ERR_REQUIRED_GENDER;
					$('#depGender_error').show();
					return false;
				}
				$('#depGender_error').hide();
				return true;
			},
	
			/**
	  * Add validation method to check human patient age
	  */
			isHumanDependentsAgeAllowed: function isHumanDependentsAgeAllowed() {
				var selectedDependent = $("#relationship option:selected").val();
				var month = $('#month').val();
				var day = $('#day').val();
				var year = $('#year').val();
				var currentDate = new Date();
				var idate = new Date(year, month - 1, day);
				var age = currentDate.getTime() - idate.getTime();
				age = Math.floor(age / (1000 * 60 * 60 * 24 * 365.25));
				var ageOnBirthday = currentDate.getTime() - idate.getTime();
				ageOnBirthday = Math.round(ageOnBirthday / (1000 * 60 * 60 * 24 * 365.25));
	
				if (ageOnBirthday > 17 && idate.getDate() == currentDate.getDate() && idate.getMonth() == currentDate.getMonth()) {
					$('#family-member-email-address').removeClass('hidden');
					return true;
				} else if (age <= 17 || selectedDependent === "6") {
					$('#family-member-email-address').addClass('hidden');
					$('#emailAddress').val('');
					return false;
				} else {
					$('#family-member-email-address').removeClass('hidden');
					return true;
				}
			},
			/**
	   * Add validation method to check selected patient relationship
	   */
			checkSelectedPatientRelationship: function checkSelectedPatientRelationship() {
				var selectedDependent = $("#relationship option:selected").val();
				if (selectedDependent === "6" || rxFamilyAccount.isHumanDependentsAgeAllowed() == false) {
					$('#family-member-email-address').addClass('hidden');
					$('#emailAddress').val('');
					return false;
				} else {
					$('#family-member-email-address').removeClass('hidden');
					return true;
				}
			},
			/**
	   * Opens learn more dialog on click "Learn more" link from Manage Family Account
	   */
			showLearnMoreModal: function showLearnMoreModal() {
				COSTCO.dialog.modalStack({
					title: messages.LEARN_MORE_ACCOUNT_STATUS_TITLE,
					body: COSTCO.util.tmpl('learn_more_modal', {}),
					primary: messages.JS_DIALOG_CLOSE,
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					}
				});
			},
	
			/**
	   * Opens info dialog on click "Remove" link from Manage Family Account
	   */
			showRemoveInfoModal: function showRemoveInfoModal(primaryShopperId, dependentShopperId, firstName, lastName, index) {
				COSTCO.dialog.modalStack({
					title: messages.REMOVE_DEPENDENT_TITLE,
					body: COSTCO.util.tmpl('remove_modal', {
						firstName: firstName,
						lastName: lastName
					}),
					primary: messages.REMOVE_DEPENDENT_BUTTON,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						COSTCO.dialog.close();
						$('#primaryShopperId').val(primaryShopperId);
						$('#dependentShopperId').val(dependentShopperId);
						if (sessionStorage.getItem("SelectedPatientIndex") == index) {
							sessionStorage.removeItem("SelectedPatientIndex");
						}
						$("#remove_dependent_modal").submit();
					}
				});
			},
	
			emailDependentValidation: function emailDependentValidation() {
	
				// custom validation for email address
				//$.validator.addMethod('emailAddress', function(value, element, param) {		
	
				var emailFormat = $('#emailAddress').val();
				var accountEmailRegister = $('#accountEmailRegister').val();
				if (emailFormat === "" || rxFamilyAccount.validateEmail(emailFormat) == false) {
					var errField = '#family_member_email_address_error';
					var errorFieldEmailValidate = '#family_member_email_address_error';
					$('#emailAddress').addClass('error select-error');
					$('#family_member_email_address_error').removeClass('hidden');
	
					$(errorFieldEmailValidate)[0].innerHTML = messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS_SEND_REQUEST;
					$(errorFieldEmailValidate).show();
					$(errorFieldEmailValidate).focus();
					$(errField)[0].innerHTML = messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS_SEND_REQUEST;
	
					COSTCO.util.announceSRErrorMessage($("#family_member_email_address_error")[0].innerText);
					$('#family_member_email_address_error').addClass('visible');
					$('#family_member_account_manager_email_address_error').addClass('hidden');
					valid = false;
				} else if (accountEmailRegister.toLowerCase() === emailFormat.toLowerCase()) {
					var _errField = '#family_member_account_manager_email_address_error';
					var _errorFieldEmailValidate = '#family_member_account_manager_email_address_error';
					$('#emailAddress').addClass('error select-error');
					$('#family_member_account_manager_email_address_error').removeClass('hidden');
	
					$(_errorFieldEmailValidate)[0].innerHTML = messages.ERR_ACCOUNT_MANAGER_FAMILY_MEMBER_EMAIL_ADDRESS;
					$(_errorFieldEmailValidate).show();
					$(_errorFieldEmailValidate).focus();
					$(_errField)[0].innerHTML = messages.ERR_ACCOUNT_MANAGER_FAMILY_MEMBER_EMAIL_ADDRESS;
	
					COSTCO.util.announceSRErrorMessage($("#family_member_account_manager_email_address_error")[0].innerText);
					$('#family_member_account_manager_email_address_error').addClass('visible');
					$('#family_member_email_address_error').addClass('hidden');
					valid = false;
				} else {
					$('#family_member_email_address_error').addClass('hidden');
					$('#family_member_account_manager_email_address_error').addClass('hidden');
					valid = true;
				}
				return valid;
			},
			/**
	   * Open info Resend Email Request modal on click from Manage Family Account
	   */
			showResendEmailRequestModal: function showResendEmailRequestModal(dependentEmailAddress, dependentShopperId) {
				COSTCO.dialog.createExtDialogBox({
					title: messages.RESEND_EMAIL_REQUEST_DEPENDENT,
					body: COSTCO.util.tmpl('resend_email', {
						dependentEmailAddress: dependentEmailAddress,
						dependentShopperId: dependentShopperId
					}),
					primary: messages.SEND_REQUEST_DEPENDENT_BUTTON,
					secondary: messages.JS_DIALOG_CANCEL,
					preventClose: true,
					primary_event: function primary_event() {
						$('#dependentShopperId').val(dependentShopperId);
						$('#dependentEmailAddress').val(dependentEmailAddress);
	
						if (rxFamilyAccount.emailDependentValidation()) {
							window.digitalDataEvents = window.digitalDataEvents || [];
							digitalDataEvents.push({ uimsg: "Manage Family Account | Email Modal | Send Request" });
							$("#resend_email_request").submit();
						}
					},
					secondary_event: function secondary_event() {
						window.digitalDataEvents = window.digitalDataEvents || [];
						digitalDataEvents.push({ uimsg: "Manage Family Account | Email Modal | Cancel" });
						COSTCO.dialog.close();
					}
				});
			},
	
			/**
	   * Open info Send Email Request modal on click from Manage Family Account
	   */
			showSendEmailRequestModal: function showSendEmailRequestModal(dependentEmailAddress, dependentShopperId) {
				COSTCO.dialog.modalStack({
					title: messages.SEND_EMAIL_REQUEST_DEPENDENT,
					body: COSTCO.util.tmpl('send_email', {
						dependentEmailAddress: dependentEmailAddress,
						dependentShopperId: dependentShopperId
					}),
					primary: messages.SEND_REQUEST_DEPENDENT_BUTTON,
					secondary: messages.JS_DIALOG_CANCEL,
					preventClose: true,
					primary_event: function primary_event() {
						$('#dependentShopperId').val(dependentShopperId);
						$('#dependentEmailAddress').val(dependentEmailAddress);
	
						if (rxFamilyAccount.emailDependentValidation()) {
							window.digitalDataEvents = window.digitalDataEvents || [];
							digitalDataEvents.push({ uimsg: "Manage Family Account | Email Modal | Send Request" });
							$("#send_email_request").submit();
						}
					},
					secondary_event: function secondary_event() {
						window.digitalDataEvents = window.digitalDataEvents || [];
						digitalDataEvents.push({ uimsg: "Manage Family Account | Email Modal | Cancel" });
						COSTCO.dialog.close();
					}
				});
			},
	
			/**
	   * Add validation methods for form validation
	   */
			addValidationMethods: function addValidationMethods() {
	
				$.validator.setDefaults({
					onfocusout: false
				});
	
				COSTCO.rxFamilyAccount.getForm().find("input[name=firstName]").on("focus", function () {
					$(".ally-error-msg").removeAttr("role");
					$("#firstName_error").attr("role", "alert");
					COSTCO.rxFamilyAccount.checkFirstNameValid();
				});
	
				COSTCO.rxFamilyAccount.getForm().find("input[name=lastName]").on("focus", function () {
					$(".ally-error-msg").removeAttr("role");
					$("#lastName_error").attr("role", "alert");
					COSTCO.rxFamilyAccount.checkLastNameValid();
				});
	
				$("#relationship").on("focus", function () {
					$(".ally-error-msg").removeAttr("role");
					$("#relationship_error").attr("role", "alert");
					COSTCO.rxFamilyAccount.checkPatientRelationshipValid();
				});
	
				$("#month").on("focus", function () {
					$(".ally-error-msg").removeAttr("role");
					$("#dob_error").attr("role", "alert");
					COSTCO.rxFamilyAccount.checkDOBMonthValid();
				});
	
				$("#day").on("focus", function () {
					$(".ally-error-msg").removeAttr("role");
					$("#dob_error").attr("role", "alert");
					COSTCO.rxFamilyAccount.checkDOBDayValid();
				});
	
				$("#year").on("focus", function () {
					$(".ally-error-msg").removeAttr("role");
					$("#dob_error").attr("role", "alert");
					COSTCO.rxFamilyAccount.checkDOBYearValid();
				});
	
				$("#dependent_acc_male").on("focus", function () {
					$("#depGender_error").attr("role", "alert");
					COSTCO.rxFamilyAccount.checkGenderValid();
				});
	
				$("#relationship").on("change", function () {
					COSTCO.rxFamilyAccount.checkPatientRelationshipValid();
				});
	
				$("#month").on("change", function () {
					COSTCO.rxFamilyAccount.checkDOBMonthValid();
				});
	
				$("#day").on("change", function () {
					COSTCO.rxFamilyAccount.checkDOBDayValid();
				});
	
				$("#year").on("change", function () {
					COSTCO.rxFamilyAccount.checkDOBYearValid();
				});
	
				// custom validation for email address
				$.validator.addMethod('emailAddress', function (value, element, param) {
					var form = COSTCO.rxFamilyAccount.getForm();
					var valid = true;
					var emailFormat = $('#emailAddress').val();
					var accountEmailRegister = $('#accountEmailRegister').val();
					if (rxFamilyAccount.isHumanDependentsAgeAllowed() && rxFamilyAccount.checkSelectedPatientRelationship() == true && (emailFormat === "" || rxFamilyAccount.validateEmail(emailFormat) == false || accountEmailRegister.toLowerCase() === emailFormat.toLowerCase())) {
						var errField = '#family_member_email_address_error';
						var errEmptyField = '#family_member_email_empty_error';
						$('#emailAddress').addClass('error select-error');
						if (accountEmailRegister.toLowerCase() === emailFormat.toLowerCase()) {
							var errorFieldEmailValidate = '#family_member_email_address_error';
							$('#family_member_email_empty_error').addClass('hidden');
							$('#family_member_email_address_error').removeClass('hidden');
							$("#family_member_email_address_error").attr("role", "alert");
							$(errorFieldEmailValidate)[0].innerHTML = messages.ERR_ACCOUNT_MANAGER_FAMILY_MEMBER_EMAIL_ADDRESS;
							$(errorFieldEmailValidate).show();
							$(errorFieldEmailValidate).focus();
							$(errField)[0].innerHTML = messages.ERR_ACCOUNT_MANAGER_FAMILY_MEMBER_EMAIL_ADDRESS;
						} else if (emailFormat === "") {
							var _errorFieldEmailValidate2 = '#family_member_email_empty_error';
							$('#family_member_email_address_error').addClass('hidden');
							$('#family_member_email_empty_error').removeClass('hidden');
							$(_errorFieldEmailValidate2)[0].innerHTML = messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS;
							$(_errorFieldEmailValidate2).show();
							$(_errorFieldEmailValidate2).focus();
							$(errEmptyField)[0].innerHTML = messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS;
						} else {
							var _errorFieldEmailValidate3 = '#family_member_email_address_error';
							$('#family_member_email_empty_error').addClass('hidden');
							$('#family_member_email_address_error').removeClass('hidden');
							$("#family_member_email_address_error").attr("role", "alert");
							$(_errorFieldEmailValidate3)[0].innerHTML = messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS_SEND_REQUEST;
							$(_errorFieldEmailValidate3).show();
							$(_errorFieldEmailValidate3).focus();
							$(errField)[0].innerHTML = messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS_SEND_REQUEST;
						}
						valid = false;
					} else {
	
						$('#family_member_email_address_error').addClass('hidden');
						valid = true;
					}
					return valid;
				}, '');
	
				// custom validation for date of birth
				$.validator.addMethod('dob', function (value, element, param) {
	
					var form = COSTCO.rxFamilyAccount.getForm();
					var valid = true;
					var month = void 0;
					var day = void 0;
					var year = void 0;
					var errField = void 0;
					var idate = void 0;
					var isFuture = false;
	
					var dateEntered = false;
	
					var isFutureDate = function isFutureDate(idate) {
						var today = new Date().getTime();
						idate = idate.split('/');
						idate = new Date(idate[2], idate[0] - 1, idate[1]).getTime();
						return today - idate < 0 ? true : false;
					};
	
					if (element.name == 'month' || element.name == 'day' || element.name == 'year') {
						month = form.find('select[name=month]').val();
						day = form.find('select[name=day]').val();
						year = form.find('select[name=year]').val();
						dateEntered = month != 'Month' & day != 'Day' & year != 'Year';
						errField = '#dob_error';
					}
					if (month != 'Month' && day != 'Day' && year != 'Year') {
						idate = month + '/' + day + '/' + year;
						if (isFutureDate(idate)) {
							isFuture = true;
						}
					}
					if (dateEntered && !isFuture) {
						$(errField).hide();
						$('.dateOfBirth').removeClass('error select-error');
						valid = true;
					} else {
						$(element).closest('.dateOfBirth').addClass('error select-error');
						$(errField).show();
						if (isFuture) {
							$(errField)[0].innerHTML = messages.ERR_INCORRECT_DATE_OF_BIRTH;
						} else {
							if (element.name == 'month') {
								COSTCO.rxFamilyAccount.checkDOBMonthValid();
							} else if (element.name == 'day') {
								COSTCO.rxFamilyAccount.checkDOBDayValid();
							} else if (element.name == 'year') {
								COSTCO.rxFamilyAccount.checkDOBYearValid();
							}
						}
						valid = false;
					}
					return valid;
				}, '');
	
				$.validator.addMethod("firstNameValidation", function (value, element) {
					return COSTCO.rxFamilyAccount.checkFirstNameValid();
				}, "");
	
				$.validator.addMethod("lastNameValidation", function (value, element) {
					return COSTCO.rxFamilyAccount.checkLastNameValid();
				}, "");
	
				$.validator.addMethod("relationshipValidation", function (value, element, param) {
					return COSTCO.rxFamilyAccount.checkPatientRelationshipValid();
				}, "");
	
				$.validator.addMethod('genderValidation', function (value, element) {
					return COSTCO.rxFamilyAccount.checkGenderValid();
				}, "");
	
				$.validator.addMethod('emailAddressRequired', function (value, element) {
					if (value == "") {
						$('#family_member_email_address_error').addClass('hidden');
						return false;
					}
					return true;
				}, "");
			},
	
			/**
	      * This is the form handler for the add dependent account form).
	      * @return {void}
	      */
			addDependentFormHandler: function addDependentFormHandler() {
				rxFamilyAccount.addValidationMethods();
				var form = rxFamilyAccount.getForm();
	
				if (form != undefined) {
	
					form.validate({
						rules: {
							firstName: { required: false, firstNameValidation: true },
							lastName: { required: false, lastNameValidation: true },
							relationship: { required: false, relationshipValidation: true },
							month: { required: false, dob: true },
							day: { required: false, dob: true },
							year: { required: false, dob: true },
							depGender: { required: false, genderValidation: true },
							emailAddress: { emailAddressRequired: true, emailAddress: true }
						},
						messages: {
							emailAddress: { emailAddressRequired: messages.ERR_FAMILY_MEMBER_EMAIL_ADDRESS }
						},
						errorPlacement: function errorPlacement(error, element) {
							if (element.is(":radio")) {
								error.appendTo(element.parents('.gender-radio'));
							} else {
								// This is the default behavior of the script for all fields
								error.insertAfter(element);
							}
						}
					});
					return this.getForm().valid();
				}
			},
	
			getForm: function getForm() {
				var forms = $('#dependent-modal');
				return forms;
			}
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.rxFamilyAccount = rxFamilyAccount;
	
		return rxFamilyAccount;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// rx.module.min.js